/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/v3/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(291);
	module.exports = __webpack_require__(743);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(593);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(566)();
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var core = __webpack_require__(32);
	var hide = __webpack_require__(57);
	var redefine = __webpack_require__(74);
	var ctx = __webpack_require__(83);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APP_INITIALIZED = exports.APP_INITIALIZED = 'APP_INITIALIZED';
	
	var TOKEN_CHANGE = exports.TOKEN_CHANGE = 'TOKEN_CHANGE';
	var STEP_SELECTED = exports.STEP_SELECTED = 'STEP_SELECTED';
	var STEP_CONTROL_NEXT = exports.STEP_CONTROL_NEXT = 'STEP_CONTROL_NEXT';
	var STEP_CONTROL_PREV = exports.STEP_CONTROL_PREV = 'STEP_CONTROL_PREV';
	var STEP_SELECT_LATEST = exports.STEP_SELECT_LATEST = 'STEP_SELECT_LATEST';
	
	var STEP_FORCE_VALIDATION = exports.STEP_FORCE_VALIDATION = 'STEP_FORCE_VALIDATION';
	
	var DOMAIN_INPUT_CHANGE = exports.DOMAIN_INPUT_CHANGE = "DOMAIN_INPUT_CHANGE";
	var DOMAIN_CHECK_BEGIN = exports.DOMAIN_CHECK_BEGIN = "DOMAIN_CHECK_BEGIN";
	var DOMAIN_LOAD_MORE = exports.DOMAIN_LOAD_MORE = "DOMAIN_LOAD_MORE";
	var DOMAIN_HIDE_GONE = exports.DOMAIN_HIDE_GONE = "DOMAIN_HIDE_GONE";
	
	var ALTERNATE_SEPA_TOGGLE = exports.ALTERNATE_SEPA_TOGGLE = "ALTERNATE_SEPA_TOGGLE";
	
	var COLLAPSIBLE_CONTENT_TOGGLED = exports.COLLAPSIBLE_CONTENT_TOGGLED = "COLLAPSIBLE_CONTENT_TOGGLED";
	var COLLAPSIBLE_OPEN_CONTENT = exports.COLLAPSIBLE_OPEN_CONTENT = "COLLAPSIBLE_OPEN_CONTENT";
	var COLLAPSIBLE_CLOSE_CONTENT = exports.COLLAPSIBLE_CLOSE_CONTENT = "COLLAPSIBLE_CLOSE_CONTENT";
	
	var TOGGLE_SELECTION_TRIGGERED = exports.TOGGLE_SELECTION_TRIGGERED = "TOGGLE_SELECTION_TRIGGERED";
	
	var BASE_ARTICLE_REQUEST = exports.BASE_ARTICLE_REQUEST = 'BASE_ARTICLE_REQUEST';
	var BASE_ARTICLE_SUCCESS = exports.BASE_ARTICLE_SUCCESS = 'BASE_ARTICLE_SUCCESS';
	var BASE_ARTICLE_FAILURE = exports.BASE_ARTICLE_FAILURE = 'BASE_ARTICLE_FAILURE';
	
	var PRODUCT_SET_CURRENT = exports.PRODUCT_SET_CURRENT = 'PRODUCT_SET_CURRENT';
	
	var BASE_ARTICLE_SELECT = exports.BASE_ARTICLE_SELECT = 'BASE_ARTICLE_SELECT';
	var BASE_ARTICLE_DESELECT = exports.BASE_ARTICLE_DESELECT = 'BASE_ARTICLE_DESELECT';
	var BASE_ARTICLE_LOAD_START = exports.BASE_ARTICLE_LOAD_START = 'BASE_ARTICLE_LOAD_START';
	var BASE_ARTICLE_LOAD_COMPLETE = exports.BASE_ARTICLE_LOAD_COMPLETE = 'BASE_ARTICLE_LOAD_COMPLETE';
	var BASE_ARTICLE_CUSTOM_SELECTED = exports.BASE_ARTICLE_CUSTOM_SELECTED = 'BASE_ARTICLE_CUSTOM_SELECTED';
	
	var BANKACCOUNT_VERIFY_REQUEST = exports.BANKACCOUNT_VERIFY_REQUEST = 'BANKACCOUNT_VERIFY_REQUEST';
	var BANKACCOUNT_VERIFY_SUCCESS = exports.BANKACCOUNT_VERIFY_SUCCESS = 'BANKACCOUNT_VERIFY_SUCCESS';
	var BANKACCOUNT_VERIFY_FAILURE = exports.BANKACCOUNT_VERIFY_FAILURE = 'BANKACCOUNT_VERIFY_FAILURE';
	
	var ARTICLEOPTION_DATA_REQUEST = exports.ARTICLEOPTION_DATA_REQUEST = 'ARTICLEOPTION_DATA_REQUEST';
	var ARTICLEOPTION_DATA_SUCCESS = exports.ARTICLEOPTION_DATA_SUCCESS = 'ARTICLEOPTION_DATA_SUCCESS';
	var ARTICLEOPTION_DATA_FAILURE = exports.ARTICLEOPTION_DATA_FAILURE = 'ARTICLEOPTION_DATA_FAILURE';
	
	var CUSTOMER_CATEGORIES_REQUEST = exports.CUSTOMER_CATEGORIES_REQUEST = 'CUSTOMER_CATEGORIES_REQUEST';
	var CUSTOMER_CATEGORIES_FAILURE = exports.CUSTOMER_CATEGORIES_FAILURE = 'CUSTOMER_CATEGORIES_FAILURE';
	var CUSTOMER_CATEGORIES_SUCCESS = exports.CUSTOMER_CATEGORIES_SUCCESS = 'CUSTOMER_CATEGORIES_SUCCESS';
	
	var SOFTWARE_REQUEST = exports.SOFTWARE_REQUEST = 'SOFTWARE_REQUEST';
	var SOFTWARE_FAILURE = exports.SOFTWARE_FAILURE = 'SOFTWARE_FAILURE';
	var SOFTWARE_SUCCESS = exports.SOFTWARE_SUCCESS = 'SOFTWARE_SUCCESS';
	var SELECT_SOFTWARE = exports.SELECT_SOFTWARE = 'SOFTWARE_SELECT';
	
	var DATABASE_REQUEST = exports.DATABASE_REQUEST = 'DATABASE_REQUEST';
	var DATABASE_FAILURE = exports.DATABASE_FAILURE = 'DATABASE_FAILURE';
	var DATABASE_SUCCESS = exports.DATABASE_SUCCESS = 'DATABASE_SUCCESS';
	var SELECT_DATABASE = exports.SELECT_DATABASE = 'DATABASE_SELECT';
	
	var SELECT_BILLINGPERIOD = exports.SELECT_BILLINGPERIOD = 'SELECT_BILLINGPERIOD';
	var SELECT_CART_PROPERTY = exports.SELECT_CART_PROPERTY = 'SELECT_CART_PROPERTY';
	
	var OPERATINGSYSTEM_REQUEST = exports.OPERATINGSYSTEM_REQUEST = 'OPERATINGSYSTEM_REQUEST';
	var OPERATINGSYSTEM_FAILURE = exports.OPERATINGSYSTEM_FAILURE = 'OPERATINGSYSTEM_FAILURE';
	var OPERATINGSYSTEM_SUCCESS = exports.OPERATINGSYSTEM_SUCCESS = 'OPERATINGSYSTEM_SUCCESS';
	var SELECT_OPERATINGSYSTEM = exports.SELECT_OPERATINGSYSTEM = 'OPERATINGSYSTEM_SELECT';
	
	var SEND_OFFER_REQUEST = exports.SEND_OFFER_REQUEST = 'SEND_OFFER_REQUEST';
	var SEND_OFFER_SUCCESS = exports.SEND_OFFER_SUCCESS = 'SEND_OFFER_SUCCESS';
	var SEND_OFFER_FAILURE = exports.SEND_OFFER_FAILURE = 'SEND_OFFER_FAILURE';
	var SEND_OFFER_COPY = exports.SEND_OFFER_COPY = 'SEND_OFFER_COPY';
	var SEND_OFFER_COPY_RESET = exports.SEND_OFFER_COPY_RESET = 'SEND_OFFER_COPY_RESET';
	
	var PROMOTIONCODE_VALIDATE_REQUEST = exports.PROMOTIONCODE_VALIDATE_REQUEST = 'PROMOTIONCODE_VALIDATE_REQUEST';
	var PROMOTIONCODE_VALIDATE_SUCCESS = exports.PROMOTIONCODE_VALIDATE_SUCCESS = 'PROMOTIONCODE_VALIDATE_SUCCESS';
	var PROMOTIONCODE_VALIDATE_FAILURE = exports.PROMOTIONCODE_VALIDATE_FAILURE = 'PROMOTIONCODE_VALIDATE_FAILURE';
	
	var PROMOTIONCODE_DATA_REQUEST = exports.PROMOTIONCODE_DATA_REQUEST = 'PROMOTIONCODE_DATA_REQUEST';
	var PROMOTIONCODE_DATA_SUCCESS = exports.PROMOTIONCODE_DATA_SUCCESS = 'PROMOTIONCODE_DATA_SUCCESS';
	var PROMOTIONCODE_DATA_FAILURE = exports.PROMOTIONCODE_DATA_FAILURE = 'PROMOTIONCODE_DATA_FAILURE';
	
	var PROMOTIONCODE_RESET = exports.PROMOTIONCODE_RESET = 'PROMOTIONCODE_RESET';
	var PROMOTIONCODE_INIT = exports.PROMOTIONCODE_INIT = 'PROMOTIONCODE_INIT';
	
	var BEARER_TOKEN_REQUEST = exports.BEARER_TOKEN_REQUEST = 'BEARER_TOKEN_REQUEST';
	var BEARER_TOKEN_CACHE = exports.BEARER_TOKEN_CACHE = 'BEARER_TOKEN_CACHE';
	var BEARER_TOKEN_SUCCESS = exports.BEARER_TOKEN_SUCCESS = 'BEARER_TOKEN_SUCCESS';
	var BEARER_TOKEN_FAILURE = exports.BEARER_TOKEN_FAILURE = 'BEARER_TOKEN_FAILURE';
	
	var TOPLEVELDOMAINS_REQUEST = exports.TOPLEVELDOMAINS_REQUEST = "TOPLEVELDOMAINS_REQUEST";
	var TOPLEVELDOMAINS_SUCCESS = exports.TOPLEVELDOMAINS_SUCCESS = "TOPLEVELDOMAINS_SUCCESS";
	var TOPLEVELDOMAINS_FAILURE = exports.TOPLEVELDOMAINS_FAILURE = "TOPLEVELDOMAINS_FAILURE";
	
	var DOMAIN_CHECK_REQUEST = exports.DOMAIN_CHECK_REQUEST = "DOMAIN_CHECK_REQUEST";
	var DOMAIN_CHECK_SUCCESS = exports.DOMAIN_CHECK_SUCCESS = "DOMAIN_CHECK_SUCCESS";
	var DOMAIN_CHECK_FAILURE = exports.DOMAIN_CHECK_FAILURE = "DOMAIN_CHECK_FAILURE";
	
	var CART_CREATE_REQUEST = exports.CART_CREATE_REQUEST = "CART_CREATE_REQUEST";
	var CART_CREATE_SUCCESS = exports.CART_CREATE_SUCCESS = "CART_CREATE_SUCCESS";
	var CART_CREATE_FAILURE = exports.CART_CREATE_FAILURE = "CART_CREATE_FAILURE";
	
	var CART_SHARE_REQUEST = exports.CART_SHARE_REQUEST = "CART_SHARE_REQUEST";
	var CART_SHARE_SUCCESS = exports.CART_SHARE_SUCCESS = "CART_SHARE_SUCCESS";
	var CART_SHARE_FAILURE = exports.CART_SHARE_FAILURE = "CART_SHARE_FAILURE";
	
	var CART_UPDATE_REQUEST = exports.CART_UPDATE_REQUEST = "CART_UPDATE_REQUEST";
	var CART_UPDATE_SUCCESS = exports.CART_UPDATE_SUCCESS = "CART_UPDATE_SUCCESS";
	var CART_UPDATE_FAILURE = exports.CART_UPDATE_FAILURE = "CART_UPDATE_FAILURE";
	
	var CART_CHECKOUT_REQUEST = exports.CART_CHECKOUT_REQUEST = "CART_CHECKOUT_REQUEST";
	var CART_CHECKOUT_SUCCESS = exports.CART_CHECKOUT_SUCCESS = "CART_CHECKOUT_SUCCESS";
	var CART_CHECKOUT_FAILURE = exports.CART_CHECKOUT_FAILURE = "CART_CHECKOUT_FAILURE";
	
	var CART_RECOMMEND_REQUEST = exports.CART_RECOMMEND_REQUEST = "CART_RECOMMEND_REQUEST";
	var CART_RECOMMEND_SUCCESS = exports.CART_RECOMMEND_SUCCESS = "CART_RECOMMEND_SUCCESS";
	var CART_RECOMMEND_FAILURE = exports.CART_RECOMMEND_FAILURE = "CART_RECOMMEND_FAILURE";
	
	var CART_PINCODE_VERIFY_REQUEST = exports.CART_PINCODE_VERIFY_REQUEST = "CART_PINCODE_VERIFY_REQUEST";
	var CART_PINCODE_VERIFY_RESPONSE = exports.CART_PINCODE_VERIFY_RESPONSE = "CART_PINCODE_VERIFY_RESPONSE";
	var CART_PINCODE_VERIFY_FAILURE = exports.CART_PINCODE_VERIFY_FAILURE = "CART_PINCODE_VERIFY_FAILURE";
	var CART_PINCODE_VERIFY_SUCCESS = exports.CART_PINCODE_VERIFY_SUCCESS = "CART_PINCODE_VERIFY_SUCCESS";
	
	var CART_REMOVE_ITEM_REQUEST = exports.CART_REMOVE_ITEM_REQUEST = "CART_REMOVE_ITEM_REQUEST";
	var CART_REMOVE_ITEM_SUCCESS = exports.CART_REMOVE_ITEM_SUCCESS = "CART_REMOVE_ITEM_SUCCESS";
	var CART_REMOVE_ITEM_FAILURE = exports.CART_REMOVE_ITEM_FAILURE = "CART_REMOVE_ITEM_FAILURE";
	
	var CART_ADD_ITEM_REQUEST = exports.CART_ADD_ITEM_REQUEST = 'CART_ADD_ITEM_REQUEST';
	var CART_ADD_ITEM_SUCCESS = exports.CART_ADD_ITEM_SUCCESS = 'CART_ADD_ITEM_SUCCESS';
	var CART_ADD_ITEM_FAILURE = exports.CART_ADD_ITEM_FAILURE = 'CART_ADD_ITEM_FAILURE';
	
	var CART_ADD_DOMAIN_REQUEST = exports.CART_ADD_DOMAIN_REQUEST = 'CART_ADD_DOMAIN_REQUEST';
	var CART_ADD_DOMAIN_SUCCESS = exports.CART_ADD_DOMAIN_SUCCESS = 'CART_ADD_DOMAIN_SUCCESS';
	var CART_ADD_DOMAIN_FAILURE = exports.CART_ADD_DOMAIN_FAILURE = 'CART_ADD_DOMAIN_FAILURE';
	
	var NEOS_ARTICLEDATA_REQUEST = exports.NEOS_ARTICLEDATA_REQUEST = 'NEOS_ARTICLEDATA_REQUEST';
	var NEOS_ARTICLEDATA_SUCCESS = exports.NEOS_ARTICLEDATA_SUCCESS = 'NEOS_ARTICLEDATA_SUCCESS';
	var NEOS_ARTICLEDATA_FAILURE = exports.NEOS_ARTICLEDATA_FAILURE = 'NEOS_ARTICLEDATA_FAILURE';
	
	var CART_PUT_FORM_DATA_REQUEST = exports.CART_PUT_FORM_DATA_REQUEST = 'CART_PUT_FORM_DATA_REQUEST';
	var CART_PUT_FORM_DATA_SUCCESS = exports.CART_PUT_FORM_DATA_SUCCESS = 'CART_PUT_FORM_DATA_SUCCESS';
	var CART_PUT_FORM_DATA_FAILURE = exports.CART_PUT_FORM_DATA_FAILURE = 'CART_PUT_FORM_DATA_FAILURE';
	
	var CART_QUERYPROJECT_START = exports.CART_QUERYPROJECT_START = 'CART_QUERYPROJECT_START';
	var CART_QUERYPROJECT_COMPLETE = exports.CART_QUERYPROJECT_COMPLETE = 'CART_QUERYPROJECT_COMPLETE';
	
	var CART_SET_INITIAL = exports.CART_SET_INITIAL = "CART_SET_INITIAL";
	
	var CLIENTDATA_SELECT_EXISTING = exports.CLIENTDATA_SELECT_EXISTING = 'CLIENTDATA_SELECT_EXISTING';
	var CLIENTDATA_SELECT_NEW = exports.CLIENTDATA_SELECT_NEW = 'CLIENTDATA_SELECT_NEW';
	
	var AUTHENTICATION_REQUEST = exports.AUTHENTICATION_REQUEST = 'AUTHENTICATION_REQUEST';
	var AUTHENTICATION_FAILURE = exports.AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE';
	var AUTHENTICATION_SUCCESS = exports.AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
	var AUTHENTICATION_CACHED = exports.AUTHENTICATION_CACHED = 'AUTHENTICATION_CACHED';
	
	var CLIENTNUMBER_REQUEST = exports.CLIENTNUMBER_REQUEST = 'CLIENTNUMBER_REQUEST';
	var CLIENTNUMBER_SUCCESS = exports.CLIENTNUMBER_SUCCESS = 'CLIENTNUMBER_SUCCESS';
	var CLIENTNUMBER_FAILURE = exports.CLIENTNUMBER_FAILURE = 'CLIENTNUMBER_FAILURE';
	
	var ACCOUNTS_REQUEST = exports.ACCOUNTS_REQUEST = 'ACCOUNTS_REQUEST';
	var ACCOUNTS_SUCCESS = exports.ACCOUNTS_SUCCESS = 'ACCOUNTS_SUCCESS';
	var ACCOUNTS_FAILURE = exports.ACCOUNTS_FAILURE = 'ACCOUNTS_FAILURE';
	
	var PRE_UPGRADECHECK_REQUEST = exports.PRE_UPGRADECHECK_REQUEST = 'PRE_UPGRADECHECK_REQUEST';
	var PRE_UPGRADECHECK_SUCCESS = exports.PRE_UPGRADECHECK_SUCCESS = 'PRE_UPGRADECHECK_SUCCESS';
	var PRE_UPGRADECHECK_FAILURE = exports.PRE_UPGRADECHECK_FAILURE = 'PRE_UPGRADECHECK_FAILURE';
	
	var CONTRACTS_REQUEST = exports.CONTRACTS_REQUEST = 'CONTRACTS_REQUEST';
	var CONTRACTS_SUCCESS = exports.CONTRACTS_SUCCESS = 'CONTRACTS_SUCCESS';
	var CONTRACTS_FAILURE = exports.CONTRACTS_FAILURE = 'CONTRACTS_FAILURE';
	
	var RESELLERS_REQUEST = exports.RESELLERS_REQUEST = 'RESELLERS_REQUEST';
	var RESELLERS_SUCCESS = exports.RESELLERS_SUCCESS = 'RESELLERS_SUCCESS';
	var RESELLERS_FAILURE = exports.RESELLERS_FAILURE = 'RESELLERS_FAILURE';
	
	var CLIENTDATA_REQUEST = exports.CLIENTDATA_REQUEST = 'CLIENTDATA_REQUEST';
	var CLIENTDATA_SUCCESS = exports.CLIENTDATA_SUCCESS = 'CLIENTDATA_SUCCESS';
	var CLIENTDATA_FAILURE = exports.CLIENTDATA_FAILURE = 'CLIENTDATA_FAILURE';
	
	var POPUP_SHOW_OFFER_SHARING = exports.POPUP_SHOW_OFFER_SHARING = 'POPUP_SHOW_OFFER_SHARING';
	var POPUP_SHOW_IFRAME = exports.POPUP_SHOW_IFRAME = 'POPUP_SHOW_IFRAME';
	var POPUP_CLOSE_ANY = exports.POPUP_CLOSE_ANY = 'POPUP_CLOSE_ANY';
	
	var SUPPORT_BOX_HIDDEN = exports.SUPPORT_BOX_HIDDEN = 'SUPPORT_BOX_HIDDEN';
	var SUPPORT_BOX_SHOWN = exports.SUPPORT_BOX_SHOWN = 'SUPPORT_BOX_SHOWN';
	
	var CONFIGURATION_SCROLL_PROGRESS = exports.CONFIGURATION_SCROLL_PROGRESS = 'CONFIGURATION_SCROLL_PROGRESS';
	var STEP_UNDONE = exports.STEP_UNDONE = 'STEP_UNDONE';
	
	var FORM_TOGGLE_PASSWORD_VISIBILITY = exports.FORM_TOGGLE_PASSWORD_VISIBILITY = 'FORM_TOGGLE_PASSWORD_VISIBILITY';

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _splice = _interopRequireDefault(__webpack_require__(667));
	
	var _getIn = _interopRequireDefault(__webpack_require__(664));
	
	var _setIn = _interopRequireDefault(__webpack_require__(666));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(662));
	
	var _deleteIn = _interopRequireDefault(__webpack_require__(663));
	
	var _keys = _interopRequireDefault(__webpack_require__(665));
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn["default"],
	  setIn: _setIn["default"],
	  deepEqual: _deepEqual["default"],
	  deleteIn: _deleteIn["default"],
	  forEach: function forEach(items, callback) {
	    return items.forEach(callback);
	  },
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys["default"],
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice["default"],
	  equals: function equals(a, b) {
	    return b.every(function (val) {
	      return ~a.indexOf(val);
	    });
	  },
	  orderChanged: function orderChanged(a, b) {
	    return b.some(function (val, index) {
	      return val !== a[index];
	    });
	  },
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	var _default = structure;
	exports["default"] = _default;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getToggleSelections = exports.getMappings = exports.getResellers = exports.getContracts = exports.getAccounts = exports.getArticleOptionCollections = exports.getArticleOptionsData = exports.getDomainData = exports.getBaseArticle = exports.isAlternateSepaSelection = exports.isPromotionCodeValid = exports.getPromotionCodeInformation = exports.getInitialPromotionCode = exports.getInitialAddonLock = exports.getInitialCartAddons = exports.getCartAllowedForCustomerChange = exports.getCartTesting = exports.getCartBackupRange = exports.getCartShowCommissionForm = exports.getCartProjectName = exports.getCartProjectPassword = exports.getCartVerification = exports.getCartItems = exports.getCartBillingAddress = exports.getCartContactPerson = exports.getCartCommissionValue = exports.getCartContractPartner = exports.getCartPhoneVerificationNote = exports.getCartNote = exports.getCartDatabase = exports.getCartSoftware = exports.getCartRecommendedAccount = exports.getCartPromotionCode = exports.getCartPaymentSettings = exports.getCartId = exports.getCart = exports.getRecommendedAccountTypes = exports.isContactPersonOpened = exports.isBillingAddressOpened = exports.getPostalInvoiceSelection = exports.getBillingTypeSelection = undefined;
	
	var _General = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// **************************************************************************************************************
	var getBillingTypeSelection = exports.getBillingTypeSelection = function getBillingTypeSelection(state) {
	    return state.toggleSelections["billingType"];
	};
	var getPostalInvoiceSelection = exports.getPostalInvoiceSelection = function getPostalInvoiceSelection(state) {
	    return state.toggleSelections["invoiceType"];
	};
	
	// **************************************************************************************************************
	var isBillingAddressOpened = exports.isBillingAddressOpened = function isBillingAddressOpened(state) {
	    return state.collapsibles["billingAddress"];
	};
	var isContactPersonOpened = exports.isContactPersonOpened = function isContactPersonOpened(state) {
	    return state.collapsibles["contactPerson"];
	};
	
	// **************************************************************************************************************
	var getRecommendedAccountTypes = exports.getRecommendedAccountTypes = function getRecommendedAccountTypes(state) {
	    return state.recommendedAccountTypes;
	};
	
	// **************************************************************************************************************
	var getCart = exports.getCart = function getCart(state) {
	    return state.cart;
	};
	var getCartId = exports.getCartId = function getCartId(state) {
	    return state.cart.id;
	};
	var getCartPaymentSettings = exports.getCartPaymentSettings = function getCartPaymentSettings(state) {
	    return state.cart.paymentSettings;
	};
	var getCartPromotionCode = exports.getCartPromotionCode = function getCartPromotionCode(state) {
	    return state.cart.promotionCode;
	};
	var getCartRecommendedAccount = exports.getCartRecommendedAccount = function getCartRecommendedAccount(state) {
	    return state.cart.recommendedAccount;
	};
	var getCartSoftware = exports.getCartSoftware = function getCartSoftware(state) {
	    return state.cart && state.cart.software ? state.cart.software : "default";
	};
	var getCartDatabase = exports.getCartDatabase = function getCartDatabase(state) {
	    return state.cart.mysqlVersion ? state.cart.mysqlVersion : false;
	};
	var getCartNote = exports.getCartNote = function getCartNote(state) {
	    return state.cart.note ? state.cart.note.split(_General.DELIMITER_NOTE)[0].split(_General.DELIMITER_SMS)[0] : "";
	};
	var getCartPhoneVerificationNote = exports.getCartPhoneVerificationNote = function getCartPhoneVerificationNote(state) {
	    return state.cart.note ? state.cart.note.split(_General.DELIMITER_NOTE)[1] : "";
	};
	var getCartContractPartner = exports.getCartContractPartner = function getCartContractPartner(state) {
	    return state.cart.contractPartner;
	};
	var getCartCommissionValue = exports.getCartCommissionValue = function getCartCommissionValue(state) {
	    return state.cart.commission;
	};
	var getCartContactPerson = exports.getCartContactPerson = function getCartContactPerson(state) {
	    return state.cart.contactPerson;
	};
	var getCartBillingAddress = exports.getCartBillingAddress = function getCartBillingAddress(state) {
	    return state.cart.billingAddress;
	};
	var getCartItems = exports.getCartItems = function getCartItems(state) {
	    if (!state || !state.cart || !state.cart.items) {
	        return [];
	    }
	    // sort articles ascending
	    return [].concat(_toConsumableArray(state.cart.items)).sort(function (a, b) {
	        return Number(a.identifier) - Number(b.identifier);
	    });
	};
	var getCartVerification = exports.getCartVerification = function getCartVerification(state) {
	    return state.cart.verification;
	};
	var getCartProjectPassword = exports.getCartProjectPassword = function getCartProjectPassword(state) {
	    return state.cart && state.cart.projectPassword;
	};
	var getCartProjectName = exports.getCartProjectName = function getCartProjectName(state) {
	    return state.cart && state.cart.projectName;
	};
	var getCartShowCommissionForm = exports.getCartShowCommissionForm = function getCartShowCommissionForm(state) {
	    return state.cart && state.cart.showCommissionForm;
	};
	
	var getCartBackupRange = exports.getCartBackupRange = function getCartBackupRange(state) {
	    return state.cart.backupRange || 0;
	};
	var getCartTesting = exports.getCartTesting = function getCartTesting(state) {
	    return state && state.cart && state.cart.testing || false;
	};
	var getCartAllowedForCustomerChange = exports.getCartAllowedForCustomerChange = function getCartAllowedForCustomerChange(state) {
	    return state.cart && state.cart.isAllowedForCustomerChange;
	};
	
	// **************************************************************************************************************
	var getInitialCartAddons = exports.getInitialCartAddons = function getInitialCartAddons(state) {
	    return state.cart && state.cart.initParams ? state.cart.initParams.initialArticles : [];
	};
	var getInitialAddonLock = exports.getInitialAddonLock = function getInitialAddonLock(state) {
	    return state.cart && state.cart.initParams ? state.cart.initParams.lockInitialAddons : false;
	};
	var getInitialPromotionCode = exports.getInitialPromotionCode = function getInitialPromotionCode(state) {
	    return state.cart && state.cart.initParams ? state.cart.initParams.initialPromotionCode : false;
	};
	
	// **************************************************************************************************************
	var getPromotionCodeInformation = exports.getPromotionCodeInformation = function getPromotionCodeInformation(state) {
	    return state.promotionCode.codeInformation;
	};
	var isPromotionCodeValid = exports.isPromotionCodeValid = function isPromotionCodeValid(state) {
	    return state.promotionCode.validatedPromotionCode;
	};
	
	// **************************************************************************************************************
	var isAlternateSepaSelection = exports.isAlternateSepaSelection = function isAlternateSepaSelection(state) {
	    return state.paymentStep.isAlternateSepaInput;
	};
	
	// **************************************************************************************************************
	var getBaseArticle = exports.getBaseArticle = function getBaseArticle(state) {
	    return state.articleData.baseArticle;
	};
	
	// **************************************************************************************************************
	var getDomainData = exports.getDomainData = function getDomainData(state) {
	    return state.domainCheck.topLevelDomains.data;
	};
	
	// **************************************************************************************************************
	var getArticleOptionsData = exports.getArticleOptionsData = function getArticleOptionsData(state) {
	    return state.articleData.articleOptions;
	};
	var getArticleOptionCollections = exports.getArticleOptionCollections = function getArticleOptionCollections(state) {
	    return state.articleData.articleOptionCollection;
	};
	
	var getAccounts = exports.getAccounts = function getAccounts(state) {
	    return state.accounts;
	};
	var getContracts = exports.getContracts = function getContracts(state) {
	    return state.contracts;
	};
	var getResellers = exports.getResellers = function getResellers(state) {
	    return state.resellers;
	};
	var getMappings = exports.getMappings = function getMappings(state) {
	    return state.mappings;
	};
	
	var getToggleSelections = exports.getToggleSelections = function getToggleSelections(state) {
	    return state.toggleSelections;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(571));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(254));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(572));
	
	exports.connect = _connect.default;

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.findGetParameter = findGetParameter;
	exports.spliceArrayByValue = spliceArrayByValue;
	exports.getRandomInt = getRandomInt;
	exports.shuffleArray = shuffleArray;
	exports.removeParameterFromUrl = removeParameterFromUrl;
	exports.setCookie = setCookie;
	exports.getCookie = getCookie;
	function findGetParameter(parameterName) {
	    var result = null,
	        tmp = [];
	    window.location.search.substr(1).split("&").forEach(function (item) {
	        tmp = item.split(/(=)(.*)/);
	        if (tmp[0] === parameterName) {
	            result = decodeURIComponent(tmp[2]);
	        }
	    });
	    return result;
	}
	
	var delve = exports.delve = function delve(obj, key, def, p, undef) {
	    key = key.split ? key.split('.') : key;
	    for (p = 0; p < key.length; p++) {
	        obj = obj ? obj[key[p]] : undef;
	    }
	    return obj === undef ? def : obj;
	};
	
	function spliceArrayByValue(array, value) {
	    if (!array) {
	        return;
	    }
	    var index = array.indexOf(value);
	    if (index !== -1) {
	        array.splice(index, 1);
	    }
	}
	
	/**
	 * @param max
	 * @returns {number} between 1 and max
	 */
	function getRandomInt(max) {
	    return Math.floor(Math.random() * Math.floor(max)) + 1;
	}
	
	function shuffleArray(array) {
	    for (var i = array.length - 1; i > 0; i--) {
	        var j = Math.floor(Math.random() * (i + 1));
	        var _ref = [array[j], array[i]];
	        array[i] = _ref[0];
	        array[j] = _ref[1];
	    }
	    return array;
	}
	
	function removeParameterFromUrl(url, parameter) {
	    return url.replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1').replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
	}
	
	function setCookie(name, value, days) {
	    var expires = "";
	
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
	        expires = "; expires=" + date.toUTCString();
	    }
	
	    document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}
	
	function getCookie(name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(';');
	
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	
	        while (c.charAt(0) === ' ') {
	            c = c.substring(1, c.length);
	        }
	
	        if (c.indexOf(nameEQ) === 0) {
	            return c.substring(nameEQ.length, c.length);
	        }
	    }
	
	    return null; // Cookie wurde nicht gefunden
	}

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DELIMITER_NOTE = exports.DELIMITER_NOTE = ", Telefonverifizierung-Notiz: ";
	var DELIMITER_SMS = exports.DELIMITER_SMS = " [SMS-Validierung]: ";
	var DELIMITER_USTID = exports.DELIMITER_USTID = ", USt-ID: ";
	
	var APP_MODE_REGULAR = exports.APP_MODE_REGULAR = "regular";
	var APP_MODE_AGENCYSERVER_ADD_PROJECT = exports.APP_MODE_AGENCYSERVER_ADD_PROJECT = "agencyserver_add_project";
	var APP_MODE_OUTSOURCING = exports.APP_MODE_OUTSOURCING = "outsourcing";
	var APP_MODE_AUTHENTICATED_ORDER = exports.APP_MODE_AUTHENTICATED_ORDER = "authenticated_order";
	var APP_MODE_PRODUCT_CHANGE = exports.APP_MODE_PRODUCT_CHANGE = "product_change";
	var APP_MODE_PRESET = exports.APP_MODE_PRESET = "preset";
	var APP_MODE_ACCESSORY = exports.APP_MODE_ACCESSORY = "accessory";
	
	var PAYMENT_TYPE_SEPA = exports.PAYMENT_TYPE_SEPA = "SEPA";
	
	/** Constants **/
	var INVOICE_TYPE_EMAIL = exports.INVOICE_TYPE_EMAIL = "email";
	var INVOICE_TYPE_POST = exports.INVOICE_TYPE_POST = "post";
	var PAYMENT_TYPE_INVOICE = exports.PAYMENT_TYPE_INVOICE = "INVOICE";
	var PROJECT_TYPE_CREATE = exports.PROJECT_TYPE_CREATE = "PROJECT_TYPE_CREATE";
	var PROJECT_TYPE_SKIP = exports.PROJECT_TYPE_SKIP = "PROJECT_TYPE_SKIP";
	
	var PRODUCT_SELECTION_CONSUMER = exports.PRODUCT_SELECTION_CONSUMER = "SELECTION_CONSUMER";
	var PRODUCT_SELECTION_AGENCY = exports.PRODUCT_SELECTION_AGENCY = "SELECTION_AGENCY";
	var PRODUCT_SELECTION_AVMANAGER_UNLIMITED = exports.PRODUCT_SELECTION_AVMANAGER_UNLIMITED = "SELECTION_AVMANAGER_UNLIMITED";
	var PRODUCT_SELECTION_AVMANAGER_LITE = exports.PRODUCT_SELECTION_AVMANAGER_LITE = "SELECTION_AVMANAGER_LITE";
	var PRODUCT_SELECTION_PROSPACE = exports.PRODUCT_SELECTION_PROSPACE = "SELECTION_PROSPACE";
	var PRODUCT_SELECTION_SPACESERVER = exports.PRODUCT_SELECTION_SPACESERVER = "SELECTION_SPACESERVER";
	
	var OUTSOURCING_CREATE_NEW = exports.OUTSOURCING_CREATE_NEW = "OUTSOURCING_CREATE_NEW";
	var OUTSOURCING_ADDPROJECT = exports.OUTSOURCING_ADDPROJECT = "OUTSOURCING_ADDPROJECT";
	
	var DOMAIN_TYPE_DEV = exports.DOMAIN_TYPE_DEV = "DOMAIN_TYPE_DEV";
	var DOMAIN_TYPE_CUSTOM = exports.DOMAIN_TYPE_CUSTOM = "DOMAIN_TYPE_CUSTOM";
	
	var ARTICLE_TYPE_CMS = exports.ARTICLE_TYPE_CMS = "cms";
	var ARTICLE_TYPE_SHOP = exports.ARTICLE_TYPE_SHOP = "shop";
	var ARTICLE_TYPE_DEV = exports.ARTICLE_TYPE_DEV = "dev";
	var ARTICLE_TYPE_BASE = exports.ARTICLE_TYPE_BASE = "base";
	
	var PROJECT_STATE_LIVE = exports.PROJECT_STATE_LIVE = "live";
	var PROJECT_STATE_DEV = exports.PROJECT_STATE_DEV = "dev";
	
	var ARTICLE_CONFIGURATOR_MODE_CMS = exports.ARTICLE_CONFIGURATOR_MODE_CMS = "cms";
	var ARTICLE_CONFIGURATOR_MODE_SHOP = exports.ARTICLE_CONFIGURATOR_MODE_SHOP = "shop";
	var ARTICLE_CONFIGURATOR_MODE_SHARED = exports.ARTICLE_CONFIGURATOR_MODE_SHARED = "shared";
	var ARTICLE_CONFIGURATOR_MODE_CONSUMER = exports.ARTICLE_CONFIGURATOR_MODE_CONSUMER = "consumer";
	var ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION = exports.ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION = "consumer_selection";
	var ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE = exports.ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE = "website";
	var ARTICLE_CONFIGURATOR_LAYOUT_AGENCY = exports.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY = "agency";
	
	var SALUTATION_PREFIXES = exports.SALUTATION_PREFIXES = {
	  'Herr': 'Herr ',
	  'Frau': 'Frau ',
	  '': '',
	  'keine Angabe': '',
	  'Divers': ''
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getArticleConfiguratorData = exports.getAvailableAccessoryArticles = exports.cartApiEndpoint = exports.lsPrefix = exports.lsConfigurator = exports.dsgvoArticles = exports.accessoryArticles = exports.agencyServerProjectArticles = exports.agencyServerShopArticles = exports.agencyServerCMSArticles = exports.shopArticles = exports.cmsArticles = exports.devProjectArticleNumber = exports.agencyServerArticleNumber = exports.DOMAIN_LOAD_MORE_AMOUNT = exports.DOMAIN_AMOUNT_TOPDOMAINS = undefined;
	
	var _faBoxAlt = __webpack_require__(295);
	
	var _faShoppingBasket = __webpack_require__(307);
	
	var _General = __webpack_require__(10);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _GetParam = __webpack_require__(17);
	
	var _Accounts = __webpack_require__(125);
	
	var _util = __webpack_require__(9);
	
	var _reselect = __webpack_require__(31);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DOMAIN_AMOUNT_TOPDOMAINS = exports.DOMAIN_AMOUNT_TOPDOMAINS = 10;
	var DOMAIN_LOAD_MORE_AMOUNT = exports.DOMAIN_LOAD_MORE_AMOUNT = 10;
	
	var agencyServerArticleNumber = exports.agencyServerArticleNumber = "72000";
	var devProjectArticleNumber = exports.devProjectArticleNumber = "72002";
	
	/** Article Mapping **/
	var cmsArticles = exports.cmsArticles = ["70000", "70010", "70001", "70011", "70012", "70002", "70013", "70014", "70003", "70015", "70016", "70004", /* HS: */"70017", "70018", "70019"];
	var shopArticles = exports.shopArticles = ["70500", "70510", "70501", "70511", "70512", "70502", "70513", "70514", "70503", "70515", "70516", "70504", /* HS: */"70517", "70518", "70519"];
	var agencyServerCMSArticles = exports.agencyServerCMSArticles = ["72100", "72101", "72111", "72112", "72102", "72113", "72114", "72103", "72115", "72116", "72104", /* HS: */"72117", "72118", "72119"];
	var agencyServerShopArticles = exports.agencyServerShopArticles = ["72200", "72210", "72201", "72211", "72212", "72202", "72213", "72214", "72203", "72223", "72224", "72204", /* HS: */"72225", "72226", "72227"];
	var agencyServerProjectArticles = exports.agencyServerProjectArticles = ["696969", "72002"].concat(agencyServerCMSArticles, agencyServerShopArticles);
	var accessoryArticles = exports.accessoryArticles = ["74000", "74011" /*, "74010"*/, "75000", "75001", "75002", "75003"];
	var dsgvoArticles = exports.dsgvoArticles = ["191021", "191025", "191026"];
	
	var lsConfigurator = exports.lsConfigurator = "mw_configurator_0221";
	var lsPrefix = exports.lsPrefix = "mw_3.2_";
	
	/** DYNAMIC API ENDPOINTS **/
	var cartApiEndpoint = exports.cartApiEndpoint =  false ? 'carts' : 'carts';
	
	var getAvailableAccessoryArticles = exports.getAvailableAccessoryArticles = (0, _reselect.createSelector)([_SimpleSelectors.getContracts, _SimpleSelectors.getMappings, _Accounts.getCurrentAccountByContract], function (contracts, mappings, currentAccount) {
	
	    var availableAccessories = [].concat(accessoryArticles);
	
	    // search for already purchased accessories for current account
	    var pNameMappings = mappings && mappings.pNameAccount || {};
	
	    if (contracts && currentAccount) {
	        Object.keys(contracts).forEach(function (contractIdentifier) {
	            var contractData = contracts[contractIdentifier];
	            var contractArticleNumber = '' + (0, _util.delve)(contractData, 'article.articleNumber');
	            if (accessoryArticles.indexOf(contractArticleNumber) >= 0) {
	                // is accessory
	                var accountName = (0, _util.delve)(contractData, 'account.name');
	                if (accountName && pNameMappings[accountName] === '' + currentAccount) {
	                    availableAccessories = availableAccessories.filter(function (accessory) {
	                        return accessory !== contractArticleNumber;
	                    });
	                }
	            }
	        });
	    }
	
	    return availableAccessories;
	});
	
	/** Article Configurator setup **/
	var getArticleConfiguratorData = exports.getArticleConfiguratorData = function getArticleConfiguratorData(state) {
	    var _projectStates, _ref;
	
	    return _ref = {}, _defineProperty(_ref, _General.ARTICLE_CONFIGURATOR_MODE_SHARED, {
	        projectStates: (_projectStates = {}, _defineProperty(_projectStates, _General.PROJECT_STATE_DEV, {
	            label: "DEV-Projekt",
	            value: _General.PROJECT_STATE_DEV,
	            projectTypes: {
	                dev: {
	                    label: "DEV-Projekt",
	                    value: _General.ARTICLE_TYPE_DEV,
	                    icon: _faBoxAlt.faBoxAlt,
	                    default: "72002",
	                    articles: ["72002"]
	                }
	            }
	        }), _defineProperty(_projectStates, _General.PROJECT_STATE_LIVE, {
	            label: "LIVE-Projekt",
	            value: _General.PROJECT_STATE_LIVE,
	            projectTypes: {
	                cms: {
	                    label: "Website / Blog",
	                    value: _General.ARTICLE_TYPE_CMS,
	                    icon: _faBoxAlt.faBoxAlt,
	                    default: "72111",
	                    articles: ["72100", "72101", "72111", "72112", "72102", "72113", "72114", "72103", "72115", "72116", "72104", "72117", "72118", "72119"]
	                },
	                shop: {
	                    label: "Shop / E-Commerce",
	                    value: _General.ARTICLE_TYPE_SHOP,
	                    icon: _faShoppingBasket.faShoppingBasket,
	                    default: "72201",
	                    articles: ["72200", "72210", "72201", "72211", "72212", "72202", "72213", "72214", "72203", "72223", "72224", "72204", "72225", "72226", "72227"]
	                }
	            }
	        }), _projectStates),
	        backupRange: [{ label: "1 Tag", value: 1 }, { label: "7 Tage", value: 7 }, { label: "14 Tage", value: 14 }, { label: "28 Tage", value: 28 }],
	        initialValues: {
	            state: "",
	            article: "",
	            type: "",
	            backup: 0,
	            storage: ""
	        }
	    }), _defineProperty(_ref, _General.ARTICLE_CONFIGURATOR_MODE_CMS, {
	        projectStates: _defineProperty({}, _General.PROJECT_STATE_LIVE, {
	            label: "LIVE-Projekt",
	            value: _General.PROJECT_STATE_LIVE,
	            projectTypes: {
	                cms: {
	                    label: "Website / Blog",
	                    value: _General.ARTICLE_TYPE_CMS,
	                    icon: _faBoxAlt.faBoxAlt,
	                    default: "70010",
	                    articles: ["70000", "70010", "70001", "70011", "70012", "70002", "70013", "70014", "70003", "70015", "70016", "70004", "70017", "70018", "70019"]
	                }
	            }
	        }),
	        backupRange: [{ label: "1 Tag", value: 1 }, { label: "7 Tage", value: 7 }, { label: "14 Tage", value: 14 }, { label: "28 Tage", value: 28 }],
	        initialValues: {
	            state: "",
	            article: "",
	            type: "",
	            backup: 0,
	            storage: ""
	        }
	    }), _defineProperty(_ref, _General.ARTICLE_CONFIGURATOR_MODE_SHOP, {
	        projectStates: _defineProperty({}, _General.PROJECT_STATE_LIVE, {
	            label: "LIVE-Projekt",
	            value: _General.PROJECT_STATE_LIVE,
	            projectTypes: {
	                shop: {
	                    label: "Shop / E-Commerce",
	                    value: _General.ARTICLE_TYPE_SHOP,
	                    icon: _faBoxAlt.faBoxAlt,
	                    default: "70510",
	                    articles: ["70500", "70510", "70501", "70511", "70512", "70502", "70513", "70514", "70503", "70515", "70516", "70504", "70517", "70518", "70519"]
	                }
	            }
	        }),
	        backupRange: [{ label: "1 Tag", value: 1 }, { label: "7 Tage", value: 7 }, { label: "14 Tage", value: 14 }, { label: "28 Tage", value: 28 }],
	        initialValues: {
	            state: "",
	            article: "",
	            type: "",
	            backup: 0,
	            storage: ""
	        }
	    }), _defineProperty(_ref, _General.ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION, {
	        projectStates: _defineProperty({}, _General.PROJECT_STATE_LIVE, {
	            label: "LIVE-Projekt",
	            value: _General.PROJECT_STATE_LIVE,
	            projectTypes: {
	                cms: {
	                    label: "Website / Blog",
	                    value: _General.ARTICLE_TYPE_CMS,
	                    icon: _faBoxAlt.faBoxAlt,
	                    default: "70010",
	                    articles: ["70000", "70010", "70001", "70011", "70012", "70002", "70013", "70014", "70003", "70015", "70016", "70004", "70017", "70018", "70019"]
	                },
	                shop: {
	                    label: "Shop / E-Commerce",
	                    value: _General.ARTICLE_TYPE_SHOP,
	                    icon: _faShoppingBasket.faShoppingBasket,
	                    default: "70510",
	                    articles: ["70500", "70510", "70501", "70511", "70512", "70502", "70513", "70514", "70503", "70515", "70516", "70504", "70517", "70518", "70519"]
	                }
	            }
	        }),
	        backupRange: [{ label: "1 Tag", value: 1 }, { label: "7 Tage", value: 7 }, { label: "14 Tage", value: 14 }, { label: "28 Tage", value: 28 }],
	        initialValues: {
	            state: "",
	            article: "",
	            type: "",
	            backup: 0,
	            storage: ""
	        }
	    }), _defineProperty(_ref, _General.ARTICLE_CONFIGURATOR_MODE_CONSUMER, {
	        projectStates: _defineProperty({}, _General.PROJECT_STATE_LIVE, {
	            label: "LIVE-Projekt",
	            value: _General.PROJECT_STATE_LIVE,
	            projectTypes: {
	                base: {
	                    label: "Ihr gewählter Artikel",
	                    value: _General.ARTICLE_TYPE_BASE,
	                    icon: _faBoxAlt.faBoxAlt,
	                    default: "" + (0, _SimpleSelectors.getBaseArticle)(state).articleNumber,
	                    articles: [
	                    // in this mode, only add base article as only option
	                    "" + (0, _SimpleSelectors.getBaseArticle)(state).articleNumber]
	                }
	            }
	        }),
	        backupRange: [{ label: "1 Tag", value: 1 }, { label: "7 Tage", value: 7 }, { label: "14 Tage", value: 14 }, { label: "28 Tage", value: 28 }],
	        initialValues: {
	            state: "",
	            article: "",
	            type: "",
	            backup: 0,
	            storage: ""
	        }
	    }), _ref;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.updateSyncErrors = exports.updateSyncWarnings = exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.resetSection = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.clearSubmit = exports.clearFields = exports.clearAsyncError = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.formPropTypes = exports.fieldArrayPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.SubmissionError = exports.ReduxFormContext = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.isAsyncValidating = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.getFormError = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.propTypes = exports.FormSection = exports.FormName = exports.Form = exports.defaultShouldWarn = exports.defaultShouldError = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = exports.actionTypes = void 0;
	
	var _actions = _interopRequireDefault(__webpack_require__(264));
	
	var _actionTypes = _interopRequireDefault(__webpack_require__(168));
	
	exports.actionTypes = _actionTypes["default"];
	
	var _ReduxFormContext = __webpack_require__(46);
	
	exports.ReduxFormContext = _ReduxFormContext.ReduxFormContext;
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(266));
	
	exports.defaultShouldAsyncValidate = _defaultShouldAsyncValidate["default"];
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(268));
	
	exports.defaultShouldValidate = _defaultShouldValidate["default"];
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(267));
	
	exports.defaultShouldError = _defaultShouldError["default"];
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(269));
	
	exports.defaultShouldWarn = _defaultShouldWarn["default"];
	
	var _Form = _interopRequireDefault(__webpack_require__(606));
	
	exports.Form = _Form["default"];
	
	var _FormName = _interopRequireDefault(__webpack_require__(607));
	
	exports.FormName = _FormName["default"];
	
	var _FormSection = _interopRequireDefault(__webpack_require__(608));
	
	exports.FormSection = _FormSection["default"];
	
	var _SubmissionError = __webpack_require__(263);
	
	exports.SubmissionError = _SubmissionError.SubmissionError;
	
	var _propTypes = _interopRequireWildcard(__webpack_require__(644));
	
	exports.propTypes = _propTypes["default"];
	exports.fieldInputPropTypes = _propTypes.fieldInputPropTypes;
	exports.fieldMetaPropTypes = _propTypes.fieldMetaPropTypes;
	exports.fieldPropTypes = _propTypes.fieldPropTypes;
	exports.fieldArrayFieldsPropTypes = _propTypes.fieldArrayFieldsPropTypes;
	exports.fieldArrayMetaPropTypes = _propTypes.fieldArrayMetaPropTypes;
	exports.fieldArrayPropTypes = _propTypes.fieldArrayPropTypes;
	exports.formPropTypes = _propTypes.formPropTypes;
	
	var _Field = _interopRequireDefault(__webpack_require__(603));
	
	exports.Field = _Field["default"];
	
	var _Fields = _interopRequireDefault(__webpack_require__(605));
	
	exports.Fields = _Fields["default"];
	
	var _FieldArray = _interopRequireDefault(__webpack_require__(604));
	
	exports.FieldArray = _FieldArray["default"];
	
	var _formValueSelector = _interopRequireDefault(__webpack_require__(622));
	
	exports.formValueSelector = _formValueSelector["default"];
	
	var _formValues = _interopRequireDefault(__webpack_require__(623));
	
	exports.formValues = _formValues["default"];
	
	var _getFormError = _interopRequireDefault(__webpack_require__(626));
	
	exports.getFormError = _getFormError["default"];
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(629));
	
	exports.getFormNames = _getFormNames["default"];
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(633));
	
	exports.getFormValues = _getFormValues["default"];
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(627));
	
	exports.getFormInitialValues = _getFormInitialValues["default"];
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(631));
	
	exports.getFormSyncErrors = _getFormSyncErrors["default"];
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(628));
	
	exports.getFormMeta = _getFormMeta["default"];
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(625));
	
	exports.getFormAsyncErrors = _getFormAsyncErrors["default"];
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(632));
	
	exports.getFormSyncWarnings = _getFormSyncWarnings["default"];
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(630));
	
	exports.getFormSubmitErrors = _getFormSubmitErrors["default"];
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(638));
	
	exports.isAsyncValidating = _isAsyncValidating["default"];
	
	var _isDirty = _interopRequireDefault(__webpack_require__(639));
	
	exports.isDirty = _isDirty["default"];
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(640));
	
	exports.isInvalid = _isInvalid["default"];
	
	var _isPristine = _interopRequireDefault(__webpack_require__(641));
	
	exports.isPristine = _isPristine["default"];
	
	var _isValid = _interopRequireDefault(__webpack_require__(643));
	
	exports.isValid = _isValid["default"];
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(642));
	
	exports.isSubmitting = _isSubmitting["default"];
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(637));
	
	exports.hasSubmitSucceeded = _hasSubmitSucceeded["default"];
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(636));
	
	exports.hasSubmitFailed = _hasSubmitFailed["default"];
	
	var _reduxForm = _interopRequireDefault(__webpack_require__(646));
	
	exports.reduxForm = _reduxForm["default"];
	
	var _reducer = _interopRequireDefault(__webpack_require__(645));
	
	exports.reducer = _reducer["default"];
	
	var _values = _interopRequireDefault(__webpack_require__(671));
	
	exports.values = _values["default"];
	// alias for propTypes
	var arrayInsert = _actions["default"].arrayInsert;
	exports.arrayInsert = arrayInsert;
	var arrayMove = _actions["default"].arrayMove;
	exports.arrayMove = arrayMove;
	var arrayPop = _actions["default"].arrayPop;
	exports.arrayPop = arrayPop;
	var arrayPush = _actions["default"].arrayPush;
	exports.arrayPush = arrayPush;
	var arrayRemove = _actions["default"].arrayRemove;
	exports.arrayRemove = arrayRemove;
	var arrayRemoveAll = _actions["default"].arrayRemoveAll;
	exports.arrayRemoveAll = arrayRemoveAll;
	var arrayShift = _actions["default"].arrayShift;
	exports.arrayShift = arrayShift;
	var arraySplice = _actions["default"].arraySplice;
	exports.arraySplice = arraySplice;
	var arraySwap = _actions["default"].arraySwap;
	exports.arraySwap = arraySwap;
	var arrayUnshift = _actions["default"].arrayUnshift;
	exports.arrayUnshift = arrayUnshift;
	var autofill = _actions["default"].autofill;
	exports.autofill = autofill;
	var blur = _actions["default"].blur;
	exports.blur = blur;
	var change = _actions["default"].change;
	exports.change = change;
	var clearAsyncError = _actions["default"].clearAsyncError;
	exports.clearAsyncError = clearAsyncError;
	var clearFields = _actions["default"].clearFields;
	exports.clearFields = clearFields;
	var clearSubmit = _actions["default"].clearSubmit;
	exports.clearSubmit = clearSubmit;
	var clearSubmitErrors = _actions["default"].clearSubmitErrors;
	exports.clearSubmitErrors = clearSubmitErrors;
	var destroy = _actions["default"].destroy;
	exports.destroy = destroy;
	var focus = _actions["default"].focus;
	exports.focus = focus;
	var initialize = _actions["default"].initialize;
	exports.initialize = initialize;
	var registerField = _actions["default"].registerField;
	exports.registerField = registerField;
	var reset = _actions["default"].reset;
	exports.reset = reset;
	var resetSection = _actions["default"].resetSection;
	exports.resetSection = resetSection;
	var setSubmitFailed = _actions["default"].setSubmitFailed;
	exports.setSubmitFailed = setSubmitFailed;
	var setSubmitSucceeded = _actions["default"].setSubmitSucceeded;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	var startAsyncValidation = _actions["default"].startAsyncValidation;
	exports.startAsyncValidation = startAsyncValidation;
	var startSubmit = _actions["default"].startSubmit;
	exports.startSubmit = startSubmit;
	var stopAsyncValidation = _actions["default"].stopAsyncValidation;
	exports.stopAsyncValidation = stopAsyncValidation;
	var stopSubmit = _actions["default"].stopSubmit;
	exports.stopSubmit = stopSubmit;
	var submit = _actions["default"].submit;
	exports.submit = submit;
	var touch = _actions["default"].touch;
	exports.touch = touch;
	var unregisterField = _actions["default"].unregisterField;
	exports.unregisterField = unregisterField;
	var untouch = _actions["default"].untouch;
	exports.untouch = untouch;
	var updateSyncWarnings = _actions["default"].updateSyncWarnings;
	exports.updateSyncWarnings = updateSyncWarnings;
	var updateSyncErrors = _actions["default"].updateSyncErrors;
	exports.updateSyncErrors = updateSyncErrors;

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 14 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(108)('wks');
	var uid = __webpack_require__(89);
	var Symbol = __webpack_require__(29).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._token = exports._configuratorMode = exports._useConfiguration = exports._orderCta = exports._orderTitle = exports._initialSoftware = exports._forcePartnerId = exports._preset = exports._accessory = exports._contract = exports._account = exports._action = exports._auth = exports._customerNumber = exports._agencyServer = exports._article = exports.isNoRedirect = exports.isContractLocked = exports.isGTMDisabled = exports.getSandboxModeFlag = exports.getEndpointURL = exports.getSimpleModeFlag = exports.getParamPromotion = exports.getAffiliateId = undefined;
	
	var _util = __webpack_require__(9);
	
	// **************************************************************************************************************
	
	var commissionParam = (0, _util.findGetParameter)('aid');
	var commissionCookie = (0, _util.getCookie)('recommendationCode');
	var getAffiliateId = exports.getAffiliateId = function getAffiliateId() {
	  return commissionCookie || commissionParam;
	};
	
	var promotionParam = (0, _util.findGetParameter)('promotion');
	var getParamPromotion = exports.getParamPromotion = function getParamPromotion() {
	  return promotionParam;
	};
	
	var simpleMode = (0, _util.findGetParameter)('simple');
	var getSimpleModeFlag = exports.getSimpleModeFlag = function getSimpleModeFlag() {
	  return simpleMode === "1";
	};
	
	var endpoint = (0, _util.findGetParameter)('endpoint');
	var getEndpointURL = exports.getEndpointURL = function getEndpointURL() {
	  return endpoint;
	};
	
	var isSandboxMode = (0, _util.findGetParameter)('sandbox');
	var getSandboxModeFlag = exports.getSandboxModeFlag = function getSandboxModeFlag() {
	  return isSandboxMode;
	};
	
	var isIgnoreGTM = (0, _util.findGetParameter)('disablegtm');
	var isGTMDisabled = exports.isGTMDisabled = function isGTMDisabled() {
	  return isIgnoreGTM;
	};
	
	var _isContractLocked = (0, _util.findGetParameter)('contractFixed');
	var isContractLocked = exports.isContractLocked = function isContractLocked() {
	  return _isContractLocked === "1";
	};
	
	var redirect = (0, _util.findGetParameter)('redirect') || "";
	var isNoRedirect = exports.isNoRedirect = function isNoRedirect() {
	  return redirect === "false";
	};
	
	var _article = exports._article = (0, _util.findGetParameter)("article");
	
	// bestellstrecke: agenturserver projekt hinzufügen
	var _agencyServer = exports._agencyServer = (0, _util.findGetParameter)("agencyServer");
	
	// bestellstrecken authentizierung
	var _customerNumber = exports._customerNumber = (0, _util.findGetParameter)("customerNumber");
	var _auth = exports._auth = (0, _util.findGetParameter)("auth");
	
	var _action = exports._action = (0, _util.findGetParameter)("action");
	var _account = exports._account = (0, _util.findGetParameter)("account");
	var _contract = exports._contract = (0, _util.findGetParameter)("contract");
	var _accessory = exports._accessory = (0, _util.findGetParameter)("accessory");
	var _preset = exports._preset = (0, _util.findGetParameter)('preset');
	var _forcePartnerId = exports._forcePartnerId = (0, _util.findGetParameter)('forcePartnerId');
	
	var _initialSoftware = exports._initialSoftware = (0, _util.findGetParameter)('software');
	
	var _orderTitle = exports._orderTitle = (0, _util.findGetParameter)('orderTitle');
	var _orderCta = exports._orderCta = (0, _util.findGetParameter)('orderCta');
	
	// agenturserver configurator flag
	var _useConfiguration = exports._useConfiguration = (0, _util.findGetParameter)("useConfiguration");
	
	var _configuratorMode = exports._configuratorMode = (0, _util.findGetParameter)("mode");
	
	var _token = exports._token = (0, _util.findGetParameter)("token");

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isAgencyCustomer = exports.getAppMode = exports.isMode = undefined;
	
	var _GetParam = __webpack_require__(17);
	
	var _General = __webpack_require__(10);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Config = __webpack_require__(11);
	
	var calculatedAppMode = null;
	
	if (!!(_GetParam._customerNumber && _GetParam._auth && _GetParam._action === "accessory" && (_GetParam._contract || _GetParam._account) && _GetParam._accessory)) {
	    calculatedAppMode = _General.APP_MODE_ACCESSORY;
	} else if (!!(_GetParam._customerNumber && _GetParam._auth && _GetParam._action === "change" && _GetParam._contract)) {
	    calculatedAppMode = _General.APP_MODE_PRODUCT_CHANGE;
	} else if (!!(_GetParam._customerNumber && _GetParam._auth && _GetParam._action === "order")) {
	    calculatedAppMode = _General.APP_MODE_AUTHENTICATED_ORDER;
	} else if (!!(_GetParam._agencyServer && _GetParam._customerNumber && _GetParam._auth)) {
	    calculatedAppMode = _General.APP_MODE_AGENCYSERVER_ADD_PROJECT;
	} else if (!!(_GetParam._customerNumber && _GetParam._auth && _GetParam._action === "outsourcing" && _GetParam._account)) {
	    calculatedAppMode = _General.APP_MODE_OUTSOURCING;
	} else if (!!_GetParam._preset) {
	    calculatedAppMode = _General.APP_MODE_PRESET;
	} else if (!(_GetParam._customerNumber || _GetParam._preset || _GetParam._auth || _GetParam._action || _GetParam._account || _GetParam._agencyServer || _GetParam._customerNumber)) {
	    calculatedAppMode = _General.APP_MODE_REGULAR;
	}
	
	var isMode = exports.isMode = function isMode(mode) {
	    return calculatedAppMode === mode;
	};
	
	var getAppMode = exports.getAppMode = function getAppMode() {
	    return calculatedAppMode;
	};
	
	var isAgencyCustomer = exports.isAgencyCustomer = function isAgencyCustomer(state) {
	    return (0, _SimpleSelectors.getBaseArticle)(state).articleNumber + '' === _Config.agencyServerArticleNumber || isMode(_General.APP_MODE_AGENCYSERVER_ADD_PROJECT);
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(13)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(52);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 22 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 23 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.newCustomerSelected = exports.existingCustomerSelected = exports.queryUserAuthentication = exports.cachedCustomerAuthentication = exports.queryBearerToken = undefined;
	
	var _MittwaldApi = __webpack_require__(42);
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _Cart = __webpack_require__(28);
	
	var _GetParam = __webpack_require__(17);
	
	var _FormData = __webpack_require__(35);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// **************************************************************************************************************
	
	
	var fetchAuthenticatedClientData = function fetchAuthenticatedClientData(bearer, customerNumber) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CLIENTDATA_REQUEST, ActionTypes.CLIENTDATA_SUCCESS, ActionTypes.CLIENTDATA_FAILURE],
	        endpoint: 'customers/' + customerNumber + '/contractpartner',
	        schema: _MittwaldApi.Schemas.CLIENT_DATA,
	        bearer: bearer,
	        method: 'GET',
	        payload: {
	            customerNumber: customerNumber
	        }
	    });
	};
	
	var fetchBearerToken = function fetchBearerToken() {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.BEARER_TOKEN_REQUEST, ActionTypes.BEARER_TOKEN_SUCCESS, ActionTypes.BEARER_TOKEN_FAILURE],
	        endpoint: 'authenticate',
	        schema: _MittwaldApi.Schemas.BEARER_TOKEN,
	        method: 'POST',
	        postData: {}
	    });
	};
	
	var fetchBearerTokenSpecial = function fetchBearerTokenSpecial(tempToken, customerNumber) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.BEARER_TOKEN_REQUEST, ActionTypes.BEARER_TOKEN_SUCCESS, ActionTypes.BEARER_TOKEN_FAILURE],
	        endpoint: 'authenticate/token',
	        schema: _MittwaldApi.Schemas.BEARER_TOKEN,
	        method: 'POST',
	        postData: {
	            username: customerNumber,
	            sudo: "true",
	            ttl: 10000
	        },
	        customHeaders: {
	            auth: {
	                key: "Authorization",
	                value: "Bearer " + tempToken
	            },
	            accept: {
	                key: "Accept",
	                value: "application/json"
	            }
	        }
	    });
	};
	
	var cachedBearerToken = function cachedBearerToken() {
	    return {
	
	        type: ActionTypes.BEARER_TOKEN_CACHE
	
	    };
	};
	
	var queryBearerToken = exports.queryBearerToken = function queryBearerToken() {
	    var forceNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return function (dispatch, getState) {
	
	        /**
	         * Functionality to test with custom token
	         */
	        if (!forceNew && _GetParam._token && _GetParam._customerNumber && !getState().appState.isAuthenticatedUser) {
	            dispatch({
	                type: ActionTypes.BEARER_TOKEN_SUCCESS,
	                response: {
	                    entities: {
	                        tokens: {
	                            token: {
	                                token: _GetParam._token,
	                                expires: new Date().getTime() + 86400 * 1000
	                            }
	                        }
	                    }
	                }
	            });
	            return dispatch(fetchAuthenticatedClientData(getState().token.bearer, _GetParam._customerNumber));
	        }
	
	        if (_GetParam._customerNumber && _GetParam._auth && !getState().appState.isAuthenticatedUser || getState().token.bearer === "" || new Date().getTime() > new Date(getState().token.expires).getTime() || forceNew) {
	
	            if (_GetParam._customerNumber && _GetParam._auth) {
	
	                return dispatch(fetchBearerTokenSpecial(_GetParam._auth, _GetParam._customerNumber)).then(function (args) {
	                    return dispatch(fetchAuthenticatedClientData(getState().token.bearer, _GetParam._customerNumber));
	                });
	            } else {
	
	                return dispatch(fetchBearerToken());
	            }
	        } else {
	            // return promise to match MittwaldApi return type ().then()
	            return new Promise(function (resolve) {
	                resolve(dispatch(cachedBearerToken()));
	            });
	        }
	    };
	};
	
	// **************************************************************************************************************
	
	var fetchUserAuthentication = function fetchUserAuthentication(username, password) {
	    var multiFactorCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var deviceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.AUTHENTICATION_REQUEST, ActionTypes.AUTHENTICATION_SUCCESS, ActionTypes.AUTHENTICATION_FAILURE],
	        endpoint: 'authenticate',
	        //credentials: 'include',
	        schema: _MittwaldApi.Schemas.BEARER_TOKEN,
	        method: 'POST',
	        postData: {
	            username: username,
	            password: password,
	            multiFactorCode: multiFactorCode,
	            deviceId: deviceId
	        }
	    });
	};
	
	var fetchClientNumber = function fetchClientNumber(bearer, clientType, accountName) {
	
	    var endpointPartial = "";
	
	    switch (clientType) {
	
	        default:
	        case 'paccount':
	            endpointPartial = "accounts";
	            break;
	
	        case 'reseller':
	            endpointPartial = "resellers";
	            break;
	
	    }
	
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CLIENTNUMBER_REQUEST, ActionTypes.CLIENTNUMBER_SUCCESS, ActionTypes.CLIENTNUMBER_FAILURE],
	        endpoint: endpointPartial + '/' + accountName,
	        schema: _MittwaldApi.Schemas.JSON,
	        bearer: bearer,
	        method: 'GET'
	    });
	};
	
	var cachedCustomerAuthentication = exports.cachedCustomerAuthentication = function cachedCustomerAuthentication() {
	    return {
	        type: ActionTypes.AUTHENTICATION_CACHED
	    };
	};
	
	var queryAuthenticatedClientData = function queryAuthenticatedClientData(accountName) {
	    return function (dispatch, getState) {
	
	        switch (accountName.charAt(0)) {
	
	            case "r":
	                return dispatch(fetchClientNumber(getState().token.bearer, "reseller", accountName)).then(function (args) {
	                    if (args.type === ActionTypes.CLIENTNUMBER_SUCCESS) {
	                        return dispatch(fetchAuthenticatedClientData(getState().token.bearer, args.response.result.customerNumber));
	                    } else {
	                        return false;
	                    }
	                });
	
	            case "p":
	                return dispatch(fetchClientNumber(getState().token.bearer, "paccount", accountName)).then(function (args) {
	                    if (args.type === ActionTypes.CLIENTNUMBER_SUCCESS) {
	                        return dispatch(fetchAuthenticatedClientData(getState().token.bearer, args.response.result.customerNumber));
	                    } else {
	                        return false;
	                    }
	                });
	
	            default:
	                return dispatch(fetchAuthenticatedClientData(getState().token.bearer, accountName));
	
	        }
	    };
	};
	
	var queryUserAuthentication = exports.queryUserAuthentication = function queryUserAuthentication(username, password, multiFactorCode) {
	    return function (dispatch, getState) {
	
	        var oldToken = getState().token.bearer;
	
	        var deviceId = (0, _util.getCookie)('device_id');
	
	        return dispatch(fetchUserAuthentication(username, password, multiFactorCode, deviceId)).then(function (args) {
	            if (args.type === ActionTypes.AUTHENTICATION_FAILURE) {
	                return args;
	            }
	            return Promise.all([dispatch((0, _Cart.queryCartShare)(oldToken)).then(function (args) {
	
	                var shareTemplateId = args.response.result.id;
	
	                return dispatch((0, _Cart.queryNewCartFromTemplate)(shareTemplateId)).then(function (args) {
	                    if (!(0, _GetParam.getSimpleModeFlag)()) {
	                        return dispatch((0, _FormData.putFormData)());
	                    }
	                });
	            }), dispatch(queryAuthenticatedClientData(username))]);
	            // share cart
	            // create new cart with new token
	            // put form data
	        });
	    };
	};
	
	// **************************************************************************************************************
	var existingCustomerSelected = exports.existingCustomerSelected = function existingCustomerSelected() {
	    return function (dispatch, getState) {
	
	        return dispatch({
	            type: ActionTypes.CLIENTDATA_SELECT_EXISTING
	        });
	    };
	};
	
	var newCustomerSelected = exports.newCustomerSelected = function newCustomerSelected() {
	    return function (dispatch, getState) {
	
	        var oldToken = getState().token.bearer;
	
	        dispatch({
	            type: ActionTypes.CLIENTDATA_SELECT_NEW
	        });
	
	        return dispatch(queryBearerToken(true)).then(function (args) {
	
	            return Promise.all([dispatch((0, _Cart.queryCartShare)(oldToken)).then(function (args) {
	
	                var shareTemplateId = args.response.result.id;
	
	                return dispatch((0, _Cart.queryNewCartFromTemplate)(shareTemplateId)).then(function (args) {
	                    if (!(0, _GetParam.getSimpleModeFlag)()) {
	                        return dispatch((0, _FormData.putFormData)());
	                    }
	                });
	            })]);
	        });
	    };
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(294), __webpack_require__(3), __webpack_require__(1)) :
	  typeof define === 'function' && define.amd ? define(['exports', '@fortawesome/fontawesome-svg-core', 'prop-types', 'react'], factory) :
	  (global = global || self, factory(global['react-fontawesome'] = {}, global.FontAwesome, global.PropTypes, global.React));
	}(this, (function (exports, fontawesomeSvgCore, PropTypes, React) { 'use strict';
	
	  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
	  React = React && React.hasOwnProperty('default') ? React['default'] : React;
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function ownKeys(object, enumerableOnly) {
	    var keys = Object.keys(object);
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(object);
	      if (enumerableOnly) symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	      keys.push.apply(keys, symbols);
	    }
	
	    return keys;
	  }
	
	  function _objectSpread2(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	
	      if (i % 2) {
	        ownKeys(Object(source), true).forEach(function (key) {
	          _defineProperty(target, key, source[key]);
	        });
	      } else if (Object.getOwnPropertyDescriptors) {
	        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	      } else {
	        ownKeys(Object(source)).forEach(function (key) {
	          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	        });
	      }
	    }
	
	    return target;
	  }
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  // Get CSS class list from a props object
	  function classList(props) {
	    var _classes;
	
	    var spin = props.spin,
	        pulse = props.pulse,
	        fixedWidth = props.fixedWidth,
	        inverse = props.inverse,
	        border = props.border,
	        listItem = props.listItem,
	        flip = props.flip,
	        size = props.size,
	        rotation = props.rotation,
	        pull = props.pull; // map of CSS class names to properties
	
	    var classes = (_classes = {
	      'fa-spin': spin,
	      'fa-pulse': pulse,
	      'fa-fw': fixedWidth,
	      'fa-inverse': inverse,
	      'fa-border': border,
	      'fa-li': listItem,
	      'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
	      'fa-flip-vertical': flip === 'vertical' || flip === 'both'
	    }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
	    // return an array of the keys where the value for the key is not null
	
	    return Object.keys(classes).map(function (key) {
	      return classes[key] ? key : null;
	    }).filter(function (key) {
	      return key;
	    });
	  }
	
	  // Camelize taken from humps
	  // humps is copyright © 2012+ Dom Christie
	  // Released under the MIT license.
	  // Performant way to determine if object coerces to a number
	  function _isNumerical(obj) {
	    obj = obj - 0; // eslint-disable-next-line no-self-compare
	
	    return obj === obj;
	  }
	
	  function camelize(string) {
	    if (_isNumerical(string)) {
	      return string;
	    } // eslint-disable-next-line no-useless-escape
	
	
	    string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    }); // Ensure 1st char is always lowercase
	
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  }
	
	  function capitalize(val) {
	    return val.charAt(0).toUpperCase() + val.slice(1);
	  }
	
	  function styleToObject(style) {
	    return style.split(';').map(function (s) {
	      return s.trim();
	    }).filter(function (s) {
	      return s;
	    }).reduce(function (acc, pair) {
	      var i = pair.indexOf(':');
	      var prop = camelize(pair.slice(0, i));
	      var value = pair.slice(i + 1).trim();
	      prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
	      return acc;
	    }, {});
	  }
	
	  function convert(createElement, element) {
	    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (typeof element === 'string') {
	      return element;
	    }
	
	    var children = (element.children || []).map(function (child) {
	      return convert(createElement, child);
	    });
	    /* eslint-disable dot-notation */
	
	    var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
	      var val = element.attributes[key];
	
	      switch (key) {
	        case 'class':
	          acc.attrs['className'] = val;
	          delete element.attributes['class'];
	          break;
	
	        case 'style':
	          acc.attrs['style'] = styleToObject(val);
	          break;
	
	        default:
	          if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
	            acc.attrs[key.toLowerCase()] = val;
	          } else {
	            acc.attrs[camelize(key)] = val;
	          }
	
	      }
	
	      return acc;
	    }, {
	      attrs: {}
	    });
	
	    var _extraProps$style = extraProps.style,
	        existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
	        remaining = _objectWithoutProperties(extraProps, ["style"]);
	
	    mixins.attrs['style'] = _objectSpread2({}, mixins.attrs['style'], {}, existingStyle);
	    /* eslint-enable */
	
	    return createElement.apply(void 0, [element.tag, _objectSpread2({}, mixins.attrs, {}, remaining)].concat(_toConsumableArray(children)));
	  }
	
	  var PRODUCTION = false;
	
	  try {
	    PRODUCTION = ("production") === 'production';
	  } catch (e) {}
	
	  function log () {
	    if (!PRODUCTION && console && typeof console.error === 'function') {
	      var _console;
	
	      (_console = console).error.apply(_console, arguments);
	    }
	  }
	
	  // Normalize icon arguments
	  function normalizeIconArgs(icon) {
	    // if the icon is null, there's nothing to do
	    if (icon === null) {
	      return null;
	    } // if the icon is an object and has a prefix and an icon name, return it
	
	
	    if (_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
	      return icon;
	    } // if it's an array with length of two
	
	
	    if (Array.isArray(icon) && icon.length === 2) {
	      // use the first item as prefix, second as icon name
	      return {
	        prefix: icon[0],
	        iconName: icon[1]
	      };
	    } // if it's a string, use it as the icon name
	
	
	    if (typeof icon === 'string') {
	      return {
	        prefix: 'fas',
	        iconName: icon
	      };
	    }
	  }
	
	  // creates an object with a key of key
	  // and a value of value
	  // if certain conditions are met
	  function objectWithKey(key, value) {
	    // if the value is a non-empty array
	    // or it's not an array but it is truthy
	    // then create the object with the key and the value
	    // if not, return an empty array
	    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
	  }
	
	  function FontAwesomeIcon(_ref) {
	    var forwardedRef = _ref.forwardedRef,
	        props = _objectWithoutProperties(_ref, ["forwardedRef"]);
	
	    var iconArgs = props.icon,
	        maskArgs = props.mask,
	        symbol = props.symbol,
	        className = props.className,
	        title = props.title;
	    var iconLookup = normalizeIconArgs(iconArgs);
	    var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
	    var transform = objectWithKey('transform', typeof props.transform === 'string' ? fontawesomeSvgCore.parse.transform(props.transform) : props.transform);
	    var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
	    var renderedIcon = fontawesomeSvgCore.icon(iconLookup, _objectSpread2({}, classes, {}, transform, {}, mask, {
	      symbol: symbol,
	      title: title
	    }));
	
	    if (!renderedIcon) {
	      log('Could not find icon', iconLookup);
	      return null;
	    }
	
	    var abstract = renderedIcon.abstract;
	    var extraProps = {
	      ref: forwardedRef
	    };
	    Object.keys(props).forEach(function (key) {
	      // eslint-disable-next-line no-prototype-builtins
	      if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
	        extraProps[key] = props[key];
	      }
	    });
	    return convertCurry(abstract[0], extraProps);
	  }
	  FontAwesomeIcon.displayName = 'FontAwesomeIcon';
	  FontAwesomeIcon.propTypes = {
	    border: PropTypes.bool,
	    className: PropTypes.string,
	    mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
	    fixedWidth: PropTypes.bool,
	    inverse: PropTypes.bool,
	    flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
	    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
	    listItem: PropTypes.bool,
	    pull: PropTypes.oneOf(['right', 'left']),
	    pulse: PropTypes.bool,
	    rotation: PropTypes.oneOf([0, 90, 180, 270]),
	    size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
	    spin: PropTypes.bool,
	    symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	    title: PropTypes.string,
	    transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	    swapOpacity: PropTypes.bool
	  };
	  FontAwesomeIcon.defaultProps = {
	    border: false,
	    className: '',
	    mask: null,
	    fixedWidth: false,
	    inverse: false,
	    flip: null,
	    icon: null,
	    listItem: false,
	    pull: null,
	    pulse: false,
	    rotation: null,
	    size: null,
	    spin: false,
	    symbol: false,
	    title: '',
	    transform: null,
	    swapOpacity: false
	  };
	  var convertCurry = convert.bind(null, React.createElement);
	
	  exports.FontAwesomeIcon = FontAwesomeIcon;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(293);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.queryCartRemoveAllItems = exports.querySimpleCartCheckout = exports.queryCartCheckout = exports.validateCartPaidSoftware = exports.removeAllDomainsFromCart = exports.addDomainToCartAndRefresh = exports.addDomainToCart = exports.removeDomainFromCart = exports.removeItemFromCartByArticleNumber = exports.removeItemFromCart = exports.setInitialParam = exports.addItemToCart = exports.queryCartUpdate = exports.queryPreloadedCart = exports.queryNewCart = exports.queryNewCartFromTemplate = exports.queryCartShare = exports.queueItemOperation = undefined;
	
	var _MittwaldApi = __webpack_require__(42);
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _FormData = __webpack_require__(35);
	
	var _UserAuthentication = __webpack_require__(24);
	
	var _Popup = __webpack_require__(174);
	
	var _PromotionCode = __webpack_require__(131);
	
	var _GetParam = __webpack_require__(17);
	
	var _CartUtil = __webpack_require__(37);
	
	var _Cart = __webpack_require__(36);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _General = __webpack_require__(10);
	
	var _Mode = __webpack_require__(18);
	
	var _engine = __webpack_require__(288);
	
	var _Config = __webpack_require__(11);
	
	var _UserInterface = __webpack_require__(70);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var itemsOperationQueue = [];
	var itemOperationRunning = false;
	var itemOperationPromise = null;
	
	var processItemOperation = function processItemOperation(dispatch, getState, resolve) {
	    var _operation$;
	
	    itemOperationRunning = true;
	    var operation = itemsOperationQueue.shift();
	    dispatch((_operation$ = operation[0]).call.apply(_operation$, [null].concat(_toConsumableArray(operation[1])))).then(function (args) {
	        if (itemsOperationQueue.length > 0) {
	            setTimeout(function () {
	                processItemOperation(dispatch, getState, resolve);
	            }, 50);
	        } else {
	            itemOperationRunning = false;
	            itemOperationPromise = null;
	            setTimeout(function () {
	                resolve(true);
	            }, 50);
	        }
	    });
	};
	
	/**
	 * wrapper function to execute promises in sequence
	 * @param queuedOperation
	 * @param queuedParams
	 * @returns {(function(*, *): (null))|*}
	 */
	var queueItemOperation = exports.queueItemOperation = function queueItemOperation(queuedOperation) {
	    for (var _len = arguments.length, queuedParams = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        queuedParams[_key - 1] = arguments[_key];
	    }
	
	    return function (dispatch, getState) {
	        itemsOperationQueue.push([queuedOperation, queuedParams]);
	        if (!itemOperationRunning) {
	            itemOperationPromise = new Promise(function (resolve, reject) {
	                processItemOperation(dispatch, getState, resolve);
	            });
	        }
	        if (itemOperationPromise) {
	            return itemOperationPromise;
	        }
	    };
	};
	
	// **************************************************************************************************************
	var fetchCartShare = function fetchCartShare(bearer, cartId) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_SHARE_REQUEST, ActionTypes.CART_SHARE_SUCCESS, ActionTypes.CART_SHARE_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + cartId + '/actions/share',
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.CARTSHARESCHEMA,
	        method: 'POST'
	    });
	};
	
	var queryCartShare = exports.queryCartShare = function queryCartShare() {
	    var bearer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchCartShare(bearer ? bearer : getState().token.bearer, getState().cart.id));
	        });
	    };
	};
	
	// **************************************************************************************************************
	var fetchNewCartFromTemplate = function fetchNewCartFromTemplate(bearer, presetId) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_CREATE_REQUEST, ActionTypes.CART_CREATE_SUCCESS, ActionTypes.CART_CREATE_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + presetId,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.CARTSCHEMA,
	        method: 'POST',
	        payload: {
	            createdFromPreset: presetId
	        }
	    });
	};
	
	var queryNewCartFromTemplate = exports.queryNewCartFromTemplate = function queryNewCartFromTemplate(presetId) {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchNewCartFromTemplate(getState().token.bearer, presetId));
	        });
	    };
	};
	
	// **************************************************************************************************************
	var fetchNewCart = function fetchNewCart(bearer) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_CREATE_REQUEST, ActionTypes.CART_CREATE_SUCCESS, ActionTypes.CART_CREATE_FAILURE],
	        endpoint: '' + _Config.cartApiEndpoint,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.CARTSCHEMA,
	        method: 'POST',
	        postData: (0, _Mode.isMode)(_General.APP_MODE_OUTSOURCING) ? {
	            forcePartnerId: _GetParam._forcePartnerId
	        } : null
	    });
	};
	
	var queryNewCart = exports.queryNewCart = function queryNewCart() {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchNewCart(getState().token.bearer));
	        });
	    };
	};
	
	// **************************************************************************************************************
	var fetchCartUpdate = function fetchCartUpdate(bearer, cartId) {
	    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_UPDATE_REQUEST, ActionTypes.CART_UPDATE_SUCCESS, ActionTypes.CART_UPDATE_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + cartId,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.CARTSCHEMA,
	        method: 'GET',
	        payload: payload
	    });
	};
	
	var queryPreloadedCart = exports.queryPreloadedCart = function queryPreloadedCart(cartId) {
	    return function (dispatch, getState) {
	
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchCartUpdate(getState().token.bearer, cartId, { updateSteps: true, isUserAuthenticated: getState().clientDataStep.clientData !== false }));
	        });
	    };
	};
	
	var queryCartUpdate = exports.queryCartUpdate = function queryCartUpdate() {
	    return function (dispatch, getState) {
	
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchCartUpdate(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState())));
	        });
	    };
	};
	
	// **************************************************************************************************************
	var fetchAddItemToCart = function fetchAddItemToCart(bearer, cartId, articleNumber) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_ADD_ITEM_REQUEST, ActionTypes.CART_ADD_ITEM_SUCCESS, ActionTypes.CART_ADD_ITEM_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + cartId + '/items',
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.CARTSCHEMA,
	        method: 'POST',
	        payload: {
	            itemId: articleNumber
	        },
	        postData: {
	            identifier: articleNumber
	        }
	    });
	};
	
	var addItemToCart = exports.addItemToCart = function addItemToCart(articleNumber) {
	    return function (dispatch, getState) {
	        if (!articleNumber) {
	            return Promise.resolve();
	        }
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            // show popup when item added to cart
	            var articleData = (0, _SimpleSelectors.getArticleOptionsData)(getState())[articleNumber];
	            var onSelectPopup = articleData ? articleData.onSelectPopup : false;
	
	            if (onSelectPopup) {
	                setTimeout(function () {
	                    dispatch((0, _Popup.showPopupWithIframe)(onSelectPopup));
	                }, 500);
	            }
	            return dispatch(fetchAddItemToCart(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), "" + articleNumber)).then(function (action) {
	                return dispatch((0, _PromotionCode.queryPromotionCodeIfArticleInCode)("" + articleNumber));
	            });
	        });
	    };
	};
	
	var setInitialParam = exports.setInitialParam = function setInitialParam(key, value) {
	    return {
	        type: ActionTypes.CART_SET_INITIAL,
	        key: key,
	        value: value
	    };
	};
	
	// **************************************************************************************************************
	var fetchRemoveItemFromCart = function fetchRemoveItemFromCart(bearer, cartId, itemId) {
	    var itemType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
	    var isSwapping = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_REMOVE_ITEM_REQUEST, ActionTypes.CART_REMOVE_ITEM_SUCCESS, ActionTypes.CART_REMOVE_ITEM_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + cartId + '/items/' + itemId,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.CARTSCHEMA,
	        method: 'DELETE',
	        payload: {
	            itemType: itemType,
	            itemId: itemId,
	            isSwapping: isSwapping
	        }
	    });
	};
	
	var removeItemFromCart = exports.removeItemFromCart = function removeItemFromCart(itemId) {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchRemoveItemFromCart(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), itemId)).then(function (action) {
	                if (action.type === _ActionTypes.CART_REMOVE_ITEM_SUCCESS) {
	                    return dispatch((0, _PromotionCode.queryPromotionCodeStatusAndData)());
	                } else {
	                    // try a second time
	                    return dispatch(fetchRemoveItemFromCart(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), itemId)).then(function (action) {
	                        return dispatch((0, _PromotionCode.queryPromotionCodeStatusAndData)());
	                    });
	                }
	            });
	        });
	    };
	};
	
	// todo: failsafe remove calls by adding them to queue, for now a second attempt will be made
	var removeItemFromCartByArticleNumber = exports.removeItemFromCartByArticleNumber = function removeItemFromCartByArticleNumber(articleNumber, isSwapping) {
	    return function (dispatch, getState) {
	
	        var itemId = (0, _Cart.getItemInCartByArticleNumber)(getState(), articleNumber);
	
	        if (!itemId) {
	            return new Promise(function (resolve, reject) {
	                setTimeout(function () {
	                    resolve(true);
	                }, 50);
	            });
	        }
	
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchRemoveItemFromCart(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), itemId, '', isSwapping)).then(function (action) {
	                if (action.type === _ActionTypes.CART_REMOVE_ITEM_SUCCESS) {
	                    return dispatch((0, _PromotionCode.queryPromotionCodeIfArticleInCode)(articleNumber));
	                } else {
	                    // try a second time
	                    return dispatch(fetchRemoveItemFromCart(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), itemId, '', isSwapping)).then(function (action) {
	                        return dispatch((0, _PromotionCode.queryPromotionCodeIfArticleInCode)(articleNumber));
	                    });
	                }
	            });
	        });
	    };
	};
	
	var removeDomainFromCart = exports.removeDomainFromCart = function removeDomainFromCart(itemId) {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchRemoveItemFromCart(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), itemId, 'DOMAIN'));
	        });
	    };
	};
	// **************************************************************************************************************
	var fetchAddDomainToCart = function fetchAddDomainToCart(bearer, cartId, domainNameAndEnding) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_ADD_DOMAIN_REQUEST, ActionTypes.CART_ADD_DOMAIN_SUCCESS, ActionTypes.CART_ADD_DOMAIN_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + cartId + '/domains',
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.STATUSTEXT,
	        method: 'POST',
	        payload: {
	            domain: domainNameAndEnding
	        },
	        postData: {
	            name: domainNameAndEnding
	        }
	    });
	};
	
	var addDomainToCart = exports.addDomainToCart = function addDomainToCart(domainNameAndEnding) {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchAddDomainToCart(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), domainNameAndEnding));
	        });
	    };
	};
	
	// dummy action until api is fixed
	var addDomainToCartAndRefresh = exports.addDomainToCartAndRefresh = function addDomainToCartAndRefresh(domainNameAndEnding) {
	    return function (dispatch, getState) {
	        Promise.all([dispatch(addDomainToCart(domainNameAndEnding))]).then(function (args) {
	            dispatch(queryCartUpdate());
	        });
	    };
	};
	
	var removeAllDomainsFromCart = exports.removeAllDomainsFromCart = function removeAllDomainsFromCart() {
	    return function (dispatch, getState) {
	        var domainItems = (0, _CartUtil.getDomainInCartObject)(getState());
	
	        domainItems.forEach(function (domainObject) {
	            dispatch(queueItemOperation(removeItemFromCart, domainObject.itemId));
	        });
	    };
	};
	
	var validateCartPaidSoftware = exports.validateCartPaidSoftware = function validateCartPaidSoftware() {
	    return function (dispatch, getState) {};
	};
	
	// **************************************************************************************************************
	var fetchCartCheckout = function fetchCartCheckout(bearer, cartId, pinCode) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_CHECKOUT_REQUEST, ActionTypes.CART_CHECKOUT_SUCCESS, ActionTypes.CART_CHECKOUT_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + cartId + '/actions/checkout',
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.STATUSCODE,
	        method: 'POST',
	        postData: pinCode ? {
	            pinCode: pinCode
	        } : null
	    });
	};
	
	var queryCartCheckout = exports.queryCartCheckout = function queryCartCheckout() {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch((0, _FormData.putFormData)(true)).then(function (args) {
	
	                return dispatch(fetchCartCheckout(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), getState().properties.pinCode)).then(function (args) {
	
	                    if (args && args.type === ActionTypes.CART_CHECKOUT_SUCCESS) {
	                        var state = getState();
	                        var engine = (0, _engine.getEngine)();
	                        engine.save({});
	
	                        if ((0, _GetParam.isNoRedirect)()) {
	                            console.log("no redirect detected");
	                        } else {
	                            setTimeout(function () {
	                                performFinalRedirect(state);
	                            }, 350);
	                        }
	                    } else {
	                        alert("Bei der Bestellung ist leider ein Problem aufgetreten. Bei weiteren Fragen wende dich bitte an den Kundenservice.");
	                    }
	                });
	            });
	        });
	    };
	};
	
	var querySimpleCartCheckout = exports.querySimpleCartCheckout = function querySimpleCartCheckout() {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch((0, _FormData.putSimpleFormData)()).then(function (args) {
	                return dispatch(fetchCartCheckout(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()))).then(function (args) {
	
	                    var state = getState();
	                    var endpointURL = (0, _GetParam.getEndpointURL)();
	                    var engine = (0, _engine.getEngine)();
	
	                    engine.save({});
	
	                    if (args && args.type === ActionTypes.CART_CHECKOUT_SUCCESS) {
	                        setTimeout(function () {
	                            if (endpointURL) {
	                                top.location.assign(endpointURL);
	                            } else {
	                                performFinalRedirect(state, top);
	                            }
	                        }, 350);
	                    } else {
	                        alert("Bei der Bestellung ist leider ein Problem aufgetreten. Bei weiteren Fragen wende dich bitte an den Kundenservice.");
	                    }
	                });
	            });
	        });
	    };
	};
	
	var performFinalRedirect = function performFinalRedirect(state) {
	    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
	
	    var isAuthenticated = (0, _UserInterface.isExistingUserAuthenticatedAndSelected)(state);
	    var mainArticle = (0, _Cart.getMainArticleInCart)(state);
	    var articleData = (0, _SimpleSelectors.getArticleOptionsData)(state);
	    var mainArticleData = articleData[mainArticle];
	
	    var url = void 0;
	    if (mainArticleData) {
	        url = 'https://www.mittwald.de/bestellung/bestellbestaetigung?articlenumber=' + mainArticleData.articleNumber + '&articletitle=' + mainArticleData.title + '&new=' + (isAuthenticated ? 'false' : 'true');
	    } else {
	        url = 'https://www.mittwald.de/bestellung/bestellbestaetigung';
	    }
	
	    target.location.assign(url);
	};
	
	var queryCartRemoveAllItems = exports.queryCartRemoveAllItems = function queryCartRemoveAllItems() {
	    return function (dispatch, getState) {
	        var itemsInCart = (0, _SimpleSelectors.getCartItems)(getState());
	        var promise = null;
	        itemsInCart.forEach(function (item) {
	            promise = dispatch(queueItemOperation(removeItemFromCart, item.id));
	        });
	        return itemOperationPromise || promise || Promise.resolve(true);
	    };
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var fails = __webpack_require__(13);
	var defined = __webpack_require__(51);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 32 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25);
	var IE8_DOM_DEFINE = __webpack_require__(188);
	var toPrimitive = __webpack_require__(75);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(84);
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.putSimpleFormData = exports.putFormData = undefined;
	
	var _MittwaldApi = __webpack_require__(42);
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(11);
	
	var _validate = __webpack_require__(78);
	
	var _General = __webpack_require__(10);
	
	var _GetParam = __webpack_require__(17);
	
	var _UserAuthentication = __webpack_require__(24);
	
	var _Mode = __webpack_require__(18);
	
	var _Cart = __webpack_require__(36);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Forms = __webpack_require__(38);
	
	var _ProductSelection = __webpack_require__(48);
	
	var _util = __webpack_require__(9);
	
	var _UserInterface = __webpack_require__(70);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// **************************************************************************************************************
	var fetchPutFormData = function fetchPutFormData(bearer, cartId, formData) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.CART_PUT_FORM_DATA_REQUEST, ActionTypes.CART_PUT_FORM_DATA_SUCCESS, ActionTypes.CART_PUT_FORM_DATA_FAILURE],
	        endpoint: _Config.cartApiEndpoint + '/' + cartId,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.CARTSCHEMA,
	        method: 'PUT',
	        postData: formData
	    });
	};
	/*let latestFormDataCall = 0*/
	
	/**
	 *
	 * @param isFinalCall
	 * @returns {function(*, *): *}
	 */
	var putFormData = exports.putFormData = function putFormData() {
	    var isFinalCall = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return function (dispatch, getState) {
	
	        // don't spam putFormData
	        /*if(new Date().getTime() - latestFormDataCall < 100) {
	         return
	         }
	          latestFormDataCall = new Date().getTime()*/
	
	        var formData = Object.assign({}, (0, _Cart.getInitialCartFormData)(getState()));
	
	        var state = getState();
	
	        var commissionByCookie = (0, _util.getCookie)('recommendationCode');
	
	        if ((0, _GetParam.getAffiliateId)()) {
	            if (!(0, _SimpleSelectors.getCartCommissionValue)(state)) {
	                formData.commission = (0, _GetParam.getAffiliateId)();
	            } else {
	                formData.commission = (0, _SimpleSelectors.getCartCommissionValue)(state);
	            }
	        } else if ((0, _Forms.getCommissionForm)(state) && (0, _Forms.getCommissionForm)(state).values) {
	            formData.commission = (0, _Forms.getCommissionForm)(state).values.commission;
	        } else {
	            if (getState().cart.isCommissionLocked && getState().cart.commission) {
	                formData.commission = getState().cart.commission;
	            }
	        }
	
	        if ((0, _Forms.isNewCustomerSelected)(state)) {
	
	            //if contract partner form is valid
	            if ((0, _Forms.getContractPartnerForm)(state) && (0, _Forms.getContractPartnerForm)(state).values && Object.keys((0, _Forms.getContractPartnerForm)(state).values).length > 0) {
	
	                // if data is valid, push contractPartner data
	                if (!(0, _Forms.getContractPartnerForm)(state).syncErrors) {
	                    formData.contractPartner = Object.assign({}, (0, _Forms.getContractPartnerForm)(state).values);
	
	                    if (formData.contractPartner.phone) {
	                        formData.contractPartner.phone = (0, _validate.getCorrectPhoneFormat)(formData.contractPartner.phone);
	                    }
	
	                    if (formData.contractPartner.salutation === 'keine Angabe') {
	                        formData.contractPartner.salutation = '';
	                    }
	
	                    Object.keys(formData["contractPartner"]).forEach(function (key) {
	                        formData["contractPartner"][key] = String(formData["contractPartner"][key]).trim();
	                    });
	                }
	
	                // if data is set, push note
	                if ((0, _Forms.getContractPartnerForm)(state).values.note) {
	                    formData.note = (0, _Forms.getContractPartnerForm)(state).values.note;
	                } else {
	                    formData.note = "";
	                }
	
	                //phone selected, form exists?
	                if ((0, _Forms.getPhoneVerificationForm)(state) && (0, _Forms.getPhoneVerificationForm)(state).values && (0, _Forms.getPhoneVerificationForm)(state).values.note) {
	                    formData.note = formData.note + _General.DELIMITER_NOTE + (0, _Forms.getPhoneVerificationForm)(state).values.note;
	                }
	
	                // if data is set, set client type
	                if ((0, _Forms.getContractPartnerForm)(state).values.recommendedAccount) {
	                    formData.recommendedAccount = (0, _Forms.getContractPartnerForm)(state).values.recommendedAccount;
	                }
	            }
	
	            // if billing address is set and valid, push - else delete
	            if ((0, _Forms.getBillingAddressForm)(state) && (0, _Forms.getBillingAddressForm)(state).values && Object.keys((0, _Forms.getBillingAddressForm)(state).values).length > 0) {
	                if ((0, _SimpleSelectors.isBillingAddressOpened)(state) && !(0, _Forms.getBillingAddressForm)(state).syncErrors) {
	                    formData.billingAddress = Object.assign({}, (0, _Forms.getBillingAddressForm)(state).values);
	                    if (formData.billingAddress.phone) {
	                        formData.billingAddress.phone = (0, _validate.getCorrectPhoneFormat)(formData.billingAddress.phone);
	                    }
	
	                    if (formData.billingAddress.salutation === 'keine Angabe') {
	                        formData.billingAddress.salutation = '';
	                    }
	
	                    Object.keys(formData["billingAddress"]).forEach(function (key) {
	                        formData["billingAddress"][key] = String(formData["billingAddress"][key]).trim();
	                    });
	                } else {
	                    // empty data if no longer opened
	                    delete formData.billingAddress;
	                }
	            }
	
	            // if technical contact is set and valid, push - else delete
	            if ((0, _Forms.getContactPersonForm)(state) && (0, _Forms.getContactPersonForm)(state).values && Object.keys((0, _Forms.getContactPersonForm)(state).values).length > 0) {
	                if ((0, _SimpleSelectors.isContactPersonOpened)(state) && !(0, _Forms.getContactPersonForm)(state).syncErrors) {
	                    formData.contactPerson = Object.assign({}, (0, _Forms.getContactPersonForm)(state).values);
	                    if (formData.contactPerson.phone) {
	                        formData.contactPerson.phone = (0, _validate.getCorrectPhoneFormat)(formData.contactPerson.phone);
	                    }
	
	                    if (formData.contactPerson.salutation === 'keine Angabe') {
	                        formData.contactPerson.salutation = '';
	                    }
	
	                    Object.keys(formData["contactPerson"]).forEach(function (key) {
	                        formData["contactPerson"][key] = String(formData["contactPerson"][key]).trim();
	                    });
	                } else {
	                    // empty data if no longer opened
	                    delete formData.contactPerson;
	                }
	            }
	        }
	
	        // if payment type is selected, push
	        if ((0, _SimpleSelectors.getBillingTypeSelection)(state) !== undefined) {
	
	            if (!formData.paymentSettings) {
	                formData.paymentSettings = {};
	            }
	
	            if ((0, _SimpleSelectors.getBillingTypeSelection)(state) === _General.PAYMENT_TYPE_INVOICE) {
	
	                // delete existing sepa data
	                if (formData.paymentSettings.iban) {
	                    delete formData.paymentSettings.iban;
	                }
	                if (formData.paymentSettings.bic) {
	                    delete formData.paymentSettings.bic;
	                }
	                if (formData.paymentSettings.accountHolder) {
	                    delete formData.paymentSettings.accountHolder;
	                }
	
	                formData.paymentSettings.billingType = _General.PAYMENT_TYPE_INVOICE;
	            } else if ((0, _SimpleSelectors.getBillingTypeSelection)(state) === _General.PAYMENT_TYPE_SEPA) {
	
	                // delete existing invoice
	                if (formData.paymentSettings.billingType) {
	                    delete formData.paymentSettings.billingType;
	                }
	
	                // if no validationResult errors, push data
	                if ((0, _Forms.getSepaForm)(state) && (0, _Forms.getSepaForm)(state).values && !Object.keys((0, _validate.validateSepa)((0, _Forms.getSepaForm)(state).values)).length) {
	                    var sepaValues = (0, _Forms.getSepaForm)(state).values;
	
	                    formData.paymentSettings = Object.assign({}, formData.paymentSettings, {
	                        billingType: _General.PAYMENT_TYPE_SEPA,
	                        bic: String(sepaValues.bic).trim(),
	                        iban: String(sepaValues.iban).trim(),
	                        accountHolder: String(sepaValues.accountHolder).trim()
	                    });
	                }
	            }
	        }
	
	        // postal invoice selected?
	        if ((0, _SimpleSelectors.getPostalInvoiceSelection)(state) !== undefined) {
	            // postal invoice true?
	            if (!formData.paymentSettings) {
	                formData.paymentSettings = {};
	            }
	            formData.paymentSettings.postalInvoice = (0, _SimpleSelectors.getPostalInvoiceSelection)(state) === _General.INVOICE_TYPE_POST;
	        }
	
	        if (state.properties.software && state.properties.software !== "default" && state.properties.software !== "") {
	            formData.software = state.properties.software;
	        }
	
	        // promotion code entered and validated?
	        if (state.promotionCode.validatedPromotionCode) {
	            formData.promotionCode = state.promotionCode.codeInformation.code;
	        } else {
	            formData.promotionCode = "";
	        }
	
	        if (state.database.databaseSelected) {
	            formData.mysqlVersion = state.database.databaseSelected;
	        } else if (state.database.defaultOption) {
	            formData.mysqlVersion = state.database.defaultOption.uid;
	        }
	
	        if (!(0, _Forms.isNewCustomerSelected)(state) && (0, _Forms.getOrderNoteForm)(state) && (0, _Forms.getOrderNoteForm)(state).values && (0, _Forms.getOrderNoteForm)(state).values.note) {
	            formData.note = (0, _Forms.getOrderNoteForm)(state).values.note;
	        }
	
	        /** Validate values in properties state and assign values if matching **/
	        if ([1, 2, 3, 4].indexOf(state.properties.billingPeriod) >= 0) {
	            formData.billingPeriod = state.properties.billingPeriod;
	        }
	        if ([1, 7, 14, 28].indexOf(state.properties.backupRange) >= 0) {
	            formData.backupRange = state.properties.backupRange;
	        }
	        /** **/
	        if (state.properties.projectName) {
	            formData.projectName = state.properties.projectName;
	        }
	
	        if (state.properties.projectPasswordInCart) {
	            formData.projectPassword = state.properties.projectPasswordInCart;
	        } else if (state.properties.projectPassword) {
	            formData.projectPassword = state.properties.projectPassword;
	        }
	
	        if ((0, _Mode.isMode)(_General.APP_MODE_ACCESSORY)) {
	
	            formData.sourceAccount = "" + (0, _ProductSelection.getSelectedAccount)(getState());
	        } else if ((0, _Mode.isMode)(_General.APP_MODE_AGENCYSERVER_ADD_PROJECT)) {
	
	            formData.agencyServer = _GetParam._agencyServer;
	        } else if ((0, _Mode.isMode)(_General.APP_MODE_PRODUCT_CHANGE)) {
	
	            var contracts = (0, _SimpleSelectors.getContracts)(getState());
	            var resellers = (0, _SimpleSelectors.getResellers)(getState());
	            var resellerId = (0, _util.delve)(contracts, _GetParam._contract + ".account.reseller.uid");
	            var article = (0, _util.delve)(contracts, _GetParam._contract + ".article");
	
	            // don't set sourceAccount on legacy resellers
	            if (article.type === "vserver" && parseInt(article.articleNumber, 10) < 70000) {} else {
	                formData.sourceAccount = "" + (0, _ProductSelection.getSelectedAccount)(getState());
	            }
	
	            if (resellerId && resellers[resellerId].articleNumber + '' === _Config.agencyServerArticleNumber) {
	                formData.agencyServer = "" + resellerId;
	            }
	        } else if ((0, _Mode.isMode)(_General.APP_MODE_OUTSOURCING)) {
	
	            var toggleSelections = (0, _SimpleSelectors.getToggleSelections)(getState());
	
	            if (toggleSelections["outsourcingTarget"] === _General.OUTSOURCING_ADDPROJECT) {
	                formData.agencyServer = toggleSelections["outsourcingResellerTarget"];
	            }
	
	            formData.sourceAccount = (0, _ProductSelection.getSelectedAccount)(getState());
	        } else {
	
	            var currentCartState = (0, _SimpleSelectors.getCart)(getState());
	
	            if (currentCartState && currentCartState["sourceAccount"]) {
	                formData.sourceAccount = currentCartState["sourceAccount"];
	            }
	
	            if (currentCartState && currentCartState["agencyServer"]) {
	                formData.agencyServer = currentCartState["agencyServer"];
	            }
	
	            if ((0, _SimpleSelectors.getCartAllowedForCustomerChange)(state)) {
	                if ((0, _util.delve)(state, "properties.commission", null) !== null) {
	                    formData.commission = state.properties.commission;
	                }
	            }
	        }
	
	        if ((0, _UserInterface.isExistingUserAuthenticatedAndSelected)(getState())) {
	            // only allow testing for new customers
	            formData.testing = false;
	        } else {
	            var testingForm = (0, _Forms.getTestingForm)(getState());
	
	            if (testingForm && testingForm.values) {
	                if (testingForm.values.testing) {
	                    formData.testing = testingForm.values.testing;
	                }
	            } else {
	                formData.testing = state.cart.testing;
	            }
	        }
	
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchPutFormData(state.token.bearer, (0, _SimpleSelectors.getCartId)(state), formData));
	        });
	    };
	};
	
	/**
	 *
	 * @param isFinalCall
	 * @returns {Function}
	 */
	var putSimpleFormData = exports.putSimpleFormData = function putSimpleFormData() {
	    return function (dispatch, getState) {
	
	        var formData = Object.assign({}, (0, _Cart.getInitialCartFormData)(getState()));
	
	        var state = getState();
	
	        if ((0, _Forms.isNewCustomerSelected)(state)) {
	
	            //if contract partner form is valid
	            if ((0, _Forms.getContractPartnerForm)(state) && (0, _Forms.getContractPartnerForm)(state).values && Object.keys((0, _Forms.getContractPartnerForm)(state).values).length > 0) {
	
	                // if data is valid, push contractPartner data
	                if (!(0, _Forms.getContractPartnerForm)(state).syncErrors) {
	                    formData.contractPartner = (0, _Forms.getContractPartnerForm)(state).values;
	
	                    if (formData.contractPartner.phone) {
	                        formData.contractPartner.phone = (0, _validate.getCorrectPhoneFormat)(formData.contractPartner.phone);
	                    } else {
	                        formData.contractPartner.phone = "+49-0000-00000";
	                    }
	
	                    if (formData.contractPartner.salutation === 'keine Angabe') {
	                        formData.contractPartner.salutation = '';
	                    }
	                }
	            }
	        }
	
	        if (state.properties && state.properties.software && state.properties.software !== "default") {
	            formData.software = state.properties.software;
	        }
	
	        if (!formData.paymentSettings) {
	            formData.paymentSettings = {};
	        }
	
	        formData.paymentSettings.billingType = _General.PAYMENT_TYPE_INVOICE;
	        formData.paymentSettings.postalInvoice = false;
	
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchPutFormData(state.token.bearer, (0, _SimpleSelectors.getCartId)(state), formData));
	        });
	    };
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMainArticleInCart = exports.getMainArticleByItems = exports.getInitialCartFormData = exports.getCartSummary = exports.getBaseArticlePrice = exports.getTotalCartCosts = exports.getPromotionsInCart = exports.isDevProjectInCart = exports.getRemainingInclusiveDomains = exports.getItemInCartByArticleNumber = exports.getCartBillingPeriod = exports.getFirstArticleData = undefined;
	
	var _CartUtil = __webpack_require__(37);
	
	Object.keys(_CartUtil).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _CartUtil[key];
	        }
	    });
	});
	
	var _reselect = __webpack_require__(31);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Software = __webpack_require__(180);
	
	var _util = __webpack_require__(9);
	
	var _Mode = __webpack_require__(18);
	
	var _General = __webpack_require__(10);
	
	var _Config = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getFirstArticleData = exports.getFirstArticleData = (0, _reselect.createSelector)([_SimpleSelectors.getCartItems, _SimpleSelectors.getArticleOptionsData, _SimpleSelectors.getBaseArticle], function (cartItems, articleOptions, baseArticle) {
	
	    var firstArticleNumber = getMainArticleByItems(cartItems);
	
	    if (baseArticle && baseArticle.articleNumber + '' === firstArticleNumber) {
	
	        return baseArticle;
	    } else if (articleOptions && articleOptions[firstArticleNumber]) {
	
	        return articleOptions[firstArticleNumber];
	    } else {
	
	        return null;
	    }
	});
	
	/**
	 * Gets the billing period value that is or is supposed to be set as cart property. Mittwald values are transformed back to the mapped value.
	 */
	var getCartBillingPeriod = exports.getCartBillingPeriod = (0, _reselect.createSelector)([function (state) {
	    return state.cart && state.cart.billingPeriod;
	}, getFirstArticleData], function (cartBillingPeriod, firstArticleData) {
	
	    var billingPeriodMappingReverse = {
	        0: 0,
	        1: 1,
	        3: 2,
	        6: 3,
	        12: 4
	    };
	
	    if (cartBillingPeriod) {
	
	        return cartBillingPeriod;
	    } else {
	
	        if (firstArticleData) {
	
	            if (Number((0, _util.delve)(firstArticleData, "billing.billingPeriod")) >= 0) {
	
	                return billingPeriodMappingReverse[firstArticleData.billing.billingPeriod] >= 0 ? billingPeriodMappingReverse[firstArticleData.billing.billingPeriod] : 12;
	            } else {
	
	                // mapping for 12 months
	                return 4;
	            }
	        } else {
	
	            // mapping for 12 months
	            return 4;
	        }
	    }
	});
	
	// **************************************************************************************************************
	var getItemInCartByArticleNumber = exports.getItemInCartByArticleNumber = function getItemInCartByArticleNumber(state, articleNumber) {
	
	    var cartItems = (0, _SimpleSelectors.getCartItems)(state);
	
	    if (!cartItems) {
	        return false;
	    }
	
	    var itemToRemove = cartItems.find(function (item) {
	        return item.identifier === "" + articleNumber;
	    });
	
	    return itemToRemove ? itemToRemove.id : false;
	};
	
	var getTrimmedBaseArticle = function getTrimmedBaseArticle(baseArticleData) {
	
	    var val = void 0;
	
	    var appMode = (0, _Mode.getAppMode)();
	    // only show setup fee for new orders
	    var hasSetupFee = appMode === _General.APP_MODE_REGULAR || appMode === _General.APP_MODE_AUTHENTICATED_ORDER;
	
	    if (Object.keys(baseArticleData).length > 0) {
	        val = {
	            title: baseArticleData.title,
	            type: baseArticleData.type,
	            description: baseArticleData.description,
	            setupFee: hasSetupFee ? baseArticleData.price.default.setupFee : 0,
	            priceMonthly: baseArticleData.price.default.net,
	            articleNumber: baseArticleData.articleNumber,
	            billingPeriod: (0, _util.delve)(baseArticleData, "billing.billingPeriod"),
	            billingPeriodUnlocked: (0, _util.delve)(baseArticleData, "billing.allowDurationModification")
	        };
	    } else {
	        val = {
	            title: "",
	            description: "",
	            setupFee: 0,
	            priceMonthly: 0,
	            articleNumber: false,
	            billingPeriod: 12,
	            billingPeriodUnlocked: false
	        };
	    }
	
	    if ((0, _util.delve)(baseArticleData, "billing.billingPeriod") === 0) {
	        val.setupFee = val.priceMonthly;
	        val.priceMonthly = 0;
	    }
	
	    return val;
	};
	
	var getRemainingInclusiveDomains = exports.getRemainingInclusiveDomains = (0, _reselect.createSelector)([_SimpleSelectors.getCartItems, _SimpleSelectors.getDomainData, _SimpleSelectors.getBaseArticle], function (cartItems, domainData, baseArticle) {
	
	    var limit = baseArticle && baseArticle.benefits && baseArticle.benefits.domain && baseArticle.benefits.domain.inclusive;
	
	    var domainItems = cartItems.filter(function (cartItem) {
	        return cartItem.itemType === "DOMAIN";
	    });
	
	    domainItems.map(function (domainItem) {
	        var split = domainItem.identifier.split(/\.([a-zA-Z.]+)/);
	        if (domainData[split[1]].isAllowedAsInclusiveDomain !== 0) {
	            limit--;
	        }
	        return null;
	    });
	
	    return limit;
	});
	
	var isDevProjectInCart = exports.isDevProjectInCart = (0, _reselect.createSelector)([_CartUtil.getArticleOptionsInCartList], function (articleOptionsInCartList) {
	    var isDevProjectInCart = false;
	
	    articleOptionsInCartList.forEach(function (articleOptionNumber) {
	        if (articleOptionNumber + "" === "72002") {
	            isDevProjectInCart = true;
	        }
	    });
	
	    return isDevProjectInCart;
	});
	
	var getPromotionsInCart = exports.getPromotionsInCart = (0, _reselect.createSelector)([_SimpleSelectors.getPromotionCodeInformation, _SimpleSelectors.isPromotionCodeValid, _SimpleSelectors.getBaseArticle, _CartUtil.getArticleOptionsInCartObject], function (promotionCodeInformation, isPromotionCodeValid, baseArticle, articleOptions) {
	
	    // base article data
	    var baseArticleTrimmed = getTrimmedBaseArticle(baseArticle);
	
	    // manage promotions
	    var promotions = [];
	
	    // add base article promotion
	    if (isPromotionCodeValid && promotionCodeInformation && promotionCodeInformation.articles) {
	        if (promotionCodeInformation.articles.includes(baseArticle.articleNumber)) {
	            promotions.push({
	                code: promotionCodeInformation.code,
	                articleNumber: baseArticle.articleNumber,
	                title: "Aktion " + promotionCodeInformation.code.toUpperCase() + ": " + baseArticleTrimmed.title,
	                reductionSetupFee: !promotionCodeInformation.periodic ? promotionCodeInformation.absolute ? promotionCodeInformation.discount : baseArticleTrimmed.setupFee * promotionCodeInformation.discount : 0,
	                reductionPriceMonthly: promotionCodeInformation.periodic ? promotionCodeInformation.absolute ? promotionCodeInformation.discount : baseArticleTrimmed.priceMonthly * promotionCodeInformation.discount : 0,
	                freeRuntime: promotionCodeInformation.runtime ? Number(promotionCodeInformation.freeRuntime) : 0
	            });
	        }
	        articleOptions.forEach(function (articleOption) {
	
	            if (promotionCodeInformation.articles.includes(articleOption.articleNumber)) {
	                promotions.push({
	                    code: promotionCodeInformation.code,
	                    articleNumber: articleOption.articleNumber,
	                    title: "Aktion " + promotionCodeInformation.code.toUpperCase() + ": " + articleOption.title,
	                    reductionSetupFee: !promotionCodeInformation.periodic ? promotionCodeInformation.absolute ? promotionCodeInformation.discount : articleOption.setupFee * promotionCodeInformation.discount : 0,
	                    reductionPriceMonthly: promotionCodeInformation.periodic ? promotionCodeInformation.absolute ? promotionCodeInformation.discount : articleOption.priceMonthly * promotionCodeInformation.discount : 0
	                });
	            }
	        });
	    }
	
	    return promotions;
	});
	
	var getTotalCartCosts = exports.getTotalCartCosts = (0, _reselect.createSelector)([_CartUtil.getDomainInCartObject, _SimpleSelectors.getBaseArticle, _SimpleSelectors.getCartPaymentSettings, getPromotionsInCart, _CartUtil.getArticleOptionsInCartObject, _SimpleSelectors.getCartItems], function (domainItems, baseArticleData, paymentSettings, promotionsInCart, articleOptions, cartItems) {
	
	    if (!baseArticleData) {
	        return {
	            setupFee: 0,
	            priceMonthly: 0
	        };
	    }
	
	    var baseArticleTrimmed = getTrimmedBaseArticle(baseArticleData);
	
	    var setupFee = 0;
	    var priceMonthly = 0;
	    var freeRuntime = 0;
	
	    var baseArticleInCart = cartItems ? cartItems.some(function (item) {
	        return item.identifier === "" + baseArticleTrimmed.articleNumber;
	    }) : false;
	
	    if (baseArticleInCart) {
	        // add base article
	        priceMonthly += baseArticleTrimmed.priceMonthly;
	        setupFee += baseArticleTrimmed.setupFee;
	    }
	
	    // add article options
	    var articlePrices = articleOptions.reduce(function (a, b) {
	        return {
	            setupFee: Number(a.setupFee) + Number(b.setupFee),
	            priceMonthly: Number(a.priceMonthly) + Number(b.priceMonthly)
	        };
	    }, { setupFee: 0, priceMonthly: 0 });
	
	    // add domains
	    var domainPrices = domainItems.reduce(function (a, b) {
	        return {
	            setupFee: Number(a.setupFee) + Number(b.setupFee),
	            priceMonthly: Number(a.priceMonthly) + Number(b.priceMonthly)
	        };
	    }, { setupFee: 0, priceMonthly: 0 });
	
	    //postal invoice
	    if (paymentSettings && paymentSettings.postalInvoice) {
	        setupFee += 1;
	    }
	
	    // promotion code data
	    promotionsInCart.forEach(function (promotionData) {
	        setupFee -= promotionData.reductionSetupFee;
	        priceMonthly -= promotionData.reductionPriceMonthly;
	        freeRuntime += Number(promotionData.freeRuntime);
	    });
	
	    return {
	        setupFee: Number(setupFee) + Number(domainPrices.setupFee) + Number(articlePrices.setupFee),
	        priceMonthly: Number(priceMonthly) + Number(domainPrices.priceMonthly + Number(articlePrices.priceMonthly)),
	        domainPricesMonthly: Number(domainPrices.priceMonthly),
	        freeRuntime: freeRuntime
	    };
	});
	
	var getBaseArticlePrice = exports.getBaseArticlePrice = (0, _reselect.createSelector)([_SimpleSelectors.getBaseArticle], function (baseArticle) {
	    return baseArticle && baseArticle.price ? baseArticle.price.default.net : 0;
	});
	
	var getCartSummary = exports.getCartSummary = (0, _reselect.createSelector)([_SimpleSelectors.getBaseArticle, _SimpleSelectors.getCartSoftware, _Software.getSoftwareData, _CartUtil.getArticleOptionsInCartObject, _CartUtil.getDomainInCartObject, _SimpleSelectors.getCartPaymentSettings, getPromotionsInCart, getTotalCartCosts, getCartBillingPeriod, _SimpleSelectors.getCartBackupRange, _SimpleSelectors.getCartItems], function (baseArticle, softwareSelected, softwareData, articleOptions, domains, paymentSettings, promotionsInCart, totalCartCosts, billingPeriod, backupRange, cartItems) {
	
	    // base article data
	    var baseArticleTrimmed = getTrimmedBaseArticle(baseArticle);
	
	    // postal invoice
	    var postalInvoice = paymentSettings && paymentSettings.postalInvoice ? {
	        priceMonthly: 0,
	        setupFee: 1
	    } : false;
	
	    var billingPeriodMapping = {
	        0: 0,
	        1: 1,
	        2: 3,
	        3: 6,
	        4: 12
	    };
	
	    var billingPeriodMonths = billingPeriodMapping[billingPeriod];
	
	    var firstInvoiceSum = billingPeriodMonths * totalCartCosts.priceMonthly + totalCartCosts.setupFee;
	
	    if (billingPeriodMonths < 12) {
	        // normalize domain price to 12 months
	        firstInvoiceSum += totalCartCosts.domainPricesMonthly * (12 - billingPeriodMonths);
	    }
	
	    var freeMonthsEffective = 0;
	
	    if (totalCartCosts.freeRuntime > 0) {
	        freeMonthsEffective = Math.min(totalCartCosts.freeRuntime, billingPeriodMonths);
	    }
	
	    if (baseArticleTrimmed && baseArticleTrimmed.priceMonthly) {
	
	        firstInvoiceSum -= freeMonthsEffective * baseArticleTrimmed.priceMonthly;
	    }
	
	    var baseArticleInCart = cartItems ? cartItems.some(function (item) {
	        return item.identifier === "" + baseArticle.articleNumber;
	    }) : false;
	
	    return {
	        baseArticle: baseArticleTrimmed,
	        software: softwareData && softwareData[softwareSelected] ? softwareData[softwareSelected] : false,
	        articleOptions: articleOptions,
	        domains: domains,
	        cartItems: cartItems,
	        paymentSettings: Object.assign({}, paymentSettings, { postalInvoice: postalInvoice }),
	        promotions: promotionsInCart,
	        total: totalCartCosts,
	        firstInvoiceSum: firstInvoiceSum,
	        billingPeriodMonths: billingPeriodMonths,
	        freeMonthsEffective: freeMonthsEffective,
	        backupRange: backupRange,
	        baseArticleInCart: baseArticleInCart
	    };
	});
	
	var getInitialCartFormData = exports.getInitialCartFormData = (0, _reselect.createSelector)([_SimpleSelectors.getCartContractPartner, _SimpleSelectors.getCartBillingAddress, _SimpleSelectors.getCartContactPerson, _SimpleSelectors.getCartRecommendedAccount, _SimpleSelectors.getCartNote, _SimpleSelectors.getCartPromotionCode, _SimpleSelectors.getCartPaymentSettings], function (contractPartner, billingAddress, contactPerson, recommendedAccount, orderNote, promotionCode, paymentSettings) {
	    return {
	        contractPartner: contractPartner,
	        billingAddress: billingAddress,
	        contactPerson: contactPerson,
	        recommendedAccount: recommendedAccount,
	        note: orderNote,
	        promotionCode: promotionCode,
	        paymentSettings: paymentSettings
	    };
	});
	
	var getMainArticleByItems = exports.getMainArticleByItems = function getMainArticleByItems(cartItems) {
	    if (!cartItems) {
	        return '';
	    }
	    var mainArticles = [_Config.agencyServerArticleNumber].concat(_toConsumableArray(_Config.cmsArticles), _toConsumableArray(_Config.shopArticles), _toConsumableArray(_Config.agencyServerProjectArticles), _toConsumableArray(_Config.dsgvoArticles), _toConsumableArray(_Config.accessoryArticles), ['30000']);
	    var mainArticle = cartItems.find(function (element) {
	        return mainArticles.indexOf(element.identifier) >= 0;
	    });
	    return mainArticle && mainArticle.identifier;
	};
	
	var getMainArticleInCart = exports.getMainArticleInCart = (0, _reselect.createSelector)([_SimpleSelectors.getCartItems], function (cartItems) {
	    return getMainArticleByItems(cartItems);
	});

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDomainInCartObject = exports.getDomainInCartList = exports.getArticleOptionsInCartObject = exports.getArticleOptionsInCartList = undefined;
	
	var _reselect = __webpack_require__(31);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Mode = __webpack_require__(18);
	
	var _util = __webpack_require__(9);
	
	var _General = __webpack_require__(10);
	
	var _Config = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// **************************************************************************************************************
	var getArticleOptionsInCartList = exports.getArticleOptionsInCartList = (0, _reselect.createSelector)([_SimpleSelectors.getCartItems, _SimpleSelectors.getBaseArticle], function (cartItems, baseArticle) {
	    if (!cartItems) {
	        return [];
	    }
	    var articleOptions = cartItems.filter(function (cartItem) {
	        return cartItem.itemType !== "DOMAIN" && cartItem.identifier !== "" + baseArticle.articleNumber;
	    });
	
	    return articleOptions.map(function (articleOption) {
	        return articleOption.identifier;
	    });
	});
	
	var getArticleOptionsInCartObject = exports.getArticleOptionsInCartObject = (0, _reselect.createSelector)([_SimpleSelectors.getCartItems, _SimpleSelectors.getBaseArticle, _SimpleSelectors.getArticleOptionsData], function (cartItems, baseArticle, articleOptionsData) {
	
	    if (!cartItems || !articleOptionsData || !baseArticle) {
	        return [];
	    }
	
	    var articleOptions = cartItems.filter(function (cartItem) {
	        return cartItem.itemType !== "DOMAIN" && cartItem.identifier !== "" + baseArticle.articleNumber;
	    });
	
	    return articleOptions.map(function (articleOption) {
	
	        var articleNumber = articleOption.identifier;
	        var articleOptionData = articleOptionsData[articleNumber];
	        var isSetupFee = true;
	
	        if (!articleOptionData) {
	            return {
	                title: "articleOptionData missing",
	                itemId: articleOption.id,
	                setupFee: 0,
	                priceMonthly: 0,
	                contract: {}
	            };
	        }
	
	        if ((0, _Mode.getAppMode)() === _General.APP_MODE_OUTSOURCING || (0, _Mode.getAppMode)() === _General.APP_MODE_PRODUCT_CHANGE) {
	            // actually no setup fee for EK tariffs
	            if ([].concat(_toConsumableArray(_Config.cmsArticles), _toConsumableArray(_Config.shopArticles)).includes("" + articleNumber)) {
	                isSetupFee = false;
	            }
	        }
	
	        return {
	            title: articleOptionData.title,
	            description: articleOptionData.description,
	            itemId: articleOption.id,
	            articleNumber: articleNumber,
	            type: articleOptionData.type,
	            billing: articleOptionData.billing,
	            contract: articleOptionData.contract,
	            setupFee: isSetupFee && articleOptionData.price && articleOptionData.price.default.setupFee ? articleOptionData.price.default.setupFee : 0,
	            priceMonthly: articleOptionData.price && articleOptionData.price.default.net ? articleOptionData.price.default.net : 0,
	            inclusiveStorage: articleOptionData.projectSpace
	        };
	    });
	});
	
	var getDomainInCartList = exports.getDomainInCartList = (0, _reselect.createSelector)([_SimpleSelectors.getCartItems], function (cartItems) {
	    if (!cartItems) {
	        return [];
	    }
	    var domainItems = cartItems.filter(function (cartItem) {
	        return cartItem.itemType === "DOMAIN";
	    });
	
	    return domainItems.map(function (domainItem) {
	        return domainItem.identifier;
	    });
	});
	
	var getDomainInCartObject = exports.getDomainInCartObject = (0, _reselect.createSelector)([_SimpleSelectors.getCartItems, _SimpleSelectors.getDomainData, _SimpleSelectors.getBaseArticle, _Mode.isAgencyCustomer], function (cartItems, domainData, baseArticle, isAgencyCustomer) {
	
	    if (!cartItems || Object.keys(domainData).length === 0) {
	        return [];
	    }
	
	    var limit = baseArticle && baseArticle.benefits && baseArticle.benefits.domain && baseArticle.benefits.domain.inclusive;
	
	    var domainItems = cartItems.filter(function (cartItem) {
	        return cartItem.itemType === "DOMAIN";
	    });
	
	    return domainItems.map(function (domainItem) {
	
	        var split = domainItem.identifier.split(/\.([a-zA-Z.]+)/);
	        var domainDataEntry = domainData[split[1]];
	
	        var isInclusiveDomain = false;
	
	        if (limit > 0 && domainData[split[1]].isAllowedAsInclusiveDomain !== 0) {
	            limit--;
	            isInclusiveDomain = true;
	        }
	
	        var agencyArticle = isAgencyCustomer ? domainDataEntry.agencyArticle : null;
	        var setupFee = void 0,
	            priceMonthly = void 0;
	
	        if (isInclusiveDomain) {
	            setupFee = 0;
	            priceMonthly = 0;
	        } else if (agencyArticle) {
	            setupFee = (0, _util.delve)(agencyArticle, "price.default.setupFee");
	            priceMonthly = (0, _util.delve)(agencyArticle, "price.default.net");
	        } else {
	            setupFee = domainDataEntry.setupFee;
	            priceMonthly = domainDataEntry.price;
	        }
	
	        return {
	            domainName: split[0],
	            domainEnding: split[1],
	            domain: domainItem.identifier,
	            itemId: domainItem.id,
	            setupFee: setupFee,
	            priceMonthly: priceMonthly,
	            isInclusiveDomain: isInclusiveDomain
	        };
	    });
	});

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPhoneVerification = exports.getActualEmailAddress = exports.getContractPartnerAddressSmall = exports.getActualBillingAddressSmall = exports.getActualBillingAddress = exports.getInitialContractPartner = exports.getInitialContactPerson = exports.getInitialBillingAddress = exports.getInitialSepaData = exports.getFormLabels = exports.isUserAuthenticated = exports.isNewCustomerSelected = exports.getRecommendForm = exports.getProjectSelectionForm = exports.getTestingForm = exports.getLoginForm = exports.getSimpleSummaryForm = exports.getOrderNoteForm = exports.getCommissionForm = exports.getPromotionCodeForm = exports.getPhoneVerificationForm = exports.getBillingAddressForm = exports.getContactPersonForm = exports.getContractPartnerForm = exports.getAlternateSepaForm = exports.getSepaForm = undefined;
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _reselect = __webpack_require__(31);
	
	var _i18nIsoCountries = __webpack_require__(289);
	
	var _i18nIsoCountries2 = _interopRequireDefault(_i18nIsoCountries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// **************************************************************************************************************
	var getSepaForm = exports.getSepaForm = function getSepaForm(state) {
	    return state.form.sepaPayment;
	};
	var getAlternateSepaForm = exports.getAlternateSepaForm = function getAlternateSepaForm(state) {
	    return state.form.alternateSepaPayment;
	};
	var getContractPartnerForm = exports.getContractPartnerForm = function getContractPartnerForm(state) {
	    return state.form.contractPartner;
	};
	var getContactPersonForm = exports.getContactPersonForm = function getContactPersonForm(state) {
	    return state.form.contactPerson;
	};
	var getBillingAddressForm = exports.getBillingAddressForm = function getBillingAddressForm(state) {
	    return state.form.billingAddress;
	};
	var getPhoneVerificationForm = exports.getPhoneVerificationForm = function getPhoneVerificationForm(state) {
	    return state.form.phoneVerification;
	};
	var getPromotionCodeForm = exports.getPromotionCodeForm = function getPromotionCodeForm(state) {
	    return state.form.promotionCodeForm;
	};
	var getCommissionForm = exports.getCommissionForm = function getCommissionForm(state) {
	    return state.form.commissionForm;
	};
	var getOrderNoteForm = exports.getOrderNoteForm = function getOrderNoteForm(state) {
	    return state.form.existingUserNote;
	};
	var getSimpleSummaryForm = exports.getSimpleSummaryForm = function getSimpleSummaryForm(state) {
	    return state.form.summary;
	};
	var getLoginForm = exports.getLoginForm = function getLoginForm(state) {
	    return state.form.loginForm;
	};
	var getTestingForm = exports.getTestingForm = function getTestingForm(state) {
	    return state.form.testing;
	};
	var getProjectSelectionForm = exports.getProjectSelectionForm = function getProjectSelectionForm(state) {
	    return state && state.form.projectSelection;
	};
	var getRecommendForm = exports.getRecommendForm = function getRecommendForm(state) {
	    return state && state.form.recommend;
	};
	
	var isNewCustomerSelected = exports.isNewCustomerSelected = function isNewCustomerSelected(state) {
	    return state.clientDataStep.newCustomerSelected;
	};
	var isUserAuthenticated = exports.isUserAuthenticated = function isUserAuthenticated(state) {
	    return state.clientDataStep.existingUserAuthenticated;
	};
	
	var getFormLabels = exports.getFormLabels = function getFormLabels() {
	    var labelSetId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	    var labels = {};
	
	    switch (labelSetId) {
	
	        case "login":
	            labels.username = "Kundennummer";
	            labels.password = "Passwort";
	            labels.totp = "Zwei-Faktor-Authentifizierungscode";
	            labels.devicecookie = "Verifizierungscode";
	            break;
	
	        default:
	            labels.note = "Notiz";
	            labels.salutation = "Anrede";
	            labels.company = "Firma";
	            labels.vat = "USt-IdNr.";
	            labels.firstName = "Vorname";
	            labels.lastName = "Nachname";
	            labels.emailAddress = "E-Mail-Adresse";
	            labels.phone = "Telefonnummer";
	            labels.street = "Straße";
	            labels.houseNumber = "Hausnummer";
	            labels.zip = "PLZ";
	            labels.city = "Ort";
	            labels.country = "Land";
	            labels.recommendedAccount = "Kundentyp";
	            labels.title = "Titel";
	            labels.commission = 'Betreuer-ID';
	            break;
	
	    }
	
	    return labels;
	};
	
	// **************************************************************************************************************
	var countryData = _i18nIsoCountries2.default.getNames("de");
	
	/*const isSMSValidationSuccess = (state) => {
		return state.smsVerification.codeSuccessfullyVerified
	}*/
	
	var getInitialSepaData = exports.getInitialSepaData = (0, _reselect.createSelector)([_SimpleSelectors.getCartPaymentSettings], function (paymentSettings) {
	    if (!paymentSettings) {
	        return {};
	    }
	    return {
	        accountHolder: paymentSettings.accountHolder,
	        bic: paymentSettings.bic,
	        iban: paymentSettings.iban
	    };
	});
	
	var getInitialBillingAddress = exports.getInitialBillingAddress = (0, _reselect.createSelector)([_SimpleSelectors.getCartBillingAddress], function (billingAddress) {
	    var defaultAddress = {};
	    if (billingAddress && billingAddress.salutation === '') {
	        billingAddress.salutation = 'keine Angabe';
	    }
	    return Object.assign({}, defaultAddress, billingAddress);
	});
	
	var getInitialContactPerson = exports.getInitialContactPerson = (0, _reselect.createSelector)([_SimpleSelectors.getCartContactPerson], function (contactPerson) {
	    var defaultAddress = {};
	    if (contactPerson && contactPerson.salutation === '') {
	        contactPerson.salutation = 'keine Angabe';
	    }
	    return Object.assign({}, defaultAddress, contactPerson);
	});
	
	var getInitialContractPartner = exports.getInitialContractPartner = (0, _reselect.createSelector)([_SimpleSelectors.getCartContractPartner, _SimpleSelectors.getCartRecommendedAccount, _SimpleSelectors.getCartNote], function (contractPartner, recommendedAccount, orderNote) {
	    var extendedFormData = {};
	    if (orderNote) {
	        extendedFormData["note"] = orderNote;
	    }
	    if (recommendedAccount) {
	        extendedFormData["recommendedAccount"] = recommendedAccount;
	    }
	    if (contractPartner && contractPartner.salutation === '') {
	        contractPartner.salutation = 'keine Angabe';
	    }
	    return Object.assign({}, extendedFormData, contractPartner);
	});
	
	//todo: return existing customer data if available and selected
	// returns actual billing address
	var getActualBillingAddress = exports.getActualBillingAddress = (0, _reselect.createSelector)([_SimpleSelectors.getCartContractPartner, _SimpleSelectors.getCartBillingAddress], function (contractPartner, billingAddress) {
	    if (billingAddress) {
	        return billingAddress;
	    } else {
	        return contractPartner;
	    }
	});
	
	// returns blling address data
	var getActualBillingAddressSmall = exports.getActualBillingAddressSmall = (0, _reselect.createSelector)([getActualBillingAddress], function (actualAddress) {
	    if (!actualAddress) {
	        return [];
	    }
	    var smallAddressData = [actualAddress.company ? actualAddress.company : actualAddress.firstName + " " + actualAddress.lastName, actualAddress.street + " " + actualAddress.houseNumber, actualAddress.zip + " " + actualAddress.city, countryData[actualAddress.country]];
	    return smallAddressData;
	});
	
	//todo: return existing customer data if available and selected
	// returns blling address data
	var getContractPartnerAddressSmall = exports.getContractPartnerAddressSmall = (0, _reselect.createSelector)([_SimpleSelectors.getCartContractPartner], function (contractPartner) {
	    if (!contractPartner) {
	        return [];
	    }
	    var smallAddressData = [contractPartner.street + " " + contractPartner.houseNumber, contractPartner.zip + " " + contractPartner.city, countryData[contractPartner.country]];
	    return smallAddressData;
	});
	
	// returns billing email address
	var getActualEmailAddress = exports.getActualEmailAddress = (0, _reselect.createSelector)([getActualBillingAddress], function (actualAddress) {
	    if (!actualAddress) {
	        return "";
	    }
	    return actualAddress.emailAddress;
	});
	
	var getPhoneVerification = exports.getPhoneVerification = (0, _reselect.createSelector)([_SimpleSelectors.getCartVerification], function (verification) {
	
	    if (!verification) {
	        return false;
	    }
	
	    return verification;
	});

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(13);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 41 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONFIG = exports.CONFIG = "konfiguration";
	var DOMAIN = exports.DOMAIN = "domain";
	var CLIENTDATA = exports.CLIENTDATA = "kundendaten";
	var PAYMENT = exports.PAYMENT = "zahlungsart";
	var SUMMARY = exports.SUMMARY = "bestellübersicht";
	var STANDALONE = exports.STANDALONE = "iframe";
	
	var OUTSOURCING_TARGET = exports.OUTSOURCING_TARGET = "ausgliederung-ziel";
	var OUTSOURCING_RECOMMEND = exports.OUTSOURCING_RECOMMEND = "ausgliederung-empfehlung";
	
	var PRODUCT_SELECTION = exports.PRODUCT_SELECTION = "produkt-auswahl";
	var PRODUCT_CHANGE = exports.PRODUCT_CHANGE = "produkt-wechsel";
	//export const ACCESSORY_ADD = "addon-bestellen"

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MITTWALD_API = exports.callApi = exports.Schemas = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _normalizr = __webpack_require__(555);
	
	var _humps = __webpack_require__(430);
	
	var _Errors = __webpack_require__(134);
	
	var Errors = _interopRequireWildcard(_Errors);
	
	var _GetParam = __webpack_require__(17);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var isSandboxMode = (0, _GetParam.getSandboxModeFlag)();
	var API_ROOT_DEFAULT = isSandboxMode ? 'https://api-sandbox.mittwald.de/v1/' : 'https://api.mittwald.de/v1/';
	
	var reseller = new _normalizr.schema.Entity('reseller', {}, {
	    idAttribute: function idAttribute(value, parent, key) {
	        return value.uid;
	    }
	});
	
	var account = new _normalizr.schema.Entity('account', {}, {
	    idAttribute: function idAttribute(value, parent, key) {
	        return value.uid;
	    }
	});
	
	var contract = new _normalizr.schema.Entity('contract', {}, {
	    idAttribute: function idAttribute(value, parent, key) {
	        return value.uid;
	    }
	});
	
	var articleOption = new _normalizr.schema.Entity('articleOption', {}, {
	    idAttribute: function idAttribute(value, parent, key) {
	        return value.default ? 'default_' + key : value.article ? "" + value.article.articleNumber : "virtual";
	    }
	});
	
	var articleOptionCollection = new _normalizr.schema.Entity('articleOptionCollection', {
	    hardware: {
	        "hddSw": [articleOption]
	    },
	    paidSoftware: {
	        "elasticsearch": [articleOption],
	        "varnish": [articleOption],
	        "node": [articleOption]
	    }
	}, {
	    idAttribute: function idAttribute(value, parent, key) {
	        return "" + parent.articleNumber;
	    }
	});
	
	var baseArticleSchema = new _normalizr.schema.Entity('article', {
	    articleOptions: articleOptionCollection
	}, { idAttribute: function idAttribute(articleNumber) {
	        return 'baseArticle';
	    } });
	
	var articleOptionDataSchema = new _normalizr.schema.Entity('articleOption', {
	    articleOptions: articleOptionCollection
	}, {
	    idAttribute: function idAttribute(value, parent, key) {
	        return "" + value.articleNumber;
	    }
	});
	
	var articleOptionsDataSchema = [articleOptionDataSchema];
	
	var bearerTokenSchema = new _normalizr.schema.Entity('tokens', {}, { idAttribute: function idAttribute(token) {
	        return "token";
	    } });
	var topLevelDomainSchema = new _normalizr.schema.Entity('topLevelDomains', {}, { idAttribute: 'name' });
	var topLevelDomainsSchema = new _normalizr.schema.Array(topLevelDomainSchema);
	var domainCheckSchema = new _normalizr.schema.Entity('domainAvailabiltiy');
	var cartSchema = new _normalizr.schema.Object('cart');
	
	var customerCategorySchema = new _normalizr.schema.Entity('customerCategory', {}, { idAttribute: 'uid' });
	var customerCategoriesSchema = new _normalizr.schema.Array(customerCategorySchema);
	
	var softwareItemSchema = new _normalizr.schema.Entity('software', {}, { idAttribute: 'identifier' });
	var softwareDataSchema = new _normalizr.schema.Array(softwareItemSchema);
	
	var databaseItemSchema = new _normalizr.schema.Entity('database', {}, { idAttribute: 'uid' });
	var databaseDataSchema = new _normalizr.schema.Array(databaseItemSchema);
	
	var operatingSystemItemSchema = new _normalizr.schema.Entity('operatingSystem', {}, { idAttribute: 'identifier' });
	var operatingSystemsDataSchema = new _normalizr.schema.Array(operatingSystemItemSchema);
	
	var promotionCodeSchema = new _normalizr.schema.Object('promotionCode');
	var bankAccountSchema = new _normalizr.schema.Object('bankAccountSchema');
	
	var jsonSchema = new _normalizr.schema.Object('json');
	
	var accountSchema = [account];
	var contractSchema = [contract];
	var resellerSchema = [reseller];
	
	var Schemas = exports.Schemas = {
	    BASE_ARTICLE: baseArticleSchema,
	    ARTICLE_OPTION_DATA: articleOptionsDataSchema,
	    ARTICLE_OPTION_DATA_SINGLE: articleOptionDataSchema,
	    BEARER_TOKEN: bearerTokenSchema,
	    TOPLEVELDOMAINS: topLevelDomainsSchema,
	    DOMAINCHECK: domainCheckSchema,
	    CARTSCHEMA: cartSchema,
	    CUSTOMERCATEGORIES: customerCategoriesSchema,
	    SOFTWARE: softwareDataSchema,
	    DATABASE: databaseDataSchema,
	    OPERATINGSYSTEMS: operatingSystemsDataSchema,
	    PROMOTIONCODE: promotionCodeSchema,
	    BANKACCOUNT: bankAccountSchema,
	    PROMOTIONCODESTATUS: 'PROMOTIONCODE',
	    STATUSTEXT: 'TEXT',
	    STATUSCODE: 'STATUSCODE',
	    CARTSHARESCHEMA: cartSchema,
	    JSON: jsonSchema,
	    RECOMMEND: jsonSchema,
	    CLIENT_DATA: jsonSchema,
	    ACCOUNTS: accountSchema,
	    ACCOUNT: account,
	    CONTRACTS: contractSchema,
	    RESELLERS: resellerSchema
	};
	
	var callApi = exports.callApi = function callApi(endpoint, schema, method, bearer, postData) {
	    var customHeaders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	
	    var fullUrl = endpoint.indexOf(API_ROOT_DEFAULT) === -1 && endpoint.indexOf('http') === -1 ? API_ROOT_DEFAULT + endpoint : endpoint;
	
	    var requestHeaders = new Headers();
	    requestHeaders.append('content-type', 'application/json');
	
	    if (bearer) {
	        requestHeaders.append('Authorization', 'Bearer ' + bearer);
	    }
	
	    if (customHeaders) {
	        Object.keys(customHeaders).forEach(function (key) {
	            requestHeaders.append(customHeaders[key].key, customHeaders[key].value);
	        });
	    }
	
	    var fetchOtions = { method: method, headers: requestHeaders };
	
	    if ((method === "POST" || method === "PUT") && postData) {
	        fetchOtions.body = JSON.stringify(postData);
	    }
	
	    if (schema === Schemas.STATUSTEXT) {
	
	        return fetch(fullUrl, fetchOtions).then(function (response) {
	            return response.statusText;
	        });
	    } else if (schema === Schemas.STATUSCODE) {
	
	        return fetch(fullUrl, fetchOtions).then(function (response) {
	            if (!response.ok) {
	                return Promise.reject({ status: response.status });
	            }
	            return response.status;
	        });
	    } else if (schema === Schemas.PROMOTIONCODESTATUS) {
	
	        return fetch(fullUrl, fetchOtions).then(function (response) {
	            if (!response.ok) {
	                // code is not existing, return 400 status
	                if (response.status === 404) {
	                    return Promise.reject({ status: response.status, msg: Errors.PROMOTION_CODE_INVALID });
	                } else if (response.status === 400) {
	                    return Promise.reject({ status: response.status, msg: Errors.PROMOTION_CODE_FALSE_ARTICLES });
	                }
	            }
	            return response.json().catch(function (error) {
	                // error will be thrown when json() fails, it fails when code is valid
	                return Promise.resolve({ status: 200 });
	            }).then(function (json, error) {
	                if (json && json.msg) {
	                    return Promise.reject({ status: 404, msg: json && json.msg ? json.msg : Errors.PROMOTION_CODE_INVALID });
	                } else if (json.status === 200) {
	                    return Promise.resolve({ status: 200 });
	                }
	            });
	        });
	    } else if (schema === Schemas.BEARER_TOKEN) {
	
	        return fetch(fullUrl, fetchOtions).then(function (response) {
	            return response.json().then(function (json) {
	
	                if (response.status === 202) {
	                    if (json.name === 'TOTP') {
	                        return Promise.reject({ status: response.status, msg: Errors.TOTP_REQUIRED });
	                    } else if (json.name === 'DeviceCookie') {
	                        (0, _util.setCookie)('device_id', json.deviceId, 365);
	                        return Promise.reject({ status: response.status, msg: Errors.DEVICECOOKIE_REQUIRED });
	                    }
	                } else if (!response.ok) {
	                    return Promise.reject({ status: response.status, msg: Errors.INVALID_CREDENTIALS });
	                }
	
	                var camelizedJson = (0, _humps.camelizeKeys)(json);
	
	                if (camelizedJson.data) {
	                    camelizedJson = camelizedJson.data;
	                }
	                return Object.assign({ status: response.status }, (0, _normalizr.normalize)(camelizedJson, schema));
	            });
	        });
	    } else {
	
	        return fetch(fullUrl, fetchOtions).then(function (response) {
	            return response.json().then(function (json) {
	                if (!response.ok) {
	                    return Promise.reject(json);
	                }
	
	                var camelizedJson = (0, _humps.camelizeKeys)(json);
	
	                if (camelizedJson.data) {
	                    camelizedJson = camelizedJson.data;
	                }
	                return Object.assign({ status: response.status }, (0, _normalizr.normalize)(camelizedJson, schema));
	            });
	        });
	    }
	};
	
	var MITTWALD_API = exports.MITTWALD_API = 'MITTWALD_API';
	
	exports.default = function (store) {
	    return function (next) {
	        return function (action) {
	            var callAPI = action[MITTWALD_API];
	            if (typeof callAPI === 'undefined') {
	                return next(action);
	            }
	
	            var endpoint = callAPI.endpoint;
	            var schema = callAPI.schema,
	                types = callAPI.types,
	                method = callAPI.method,
	                bearer = callAPI.bearer,
	                postData = callAPI.postData,
	                payload = callAPI.payload,
	                customHeaders = callAPI.customHeaders;
	
	
	            if (typeof endpoint === 'function') {
	                endpoint = endpoint(store.getState());
	            }
	
	            if (typeof endpoint !== 'string') {
	                throw new Error('API Path needs to be specified.');
	            }
	            if (!schema) {
	                throw new Error('Result schema needs to be specified.');
	            }
	
	            if (!Array.isArray(types) || types.length !== 3) {
	                throw new Error('Expected an array of three action types.');
	            }
	
	            if (!types.every(function (type) {
	                return typeof type === 'string';
	            })) {
	                throw new Error('Expected action types to be strings.');
	            }
	
	            var actionWith = function actionWith(data) {
	                var finalAction = Object.assign({}, action, data);
	                delete finalAction[MITTWALD_API];
	                return finalAction;
	            };
	
	            var _types = _slicedToArray(types, 3),
	                requestType = _types[0],
	                successType = _types[1],
	                failureType = _types[2];
	
	            next(actionWith({ type: requestType, payload: payload }));
	
	            return callApi(endpoint, schema, method, bearer, postData, customHeaders).then(function (response) {
	                return next(actionWith({
	                    response: response,
	                    payload: payload,
	                    type: successType
	                }));
	            }, function (error) {
	                return next(actionWith({
	                    payload: payload,
	                    status: error.status,
	                    type: failureType,
	                    error: error.msg || 'error'
	                }));
	            });
	        };
	    };
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(4);
	var core = __webpack_require__(32);
	var fails = __webpack_require__(13);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(240);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleCartCommission = exports.querySelectCartProperty = exports.selectCartProperty = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _FormData = __webpack_require__(35);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var selectCartProperty = exports.selectCartProperty = function selectCartProperty(key, value) {
	    return {
	        type: ActionTypes.SELECT_CART_PROPERTY,
	        selected: value,
	        key: key
	    };
	};
	
	var dispatchFormDataTimeout = false;
	
	var querySelectCartProperty = exports.querySelectCartProperty = function querySelectCartProperty(key, value) {
	    return function (dispatch, getState) {
	
	        var immediateUpdateProperties = ['billingPeriod'];
	
	        dispatch(selectCartProperty(key, value));
	        return new Promise(function (resolve) {
	            if (dispatchFormDataTimeout) {
	                clearTimeout(dispatchFormDataTimeout);
	            }
	            dispatchFormDataTimeout = setTimeout(function () {
	                dispatchFormDataTimeout = false;
	                resolve();
	            }, immediateUpdateProperties.includes(key) ? 0 : 1000);
	        }).then(function () {
	            return dispatch((0, _FormData.putFormData)());
	        });
	    };
	};
	
	var toggleCartCommission = exports.toggleCartCommission = function toggleCartCommission() {
	    return function (dispatch, getState) {
	
	        var cart = (0, _SimpleSelectors.getCart)(getState());
	        var initialCommission = (0, _util.delve)(getState(), "outsourcing.initialCommission");
	
	        if (cart.commission) {
	            dispatch(selectCartProperty("commission", ""));
	            return dispatch((0, _FormData.putFormData)());
	        } else if (initialCommission) {
	            dispatch(selectCartProperty("commission", initialCommission));
	            return dispatch((0, _FormData.putFormData)());
	        }
	    };
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.withReduxForm = exports.renderChildren = exports.ReduxFormContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReduxFormContext = React.createContext(null);
	exports.ReduxFormContext = ReduxFormContext;
	
	var renderChildren = function renderChildren(Component, _ref) {
	  var forwardedRef = _ref.forwardedRef,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["forwardedRef"]);
	  return function (_reduxForm) {
	    return React.createElement(Component, (0, _extends2["default"])({}, rest, {
	      _reduxForm: _reduxForm,
	      ref: forwardedRef
	    }));
	  };
	};
	
	exports.renderChildren = renderChildren;
	
	var withReduxForm = function withReduxForm(Component) {
	  var Hoc = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(Hoc, _React$Component);
	
	    function Hoc() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = Hoc.prototype;
	
	    _proto.render = function render() {
	      return React.createElement(ReduxFormContext.Consumer, {
	        children: renderChildren(Component, this.props)
	      });
	    };
	
	    return Hoc;
	  }(React.Component);
	
	  var ref = React.forwardRef(function (props, ref) {
	    return React.createElement(Hoc, (0, _extends2["default"])({}, props, {
	      forwardedRef: ref
	    }));
	  });
	  ref.displayName = Component.displayName || Component.name || 'Component';
	  return ref;
	};
	
	exports.withReduxForm = withReduxForm;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(568);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isBaseArticleDataLoaded = exports.getActivatedArticle = exports.getSelectedArticle = exports.getCurrentProduct = exports.getSelectedAccount = undefined;
	
	var _util = __webpack_require__(9);
	
	var getSelectedAccount = exports.getSelectedAccount = function getSelectedAccount(state) {
	  return (0, _util.delve)(state, "productSelection.selectedAccount");
	};
	var getCurrentProduct = exports.getCurrentProduct = function getCurrentProduct(state) {
	  return (0, _util.delve)(state, "productSelection.currentProduct");
	};
	var getSelectedArticle = exports.getSelectedArticle = function getSelectedArticle(state) {
	  return (0, _util.delve)(state, "productSelection.selectedArticle");
	};
	var getActivatedArticle = exports.getActivatedArticle = function getActivatedArticle(state) {
	  return (0, _util.delve)(state, "productSelection.activatedArticle");
	};
	var isBaseArticleDataLoaded = exports.isBaseArticleDataLoaded = function isBaseArticleDataLoaded(state) {
	  return (0, _util.delve)(state, "productSelection.baseArticleDataLoaded");
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(16)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(57)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 51 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 52 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.activateBaseArticle = exports.deselectBaseArticle = exports.selectBaseArticle = exports.selectCurrentProduct = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _Cart = __webpack_require__(28);
	
	var _ArticleData = __webpack_require__(64);
	
	var _ProductSelection = __webpack_require__(48);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var selectCurrentProduct = exports.selectCurrentProduct = function selectCurrentProduct(articleNumber) {
	    var selectedAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return function (dispatch, getState) {
	
	        return dispatch({
	            type: ActionTypes.PRODUCT_SET_CURRENT,
	            articleNumber: articleNumber,
	            selectedAccount: selectedAccount
	        });
	    };
	};
	
	var selectBaseArticle = exports.selectBaseArticle = function selectBaseArticle(articleNumber) {
	    return function (dispatch, getState) {
	        return dispatch({
	            type: ActionTypes.BASE_ARTICLE_SELECT,
	            articleNumber: articleNumber
	        });
	    };
	};
	
	var deselectBaseArticle = exports.deselectBaseArticle = function deselectBaseArticle() {
	    return function (dispatch, getState) {
	
	        return dispatch((0, _Cart.queryNewCart)()).then(function (args) {
	            return dispatch({
	                type: ActionTypes.BASE_ARTICLE_DESELECT
	            });
	        });
	    };
	};
	
	var activateBaseArticle = exports.activateBaseArticle = function activateBaseArticle() {
	    var articleNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var addToCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return function (dispatch, getState) {
	
	        if (!articleNumber) {
	            dispatch({
	                type: ActionTypes.BASE_ARTICLE_CUSTOM_SELECTED
	            });
	            return;
	        }
	
	        if (articleNumber) {
	            dispatch(selectBaseArticle(articleNumber));
	        }
	
	        var state = getState();
	
	        var selectedBaseArticle = (0, _ProductSelection.getSelectedArticle)(state);
	        var activatedBaseArticle = (0, _ProductSelection.getActivatedArticle)(state);
	
	        var activationPromises = [];
	
	        if (selectedBaseArticle !== activatedBaseArticle) {
	            if (!state.articleData.baseArticle || (0, _SimpleSelectors.getBaseArticle)(state).articleNumber + '' !== selectedBaseArticle) {
	                activationPromises.push((0, _ArticleData.queryBaseArticle)(selectedBaseArticle));
	            }
	        }
	
	        return Promise.all(activationPromises.map(function (func) {
	            return dispatch(func);
	        })).then(function (args) {
	
	            if (addToCart) {
	                return dispatch((0, _Cart.addItemToCart)(selectedBaseArticle)).then(function (args) {
	                    return true;
	                });
	            } else {
	                return true;
	            }
	        });
	    };
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(83);
	var IObject = __webpack_require__(84);
	var toObject = __webpack_require__(15);
	var toLength = __webpack_require__(20);
	var asc = __webpack_require__(138);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 56 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(33);
	var createDesc = __webpack_require__(87);
	module.exports = __webpack_require__(19) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.19.1
	 * DATE: 2017-01-17
	 * UPDATES AND DOCS AT: http://greensock.com
	 * 
	 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
	 *
	 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				TweenMax = function(target, duration, vars) {
					TweenLite.call(this, target, duration, vars);
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._dirty = true; //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
					this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
				_blankArray = [];
	
			TweenMax.version = "1.19.1";
			p.constructor = TweenMax;
			p.kill()._gc = false;
			TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
			TweenMax.getTweensOf = TweenLite.getTweensOf;
			TweenMax.lagSmoothing = TweenLite.lagSmoothing;
			TweenMax.ticker = TweenLite.ticker;
			TweenMax.render = TweenLite.render;
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TweenLite.prototype.invalidate.call(this);
			};
			
			p.updateTo = function(vars, resetDuration) {
				var curRatio = this.ratio,
					immediate = this.vars.immediateRender || vars.immediateRender,
					p;
				if (resetDuration && this._startTime < this._timeline._time) {
					this._startTime = this._timeline._time;
					this._uncache(false);
					if (this._gc) {
						this._enabled(true, false);
					} else {
						this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				for (p in vars) {
					this.vars[p] = vars[p];
				}
				if (this._initted || immediate) {
					if (resetDuration) {
						this._initted = false;
						if (immediate) {
							this.render(0, true, true);
						}
					} else {
						if (this._gc) {
							this._enabled(true, false);
						}
						if (this._notifyPluginsOfEnabled && this._firstPT) {
							TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
						}
						if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
							var prevTime = this._totalTime;
							this.render(0, true, false);
							this._initted = false;
							this.render(prevTime, true, false);
						} else {
							this._initted = false;
							this._init();
							if (this._time > 0 || immediate) {
								var inv = 1 / (1 - curRatio),
									pt = this._firstPT, endValue;
								while (pt) {
									endValue = pt.s + pt.c;
									pt.c *= inv;
									pt.s = endValue - pt.c;
									pt = pt._next;
								}
							}
						}
					}
				}
				return this;
			};
					
			p.render = function(time, suppressEvents, force) {
				if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
					this.invalidate();
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevTotalTime = this._totalTime, 
					prevCycle = this._cycle,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime;
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = totalDur;
					this._cycle = this._repeat;
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = 0;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					} else {
						this._time = duration;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					}
					if (!this._reversed) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
					
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = this._cycle = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
					if (this._repeat !== 0) {
						cycleDuration = duration + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = duration - this._time;
						}
						if (this._time > duration) {
							this._time = duration;
						} else if (this._time < 0) {
							this._time = 0;
						}
					}
	
					if (this._easeType) {
						r = this._time / duration;
						type = this._easeType;
						pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (this._time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(this._time / duration);
					}
					
				}
					
				if (prevTime === this._time && !force && prevCycle === this._cycle) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
						this._time = prevTime;
						this._totalTime = prevTotalTime;
						this._rawPrevTime = prevRawPrevTime;
						this._cycle = prevCycle;
						TweenLiteInternals.lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) {
					this._lazy = false;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTotalTime === 0) {
					if (this._initted === 2 && time > 0) {
						//this.invalidate();
						this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
					}
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
				
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
						this._callback("onUpdate");
					}
				}
				if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
					this._callback("onRepeat");
				}
				if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
			
	//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
			
			TweenMax.to = function(target, duration, vars) {
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenMax(target, duration, toVars);
			};
			
			TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				stagger = stagger || 0;
				var delay = 0,
					a = [],
					finalComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					},
					cycle = vars.cycle,
					fromCycle = (vars.startAt && vars.startAt.cycle),
					l, copy, i, p;
				if (!_isArray(targets)) {
					if (typeof(targets) === "string") {
						targets = TweenLite.selector(targets) || targets;
					}
					if (_isSelector(targets)) {
						targets = _slice(targets);
					}
				}
				targets = targets || [];
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				l = targets.length - 1;
				for (i = 0; i <= l; i++) {
					copy = {};
					for (p in vars) {
						copy[p] = vars[p];
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					if (fromCycle) {
						fromCycle = copy.startAt = {};
						for (p in vars.startAt) {
							fromCycle[p] = vars.startAt[p];
						}
						_applyCycle(copy.startAt, targets, i);
					}
					copy.delay = delay + (copy.delay || 0);
					if (i === l && onCompleteAll) {
						copy.onComplete = finalComplete;
					}
					a[i] = new TweenMax(targets[i], duration, copy);
					delay += stagger;
				}
				return a;
			};
			
			TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
			
			TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
					
			TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
			};
			
			TweenMax.set = function(target, vars) {
				return new TweenMax(target, 0, vars);
			};
			
			TweenMax.isTweening = function(target) {
				return (TweenLite.getTweensOf(target, true).length > 0);
			};
			
			var _getChildrenOf = function(timeline, includeTimelines) {
					var a = [],
						cnt = 0,
						tween = timeline._first;
					while (tween) {
						if (tween instanceof TweenLite) {
							a[cnt++] = tween;
						} else {
							if (includeTimelines) {
								a[cnt++] = tween;
							}
							a = a.concat(_getChildrenOf(tween, includeTimelines));
							cnt = a.length;
						}
						tween = tween._next;
					}
					return a;
				}, 
				getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
					return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
				};
			
			TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
				if (tweens == null) {
					tweens = true;
				}
				if (delayedCalls == null) {
					delayedCalls = true;
				}
				var a = getAllTweens((timelines != false)),
					l = a.length,
					allTrue = (tweens && delayedCalls && timelines),
					isDC, tween, i;
				for (i = 0; i < l; i++) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						if (complete) {
							tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
						} else {
							tween._enabled(false, false);
						}
					}
				}
			};
			
			TweenMax.killChildTweensOf = function(parent, complete) {
				if (parent == null) {
					return;
				}
				var tl = TweenLiteInternals.tweenLookup,
					a, curParent, p, i, l;
				if (typeof(parent) === "string") {
					parent = TweenLite.selector(parent) || parent;
				}
				if (_isSelector(parent)) {
					parent = _slice(parent);
				}
				if (_isArray(parent)) {
					i = parent.length;
					while (--i > -1) {
						TweenMax.killChildTweensOf(parent[i], complete);
					}
					return;
				}
				a = [];
				for (p in tl) {
					curParent = tl[p].target.parentNode;
					while (curParent) {
						if (curParent === parent) {
							a = a.concat(tl[p].tweens);
						}
						curParent = curParent.parentNode;
					}
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					if (complete) {
						a[i].totalTime(a[i].totalDuration());
					}
					a[i]._enabled(false, false);
				}
			};
	
			var _changePause = function(pause, tweens, delayedCalls, timelines) {
				tweens = (tweens !== false);
				delayedCalls = (delayedCalls !== false);
				timelines = (timelines !== false);
				var a = getAllTweens(timelines),
					allTrue = (tweens && delayedCalls && timelines),
					i = a.length,
					isDC, tween;
				while (--i > -1) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						tween.paused(pause);
					}
				}
			};
			
			TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
				_changePause(true, tweens, delayedCalls, timelines);
			};
			
			TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
				_changePause(false, tweens, delayedCalls, timelines);
			};
	
			TweenMax.globalTimeScale = function(value) {
				var tl = Animation._rootTimeline,
					t = TweenLite.ticker.time;
				if (!arguments.length) {
					return tl._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl = Animation._rootFramesTimeline;
				t = TweenLite.ticker.frame;
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl._timeScale = Animation._rootTimeline._timeScale = value;
				return value;
			};
			
		
	//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
			
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
			
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
			
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
				}
				return Animation.prototype.duration.call(this, value);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						//instead of Infinity, we use 999999999999 so that we can accommodate reverses
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
			};
			
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
			
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
			
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
			
			
			return TweenMax;
			
		}, true);
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TimelineLite
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var TimelineLite = function(vars) {
					SimpleTimeline.call(this, vars);
					this._labels = {};
					this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
					this.smoothChildTiming = (this.vars.smoothChildTiming === true);
					this._sortChildren = true;
					this._onUpdate = this.vars.onUpdate;
					var v = this.vars,
						val, p;
					for (p in v) {
						val = v[p];
						if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
							v[p] = this._swapSelfInParams(val);
						}
					}
					if (_isArray(v.tweens)) {
						this.add(v.tweens, 0, v.align, v.stagger);
					}
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_internals = TimelineLite._internals = {},
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_copy = function(vars) {
					var copy = {}, p;
					for (p in vars) {
						copy[p] = vars[p];
					}
					return copy;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				_pauseCallback = _internals.pauseCallback = function() {},
				_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				p = TimelineLite.prototype = new SimpleTimeline();
	
			TimelineLite.version = "1.19.1";
			p.constructor = TimelineLite;
			p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
	
			/* might use later...
			//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
			function localToGlobal(time, animation) {
				while (animation) {
					time = (time / animation._timeScale) + animation._startTime;
					animation = animation.timeline;
				}
				return time;
			}
	
			//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
			function globalToLocal(time, animation) {
				var scale = 1;
				time -= localToGlobal(0, animation);
				while (animation) {
					scale *= animation._timeScale;
					animation = animation.timeline;
				}
				return time * scale;
			}
			*/
	
			p.to = function(target, duration, vars, position) {
				var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
			};
	
			p.from = function(target, duration, vars, position) {
				return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
			};
	
			p.fromTo = function(target, duration, fromVars, toVars, position) {
				var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
			};
	
			p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
					cycle = vars.cycle,
					copy, i;
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				targets = targets || [];
				if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
					targets = _slice(targets);
				}
				stagger = stagger || 0;
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				for (i = 0; i < targets.length; i++) {
					copy = _copy(vars);
					if (copy.startAt) {
						copy.startAt = _copy(copy.startAt);
						if (copy.startAt.cycle) {
							_applyCycle(copy.startAt, targets, i);
						}
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					tl.to(targets[i], duration, copy, i * stagger);
				}
				return this.add(tl, position);
			};
	
			p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.immediateRender = (vars.immediateRender != false);
				vars.runBackwards = true;
				return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.call = function(callback, params, scope, position) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.set = function(target, vars, position) {
				position = this._parseTimeOrLabel(position, 0, true);
				if (vars.immediateRender == null) {
					vars.immediateRender = (position === this._time && !this._paused);
				}
				return this.add( new TweenLite(target, 0, vars), position);
			};
	
			TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
				vars = vars || {};
				if (vars.smoothChildTiming == null) {
					vars.smoothChildTiming = true;
				}
				var tl = new TimelineLite(vars),
					root = tl._timeline,
					tween, next;
				if (ignoreDelayedCalls == null) {
					ignoreDelayedCalls = true;
				}
				root._remove(tl, true);
				tl._startTime = 0;
				tl._rawPrevTime = tl._time = tl._totalTime = root._time;
				tween = root._first;
				while (tween) {
					next = tween._next;
					if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
						tl.add(tween, tween._startTime - tween._delay);
					}
					tween = next;
				}
				root.add(tl, 0);
				return tl;
			};
	
			p.add = function(value, position, align, stagger) {
				var curTime, l, i, child, tl, beforeRawTime;
				if (typeof(position) !== "number") {
					position = this._parseTimeOrLabel(position, 0, true, value);
				}
				if (!(value instanceof Animation)) {
					if ((value instanceof Array) || (value && value.push && _isArray(value))) {
						align = align || "normal";
						stagger = stagger || 0;
						curTime = position;
						l = value.length;
						for (i = 0; i < l; i++) {
							if (_isArray(child = value[i])) {
								child = new TimelineLite({tweens:child});
							}
							this.add(child, curTime);
							if (typeof(child) !== "string" && typeof(child) !== "function") {
								if (align === "sequence") {
									curTime = child._startTime + (child.totalDuration() / child._timeScale);
								} else if (align === "start") {
									child._startTime -= child.delay();
								}
							}
							curTime += stagger;
						}
						return this._uncache(true);
					} else if (typeof(value) === "string") {
						return this.addLabel(value, position);
					} else if (typeof(value) === "function") {
						value = TweenLite.delayedCall(0, value);
					} else {
						throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
					}
				}
	
				SimpleTimeline.prototype.add.call(this, value, position);
	
				//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
				if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
					//in case any of the ancestors had completed but should now be enabled...
					tl = this;
					beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
					while (tl._timeline) {
						if (beforeRawTime && tl._timeline.smoothChildTiming) {
							tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
						} else if (tl._gc) {
							tl._enabled(true, false);
						}
						tl = tl._timeline;
					}
				}
	
				return this;
			};
	
			p.remove = function(value) {
				if (value instanceof Animation) {
					this._remove(value, false);
					var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
					value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
					return this;
				} else if (value instanceof Array || (value && value.push && _isArray(value))) {
					var i = value.length;
					while (--i > -1) {
						this.remove(value[i]);
					}
					return this;
				} else if (typeof(value) === "string") {
					return this.removeLabel(value);
				}
				return this.kill(null, value);
			};
	
			p._remove = function(tween, skipDisable) {
				SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
				var last = this._last;
				if (!last) {
					this._time = this._totalTime = this._duration = this._totalDuration = 0;
				} else if (this._time > this.duration()) {
					this._time = this._duration;
					this._totalTime = this._totalDuration;
				}
				return this;
			};
	
			p.append = function(value, offsetOrLabel) {
				return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
			};
	
			p.insert = p.insertMultiple = function(value, position, align, stagger) {
				return this.add(value, position || 0, align, stagger);
			};
	
			p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
				return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
			};
	
			p.addLabel = function(label, position) {
				this._labels[label] = this._parseTimeOrLabel(position);
				return this;
			};
	
			p.addPause = function(position, callback, params, scope) {
				var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
				t.vars.onComplete = t.vars.onReverseComplete = callback;
				t.data = "isPause";
				this._hasPause = true;
				return this.add(t, position);
			};
	
			p.removeLabel = function(label) {
				delete this._labels[label];
				return this;
			};
	
			p.getLabelTime = function(label) {
				return (this._labels[label] != null) ? this._labels[label] : -1;
			};
	
			p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
				var i;
				//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
				if (ignore instanceof Animation && ignore.timeline === this) {
					this.remove(ignore);
				} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
					i = ignore.length;
					while (--i > -1) {
						if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
							this.remove(ignore[i]);
						}
					}
				}
				if (typeof(offsetOrLabel) === "string") {
					return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - this.duration() : 0, appendIfAbsent);
				}
				offsetOrLabel = offsetOrLabel || 0;
				if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
					i = timeOrLabel.indexOf("=");
					if (i === -1) {
						if (this._labels[timeOrLabel] == null) {
							return appendIfAbsent ? (this._labels[timeOrLabel] = this.duration() + offsetOrLabel) : offsetOrLabel;
						}
						return this._labels[timeOrLabel] + offsetOrLabel;
					}
					offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
					timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : this.duration();
				} else if (timeOrLabel == null) {
					timeOrLabel = this.duration();
				}
				return Number(timeOrLabel) + offsetOrLabel;
			};
	
			p.seek = function(position, suppressEvents) {
				return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
			};
	
			p.stop = function() {
				return this.paused(true);
			};
	
			p.gotoAndPlay = function(position, suppressEvents) {
				return this.play(position, suppressEvents);
			};
	
			p.gotoAndStop = function(position, suppressEvents) {
				return this.pause(position, suppressEvents);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevPaused = this._paused,
					tween, isComplete, next, callback, internalForce, pauseTween, curTime;
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = totalDur;
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
							internalForce = true;
							if (this._rawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
					this._totalTime = this._time = this._rawPrevTime = time;
				}
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
	
				if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p._hasPausedChild = function() {
				var tween = this._first;
				while (tween) {
					if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
						return true;
					}
					tween = tween._next;
				}
				return false;
			};
	
			p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || -9999999999;
				var a = [],
					tween = this._first,
					cnt = 0;
				while (tween) {
					if (tween._startTime < ignoreBeforeTime) {
						//do nothing
					} else if (tween instanceof TweenLite) {
						if (tweens !== false) {
							a[cnt++] = tween;
						}
					} else {
						if (timelines !== false) {
							a[cnt++] = tween;
						}
						if (nested !== false) {
							a = a.concat(tween.getChildren(true, tweens, timelines));
							cnt = a.length;
						}
					}
					tween = tween._next;
				}
				return a;
			};
	
			p.getTweensOf = function(target, nested) {
				var disabled = this._gc,
					a = [],
					cnt = 0,
					tweens, i;
				if (disabled) {
					this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
				}
				tweens = TweenLite.getTweensOf(target);
				i = tweens.length;
				while (--i > -1) {
					if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
						a[cnt++] = tweens[i];
					}
				}
				if (disabled) {
					this._enabled(false, true);
				}
				return a;
			};
	
			p.recent = function() {
				return this._recent;
			};
	
			p._contains = function(tween) {
				var tl = tween.timeline;
				while (tl) {
					if (tl === this) {
						return true;
					}
					tl = tl.timeline;
				}
				return false;
			};
	
			p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || 0;
				var tween = this._first,
					labels = this._labels,
					p;
				while (tween) {
					if (tween._startTime >= ignoreBeforeTime) {
						tween._startTime += amount;
					}
					tween = tween._next;
				}
				if (adjustLabels) {
					for (p in labels) {
						if (labels[p] >= ignoreBeforeTime) {
							labels[p] += amount;
						}
					}
				}
				return this._uncache(true);
			};
	
			p._kill = function(vars, target) {
				if (!vars && !target) {
					return this._enabled(false, false);
				}
				var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
					i = tweens.length,
					changed = false;
				while (--i > -1) {
					if (tweens[i]._kill(vars, target)) {
						changed = true;
					}
				}
				return changed;
			};
	
			p.clear = function(labels) {
				var tweens = this.getChildren(false, true, true),
					i = tweens.length;
				this._time = this._totalTime = 0;
				while (--i > -1) {
					tweens[i]._enabled(false, false);
				}
				if (labels !== false) {
					this._labels = {};
				}
				return this._uncache(true);
			};
	
			p.invalidate = function() {
				var tween = this._first;
				while (tween) {
					tween.invalidate();
					tween = tween._next;
				}
				return Animation.prototype.invalidate.call(this);;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (enabled === this._gc) {
					var tween = this._first;
					while (tween) {
						tween._enabled(enabled, true);
						tween = tween._next;
					}
				}
				return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				this._forcingPlayhead = true;
				var val = Animation.prototype.totalTime.apply(this, arguments);
				this._forcingPlayhead = false;
				return val;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						this.totalDuration(); //just triggers recalculation
					}
					return this._duration;
				}
				if (this.duration() !== 0 && value !== 0) {
					this.timeScale(this._duration / value);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						var max = 0,
							tween = this._last,
							prevStart = 999999999999,
							prev, end;
						while (tween) {
							prev = tween._prev; //record it here in case the tween changes position in the sequence...
							if (tween._dirty) {
								tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
							}
							if (tween._startTime > prevStart && this._sortChildren && !tween._paused) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
								this.add(tween, tween._startTime - tween._delay);
							} else {
								prevStart = tween._startTime;
							}
							if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
								max -= tween._startTime;
								if (this._timeline.smoothChildTiming) {
									this._startTime += tween._startTime / this._timeScale;
								}
								this.shiftChildren(-tween._startTime, false, -9999999999);
								prevStart = 0;
							}
							end = tween._startTime + (tween._totalDuration / tween._timeScale);
							if (end > max) {
								max = end;
							}
							tween = prev;
						}
						this._duration = this._totalDuration = max;
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
			};
	
			p.paused = function(value) {
				if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
					var tween = this._first,
						time = this._time;
					while (tween) {
						if (tween._startTime === time && tween.data === "isPause") {
							tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
						}
						tween = tween._next;
					}
				}
				return Animation.prototype.paused.apply(this, arguments);
			};
	
			p.usesFrames = function() {
				var tl = this._timeline;
				while (tl._timeline) {
					tl = tl._timeline;
				}
				return (tl === Animation._rootFramesTimeline);
			};
	
			p.rawTime = function(wrapRepeats) {
				return (wrapRepeats && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
			};
	
			return TimelineLite;
	
		}, true);
	
	
	
	
	
	
	
	
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * TimelineMax
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {
	
			var TimelineMax = function(vars) {
					TimelineLite.call(this, vars);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._dirty = true;
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_easeNone = new Ease(null, null, 1, 0),
				p = TimelineMax.prototype = new TimelineLite();
	
			p.constructor = TimelineMax;
			p.kill()._gc = false;
			TimelineMax.version = "1.19.1";
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TimelineLite.prototype.invalidate.call(this);
			};
	
			p.addCallback = function(callback, position, params, scope) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.removeCallback = function(callback, position) {
				if (callback) {
					if (position == null) {
						this._kill(null, callback);
					} else {
						var a = this.getTweensOf(callback, false),
							i = a.length,
							time = this._parseTimeOrLabel(position);
						while (--i > -1) {
							if (a[i]._startTime === time) {
								a[i]._enabled(false, false);
							}
						}
					}
				}
				return this;
			};
	
			p.removePause = function(position) {
				return this.removeCallback(TimelineLite._internals.pauseCallback, position);
			};
	
			p.tweenTo = function(position, vars) {
				vars = vars || {};
				var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false},
					Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
					duration, p, t;
				for (p in vars) {
					copy[p] = vars[p];
				}
				copy.time = this._parseTimeOrLabel(position);
				duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
				t = new Engine(this, duration, copy);
				copy.onStart = function() {
					t.target.paused(true);
					if (t.vars.time !== t.target.time() && duration === t.duration()) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
						t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale );
					}
					if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
						vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
					}
				};
				return t;
			};
	
			p.tweenFromTo = function(fromPosition, toPosition, vars) {
				vars = vars || {};
				fromPosition = this._parseTimeOrLabel(fromPosition);
				vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
				vars.immediateRender = (vars.immediateRender !== false);
				var t = this.tweenTo(toPosition, vars);
				return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					dur = this._duration,
					prevTime = this._time,
					prevTotalTime = this._totalTime,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevRawPrevTime = this._rawPrevTime,
					prevPaused = this._paused,
					prevCycle = this._cycle,
					tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					if (!this._locked) {
						this._totalTime = totalDur;
						this._cycle = this._repeat;
					}
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
							internalForce = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = time = 0;
					} else {
						this._time = dur;
						time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					if (!this._locked) {
						this._totalTime = this._cycle = 0;
					}
					this._time = 0;
					if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) {
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
					if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
						internalForce = true;
					}
					this._time = this._rawPrevTime = time;
					if (!this._locked) {
						this._totalTime = time;
						if (this._repeat !== 0) {
							cycleDuration = dur + this._repeatDelay;
							this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
							if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
								this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
							}
							this._time = this._totalTime - (this._cycle * cycleDuration);
							if (this._yoyo) if ((this._cycle & 1) !== 0) {
								this._time = dur - this._time;
							}
							if (this._time > dur) {
								this._time = dur;
								time = dur + 0.0001; //to avoid occasional floating point rounding error
							} else if (this._time < 0) {
								this._time = time = 0;
							} else {
								time = this._time;
							}
						}
					}
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents && time < dur) {
						time = this._time;
						if (time >= prevTime || (this._repeat && prevCycle !== this._cycle)) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
				}
	
				if (this._cycle !== prevCycle) if (!this._locked) {
					/*
					make sure children at the end/beginning of the timeline are rendered properly. If, for example,
					a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
					would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
					could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
					we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
					ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
					*/
					var backwards = (this._yoyo && (prevCycle & 1) !== 0),
						wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
						recTotalTime = this._totalTime,
						recCycle = this._cycle,
						recRawPrevTime = this._rawPrevTime,
						recTime = this._time;
	
					this._totalTime = prevCycle * dur;
					if (this._cycle < prevCycle) {
						backwards = !backwards;
					} else {
						this._totalTime += dur;
					}
					this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
	
					this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
					this._cycle = prevCycle;
					this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
					prevTime = (backwards) ? 0 : dur;
					this.render(prevTime, suppressEvents, (dur === 0));
					if (!suppressEvents) if (!this._gc) {
						if (this.vars.onRepeat) {
							this._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
							this._locked = false;
							this._callback("onRepeat");
						}
					}
					if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
						return;
					}
					if (wrap) {
						this._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
						this._locked = true;
						prevTime = (backwards) ? dur + 0.0001 : -0.0001;
						this.render(prevTime, true, false);
					}
					this._locked = false;
					if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
						return;
					}
					this._time = recTime;
					this._totalTime = recTotalTime;
					this._cycle = recCycle;
					this._rawPrevTime = recRawPrevTime;
				}
	
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
				if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p.getActive = function(nested, tweens, timelines) {
				if (nested == null) {
					nested = true;
				}
				if (tweens == null) {
					tweens = true;
				}
				if (timelines == null) {
					timelines = false;
				}
				var a = [],
					all = this.getChildren(nested, tweens, timelines),
					cnt = 0,
					l = all.length,
					i, tween;
				for (i = 0; i < l; i++) {
					tween = all[i];
					if (tween.isActive()) {
						a[cnt++] = tween;
					}
				}
				return a;
			};
	
	
			p.getLabelAfter = function(time) {
				if (!time) if (time !== 0) { //faster than isNan()
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					l = labels.length,
					i;
				for (i = 0; i < l; i++) {
					if (labels[i].time > time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelBefore = function(time) {
				if (time == null) {
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					i = labels.length;
				while (--i > -1) {
					if (labels[i].time < time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelsArray = function() {
				var a = [],
					cnt = 0,
					p;
				for (p in this._labels) {
					a[cnt++] = {time:this._labels[p], name:p};
				}
				a.sort(function(a,b) {
					return a.time - b.time;
				});
				return a;
			};
	
			p.invalidate = function() {
				this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
				return TimelineLite.prototype.invalidate.call(this);
			};
	
	
	//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
	
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
	
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						TimelineLite.prototype.totalDuration.call(this); //just forces refresh
						//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					}
					return this._totalDuration;
				}
				return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
	
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
	
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
	
			p.currentLabel = function(value) {
				if (!arguments.length) {
					return this.getLabelBefore(this._time + 0.00000001);
				}
				return this.seek(value, true);
			};
	
			return TimelineMax;
	
		}, true);
		
	
	
	
	
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * BezierPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var _RAD2DEG = 180 / Math.PI,
				_r1 = [],
				_r2 = [],
				_r3 = [],
				_corProps = {},
				_globals = _gsScope._gsDefine.globals,
				Segment = function(a, b, c, d) {
					if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
						c = d - (d - b) / 1000000;
					}
					if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
						b = a + (c - a) / 1000000;
					}
					this.a = a;
					this.b = b;
					this.c = c;
					this.d = d;
					this.da = d - a;
					this.ca = c - a;
					this.ba = b - a;
				},
				_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
				cubicToQuadratic = function(a, b, c, d) {
					var q1 = {a:a},
						q2 = {},
						q3 = {},
						q4 = {c:d},
						mab = (a + b) / 2,
						mbc = (b + c) / 2,
						mcd = (c + d) / 2,
						mabc = (mab + mbc) / 2,
						mbcd = (mbc + mcd) / 2,
						m8 = (mbcd - mabc) / 8;
					q1.b = mab + (a - mab) / 4;
					q2.b = mabc + m8;
					q1.c = q2.a = (q1.b + q2.b) / 2;
					q2.c = q3.a = (mabc + mbcd) / 2;
					q3.b = mbcd - m8;
					q4.b = mcd + (d - mcd) / 4;
					q3.c = q4.a = (q3.b + q4.b) / 2;
					return [q1, q2, q3, q4];
				},
				_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
					var l = a.length - 1,
						ii = 0,
						cp1 = a[0].a,
						i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
					for (i = 0; i < l; i++) {
						seg = a[ii];
						p1 = seg.a;
						p2 = seg.d;
						p3 = a[ii+1].d;
	
						if (correlate) {
							r1 = _r1[i];
							r2 = _r2[i];
							tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
							m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
							m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
							mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
						} else {
							m1 = p2 - (p2 - p1) * curviness * 0.5;
							m2 = p2 + (p3 - p2) * curviness * 0.5;
							mm = p2 - (m1 + m2) / 2;
						}
						m1 += mm;
						m2 += mm;
	
						seg.c = cp2 = m1;
						if (i !== 0) {
							seg.b = cp1;
						} else {
							seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
						}
	
						seg.da = p2 - p1;
						seg.ca = cp2 - p1;
						seg.ba = cp1 - p1;
	
						if (quad) {
							qb = cubicToQuadratic(p1, cp1, cp2, p2);
							a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
							ii += 4;
						} else {
							ii++;
						}
	
						cp1 = m2;
					}
					seg = a[ii];
					seg.b = cp1;
					seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
					seg.da = seg.d - seg.a;
					seg.ca = seg.c - seg.a;
					seg.ba = cp1 - seg.a;
					if (quad) {
						qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
					}
				},
				_parseAnchors = function(values, p, correlate, prepend) {
					var a = [],
						l, i, p1, p2, p3, tmp;
					if (prepend) {
						values = [prepend].concat(values);
						i = values.length;
						while (--i > -1) {
							if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
								values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
							}
						}
					}
					l = values.length - 2;
					if (l < 0) {
						a[0] = new Segment(values[0][p], 0, 0, values[(l < -1) ? 0 : 1][p]);
						return a;
					}
					for (i = 0; i < l; i++) {
						p1 = values[i][p];
						p2 = values[i+1][p];
						a[i] = new Segment(p1, 0, 0, p2);
						if (correlate) {
							p3 = values[i+2][p];
							_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
							_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
						}
					}
					a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
					return a;
				},
				bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
					var obj = {},
						props = [],
						first = prepend || values[0],
						i, p, a, j, r, l, seamless, last;
					correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
					if (curviness == null) {
						curviness = 1;
					}
					for (p in values[0]) {
						props.push(p);
					}
					//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
					if (values.length > 1) {
						last = values[values.length - 1];
						seamless = true;
						i = props.length;
						while (--i > -1) {
							p = props[i];
							if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
								seamless = false;
								break;
							}
						}
						if (seamless) {
							values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
							if (prepend) {
								values.unshift(prepend);
							}
							values.push(values[1]);
							prepend = values[values.length - 3];
						}
					}
					_r1.length = _r2.length = _r3.length = 0;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
						obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
					}
					i = _r1.length;
					while (--i > -1) {
						_r1[i] = Math.sqrt(_r1[i]);
						_r2[i] = Math.sqrt(_r2[i]);
					}
					if (!basic) {
						i = props.length;
						while (--i > -1) {
							if (_corProps[p]) {
								a = obj[props[i]];
								l = a.length - 1;
								for (j = 0; j < l; j++) {
									r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
									_r3[j] = (_r3[j] || 0) + r * r;
								}
							}
						}
						i = _r3.length;
						while (--i > -1) {
							_r3[i] = Math.sqrt(_r3[i]);
						}
					}
					i = props.length;
					j = quadratic ? 4 : 1;
					while (--i > -1) {
						p = props[i];
						a = obj[p];
						_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
						if (seamless) {
							a.splice(0, j);
							a.splice(a.length - j, j);
						}
					}
					return obj;
				},
				_parseBezierData = function(values, type, prepend) {
					type = type || "soft";
					var obj = {},
						inc = (type === "cubic") ? 3 : 2,
						soft = (type === "soft"),
						props = [],
						a, b, c, d, cur, i, j, l, p, cnt, tmp;
					if (soft && prepend) {
						values = [prepend].concat(values);
					}
					if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
					for (p in values[0]) {
						props.push(p);
					}
					i = props.length;
					while (--i > -1) {
						p = props[i];
						obj[p] = cur = [];
						cnt = 0;
						l = values.length;
						for (j = 0; j < l; j++) {
							a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
							if (soft) if (j > 1) if (j < l - 1) {
								cur[cnt++] = (a + cur[cnt-2]) / 2;
							}
							cur[cnt++] = a;
						}
						l = cnt - inc + 1;
						cnt = 0;
						for (j = 0; j < l; j += inc) {
							a = cur[j];
							b = cur[j+1];
							c = cur[j+2];
							d = (inc === 2) ? 0 : cur[j+3];
							cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
						}
						cur.length = cnt;
					}
					return obj;
				},
				_addCubicLengths = function(a, steps, resolution) {
					var inc = 1 / resolution,
						j = a.length,
						d, d1, s, da, ca, ba, p, i, inv, bez, index;
					while (--j > -1) {
						bez = a[j];
						s = bez.a;
						da = bez.d - s;
						ca = bez.c - s;
						ba = bez.b - s;
						d = d1 = 0;
						for (i = 1; i <= resolution; i++) {
							p = inc * i;
							inv = 1 - p;
							d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
							index = j * resolution + i - 1;
							steps[index] = (steps[index] || 0) + d * d;
						}
					}
				},
				_parseLengthData = function(obj, resolution) {
					resolution = resolution >> 0 || 6;
					var a = [],
						lengths = [],
						d = 0,
						total = 0,
						threshold = resolution - 1,
						segments = [],
						curLS = [], //current length segments array
						p, i, l, index;
					for (p in obj) {
						_addCubicLengths(obj[p], a, resolution);
					}
					l = a.length;
					for (i = 0; i < l; i++) {
						d += Math.sqrt(a[i]);
						index = i % resolution;
						curLS[index] = d;
						if (index === threshold) {
							total += d;
							index = (i / resolution) >> 0;
							segments[index] = curLS;
							lengths[index] = total;
							d = 0;
							curLS = [];
						}
					}
					return {length:total, lengths:lengths, segments:segments};
				},
	
	
	
				BezierPlugin = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.7",
						API: 2,
						global:true,
	
						//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
						init: function(target, vars, tween) {
							this._target = target;
							if (vars instanceof Array) {
								vars = {values:vars};
							}
							this._func = {};
							this._mod = {};
							this._props = [];
							this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
							var values = vars.values || [],
								first = {},
								second = values[0],
								autoRotate = vars.autoRotate || tween.vars.orientToBezier,
								p, isFunc, i, j, prepend;
	
							this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
							for (p in second) {
								this._props.push(p);
							}
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
	
								this._overwriteProps.push(p);
								isFunc = this._func[p] = (typeof(target[p]) === "function");
								first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
								if (!prepend) if (first[p] !== values[0][p]) {
									prepend = first;
								}
							}
							this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
							this._segCount = this._beziers[p].length;
	
							if (this._timeRes) {
								var ld = _parseLengthData(this._beziers, this._timeRes);
								this._length = ld.length;
								this._lengths = ld.lengths;
								this._segments = ld.segments;
								this._l1 = this._li = this._s1 = this._si = 0;
								this._l2 = this._lengths[0];
								this._curSeg = this._segments[0];
								this._s2 = this._curSeg[0];
								this._prec = 1 / this._curSeg.length;
							}
	
							if ((autoRotate = this._autoRotate)) {
								this._initialRotations = [];
								if (!(autoRotate[0] instanceof Array)) {
									this._autoRotate = autoRotate = [autoRotate];
								}
								i = autoRotate.length;
								while (--i > -1) {
									for (j = 0; j < 3; j++) {
										p = autoRotate[i][j];
										this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
									}
									p = autoRotate[i][2];
									this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
									this._overwriteProps.push(p);
								}
							}
							this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
							return true;
						},
	
						//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
						set: function(v) {
							var segments = this._segCount,
								func = this._func,
								target = this._target,
								notStart = (v !== this._startRatio),
								curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
							if (!this._timeRes) {
								curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
								t = (v - (curIndex * (1 / segments))) * segments;
							} else {
								lengths = this._lengths;
								curSeg = this._curSeg;
								v *= this._length;
								i = this._li;
								//find the appropriate segment (if the currently cached one isn't correct)
								if (v > this._l2 && i < segments - 1) {
									l = segments - 1;
									while (i < l && (this._l2 = lengths[++i]) <= v) {	}
									this._l1 = lengths[i-1];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s2 = curSeg[(this._s1 = this._si = 0)];
								} else if (v < this._l1 && i > 0) {
									while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
									if (i === 0 && v < this._l1) {
										this._l1 = 0;
									} else {
										i++;
									}
									this._l2 = lengths[i];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
									this._s2 = curSeg[this._si];
								}
								curIndex = i;
								//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
								v -= this._l1;
								i = this._si;
								if (v > this._s2 && i < curSeg.length - 1) {
									l = curSeg.length - 1;
									while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
									this._s1 = curSeg[i-1];
									this._si = i;
								} else if (v < this._s1 && i > 0) {
									while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
									if (i === 0 && v < this._s1) {
										this._s1 = 0;
									} else {
										i++;
									}
									this._s2 = curSeg[i];
									this._si = i;
								}
								t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
							}
							inv = 1 - t;
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
								b = this._beziers[p][curIndex];
								val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
								if (this._mod[p]) {
									val = this._mod[p](val, target);
								}
								if (func[p]) {
									target[p](val);
								} else {
									target[p] = val;
								}
							}
	
							if (this._autoRotate) {
								var ar = this._autoRotate,
									b2, x1, y1, x2, y2, add, conv;
								i = ar.length;
								while (--i > -1) {
									p = ar[i][2];
									add = ar[i][3] || 0;
									conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
									b = this._beziers[ar[i][0]];
									b2 = this._beziers[ar[i][1]];
	
									if (b && b2) { //in case one of the properties got overwritten.
										b = b[curIndex];
										b2 = b2[curIndex];
	
										x1 = b.a + (b.b - b.a) * t;
										x2 = b.b + (b.c - b.b) * t;
										x1 += (x2 - x1) * t;
										x2 += ((b.c + (b.d - b.c) * t) - x2) * t;
	
										y1 = b2.a + (b2.b - b2.a) * t;
										y2 = b2.b + (b2.c - b2.b) * t;
										y1 += (y2 - y1) * t;
										y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;
	
										val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
	
										if (this._mod[p]) {
											val = this._mod[p](val, target); //for modProps
										}
	
										if (func[p]) {
											target[p](val);
										} else {
											target[p] = val;
										}
									}
								}
							}
						}
				}),
				p = BezierPlugin.prototype;
	
	
			BezierPlugin.bezierThrough = bezierThrough;
			BezierPlugin.cubicToQuadratic = cubicToQuadratic;
			BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
			BezierPlugin.quadraticToCubic = function(a, b, c) {
				return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
			};
	
			BezierPlugin._cssRegister = function() {
				var CSSPlugin = _globals.CSSPlugin;
				if (!CSSPlugin) {
					return;
				}
				var _internals = CSSPlugin._internals,
					_parseToProxy = _internals._parseToProxy,
					_setPluginRatio = _internals._setPluginRatio,
					CSSPropTween = _internals.CSSPropTween;
				_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
					if (e instanceof Array) {
						e = {values:e};
					}
					plugin = new BezierPlugin();
					var values = e.values,
						l = values.length - 1,
						pluginValues = [],
						v = {},
						i, p, data;
					if (l < 0) {
						return pt;
					}
					for (i = 0; i <= l; i++) {
						data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
						pluginValues[i] = data.end;
					}
					for (p in e) {
						v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
					}
					v.values = pluginValues;
					pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
					pt.data = data;
					pt.plugin = plugin;
					pt.setRatio = _setPluginRatio;
					if (v.autoRotate === 0) {
						v.autoRotate = true;
					}
					if (v.autoRotate && !(v.autoRotate instanceof Array)) {
						i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
						v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
					}
					if (v.autoRotate) {
						if (!cssp._transform) {
							cssp._enableTransforms(false);
						}
						data.autoRotate = cssp._target._gsTransform;
						data.proxy.rotation = data.autoRotate.rotation || 0;
						cssp._overwriteProps.push("rotation");
					}
					plugin._onInitTween(data.proxy, v, cssp._tween);
					return pt;
				}});
			};
	
			p._mod = function(lookup) {
				var op = this._overwriteProps,
					i = op.length,
					val;
				while (--i > -1) {
					val = lookup[op[i]];
					if (val && typeof(val) === "function") {
						this._mod[op[i]] = val;
					}
				}
			};
	
			p._kill = function(lookup) {
				var a = this._props,
					p, i;
				for (p in this._beziers) {
					if (p in lookup) {
						delete this._beziers[p];
						delete this._func[p];
						i = a.length;
						while (--i > -1) {
							if (a[i] === p) {
								a.splice(i, 1);
							}
						}
					}
				}
				a = this._autoRotate;
				if (a) {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i][2]]) {
							a.splice(i, 1);
						}
					}
				}
				return this._super._kill.call(this, lookup);
			};
	
		}());
	
	
	
	
	
	
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * CSSPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.19.1";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_dummyElement = {style:{}},
				_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
				_createElement = function(type, ns) {
					return _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = (_gsScope.navigator || {}).userAgent || "",
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
					_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (_gsScope.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || !sfx) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getCTM && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(v[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = colors.length ? "" : s,
						i, color, temp;
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = Math.round(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod(proxy.rotation, this.t) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = r; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i];
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1), true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra((hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra((hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", true, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", true)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), true);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px"), (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = _gsScope.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement || {},
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !_gsScope.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
							b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
						}
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
							x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
							y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
							xOrigin = decoratee.xOrigin = v[0] = x;
							yOrigin = decoratee.yOrigin = v[1] = y;
						}
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
					var svg = _createElement("svg", this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
						oldParent = this.parentNode,
						oldSibling = this.nextSibling,
						oldCSS = this.style.cssText,
						bbox;
					_docElement.appendChild(svg);
					svg.appendChild(this);
					this.style.display = "block";
					if (swapIfPossible) {
						try {
							bbox = this.getBBox();
							this._originalGetBBox = this.getBBox;
							this.getBBox = _getBBoxHack;
						} catch (e) { }
					} else if (this._originalGetBBox) {
						bbox = this._originalGetBBox();
					}
					if (oldSibling) {
						oldParent.insertBefore(this, oldSibling);
					} else {
						oldParent.appendChild(this);
					}
					_docElement.removeChild(svg);
					this.style.cssText = oldCSS;
					return bbox;
				},
				_getBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (error) {
						return _getBBoxHack.call(e, true);
					}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getCTM && _getBBox(e) && (!e.parentNode || e.ownerSVGElement));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (isDefault && _transformProp && ((none = (_getComputedStyle(e).display === "none")) || !e.parentNode)) {
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none".
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getCTM && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							if (m.indexOf("matrix") !== -1) { //just in case there's a "transform" value specified as an attribute instead of CSS style. Accept either a matrix() or simple translate() value though.
								s = m;
								isDefault = 0;
							} else if (m.indexOf("translate") !== -1) {
								s = "matrix(1,0,0,1," + m.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",") + ")";
								isDefault = 0;
							}
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getCTM && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
	
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								a11 = a11*cos+a12*sin;
								t2 = a21*cos+a22*sin;
								a22 = a21*-sin+a22*cos;
								a32 = a31*-sin+a32*cos;
								a21 = t2;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a23 * a23) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a32 * a32 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							if (tm.rotationX || tm.rotationY) {
								tm.skewX = 0;
							} else {
								tm.skewX = (a12 || a22) ? Math.atan2(a12, a22) * _RAD2DEG + tm.rotation : tm.skewX || 0;
								if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
									if (invX) {
										tm.scaleX *= -1;
										tm.skewX += (tm.rotation <= 0) ? 180 : -180;
										tm.rotation += (tm.rotation <= 0) ? 180 : -180;
									} else {
										tm.scaleY *= -1;
										tm.skewX += (tm.skewX <= 0) ? 180 : -180;
									}
								}
							}
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
								if (invX) {
									scaleX *= -1;
									skewX += (rotation <= 0) ? 180 : -180;
									rotation += (rotation <= 0) ? 180 : -180;
								} else {
									scaleY *= -1;
									skewX += (skewX <= 0) ? 180 : -180;
								}
							}
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						skewY = t.skewY,
						skewX = t.skewX,
						t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
					if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
						skewX += skewY;
						angle += skewY;
					}
	
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (skewX) {
							angle -= skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((skewX - skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0, //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
					swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc(_index, t);
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation, m1.rotation, "rotation", endRotations);
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX);
					m2.skewY = _parseAngle(v.skewY, m1.skewY);
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong).
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
	
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
	
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = Math.round(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = Math.round(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function" && lookup[pt.p] === Math.round) { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally..
						pt.r = 1;
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
	
		
		
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * RoundPropsPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var RoundPropsPlugin = _gsScope._gsDefine.plugin({
					propName: "roundProps",
					version: "1.6.0",
					priority: -1,
					API: 2,
	
					//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, value, tween) {
						this._tween = tween;
						return true;
					}
	
				}),
				_roundLinkedList = function(node) {
					while (node) {
						if (!node.f && !node.blob) {
							node.m = Math.round;
						}
						node = node._next;
					}
				},
				p = RoundPropsPlugin.prototype;
	
			p._onInitAllProps = function() {
				var tween = this._tween,
					rp = (tween.vars.roundProps.join) ? tween.vars.roundProps : tween.vars.roundProps.split(","),
					i = rp.length,
					lookup = {},
					rpt = tween._propLookup.roundProps,
					prop, pt, next;
				while (--i > -1) {
					lookup[rp[i]] = Math.round;
				}
				i = rp.length;
				while (--i > -1) {
					prop = rp[i];
					pt = tween._firstPT;
					while (pt) {
						next = pt._next; //record here, because it may get removed
						if (pt.pg) {
							pt.t._mod(lookup);
						} else if (pt.n === prop) {
							if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
								_roundLinkedList(pt.t._firstPT);
							} else {
								this._add(pt.t, prop, pt.s, pt.c);
								//remove from linked list
								if (next) {
									next._prev = pt._prev;
								}
								if (pt._prev) {
									pt._prev._next = next;
								} else if (tween._firstPT === pt) {
									tween._firstPT = next;
								}
								pt._next = pt._prev = null;
								tween._propLookup[prop] = rpt;
							}
						}
						pt = next;
					}
				}
				return false;
			};
	
			p._add = function(target, p, s, c) {
				this._addTween(target, p, s, s + c, p, Math.round);
				this._overwriteProps.push(p);
			};
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * AttrPlugin
	 * ----------------------------------------------------------------
	 */
	
		(function() {
	
			_gsScope._gsDefine.plugin({
				propName: "attr",
				API: 2,
				version: "0.6.0",
	
				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var p, end;
					if (typeof(target.setAttribute) !== "function") {
						return false;
					}
					for (p in value) {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
						this._overwriteProps.push(p);
					}
					return true;
				}
	
			});
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * DirectionalRotationPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine.plugin({
			propName: "directionalRotation",
			version: "0.3.0",
			API: 2,
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				if (typeof(value) !== "object") {
					value = {rotation:value};
				}
				this.finals = {};
				var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
					min = 0.000001,
					p, v, start, end, dif, split;
				for (p in value) {
					if (p !== "useRadians") {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						split = (end + "").split("_");
						v = split[0];
						start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
						end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
						dif = end - start;
						if (split.length) {
							v = split.join("_");
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						if (dif > min || dif < -min) {
							this._addTween(target, p, start, start + dif, p);
							this._overwriteProps.push(p);
						}
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(ratio) {
				var pt;
				if (ratio !== 1) {
					this._super.setRatio.call(this, ratio);
				} else {
					pt = this._firstPT;
					while (pt) {
						if (pt.f) {
							pt.t[pt.p](this.finals[pt.p]);
						} else {
							pt.t[pt.p] = this.finals[pt.p];
						}
						pt = pt._next;
					}
				}
			}
	
		})._autoCSS = true;
	
	
	
	
	
	
	
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * EasePack
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
			
			var w = (_gsScope.GreenSockGlobals || _gsScope),
				gs = w.com.greensock,
				_2PI = Math.PI * 2,
				_HALF_PI = Math.PI / 2,
				_class = gs._class,
				_create = function(n, f) {
					var C = _class("easing." + n, function(){}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					return C;
				},
				_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
				_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
					var C = _class("easing."+name, {
						easeOut:new EaseOut(),
						easeIn:new EaseIn(),
						easeInOut:new EaseInOut()
					}, true);
					_easeReg(C, name);
					return C;
				},
				EasePoint = function(time, value, next) {
					this.t = time;
					this.v = value;
					if (next) {
						this.next = next;
						next.prev = this;
						this.c = next.v - value;
						this.gap = next.t - time;
					}
				},
	
				//Back
				_createBack = function(n, f) {
					var C = _class("easing." + n, function(overshoot) {
							this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
							this._p2 = this._p1 * 1.525;
						}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					p.config = function(overshoot) {
						return new C(overshoot);
					};
					return C;
				},
	
				Back = _wrap("Back",
					_createBack("BackOut", function(p) {
						return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
					}),
					_createBack("BackIn", function(p) {
						return p * p * ((this._p1 + 1) * p - this._p1);
					}),
					_createBack("BackInOut", function(p) {
						return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
					})
				),
	
	
				//SlowMo
				SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
					power = (power || power === 0) ? power : 0.7;
					if (linearRatio == null) {
						linearRatio = 0.7;
					} else if (linearRatio > 1) {
						linearRatio = 1;
					}
					this._p = (linearRatio !== 1) ? power : 0;
					this._p1 = (1 - linearRatio) / 2;
					this._p2 = linearRatio;
					this._p3 = this._p1 + this._p2;
					this._calcEnd = (yoyoMode === true);
				}, true),
				p = SlowMo.prototype = new Ease(),
				SteppedEase, RoughEase, _createElastic;
	
			p.constructor = SlowMo;
			p.getRatio = function(p) {
				var r = p + (0.5 - p) * this._p;
				if (p < this._p1) {
					return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
				} else if (p > this._p3) {
					return this._calcEnd ? 1 - (p = (p - this._p3) / this._p1) * p : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p);
				}
				return this._calcEnd ? 1 : r;
			};
			SlowMo.ease = new SlowMo(0.7, 0.7);
	
			p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
				return new SlowMo(linearRatio, power, yoyoMode);
			};
	
	
			//SteppedEase
			SteppedEase = _class("easing.SteppedEase", function(steps) {
					steps = steps || 1;
					this._p1 = 1 / steps;
					this._p2 = steps + 1;
				}, true);
			p = SteppedEase.prototype = new Ease();
			p.constructor = SteppedEase;
			p.getRatio = function(p) {
				if (p < 0) {
					p = 0;
				} else if (p >= 1) {
					p = 0.999999999;
				}
				return ((this._p2 * p) >> 0) * this._p1;
			};
			p.config = SteppedEase.config = function(steps) {
				return new SteppedEase(steps);
			};
	
	
			//RoughEase
			RoughEase = _class("easing.RoughEase", function(vars) {
				vars = vars || {};
				var taper = vars.taper || "none",
					a = [],
					cnt = 0,
					points = (vars.points || 20) | 0,
					i = points,
					randomize = (vars.randomize !== false),
					clamp = (vars.clamp === true),
					template = (vars.template instanceof Ease) ? vars.template : null,
					strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
					x, y, bump, invX, obj, pnt;
				while (--i > -1) {
					x = randomize ? Math.random() : (1 / points) * i;
					y = template ? template.getRatio(x) : x;
					if (taper === "none") {
						bump = strength;
					} else if (taper === "out") {
						invX = 1 - x;
						bump = invX * invX * strength;
					} else if (taper === "in") {
						bump = x * x * strength;
					} else if (x < 0.5) {  //"both" (start)
						invX = x * 2;
						bump = invX * invX * 0.5 * strength;
					} else {				//"both" (end)
						invX = (1 - x) * 2;
						bump = invX * invX * 0.5 * strength;
					}
					if (randomize) {
						y += (Math.random() * bump) - (bump * 0.5);
					} else if (i % 2) {
						y += bump * 0.5;
					} else {
						y -= bump * 0.5;
					}
					if (clamp) {
						if (y > 1) {
							y = 1;
						} else if (y < 0) {
							y = 0;
						}
					}
					a[cnt++] = {x:x, y:y};
				}
				a.sort(function(a, b) {
					return a.x - b.x;
				});
	
				pnt = new EasePoint(1, 1, null);
				i = points;
				while (--i > -1) {
					obj = a[i];
					pnt = new EasePoint(obj.x, obj.y, pnt);
				}
	
				this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
			}, true);
			p = RoughEase.prototype = new Ease();
			p.constructor = RoughEase;
			p.getRatio = function(p) {
				var pnt = this._prev;
				if (p > pnt.t) {
					while (pnt.next && p >= pnt.t) {
						pnt = pnt.next;
					}
					pnt = pnt.prev;
				} else {
					while (pnt.prev && p <= pnt.t) {
						pnt = pnt.prev;
					}
				}
				this._prev = pnt;
				return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
			};
			p.config = function(vars) {
				return new RoughEase(vars);
			};
			RoughEase.ease = new RoughEase();
	
	
			//Bounce
			_wrap("Bounce",
				_create("BounceOut", function(p) {
					if (p < 1 / 2.75) {
						return 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					}
					return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}),
				_create("BounceIn", function(p) {
					if ((p = 1 - p) < 1 / 2.75) {
						return 1 - (7.5625 * p * p);
					} else if (p < 2 / 2.75) {
						return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
					} else if (p < 2.5 / 2.75) {
						return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
					}
					return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
				}),
				_create("BounceInOut", function(p) {
					var invert = (p < 0.5);
					if (invert) {
						p = 1 - (p * 2);
					} else {
						p = (p * 2) - 1;
					}
					if (p < 1 / 2.75) {
						p = 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					} else {
						p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
					}
					return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
				})
			);
	
	
			//CIRC
			_wrap("Circ",
				_create("CircOut", function(p) {
					return Math.sqrt(1 - (p = p - 1) * p);
				}),
				_create("CircIn", function(p) {
					return -(Math.sqrt(1 - (p * p)) - 1);
				}),
				_create("CircInOut", function(p) {
					return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
				})
			);
	
	
			//Elastic
			_createElastic = function(n, f, def) {
				var C = _class("easing." + n, function(amplitude, period) {
						this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
						this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
						this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
						this._p2 = _2PI / this._p2; //precalculate to optimize
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(amplitude, period) {
					return new C(amplitude, period);
				};
				return C;
			};
			_wrap("Elastic",
				_createElastic("ElasticOut", function(p) {
					return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
				}, 0.3),
				_createElastic("ElasticIn", function(p) {
					return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
				}, 0.3),
				_createElastic("ElasticInOut", function(p) {
					return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
				}, 0.45)
			);
	
	
			//Expo
			_wrap("Expo",
				_create("ExpoOut", function(p) {
					return 1 - Math.pow(2, -10 * p);
				}),
				_create("ExpoIn", function(p) {
					return Math.pow(2, 10 * (p - 1)) - 0.001;
				}),
				_create("ExpoInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
				})
			);
	
	
			//Sine
			_wrap("Sine",
				_create("SineOut", function(p) {
					return Math.sin(p * _HALF_PI);
				}),
				_create("SineIn", function(p) {
					return -Math.cos(p * _HALF_PI) + 1;
				}),
				_create("SineInOut", function(p) {
					return -0.5 * (Math.cos(Math.PI * p) - 1);
				})
			);
	
			_class("easing.EaseLookup", {
					find:function(s) {
						return Ease.map[s];
					}
				}, true);
	
			//register the non-standard eases
			_easeReg(w.SlowMo, "SlowMo", "ease,");
			_easeReg(RoughEase, "RoughEase", "ease,");
			_easeReg(SteppedEase, "SteppedEase", "ease,");
	
			return Back;
			
		}, true);
	
	
	});
	
	if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.
	
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
	 * ----------------------------------------------------------------
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_doc = window.document,
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl, hasModule;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								hasModule = (typeof(module) !== "undefined" && module.exports);
								if (!hasModule && "function" === "function" && __webpack_require__(682)){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								} else if (hasModule){ //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				_blankArray = [],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) {
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && _doc.visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000) {
						_ticker.wake();
					}
					setTimeout(_checkTimeout, 2000);
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					var pauseTime = this._pauseTime,
						t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				return this._uncache(false);
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.19.1";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				return (typeof(_doc) === "undefined") ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : (v === 1) ? this.end : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m(val, this._target || pt.t);
						} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					a.end = end;
					start = a[0] = start + ""; //ensure values are strings
					end = a[1] = end + "";
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var type = typeof(target[prop]),
						getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
						s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob;
	
					if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
						if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, (isRelative ? pt.s + pt.c : end), stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else {
							pt.s = parseFloat(s);
							if (!isRelative) {
								pt.c = (parseFloat(end) - pt.s) || 0;
							}
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					this._startAt = TweenLite.to(this.target, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a;
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(475),
	    getValue = __webpack_require__(504);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 60 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	
	function ___$insertStyle(css) {
	  if (!css) {
	    return;
	  }
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	  var style = document.createElement('style');
	
	  style.setAttribute('type', 'text/css');
	  style.innerHTML = css;
	  document.head.appendChild(style);
	  return css;
	}
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(3));
	var uuid = __webpack_require__(583);
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	var CONSTANT = {
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};
	
	/**
	 * Static methods for react-tooltip
	 */
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatible with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
	  var event;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, {
	      detail: opts
	    });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true, opts);
	  }
	
	  window.dispatchEvent(event);
	};
	
	function staticMethods (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
	      target: target
	    });
	  };
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	
	
	  target.rebuild = function () {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
	  };
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	
	
	  target.show = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
	      target: target
	    });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	
	      this.showTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, hasTarget);
	    }
	  };
	}
	
	/**
	 * Events that should be bound to the window
	 */
	function windowListener (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
	
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
	
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
	
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	  /**
	   * invoked by resize event of window
	   */
	
	
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	}
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	  var isCapture = this.isCapture(e.currentTarget);
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	  if (!isCapture) e.stopPropagation();
	
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListeners = {
	  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};
	function customEvent (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	    return event || !!ele.getAttribute('data-event');
	  };
	  /* Bind listener for custom event */
	
	
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff;
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	  /* Unbind listener for custom event */
	
	
	  target.prototype.customUnbindListener = function (ele) {
	    var _this$state2 = this.state,
	        event = _this$state2.event,
	        eventOff = _this$state2.eventOff;
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	}
	
	/**
	 * Util method to judge if it should follow capture model
	 */
	function isCapture (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	function getEffect (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	
	var makeProxy = function makeProxy(e) {
	  var proxy = {};
	
	  for (var key in e) {
	    if (typeof e[key] === 'function') {
	      proxy[key] = e[key].bind(e);
	    } else {
	      proxy[key] = e[key];
	    }
	  }
	
	  return proxy;
	};
	
	var bodyListener = function bodyListener(callback, options, e) {
	  var _options$respectEffec = options.respectEffect,
	      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
	      _options$customEvent = options.customEvent,
	      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
	  var id = this.props.id;
	  var tip = e.target.getAttribute('data-tip') || null;
	  var forId = e.target.getAttribute('data-for') || null;
	  var target = e.target;
	
	  if (this.isCustomEvent(target) && !customEvent) {
	    return;
	  }
	
	  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
	
	  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
	    var proxy = makeProxy(e);
	    proxy.currentTarget = target;
	    callback(proxy);
	  }
	};
	
	var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
	  var events = {};
	  targetArray.forEach(function (target) {
	    var event = target.getAttribute(dataAttribute);
	    if (event) event.split(' ').forEach(function (event) {
	      return events[event] = true;
	    });
	  });
	  return events;
	};
	
	var getBody = function getBody() {
	  return document.getElementsByTagName('body')[0];
	};
	
	function bodyMode (target) {
	  target.prototype.isBodyMode = function () {
	    return !!this.props.bodyMode;
	  };
	
	  target.prototype.bindBodyListener = function (targetArray) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff,
	        possibleCustomEvents = _this$state.possibleCustomEvents,
	        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
	    var body = getBody();
	    var customEvents = findCustomEvents(targetArray, 'data-event');
	    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
	    if (event != null) customEvents[event] = true;
	    if (eventOff != null) customEventsOff[eventOff] = true;
	    possibleCustomEvents.split(' ').forEach(function (event) {
	      return customEvents[event] = true;
	    });
	    possibleCustomEventsOff.split(' ').forEach(function (event) {
	      return customEventsOff[event] = true;
	    });
	    this.unbindBodyListener(body);
	    var listeners = this.bodyModeListeners = {};
	
	    if (event == null) {
	      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
	      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
	        respectEffect: true
	      });
	      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
	    }
	
	    for (var _event in customEvents) {
	      listeners[_event] = bodyListener.bind(this, function (e) {
	        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
	        checkStatus.call(_this, targetEventOff, e);
	      }, {
	        customEvent: true
	      });
	    }
	
	    for (var _event2 in customEventsOff) {
	      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
	        customEvent: true
	      });
	    }
	
	    for (var _event3 in listeners) {
	      body.addEventListener(_event3, listeners[_event3]);
	    }
	  };
	
	  target.prototype.unbindBodyListener = function (body) {
	    body = body || getBody();
	    var listeners = this.bodyModeListeners;
	
	    for (var event in listeners) {
	      body.removeEventListener(event, listeners[event]);
	    }
	  };
	}
	
	/**
	 * Tracking target removing from DOM.
	 * It's necessary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};
	
	function trackRemoval (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	
	            return;
	          }
	        }
	      }
	    });
	    observer.observe(window.document, {
	      childList: true,
	      subtree: true
	    });
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	}
	
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	function getPosition (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffsetX = _calculateOffset.extraOffsetX,
	      extraOffsetY = _calculateOffset.extraOffsetY;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offsetX = defaultOffset[place].l;
	    return mouseX + offsetX + extraOffsetX;
	  };
	
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offsetX = defaultOffset[place].r;
	    return mouseX + offsetX + extraOffsetX;
	  };
	
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offsetY = defaultOffset[place].t;
	    return mouseY + offsetY + extraOffsetY;
	  };
	
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offsetY = defaultOffset[place].b;
	    return mouseY + offsetY + extraOffsetY;
	  }; //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	
	
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  }; // Check whether the tooltip with orientation p is completely inside the client window
	
	
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ['top', 'bottom', 'left', 'right'];
	  var insideList = [];
	
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace;
	  var shouldUpdatePlace = desiredPlace !== place;
	
	  if (inside(desiredPlace) && shouldUpdatePlace) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: {
	        place: newPlace
	      }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	}
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	}; // Get current mouse offset
	
	
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	}; // List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	
	
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top;
	  var right;
	  var bottom;
	  var left;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right
	  };
	}; // Consider additional offset into position calculation
	
	
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffsetX = 0;
	  var extraOffsetY = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
	  }
	
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffsetY -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffsetY += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffsetX -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffsetX += parseInt(offset[key], 10);
	    }
	  }
	
	  return {
	    extraOffsetX: extraOffsetX,
	    extraOffsetY: extraOffsetY
	  };
	}; // Get the offset of the parent elements
	
	
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	
	  while (currentParent) {
	    var computedStyle = window.getComputedStyle(currentParent); // transform and will-change: transform change the containing block
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
	
	    if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	  return {
	    parentTop: parentTop,
	    parentLeft: parentLeft
	  };
	};
	
	/**
	 * To get the tooltip content
	 * it may comes from data-tip or this.props.children
	 * it should support multiline
	 *
	 * @params
	 * - `tip` {String} value of data-tip
	 * - `children` {ReactElement} this.props.children
	 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
	 *
	 * @return
	 * - String or react component
	 */
	function getTipContent (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	
	  if (getContent === null) return null; // Tip not exist and children is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  } // Multiline tooltip content
	
	
	  return tip.split(regexp).map(function (d, i) {
	    return React.createElement("span", {
	      key: i,
	      className: "multi-line"
	    }, d);
	  });
	}
	
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return /(^aria-\w+$|^role$)/.test(prop);
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	  return ariaObj;
	}
	
	/**
	 * Convert nodelist to array
	 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
	 * NodeLists are functions in Safari
	 */
	function nodeListToArray (nodeList) {
	  var length = nodeList.length;
	
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	}
	
	function generateUUID() {
	  return 't' + uuid.v4();
	}
	
	___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}");
	
	/**
	 * Default pop-up style values (text color, background color).
	 */
	var defaultColors = {
	  dark: {
	    text: '#fff',
	    background: '#222',
	    border: 'transparent',
	    arrow: '#222'
	  },
	  success: {
	    text: '#fff',
	    background: '#8DC572',
	    border: 'transparent',
	    arrow: '#8DC572'
	  },
	  warning: {
	    text: '#fff',
	    background: '#F0AD4E',
	    border: 'transparent',
	    arrow: '#F0AD4E'
	  },
	  error: {
	    text: '#fff',
	    background: '#BE6464',
	    border: 'transparent',
	    arrow: '#BE6464'
	  },
	  info: {
	    text: '#fff',
	    background: '#337AB7',
	    border: 'transparent',
	    arrow: '#337AB7'
	  },
	  light: {
	    text: '#222',
	    background: '#fff',
	    border: 'transparent',
	    arrow: '#fff'
	  }
	};
	function getDefaultPopupColors(type) {
	  return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
	}
	
	/**
	 * Generates the specific tooltip style for use on render.
	 */
	
	function generateTooltipStyle(uuid, customColors, type, hasBorder) {
	  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder));
	}
	/**
	 * Generates the tooltip style rules based on the element-specified "data-type" property.
	 */
	
	function generateStyle(uuid, colors) {
	  var textColor = colors.text;
	  var backgroundColor = colors.background;
	  var borderColor = colors.border;
	  var arrowColor = colors.arrow;
	  return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
	}
	
	function getPopupColors(customColors, type, hasBorder) {
	  var textColor = customColors.text;
	  var backgroundColor = customColors.background;
	  var borderColor = customColors.border;
	  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
	  var colors = getDefaultPopupColors(type);
	
	  if (textColor) {
	    colors.text = textColor;
	  }
	
	  if (backgroundColor) {
	    colors.background = backgroundColor;
	  }
	
	  if (hasBorder) {
	    if (borderColor) {
	      colors.border = borderColor;
	    } else {
	      colors.border = type === 'light' ? 'black' : 'white';
	    }
	  }
	
	  if (arrowColor) {
	    colors.arrow = arrowColor;
	  }
	
	  return colors;
	}
	
	var _class, _class2, _temp;
	
	var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  _createClass(ReactTooltip, null, [{
	    key: "propTypes",
	    get: function get() {
	      return {
	        uuid: PropTypes.string,
	        children: PropTypes.any,
	        place: PropTypes.string,
	        type: PropTypes.string,
	        effect: PropTypes.string,
	        offset: PropTypes.object,
	        multiline: PropTypes.bool,
	        border: PropTypes.bool,
	        textColor: PropTypes.string,
	        backgroundColor: PropTypes.string,
	        borderColor: PropTypes.string,
	        arrowColor: PropTypes.string,
	        insecure: PropTypes.bool,
	        "class": PropTypes.string,
	        className: PropTypes.string,
	        id: PropTypes.string,
	        html: PropTypes.bool,
	        delayHide: PropTypes.number,
	        delayUpdate: PropTypes.number,
	        delayShow: PropTypes.number,
	        event: PropTypes.string,
	        eventOff: PropTypes.string,
	        isCapture: PropTypes.bool,
	        globalEventOff: PropTypes.string,
	        getContent: PropTypes.any,
	        afterShow: PropTypes.func,
	        afterHide: PropTypes.func,
	        overridePosition: PropTypes.func,
	        disable: PropTypes.bool,
	        scrollHide: PropTypes.bool,
	        resizeHide: PropTypes.bool,
	        wrapper: PropTypes.string,
	        bodyMode: PropTypes.bool,
	        possibleCustomEvents: PropTypes.string,
	        possibleCustomEventsOff: PropTypes.string,
	        clickable: PropTypes.bool
	      };
	    }
	  }]);
	
	  function ReactTooltip(props) {
	    var _this;
	
	    _classCallCheck(this, ReactTooltip);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
	    _this.state = {
	      uuid: props.uuid || generateUUID(),
	      place: props.place || 'top',
	      // Direction of tooltip
	      desiredPlace: props.place || 'top',
	      type: 'dark',
	      // Color theme of tooltip
	      effect: 'float',
	      // float or fixed
	      show: false,
	      border: false,
	      customColors: {},
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null,
	      // Current mouse event
	      currentTarget: null,
	      // Current target of mouse event
	      ariaProps: parseAria(props),
	      // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      possibleCustomEvents: props.possibleCustomEvents || '',
	      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: "bind",
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          insecure = _this$props.insecure,
	          resizeHide = _this$props.resizeHide;
	      this.bindListener(); // Bind listener for tooltip
	
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mount = false;
	      this.clearTimer();
	      this.unbindListener();
	      this.removeScrollListener(this.state.currentTarget);
	      this.unbindWindowEvents();
	    }
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: "mouseOnToolTip",
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	
	        return this.tooltipRef.matches(':hover');
	      }
	
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: "getTargetArray",
	    value: function getTargetArray(id) {
	      var targetArray = [];
	      var selector;
	
	      if (!id) {
	        selector = '[data-tip]:not([data-for])';
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
	      } // Scan document for shadow DOM elements
	
	
	      nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
	        return element.shadowRoot;
	      }).forEach(function (element) {
	        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
	      });
	      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
	    }
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: "bindListener",
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          id = _this$props2.id,
	          globalEventOff = _this$props2.globalEventOff,
	          isCapture = _this$props2.isCapture;
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customUnbindListener(target);
	        }
	      });
	
	      if (this.isBodyMode()) {
	        this.bindBodyListener(targetArray);
	      } else {
	        targetArray.forEach(function (target) {
	          var isCaptureMode = _this3.isCapture(target);
	
	          var effect = _this3.getEffect(target);
	
	          if (_this3.isCustomEvent(target)) {
	            _this3.customBindListener(target);
	
	            return;
	          }
	
	          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	
	          if (effect === 'float') {
	            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	          }
	
	          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	        });
	      } // Global event to hide tooltip
	
	
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      } // Track removal of targetArray elements from DOM
	
	
	      this.bindRemovalTracker();
	    }
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: "unbindListener",
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _this$props3 = this.props,
	          id = _this$props3.id,
	          globalEventOff = _this$props3.globalEventOff;
	
	      if (this.isBodyMode()) {
	        this.unbindBodyListener();
	      } else {
	        var targetArray = this.getTargetArray(id);
	        targetArray.forEach(function (target) {
	          _this4.unbindBasicListener(target);
	
	          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	        });
	      }
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	    /**
	     * Invoke this before bind listener and unmount the component
	     * it is necessary to invoke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: "unbindBasicListener",
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: "getTooltipContent",
	    value: function getTooltipContent() {
	      var _this$props4 = this.props,
	          getContent = _this$props4.getContent,
	          children = _this$props4.children; // Generate tooltip content
	
	      var content;
	
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: "isEmptyTip",
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: "showTooltip",
	    value: function showTooltip(e, isGlobalCall) {
	      if (!this.tooltipRef) {
	        return;
	      }
	
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      } // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	
	
	      var _this$props5 = this.props,
	          multiline = _this$props5.multiline,
	          getContent = _this$props5.getContent;
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
	
	      var scrollHide = true;
	
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      } // Make sure the correct place is set
	
	
	      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
	      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
	      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      }
	
	      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
	
	      this.clearTimer();
	      var target = e.currentTarget;
	      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute('data-type') || self.props.type || 'dark',
	          customColors: {
	            text: target.getAttribute('data-text-color') || self.props.textColor || null,
	            background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
	            border: target.getAttribute('data-border-color') || self.props.borderColor || null,
	            arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
	          },
	          effect: effect,
	          offset: offset,
	          html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
	          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
	          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
	          border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
	          extraClass: target.getAttribute('data-class') || self.props["class"] || self.props.className || '',
	          disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) {
	            self.addScrollListener(self.state.currentTarget);
	          }
	
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	                var placeholder = getTipContent(originTooltip, '', _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      }; // If there is no delay call immediately, don't allow events to get in first.
	
	
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	    /**
	     * When mouse hover, update tool tip
	     */
	
	  }, {
	    key: "updateTooltip",
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _this$state = this.state,
	          delayShow = _this$state.delayShow,
	          disable = _this$state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	      if (this.mouseOnToolTip()) {
	        return;
	      } // if the tooltip is empty, disable the tooltip
	
	
	      if (this.isEmptyTip(placeholder) || disable) {
	        return;
	      }
	
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	
	            if (isInvisible && afterShow) {
	              afterShow(e);
	            }
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	    /*
	     * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: "listenForTooltipExit",
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	  }, {
	    key: "removeListenerForTooltipExit",
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltip",
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	        isScroll: false
	      };
	      var disable = this.state.disable;
	      var isScroll = options.isScroll;
	      var delayHide = isScroll ? 0 : this.state.delayHide;
	      var afterHide = this.props.afterHide;
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	
	          return;
	        }
	
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener(_this6.state.currentTarget);
	
	          if (isVisible && afterHide) {
	            afterHide(e);
	          }
	        });
	      };
	
	      this.clearTimer();
	
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	    /**
	     * When scroll, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltipOnScroll",
	    value: function hideTooltipOnScroll(event, hasTarget) {
	      this.hideTooltip(event, hasTarget, {
	        isScroll: true
	      });
	    }
	    /**
	     * Add scroll event listener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: "addScrollListener",
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
	    }
	  }, {
	    key: "removeScrollListener",
	    value: function removeScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
	    } // Calculation the position
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _this$state2 = this.state,
	          currentEvent = _this$state2.currentEvent,
	          currentTarget = _this$state2.currentTarget,
	          place = _this$state2.place,
	          desiredPlace = _this$state2.desiredPlace,
	          effect = _this$state2.effect,
	          offset = _this$state2.offset;
	      var node = this.tooltipRef;
	      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      }
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      } // Set tooltip position
	
	
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: "clearTimer",
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: "hasCustomColors",
	    value: function hasCustomColors() {
	      var _this8 = this;
	
	      return Boolean(Object.keys(this.state.customColors).find(function (color) {
	        return color !== 'border' && _this8.state.customColors[color];
	      }) || this.state.border && this.state.customColors['border']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      var _this$state3 = this.state,
	          extraClass = _this$state3.extraClass,
	          html = _this$state3.html,
	          ariaProps = _this$state3.ariaProps,
	          disable = _this$state3.disable;
	      var content = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(content);
	      var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
	      var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + " place-".concat(this.state.place) + // top, bottom, left, right
	      " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + ( // dark, success, warning, error, info, light, custom
	      this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
	      var Wrapper = this.props.wrapper;
	
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');
	
	      if (html) {
	        var htmlContent = "".concat(content, "\n<style>").concat(style, "</style>");
	        return React.createElement(Wrapper, _extends({
	          className: "".concat(wrapperClassName),
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this9.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          "data-id": "tooltip",
	          dangerouslySetInnerHTML: {
	            __html: htmlContent
	          }
	        }));
	      } else {
	        return React.createElement(Wrapper, _extends({
	          className: "".concat(wrapperClassName),
	          id: this.props.id
	        }, ariaProps, {
	          ref: function ref(_ref2) {
	            return _this9.tooltipRef = _ref2;
	          },
	          "data-id": "tooltip"
	        }), React.createElement("style", {
	          dangerouslySetInnerHTML: {
	            __html: style
	          }
	        }), content);
	      }
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var ariaProps = prevState.ariaProps;
	      var newAriaProps = parseAria(nextProps);
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	
	      if (!isChanged) {
	        return null;
	      }
	
	      return _objectSpread2({}, prevState, {
	        ariaProps: newAriaProps
	      });
	    }
	  }]);
	
	  return ReactTooltip;
	}(React.Component), _defineProperty(_class2, "defaultProps", {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div',
	  clickable: false
	}), _defineProperty(_class2, "supportedWrappers", ['div', 'span']), _defineProperty(_class2, "displayName", 'ReactTooltip'), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
	
	module.exports = ReactTooltip;
	//# sourceMappingURL=index.js.map


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _reactIs = __webpack_require__(165);
	
	var validateComponentProp = function validateComponentProp(props, propName, componentName) {
	  if (!(0, _reactIs.isValidElementType)(props[propName])) {
	    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`.');
	  }
	
	  return null;
	};
	
	var _default = validateComponentProp;
	exports["default"] = _default;

/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.queryArticleOptionData = exports.queryBaseArticle = undefined;
	
	var _MittwaldApi = __webpack_require__(42);
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _UserAuthentication = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// **************************************************************************************************************
	var fetchBaseArticle = function fetchBaseArticle(bearer, articleId) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.BASE_ARTICLE_REQUEST, ActionTypes.BASE_ARTICLE_SUCCESS, ActionTypes.BASE_ARTICLE_FAILURE],
	        endpoint: 'articles/' + articleId,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.BASE_ARTICLE,
	        method: 'GET',
	        payload: {
	            articleId: articleId
	        }
	    });
	};
	
	var queryBaseArticle = exports.queryBaseArticle = function queryBaseArticle(articleId) {
	    return function (dispatch, getState) {
	
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchBaseArticle(getState().token.bearer, articleId));
	        });
	    };
	};
	
	// **************************************************************************************************************
	var fetchArticleOptionData = function fetchArticleOptionData(bearer, articleId) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.ARTICLEOPTION_DATA_REQUEST, ActionTypes.ARTICLEOPTION_DATA_SUCCESS, ActionTypes.ARTICLEOPTION_DATA_FAILURE],
	        endpoint: 'articles?limit=99&articles=' + (Array.isArray(articleId) ? articleId.join(",") : articleId),
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.ARTICLE_OPTION_DATA,
	        method: 'GET',
	        payload: {
	            baseArticleId: articleId
	        }
	    });
	};
	var fetchArticleOptionDataSingle = function fetchArticleOptionDataSingle(bearer, articleId) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.ARTICLEOPTION_DATA_REQUEST, ActionTypes.ARTICLEOPTION_DATA_SUCCESS, ActionTypes.ARTICLEOPTION_DATA_FAILURE],
	        endpoint: 'articles/' + articleId,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.ARTICLE_OPTION_DATA_SINGLE,
	        method: 'GET',
	        payload: {
	            baseArticleId: articleId
	        }
	    });
	};
	
	// single id or array of ids
	var queryArticleOptionData = exports.queryArticleOptionData = function queryArticleOptionData(articleId) {
	    return function (dispatch, getState) {
	
	        if (!articleId || Array.isArray(articleId) && articleId.length === 0) {
	            return false;
	        }
	
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            if (!Array.isArray(articleId) || Array.isArray(articleId) && articleId.length === 1) {
	                return dispatch(fetchArticleOptionDataSingle(getState().token.bearer, articleId));
	            } else {
	                return dispatch(fetchArticleOptionData(getState().token.bearer, articleId));
	            }
	        });
	    };
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isHighscaleAgencyServerArticle = exports.isNonUsualArticleType = exports.isAgencyServerDevProjectArticle = exports.isAgencyServerShopArticle = exports.isAgencyServerCMSArticle = exports.isNextcloudArticle = exports.isConfigurableArticle = exports.isAgencyServer = undefined;
	
	var _Config = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isAgencyServer = exports.isAgencyServer = function isAgencyServer(articleNumber) {
	    return "" + articleNumber === _Config.agencyServerArticleNumber;
	};
	
	var isConfigurableArticle = exports.isConfigurableArticle = function isConfigurableArticle(articleNumber) {
	    if (!articleNumber) {
	        return false;
	    }
	    return [].concat(_toConsumableArray(_Config.cmsArticles), _toConsumableArray(_Config.shopArticles)).indexOf("" + articleNumber) >= 0;
	};
	
	var isNextcloudArticle = exports.isNextcloudArticle = function isNextcloudArticle(articleNumber) {
	    return "" + articleNumber === "70009";
	};
	
	var isAgencyServerCMSArticle = exports.isAgencyServerCMSArticle = function isAgencyServerCMSArticle(articleNumber) {
	    return _Config.agencyServerCMSArticles.indexOf("" + articleNumber) >= 0;
	};
	
	var isAgencyServerShopArticle = exports.isAgencyServerShopArticle = function isAgencyServerShopArticle(articleNumber) {
	    return _Config.agencyServerShopArticles.indexOf("" + articleNumber) >= 0;
	};
	
	var isAgencyServerDevProjectArticle = exports.isAgencyServerDevProjectArticle = function isAgencyServerDevProjectArticle(articleNumber) {
	    return "" + articleNumber === "72002";
	};
	
	var isNonUsualArticleType = exports.isNonUsualArticleType = function isNonUsualArticleType(articleType) {
	    return ["dsgvo", "solr", "varnish"].includes(articleType);
	};
	
	var isHighscaleAgencyServerArticle = exports.isHighscaleAgencyServerArticle = function isHighscaleAgencyServerArticle(articleNumber) {
	    return ["72117", "72118", "72119", "72225", "72226", "72227"].includes('' + articleNumber);
	};

/***/ },
/* 66 */
/***/ function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
	
		if (typeof mix === 'string' || typeof mix === 'number') {
			str += mix;
		} else if (typeof mix === 'object') {
			if (Array.isArray(mix)) {
				for (k=0; k < mix.length; k++) {
					if (mix[k]) {
						if (y = toVal(mix[k])) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else {
				for (k in mix) {
					if (mix[k]) {
						str && (str += ' ');
						str += k;
					}
				}
			}
		}
	
		return str;
	}
	
	module.exports = function () {
		var i=0, tmp, x, str='';
		while (i < arguments.length) {
			if (tmp = arguments[i++]) {
				if (x = toVal(tmp)) {
					str && (str += ' ');
					str += x
				}
			}
		}
		return str;
	}


/***/ },
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleSelectionTriggered = exports.closeCollapsibleContent = exports.openCollapsibleContent = exports.toggleCollapsibleContent = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// **************************************************************************************************************
	var toggleCollapsibleContent = exports.toggleCollapsibleContent = function toggleCollapsibleContent(toggleId) {
	    return {
	        type: ActionTypes.COLLAPSIBLE_CONTENT_TOGGLED,
	        toggleId: toggleId
	    };
	};
	var openCollapsibleContent = exports.openCollapsibleContent = function openCollapsibleContent(toggleId) {
	    return {
	        type: ActionTypes.COLLAPSIBLE_OPEN_CONTENT,
	        toggleId: toggleId
	    };
	};
	var closeCollapsibleContent = exports.closeCollapsibleContent = function closeCollapsibleContent(toggleId) {
	    return {
	        type: ActionTypes.COLLAPSIBLE_CLOSE_CONTENT,
	        toggleId: toggleId
	    };
	};
	
	var toggleSelectionTriggered = exports.toggleSelectionTriggered = function toggleSelectionTriggered(selectionId, selectedContentId) {
	    return {
	        type: ActionTypes.TOGGLE_SELECTION_TRIGGERED,
	        selectionId: selectionId,
	        selectedContentId: selectedContentId
	    };
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HintWrapper = function HintWrapper(props) {
	
	    var className = "hint-wrapper";
	
	    if (props.alignment) {
	        className += " hint-wrapper--" + props.alignment;
	    }
	
	    if (props.theme) {
	        className += " hint-wrapper--" + props.theme;
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	            'p',
	            null,
	            props.children || props.content
	        )
	    );
	};
	
	HintWrapper.propTypes = {
	    content: _propTypes2.default.string,
	    alignment: _propTypes2.default.string,
	    theme: _propTypes2.default.string
	};
	
	exports.default = HintWrapper;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLabeledStepOrder = exports.getStepLabelWording = exports.getStepOrder = exports.isExistingUserAuthenticatedAndSelected = undefined;
	
	var _reselect = __webpack_require__(31);
	
	var _StepLabels = __webpack_require__(41);
	
	var StepLabels = _interopRequireWildcard(_StepLabels);
	
	var _faCogs = __webpack_require__(298);
	
	var _faGlobe = __webpack_require__(303);
	
	var _faUser = __webpack_require__(308);
	
	var _faCreditCardFront = __webpack_require__(300);
	
	var _faClipboardListCheck = __webpack_require__(297);
	
	var _CartUtil = __webpack_require__(37);
	
	var _Mode = __webpack_require__(18);
	
	var _General = __webpack_require__(10);
	
	var _faCompressAlt = __webpack_require__(299);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Config = __webpack_require__(11);
	
	var _faBoxes = __webpack_require__(296);
	
	var _ProductSelection = __webpack_require__(48);
	
	var _ArticleNumbers = __webpack_require__(65);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isExistingUserAuthenticatedAndSelected = exports.isExistingUserAuthenticatedAndSelected = function isExistingUserAuthenticatedAndSelected(state) {
	    return state && state.clientDataStep && state.clientDataStep.existingUserAuthenticated && state.clientDataStep.existingCustomerSelected;
	};
	
	// **************************************************************************************************************
	var getStepOrder = exports.getStepOrder = (0, _reselect.createSelector)([isExistingUserAuthenticatedAndSelected, _CartUtil.getArticleOptionsInCartList, _SimpleSelectors.getToggleSelections, _ProductSelection.getCurrentProduct, _SimpleSelectors.getBaseArticle, _SimpleSelectors.getCartAllowedForCustomerChange], function (existingUserAuthenticatedAndSelected, articleOptionsInCartList, toggleSelections, currentProduct, baseArticle, isAllowedForCustomerChange) {
	
	    if ((0, _Mode.isMode)(_General.APP_MODE_PRODUCT_CHANGE)) {
	
	        if (_Config.agencyServerProjectArticles.indexOf("" + currentProduct) >= 0) {
	            return [StepLabels.PRODUCT_CHANGE, StepLabels.SUMMARY];
	        } else {
	            return [StepLabels.PRODUCT_CHANGE, StepLabels.SUMMARY];
	        }
	    } else if ((0, _Mode.isMode)(_General.APP_MODE_OUTSOURCING)) {
	
	        // always logged in
	
	        if (toggleSelections && toggleSelections["outsourcingTarget"] === _General.OUTSOURCING_CREATE_NEW) {
	            return [StepLabels.OUTSOURCING_TARGET, StepLabels.OUTSOURCING_RECOMMEND];
	        } else {
	            return [StepLabels.OUTSOURCING_TARGET, StepLabels.SUMMARY];
	        }
	    } else if ((0, _Mode.isMode)(_General.APP_MODE_AGENCYSERVER_ADD_PROJECT)) {
	
	        // always logged in
	
	        if (articleOptionsInCartList.indexOf("696969") >= 0) {
	
	            // hide domains when dev account selected
	
	            return [StepLabels.CONFIG, StepLabels.SUMMARY];
	        } else {
	
	            return [StepLabels.CONFIG, StepLabels.DOMAIN, StepLabels.SUMMARY];
	        }
	    } else if ((0, _Mode.isMode)(_General.APP_MODE_ACCESSORY)) {
	
	        return [StepLabels.SUMMARY];
	    } else {
	
	        var stepConfig = void 0;
	
	        if ((0, _Mode.isMode)(_General.APP_MODE_AUTHENTICATED_ORDER)) {
	            stepConfig = [StepLabels.PRODUCT_SELECTION];
	        } else {
	            stepConfig = [];
	        }
	
	        var includeDomainStep = true;
	        var includeConfigStep = true;
	
	        if (baseArticle && baseArticle.articleNumber + '' === _Config.agencyServerArticleNumber && toggleSelections && toggleSelections["projectConfiguration"] === _General.PROJECT_TYPE_SKIP) {
	            // skip domain step if project is skipped
	            includeDomainStep = false;
	        }
	
	        if (baseArticle && (0, _ArticleNumbers.isNonUsualArticleType)(baseArticle.type)) {
	            includeDomainStep = false;
	            includeConfigStep = false;
	        }
	
	        if (isAllowedForCustomerChange) {
	            includeDomainStep = false;
	        }
	
	        if (includeConfigStep) {
	            stepConfig.push(StepLabels.CONFIG);
	        }
	
	        if (includeDomainStep) {
	            stepConfig.push(StepLabels.DOMAIN);
	        }
	
	        if (!(0, _Mode.isMode)(_General.APP_MODE_AUTHENTICATED_ORDER)) {
	            stepConfig.push(StepLabels.CLIENTDATA);
	        }
	
	        if (!existingUserAuthenticatedAndSelected) {
	            stepConfig.push(StepLabels.PAYMENT);
	        }
	
	        stepConfig.push(StepLabels.SUMMARY);
	
	        return stepConfig;
	    }
	});
	
	// **************************************************************************************************************
	var getStepLabelWording = exports.getStepLabelWording = function getStepLabelWording() {
	    var _ref;
	
	    return _ref = {}, _defineProperty(_ref, StepLabels.PRODUCT_CHANGE, { title: "Tarifauswahl", icon: _faBoxes.faBoxes }), _defineProperty(_ref, StepLabels.PRODUCT_SELECTION, { title: "Tarifauswahl", icon: _faBoxes.faBoxes }), _defineProperty(_ref, StepLabels.OUTSOURCING_TARGET, { title: "Ziel", icon: _faCompressAlt.faCompressAlt }), _defineProperty(_ref, StepLabels.OUTSOURCING_CONFIG, { title: "Konfiguration", icon: _faCogs.faCogs }), _defineProperty(_ref, StepLabels.OUTSOURCING_AGENCY, { title: "Konfiguration", icon: _faCogs.faCogs }), _defineProperty(_ref, StepLabels.OUTSOURCING_RECOMMEND, { title: "Bestellübersicht", icon: _faClipboardListCheck.faClipboardListCheck }), _defineProperty(_ref, StepLabels.CONFIG, { title: "Konfiguration", icon: _faCogs.faCogs }), _defineProperty(_ref, StepLabels.DOMAIN, { title: "Domainauswahl", icon: _faGlobe.faGlobe }), _defineProperty(_ref, StepLabels.CLIENTDATA, { title: "Vertragspartner", icon: _faUser.faUser }), _defineProperty(_ref, StepLabels.PAYMENT, { title: "Zahlungsart", icon: _faCreditCardFront.faCreditCardFront }), _defineProperty(_ref, StepLabels.SUMMARY, { title: "Bestellübersicht", icon: _faClipboardListCheck.faClipboardListCheck }), _defineProperty(_ref, StepLabels.ACCESSORY_ADD, { title: "Bestellübersicht", icon: _faClipboardListCheck.faClipboardListCheck }), _ref;
	};
	
	var getLabeledStepOrder = exports.getLabeledStepOrder = (0, _reselect.createSelector)([getStepOrder], function (order) {
	    var mapStepsToLabel = {};
	
	    order.forEach(function (stepOrderEntry) {
	        mapStepsToLabel[stepOrderEntry] = getStepLabelWording()[stepOrderEntry];
	    });
	
	    return mapStepsToLabel;
	});

/***/ },
/* 71 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(86);
	var createDesc = __webpack_require__(87);
	var toIObject = __webpack_require__(34);
	var toPrimitive = __webpack_require__(75);
	var has = __webpack_require__(56);
	var IE8_DOM_DEFINE = __webpack_require__(188);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(193);
	var enumBugKeys = __webpack_require__(141);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var hide = __webpack_require__(57);
	var has = __webpack_require__(56);
	var SRC = __webpack_require__(89)('src');
	var $toString = __webpack_require__(349);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(32).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(21);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(110),
	    getRawTag = __webpack_require__(502),
	    objectToString = __webpack_require__(530);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.validateCommissionForm = exports.validateSimpleSummaryForm = exports.validatePhoneForm = exports.validateAlternateSepa = exports.validateSepa = exports.validateTradePartnerSimpleForm = exports.validateTradePartner = exports.validateTechnicalContact = exports.validateBillingAddress = exports.getCorrectPhoneFormat = undefined;
	
	var _iban = __webpack_require__(431);
	
	var IBAN = _interopRequireWildcard(_iban);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var regexFull = /^(\+|[0]{2})([0-9]{2,3})[\- \/\\]([0-9]{2,5})[\- \/\\]([0-9- ]+)/;
	var regexTrimmed = /^[0]{0,1}([1-9]{1}[0-9]{1,4})[\- \/\\]([0-9- ]+)/;
	var regexNoSeperator = /[\- \/\\]/;
	
	var validatePhone = function validatePhone(phone) {
	
	    if (!phone) {
	        //return "Bitte geben Sie eine Telefonnummer an."
	        return " ";
	    }
	
	    if (regexFull.test(phone)) {} else if (regexTrimmed.test(phone)) {} else if (!regexNoSeperator.test(phone)) {
	
	        return "Vorwahl und Rufnummer mit Leertaste oder Trennzeichen eingeben.";
	    } else {
	
	        return "Bitte geben Sie eine Telefonnummer im Format 0160 1456789 an.";
	    }
	
	    return null;
	};
	
	var getCorrectPhoneFormat = exports.getCorrectPhoneFormat = function getCorrectPhoneFormat(phone) {
	
	    if (regexFull.test(phone)) {
	
	        var exec = regexFull.exec(phone);
	
	        return "+" + exec[2] + "-" + exec[3] + "-" + String(exec[4]).split(/[- ]/).join('');
	    } else if (regexTrimmed.test(phone)) {
	
	        var _exec = regexTrimmed.exec(phone);
	
	        return "+49-" + _exec[1] + "-" + String(_exec[2]).split(/[- ]/).join('');
	    }
	};
	
	var validateAddress = function validateAddress(values) {
	    var useSpecialPhone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	
	    var errors = {};
	
	    if (!values.salutation && values.salutation !== '') {
	        //errors.salutation = "Bitte wählen Sie eine Anrede."
	        errors.salutation = " ";
	    }
	
	    if (!values.firstName) {
	        //errors.firstName = "Bitte geben Sie einen Vornamen an."
	        errors.firstName = " ";
	    } else if (values.firstName && values.firstName.length < 2) {
	        errors.firstName = "Bitte gib einen gültigen Vornamen an.";
	    }
	
	    if (!values.lastName) {
	        //errors.lastName = "Bitte geben Sie einen Nachnamen an."
	        errors.lastName = " ";
	    } else if (values.lastName && values.lastName.length < 2) {
	        errors.lastName = "Bitte gib einen gültigen Nachnamen an.";
	    }
	
	    var emailRegEx = /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
	
	    if (!values.emailAddress) {
	        //errors.emailAddress = "Bitte geben Sie eine E-Mail-Adresse an."
	        errors.emailAddress = " ";
	    } else if (!emailRegEx.test(values.emailAddress)) {
	        errors.emailAddress = "Bitte gib eine gültige E-Mail-Adresse an.";
	    }
	
	    var phoneValidationError = validatePhone(values.phone);
	
	    if (useSpecialPhone) {
	
	        if (phoneValidationError) {
	            errors.phone = phoneValidationError;
	        }
	    } else {
	
	        if (!values.phone) {
	            //errors.phone = " "
	        } else if (phoneValidationError) {
	            errors.phone = phoneValidationError;
	        }
	    }
	
	    if (!values.street) {
	        //errors.street = "Bitte geben Sie einen Straßennamen an."
	        errors.street = " ";
	    } else if (values.street && values.street.length < 2) {
	        errors.street = "Bitte gib einen gültigen Straßennamen an.";
	    }
	
	    if (!values.houseNumber) {
	        //errors.houseNumber = "Bitte geben Sie eine Hausnummer an."
	        errors.houseNumber = " ";
	    } else if (values.houseNumber && values.houseNumber.match(/^0*$/g)) {
	        errors.houseNumber = "Bitte gib eine gültige Hausnummer an.";
	    }
	
	    if (!values.zip) {
	        //errors.zip = "Bitte geben Sie eine Postleitzahl an."
	        errors.zip = " ";
	    } else if (values.zip && values.zip.match(/^0*$/g)) {
	        errors.zip = "Bitte gib eine gültige Postleitzahl an.";
	    } else if (values.zip && values.zip.length < 4) {
	        errors.zip = "Bitte gib eine gültige Postleitzahl an.";
	    }
	
	    if (!values.city) {
	        //errors.city = "Bitte geben Sie einen Ortsnamen an."
	        errors.city = " ";
	    } else if (values.city && values.city.length < 3) {
	        errors.city = "Bitte gib einen gültigen Ortsnamen an.";
	    }
	
	    if (!values.country) {
	        errors.country = "Bitte wähle ein Land.";
	    }
	
	    /*if(values.recommendedAccount !== "21") {
	     if(!values.company) {
	     errors.company = "Bitte geben Sie einen Firmennamen an."
	     }
	     }*/
	
	    return errors;
	};
	
	var validateBillingAddress = exports.validateBillingAddress = function validateBillingAddress(values) {
	
	    var errors = validateAddress(values);
	
	    /*if (!values.company) {
	        errors.company = "Bitte geben Sie einen Firmennamen an."
	    }*/
	    return errors;
	};
	
	var validateTechnicalContact = exports.validateTechnicalContact = function validateTechnicalContact(values) {
	
	    var errors = validateBillingAddress(values);
	
	    return errors;
	};
	
	var validateTradePartner = exports.validateTradePartner = function validateTradePartner(values) {
	
	    var errors = validateAddress(values);
	
	    /*if(!values.recommendedAccount) {
	     errors.recommendedAccount = "Bitte geben Sie einen Kundentyp an."
	     }*/
	    return errors;
	};
	
	var validateTradePartnerSimpleForm = exports.validateTradePartnerSimpleForm = function validateTradePartnerSimpleForm(values, props) {
	
	    var errors = validateAddress(values, false);
	
	    if (!values.company) {
	        errors.company = "Bitte gib einen Firmennamen an.";
	    }
	
	    if (props.optionals.indexOf('phone') === -1) {
	        if (!values.phone) {
	            errors.phone = "Bitte gib eine Telefonnummer an.";
	        } else {
	            var phoneValidationError = validatePhone(values.phone);
	            if (phoneValidationError) {
	                errors.phone = phoneValidationError;
	            }
	        }
	    }
	
	    return errors;
	};
	
	var validateSepa = exports.validateSepa = function validateSepa(values) {
	
	    var errors = {};
	
	    var bicRegEx = /^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;
	
	    if (!values.iban) {
	        errors.iban = "Bitte gib eine IBAN an.";
	    } else if (!IBAN.isValid(values.iban)) {
	        errors.iban = "Bitte gib eine gültige IBAN an.";
	    }
	
	    if (!values.bic) {
	        errors.bic = "Bitte gib eine BIC an.";
	    } else if (!bicRegEx.test(values.bic)) {
	        errors.bic = "Bitte gib eine gültige BIC an.";
	    }
	
	    if (!values.accountHolder) {
	        errors.accountHolder = "Bitte gib einen Kontoinhaber an.";
	    } else if (values.accountHolder.length < 2) {
	        errors.accountHolder = "Bitte gib einen gültigen Kontoinhaber an.";
	    }
	
	    return errors;
	};
	
	var validateAlternateSepa = exports.validateAlternateSepa = function validateAlternateSepa(values) {
	
	    var errors = {};
	
	    if (!values.accountHolder) {
	        errors.accountHolder = "Bitte gib einen Kontoinhaber an.";
	    } else if (values.accountHolder.length < 2) {
	        errors.accountHolder = "Bitte gib einen gültigen Kontoinhaber an.";
	    }
	
	    if (!values.accountNumber) {
	        errors.accountNumber = "Bitte gib deine Kontonummer an.";
	    }
	
	    if (!values.bankAddress) {
	        errors.bankAddress = "Bitte gib die Bankleitzahl deiner Bank an.";
	    }
	
	    return errors;
	};
	
	var validatePhoneForm = exports.validatePhoneForm = function validatePhoneForm(values) {
	    var errors = {};
	    return errors;
	};
	
	var validateSimpleSummaryForm = exports.validateSimpleSummaryForm = function validateSimpleSummaryForm(values, props) {
	    var errors = {};
	
	    if (!values.price && !(props && props.articlePrice === 0)) {
	        errors.price = " ";
	    }
	
	    return errors;
	};
	
	var validateCommissionForm = exports.validateCommissionForm = function validateCommissionForm(values) {
	    var errors = {};
	
	    if (values && values.commission && ('' + values.commission).length !== 6) {
	        errors.commission = 'Die Betreuer-ID besteht aus 6 Zeichen. Bitte gib eine 6-stellige Betreuer-ID an.';
	    }
	
	    return errors;
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__(590);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__(260);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ },
/* 80 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.appInitialized = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// **************************************************************************************************************
	var appInitialized = exports.appInitialized = function appInitialized(initParams) {
	    return {
	
	        type: ActionTypes.APP_INITIALIZED,
	        payload: initParams
	
	    };
	};

/***/ },
/* 82 */,
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(49);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(71);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 86 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(52);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 89 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(120);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(119),
	    isLength = __webpack_require__(161);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 93 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var formatName = function formatName(_ref, name) {
	  var sectionPrefix = _ref._reduxForm.sectionPrefix;
	  return sectionPrefix ? sectionPrefix + "." + name : name;
	};
	
	var _default = formatName;
	exports["default"] = _default;

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD = exports.LOAD = 'REDUX_STORAGE_LOAD';
	var SAVE = exports.SAVE = 'REDUX_STORAGE_SAVE';

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(679));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
	  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
	  }
	
	  if (enumerableOnly) keys = keys.filter(function (sym) {
	    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	  });
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread2({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.selectDomainTypeIfNoDomainsInCart = exports.toggleHideDomainsGone = exports.queryMoreDomains = exports.queryInitialDomains = exports.beginDomainCheck = exports.domainInputChange = exports.queryDomainCheck = exports.queryTopLevelDomains = undefined;
	
	var _MittwaldApi = __webpack_require__(42);
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(11);
	
	var Config = _interopRequireWildcard(_Config);
	
	var _UserAuthentication = __webpack_require__(24);
	
	var _CartUtil = __webpack_require__(37);
	
	var _Util = __webpack_require__(68);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// **************************************************************************************************************
	var fetchTopLevelDomains = function fetchTopLevelDomains(bearer) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.TOPLEVELDOMAINS_REQUEST, ActionTypes.TOPLEVELDOMAINS_SUCCESS, ActionTypes.TOPLEVELDOMAINS_FAILURE],
	        endpoint: 'topleveldomains',
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.TOPLEVELDOMAINS,
	        method: 'GET'
	    });
	};
	
	var queryTopLevelDomains = exports.queryTopLevelDomains = function queryTopLevelDomains() {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchTopLevelDomains(getState().token.bearer));
	        });
	    };
	};
	
	var fetchDomainCheck = function fetchDomainCheck(bearer, domainName, domainEnding) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.DOMAIN_CHECK_REQUEST, ActionTypes.DOMAIN_CHECK_SUCCESS, ActionTypes.DOMAIN_CHECK_FAILURE],
	        endpoint: 'domains/' + domainName + '.' + domainEnding + '/actions/check',
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.STATUSCODE,
	        method: 'POST',
	        payload: {
	            domainName: domainName,
	            domainEnding: domainEnding
	        }
	    });
	};
	
	var queryDomainCheck = exports.queryDomainCheck = function queryDomainCheck(domainName, domainEnding) {
	    return function (dispatch, getState) {
	        return dispatch((0, _UserAuthentication.queryBearerToken)()).then(function () {
	            return dispatch(fetchDomainCheck(getState().token.bearer, domainName, domainEnding));
	        });
	    };
	};
	
	var domainInputChange = exports.domainInputChange = function domainInputChange(value) {
	    return {
	        type: ActionTypes.DOMAIN_INPUT_CHANGE,
	        value: value
	    };
	};
	
	var beginDomainCheck = exports.beginDomainCheck = function beginDomainCheck() {
	    return function (dispatch, getState) {
	        return dispatch({ type: ActionTypes.DOMAIN_CHECK_BEGIN });
	    };
	};
	
	var queryInitialDomains = exports.queryInitialDomains = function queryInitialDomains() {
	    return function (dispatch, getState) {
	
	        // fetch initial 10 top domains and further domains
	        var queriedDomain = getState().domainCheck.queriedDomain;
	        var queriedDomainEnding = getState().domainCheck.queriedDomainEnding;
	        var furtherDomainLimit = getState().domainCheck.furtherDomainLimit;
	        var domainOrder = getState().domainCheck.topLevelDomains.order;
	        var domainData = getState().domainCheck.topLevelDomains.data;
	
	        var domainsToCheck = [];
	        var topDomainsToAdd = Config.DOMAIN_AMOUNT_TOPDOMAINS;
	
	        if (queriedDomainEnding !== "" && domainData[queriedDomainEnding]) {
	            domainsToCheck.push(queriedDomainEnding);
	            topDomainsToAdd--;
	        }
	
	        for (var i = 0; i < topDomainsToAdd + furtherDomainLimit; i++) {
	            if (domainOrder[i] === queriedDomainEnding) {
	                topDomainsToAdd++;
	            } else {
	                domainsToCheck.push(domainOrder[i]);
	            }
	        }
	
	        // perform loading calls for the top domains
	        domainsToCheck.forEach(function (domainEnding) {
	            dispatch(queryDomainCheck(queriedDomain, domainEnding));
	        });
	    };
	};
	
	var loadMoreDomains = function loadMoreDomains() {
	    return {
	        type: ActionTypes.DOMAIN_LOAD_MORE
	    };
	};
	
	var queryMoreDomains = exports.queryMoreDomains = function queryMoreDomains() {
	    return function (dispatch, getState) {
	
	        // store old limit before dispatching load more action
	        var oldLimit = getState().domainCheck.furtherDomainLimit;
	
	        dispatch(loadMoreDomains());
	
	        var newLimit = getState().domainCheck.furtherDomainLimit;
	        var queriedDomain = getState().domainCheck.queriedDomain;
	        var queriedDomainEnding = getState().domainCheck.queriedDomainEnding;
	        var domainOrder = getState().domainCheck.topLevelDomains.order;
	
	        var domainsToCheck = [];
	        var offset = 0;
	        var topDomainsAdded = Config.DOMAIN_AMOUNT_TOPDOMAINS;
	        var queriedDomainOffset = queriedDomainEnding === '' ? 0 : 1;
	
	        for (var i = 0; i < topDomainsAdded + newLimit - queriedDomainOffset; i++) {
	
	            // find index to skip (queriedDomainEnding in front, not reflected in order)
	            if (queriedDomainOffset && !offset && domainOrder[i] === queriedDomainEnding) {
	                offset = 1;
	            }
	
	            if (i + queriedDomainOffset >= topDomainsAdded + oldLimit) {
	                domainsToCheck.push(domainOrder[i + offset]);
	            }
	        }
	
	        // perform loading calls for the bottom domains
	        domainsToCheck.forEach(function (domainEnding) {
	            dispatch(queryDomainCheck(queriedDomain, domainEnding));
	        });
	    };
	};
	
	var toggleHideDomainsGone = exports.toggleHideDomainsGone = function toggleHideDomainsGone() {
	    return function (dispatch, getState) {
	        dispatch({
	            type: ActionTypes.DOMAIN_HIDE_GONE
	        });
	    };
	};
	
	var selectDomainTypeIfNoDomainsInCart = exports.selectDomainTypeIfNoDomainsInCart = function selectDomainTypeIfNoDomainsInCart(domainType) {
	    return function (dispatch, getState) {
	        var domainsInCartList = (0, _CartUtil.getDomainInCartList)(getState());
	        if (domainsInCartList.length === 0) {
	            dispatch((0, _Util.toggleSelectionTriggered)('domainType', domainType));
	        }
	    };
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(12);
	
	var _clsx = __webpack_require__(66);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _faEye = __webpack_require__(301);
	
	var _faEyeSlash = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderField = function renderField(_ref) {
	    var noValidation = _ref.noValidation,
	        label = _ref.label,
	        onKeyDown = _ref.onKeyDown,
	        disabled = _ref.disabled,
	        input = _ref.input,
	        fieldId = _ref.fieldId,
	        placeholder = _ref.placeholder,
	        isOptional = _ref.isOptional,
	        autocomplete = _ref.autocomplete,
	        forceValidation = _ref.forceValidation,
	        type = _ref.type,
	        togglePasswordCallback = _ref.togglePasswordCallback,
	        showPassword = _ref.showPassword,
	        hint = _ref.hint,
	        _ref$meta = _ref.meta,
	        touched = _ref$meta.touched,
	        active = _ref$meta.active,
	        visited = _ref$meta.visited,
	        error = _ref$meta.error,
	        warning = _ref$meta.warning;
	
	
	    var showValidationResult = !noValidation && (touched || forceValidation);
	
	    var showPasswordButton = null;
	    if (togglePasswordCallback) {
	        showPasswordButton = _react2.default.createElement(
	            'a',
	            { className: 'labeled-input__show-password', onClick: function onClick(e) {
	                    togglePasswordCallback();
	                } },
	            showPassword ? _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { fixedWidth: true, icon: _faEyeSlash.faEyeSlash }) : _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { fixedWidth: true, icon: _faEye.faEye })
	        );
	    }
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _clsx2.default)('labeled-input', active && 'labeled-input--focus', showValidationResult && error && 'labeled-input--error', showValidationResult && !error && 'labeled-input--valid') },
	        _react2.default.createElement(
	            'label',
	            { htmlFor: fieldId },
	            label,
	            ' ',
	            label && isOptional ? _react2.default.createElement(
	                'span',
	                null,
	                "(optional)"
	            ) : ''
	        ),
	        showPasswordButton,
	        _react2.default.createElement('input', _extends({ onKeyDown: onKeyDown ? onKeyDown : null, disabled: disabled, placeholder: placeholder }, input, { autoComplete: autocomplete, type: type })),
	        (hint || showValidationResult) && _react2.default.createElement(
	            'div',
	            { className: 'hint' },
	            (touched || forceValidation && error) && error ? error : hint
	        )
	    );
	};
	
	function LabeledInput(props) {
	    return _react2.default.createElement(_reduxForm.Field, { onKeyDown: props.onKeyDown, name: props.fieldId, forceValidation: props.forceValidation, component: renderField, props: props });
	}
	
	LabeledInput.propTypes = {
	    fieldId: _propTypes2.default.string.isRequired,
	    placeholder: _propTypes2.default.string,
	    label: _propTypes2.default.string.isRequired,
	    isOptional: _propTypes2.default.bool,
	    hint: _propTypes2.default.string,
	    forceValidation: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    type: _propTypes2.default.string,
	    onKeyDown: _propTypes2.default.func
	};
	
	LabeledInput.defaultProps = {
	    forceValidation: false,
	    type: "text"
	};
	
	exports.default = LabeledInput;

/***/ },
/* 98 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'check';
	var width = 448;
	var height = 512;
	var ligatures = [];
	var unicode = 'f00c';
	var svgPathData = 'M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faCheck = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 99 */,
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(385);
	var redefine = __webpack_require__(74);
	var hide = __webpack_require__(57);
	var fails = __webpack_require__(13);
	var defined = __webpack_require__(51);
	var wks = __webpack_require__(16);
	var regexpExec = __webpack_require__(146);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(71);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(89)('meta');
	var isObject = __webpack_require__(21);
	var has = __webpack_require__(56);
	var setDesc = __webpack_require__(33).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(13)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(85) || !__webpack_require__(13)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(29)[K];
	});


/***/ },
/* 105 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(56);
	var toObject = __webpack_require__(15);
	var IE_PROTO = __webpack_require__(148)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(139);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(32);
	var global = __webpack_require__(29);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(85) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(515),
	    listCacheDelete = __webpack_require__(516),
	    listCacheGet = __webpack_require__(517),
	    listCacheHas = __webpack_require__(518),
	    listCacheSet = __webpack_require__(519);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(44);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(91);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(238);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(473),
	    isObjectLike = __webpack_require__(60);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(513);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 115 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(59);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(472),
	    isObjectLike = __webpack_require__(60);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(44),
	    stubFalse = __webpack_require__(553);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(77),
	    isObject = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(77),
	    isObjectLike = __webpack_require__(60);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(476),
	    baseUnary = __webpack_require__(489),
	    nodeUtil = __webpack_require__(529);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(231),
	    copyArray = __webpack_require__(237),
	    isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(120),
	    stringToPath = __webpack_require__(247),
	    toKey = __webpack_require__(90),
	    toString = __webpack_require__(252);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 123 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isImmutable = isImmutable;
	exports.denormalizeImmutable = denormalizeImmutable;
	/**
	 * Helpers to enable Immutable compatibility *without* bringing in
	 * the 'immutable' package as a dependency.
	 */
	
	/**
	 * Check if an object is immutable by checking if it has a key specific
	 * to the immutable library.
	 *
	 * @param  {any} object
	 * @return {bool}
	 */
	function isImmutable(object) {
	  return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
	  object._map && object._map.hasOwnProperty('__ownerID') // Immutable.Record
	  ));
	}
	
	/**
	 * Denormalize an immutable entity.
	 *
	 * @param  {Schema} schema
	 * @param  {Immutable.Map|Immutable.Record} input
	 * @param  {function} unvisit
	 * @param  {function} getDenormalizedEntity
	 * @return {Immutable.Map|Immutable.Record}
	 */
	function denormalizeImmutable(schema, input, unvisit) {
	  return Object.keys(schema).reduce(function (object, key) {
	    // Immutable maps cast keys to strings on write so we need to ensure
	    // we're accessing them using string keys.
	    var stringKey = '' + key;
	
	    if (object.has(stringKey)) {
	      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
	    } else {
	      return object;
	    }
	  }, input);
	}

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setInitialConfigurationByState = exports.queryAddInitialProject = exports.queryProjectRemove = exports.queryProjectSelection = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Cart = __webpack_require__(28);
	
	var _Properties = __webpack_require__(45);
	
	var _ProjectSelection = __webpack_require__(127);
	
	var _Forms = __webpack_require__(38);
	
	var _reduxForm = __webpack_require__(12);
	
	var _General = __webpack_require__(10);
	
	var _util = __webpack_require__(9);
	
	var _Config = __webpack_require__(11);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _ProductSelection = __webpack_require__(48);
	
	var _Mode = __webpack_require__(18);
	
	var _BaseArticle = __webpack_require__(54);
	
	var _ActionTypes = __webpack_require__(5);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var queryProjectSelection = exports.queryProjectSelection = function queryProjectSelection(values) {
	    return function (dispatch, getState) {
	
	        // loop projectSelection form state and add items to cart
	        return new Promise(function (resolve, reject) {
	            var calls = [];
	
	            if (values && values.article) {
	                calls.push((0, _Cart.addItemToCart)(values.article));
	            }
	
	            if (values && values.storage) {
	                calls.push((0, _Cart.addItemToCart)(values.storage));
	            }
	
	            if (values && values.backup) {
	                calls.push((0, _Properties.querySelectCartProperty)("backupRange", values.backup));
	            }
	
	            var dispatchFirstCall = function dispatchFirstCall(calls) {
	                dispatch(calls.shift()).then(function (args) {
	                    if (calls.length > 0) {
	                        dispatchFirstCall(calls);
	                    } else {
	                        resolve(true);
	                    }
	                });
	            };
	            dispatchFirstCall(calls);
	        });
	    };
	};
	
	var queryProjectRemove = exports.queryProjectRemove = function queryProjectRemove() {
	    return function (dispatch, getState) {
	        return new Promise(function (resolve, reject) {
	            var calls = [];
	
	            // 1: remove any articles matching agencyServerProjectArticles
	            // 3: remove any article in cart being a storage option
	            var articlesToRemove = (0, _ProjectSelection.getAgencyServerProjectArticlesInCart)(getState());
	
	            articlesToRemove.forEach(function (cartItem) {
	                calls.push((0, _Cart.removeItemFromCart)(cartItem.itemId));
	            });
	
	            // 2: set backuprange on cart to false
	            calls.push((0, _Properties.querySelectCartProperty)("backupRange", ""));
	
	            var dispatchFirstCall = function dispatchFirstCall(calls) {
	
	                if (calls.length === 0) {
	                    resolve(true);
	                } else {
	                    dispatch(calls.shift()).then(function (args) {
	                        dispatchFirstCall(calls);
	                    });
	                }
	            };
	            dispatchFirstCall(calls);
	        });
	    };
	};
	
	var queryAddInitialProject = exports.queryAddInitialProject = function queryAddInitialProject() {
	    var selectBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return function (dispatch, getState) {
	        dispatch({
	            type: _ActionTypes.CART_QUERYPROJECT_START
	        });
	        return dispatch(queryProjectRemove()).then(function (args) {
	            var form = (0, _Forms.getProjectSelectionForm)(getState());
	            if (selectBase && form && form.values && form.values.article) {
	                dispatch((0, _BaseArticle.selectBaseArticle)(form.values.article));
	            }
	            return dispatch(queryProjectSelection(form.values)).then(function () {
	                return dispatch({
	                    type: _ActionTypes.CART_QUERYPROJECT_COMPLETE
	                });
	            });
	        });
	    };
	};
	
	var findMinimumRequirementArticle = function findMinimumRequirementArticle(currentProduct, possibleArticles, articleOptionsState) {
	    return possibleArticles.find(function (articleId) {
	        return parseInt((0, _util.delve)(articleOptionsState, articleId + ".limits.visitors")) >= (0, _util.delve)(articleOptionsState, currentProduct + ".limits.visitors");
	    }) || possibleArticles[1];
	};
	
	var setInitialConfigurationByState = exports.setInitialConfigurationByState = function setInitialConfigurationByState(target) {
	    return function (dispatch, getState) {
	
	        var accounts = (0, _SimpleSelectors.getAccounts)(getState());
	        var selectedAccount = (0, _ProductSelection.getSelectedAccount)(getState());
	        var currentProduct = (0, _ProductSelection.getCurrentProduct)(getState());
	        var form = (0, _Forms.getProjectSelectionForm)(getState());
	        var projectSettings = form ? {
	            projectName: form.values && form.values.projectName,
	            projectPassword: form.values && form.values.projectPassword,
	            projectPasswordRepeat: form.values && form.values.projectPasswordRepeat
	        } : {};
	        var mode = (0, _Mode.getAppMode)();
	
	        switch (mode) {
	            case _General.APP_MODE_OUTSOURCING:
	                if (target === _General.OUTSOURCING_CREATE_NEW) {
	                    dispatch((0, _reduxForm.initialize)('projectSelection', {
	                        article: [].concat(_toConsumableArray(_Config.cmsArticles), _toConsumableArray(_Config.shopArticles)).includes("" + currentProduct) ? currentProduct : findMinimumRequirementArticle(currentProduct, _Config.cmsArticles, (0, _SimpleSelectors.getArticleOptionsData)(getState())),
	                        storage: "",
	                        state: _General.PROJECT_STATE_LIVE,
	                        backup: (0, _util.delve)(accounts, selectedAccount + ".backupRange") || 7,
	                        type: _Config.cmsArticles.includes("" + currentProduct) ? _General.ARTICLE_TYPE_CMS : _Config.shopArticles.includes("" + currentProduct) ? _General.ARTICLE_TYPE_SHOP : _General.ARTICLE_TYPE_CMS
	                    }, false));
	                } else if (target === _General.OUTSOURCING_ADDPROJECT) {
	                    dispatch((0, _reduxForm.initialize)('projectSelection', {
	                        article: [].concat(_toConsumableArray(_Config.agencyServerCMSArticles), _toConsumableArray(_Config.agencyServerShopArticles)).includes("" + currentProduct) ? currentProduct : findMinimumRequirementArticle(currentProduct, _Config.agencyServerCMSArticles, (0, _SimpleSelectors.getArticleOptionsData)(getState())),
	                        storage: "",
	                        state: _General.PROJECT_STATE_LIVE,
	                        backup: (0, _util.delve)(accounts, selectedAccount + ".backupRange") || 7,
	                        type: _Config.agencyServerCMSArticles.includes("" + currentProduct) ? _General.ARTICLE_TYPE_CMS : _Config.agencyServerShopArticles.includes("" + currentProduct) ? _General.ARTICLE_TYPE_SHOP : _General.ARTICLE_TYPE_CMS
	                    }, false));
	                }
	
	                break;
	
	            case _General.APP_MODE_AUTHENTICATED_ORDER:
	
	                if (target === _General.PRODUCT_SELECTION_AGENCY) {
	                    dispatch((0, _reduxForm.initialize)('projectSelection', _extends({
	                        article: _Config.agencyServerCMSArticles[1],
	                        storage: "",
	                        state: _General.PROJECT_STATE_LIVE,
	                        backup: 7,
	                        type: _General.ARTICLE_TYPE_CMS
	                    }, projectSettings), false));
	                } else if (target === _General.PRODUCT_SELECTION_CONSUMER) {
	                    dispatch((0, _reduxForm.initialize)('projectSelection', _extends({
	                        article: _Config.cmsArticles[1],
	                        storage: "",
	                        state: _General.PROJECT_STATE_LIVE,
	                        backup: 7,
	                        type: _General.ARTICLE_TYPE_CMS
	                    }, projectSettings), false));
	                }
	
	                break;
	
	            default:
	                dispatch((0, _reduxForm.initialize)('projectSelection', _extends({
	                    article: _Config.agencyServerCMSArticles[1],
	                    storage: "",
	                    state: _General.PROJECT_STATE_LIVE,
	                    backup: (0, _util.delve)(accounts, selectedAccount + ".backupRange") || 7,
	                    type: _General.ARTICLE_TYPE_CMS
	                }, projectSettings), false));
	                break;
	        }
	
	        //return dispatch(reset('projectSelection'));
	    };
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAccountExtraStorage = exports.getAccountStorageLimit = exports.getAccountBackupRange = exports.getAccountStorageUsage = exports.getAccountProjectSpace = exports.getCurrentAccountByContract = undefined;
	
	var _reselect = __webpack_require__(31);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _util = __webpack_require__(9);
	
	var _GetParam = __webpack_require__(17);
	
	var getCurrentAccountByContract = exports.getCurrentAccountByContract = (0, _reselect.createSelector)([_SimpleSelectors.getContracts], function (contracts) {
	    return (0, _util.delve)(contracts, _GetParam._contract + ".sourceUid") || _GetParam._account;
	});
	
	var getAccountProjectSpace = exports.getAccountProjectSpace = (0, _reselect.createSelector)([_SimpleSelectors.getAccounts, getCurrentAccountByContract, _SimpleSelectors.getArticleOptionsData], function (accounts, currentAccount, articleOptionsData) {
	    if (!accounts || !currentAccount || !articleOptionsData) {
	        return 0;
	    }
	    if (!accounts[currentAccount] || !accounts[currentAccount].article) {
	        return 0;
	    }
	    return Number((0, _util.delve)(articleOptionsData, accounts[currentAccount].article.articleNumber + ".projectSpace") || 0) / 1024 / 1024;
	});
	
	var getAccountStorageUsage = exports.getAccountStorageUsage = (0, _reselect.createSelector)([_SimpleSelectors.getAccounts, getCurrentAccountByContract], function (accounts, currentAccount) {
	    if (!accounts || !currentAccount) {
	        return 0;
	    }
	    return Number((0, _util.delve)(accounts, currentAccount + ".stats.summary") || 0) / 1024 / 1024;
	});
	var getAccountBackupRange = exports.getAccountBackupRange = (0, _reselect.createSelector)([_SimpleSelectors.getAccounts, getCurrentAccountByContract], function (accounts, currentAccount) {
	    if (!accounts || !currentAccount) {
	        return 0;
	    }
	    return Number((0, _util.delve)(accounts, currentAccount + ".backupRange") || 7);
	});
	
	var getAccountStorageLimit = exports.getAccountStorageLimit = (0, _reselect.createSelector)([_SimpleSelectors.getAccounts, getCurrentAccountByContract], function (accounts, currentAccount) {
	    if (!accounts || !currentAccount) {
	        return 0;
	    }
	    return Number(((0, _util.delve)(accounts, currentAccount + ".stats.limit") || 0) / 1024 / 1024);
	});
	
	var getAccountExtraStorage = exports.getAccountExtraStorage = (0, _reselect.createSelector)([getAccountStorageLimit, getAccountProjectSpace], function (storageLimit, projectSpace) {
	    return Number(storageLimit - projectSpace);
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getContractBillingPeriodNormalized = exports.getContractByParamOrAccount = undefined;
	
	var _reselect = __webpack_require__(31);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _GetParam = __webpack_require__(17);
	
	var getContractByParamOrAccount = exports.getContractByParamOrAccount = (0, _reselect.createSelector)([_SimpleSelectors.getContracts], function (contracts) {
	    if (_GetParam._contract) {
	        return _GetParam._contract;
	    } else if (_GetParam._account) {
	        return Object.keys(contracts).find(function (contractId) {
	            return (contracts[contractId] && contracts[contractId].sourceUid) + '' === _GetParam._account;
	        });
	    }
	});
	
	var getContractBillingPeriodNormalized = exports.getContractBillingPeriodNormalized = (0, _reselect.createSelector)([_SimpleSelectors.getContracts, getContractByParamOrAccount], function (contracts, currentContract) {
	
	    var billingPeriodMappingReverse = {
	        0: 0,
	        1: 1,
	        3: 2,
	        6: 3,
	        12: 4
	    };
	
	    return contracts[currentContract] && billingPeriodMappingReverse[contracts[currentContract].billingPeriod] || 0;
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isProjectSelected = exports.getConsumerArticlesInCartSplit = exports.getAgencyServerProjectArticlesInCart = exports.getAgencyServerProjectArticlesInCartSplit = undefined;
	
	var _reselect = __webpack_require__(31);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _CartUtil = __webpack_require__(37);
	
	var _Config = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getAgencyServerProjectArticlesInCartSplit = exports.getAgencyServerProjectArticlesInCartSplit = (0, _reselect.createSelector)([_CartUtil.getArticleOptionsInCartObject, _SimpleSelectors.getArticleOptionCollections], function (articleOptionsInCart, articleOptionCollections) {
	
	    var matches = {
	        storage: [],
	        article: []
	    };
	
	    articleOptionsInCart.forEach(function (item) {
	        if (_Config.agencyServerProjectArticles.indexOf("" + item.articleNumber) >= 0) {
	
	            matches.article.push(item);
	            // article found, check if matching storage items are in cart
	            if (articleOptionCollections["" + item.articleNumber].hardware && articleOptionCollections["" + item.articleNumber].hardware.hddSw) {
	                var collection = articleOptionCollections["" + item.articleNumber].hardware.hddSw;
	
	                articleOptionsInCart.forEach(function (swItem) {
	
	                    if (collection.indexOf(swItem.articleNumber) >= 0) {
	                        matches.storage.push(swItem);
	                    }
	                });
	            }
	        }
	    });
	    return matches;
	});
	
	var getAgencyServerProjectArticlesInCart = exports.getAgencyServerProjectArticlesInCart = (0, _reselect.createSelector)(getAgencyServerProjectArticlesInCartSplit, function (projectsInCartSplit) {
	    return [].concat(_toConsumableArray(projectsInCartSplit.storage), _toConsumableArray(projectsInCartSplit.article));
	});
	
	var getConsumerArticlesInCartSplit = exports.getConsumerArticlesInCartSplit = (0, _reselect.createSelector)([_CartUtil.getArticleOptionsInCartObject, _SimpleSelectors.getArticleOptionCollections, _SimpleSelectors.getBaseArticle], function (articleOptionsInCart, articleOptionCollections, baseArticleData) {
	
	    var matches = {
	        storage: [],
	        article: []
	    };
	
	    var articlesToCheck = [].concat(_toConsumableArray(articleOptionsInCart), [baseArticleData]);
	
	    articlesToCheck.forEach(function (item) {
	        if (_Config.cmsArticles.indexOf("" + item.articleNumber) >= 0 || _Config.shopArticles.indexOf("" + item.articleNumber) >= 0) {
	            matches.article.push(item);
	            // article found, check if matching storage items are in cart
	            if (articleOptionCollections["" + item.articleNumber].hardware && articleOptionCollections["" + item.articleNumber].hardware.hddSw) {
	                var collection = articleOptionCollections["" + item.articleNumber].hardware.hddSw;
	
	                articleOptionsInCart.forEach(function (swItem) {
	
	                    if (collection.indexOf(swItem.articleNumber) >= 0) {
	                        matches.storage.push(swItem);
	                    }
	                });
	            }
	        }
	    });
	    return matches;
	});
	
	var isProjectSelected = exports.isProjectSelected = (0, _reselect.createSelector)(_SimpleSelectors.getBaseArticle, _CartUtil.getArticleOptionsInCartList, function (baseArticle, articleOptionsInCart) {
	    return articleOptionsInCart.some(function (item) {
	        if (_Config.agencyServerProjectArticles.indexOf("" + item) >= 0) {
	            return true;
	        } else {
	            return false;
	        }
	    });
	});

/***/ },
/* 128 */,
/* 129 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'times';
	var width = 320;
	var height = 512;
	var ligatures = [];
	var unicode = 'f00d';
	var svgPathData = 'M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faTimes = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 130 */,
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.queryPromotionCodeIfArticleInCode = exports.queryPromotionCodeStatusAndData = exports.queryPromotionCodeInit = undefined;
	
	var _MittwaldApi = __webpack_require__(42);
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _FormData = __webpack_require__(35);
	
	var _Errors = __webpack_require__(134);
	
	var Errors = _interopRequireWildcard(_Errors);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Forms = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// **************************************************************************************************************
	var fetchPromotionCodeStatus = function fetchPromotionCodeStatus(bearer, articles, promotionCode) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.PROMOTIONCODE_VALIDATE_REQUEST, ActionTypes.PROMOTIONCODE_VALIDATE_SUCCESS, ActionTypes.PROMOTIONCODE_VALIDATE_FAILURE],
	        endpoint: 'promotioncodes/' + promotionCode + '/actions/validate',
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.PROMOTIONCODESTATUS,
	        method: 'POST',
	        postData: {
	            articles: articles
	        },
	        payload: {
	            promotionCode: promotionCode
	        }
	    });
	};
	
	var promotionCodeValidationFailure = function promotionCodeValidationFailure(errorMessage) {
	    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return {
	        type: ActionTypes.PROMOTIONCODE_VALIDATE_FAILURE,
	        error: errorMessage,
	        status: 404,
	        payload: payload
	    };
	};
	
	var fetchPromotionCodeData = function fetchPromotionCodeData(bearer, cartId, promotionCode) {
	    return _defineProperty({}, _MittwaldApi.MITTWALD_API, {
	        types: [ActionTypes.PROMOTIONCODE_DATA_REQUEST, ActionTypes.PROMOTIONCODE_DATA_SUCCESS, ActionTypes.PROMOTIONCODE_DATA_FAILURE],
	        endpoint: 'promotioncodes/' + promotionCode,
	        bearer: bearer,
	        schema: _MittwaldApi.Schemas.PROMOTIONCODE,
	        method: 'GET',
	        postData: {},
	        payload: {
	            promotionCode: promotionCode
	        }
	    });
	};
	
	var resetPromotionCode = function resetPromotionCode() {
	    return {
	        type: ActionTypes.PROMOTIONCODE_RESET
	    };
	};
	
	var initializePromotionCode = function initializePromotionCode(code) {
	    return {
	        type: ActionTypes.PROMOTIONCODE_INIT
	    };
	};
	
	var queryPromotionCodeInit = exports.queryPromotionCodeInit = function queryPromotionCodeInit() {
	    return function (dispatch, getState) {
	
	        var code = (0, _SimpleSelectors.getCartPromotionCode)(getState());
	        if (!code) {
	            return;
	        }
	        dispatch(initializePromotionCode(code));
	        dispatch(fetchPromotionCodeData(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), code));
	    };
	};
	
	var queryPromotionCodeStatusAndData = exports.queryPromotionCodeStatusAndData = function queryPromotionCodeStatusAndData() {
	    return function (dispatch, getState) {
	
	        var code = (0, _Forms.getPromotionCodeForm)(getState()) && (0, _Forms.getPromotionCodeForm)(getState()).values ? (0, _Forms.getPromotionCodeForm)(getState()).values.promotionCode : null;
	        var articles = (0, _SimpleSelectors.getCartItems)(getState()).map(function (val) {
	            return {
	                articleNumber: val.identifier
	            };
	        });
	
	        var wasValidatedBefore = getState().promotionCode.validatedPromotionCode;
	
	        if (!code) {
	            dispatch(resetPromotionCode());
	            if (wasValidatedBefore) {
	                dispatch((0, _FormData.putFormData)());
	            }
	        } else {
	            return Promise.all([dispatch(fetchPromotionCodeStatus(getState().token.bearer, articles, code))]).then(function (args) {
	
	                if (args[0].type === ActionTypes.PROMOTIONCODE_VALIDATE_SUCCESS) {
	
	                    return Promise.all([dispatch(fetchPromotionCodeData(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), code))]).then(function (args) {
	                        return dispatch((0, _FormData.putFormData)());
	                    });
	                } else {
	                    if (wasValidatedBefore) {
	                        dispatch((0, _FormData.putFormData)());
	                    }
	                    // load promotionCode data if code is valid but articles not matching
	                    if (args[0].error === Errors.PROMOTION_CODE_FALSE_ARTICLES) {
	                        return dispatch(fetchPromotionCodeData(getState().token.bearer, (0, _SimpleSelectors.getCartId)(getState()), code));
	                    }
	                }
	            });
	        }
	    };
	};
	
	var queryPromotionCodeIfArticleInCode = exports.queryPromotionCodeIfArticleInCode = function queryPromotionCodeIfArticleInCode(articleNumber) {
	    return function (dispatch, getState) {
	        // update promotioncode if article is matching promotioncode data
	        var codeInformation = getState().promotionCode.codeInformation;
	
	        var isArticleNumberIncluded = codeInformation && codeInformation.articles && codeInformation.articles.includes(articleNumber);
	
	        var isMonthlyDisabled = codeInformation && !codeInformation.monthly;
	
	        if (isArticleNumberIncluded || isMonthlyDisabled) {
	            return dispatch(queryPromotionCodeStatusAndData());
	        }
	    };
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppPreloader(props) {
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'app-preloader' },
	        _react2.default.createElement('div', { className: 'app-preloader__spinner' }),
	        _react2.default.createElement(
	            'h1',
	            null,
	            props.label
	        )
	    );
	}
	
	AppPreloader.propTypes = {
	    label: _propTypes2.default.string.isRequired
	};
	
	exports.default = AppPreloader;

/***/ },
/* 133 */,
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROMOTION_CODE_MONTHLY = exports.PROMOTION_CODE_MONTHLY = 'CODE_NOT_MONTHLY';
	var PROMOTION_CODE_FALSE_ARTICLES = exports.PROMOTION_CODE_FALSE_ARTICLES = 'Aggregated Exception: CODE IS INVALID FOR THIS ORDER.';
	var PROMOTION_CODE_INVALID = exports.PROMOTION_CODE_INVALID = 'CODE_NOT_EXISTING';
	
	var TOTP_REQUIRED = exports.TOTP_REQUIRED = 'TOTP_REQUIRED';
	var DEVICECOOKIE_REQUIRED = exports.DEVICECOOKIE_REQUIRED = 'DEVICECOOKIE_REQUIRED';
	var INVALID_CREDENTIALS = exports.INVALID_CREDENTIALS = 'INVALID_CREDENTIALS';

/***/ },
/* 135 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PASSWORD_VALIDATION_MATCHING = exports.PASSWORD_VALIDATION_MATCHING = "passwordMatch";
	var PASSWORD_VALIDATION_LENGTH = exports.PASSWORD_VALIDATION_LENGTH = "atLeastEightChars";
	var PASSWORD_VALIDATION_UPPER_LOWER = exports.PASSWORD_VALIDATION_UPPER_LOWER = "atLeastOneUpperLowerCase";
	var PASSWORD_VALIDATION_DIGIT = exports.PASSWORD_VALIDATION_DIGIT = "atLeastOneDigit";
	var PASSWORD_VALIDATION_SPECIAL = exports.PASSWORD_VALIDATION_SPECIAL = "atLeastOneSpecialChar";
	var PASSWORD_VALIDATION_DISALLOWED = exports.PASSWORD_VALIDATION_DISALLOWED = "avoidDisallowedChars";
	var PASSWORD_VALIDATION_NODASHBEGIN = exports.PASSWORD_VALIDATION_NODASHBEGIN = "avoidDashBegin";

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(149)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(34);
	var toLength = __webpack_require__(20);
	var toAbsoluteIndex = __webpack_require__(88);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(345);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(71);
	var TAG = __webpack_require__(16)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(33);
	var createDesc = __webpack_require__(87);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 141 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(16)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(25);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(25);
	var dPs = __webpack_require__(191);
	var enumBugKeys = __webpack_require__(141);
	var IE_PROTO = __webpack_require__(148)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(185)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(187).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(193);
	var hiddenKeys = __webpack_require__(141).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(143);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(33).f;
	var has = __webpack_require__(56);
	var TAG = __webpack_require__(16)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(108)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(52);
	var defined = __webpack_require__(51);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(189);
	var defined = __webpack_require__(51);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var defined = __webpack_require__(51);
	var fails = __webpack_require__(13);
	var spaces = __webpack_require__(152);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(59),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(520),
	    mapCacheDelete = __webpack_require__(521),
	    mapCacheGet = __webpack_require__(522),
	    mapCacheHas = __webpack_require__(523),
	    mapCacheSet = __webpack_require__(524);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(109),
	    stackClear = __webpack_require__(537),
	    stackDelete = __webpack_require__(538),
	    stackGet = __webpack_require__(539),
	    stackHas = __webpack_require__(540),
	    stackSet = __webpack_require__(541);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(120);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 161 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(230),
	    baseKeys = __webpack_require__(235),
	    isArrayLike = __webpack_require__(92);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(112),
	    baseForOwn = __webpack_require__(469),
	    baseIteratee = __webpack_require__(477);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ImmutableUtils = __webpack_require__(123);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PolymorphicSchema = function () {
	  function PolymorphicSchema(definition, schemaAttribute) {
	    _classCallCheck(this, PolymorphicSchema);
	
	    if (schemaAttribute) {
	      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
	        return input[schemaAttribute];
	      } : schemaAttribute;
	    }
	    this.define(definition);
	  }
	
	  _createClass(PolymorphicSchema, [{
	    key: 'define',
	    value: function define(definition) {
	      this.schema = definition;
	    }
	  }, {
	    key: 'getSchemaAttribute',
	    value: function getSchemaAttribute(input, parent, key) {
	      return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
	    }
	  }, {
	    key: 'inferSchema',
	    value: function inferSchema(input, parent, key) {
	      if (this.isSingleSchema) {
	        return this.schema;
	      }
	
	      var attr = this.getSchemaAttribute(input, parent, key);
	      return this.schema[attr];
	    }
	  }, {
	    key: 'normalizeValue',
	    value: function normalizeValue(value, parent, key, visit, addEntity) {
	      var schema = this.inferSchema(value, parent, key);
	      if (!schema) {
	        return value;
	      }
	      var normalizedValue = visit(value, parent, key, schema, addEntity);
	      return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : { id: normalizedValue, schema: this.getSchemaAttribute(value, parent, key) };
	    }
	  }, {
	    key: 'denormalizeValue',
	    value: function denormalizeValue(value, unvisit) {
	      var schemaKey = (0, _ImmutableUtils.isImmutable)(value) ? value.get('schema') : value.schema;
	      if (!this.isSingleSchema && !schemaKey) {
	        return value;
	      }
	      var id = (0, _ImmutableUtils.isImmutable)(value) ? value.get('id') : value.id;
	      var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
	      return unvisit(id || value, schema);
	    }
	  }, {
	    key: 'isSingleSchema',
	    get: function get() {
	      return !this._schemaAttribute;
	    }
	  }]);
	
	  return PolymorphicSchema;
	}();
	
	exports.default = PolymorphicSchema;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(570);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 166 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 167 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	
	  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
	}
	
	var _default = bytesToUuid;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 168 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = exports.UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_ERRORS = exports.UNTOUCH = exports.UNREGISTER_FIELD = exports.TOUCH = exports.SUBMIT = exports.STOP_SUBMIT = exports.STOP_ASYNC_VALIDATION = exports.START_SUBMIT = exports.START_ASYNC_VALIDATION = exports.SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_FAILED = exports.RESET_SECTION = exports.RESET = exports.REGISTER_FIELD = exports.INITIALIZE = exports.FOCUS = exports.DESTROY = exports.CLEAR_ASYNC_ERROR = exports.CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT = exports.CLEAR_FIELDS = exports.CHANGE = exports.BLUR = exports.AUTOFILL = exports.ARRAY_SWAP = exports.ARRAY_UNSHIFT = exports.ARRAY_SPLICE = exports.ARRAY_SHIFT = exports.ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE = exports.ARRAY_PUSH = exports.ARRAY_POP = exports.ARRAY_MOVE = exports.ARRAY_INSERT = exports.prefix = void 0;
	var prefix = '@@redux-form/';
	exports.prefix = prefix;
	var ARRAY_INSERT = prefix + "ARRAY_INSERT";
	exports.ARRAY_INSERT = ARRAY_INSERT;
	var ARRAY_MOVE = prefix + "ARRAY_MOVE";
	exports.ARRAY_MOVE = ARRAY_MOVE;
	var ARRAY_POP = prefix + "ARRAY_POP";
	exports.ARRAY_POP = ARRAY_POP;
	var ARRAY_PUSH = prefix + "ARRAY_PUSH";
	exports.ARRAY_PUSH = ARRAY_PUSH;
	var ARRAY_REMOVE = prefix + "ARRAY_REMOVE";
	exports.ARRAY_REMOVE = ARRAY_REMOVE;
	var ARRAY_REMOVE_ALL = prefix + "ARRAY_REMOVE_ALL";
	exports.ARRAY_REMOVE_ALL = ARRAY_REMOVE_ALL;
	var ARRAY_SHIFT = prefix + "ARRAY_SHIFT";
	exports.ARRAY_SHIFT = ARRAY_SHIFT;
	var ARRAY_SPLICE = prefix + "ARRAY_SPLICE";
	exports.ARRAY_SPLICE = ARRAY_SPLICE;
	var ARRAY_UNSHIFT = prefix + "ARRAY_UNSHIFT";
	exports.ARRAY_UNSHIFT = ARRAY_UNSHIFT;
	var ARRAY_SWAP = prefix + "ARRAY_SWAP";
	exports.ARRAY_SWAP = ARRAY_SWAP;
	var AUTOFILL = prefix + "AUTOFILL";
	exports.AUTOFILL = AUTOFILL;
	var BLUR = prefix + "BLUR";
	exports.BLUR = BLUR;
	var CHANGE = prefix + "CHANGE";
	exports.CHANGE = CHANGE;
	var CLEAR_FIELDS = prefix + "CLEAR_FIELDS";
	exports.CLEAR_FIELDS = CLEAR_FIELDS;
	var CLEAR_SUBMIT = prefix + "CLEAR_SUBMIT";
	exports.CLEAR_SUBMIT = CLEAR_SUBMIT;
	var CLEAR_SUBMIT_ERRORS = prefix + "CLEAR_SUBMIT_ERRORS";
	exports.CLEAR_SUBMIT_ERRORS = CLEAR_SUBMIT_ERRORS;
	var CLEAR_ASYNC_ERROR = prefix + "CLEAR_ASYNC_ERROR";
	exports.CLEAR_ASYNC_ERROR = CLEAR_ASYNC_ERROR;
	var DESTROY = prefix + "DESTROY";
	exports.DESTROY = DESTROY;
	var FOCUS = prefix + "FOCUS";
	exports.FOCUS = FOCUS;
	var INITIALIZE = prefix + "INITIALIZE";
	exports.INITIALIZE = INITIALIZE;
	var REGISTER_FIELD = prefix + "REGISTER_FIELD";
	exports.REGISTER_FIELD = REGISTER_FIELD;
	var RESET = prefix + "RESET";
	exports.RESET = RESET;
	var RESET_SECTION = prefix + "RESET_SECTION";
	exports.RESET_SECTION = RESET_SECTION;
	var SET_SUBMIT_FAILED = prefix + "SET_SUBMIT_FAILED";
	exports.SET_SUBMIT_FAILED = SET_SUBMIT_FAILED;
	var SET_SUBMIT_SUCCEEDED = prefix + "SET_SUBMIT_SUCCEEDED";
	exports.SET_SUBMIT_SUCCEEDED = SET_SUBMIT_SUCCEEDED;
	var START_ASYNC_VALIDATION = prefix + "START_ASYNC_VALIDATION";
	exports.START_ASYNC_VALIDATION = START_ASYNC_VALIDATION;
	var START_SUBMIT = prefix + "START_SUBMIT";
	exports.START_SUBMIT = START_SUBMIT;
	var STOP_ASYNC_VALIDATION = prefix + "STOP_ASYNC_VALIDATION";
	exports.STOP_ASYNC_VALIDATION = STOP_ASYNC_VALIDATION;
	var STOP_SUBMIT = prefix + "STOP_SUBMIT";
	exports.STOP_SUBMIT = STOP_SUBMIT;
	var SUBMIT = prefix + "SUBMIT";
	exports.SUBMIT = SUBMIT;
	var TOUCH = prefix + "TOUCH";
	exports.TOUCH = TOUCH;
	var UNREGISTER_FIELD = prefix + "UNREGISTER_FIELD";
	exports.UNREGISTER_FIELD = UNREGISTER_FIELD;
	var UNTOUCH = prefix + "UNTOUCH";
	exports.UNTOUCH = UNTOUCH;
	var UPDATE_SYNC_ERRORS = prefix + "UPDATE_SYNC_ERRORS";
	exports.UPDATE_SYNC_ERRORS = UPDATE_SYNC_ERRORS;
	var UPDATE_SYNC_WARNINGS = prefix + "UPDATE_SYNC_WARNINGS";
	exports.UPDATE_SYNC_WARNINGS = UPDATE_SYNC_WARNINGS;
	var _default = {
	  ARRAY_INSERT: ARRAY_INSERT,
	  ARRAY_MOVE: ARRAY_MOVE,
	  ARRAY_POP: ARRAY_POP,
	  ARRAY_PUSH: ARRAY_PUSH,
	  ARRAY_REMOVE: ARRAY_REMOVE,
	  ARRAY_REMOVE_ALL: ARRAY_REMOVE_ALL,
	  ARRAY_SHIFT: ARRAY_SHIFT,
	  ARRAY_SPLICE: ARRAY_SPLICE,
	  ARRAY_UNSHIFT: ARRAY_UNSHIFT,
	  ARRAY_SWAP: ARRAY_SWAP,
	  AUTOFILL: AUTOFILL,
	  BLUR: BLUR,
	  CHANGE: CHANGE,
	  CLEAR_FIELDS: CLEAR_FIELDS,
	  CLEAR_SUBMIT: CLEAR_SUBMIT,
	  CLEAR_SUBMIT_ERRORS: CLEAR_SUBMIT_ERRORS,
	  CLEAR_ASYNC_ERROR: CLEAR_ASYNC_ERROR,
	  DESTROY: DESTROY,
	  FOCUS: FOCUS,
	  INITIALIZE: INITIALIZE,
	  REGISTER_FIELD: REGISTER_FIELD,
	  RESET: RESET,
	  RESET_SECTION: RESET_SECTION,
	  SET_SUBMIT_FAILED: SET_SUBMIT_FAILED,
	  SET_SUBMIT_SUCCEEDED: SET_SUBMIT_SUCCEEDED,
	  START_ASYNC_VALIDATION: START_ASYNC_VALIDATION,
	  START_SUBMIT: START_SUBMIT,
	  STOP_ASYNC_VALIDATION: STOP_ASYNC_VALIDATION,
	  STOP_SUBMIT: STOP_SUBMIT,
	  SUBMIT: SUBMIT,
	  TOUCH: TOUCH,
	  UNREGISTER_FIELD: UNREGISTER_FIELD,
	  UNTOUCH: UNTOUCH,
	  UPDATE_SYNC_ERRORS: UPDATE_SYNC_ERRORS,
	  UPDATE_SYNC_WARNINGS: UPDATE_SYNC_WARNINGS
	};
	exports["default"] = _default;

/***/ },
/* 169 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	var _default = isEvent;
	exports["default"] = _default;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createIsValid;
	
	var _hasError = _interopRequireDefault(__webpack_require__(635));
	
	function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	  var hasError = (0, _hasError["default"])(structure);
	  return function (form, getFormState, ignoreSubmitErrors) {
	    if (ignoreSubmitErrors === void 0) {
	      ignoreSubmitErrors = false;
	    }
	
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	      var syncError = getIn(formState, form + ".syncError");
	
	      if (syncError) {
	        return false;
	      }
	
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + ".error");
	
	        if (error) {
	          return false;
	        }
	      }
	
	      var syncErrors = getIn(formState, form + ".syncErrors");
	      var asyncErrors = getIn(formState, form + ".asyncErrors");
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + ".submitErrors");
	
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + ".registeredFields");
	
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, "['" + name + "'].count") > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, "['" + name + "']"), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	}

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(563).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(171).setImmediate, __webpack_require__(171).clearImmediate))

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'plus';
	var width = 384;
	var height = 512;
	var ligatures = [];
	var unicode = 'f067';
	var svgPathData = 'M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faPlus = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 173 */,
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.closeAnyPopup = exports.showPopupOfferSharing = exports.showPopupWithIframe = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// **************************************************************************************************************
	var showPopupWithIframe = exports.showPopupWithIframe = function showPopupWithIframe(src) {
	    return {
	        type: ActionTypes.POPUP_SHOW_IFRAME,
	        src: src
	    };
	};
	
	var showPopupOfferSharing = exports.showPopupOfferSharing = function showPopupOfferSharing() {
	    return {
	        type: ActionTypes.POPUP_SHOW_OFFER_SHARING
	    };
	};
	
	var closeAnyPopup = exports.closeAnyPopup = function closeAnyPopup() {
	    return {
	        type: ActionTypes.POPUP_CLOSE_ANY
	    };
	};

/***/ },
/* 175 */,
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.togglePasswordVisibility = exports.undoStepCompletion = exports.configurationScrollProgress = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var configurationScrollProgress = exports.configurationScrollProgress = function configurationScrollProgress(val) {
	    return {
	        type: ActionTypes.CONFIGURATION_SCROLL_PROGRESS,
	        configurationScrollProgress: val
	    };
	};
	
	var undoStepCompletion = exports.undoStepCompletion = function undoStepCompletion(stepLabel) {
	    return {
	        type: ActionTypes.STEP_UNDONE,
	        stepLabel: stepLabel
	    };
	};
	
	var togglePasswordVisibility = exports.togglePasswordVisibility = function togglePasswordVisibility() {
	    return {
	        type: ActionTypes.FORM_TOGGLE_PASSWORD_VISIBILITY
	    };
	};

/***/ },
/* 177 */,
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reduxForm = __webpack_require__(12);
	
	var _ProjectSelection = __webpack_require__(127);
	
	var _HintWrapper = __webpack_require__(69);
	
	var _HintWrapper2 = _interopRequireDefault(_HintWrapper);
	
	var _Cart = __webpack_require__(28);
	
	var _ProjectSelection2 = __webpack_require__(124);
	
	var _Properties = __webpack_require__(45);
	
	var _util = __webpack_require__(9);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _LabeledSlider = __webpack_require__(320);
	
	var _LabeledSlider2 = _interopRequireDefault(_LabeledSlider);
	
	var _LabeledToggleSelection = __webpack_require__(321);
	
	var _LabeledToggleSelection2 = _interopRequireDefault(_LabeledToggleSelection);
	
	var _ArticleConfiguratorFormField = __webpack_require__(318);
	
	var _ArticleConfiguratorFormField2 = _interopRequireDefault(_ArticleConfiguratorFormField);
	
	var _clsx = __webpack_require__(66);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _General = __webpack_require__(10);
	
	var _Mode = __webpack_require__(18);
	
	var _reactTooltip = __webpack_require__(61);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Config = __webpack_require__(11);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LabeledInput = __webpack_require__(97);
	
	var _LabeledInput2 = _interopRequireDefault(_LabeledInput);
	
	var _PasswordStrengthTooltip = __webpack_require__(322);
	
	var _PasswordStrengthTooltip2 = _interopRequireDefault(_PasswordStrengthTooltip);
	
	var _PasswordStrength = __webpack_require__(135);
	
	var _SoftwareSelect = __webpack_require__(328);
	
	var _SoftwareSelect2 = _interopRequireDefault(_SoftwareSelect);
	
	var _Password = __webpack_require__(311);
	
	var _PasswordHint = __webpack_require__(327);
	
	var _PasswordHint2 = _interopRequireDefault(_PasswordHint);
	
	var _password = __webpack_require__(181);
	
	var _ArticleConfiguratorCostsDisplay = __webpack_require__(317);
	
	var _ArticleConfiguratorCostsDisplay2 = _interopRequireDefault(_ArticleConfiguratorCostsDisplay);
	
	var _Domain = __webpack_require__(96);
	
	var _UserInterface = __webpack_require__(176);
	
	var _ArticleConfiguratorTooltip = __webpack_require__(319);
	
	var _BaseArticle = __webpack_require__(54);
	
	var _Collapsible = __webpack_require__(286);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _ArticleInlineSelection = __webpack_require__(324);
	
	var _ArticleInlineSelection2 = _interopRequireDefault(_ArticleInlineSelection);
	
	var _Hardware = __webpack_require__(334);
	
	var _CartUtil = __webpack_require__(37);
	
	var _Cart2 = __webpack_require__(36);
	
	var _Accounts = __webpack_require__(125);
	
	var _ArticleConfigurator = __webpack_require__(179);
	
	var _Forms = __webpack_require__(38);
	
	var _AppPreloader = __webpack_require__(132);
	
	var _AppPreloader2 = _interopRequireDefault(_AppPreloader);
	
	var _Contract = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function mapStateToProps(state, ownProps) {
	
	    var contracts = (0, _SimpleSelectors.getContracts)(state);
	    var contractIdentifier = (0, _Contract.getContractByParamOrAccount)(state);
	    var contract = contracts ? contracts[contractIdentifier] : null;
	
	    var articleConfiguratorData = (0, _Config.getArticleConfiguratorData)(state);
	    var configuration = ownProps && articleConfiguratorData[ownProps.mode] ? articleConfiguratorData[ownProps.mode] : articleConfiguratorData['shared'];
	    var form = (0, _Forms.getProjectSelectionForm)(state);
	    var accounts = (0, _SimpleSelectors.getAccounts)(state);
	    var currentAccount = (0, _Accounts.getCurrentAccountByContract)(state);
	
	    //todo: use selector for the procedure in this method
	    var regex = /([\d.]{1,})/;
	
	    var currentValues = form && form.values;
	    var selectedArticleProjectSpace = (0, _ArticleConfigurator.getSelectedArticleProjectSpace)(state);
	
	    var projectState = currentValues && currentValues.state || 'live';
	    var projectStateLabel = currentValues ? (0, _util.delve)(configuration, 'projectStates.' + currentValues.state + '.label') : '';
	
	    var currentAccountVisitorIndex = null;
	    var currentAccountArticle = null;
	    var accountStorageUsage = null;
	    var accountExtraStorage = null;
	    var accountStorageUsagePercent = null;
	    var storageExceedingSteps = null;
	    var accountBackupIndex = null;
	
	    var articlesNotBeingAdded = [];
	    if ((0, _Mode.isMode)(_General.APP_MODE_PRODUCT_CHANGE) && currentAccount) {
	        articlesNotBeingAdded = ["" + (0, _util.delve)(currentAccount, "article.articleNumber")];
	    }
	
	    // varnish, elasticsearch
	    var potentialAddonArticles = (0, _Config.getAvailableAccessoryArticles)(state);
	    var validAddonArticles = [];
	
	    // assign config
	    var projectTypes = _extends({}, configuration.projectStates[projectState].projectTypes);
	    var backupRangeOptions = [].concat(_toConsumableArray(configuration.backupRange));
	
	    // build size options
	    var visitorOptions = [];
	    var storageOptions = [];
	    var defaultVisitorOption = null;
	
	    var projectStateOptions = Object.keys(configuration.projectStates).map(function (state) {
	        return configuration.projectStates[state];
	    });
	
	    var projectTypeOptions = Object.keys(projectTypes).map(function (type) {
	        return projectTypes[type];
	    });
	
	    if (currentValues && currentValues.type && projectTypes[currentValues.type]) {
	        visitorOptions = projectTypes[currentValues.type].articles;
	        defaultVisitorOption = projectTypes[currentValues.type].default;
	    } else {
	        visitorOptions = projectTypes[Object.keys(projectTypes)[0]].articles;
	        defaultVisitorOption = projectTypes[Object.keys(projectTypes)[0]].default;
	    }
	
	    if (state.articleData && state.articleData.articleOptions) {
	        visitorOptions = visitorOptions.map(function (articleId) {
	            var visitors = (0, _util.delve)(state, "articleData.articleOptions." + articleId + ".limits.visitors");
	            if (!visitors) {
	                var title = (0, _util.delve)(state, "articleData.articleOptions." + articleId + ".title");
	                if (title) {
	                    // if limits are not available, use title to get visitor count
	                    visitors = regex.exec(title)[1].replace(".", "");
	                } else {
	                    return false;
	                }
	            }
	            return {
	                visitors: visitors,
	                label: "" + new Intl.NumberFormat('de-DE', { useGrouping: true }).format(parseInt(visitors)) + " Besucher / Monat",
	                value: "" + articleId
	            };
	        }).filter(Boolean);
	
	        // build storage article option only if article is not DEV-Projekt
	        if (currentValues && currentValues.article) {
	            if (currentValues.article !== _Config.devProjectArticleNumber && (0, _util.delve)(state, 'articleData.articleOptionCollection.' + currentValues.article + '.hardware.hddSw')) {
	                storageOptions = state.articleData.articleOptionCollection[currentValues.article].hardware.hddSw.map(function (articleId) {
	                    if (typeof articleId === "string" && articleId.substr(0, 7) === "default") {
	                        // remove default options from storageOptions
	                        return false;
	                    }
	                    var optionUsageGB = Number(regex.exec(state.articleData.articleOptions[articleId].title)[1]);
	                    //const optionUsageGB = Number(state.articleData.articleOptions[articleId].storageSpaceKb) / 1024 / 1024;
	                    return {
	                        label: (selectedArticleProjectSpace > 0 ? optionUsageGB + selectedArticleProjectSpace : "+" + optionUsageGB) + " GB",
	                        value: "" + articleId,
	                        gb: optionUsageGB + selectedArticleProjectSpace,
	                        raw: optionUsageGB
	                    };
	                }).filter(Boolean);
	            } else {
	                storageOptions = [];
	            }
	        }
	
	        // inject default hdd option
	        storageOptions = [{
	            label: selectedArticleProjectSpace ? Number(selectedArticleProjectSpace).toFixed(0) + ' GB inkl.' : 'Standardgröße',
	            value: "",
	            gb: selectedArticleProjectSpace
	        }].concat(_toConsumableArray(storageOptions));
	
	        if (currentAccount && currentValues && currentValues.article) {
	
	            currentAccountVisitorIndex = 0;
	
	            var currentAccountArticleNumber = (0, _util.delve)(accounts, currentAccount + ".article.articleNumber");
	            var articleOptions = (0, _SimpleSelectors.getArticleOptionsData)(state);
	            var currentAccountVisitorLimit = parseInt((0, _util.delve)(articleOptions, currentAccountArticleNumber + '.limits.visitors'));
	            var previousAccountVisitorLimit = visitorOptions[0].visitors,
	                isFirst = true;
	
	            for (var i = 1; i < visitorOptions.length; i++) {
	                var visitorOption = visitorOptions[i];
	                if (currentAccountVisitorLimit > visitorOption.visitors) {
	                    currentAccountVisitorIndex++;
	                } else {
	                    currentAccountVisitorIndex += (currentAccountVisitorLimit - previousAccountVisitorLimit) / (visitorOption.visitors - previousAccountVisitorLimit);
	                    break;
	                }
	                previousAccountVisitorLimit = visitorOption.visitors;
	            }
	
	            if (currentAccountVisitorIndex < 0) {
	                currentAccountVisitorIndex = 0;
	            }
	        }
	
	        if (currentAccount && currentValues && currentValues.article && (0, _util.delve)(accounts, currentAccount + ".stats.limit") !== -1) {
	
	            // article
	            currentAccountArticle = (0, _util.delve)(accounts, currentAccount + ".article.articleNumber");
	
	            if (["696969", "72002"].indexOf(currentAccountArticle + "") === -1) {
	                // only allow upgrade to dev article if existing article is SPIELWIESE or dev article
	                projectStateOptions = projectStateOptions.filter(function (elem) {
	                    return elem.value !== _General.PROJECT_STATE_DEV;
	                });
	            }
	
	            if ((0, _Mode.isMode)(_General.APP_MODE_PRODUCT_CHANGE) && currentAccountArticle) {
	                articlesNotBeingAdded = ["" + currentAccountArticle];
	            }
	
	            // storage
	            accountExtraStorage = (0, _Accounts.getAccountExtraStorage)(state);
	            accountStorageUsage = (0, _Accounts.getAccountStorageUsage)(state);
	
	            var initialStorageLimit = selectedArticleProjectSpace + accountExtraStorage;
	
	            if (accountExtraStorage > 0) {
	                storageOptions = storageOptions.map(function (storageOption) {
	                    // update storage option labels
	                    return _extends({}, storageOption, {
	                        gb: storageOption.gb + Number(accountExtraStorage),
	                        label: Number(storageOption.gb + Number(accountExtraStorage)) + ' GB',
	                        raw: storageOption.raw
	                    });
	                });
	            } else {
	                // remove inclusive Label if account data is available
	                storageOptions[0].label = Number(storageOptions[0].gb) + ' GB';
	            }
	
	            var selectedStorageLimit = selectedArticleProjectSpace + accountExtraStorage;
	
	            if (currentValues && currentValues.storage) {
	                var selectedStorageIndex = storageOptions.findIndex(function (storageOption) {
	                    return storageOption.value === currentValues.storage;
	                });
	                selectedStorageLimit = selectedStorageIndex >= 0 ? storageOptions[selectedStorageIndex].gb : 0;
	            }
	
	            // remove options that will lead to too much storage
	            storageOptions = storageOptions.filter(function (storageOption) {
	                return storageOption.raw === undefined || storageOption.raw + accountExtraStorage <= 500;
	            });
	
	            accountStorageUsagePercent = Math.min(100, accountStorageUsage / selectedStorageLimit * 100);
	
	            if (accountStorageUsage > initialStorageLimit) {
	
	                // calculate exceeding storage in storage option steps
	                var remainingExceedingStorage = accountStorageUsage - initialStorageLimit;
	                storageExceedingSteps = 0;
	
	                var previousStorageOptionGB = storageOptions[0].gb;
	
	                storageOptions.forEach(function (storageOption, idx) {
	                    if (idx > 0) {
	                        if (remainingExceedingStorage > storageOption.gb - previousStorageOptionGB) {
	                            remainingExceedingStorage -= storageOption.gb - previousStorageOptionGB;
	                            storageExceedingSteps += 1;
	                        } else if (remainingExceedingStorage > 0) {
	                            storageExceedingSteps += remainingExceedingStorage / (storageOption.gb - previousStorageOptionGB);
	                            remainingExceedingStorage = 0;
	                        }
	                        previousStorageOptionGB = storageOption.gb;
	                    }
	                });
	                storageExceedingSteps *= 1 / (storageOptions.length - 1);
	            }
	
	            if (!currentValues.storage && !ownProps.hideStorage && storageOptions && storageOptions.length > 0) {
	                currentValues.storage = storageOptions[0].value;
	            }
	        }
	
	        if (currentAccount) {
	            accountBackupIndex = backupRangeOptions.findIndex(function (backupOption) {
	                return backupOption.value === (0, _Accounts.getAccountBackupRange)(state);
	            });
	        }
	    }
	
	    var passwordInCart = (0, _SimpleSelectors.getCartProjectPassword)(state);
	    var showPasswordState = false;
	
	    if (passwordInCart && currentValues && !currentValues.projectPassword) {
	        showPasswordState = true;
	    }
	
	    // build calculated price
	    var costs = 0;
	
	    if (ownProps.connectToCart) {
	
	        costs = (0, _Cart2.getTotalCartCosts)(state).priceMonthly;
	
	        var itemsInCart = (0, _SimpleSelectors.getCartItems)(state);
	
	        if ((0, _util.delve)(itemsInCart, '0.identifier') === _Config.agencyServerArticleNumber) {
	            // if agency server, subtract the agency server base price from displayed costs
	            costs -= (0, _util.delve)(state.articleData.articleOptions, _Config.agencyServerArticleNumber + ".price.default.net") || 0;
	        }
	
	        if ((0, _Mode.isMode)(_General.APP_MODE_PRODUCT_CHANGE) || (0, _Mode.isMode)(_General.APP_MODE_OUTSOURCING)) {
	
	            var _accounts = (0, _SimpleSelectors.getAccounts)(state);
	            var _currentAccountArticle = (0, _util.delve)(_accounts, currentAccount + ".article.articleNumber");
	
	            var agencyProjectArticlesInCart = (0, _ProjectSelection.getAgencyServerProjectArticlesInCartSplit)(state);
	            var consumerProjectsInCart = (0, _ProjectSelection.getConsumerArticlesInCartSplit)(state);
	
	            if (agencyProjectArticlesInCart.article.length > 0 || consumerProjectsInCart.article.length > 0) {
	                if (contract) {
	                    costs -= Number((0, _util.delve)(contract, 'contractPrice'));
	                } else {
	                    costs -= (0, _util.delve)(state.articleData.articleOptions, _currentAccountArticle + ".price.default.net") || 0;
	                }
	            }
	        }
	    } else {
	        // if not connected to cart, price is only calculated by base article and selected storage
	        if (currentValues && currentValues.article) {
	            costs += (0, _util.delve)(state.articleData.articleOptions, currentValues.article + ".price.default.net") || 0;
	        }
	        if (currentValues && currentValues.storage) {
	            costs += (0, _util.delve)(state.articleData.articleOptions, currentValues.storage + ".price.default.net") || 0;
	        }
	    }
	
	    if (currentValues && currentValues.article) {
	        var articleOptionCollectionsData = (0, _SimpleSelectors.getArticleOptionCollections)(state);
	
	        // check for potential paidsoftware
	        potentialAddonArticles.forEach(function (potentialAddonArticle) {
	            var isValidAddonArticle = false;
	            if (articleOptionCollectionsData[currentValues.article] && articleOptionCollectionsData[currentValues.article].paidSoftware) {
	                Object.keys(articleOptionCollectionsData[currentValues.article].paidSoftware).forEach(function (typeKey) {
	                    // loop all keys like paidSoftware
	                    if (articleOptionCollectionsData[currentValues.article].paidSoftware[typeKey].includes(potentialAddonArticle)) {
	                        isValidAddonArticle = true;
	                    }
	                });
	            }
	            if (isValidAddonArticle) {
	                validAddonArticles.push(potentialAddonArticle);
	            }
	        });
	    }
	
	    return {
	        currentAccountVisitorIndex: currentAccountVisitorIndex,
	        windowWidth: window.innerWidth,
	        form: "projectSelection",
	        showPasswordState: showPasswordState,
	        projectStateOptions: projectStateOptions,
	        isProjectSelected: (0, _ProjectSelection.isProjectSelected)(state),
	        articleData: state.articleData,
	        showPassword: (0, _util.delve)(state, "ui.showPassword"),
	        selectedType: currentValues,
	        cartIsFetching: state.cart && state.cart.isFetching,
	        potentialAddonArticles: potentialAddonArticles,
	        validAddonArticles: validAddonArticles,
	        validAddonArticlesDisplay: (0, _Hardware.getCustomDisplayData)(state, validAddonArticles),
	        articleOptionsInCart: (0, _CartUtil.getArticleOptionsInCartList)(state),
	        visitorOptions: visitorOptions,
	        isQueryingAddInitial: state.cart && state.cart.isQueryingAddInitial,
	        projectTypes: projectTypes,
	        storageOptions: storageOptions,
	        articlesNotBeingAdded: articlesNotBeingAdded,
	        projectTypeOptions: projectTypeOptions,
	        backupRangeOptions: backupRangeOptions,
	        accountBackupIndex: accountBackupIndex,
	        defaultVisitorOption: defaultVisitorOption,
	        costs: costs,
	        projectState: projectState,
	        projectStateLabel: projectStateLabel,
	        currentAccountArticle: currentAccountArticle,
	        accountStorageUsage: accountStorageUsage,
	        storageExceedingSteps: storageExceedingSteps,
	        accountExtraStorage: accountExtraStorage,
	        accountStorageUsagePercent: accountStorageUsagePercent,
	        selectedArticleProjectSpace: selectedArticleProjectSpace
	    };
	}
	
	function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        handleProjectSelectionSubmit: function handleProjectSelectionSubmit(values, dispatch, props) {
	            if (props.isProjectSelected) {
	                return dispatch((0, _ProjectSelection2.queryProjectRemove)(values));
	            } else {
	                return dispatch((0, _ProjectSelection2.queryProjectSelection)(values));
	            }
	        },
	        togglePasswordVisibility: function togglePasswordVisibility() {
	            return dispatch((0, _UserInterface.togglePasswordVisibility)());
	        },
	        generatePassword: function generatePassword(e) {
	            e.preventDefault();
	            return dispatch((0, _Password.generateProjectPassword)("projectSelection"));
	        }
	    };
	}
	
	var ArticleConfigurator = function (_React$Component) {
	    _inherits(ArticleConfigurator, _React$Component);
	
	    function ArticleConfigurator(props) {
	        _classCallCheck(this, ArticleConfigurator);
	
	        var _this = _possibleConstructorReturn(this, (ArticleConfigurator.__proto__ || Object.getPrototypeOf(ArticleConfigurator)).call(this, props));
	
	        _this.tooltipMaxRef = _react2.default.createRef();
	        return _this;
	    }
	
	    /**
	     * backup: show backup in personalization by default. is personalization is hidden, show in upper group instead only if hideBackup is false and if only one projectstate option
	     */
	
	
	    _createClass(ArticleConfigurator, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = this.props;
	
	            var maxValueHint = _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Da geht noch mehr!'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Du erwartest mehr als ',
	                    props.visitorOptions[props.visitorOptions.length - 1].label,
	                    ' oder extreme Traffic-Spitzen? Kein Problem. Selbst wenn du besondere Features brauchst, frag uns einfach. Wir erstellen dir dein Hosting nach Ma\xDF!'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    {
	                        target: "_blank",
	                        rel: "no-referer",
	                        href: "https://www.mittwald.de/individual-hosting"
	                    },
	                    'Zum Individualhosting >'
	                )
	            );
	
	            var headline = void 0;
	
	            var renderBackupStandalone = !props.hideBackup && props.hidePersonalization && props.projectStateOptions.length > 1;
	            var renderBackupInTopGroup = !props.hideBackup && props.hidePersonalization && props.projectStateOptions.length <= 1;
	
	            if (props.mode === _General.ARTICLE_CONFIGURATOR_MODE_SHARED) {
	                if (props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY) {
	                    headline = 'Dein 1. Projekt';
	                } else if (props.hidePersonalization) {
	                    headline = 'Wähle deinen Projekt-Tarif';
	                } else {
	                    headline = 'Schritt 1: Definiere dein Projekt';
	                }
	            } else {
	                if (props.isStandaloneProduct) {
	                    if (props.hidePersonalization) {
	                        headline = 'Definiere dein Projekt';
	                    } else {
	                        headline = 'Schritt 1: Zusätzlichen Speicherplatz hinzufügen';
	                    }
	                } else {
	                    headline = 'Tarif-Konfigurator';
	                }
	            }
	
	            return _react2.default.createElement(
	                'form',
	                {
	                    onSubmit: props.handleSubmit(props.handleProjectSelectionSubmit),
	                    className: (0, _clsx2.default)("article-configurator", props.hidePersonalization && !renderBackupStandalone && " article-configurator--single", props.layout && "article-configurator--layout-" + props.layout)
	                },
	                props.isQueryingAddInitial ? _react2.default.createElement(
	                    'div',
	                    { className: "article-configurator__loader" },
	                    _react2.default.createElement(_AppPreloader2.default, { label: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: "article-configurator__box article-configurator__box--configuration" },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: "article-configurator__form"
	                        },
	                        props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY ? _react2.default.createElement(
	                            _react.Fragment,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Agentur-Server'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Die Homebase f\xFCr alle deine Projekte von 1 bis unendlich. Ein zentraler Login sowie zeitsparende Features sorgen f\xFCr volle Kontrolle und \xDCberblick \xFCber alle Projekte. Jedes Projekt profitiert von der flexibel erweiterbaren Tarifstruktur - bei stets optimaler Performance.'
	                            )
	                        ) : null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            headline
	                        ),
	                        this.state && this.state.showStorageReduceHint ? _react2.default.createElement(_HintWrapper2.default, {
	                            theme: 'blue',
	                            content: "Um Speicherplatz zu reduzieren, wende dich bitte an unseren Kundenservice."
	                        }) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: "article-configurator__body" },
	                            props.projectStateOptions && props.projectStateOptions.length > 1 ? _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE ? _react2.default.createElement(
	                                    'div',
	                                    { className: "article-configurator__new-wrapper" },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: "article-configurator__new-dev" },
	                                        'NEU: Kostenlos entwickeln!'
	                                    )
	                                ) : null,
	                                props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY && props.projectState === "dev" ? _react2.default.createElement(
	                                    'div',
	                                    { className: "article-configurator__agency-hint" },
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        ' Ohne Umwege loslegen. Mit dem ',
	                                        _react2.default.createElement(
	                                            'strong',
	                                            null,
	                                            'DEV-Projekt'
	                                        ),
	                                        ' kannst du in aller Ruhe kostenlos entwickeln und testen. Sobald alles steht, kannst du es mit wenigen Klicks in ein Live-Projekt \xFCberf\xFChren.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            onClick: function onClick(e) {
	                                                props.change('state', 'live');
	                                            }
	                                        },
	                                        'Du hast bereits ein ',
	                                        _react2.default.createElement(
	                                            'strong',
	                                            null,
	                                            'LIVE-Projekt'
	                                        ),
	                                        '?'
	                                    )
	                                ) : null,
	                                props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY && props.projectState === "live" ? _react2.default.createElement(
	                                    'div',
	                                    { className: "article-configurator__agency-hint" },
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'Dein Projekt soll direkt online gehen oder du ziehst ein bestehendes Projekt zu Mittwald um? Dann ist ein ',
	                                        _react2.default.createElement(
	                                            'strong',
	                                            null,
	                                            'LIVE-Projekt'
	                                        ),
	                                        ' die richtige Wahl.'
	                                    )
	                                ) : null,
	                                props.layout !== _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY || props.projectState === "live" ? _react2.default.createElement(
	                                    _ArticleConfiguratorFormField2.default,
	                                    {
	                                        label: 'Projekt-Status',
	                                        tooltip: _ArticleConfiguratorTooltip.projectStateHint,
	                                        tooltipId: 'projectState',
	                                        windowWidth: props.windowWidth
	                                    },
	                                    _react2.default.createElement(_LabeledToggleSelection2.default, {
	                                        options: props.projectStateOptions,
	                                        layout: props.layout,
	                                        fieldId: 'state',
	                                        disabled: props.cartIsFetching
	                                    })
	                                ) : null,
	                                props.layout !== _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY ? _react2.default.createElement(
	                                    _ArticleConfiguratorFormField2.default,
	                                    {
	                                        label: props.projectStateLabel,
	                                        tooltip: "",
	                                        tooltipId: 'projectStateExplanation',
	                                        windowWidth: props.windowWidth
	                                    },
	                                    props.projectState === _General.PROJECT_STATE_LIVE ? _react2.default.createElement(
	                                        'div',
	                                        { className: "article-configurator__description" },
	                                        'Dein Projekt soll direkt an den Start gehen oder du ziehst ein bestehendes Projekt zu Mittwald um? Dann ist ein LIVE-Projekt die richtige Wahl. Projekt-Typ, Besucherzahl und Speicherplatz festlegen \u2013 fertig.'
	                                    ) : _react2.default.createElement(
	                                        'div',
	                                        { className: "article-configurator__description" },
	                                        'Entwickle und teste mit dem kostenlosen DEV-Projekt und lass deinen kreativen Ideen freien Lauf! \xDCberf\xFChre dein DEV-Projekt in ein LIVE-Projekt, sobald deine Entwicklung abgeschlossen ist. ',
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                target: "_blank",
	                                                href: "https://www.mittwald.de/faq/neue-tarife/dev-projekte"
	                                            },
	                                            'Mehr erfahren'
	                                        )
	                                    )
	                                ) : null
	                            ) : null,
	                            props.projectTypeOptions && props.projectTypeOptions.length > 1 ? _react2.default.createElement(
	                                _ArticleConfiguratorFormField2.default,
	                                {
	                                    label: 'Projekt-Typ',
	                                    tooltip: _ArticleConfiguratorTooltip.typeHint,
	                                    tooltipId: 'type',
	                                    windowWidth: props.windowWidth
	                                },
	                                _react2.default.createElement(_LabeledToggleSelection2.default, {
	                                    options: props.projectTypeOptions,
	                                    layout: props.layout,
	                                    fieldId: 'type',
	                                    disabled: props.cartIsFetching
	                                })
	                            ) : null,
	                            props.layout !== _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY || props.projectState === "live" ? _react2.default.createElement(
	                                _ArticleConfiguratorFormField2.default,
	                                {
	                                    label: "Volle Performance für bis zu",
	                                    tooltip: _ArticleConfiguratorTooltip.visitorHint,
	                                    tooltipId: "article",
	                                    windowWidth: props.windowWidth
	                                },
	                                _react2.default.createElement(_LabeledSlider2.default, {
	                                    options: props.visitorOptions,
	                                    markerAtIndex: props.currentAccountVisitorIndex,
	                                    fieldId: 'article',
	                                    layout: props.layout,
	                                    disabled: props.cartIsFetching,
	                                    onMaximumDeselected: function onMaximumDeselected(e) {
	                                        _reactTooltip2.default.hide(_this2.tooltipMaxRef.current);
	                                    },
	                                    onMaximumSelected: function onMaximumSelected(e) {
	                                        _reactTooltip2.default.show(_this2.tooltipMaxRef.current);
	                                    }
	                                })
	                            ) : null,
	                            props.visitorOptions && props.visitorOptions.length > 1 ? _react2.default.createElement(_ArticleConfiguratorFormField2.default, {
	                                label: false,
	                                tooltip: maxValueHint,
	                                tooltipId: "max",
	                                windowWidth: props.windowWidth,
	                                showRef: this.tooltipMaxRef,
	                                tooltipPlace: "top"
	                            }) : null,
	                            !props.hideStorage && (props.layout !== _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY || props.projectState === "live") ? _react2.default.createElement(
	                                _ArticleConfiguratorFormField2.default,
	                                {
	                                    label: "Speicherplatz",
	                                    tooltip: _ArticleConfiguratorTooltip.storageHint,
	                                    tooltipId: "storage",
	                                    windowWidth: props.windowWidth
	                                },
	                                _react2.default.createElement(_LabeledSlider2.default, {
	                                    options: props.storageOptions,
	                                    inlineDisplay: !!props.accountStorageUsage,
	                                    inlineDisplayLabel: props.accountStorageUsage ? Number(props.accountStorageUsage).toFixed(2) + " GB verbraucht von" : null,
	                                    inlineDisplayPercent: props.accountStorageUsagePercent,
	                                    exceedingSteps: props.storageExceedingSteps,
	                                    markerAtIndex: props.accountStorageUsage ? 0 : null,
	                                    onRepeatableNegativeDrag: !!props.accountStorageUsage ? function () {
	                                        _this2.setState({ showStorageReduceHint: true });
	                                    } : null,
	                                    onClearPositiveDrag: !!props.accountStorageUsage ? function () {
	                                        _this2.setState({ showStorageReduceHint: false });
	                                    } : null,
	                                    fieldId: 'storage',
	                                    layout: props.layout,
	                                    disabled: props.cartIsFetching
	                                })
	                            ) : null,
	                            !props.hideAddons && props.validAddonArticlesDisplay && props.validAddonArticlesDisplay.length > 0 ? _react2.default.createElement(
	                                _ArticleConfiguratorFormField2.default,
	                                {
	                                    label: "Add-Ons"
	                                },
	                                _react2.default.createElement(
	                                    _Collapsible2.default,
	                                    {
	                                        id: 'addons',
	                                        label: 'Hosting Add-Ons hinzubuchen'
	                                    },
	                                    props.validAddonArticlesDisplay.map(function (articleData) {
	                                        return _react2.default.createElement(_ArticleInlineSelection2.default, {
	                                            key: articleData.display.title,
	                                            articleOptions: [articleData],
	                                            itemsPerRow: 1,
	                                            inlineOptionStyle: 'extended',
	                                            canClearOnDoubleSelect: true
	                                        });
	                                    })
	                                )
	                            ) : null,
	                            renderBackupInTopGroup ? _react2.default.createElement(
	                                _ArticleConfiguratorFormField2.default,
	                                {
	                                    label: "Backupzeitraum",
	                                    tooltip: _ArticleConfiguratorTooltip.backupHint,
	                                    tooltipId: "backup",
	                                    windowWidth: props.windowWidth,
	                                    tooltipPlace: props.windowWidth < 768 ? 'top' : 'right'
	                                },
	                                _react2.default.createElement(_LabeledSlider2.default, {
	                                    options: props.backupRangeOptions,
	                                    markerAtIndex: props.accountBackupIndex,
	                                    fieldId: 'backup',
	                                    layout: props.layout,
	                                    disabled: props.cartIsFetching
	                                })
	                            ) : null,
	                            [_General.ARTICLE_CONFIGURATOR_MODE_SHOP, _General.ARTICLE_CONFIGURATOR_MODE_CMS].includes(props.mode) ? _react2.default.createElement(
	                                _ArticleConfiguratorFormField2.default,
	                                {
	                                    label: "Immer inklusive"
	                                },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: "article-configurator__form-field__text" },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '1 Domain & Let\xB4s Encrypt, alle CMS Tools'
	                                    ),
	                                    props.hideStorage && props.selectedArticleProjectSpace ? _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ',',
	                                        _react2.default.createElement('br', null),
	                                        props.selectedArticleProjectSpace,
	                                        ' GB Speicherplatz (erweiterbar)'
	                                    ) : null
	                                )
	                            ) : null
	                        )
	                    ),
	                    _react2.default.createElement(_ArticleConfiguratorCostsDisplay2.default, {
	                        mode: props.mode,
	                        costs: props.costs,
	                        layout: props.layout,
	                        state: props.projectState
	                    })
	                ),
	                !props.hidePersonalization ? _react2.default.createElement(
	                    'div',
	                    { className: "article-configurator__box article-configurator__box--detail" },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Schritt 2: Personalisiere dein Projekt'
	                    ),
	                    _react2.default.createElement(
	                        _ArticleConfiguratorFormField2.default,
	                        {
	                            label: "Allgemein",
	                            tooltip: _ArticleConfiguratorTooltip.projectNameHint,
	                            tooltipId: "projectName",
	                            windowWidth: props.windowWidth
	                        },
	                        _react2.default.createElement(_LabeledInput2.default, {
	                            label: "Projekt-Name",
	                            fieldId: 'projectName',
	                            forceValidation: props.forceValidation
	                        })
	                    ),
	                    props.showPasswordState ? _react2.default.createElement(_HintWrapper2.default, {
	                        content: "Die Seite wurde neu geladen und dein gewähltes Passwort wird dir nicht mehr angezeigt? Aus Sicherheitsgründen vergib bitte einfach an dieser Stelle ein neues Passwort.",
	                        theme: "blue"
	                    }) : null,
	                    _react2.default.createElement(
	                        _ArticleConfiguratorFormField2.default,
	                        {
	                            label: "Sicherheit",
	                            tooltip: _ArticleConfiguratorTooltip.securityHint,
	                            tooltipId: "projectPassword",
	                            windowWidth: props.windowWidth
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'labeled-group' },
	                            _react2.default.createElement(_PasswordStrengthTooltip2.default, { formIdentifier: props.form }),
	                            _react2.default.createElement(_LabeledInput2.default, {
	                                autocomplete: "new-password",
	                                type: props.showPassword ? 'text' : 'password',
	                                label: "Projekt-Passwort",
	                                fieldId: 'projectPassword',
	                                togglePasswordCallback: props.togglePasswordVisibility,
	                                showPassword: props.showPassword,
	                                forceValidation: props.forceValidation
	                            }),
	                            _react2.default.createElement(_LabeledInput2.default, {
	                                autocomplete: "new-password",
	                                type: props.showPassword ? 'text' : 'password',
	                                label: "Projekt-Passwort wiederholen",
	                                fieldId: 'projectPasswordRepeat',
	                                togglePasswordCallback: props.togglePasswordVisibility,
	                                showPassword: props.showPassword,
	                                forceValidation: props.forceValidation
	                            }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: "article-configurator__password-generation" },
	                                '... oder ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onClick: props.generatePassword },
	                                    'Passwort generieren'
	                                ),
	                                '?'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_PasswordHint2.default, { formIdentifier: props.form }),
	                    !props.hideSoftware ? _react2.default.createElement(
	                        _ArticleConfiguratorFormField2.default,
	                        {
	                            label: "Software",
	                            tooltip: _ArticleConfiguratorTooltip.softwareHint,
	                            tooltipId: "software",
	                            windowWidth: props.windowWidth
	                        },
	                        _react2.default.createElement(_SoftwareSelect2.default, null)
	                    ) : null,
	                    !props.hideBackup ? _react2.default.createElement(
	                        _ArticleConfiguratorFormField2.default,
	                        {
	                            label: "Backupzeitraum",
	                            tooltip: _ArticleConfiguratorTooltip.backupHint,
	                            tooltipId: "backup",
	                            windowWidth: props.windowWidth,
	                            tooltipPlace: props.windowWidth < 768 ? 'top' : 'right'
	                        },
	                        _react2.default.createElement(_LabeledSlider2.default, {
	                            options: props.backupRangeOptions,
	                            markerAtIndex: props.accountBackupIndex,
	                            fieldId: 'backup',
	                            disabled: props.cartIsFetching
	                        })
	                    ) : null
	                ) : null,
	                renderBackupStandalone ? _react2.default.createElement(
	                    'div',
	                    { className: "article-configurator__box article-configurator__box--detail" },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Schritt 2: W\xE4hle deinen gew\xFCnschten Backupzeitraum'
	                    ),
	                    _react2.default.createElement(
	                        _ArticleConfiguratorFormField2.default,
	                        {
	                            label: "Backupzeitraum",
	                            tooltip: _ArticleConfiguratorTooltip.backupHint,
	                            tooltipId: "backup",
	                            windowWidth: props.windowWidth,
	                            tooltipPlace: props.windowWidth < 768 ? 'top' : 'right'
	                        },
	                        _react2.default.createElement(_LabeledSlider2.default, {
	                            options: props.backupRangeOptions,
	                            fieldId: 'backup',
	                            markerAtIndex: props.accountBackupIndex,
	                            disabled: props.cartIsFetching
	                        })
	                    )
	                ) : null,
	                !props.hidePersonalization && !props.currentProduct && !props.isStandaloneProduct ? _react2.default.createElement(_HintWrapper2.default, {
	                    alignment: "center",
	                    theme: "blue",
	                    content: "Weitere Projekte können später im Kundencenter flexibel dazugebucht werden."
	                }) : null
	            );
	        }
	    }]);
	
	    return ArticleConfigurator;
	}(_react2.default.Component);
	
	//TODO: rename form to configurator
	
	
	ArticleConfigurator = (0, _reduxForm.reduxForm)({ // eslint-disable-line
	    destroyOnUnmount: false,
	    enableReinitialize: false,
	    keepDirtyOnReinitialize: true,
	    validate: function validate(values, props) {
	        var errors = {};
	
	        if (!props.hidePersonalization) {
	            if (!values.projectName) {
	                errors["projectName"] = "Bitte wähle einen Namen für dein Projekt.";
	            }
	            if (!values.projectPasswordInCart || values.projectPassword) {
	                // only validate password if it's not set in cart or if new password is entered
	                if (!values.projectPassword) {
	                    var _errors$projectPasswo;
	
	                    errors["projectPassword"] = "Bitte wähle ein Passwort für dein Projekt.";
	                    errors["projectPasswordRepeat"] = " ";
	                    errors["projectPasswordErrors"] = (_errors$projectPasswo = {}, _defineProperty(_errors$projectPasswo, _PasswordStrength.PASSWORD_VALIDATION_LENGTH, true), _defineProperty(_errors$projectPasswo, _PasswordStrength.PASSWORD_VALIDATION_MATCHING, true), _defineProperty(_errors$projectPasswo, _PasswordStrength.PASSWORD_VALIDATION_UPPER_LOWER, true), _defineProperty(_errors$projectPasswo, _PasswordStrength.PASSWORD_VALIDATION_DIGIT, true), _defineProperty(_errors$projectPasswo, _PasswordStrength.PASSWORD_VALIDATION_SPECIAL, true), _errors$projectPasswo);
	                } else {
	                    var passwordErrors = (0, _password.validatePassword)(values.projectPassword, values.projectPasswordRepeat);
	                    var amountErrors = Object.keys(passwordErrors).length;
	
	                    if (amountErrors > 0) {
	                        errors["projectPasswordErrors"] = passwordErrors;
	                        if (passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_MATCHING] && amountErrors === 1) {
	                            errors["projectPassword"] = "";
	                            errors["projectPasswordRepeat"] = "Bitte überprüfe deine Eingabe.";
	                        } else {
	                            errors["projectPassword"] = "Bitte überprüfe deine Eingabe.";
	                        }
	                    }
	                }
	            }
	        }
	        return errors;
	    },
	    onChange: function onChange(values, dispatch, props, previousValues) {
	        var article = values.article;
	        if (previousValues && values.state !== previousValues.state) {
	            // handle state change and set form fields if needed
	            if (props.projectTypeOptions.length > 0) {
	                dispatch((0, _reduxForm.change)(props.form, "type", props.projectTypeOptions[0].value));
	            }
	            if (values.state === 'live') {
	                dispatch((0, _Domain.selectDomainTypeIfNoDomainsInCart)(_General.DOMAIN_TYPE_CUSTOM));
	            } else if (values.state === 'dev') {
	                dispatch((0, _Domain.selectDomainTypeIfNoDomainsInCart)(_General.DOMAIN_TYPE_DEV));
	            }
	            if (props.visitorOptions && props.visitorOptions.findIndex(function (elem) {
	                return elem.value === article;
	            }) === -1) {
	                dispatch((0, _reduxForm.change)(props.form, "article", props.defaultVisitorOption));
	            }
	            if (props.visitorOptions && props.visitorOptions[0] && props.visitorOptions[0].value === _Config.devProjectArticleNumber) {
	                dispatch((0, _reduxForm.change)(props.form, "storage", ''));
	            }
	        }
	
	        if (previousValues && values.type !== previousValues.type && previousValues.article === values.article) {
	
	            // handle type change and set form fields if needed ( new article will be first in list )
	            var previousArticleVisitorLimit = parseInt((0, _util.delve)(props.articleData.articleOptions, previousValues.article + '.limits.visitors'));
	
	            if (props.visitorOptions.length > 0) {
	
	                if (!props.forceDefaultOnTypeSwitch) {
	
	                    // find first option that fulfills storage
	                    var articleToSwitchToIndex = props.visitorOptions.findIndex(function (visitorOption) {
	                        return parseInt(visitorOption.visitors) >= previousArticleVisitorLimit;
	                    });
	
	                    var articleToSwitchTo = props.visitorOptions[articleToSwitchToIndex];
	
	                    // check if previous option is closer
	                    if (articleToSwitchToIndex >= 1 && !props.forceDefaultOnTypeSwitch) {
	                        var potentiallyCloserArticle = props.visitorOptions[articleToSwitchToIndex - 1];
	                        var switchToArticle = props.visitorOptions[articleToSwitchToIndex];
	
	                        var differencePotentially = Math.abs(parseInt(potentiallyCloserArticle.visitors) - previousArticleVisitorLimit);
	                        var differenceSwitchTo = Math.abs(parseInt(switchToArticle.visitors) - previousArticleVisitorLimit);
	
	                        if (differencePotentially <= differenceSwitchTo) {
	                            articleToSwitchTo = potentiallyCloserArticle;
	                        }
	                    }
	
	                    if (articleToSwitchTo) {
	                        articleToSwitchTo = articleToSwitchTo.value;
	                    } else {
	                        articleToSwitchTo = props.visitorOptions[Math.min(1, props.visitorOptions.length - 1)].value; // default
	                    }
	
	                    dispatch((0, _reduxForm.change)(props.form, "article", articleToSwitchTo));
	                    article = articleToSwitchTo;
	                } else {
	                    dispatch((0, _reduxForm.change)(props.form, "article", props.defaultVisitorOption));
	                    article = props.defaultVisitorOption;
	                }
	            }
	        }
	
	        var currentStorageOptionAvailable = false;
	
	        // disable hardcoded devproject
	        if (article !== _Config.devProjectArticleNumber && (0, _util.delve)(props.articleData, 'articleOptionCollection.' + article + '.hardware.hddSw')) {
	            props.articleData.articleOptionCollection[article].hardware.hddSw.forEach(function (articleId) {
	                if (values && (values.storage === "" || values.storage === "" + articleId)) {
	                    currentStorageOptionAvailable = true;
	                }
	            });
	        }
	
	        var storageReplacementOption = false;
	
	        if (!currentStorageOptionAvailable) {
	
	            if (values.storage) {
	                // get matching storage replacement option
	                props.articleData.articleOptionCollection[article].hardware.hddSw.forEach(function (articleId) {
	                    if ((0, _util.delve)(props.articleData.articleOptions, articleId + '.storageSpaceKb') === (0, _util.delve)(props.articleData.articleOptions, values.storage + '.storageSpaceKb')) {
	                        storageReplacementOption = articleId;
	                    }
	                });
	            }
	            dispatch((0, _reduxForm.change)(props.form, "storage", storageReplacementOption || ""));
	        }
	
	        if (props.onChangeInject) {
	            props.onChangeInject(values);
	        }
	
	        if (props.connectToCart) {
	
	            // compare values and swap articles for changed values, except for type and backup form values
	            Object.keys(values).forEach(function (key) {
	                if (previousValues[key] !== values[key]) {
	                    if (key === "article" && props.updateSelectedArticle) {
	                        // update selected base article if activated
	                        dispatch((0, _BaseArticle.selectBaseArticle)(values[key]));
	                    }
	
	                    // remove / add article in cart when changed field value belongs to article or storage input
	                    if (key === "article" || key === "storage") {
	
	                        var isAllowedArticle = values[key] && props.articlesNotBeingAdded.indexOf(values[key]) === -1;
	
	                        // if previous value existed, remove it first and add afterwards
	                        if (previousValues[key]) {
	                            dispatch((0, _Cart.queueItemOperation)(_Cart.removeItemFromCartByArticleNumber, previousValues[key], isAllowedArticle));
	                        }
	                        if (isAllowedArticle) {
	                            dispatch((0, _Cart.queueItemOperation)(_Cart.addItemToCart, values[key]));
	                        }
	                        if (key === "article") {
	                            // check if addons are available
	                            props.potentialAddonArticles.forEach(function (potentialAddonArticle) {
	                                if (props.articleOptionsInCart.includes('' + potentialAddonArticle) && !props.validAddonArticles.includes(potentialAddonArticle)) {
	                                    dispatch((0, _Cart.queueItemOperation)(_Cart.removeItemFromCartByArticleNumber, potentialAddonArticle));
	                                }
	                            });
	                        }
	                    } else if (key === "backup") {
	                        // backup field belongs to property on cart object
	                        dispatch((0, _Properties.querySelectCartProperty)("backupRange", values[key]));
	                    } else if (key === "projectName") {
	                        // projectName field belongs to property on cart object
	                        dispatch((0, _Properties.querySelectCartProperty)("projectName", values[key]));
	                    } else if (key === "projectPassword" || key === "projectPasswordRepeat") {
	                        // projectName field belongs to property on cart object
	                        if (Object.keys((0, _password.validatePassword)(values.projectPassword, values.projectPasswordRepeat)).length === 0) {
	                            dispatch((0, _Properties.querySelectCartProperty)("projectPassword", values[key]));
	                            dispatch((0, _Properties.querySelectCartProperty)("projectPasswordInCart", false));
	                        } else {
	                            dispatch((0, _Properties.querySelectCartProperty)("projectPassword", ""));
	                        }
	                    }
	                }
	            });
	        }
	    }
	})(ArticleConfigurator); // eslint-disable-line
	
	ArticleConfigurator = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArticleConfigurator); // eslint-disable-line
	
	ArticleConfigurator.propTypes = {
	    hidePersonalization: _propTypes2.default.bool,
	    connectToCart: _propTypes2.default.bool,
	    hideBackup: _propTypes2.default.bool,
	    hideSoftware: _propTypes2.default.bool,
	    hideStorage: _propTypes2.default.bool,
	    hideAddons: _propTypes2.default.bool,
	    isStandaloneProduct: _propTypes2.default.bool,
	    updateSelectedArticle: _propTypes2.default.bool,
	    forceDefaultOnTypeSwitch: _propTypes2.default.bool
	};
	
	ArticleConfigurator.defaultProps = {
	    connectToCart: true,
	    updateSelectedArticle: false
	};
	
	exports.default = ArticleConfigurator;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSelectedStorageGB = exports.getSelectedArticleProjectSpace = exports.getSelectedStateByArticle = exports.getSelectedTypeByArticle = undefined;
	
	var _ArticleNumbers = __webpack_require__(65);
	
	var _General = __webpack_require__(10);
	
	var _reselect = __webpack_require__(31);
	
	var _Forms = __webpack_require__(38);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _util = __webpack_require__(9);
	
	var _Mode = __webpack_require__(18);
	
	var getSelectedTypeByArticle = exports.getSelectedTypeByArticle = function getSelectedTypeByArticle(articleNumber) {
	    if ((0, _ArticleNumbers.isAgencyServerCMSArticle)(articleNumber)) {
	        return _General.ARTICLE_TYPE_CMS;
	    } else if ((0, _ArticleNumbers.isAgencyServerShopArticle)(articleNumber)) {
	        return _General.ARTICLE_TYPE_SHOP;
	    } else if ((0, _ArticleNumbers.isAgencyServerDevProjectArticle)(articleNumber)) {
	        return _General.ARTICLE_TYPE_DEV;
	    }
	};
	
	var getSelectedStateByArticle = exports.getSelectedStateByArticle = function getSelectedStateByArticle(articleNumber) {
	    // todo: use constants
	    if ((0, _ArticleNumbers.isAgencyServerDevProjectArticle)(articleNumber)) {
	        return _General.PROJECT_STATE_DEV;
	    } else {
	        return _General.PROJECT_STATE_LIVE;
	    }
	};
	
	var getSelectedArticleProjectSpace = exports.getSelectedArticleProjectSpace = (0, _reselect.createSelector)([_Forms.getProjectSelectionForm, _SimpleSelectors.getArticleOptionsData, _Mode.getAppMode], function (projectSelectionForm, articleOptionsData, appMode) {
	    var currentValues = projectSelectionForm && projectSelectionForm.values;
	
	    if (appMode === _General.APP_MODE_PRESET) {
	        return 0;
	    } else {
	        return currentValues && currentValues.article ? Number((0, _util.delve)(articleOptionsData, currentValues.article + ".projectSpace") || 0) / 1024 / 1024 : 0;
	    }
	});
	
	var getSelectedStorageGB = exports.getSelectedStorageGB = (0, _reselect.createSelector)([_Forms.getProjectSelectionForm, _SimpleSelectors.getArticleOptionsData], function (projectSelectionForm, articleOptionsData) {
	    var currentValues = projectSelectionForm && projectSelectionForm.values;
	    if (!currentValues || !currentValues.storage) {
	        return 0;
	    }
	    var regex = /([\d.]{1,})/;
	    var storageGB = Number(regex.exec(articleOptionsData[currentValues.storage].title)[1]);
	    return storageGB ? storageGB : 0;
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSoftwareOptions = exports.getSoftwareOrder = exports.getSoftwareData = undefined;
	
	var _reselect = __webpack_require__(31);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Config = __webpack_require__(11);
	
	var _GetParam = __webpack_require__(17);
	
	var _CartUtil = __webpack_require__(37);
	
	var _reduxForm = __webpack_require__(12);
	
	var _General = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// **************************************************************************************************************
	var getSoftwareData = exports.getSoftwareData = function getSoftwareData(state) {
	    return state.software && state.software.softwareData;
	};
	var getSoftwareOrder = exports.getSoftwareOrder = function getSoftwareOrder(state) {
	    return state.software && state.software.softwareOrder;
	};
	
	var getSoftwareOptions = exports.getSoftwareOptions = (0, _reselect.createSelector)([getSoftwareData, getSoftwareOrder, _SimpleSelectors.getBaseArticle, _CartUtil.getArticleOptionsInCartList, (0, _reduxForm.getFormValues)('projectSelection')], function (softwareData, softwareOrder, baseArticleData, articleOptionsList, projectSelectionFormValues) {
	
	    if (!softwareOrder || !softwareData) {
	        return [];
	    }
	
	    // check base article number and article options
	    var articleNumbersToCheck = ["" + baseArticleData.articleNumber].concat(_toConsumableArray(articleOptionsList));
	
	    var softwareMode = 1; // default
	
	    if (projectSelectionFormValues) {
	        if (projectSelectionFormValues.type === _General.ARTICLE_TYPE_CMS) {
	            softwareMode = 2;
	        } else if (projectSelectionFormValues.type === _General.ARTICLE_TYPE_SHOP) {
	            softwareMode = 3;
	        }
	    }
	
	    if (_Config.cmsArticles.some(function (element) {
	        return articleNumbersToCheck.includes("" + element);
	    })) {
	        softwareMode = 2; // only non-shop
	    } else if (_Config.shopArticles.some(function (element) {
	        return articleNumbersToCheck.includes("" + element);
	    })) {
	        softwareMode = 3; // only shop
	    }
	
	    var softwareArray = softwareOrder.map(function (key) {
	        var softwareObject = {
	            value: key,
	            isDefault: false,
	            display: {
	                title: softwareData[key].name,
	                icon: "images/software/" + key + ".svg"
	            }
	
	            // also include initial software in list
	        };if (softwareMode === 1 || key === _GetParam._initialSoftware) {
	            return softwareObject;
	        } else if (softwareMode === 2) {
	            if (softwareData[key].category.uid !== 19) {
	                return softwareObject;
	            }
	        } else if (softwareMode === 3) {
	            if (softwareData[key].category.uid === 19) {
	                return softwareObject;
	            }
	        }
	        return null;
	    }).filter(function (elem) {
	        return elem;
	    });
	
	    softwareArray.unshift({
	        value: "",
	        isDefault: true,
	        display: {
	            title: "Ohne CMS- / Shop-Installation",
	            icon: ""
	        }
	    });
	
	    return softwareArray;
	});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.validatePassword = undefined;
	
	var _PasswordStrength = __webpack_require__(135);
	
	var validatePassword = exports.validatePassword = function validatePassword(password, passwordRepeat) {
	
	    var passwordErrors = {};
	
	    if (!password) {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_MATCHING] = true;
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_LENGTH] = true;
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_UPPER_LOWER] = true;
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_DIGIT] = true;
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_SPECIAL] = true;
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_DISALLOWED] = true;
	
	        return passwordErrors;
	    }
	
	    // check match
	    if (password !== passwordRepeat) {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_MATCHING] = true;
	    }
	    // check length > 8
	    if (password.length < 12) {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_LENGTH] = true;
	    }
	    // check upper lower case
	    if (!/(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_UPPER_LOWER] = true;
	    }
	    // check one digit
	    if (!/(?=.*[0-9])/.test(password)) {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_DIGIT] = true;
	    }
	    // check one specialChar
	    if (!/(?=.*[$!#*+,\-.;_:\/])/.test(password)) {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_SPECIAL] = true;
	    }
	    // check disAllowedChars
	    if (/[^$!#*+,\-.;_:\/a-zA-Z0-9]+/.test(password)) {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_DISALLOWED] = true;
	    }
	
	    if (password[0] === '-') {
	        passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_NODASHBEGIN] = true;
	    }
	
	    return passwordErrors;
	};

/***/ },
/* 182 */,
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(71);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(49);
	var toObject = __webpack_require__(15);
	var IObject = __webpack_require__(84);
	var toLength = __webpack_require__(20);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	var document = __webpack_require__(29).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(101);
	var isObject = __webpack_require__(21);
	var toLength = __webpack_require__(20);
	var ctx = __webpack_require__(83);
	var IS_CONCAT_SPREADABLE = __webpack_require__(16)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(29).document;
	module.exports = document && document.documentElement;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(19) && !__webpack_require__(13)(function () {
	  return Object.defineProperty(__webpack_require__(185)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(21);
	var cof = __webpack_require__(71);
	var MATCH = __webpack_require__(16)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(85);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(74);
	var hide = __webpack_require__(57);
	var Iterators = __webpack_require__(102);
	var $iterCreate = __webpack_require__(353);
	var setToStringTag = __webpack_require__(147);
	var getPrototypeOf = __webpack_require__(106);
	var ITERATOR = __webpack_require__(16)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(33);
	var anObject = __webpack_require__(25);
	var getKeys = __webpack_require__(73);
	
	module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(34);
	var gOPN = __webpack_require__(145).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(56);
	var toIObject = __webpack_require__(34);
	var arrayIndexOf = __webpack_require__(137)(false);
	var IE_PROTO = __webpack_require__(148)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(19);
	var getKeys = __webpack_require__(73);
	var toIObject = __webpack_require__(34);
	var isEnum = __webpack_require__(86).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 195 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(52);
	var defined = __webpack_require__(51);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(16);


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $every = __webpack_require__(55)(4);
	
	$export($export.P + $export.F * !__webpack_require__(39)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $filter = __webpack_require__(55)(2);
	
	$export($export.P + $export.F * !__webpack_require__(39)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $forEach = __webpack_require__(55)(0);
	var STRICT = __webpack_require__(39)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $indexOf = __webpack_require__(137)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(39)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(101) });


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(34);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(84) != Object || !__webpack_require__(39)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(34);
	var toInteger = __webpack_require__(52);
	var toLength = __webpack_require__(20);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(39)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $map = __webpack_require__(55)(1);
	
	$export($export.P + $export.F * !__webpack_require__(39)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(184);
	
	$export($export.P + $export.F * !__webpack_require__(39)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(184);
	
	$export($export.P + $export.F * !__webpack_require__(39)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var html = __webpack_require__(187);
	var cof = __webpack_require__(71);
	var toAbsoluteIndex = __webpack_require__(88);
	var toLength = __webpack_require__(20);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(13)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $some = __webpack_require__(55)(3);
	
	$export($export.P + $export.F * !__webpack_require__(39)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(49);
	var toObject = __webpack_require__(15);
	var fails = __webpack_require__(13);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(39)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(144) });


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperties: __webpack_require__(191) });


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(21);
	var meta = __webpack_require__(103).onFreeze;
	
	__webpack_require__(43)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(34);
	var $getOwnPropertyDescriptor = __webpack_require__(72).f;
	
	__webpack_require__(43)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(43)('getOwnPropertyNames', function () {
	  return __webpack_require__(192).f;
	});


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(15);
	var $getPrototypeOf = __webpack_require__(106);
	
	__webpack_require__(43)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(21);
	
	__webpack_require__(43)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(21);
	
	__webpack_require__(43)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(21);
	
	__webpack_require__(43)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(15);
	var $keys = __webpack_require__(73);
	
	__webpack_require__(43)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(21);
	var meta = __webpack_require__(103).onFreeze;
	
	__webpack_require__(43)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(21);
	var meta = __webpack_require__(103).onFreeze;
	
	__webpack_require__(43)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(149)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(190)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(151)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 226 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(165);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 228 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    nullTag = '[object Null]',
	    proxyTag = '[object Proxy]',
	    undefinedTag = '[object Undefined]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isFunction;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(44);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(487),
	    isArguments = __webpack_require__(117),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(118),
	    isIndex = __webpack_require__(158),
	    isTypedArray = __webpack_require__(121);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(112),
	    eq = __webpack_require__(91);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(497);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(236),
	    toKey = __webpack_require__(90);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(115),
	    nativeKeys = __webpack_require__(527);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    isKey = __webpack_require__(159),
	    stringToPath = __webpack_require__(247),
	    toString = __webpack_require__(252);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(59);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(461),
	    arraySome = __webpack_require__(466),
	    cacheHas = __webpack_require__(490);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 240 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(245);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(457),
	    Map = __webpack_require__(155),
	    Promise = __webpack_require__(459),
	    Set = __webpack_require__(460),
	    WeakMap = __webpack_require__(462),
	    baseGetTag = __webpack_require__(77),
	    toSource = __webpack_require__(248);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 244 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 246 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(526);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 248 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(234);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(113);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(230),
	    baseKeysIn = __webpack_require__(478),
	    isArrayLike = __webpack_require__(92);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(488);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(309);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(292));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(227));
	
	var _invariant = _interopRequireDefault(__webpack_require__(76));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(165);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(578));
	
	var _PropTypes = __webpack_require__(256);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(257));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(579));
	
	var _warning = _interopRequireDefault(__webpack_require__(166));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rng;
	// Unique ID creation requires a high quality random # generator. In the browser we therefore
	// require the crypto API and do not support built-in fallback to lower quality random number
	// generators (like Math.random()).
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
	// find the complete implementation of crypto (msCrypto) on IE11.
	var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
	var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	function rng() {
	  if (!getRandomValues) {
	    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
	  }
	
	  return getRandomValues(rnds8);
	}
	
	module.exports = exports.default;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.URL = exports.DNS = void 0;
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(167));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function uuidToBytes(uuid) {
	  // Note: We assume we're being passed a valid uuid string
	  var bytes = [];
	  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
	    bytes.push(parseInt(hex, 16));
	  });
	  return bytes;
	}
	
	function stringToBytes(str) {
	  str = unescape(encodeURIComponent(str)); // UTF8 escape
	
	  var bytes = new Array(str.length);
	
	  for (var i = 0; i < str.length; i++) {
	    bytes[i] = str.charCodeAt(i);
	  }
	
	  return bytes;
	}
	
	const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
	exports.DNS = DNS;
	const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
	exports.URL = URL;
	
	function _default(name, version, hashfunc) {
	  var generateUUID = function (value, namespace, buf, offset) {
	    var off = buf && offset || 0;
	    if (typeof value == 'string') value = stringToBytes(value);
	    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
	    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
	    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3
	
	    var bytes = hashfunc(namespace.concat(value));
	    bytes[6] = bytes[6] & 0x0f | version;
	    bytes[8] = bytes[8] & 0x3f | 0x80;
	
	    if (buf) {
	      for (var idx = 0; idx < 16; ++idx) {
	        buf[off + idx] = bytes[idx];
	      }
	    }
	
	    return buf || (0, _bytesToUuid.default)(bytes);
	  }; // Function#name is not settable on some platforms (#270)
	
	
	  try {
	    generateUUID.name = name;
	  } catch (err) {} // For CommonJS default export support
	
	
	  generateUUID.DNS = DNS;
	  generateUUID.URL = URL;
	  return generateUUID;
	}

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(336);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(681);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 262 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleAction;
	function isFunction(val) {
	  return typeof val === 'function';
	}
	
	function handleAction(type, reducers, defaultState) {
	  var typeValue = isFunction(type) ? type.toString() : type;
	
	  return function () {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	    var action = arguments[1];
	
	    // If action type does not match, return previous state
	    if (action.type !== typeValue) return state;
	
	    var handlerKey = action.error === true ? 'throw' : 'next';
	
	    // If function is passed instead of map, use as reducer
	    if (isFunction(reducers)) {
	      reducers.next = reducers.throw = reducers;
	    }
	
	    // Otherwise, assume an action map was passed
	    var reducer = reducers[handlerKey];
	
	    return isFunction(reducer) ? reducer(state, action) : state;
	  };
	}

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.isSubmissionError = isSubmissionError;
	exports.SubmissionError = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _es6Error = _interopRequireDefault(__webpack_require__(429));
	
	var __FLAG__ = '@@redux-form/submission-error-flag';
	
	var SubmissionError = /*#__PURE__*/function (_ExtendableError) {
	  (0, _inheritsLoose2["default"])(SubmissionError, _ExtendableError);
	
	  /** @private */
	  function SubmissionError(errors) {
	    var _this;
	
	    _this = _ExtendableError.call(this, 'Submit Validation Failed') || this;
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error["default"]);
	
	exports.SubmissionError = SubmissionError;
	SubmissionError.__FLAG__ = __FLAG__;
	
	function isSubmissionError(error) {
	  return (error && error.constructor && error.constructor.__FLAG__ === __FLAG__) === true;
	}

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _actionTypes = __webpack_require__(168);
	
	var arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    },
	    payload: value
	  };
	};
	
	var arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: {
	      form: form,
	      field: field,
	      from: from,
	      to: to
	    }
	  };
	};
	
	var arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    }
	  };
	};
	
	var arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: {
	      form: form,
	      field: field,
	      index: index,
	      removeNum: removeNum
	    }
	  };
	
	  if (value !== undefined) {
	    action.payload = value;
	  }
	
	  return action;
	};
	
	var arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	
	  return {
	    type: _actionTypes.ARRAY_SWAP,
	    meta: {
	      form: form,
	      field: field,
	      indexA: indexA,
	      indexB: indexB
	    }
	  };
	};
	
	var arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch
	    },
	    payload: value
	  };
	};
	
	var change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch,
	      persistentSubmitErrors: persistentSubmitErrors
	    },
	    payload: value
	  };
	};
	
	var clearSubmit = function clearSubmit(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
	  for (var _len = arguments.length, fields = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    fields[_key - 3] = arguments[_key];
	  }
	
	  return {
	    type: _actionTypes.CLEAR_FIELDS,
	    meta: {
	      form: form,
	      keepTouched: keepTouched,
	      persistentSubmitErrors: persistentSubmitErrors,
	      fields: fields
	    }
	  };
	};
	
	var destroy = function destroy() {
	  for (var _len2 = arguments.length, form = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    form[_key2] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.DESTROY,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var focus = function focus(form, field) {
	  return {
	    type: _actionTypes.FOCUS,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var initialize = function initialize(form, values, keepDirty, otherMeta) {
	  if (otherMeta === void 0) {
	    otherMeta = {};
	  }
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: (0, _extends2["default"])({
	      form: form,
	      keepDirty: keepDirty
	    }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      type: type
	    }
	  };
	};
	
	var reset = function reset(form) {
	  return {
	    type: _actionTypes.RESET,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var resetSection = function resetSection(form) {
	  for (var _len3 = arguments.length, sections = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    sections[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.RESET_SECTION,
	    meta: {
	      form: form,
	      sections: sections
	    }
	  };
	};
	
	var startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var startSubmit = function startSubmit(form) {
	  return {
	    type: _actionTypes.START_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  return {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var stopSubmit = function stopSubmit(form, errors) {
	  return {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var submit = function submit(form) {
	  return {
	    type: _actionTypes.SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len4 = arguments.length, fields = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len5 = arguments.length, fields = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: false
	  };
	};
	
	var touch = function touch(form) {
	  for (var _len6 = arguments.length, fields = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    fields[_key6 - 1] = arguments[_key6];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var unregisterField = function unregisterField(form, name, destroyOnUnmount) {
	  if (destroyOnUnmount === void 0) {
	    destroyOnUnmount = true;
	  }
	
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      destroyOnUnmount: destroyOnUnmount
	    }
	  };
	};
	
	var untouch = function untouch(form) {
	  for (var _len7 = arguments.length, fields = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    fields[_key7 - 1] = arguments[_key7];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var updateSyncErrors = function updateSyncErrors(form, syncErrors, error) {
	  if (syncErrors === void 0) {
	    syncErrors = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncErrors: syncErrors,
	      error: error
	    }
	  };
	};
	
	var updateSyncWarnings = function updateSyncWarnings(form, syncWarnings, warning) {
	  if (syncWarnings === void 0) {
	    syncWarnings = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncWarnings: syncWarnings,
	      warning: warning
	    }
	  };
	};
	
	var actions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift,
	  autofill: autofill,
	  blur: blur,
	  change: change,
	  clearFields: clearFields,
	  clearSubmit: clearSubmit,
	  clearSubmitErrors: clearSubmitErrors,
	  clearAsyncError: clearAsyncError,
	  destroy: destroy,
	  focus: focus,
	  initialize: initialize,
	  registerField: registerField,
	  reset: reset,
	  resetSection: resetSection,
	  startAsyncValidation: startAsyncValidation,
	  startSubmit: startSubmit,
	  stopAsyncValidation: stopAsyncValidation,
	  stopSubmit: stopSubmit,
	  submit: submit,
	  setSubmitFailed: setSubmitFailed,
	  setSubmitSucceeded: setSubmitSucceeded,
	  touch: touch,
	  unregisterField: unregisterField,
	  untouch: untouch,
	  updateSyncErrors: updateSyncErrors,
	  updateSyncWarnings: updateSyncWarnings
	};
	var _default = actions;
	exports["default"] = _default;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createFieldProps;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var processProps = function processProps(type, props, _value, deepEqual) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return (0, _extends2["default"])({}, props, {
	      checked: !!value
	    });
	  }
	
	  if (type === 'radio') {
	    return (0, _extends2["default"])({}, props, {
	      checked: deepEqual(value, _value),
	      value: _value
	    });
	  }
	
	  if (type === 'select-multiple') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || []
	    });
	  }
	
	  if (type === 'file') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || undefined
	    });
	  }
	
	  return props;
	};
	
	function createFieldProps(_ref, name, _ref2) {
	  var getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      deepEqual = _ref.deepEqual;
	  var asyncError = _ref2.asyncError,
	      asyncValidating = _ref2.asyncValidating,
	      onBlur = _ref2.onBlur,
	      onChange = _ref2.onChange,
	      onDrop = _ref2.onDrop,
	      onDragStart = _ref2.onDragStart,
	      dirty = _ref2.dirty,
	      dispatch = _ref2.dispatch,
	      onFocus = _ref2.onFocus,
	      form = _ref2.form,
	      format = _ref2.format,
	      initial = _ref2.initial,
	      parse = _ref2.parse,
	      pristine = _ref2.pristine,
	      props = _ref2.props,
	      state = _ref2.state,
	      submitError = _ref2.submitError,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      validate = _ref2.validate,
	      value = _ref2.value,
	      _value = _ref2._value,
	      warn = _ref2.warn,
	      custom = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["asyncError", "asyncValidating", "onBlur", "onChange", "onDrop", "onDragStart", "dirty", "dispatch", "onFocus", "form", "format", "initial", "parse", "pristine", "props", "state", "submitError", "submitFailed", "submitting", "syncError", "syncWarning", "validate", "value", "_value", "warn"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value, deepEqual),
	    meta: (0, _extends2["default"])({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: (0, _extends2["default"])({}, custom, {}, props)
	  };
	}

/***/ },
/* 266 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	
	  switch (trigger) {
	    case 'blur':
	    case 'change':
	      // blurring
	      return true;
	
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	
	    default:
	      return false;
	  }
	};
	
	var _default = defaultShouldAsyncValidate;
	exports["default"] = _default;

/***/ },
/* 267 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldError = function defaultShouldError(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldError;
	exports["default"] = _default;

/***/ },
/* 268 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldValidate;
	exports["default"] = _default;

/***/ },
/* 269 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldWarn = function defaultShouldWarn(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldWarn;
	exports["default"] = _default;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getValue = _interopRequireDefault(__webpack_require__(620));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(272));
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	  // read value from input
	  var value = (0, _getValue["default"])(event, _isReactNative["default"]); // parse value if we have a parser
	
	  if (parse) {
	    value = parse(value, name);
	  } // normalize value
	
	
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	var _default = onChangeValue;
	exports["default"] = _default;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(169));
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent["default"])(event);
	
	  if (is) {
	    event.preventDefault();
	  }
	
	  return is;
	};
	
	var _default = silenceEvent;
	exports["default"] = _default;

/***/ },
/* 272 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	var _default = isReactNative;
	exports["default"] = _default;

/***/ },
/* 273 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsPristine;
	
	function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      if (fields && fields.length) {
	        return fields.every(function (field) {
	          var fieldInitial = getIn(formState, form + ".initial." + field);
	          var fieldValue = getIn(formState, form + ".values." + field);
	          return deepEqual(fieldInitial, fieldValue);
	        });
	      }
	
	      var initial = getIn(formState, form + ".initial") || empty;
	      var values = getIn(formState, form + ".values") || initial;
	      return deepEqual(initial, values);
	    };
	  };
	}

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(250));
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  var propsEqual = (0, _isEqualWith2["default"])(instance.props, nextProps, customizer);
	  var stateEqual = (0, _isEqualWith2["default"])(instance.state, nextState, customizer);
	  return !propsEqual || !stateEqual;
	};
	
	var _default = shallowCompare;
	exports["default"] = _default;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.save = exports.load = undefined;
	
	var _reduxActions = __webpack_require__(598);
	
	var _constants = __webpack_require__(94);
	
	var constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var load = exports.load = (0, _reduxActions.createAction)(constants.LOAD);
	var save = exports.save = (0, _reduxActions.createAction)(constants.SAVE);

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(275);
	
	exports['default'] = function (engine) {
	    return function (store) {
	        var dispatchLoad = function dispatchLoad(state) {
	            return store.dispatch((0, _actions.load)(state));
	        };
	        return engine.load().then(function (newState) {
	            dispatchLoad(newState);
	            return newState;
	        });
	    };
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(228);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(154);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _actions = __webpack_require__(275);
	
	var _constants = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function swallow() {}
	
	function warnAboutConfusingFiltering(blacklist, whitelist) {
	    blacklist.filter(function (item) {
	        return whitelist.indexOf(item) !== -1;
	    }).forEach(function (item) {
	        console.warn( // eslint-disable-line no-console
	        '[redux-storage] Action ' + item + ' is on BOTH black- and whitelist.' + ' This is most likely a mistake!');
	    });
	}
	
	function isValidAction(action) {
	    var isFunc = (0, _lodash2['default'])(action);
	    var isObj = (0, _lodash4['default'])(action);
	    var hasType = isObj && action.hasOwnProperty('type');
	
	    if (!isFunc && isObj && hasType) {
	        return true;
	    }
	
	    if (false) {
	        if (isFunc) {
	            console.warn( // eslint-disable-line no-console
	            '[redux-storage] ACTION IGNORED! Actions should be objects' + ' with a type property but received a function! Your' + ' function resolving middleware (e.g. redux-thunk) must be' + ' placed BEFORE redux-storage!');
	        } else if (!isObj) {
	            console.warn( // eslint-disable-line no-console
	            '[redux-storage] ACTION IGNORED! Actions should be objects' + (' with a type property but received: ' + action));
	        } else if (!hasType) {
	            console.warn( // eslint-disable-line no-console
	            '[redux-storage] ACTION IGNORED! Action objects should have' + ' a type property.');
	        }
	    }
	
	    return false;
	}
	
	function handleWhitelist(action, actionWhitelist) {
	    if (Array.isArray(actionWhitelist)) {
	        return actionWhitelist.length === 0 ? true // Don't filter if the whitelist is empty
	        : actionWhitelist.indexOf(action.type) !== -1;
	    }
	
	    // actionWhitelist is a function that returns true or false
	    return actionWhitelist(action);
	}
	
	exports['default'] = function (engine) {
	    var actionBlacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var actionWhitelist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    // Also don't save if we process our own actions
	    var blacklistedActions = [].concat(_toConsumableArray(actionBlacklist), [_constants.LOAD, _constants.SAVE]);
	
	    if (false) {
	        warnAboutConfusingFiltering(actionBlacklist, actionWhitelist);
	    }
	
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        return function (next) {
	            return function (action) {
	                var result = next(action);
	
	                if (!isValidAction(action)) {
	                    return result;
	                }
	
	                var isOnBlacklist = blacklistedActions.indexOf(action.type) !== -1;
	                var isOnWhitelist = handleWhitelist(action, actionWhitelist);
	
	                // Skip blacklisted actions
	                if (!isOnBlacklist && isOnWhitelist) {
	                    (function () {
	                        var saveState = getState();
	                        var saveAction = (0, _actions.save)(saveState);
	
	                        if (false) {
	                            if (!saveAction.meta) {
	                                saveAction.meta = {};
	                            }
	                            saveAction.meta.origin = action;
	                        }
	
	                        var dispatchSave = function dispatchSave() {
	                            return dispatch(saveAction);
	                        };
	                        engine.save(saveState).then(dispatchSave)['catch'](swallow);
	                    })();
	                }
	
	                return result;
	            };
	        };
	    };
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createLoader = __webpack_require__(276);
	
	Object.defineProperty(exports, 'createLoader', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_createLoader)['default'];
	    }
	});
	
	var _createMiddleware = __webpack_require__(277);
	
	Object.defineProperty(exports, 'createMiddleware', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_createMiddleware)['default'];
	    }
	});
	
	var _reducer = __webpack_require__(279);
	
	Object.defineProperty(exports, 'reducer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_reducer)['default'];
	    }
	});
	
	var _constants = __webpack_require__(94);
	
	Object.defineProperty(exports, 'LOAD', {
	    enumerable: true,
	    get: function get() {
	        return _constants.LOAD;
	    }
	});
	Object.defineProperty(exports, 'SAVE', {
	    enumerable: true,
	    get: function get() {
	        return _constants.SAVE;
	    }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// The full default export is required to be BC with redux-storage <= v1.3.2
	exports['default'] = _extends({}, __webpack_require__(94), {
	    createLoader: __webpack_require__(276)['default'],
	    createMiddleware: __webpack_require__(277)['default'],
	    reducer: __webpack_require__(279)['default']
	});

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxStorageMergerSimple = __webpack_require__(675);
	
	var _reduxStorageMergerSimple2 = _interopRequireDefault(_reduxStorageMergerSimple);
	
	var _constants = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (reducer) {
	    var merger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reduxStorageMergerSimple2['default'];
	
	    return function (state, action) {
	        return reducer(action.type === _constants.LOAD ? merger(state, action.payload) : state, action);
	    };
	};

/***/ },
/* 280 */,
/* 281 */,
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaxTag = function (_Component) {
	    _inherits(TaxTag, _Component);
	
	    function TaxTag() {
	        _classCallCheck(this, TaxTag);
	
	        return _possibleConstructorReturn(this, (TaxTag.__proto__ || Object.getPrototypeOf(TaxTag)).apply(this, arguments));
	    }
	
	    _createClass(TaxTag, [{
	        key: "render",
	        value: function render() {
	
	            return _react2.default.createElement(
	                "span",
	                { className: "tax-tag" },
	                "zzgl. USt.*"
	            );
	        }
	    }]);
	
	    return TaxTag;
	}(_react.Component);
	
	TaxTag.propTypes = {};
	exports.default = TaxTag;

/***/ },
/* 283 */,
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_Component) {
	    _inherits(Button, _Component);
	
	    function Button() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Button);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
	            if (event.key === ' ' || event.key === 'Enter') {
	                event.preventDefault(); // prevent page from scrolling
	                if (_this.props.onClick) {
	                    _this.props.onClick(event);
	                }
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Button, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'a',
	                _extends({ tabIndex: 0,
	                    role: 'button',
	                    className: 'button ' + (this.props.boldFont ? 'button--bold' : ''),
	                    onClick: this.props.onClick,
	                    onKeyDown: this.handleKeyDown
	                }, this.props),
	                this.props.label
	            );
	        }
	    }]);
	
	    return Button;
	}(_react.Component);
	
	Button.propTypes = {
	    label: _propTypes2.default.string,
	    boldFont: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func
	};
	exports.default = Button;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartPropertySelection = function (_Component) {
	    _inherits(CartPropertySelection, _Component);
	
	    function CartPropertySelection(props) {
	        _classCallCheck(this, CartPropertySelection);
	
	        var _this = _possibleConstructorReturn(this, (CartPropertySelection.__proto__ || Object.getPrototypeOf(CartPropertySelection)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.state = _this.getInitialStateObject(props);
	
	        return _this;
	    }
	
	    /*
	        componentDidMount() {
	            if(this.state.defaultOption && !this.props.activeCartProperty) {
	                this.props.selectPropertyCallback(this.state.defaultOption)
	            }
	        }*/
	
	    _createClass(CartPropertySelection, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	
	            if (this.receiveCallbackTimeout) {
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'UNSAFE_componentWillReceiveProps',
	        value: function UNSAFE_componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var selectedProperty = false;
	
	            if (!this.receiveCallbackTimeout) {
	                this.selectedBefore = this.state.selectedProperty;
	            }
	
	            if (nextProps.propertyOptions.length !== this.props.propertyOptions.length) {
	
	                if (this.state.selectedProperty !== this.state.defaultOption && this.state.defaultOption) {
	                    this.handleOptionDeSelect();
	                }
	
	                var nextState = this.getInitialStateObject(nextProps);
	
	                this.setState(nextState);
	
	                if (nextState.defaultOption) {
	                    if (this.receiveCallbackTimeout) {
	                        clearTimeout(this.receiveCallbackTimeout);
	                    }
	                    this.receiveCallbackTimeout = setTimeout(function () {
	
	                        var nextSelection = nextState.defaultOption;
	
	                        nextProps.propertyOptions.forEach(function (propertyOption) {
	                            if (propertyOption.value === _this2.selectedBefore) {
	                                nextSelection = _this2.selectedBefore;
	                            }
	                        });
	
	                        _this2.props.selectPropertyCallback(nextSelection).then(function (args) {
	                            _this2.forceUpdate();
	                            _this2.receiveCallbackTimeout = 0;
	                        });
	                    }, 350);
	                }
	
	                return;
	            }
	
	            if (nextProps.activeCartProperty === this.props.activeCartProperty) {
	                return;
	            }
	
	            nextProps.propertyOptions.forEach(function (propertyOption) {
	                if ("" + nextProps.activeCartProperty === "" + propertyOption.value) {
	                    selectedProperty = propertyOption.value;
	                }
	            });
	
	            this.setState({
	                selectedProperty: selectedProperty
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.Children.only(this.props.children(this.handleOptionSelect, this.handleOptionDeSelect, this.state.defaultOption, this.state.selectedProperty));
	        }
	    }]);
	
	    return CartPropertySelection;
	}(_react.Component);
	
	CartPropertySelection.propTypes = {
	    propertyOptions: _propTypes2.default.array.isRequired,
	    activeCartProperty: _propTypes2.default.any.isRequired,
	    selectPropertyCallback: _propTypes2.default.func.isRequired,
	    canClearOnDoubleSelect: _propTypes2.default.bool
	};
	CartPropertySelection.defaultProps = {
	    placeHolder: ""
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.receiveCallbackTimeout = 0;
	    this.selectedBefore = false;
	
	    this.getInitialStateObject = function (props) {
	
	        var initialProperty = false;
	        var defaultOption = false;
	
	        // check if one of the software options is contained in cart
	        props.propertyOptions.forEach(function (propertyOption) {
	
	            // set default if still empty
	            if (propertyOption.isDefault) {
	                defaultOption = propertyOption.value;
	                if (!initialProperty) {
	                    initialProperty = propertyOption.value;
	                }
	            }
	
	            // set cart
	            if ("" + props.activeCartProperty === "" + propertyOption.value) {
	                initialProperty = propertyOption.value;
	            }
	        });
	
	        return {
	            selectedProperty: initialProperty,
	            defaultOption: defaultOption
	        };
	    };
	
	    this.handleOptionSelect = function (clickedOption) {
	
	        if (_this3.props.cartIsBusy) {
	            return;
	        }
	
	        var selectedProperty = _this3.state.selectedProperty;
	
	        if (selectedProperty !== clickedOption) {
	            _this3.props.selectPropertyCallback(clickedOption);
	            _this3.setState({
	                selectedProperty: clickedOption
	            });
	        } else {
	
	            if (clickedOption !== _this3.state.defaultOption && _this3.props.canClearOnDoubleSelect) {
	                _this3.handleOptionDeSelect();
	            }
	        }
	    };
	
	    this.handleOptionDeSelect = function (e) {
	
	        if (_this3.state.defaultOption) {
	            _this3.setState({
	                selectedProperty: _this3.state.defaultOption
	            });
	            _this3.props.selectPropertyCallback(_this3.state.defaultOption);
	        } else {
	            _this3.setState({
	                selectedProperty: false
	            });
	            _this3.props.selectPropertyCallback(false);
	        }
	    };
	};
	
	exports.default = CartPropertySelection;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _gsap = __webpack_require__(58);
	
	var _reactDom = __webpack_require__(47);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactTransitionGroup = __webpack_require__(79);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _Util = __webpack_require__(68);
	
	var _faMinus = __webpack_require__(306);
	
	var _faPlus = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsibleInside = function (_Component) {
	    _inherits(CollapsibleInside, _Component);
	
	    function CollapsibleInside(props) {
	        _classCallCheck(this, CollapsibleInside);
	
	        var _this = _possibleConstructorReturn(this, (CollapsibleInside.__proto__ || Object.getPrototypeOf(CollapsibleInside)).call(this, props));
	
	        _this.state = {
	            isAnimating: false
	        };
	        return _this;
	    }
	
	    _createClass(CollapsibleInside, [{
	        key: 'componentWillAppear',
	        value: function componentWillAppear(callback) {
	            callback();
	        }
	    }, {
	        key: 'componentWillEnter',
	        value: function componentWillEnter(callback) {
	            var _this2 = this;
	
	            var dom = _reactDom2.default.findDOMNode(this);
	            _gsap.TweenLite.killTweensOf(dom);
	            _gsap.TweenLite.set(dom, { clearProps: "all" });
	            _gsap.TweenLite.from(dom, 0.25, {
	                ease: _gsap.Power3.ease, opacity: 0, height: 0, onComplete: function onComplete() {
	                    _this2.setState({
	                        isAnimating: false
	                    });
	                    _gsap.TweenLite.killTweensOf(dom);
	                    _gsap.TweenLite.set(dom, { clearProps: "all" });
	                    callback();
	                }
	            });
	            this.setState({
	                isAnimating: true
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var dom = _reactDom2.default.findDOMNode(this);
	            _gsap.TweenLite.killTweensOf(dom);
	            _gsap.TweenLite.set(dom, { clearProps: "all" });
	        }
	    }, {
	        key: 'componentWillLeave',
	        value: function componentWillLeave(callback) {
	            var _this3 = this;
	
	            var dom = _reactDom2.default.findDOMNode(this);
	            _gsap.TweenLite.killTweensOf(dom);
	            _gsap.TweenLite.set(dom, { clearProps: "all" });
	            _gsap.TweenLite.to(dom, 0.25, {
	                ease: _gsap.Power3.ease, opacity: 0, height: 0, onComplete: function onComplete() {
	                    _this3.setState({
	                        isAnimating: false
	                    });
	                    _gsap.TweenLite.killTweensOf(dom);
	                    _gsap.TweenLite.set(dom, { clearProps: "all" });
	                    callback();
	                }
	            });
	            this.setState({
	                isAnimating: true
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: "toggle-content__inside-wrapper " + (this.state.isAnimating ? 'animating' : '') },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'toggle-content__inside' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return CollapsibleInside;
	}(_react.Component);
	
	CollapsibleInside.propTypes = {};
	CollapsibleInside.defaultProps = {};
	
	
	function Collapsible(props) {
	
	    return _react2.default.createElement(
	        'div',
	        { className: "toggle-content" + (props.isToggled ? " toggle-content--toggled" : "") },
	        _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: props.toggleContent, className: 'toggle-content__toggle' },
	            _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: props.isToggled ? _faMinus.faMinus : _faPlus.faPlus }),
	            props.label
	        ),
	        _react2.default.createElement(
	            _reactTransitionGroup.TransitionGroup,
	            {
	                component: 'div'
	            },
	            props.isToggled && _react2.default.createElement(
	                CollapsibleInside,
	                { key: props.id },
	                props.children
	            )
	        )
	    );
	}
	
	Collapsible.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        isToggled: state.collapsibles[ownProps.id]
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	
	    return {
	        toggleContent: function toggleContent() {
	            dispatch((0, _Util.toggleCollapsibleContent)(ownProps.id));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Collapsible);

/***/ },
/* 287 */,
/* 288 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var engine = void 0;
	
	var setEngine = exports.setEngine = function setEngine(data) {
	    engine = data;
	};
	
	var getEngine = exports.getEngine = function getEngine() {
	    return engine;
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var pad = __webpack_require__(562);
	
	var codes = __webpack_require__(432);
	var data = {
	  "ar": __webpack_require__(433),
	  "cs": __webpack_require__(434),
	  "de": __webpack_require__(435),
	  "en": __webpack_require__(436),
	  "es": __webpack_require__(437),
	  "et": __webpack_require__(438),
	  "fi": __webpack_require__(439),
	  "fr": __webpack_require__(440),
	  "hu": __webpack_require__(441),
	  "it": __webpack_require__(442),
	  "nb": __webpack_require__(443),
	  "nl": __webpack_require__(444),
	  "nn": __webpack_require__(445),
	  "pl": __webpack_require__(446),
	  "pt": __webpack_require__(447),
	  "ru": __webpack_require__(448),
	  "sv": __webpack_require__(449),
	  "tr": __webpack_require__(450),
	  "zh": __webpack_require__(451)
	};
	
	/*
	 * All codes map to ISO 3166-1 alpha-2
	 */
	var alpha2 = {},
	  alpha3 = {},
	  numeric = {},
	  invertedNumeric = {};
	
	codes.forEach(function(codeInformation) {
	  "use strict";
	  var s = codeInformation;
	  alpha2[s[0]] = s[1];
	  alpha3[s[1]] = s[0];
	  numeric[s[2]] = s[0];
	  invertedNumeric[s[0]] = s[2];
	});
	
	function formatNumericCode(code) {
	  "use strict";
	  return pad(3, code, '0');
	}
	
	/*
	 * @param code Alpha-3 code
	 * @return Alpha-2 code or undefined
	 */
	function alpha3ToAlpha2(code) {
	  "use strict";
	  return alpha3[code];
	}
	exports.alpha3ToAlpha2 = alpha3ToAlpha2;
	
	/*
	 * @param code Alpha-2 code
	 * @return Alpha-3 code or undefined
	 */
	function alpha2ToAlpha3(code) {
	  "use strict";
	  return alpha2[code];
	}
	exports.alpha2ToAlpha3 = alpha2ToAlpha3;
	
	/*
	 * @param code Alpha-3 code
	 * @return Numeric code or undefined
	 */
	function alpha3ToNumeric(code) {
	  "use strict";
	  return invertedNumeric[alpha3ToAlpha2(code)];
	}
	exports.alpha3ToNumeric = alpha3ToNumeric;
	
	/*
	 * @param code Alpha-2 code
	 * @return Numeric code or undefined
	 */
	function alpha2ToNumeric(code) {
	  "use strict";
	  return invertedNumeric[code];
	}
	exports.alpha2ToNumeric = alpha2ToNumeric;
	
	/*
	 * @param code Numeric code
	 * @return Alpha-3 code or undefined
	 */
	function numericToAlpha3(code) {
	  "use strict";
	  var padded = formatNumericCode(code);
	  return alpha2ToAlpha3(numeric[padded]);
	}
	exports.numericToAlpha3 = numericToAlpha3;
	
	/*
	 * @param code Numeric code
	 * @return Alpha-2 code or undefined
	 */
	function numericToAlpha2(code) {
	  "use strict";
	  var padded = formatNumericCode(code);
	  return numeric[padded];
	}
	exports.numericToAlpha2 = numericToAlpha2;
	
	/*
	 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
	 * @return ISO 3166-1 alpha-3
	 */
	function toAlpha3(code) {
	  "use strict";
	  if (typeof code === "string") {
	    if (/^[0-9]*$/.test(code)) {
	      return numericToAlpha3(code);
	    }
	    if(code.length === 2) {
	      return alpha2ToAlpha3(code.toUpperCase());
	    }
	    if (code.length === 3) {
	      return code.toUpperCase();
	    }
	  }
	  if (typeof code === "number") {
	    return numericToAlpha3(code);
	  }
	  return undefined;
	}
	exports.toAlpha3 = toAlpha3;
	
	/*
	 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
	 * @return ISO 3166-1 alpha-2
	 */
	function toAlpha2(code) {
	  "use strict";
	  if (typeof code === "string") {
	    if (/^[0-9]*$/.test(code)) {
	      return numericToAlpha2(code);
	    }
	    if (code.length === 2) {
	      return code.toUpperCase();
	    }
	    if(code.length === 3) {
	      return alpha3ToAlpha2(code.toUpperCase());
	    }
	  }
	  if (typeof code === "number") {
	    return numericToAlpha2(code);
	  }
	  return undefined;
	}
	exports.toAlpha2 = toAlpha2;
	
	/*
	 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
	 * @param lang language for country name
	 * @return name or undefined
	 */
	exports.getName = function(code, lang) {
	  "use strict";
	  try {
	    var d = data[lang.toLowerCase()];
	    return d[toAlpha2(code)];
	  } catch (err) {
	    return undefined;
	  }
	};
	
	/*
	 * @param lang language for country name
	 * @return hash
	 */
	exports.getNames = function(lang) {
	  "use strict";
	  var d = data[lang.toLowerCase()];
	  if (d === undefined) {
	    return {};
	  }
	  return d;
	};
	
	/*
	 * @param name name
	 * @param lang language for country name
	 * @return ISO 3166-1 alpha-2 or undefined
	 */
	exports.getAlpha2Code = function(name, lang) {
	  "use strict";
	  try {
	    var p, codenames = data[lang.toLowerCase()];
	    for (p in codenames) {
	      if (codenames.hasOwnProperty(p)) {
	        if (codenames[p].toLowerCase() === name.toLowerCase()) {
	          return p;
	        }
	      }
	    }
	    return undefined;
	  } catch (err) {
	    return undefined;
	  }
	};
	
	/*
	 * @return Array of alpha-2 codes
	 */
	exports.getAlpha2Codes = function() {
	  "use strict";
	  return alpha2;
	};
	
	/*
	 * @param name name
	 * @param lang language for country name
	 * @return ISO 3166-1 alpha-3 or undefined
	 */
	exports.getAlpha3Code = function(name, lang) {
	  "use strict";
	  var alpha2 = this.getAlpha2Code(name, lang);
	  if (alpha2) {
	    return this.toAlpha3(alpha2);
	  } else {
	    return undefined;
	  }
	};
	
	/*
	 * @return Array of alpha-3 codes
	 */
	exports.getAlpha3Codes = function() {
	  "use strict";
	  return alpha3;
	};
	
	/*
	 * @return Array of numeric codes
	 */
	exports.getNumericCodes = function() {
	  "use strict";
	  return numeric;
	};
	
	/*
	 * @return Array of languages
	 */
	exports.langs = function() {
	  "use strict";
	  return Object.keys(data);
	};


/***/ },
/* 290 */,
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(565).enable();
	  window.Promise = __webpack_require__(564);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(683);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(561);


/***/ },
/* 292 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 293 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global['fontawesome-svg-core'] = {})));
	}(this, (function (exports) { 'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	      var ownKeys = Object.keys(source);
	
	      if (typeof Object.getOwnPropertySymbols === 'function') {
	        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	        }));
	      }
	
	      ownKeys.forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    }
	
	    return target;
	  }
	
	  function _slicedToArray(arr, i) {
	    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _arrayWithHoles(arr) {
	    if (Array.isArray(arr)) return arr;
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _iterableToArrayLimit(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"] != null) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  function _nonIterableRest() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	
	  var noop = function noop() {};
	
	  var _WINDOW = {};
	  var _DOCUMENT = {};
	  var _MUTATION_OBSERVER = null;
	  var _PERFORMANCE = {
	    mark: noop,
	    measure: noop
	  };
	
	  try {
	    if (typeof window !== 'undefined') _WINDOW = window;
	    if (typeof document !== 'undefined') _DOCUMENT = document;
	    if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
	    if (typeof performance !== 'undefined') _PERFORMANCE = performance;
	  } catch (e) {}
	
	  var _ref = _WINDOW.navigator || {},
	      _ref$userAgent = _ref.userAgent,
	      userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
	
	  var WINDOW = _WINDOW;
	  var DOCUMENT = _DOCUMENT;
	  var MUTATION_OBSERVER = _MUTATION_OBSERVER;
	  var PERFORMANCE = _PERFORMANCE;
	  var IS_BROWSER = !!WINDOW.document;
	  var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	  var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
	
	  var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	  var UNITS_IN_GRID = 16;
	  var DEFAULT_FAMILY_PREFIX = 'fa';
	  var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
	  var DATA_FA_I2SVG = 'data-fa-i2svg';
	  var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
	  var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
	  var DATA_PREFIX = 'data-prefix';
	  var DATA_ICON = 'data-icon';
	  var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
	  var MUTATION_APPROACH_ASYNC = 'async';
	  var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
	  var PRODUCTION = function () {
	    try {
	      return ("production") === 'production';
	    } catch (e) {
	      return false;
	    }
	  }();
	  var PREFIX_TO_STYLE = {
	    'fas': 'solid',
	    'far': 'regular',
	    'fal': 'light',
	    'fad': 'duotone',
	    'fab': 'brands',
	    'fa': 'solid'
	  };
	  var STYLE_TO_PREFIX = {
	    'solid': 'fas',
	    'regular': 'far',
	    'light': 'fal',
	    'duotone': 'fad',
	    'brands': 'fab'
	  };
	  var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
	  var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Duotone|Brands|Free|Pro)/;
	  var FONT_WEIGHT_TO_PREFIX = {
	    '900': 'fas',
	    '400': 'far',
	    'normal': 'far',
	    '300': 'fal'
	  };
	  var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	  var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
	  var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
	  var DUOTONE_CLASSES = {
	    GROUP: 'group',
	    SWAP_OPACITY: 'swap-opacity',
	    PRIMARY: 'primary',
	    SECONDARY: 'secondary'
	  };
	  var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'flip-both', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY].concat(oneToTen.map(function (n) {
	    return "".concat(n, "x");
	  })).concat(oneToTwenty.map(function (n) {
	    return "w-".concat(n);
	  }));
	
	  var initial = WINDOW.FontAwesomeConfig || {};
	
	  function getAttrConfig(attr) {
	    var element = DOCUMENT.querySelector('script[' + attr + ']');
	
	    if (element) {
	      return element.getAttribute(attr);
	    }
	  }
	
	  function coerce(val) {
	    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
	    // We'll assume that this is an indication that it should be toggled to true
	    // For example <script data-search-pseudo-elements src="..."></script>
	    if (val === '') return true;
	    if (val === 'false') return false;
	    if (val === 'true') return true;
	    return val;
	  }
	
	  if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
	    var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
	    attrs.forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          attr = _ref2[0],
	          key = _ref2[1];
	
	      var val = coerce(getAttrConfig(attr));
	
	      if (val !== undefined && val !== null) {
	        initial[key] = val;
	      }
	    });
	  }
	
	  var _default = {
	    familyPrefix: DEFAULT_FAMILY_PREFIX,
	    replacementClass: DEFAULT_REPLACEMENT_CLASS,
	    autoReplaceSvg: true,
	    autoAddCss: true,
	    autoA11y: true,
	    searchPseudoElements: false,
	    observeMutations: true,
	    mutateApproach: 'async',
	    keepOriginalSource: true,
	    measurePerformance: false,
	    showMissingIcons: true
	  };
	
	  var _config = _objectSpread({}, _default, initial);
	
	  if (!_config.autoReplaceSvg) _config.observeMutations = false;
	
	  var config = _objectSpread({}, _config);
	
	  WINDOW.FontAwesomeConfig = config;
	
	  var w = WINDOW || {};
	  if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
	  if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
	  if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
	  if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
	  var namespace = w[NAMESPACE_IDENTIFIER];
	
	  var functions = [];
	
	  var listener = function listener() {
	    DOCUMENT.removeEventListener('DOMContentLoaded', listener);
	    loaded = 1;
	    functions.map(function (fn) {
	      return fn();
	    });
	  };
	
	  var loaded = false;
	
	  if (IS_DOM) {
	    loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
	    if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
	  }
	
	  function domready (fn) {
	    if (!IS_DOM) return;
	    loaded ? setTimeout(fn, 0) : functions.push(fn);
	  }
	
	  var PENDING = 'pending';
	  var SETTLED = 'settled';
	  var FULFILLED = 'fulfilled';
	  var REJECTED = 'rejected';
	
	  var NOOP = function NOOP() {};
	
	  var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
	  var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
	  var asyncQueue = [];
	  var asyncTimer;
	
	  function asyncFlush() {
	    // run promise callbacks
	    for (var i = 0; i < asyncQueue.length; i++) {
	      asyncQueue[i][0](asyncQueue[i][1]);
	    } // reset async asyncQueue
	
	
	    asyncQueue = [];
	    asyncTimer = false;
	  }
	
	  function asyncCall(callback, arg) {
	    asyncQueue.push([callback, arg]);
	
	    if (!asyncTimer) {
	      asyncTimer = true;
	      asyncSetTimer(asyncFlush, 0);
	    }
	  }
	
	  function invokeResolver(resolver, promise) {
	    function resolvePromise(value) {
	      resolve(promise, value);
	    }
	
	    function rejectPromise(reason) {
	      reject(promise, reason);
	    }
	
	    try {
	      resolver(resolvePromise, rejectPromise);
	    } catch (e) {
	      rejectPromise(e);
	    }
	  }
	
	  function invokeCallback(subscriber) {
	    var owner = subscriber.owner;
	    var settled = owner._state;
	    var value = owner._data;
	    var callback = subscriber[settled];
	    var promise = subscriber.then;
	
	    if (typeof callback === 'function') {
	      settled = FULFILLED;
	
	      try {
	        value = callback(value);
	      } catch (e) {
	        reject(promise, e);
	      }
	    }
	
	    if (!handleThenable(promise, value)) {
	      if (settled === FULFILLED) {
	        resolve(promise, value);
	      }
	
	      if (settled === REJECTED) {
	        reject(promise, value);
	      }
	    }
	  }
	
	  function handleThenable(promise, value) {
	    var resolved;
	
	    try {
	      if (promise === value) {
	        throw new TypeError('A promises callback cannot return that same promise.');
	      }
	
	      if (value && (typeof value === 'function' || _typeof(value) === 'object')) {
	        // then should be retrieved only once
	        var then = value.then;
	
	        if (typeof then === 'function') {
	          then.call(value, function (val) {
	            if (!resolved) {
	              resolved = true;
	
	              if (value === val) {
	                fulfill(promise, val);
	              } else {
	                resolve(promise, val);
	              }
	            }
	          }, function (reason) {
	            if (!resolved) {
	              resolved = true;
	              reject(promise, reason);
	            }
	          });
	          return true;
	        }
	      }
	    } catch (e) {
	      if (!resolved) {
	        reject(promise, e);
	      }
	
	      return true;
	    }
	
	    return false;
	  }
	
	  function resolve(promise, value) {
	    if (promise === value || !handleThenable(promise, value)) {
	      fulfill(promise, value);
	    }
	  }
	
	  function fulfill(promise, value) {
	    if (promise._state === PENDING) {
	      promise._state = SETTLED;
	      promise._data = value;
	      asyncCall(publishFulfillment, promise);
	    }
	  }
	
	  function reject(promise, reason) {
	    if (promise._state === PENDING) {
	      promise._state = SETTLED;
	      promise._data = reason;
	      asyncCall(publishRejection, promise);
	    }
	  }
	
	  function publish(promise) {
	    promise._then = promise._then.forEach(invokeCallback);
	  }
	
	  function publishFulfillment(promise) {
	    promise._state = FULFILLED;
	    publish(promise);
	  }
	
	  function publishRejection(promise) {
	    promise._state = REJECTED;
	    publish(promise);
	
	    if (!promise._handled && isNode) {
	      global.process.emit('unhandledRejection', promise._data, promise);
	    }
	  }
	
	  function notifyRejectionHandled(promise) {
	    global.process.emit('rejectionHandled', promise);
	  }
	  /**
	   * @class
	   */
	
	
	  function P(resolver) {
	    if (typeof resolver !== 'function') {
	      throw new TypeError('Promise resolver ' + resolver + ' is not a function');
	    }
	
	    if (this instanceof P === false) {
	      throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
	    }
	
	    this._then = [];
	    invokeResolver(resolver, this);
	  }
	
	  P.prototype = {
	    constructor: P,
	    _state: PENDING,
	    _then: null,
	    _data: undefined,
	    _handled: false,
	    then: function then(onFulfillment, onRejection) {
	      var subscriber = {
	        owner: this,
	        then: new this.constructor(NOOP),
	        fulfilled: onFulfillment,
	        rejected: onRejection
	      };
	
	      if ((onRejection || onFulfillment) && !this._handled) {
	        this._handled = true;
	
	        if (this._state === REJECTED && isNode) {
	          asyncCall(notifyRejectionHandled, this);
	        }
	      }
	
	      if (this._state === FULFILLED || this._state === REJECTED) {
	        // already resolved, call callback async
	        asyncCall(invokeCallback, subscriber);
	      } else {
	        // subscribe
	        this._then.push(subscriber);
	      }
	
	      return subscriber.then;
	    },
	    catch: function _catch(onRejection) {
	      return this.then(null, onRejection);
	    }
	  };
	
	  P.all = function (promises) {
	    if (!Array.isArray(promises)) {
	      throw new TypeError('You must pass an array to Promise.all().');
	    }
	
	    return new P(function (resolve, reject) {
	      var results = [];
	      var remaining = 0;
	
	      function resolver(index) {
	        remaining++;
	        return function (value) {
	          results[index] = value;
	
	          if (! --remaining) {
	            resolve(results);
	          }
	        };
	      }
	
	      for (var i = 0, promise; i < promises.length; i++) {
	        promise = promises[i];
	
	        if (promise && typeof promise.then === 'function') {
	          promise.then(resolver(i), reject);
	        } else {
	          results[i] = promise;
	        }
	      }
	
	      if (!remaining) {
	        resolve(results);
	      }
	    });
	  };
	
	  P.race = function (promises) {
	    if (!Array.isArray(promises)) {
	      throw new TypeError('You must pass an array to Promise.race().');
	    }
	
	    return new P(function (resolve, reject) {
	      for (var i = 0, promise; i < promises.length; i++) {
	        promise = promises[i];
	
	        if (promise && typeof promise.then === 'function') {
	          promise.then(resolve, reject);
	        } else {
	          resolve(promise);
	        }
	      }
	    });
	  };
	
	  P.resolve = function (value) {
	    if (value && _typeof(value) === 'object' && value.constructor === P) {
	      return value;
	    }
	
	    return new P(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  P.reject = function (reason) {
	    return new P(function (resolve, reject) {
	      reject(reason);
	    });
	  };
	
	  var picked = typeof Promise === 'function' ? Promise : P;
	
	  var d = UNITS_IN_GRID;
	  var meaninglessTransform = {
	    size: 16,
	    x: 0,
	    y: 0,
	    rotate: 0,
	    flipX: false,
	    flipY: false
	  };
	
	  function isReserved(name) {
	    return ~RESERVED_CLASSES.indexOf(name);
	  }
	  function insertCss(css) {
	    if (!css || !IS_DOM) {
	      return;
	    }
	
	    var style = DOCUMENT.createElement('style');
	    style.setAttribute('type', 'text/css');
	    style.innerHTML = css;
	    var headChildren = DOCUMENT.head.childNodes;
	    var beforeChild = null;
	
	    for (var i = headChildren.length - 1; i > -1; i--) {
	      var child = headChildren[i];
	      var tagName = (child.tagName || '').toUpperCase();
	
	      if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
	        beforeChild = child;
	      }
	    }
	
	    DOCUMENT.head.insertBefore(style, beforeChild);
	    return css;
	  }
	  var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	  function nextUniqueId() {
	    var size = 12;
	    var id = '';
	
	    while (size-- > 0) {
	      id += idPool[Math.random() * 62 | 0];
	    }
	
	    return id;
	  }
	  function toArray(obj) {
	    var array = [];
	
	    for (var i = (obj || []).length >>> 0; i--;) {
	      array[i] = obj[i];
	    }
	
	    return array;
	  }
	  function classArray(node) {
	    if (node.classList) {
	      return toArray(node.classList);
	    } else {
	      return (node.getAttribute('class') || '').split(' ').filter(function (i) {
	        return i;
	      });
	    }
	  }
	  function getIconName(familyPrefix, cls) {
	    var parts = cls.split('-');
	    var prefix = parts[0];
	    var iconName = parts.slice(1).join('-');
	
	    if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
	      return iconName;
	    } else {
	      return null;
	    }
	  }
	  function htmlEscape(str) {
	    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  }
	  function joinAttributes(attributes) {
	    return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
	      return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
	    }, '').trim();
	  }
	  function joinStyles(styles) {
	    return Object.keys(styles || {}).reduce(function (acc, styleName) {
	      return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
	    }, '');
	  }
	  function transformIsMeaningful(transform) {
	    return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
	  }
	  function transformForSvg(_ref) {
	    var transform = _ref.transform,
	        containerWidth = _ref.containerWidth,
	        iconWidth = _ref.iconWidth;
	    var outer = {
	      transform: "translate(".concat(containerWidth / 2, " 256)")
	    };
	    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
	    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
	    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
	    var inner = {
	      transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
	    };
	    var path = {
	      transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
	    };
	    return {
	      outer: outer,
	      inner: inner,
	      path: path
	    };
	  }
	  function transformForCss(_ref2) {
	    var transform = _ref2.transform,
	        _ref2$width = _ref2.width,
	        width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
	        _ref2$height = _ref2.height,
	        height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
	        _ref2$startCentered = _ref2.startCentered,
	        startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
	    var val = '';
	
	    if (startCentered && IS_IE) {
	      val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
	    } else if (startCentered) {
	      val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
	    } else {
	      val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
	    }
	
	    val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
	    val += "rotate(".concat(transform.rotate, "deg) ");
	    return val;
	  }
	
	  var ALL_SPACE = {
	    x: 0,
	    y: 0,
	    width: '100%',
	    height: '100%'
	  };
	
	  function fillBlack(abstract) {
	    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (abstract.attributes && (abstract.attributes.fill || force)) {
	      abstract.attributes.fill = 'black';
	    }
	
	    return abstract;
	  }
	
	  function deGroup(abstract) {
	    if (abstract.tag === 'g') {
	      return abstract.children;
	    } else {
	      return [abstract];
	    }
	  }
	
	  function makeIconMasking (_ref) {
	    var children = _ref.children,
	        attributes = _ref.attributes,
	        main = _ref.main,
	        mask = _ref.mask,
	        explicitMaskId = _ref.maskId,
	        transform = _ref.transform;
	    var mainWidth = main.width,
	        mainPath = main.icon;
	    var maskWidth = mask.width,
	        maskPath = mask.icon;
	    var trans = transformForSvg({
	      transform: transform,
	      containerWidth: maskWidth,
	      iconWidth: mainWidth
	    });
	    var maskRect = {
	      tag: 'rect',
	      attributes: _objectSpread({}, ALL_SPACE, {
	        fill: 'white'
	      })
	    };
	    var maskInnerGroupChildrenMixin = mainPath.children ? {
	      children: mainPath.children.map(fillBlack)
	    } : {};
	    var maskInnerGroup = {
	      tag: 'g',
	      attributes: _objectSpread({}, trans.inner),
	      children: [fillBlack(_objectSpread({
	        tag: mainPath.tag,
	        attributes: _objectSpread({}, mainPath.attributes, trans.path)
	      }, maskInnerGroupChildrenMixin))]
	    };
	    var maskOuterGroup = {
	      tag: 'g',
	      attributes: _objectSpread({}, trans.outer),
	      children: [maskInnerGroup]
	    };
	    var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
	    var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
	    var maskTag = {
	      tag: 'mask',
	      attributes: _objectSpread({}, ALL_SPACE, {
	        id: maskId,
	        maskUnits: 'userSpaceOnUse',
	        maskContentUnits: 'userSpaceOnUse'
	      }),
	      children: [maskRect, maskOuterGroup]
	    };
	    var defs = {
	      tag: 'defs',
	      children: [{
	        tag: 'clipPath',
	        attributes: {
	          id: clipId
	        },
	        children: deGroup(maskPath)
	      }, maskTag]
	    };
	    children.push(defs, {
	      tag: 'rect',
	      attributes: _objectSpread({
	        fill: 'currentColor',
	        'clip-path': "url(#".concat(clipId, ")"),
	        mask: "url(#".concat(maskId, ")")
	      }, ALL_SPACE)
	    });
	    return {
	      children: children,
	      attributes: attributes
	    };
	  }
	
	  function makeIconStandard (_ref) {
	    var children = _ref.children,
	        attributes = _ref.attributes,
	        main = _ref.main,
	        transform = _ref.transform,
	        styles = _ref.styles;
	    var styleString = joinStyles(styles);
	
	    if (styleString.length > 0) {
	      attributes['style'] = styleString;
	    }
	
	    if (transformIsMeaningful(transform)) {
	      var trans = transformForSvg({
	        transform: transform,
	        containerWidth: main.width,
	        iconWidth: main.width
	      });
	      children.push({
	        tag: 'g',
	        attributes: _objectSpread({}, trans.outer),
	        children: [{
	          tag: 'g',
	          attributes: _objectSpread({}, trans.inner),
	          children: [{
	            tag: main.icon.tag,
	            children: main.icon.children,
	            attributes: _objectSpread({}, main.icon.attributes, trans.path)
	          }]
	        }]
	      });
	    } else {
	      children.push(main.icon);
	    }
	
	    return {
	      children: children,
	      attributes: attributes
	    };
	  }
	
	  function asIcon (_ref) {
	    var children = _ref.children,
	        main = _ref.main,
	        mask = _ref.mask,
	        attributes = _ref.attributes,
	        styles = _ref.styles,
	        transform = _ref.transform;
	
	    if (transformIsMeaningful(transform) && main.found && !mask.found) {
	      var width = main.width,
	          height = main.height;
	      var offset = {
	        x: width / height / 2,
	        y: 0.5
	      };
	      attributes['style'] = joinStyles(_objectSpread({}, styles, {
	        'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
	      }));
	    }
	
	    return [{
	      tag: 'svg',
	      attributes: attributes,
	      children: children
	    }];
	  }
	
	  function asSymbol (_ref) {
	    var prefix = _ref.prefix,
	        iconName = _ref.iconName,
	        children = _ref.children,
	        attributes = _ref.attributes,
	        symbol = _ref.symbol;
	    var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
	    return [{
	      tag: 'svg',
	      attributes: {
	        style: 'display: none;'
	      },
	      children: [{
	        tag: 'symbol',
	        attributes: _objectSpread({}, attributes, {
	          id: id
	        }),
	        children: children
	      }]
	    }];
	  }
	
	  function makeInlineSvgAbstract(params) {
	    var _params$icons = params.icons,
	        main = _params$icons.main,
	        mask = _params$icons.mask,
	        prefix = params.prefix,
	        iconName = params.iconName,
	        transform = params.transform,
	        symbol = params.symbol,
	        title = params.title,
	        maskId = params.maskId,
	        titleId = params.titleId,
	        extra = params.extra,
	        _params$watchable = params.watchable,
	        watchable = _params$watchable === void 0 ? false : _params$watchable;
	
	    var _ref = mask.found ? mask : main,
	        width = _ref.width,
	        height = _ref.height;
	
	    var widthClass = "fa-w-".concat(Math.ceil(width / height * 16));
	    var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
	      return extra.classes.indexOf(c) === -1;
	    }).concat(extra.classes).join(' ');
	    var content = {
	      children: [],
	      attributes: _objectSpread({}, extra.attributes, {
	        'data-prefix': prefix,
	        'data-icon': iconName,
	        'class': attrClass,
	        'role': extra.attributes.role || 'img',
	        'xmlns': 'http://www.w3.org/2000/svg',
	        'viewBox': "0 0 ".concat(width, " ").concat(height)
	      })
	    };
	
	    if (watchable) {
	      content.attributes[DATA_FA_I2SVG] = '';
	    }
	
	    if (title) content.children.push({
	      tag: 'title',
	      attributes: {
	        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
	      },
	      children: [title]
	    });
	
	    var args = _objectSpread({}, content, {
	      prefix: prefix,
	      iconName: iconName,
	      main: main,
	      mask: mask,
	      maskId: maskId,
	      transform: transform,
	      symbol: symbol,
	      styles: extra.styles
	    });
	
	    var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
	        children = _ref2.children,
	        attributes = _ref2.attributes;
	
	    args.children = children;
	    args.attributes = attributes;
	
	    if (symbol) {
	      return asSymbol(args);
	    } else {
	      return asIcon(args);
	    }
	  }
	  function makeLayersTextAbstract(params) {
	    var content = params.content,
	        width = params.width,
	        height = params.height,
	        transform = params.transform,
	        title = params.title,
	        extra = params.extra,
	        _params$watchable2 = params.watchable,
	        watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
	
	    var attributes = _objectSpread({}, extra.attributes, title ? {
	      'title': title
	    } : {}, {
	      'class': extra.classes.join(' ')
	    });
	
	    if (watchable) {
	      attributes[DATA_FA_I2SVG] = '';
	    }
	
	    var styles = _objectSpread({}, extra.styles);
	
	    if (transformIsMeaningful(transform)) {
	      styles['transform'] = transformForCss({
	        transform: transform,
	        startCentered: true,
	        width: width,
	        height: height
	      });
	      styles['-webkit-transform'] = styles['transform'];
	    }
	
	    var styleString = joinStyles(styles);
	
	    if (styleString.length > 0) {
	      attributes['style'] = styleString;
	    }
	
	    var val = [];
	    val.push({
	      tag: 'span',
	      attributes: attributes,
	      children: [content]
	    });
	
	    if (title) {
	      val.push({
	        tag: 'span',
	        attributes: {
	          class: 'sr-only'
	        },
	        children: [title]
	      });
	    }
	
	    return val;
	  }
	  function makeLayersCounterAbstract(params) {
	    var content = params.content,
	        title = params.title,
	        extra = params.extra;
	
	    var attributes = _objectSpread({}, extra.attributes, title ? {
	      'title': title
	    } : {}, {
	      'class': extra.classes.join(' ')
	    });
	
	    var styleString = joinStyles(extra.styles);
	
	    if (styleString.length > 0) {
	      attributes['style'] = styleString;
	    }
	
	    var val = [];
	    val.push({
	      tag: 'span',
	      attributes: attributes,
	      children: [content]
	    });
	
	    if (title) {
	      val.push({
	        tag: 'span',
	        attributes: {
	          class: 'sr-only'
	        },
	        children: [title]
	      });
	    }
	
	    return val;
	  }
	
	  var noop$1 = function noop() {};
	
	  var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
	    mark: noop$1,
	    measure: noop$1
	  };
	  var preamble = "FA \"5.14.0\"";
	
	  var begin = function begin(name) {
	    p.mark("".concat(preamble, " ").concat(name, " begins"));
	    return function () {
	      return end(name);
	    };
	  };
	
	  var end = function end(name) {
	    p.mark("".concat(preamble, " ").concat(name, " ends"));
	    p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
	  };
	
	  var perf = {
	    begin: begin,
	    end: end
	  };
	
	  /**
	   * Internal helper to bind a function known to have 4 arguments
	   * to a given context.
	   */
	
	  var bindInternal4 = function bindInternal4(func, thisContext) {
	    return function (a, b, c, d) {
	      return func.call(thisContext, a, b, c, d);
	    };
	  };
	
	  /**
	   * # Reduce
	   *
	   * A fast object `.reduce()` implementation.
	   *
	   * @param  {Object}   subject      The object to reduce over.
	   * @param  {Function} fn           The reducer function.
	   * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
	   * @param  {Object}   thisContext  The context for the reducer.
	   * @return {mixed}                 The final result.
	   */
	
	
	  var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
	    var keys = Object.keys(subject),
	        length = keys.length,
	        iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
	        i,
	        key,
	        result;
	
	    if (initialValue === undefined) {
	      i = 1;
	      result = subject[keys[0]];
	    } else {
	      i = 0;
	      result = initialValue;
	    }
	
	    for (; i < length; i++) {
	      key = keys[i];
	      result = iterator(result, subject[key], key, subject);
	    }
	
	    return result;
	  };
	
	  function toHex(unicode) {
	    var result = '';
	
	    for (var i = 0; i < unicode.length; i++) {
	      var hex = unicode.charCodeAt(i).toString(16);
	      result += ('000' + hex).slice(-4);
	    }
	
	    return result;
	  }
	
	  function defineIcons(prefix, icons) {
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _params$skipHooks = params.skipHooks,
	        skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
	    var normalized = Object.keys(icons).reduce(function (acc, iconName) {
	      var icon = icons[iconName];
	      var expanded = !!icon.icon;
	
	      if (expanded) {
	        acc[icon.iconName] = icon.icon;
	      } else {
	        acc[iconName] = icon;
	      }
	
	      return acc;
	    }, {});
	
	    if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
	      namespace.hooks.addPack(prefix, normalized);
	    } else {
	      namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
	    }
	    /**
	     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
	     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
	     * for `fas` so we'll easy the upgrade process for our users by automatically defining
	     * this as well.
	     */
	
	
	    if (prefix === 'fas') {
	      defineIcons('fa', icons);
	    }
	  }
	
	  var styles = namespace.styles,
	      shims = namespace.shims;
	  var _byUnicode = {};
	  var _byLigature = {};
	  var _byOldName = {};
	  var build = function build() {
	    var lookup = function lookup(reducer) {
	      return reduce(styles, function (o, style, prefix) {
	        o[prefix] = reduce(style, reducer, {});
	        return o;
	      }, {});
	    };
	
	    _byUnicode = lookup(function (acc, icon, iconName) {
	      if (icon[3]) {
	        acc[icon[3]] = iconName;
	      }
	
	      return acc;
	    });
	    _byLigature = lookup(function (acc, icon, iconName) {
	      var ligatures = icon[2];
	      acc[iconName] = iconName;
	      ligatures.forEach(function (ligature) {
	        acc[ligature] = iconName;
	      });
	      return acc;
	    });
	    var hasRegular = 'far' in styles;
	    _byOldName = reduce(shims, function (acc, shim) {
	      var oldName = shim[0];
	      var prefix = shim[1];
	      var iconName = shim[2];
	
	      if (prefix === 'far' && !hasRegular) {
	        prefix = 'fas';
	      }
	
	      acc[oldName] = {
	        prefix: prefix,
	        iconName: iconName
	      };
	      return acc;
	    }, {});
	  };
	  build();
	  function byUnicode(prefix, unicode) {
	    return (_byUnicode[prefix] || {})[unicode];
	  }
	  function byLigature(prefix, ligature) {
	    return (_byLigature[prefix] || {})[ligature];
	  }
	  function byOldName(name) {
	    return _byOldName[name] || {
	      prefix: null,
	      iconName: null
	    };
	  }
	
	  var styles$1 = namespace.styles;
	  var emptyCanonicalIcon = function emptyCanonicalIcon() {
	    return {
	      prefix: null,
	      iconName: null,
	      rest: []
	    };
	  };
	  function getCanonicalIcon(values) {
	    return values.reduce(function (acc, cls) {
	      var iconName = getIconName(config.familyPrefix, cls);
	
	      if (styles$1[cls]) {
	        acc.prefix = cls;
	      } else if (config.autoFetchSvg && ['fas', 'far', 'fal', 'fad', 'fab', 'fa'].indexOf(cls) > -1) {
	        acc.prefix = cls;
	      } else if (iconName) {
	        var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};
	        acc.iconName = shim.iconName || iconName;
	        acc.prefix = shim.prefix || acc.prefix;
	      } else if (cls !== config.replacementClass && cls.indexOf('fa-w-') !== 0) {
	        acc.rest.push(cls);
	      }
	
	      return acc;
	    }, emptyCanonicalIcon());
	  }
	  function iconFromMapping(mapping, prefix, iconName) {
	    if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
	      return {
	        prefix: prefix,
	        iconName: iconName,
	        icon: mapping[prefix][iconName]
	      };
	    }
	  }
	
	  function toHtml(abstractNodes) {
	    var tag = abstractNodes.tag,
	        _abstractNodes$attrib = abstractNodes.attributes,
	        attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
	        _abstractNodes$childr = abstractNodes.children,
	        children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
	
	    if (typeof abstractNodes === 'string') {
	      return htmlEscape(abstractNodes);
	    } else {
	      return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
	    }
	  }
	
	  var noop$2 = function noop() {};
	
	  function isWatched(node) {
	    var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
	    return typeof i2svg === 'string';
	  }
	
	  function getMutator() {
	    if (config.autoReplaceSvg === true) {
	      return mutators.replace;
	    }
	
	    var mutator = mutators[config.autoReplaceSvg];
	    return mutator || mutators.replace;
	  }
	
	  var mutators = {
	    replace: function replace(mutation) {
	      var node = mutation[0];
	      var abstract = mutation[1];
	      var newOuterHTML = abstract.map(function (a) {
	        return toHtml(a);
	      }).join('\n');
	
	      if (node.parentNode && node.outerHTML) {
	        node.outerHTML = newOuterHTML + (config.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? "<!-- ".concat(node.outerHTML, " -->") : '');
	      } else if (node.parentNode) {
	        var newNode = document.createElement('span');
	        node.parentNode.replaceChild(newNode, node);
	        newNode.outerHTML = newOuterHTML;
	      }
	    },
	    nest: function nest(mutation) {
	      var node = mutation[0];
	      var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
	      // Short-circuit to the standard replacement
	
	      if (~classArray(node).indexOf(config.replacementClass)) {
	        return mutators.replace(mutation);
	      }
	
	      var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
	      delete abstract[0].attributes.style;
	      delete abstract[0].attributes.id;
	      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
	        if (cls === config.replacementClass || cls.match(forSvg)) {
	          acc.toSvg.push(cls);
	        } else {
	          acc.toNode.push(cls);
	        }
	
	        return acc;
	      }, {
	        toNode: [],
	        toSvg: []
	      });
	      abstract[0].attributes.class = splitClasses.toSvg.join(' ');
	      var newInnerHTML = abstract.map(function (a) {
	        return toHtml(a);
	      }).join('\n');
	      node.setAttribute('class', splitClasses.toNode.join(' '));
	      node.setAttribute(DATA_FA_I2SVG, '');
	      node.innerHTML = newInnerHTML;
	    }
	  };
	
	  function performOperationSync(op) {
	    op();
	  }
	
	  function perform(mutations, callback) {
	    var callbackFunction = typeof callback === 'function' ? callback : noop$2;
	
	    if (mutations.length === 0) {
	      callbackFunction();
	    } else {
	      var frame = performOperationSync;
	
	      if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
	        frame = WINDOW.requestAnimationFrame || performOperationSync;
	      }
	
	      frame(function () {
	        var mutator = getMutator();
	        var mark = perf.begin('mutate');
	        mutations.map(mutator);
	        mark();
	        callbackFunction();
	      });
	    }
	  }
	  var disabled = false;
	  function disableObservation() {
	    disabled = true;
	  }
	  function enableObservation() {
	    disabled = false;
	  }
	  var mo = null;
	  function observe(options) {
	    if (!MUTATION_OBSERVER) {
	      return;
	    }
	
	    if (!config.observeMutations) {
	      return;
	    }
	
	    var treeCallback = options.treeCallback,
	        nodeCallback = options.nodeCallback,
	        pseudoElementsCallback = options.pseudoElementsCallback,
	        _options$observeMutat = options.observeMutationsRoot,
	        observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
	    mo = new MUTATION_OBSERVER(function (objects) {
	      if (disabled) return;
	      toArray(objects).forEach(function (mutationRecord) {
	        if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
	          if (config.searchPseudoElements) {
	            pseudoElementsCallback(mutationRecord.target);
	          }
	
	          treeCallback(mutationRecord.target);
	        }
	
	        if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
	          pseudoElementsCallback(mutationRecord.target.parentNode);
	        }
	
	        if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
	          if (mutationRecord.attributeName === 'class') {
	            var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
	                prefix = _getCanonicalIcon.prefix,
	                iconName = _getCanonicalIcon.iconName;
	
	            if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
	            if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
	          } else {
	            nodeCallback(mutationRecord.target);
	          }
	        }
	      });
	    });
	    if (!IS_DOM) return;
	    mo.observe(observeMutationsRoot, {
	      childList: true,
	      attributes: true,
	      characterData: true,
	      subtree: true
	    });
	  }
	  function disconnect() {
	    if (!mo) return;
	    mo.disconnect();
	  }
	
	  function styleParser (node) {
	    var style = node.getAttribute('style');
	    var val = [];
	
	    if (style) {
	      val = style.split(';').reduce(function (acc, style) {
	        var styles = style.split(':');
	        var prop = styles[0];
	        var value = styles.slice(1);
	
	        if (prop && value.length > 0) {
	          acc[prop] = value.join(':').trim();
	        }
	
	        return acc;
	      }, {});
	    }
	
	    return val;
	  }
	
	  function classParser (node) {
	    var existingPrefix = node.getAttribute('data-prefix');
	    var existingIconName = node.getAttribute('data-icon');
	    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
	    var val = getCanonicalIcon(classArray(node));
	
	    if (existingPrefix && existingIconName) {
	      val.prefix = existingPrefix;
	      val.iconName = existingIconName;
	    }
	
	    if (val.prefix && innerText.length > 1) {
	      val.iconName = byLigature(val.prefix, node.innerText);
	    } else if (val.prefix && innerText.length === 1) {
	      val.iconName = byUnicode(val.prefix, toHex(node.innerText));
	    }
	
	    return val;
	  }
	
	  var parseTransformString = function parseTransformString(transformString) {
	    var transform = {
	      size: 16,
	      x: 0,
	      y: 0,
	      flipX: false,
	      flipY: false,
	      rotate: 0
	    };
	
	    if (!transformString) {
	      return transform;
	    } else {
	      return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
	        var parts = n.toLowerCase().split('-');
	        var first = parts[0];
	        var rest = parts.slice(1).join('-');
	
	        if (first && rest === 'h') {
	          acc.flipX = true;
	          return acc;
	        }
	
	        if (first && rest === 'v') {
	          acc.flipY = true;
	          return acc;
	        }
	
	        rest = parseFloat(rest);
	
	        if (isNaN(rest)) {
	          return acc;
	        }
	
	        switch (first) {
	          case 'grow':
	            acc.size = acc.size + rest;
	            break;
	
	          case 'shrink':
	            acc.size = acc.size - rest;
	            break;
	
	          case 'left':
	            acc.x = acc.x - rest;
	            break;
	
	          case 'right':
	            acc.x = acc.x + rest;
	            break;
	
	          case 'up':
	            acc.y = acc.y - rest;
	            break;
	
	          case 'down':
	            acc.y = acc.y + rest;
	            break;
	
	          case 'rotate':
	            acc.rotate = acc.rotate + rest;
	            break;
	        }
	
	        return acc;
	      }, transform);
	    }
	  };
	  function transformParser (node) {
	    return parseTransformString(node.getAttribute('data-fa-transform'));
	  }
	
	  function symbolParser (node) {
	    var symbol = node.getAttribute('data-fa-symbol');
	    return symbol === null ? false : symbol === '' ? true : symbol;
	  }
	
	  function attributesParser (node) {
	    var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
	      if (acc.name !== 'class' && acc.name !== 'style') {
	        acc[attr.name] = attr.value;
	      }
	
	      return acc;
	    }, {});
	    var title = node.getAttribute('title');
	    var titleId = node.getAttribute('data-fa-title-id');
	
	    if (config.autoA11y) {
	      if (title) {
	        extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
	      } else {
	        extraAttributes['aria-hidden'] = 'true';
	        extraAttributes['focusable'] = 'false';
	      }
	    }
	
	    return extraAttributes;
	  }
	
	  function maskParser (node) {
	    var mask = node.getAttribute('data-fa-mask');
	
	    if (!mask) {
	      return emptyCanonicalIcon();
	    } else {
	      return getCanonicalIcon(mask.split(' ').map(function (i) {
	        return i.trim();
	      }));
	    }
	  }
	
	  function blankMeta() {
	    return {
	      iconName: null,
	      title: null,
	      titleId: null,
	      prefix: null,
	      transform: meaninglessTransform,
	      symbol: false,
	      mask: null,
	      maskId: null,
	      extra: {
	        classes: [],
	        styles: {},
	        attributes: {}
	      }
	    };
	  }
	  function parseMeta(node) {
	    var _classParser = classParser(node),
	        iconName = _classParser.iconName,
	        prefix = _classParser.prefix,
	        extraClasses = _classParser.rest;
	
	    var extraStyles = styleParser(node);
	    var transform = transformParser(node);
	    var symbol = symbolParser(node);
	    var extraAttributes = attributesParser(node);
	    var mask = maskParser(node);
	    return {
	      iconName: iconName,
	      title: node.getAttribute('title'),
	      titleId: node.getAttribute('data-fa-title-id'),
	      prefix: prefix,
	      transform: transform,
	      symbol: symbol,
	      mask: mask,
	      maskId: node.getAttribute('data-fa-mask-id'),
	      extra: {
	        classes: extraClasses,
	        styles: extraStyles,
	        attributes: extraAttributes
	      }
	    };
	  }
	
	  function MissingIcon(error) {
	    this.name = 'MissingIcon';
	    this.message = error || 'Icon unavailable';
	    this.stack = new Error().stack;
	  }
	  MissingIcon.prototype = Object.create(Error.prototype);
	  MissingIcon.prototype.constructor = MissingIcon;
	
	  var FILL = {
	    fill: 'currentColor'
	  };
	  var ANIMATION_BASE = {
	    attributeType: 'XML',
	    repeatCount: 'indefinite',
	    dur: '2s'
	  };
	  var RING = {
	    tag: 'path',
	    attributes: _objectSpread({}, FILL, {
	      d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
	    })
	  };
	
	  var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
	    attributeName: 'opacity'
	  });
	
	  var DOT = {
	    tag: 'circle',
	    attributes: _objectSpread({}, FILL, {
	      cx: '256',
	      cy: '364',
	      r: '28'
	    }),
	    children: [{
	      tag: 'animate',
	      attributes: _objectSpread({}, ANIMATION_BASE, {
	        attributeName: 'r',
	        values: '28;14;28;28;14;28;'
	      })
	    }, {
	      tag: 'animate',
	      attributes: _objectSpread({}, OPACITY_ANIMATE, {
	        values: '1;0;1;1;0;1;'
	      })
	    }]
	  };
	  var QUESTION = {
	    tag: 'path',
	    attributes: _objectSpread({}, FILL, {
	      opacity: '1',
	      d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
	    }),
	    children: [{
	      tag: 'animate',
	      attributes: _objectSpread({}, OPACITY_ANIMATE, {
	        values: '1;0;0;0;0;1;'
	      })
	    }]
	  };
	  var EXCLAMATION = {
	    tag: 'path',
	    attributes: _objectSpread({}, FILL, {
	      opacity: '0',
	      d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
	    }),
	    children: [{
	      tag: 'animate',
	      attributes: _objectSpread({}, OPACITY_ANIMATE, {
	        values: '0;0;1;1;0;0;'
	      })
	    }]
	  };
	  var missing = {
	    tag: 'g',
	    children: [RING, DOT, QUESTION, EXCLAMATION]
	  };
	
	  var styles$2 = namespace.styles;
	  function asFoundIcon(icon) {
	    var width = icon[0];
	    var height = icon[1];
	
	    var _icon$slice = icon.slice(4),
	        _icon$slice2 = _slicedToArray(_icon$slice, 1),
	        vectorData = _icon$slice2[0];
	
	    var element = null;
	
	    if (Array.isArray(vectorData)) {
	      element = {
	        tag: 'g',
	        attributes: {
	          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
	        },
	        children: [{
	          tag: 'path',
	          attributes: {
	            class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
	            fill: 'currentColor',
	            d: vectorData[0]
	          }
	        }, {
	          tag: 'path',
	          attributes: {
	            class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
	            fill: 'currentColor',
	            d: vectorData[1]
	          }
	        }]
	      };
	    } else {
	      element = {
	        tag: 'path',
	        attributes: {
	          fill: 'currentColor',
	          d: vectorData
	        }
	      };
	    }
	
	    return {
	      found: true,
	      width: width,
	      height: height,
	      icon: element
	    };
	  }
	  function findIcon(iconName, prefix) {
	    return new picked(function (resolve, reject) {
	      var val = {
	        found: false,
	        width: 512,
	        height: 512,
	        icon: missing
	      };
	
	      if (iconName && prefix && styles$2[prefix] && styles$2[prefix][iconName]) {
	        var icon = styles$2[prefix][iconName];
	        return resolve(asFoundIcon(icon));
	      }
	
	      var headers = {};
	
	      if (_typeof(WINDOW.FontAwesomeKitConfig) === 'object' && typeof window.FontAwesomeKitConfig.token === 'string') {
	        headers['fa-kit-token'] = WINDOW.FontAwesomeKitConfig.token;
	      }
	
	      if (iconName && prefix && !config.showMissingIcons) {
	        reject(new MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
	      } else {
	        resolve(val);
	      }
	    });
	  }
	
	  var styles$3 = namespace.styles;
	
	  function generateSvgReplacementMutation(node, nodeMeta) {
	    var iconName = nodeMeta.iconName,
	        title = nodeMeta.title,
	        titleId = nodeMeta.titleId,
	        prefix = nodeMeta.prefix,
	        transform = nodeMeta.transform,
	        symbol = nodeMeta.symbol,
	        mask = nodeMeta.mask,
	        maskId = nodeMeta.maskId,
	        extra = nodeMeta.extra;
	    return new picked(function (resolve, reject) {
	      picked.all([findIcon(iconName, prefix), findIcon(mask.iconName, mask.prefix)]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            main = _ref2[0],
	            mask = _ref2[1];
	
	        resolve([node, makeInlineSvgAbstract({
	          icons: {
	            main: main,
	            mask: mask
	          },
	          prefix: prefix,
	          iconName: iconName,
	          transform: transform,
	          symbol: symbol,
	          mask: mask,
	          maskId: maskId,
	          title: title,
	          titleId: titleId,
	          extra: extra,
	          watchable: true
	        })]);
	      });
	    });
	  }
	
	  function generateLayersText(node, nodeMeta) {
	    var title = nodeMeta.title,
	        transform = nodeMeta.transform,
	        extra = nodeMeta.extra;
	    var width = null;
	    var height = null;
	
	    if (IS_IE) {
	      var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
	      var boundingClientRect = node.getBoundingClientRect();
	      width = boundingClientRect.width / computedFontSize;
	      height = boundingClientRect.height / computedFontSize;
	    }
	
	    if (config.autoA11y && !title) {
	      extra.attributes['aria-hidden'] = 'true';
	    }
	
	    return picked.resolve([node, makeLayersTextAbstract({
	      content: node.innerHTML,
	      width: width,
	      height: height,
	      transform: transform,
	      title: title,
	      extra: extra,
	      watchable: true
	    })]);
	  }
	
	  function generateMutation(node) {
	    var nodeMeta = parseMeta(node);
	
	    if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
	      return generateLayersText(node, nodeMeta);
	    } else {
	      return generateSvgReplacementMutation(node, nodeMeta);
	    }
	  }
	
	  function onTree(root) {
	    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    if (!IS_DOM) return;
	    var htmlClassList = DOCUMENT.documentElement.classList;
	
	    var hclAdd = function hclAdd(suffix) {
	      return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
	    };
	
	    var hclRemove = function hclRemove(suffix) {
	      return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
	    };
	
	    var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$3);
	    var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
	      return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
	    })).join(', ');
	
	    if (prefixesDomQuery.length === 0) {
	      return;
	    }
	
	    var candidates = [];
	
	    try {
	      candidates = toArray(root.querySelectorAll(prefixesDomQuery));
	    } catch (e) {// noop
	    }
	
	    if (candidates.length > 0) {
	      hclAdd('pending');
	      hclRemove('complete');
	    } else {
	      return;
	    }
	
	    var mark = perf.begin('onTree');
	    var mutations = candidates.reduce(function (acc, node) {
	      try {
	        var mutation = generateMutation(node);
	
	        if (mutation) {
	          acc.push(mutation);
	        }
	      } catch (e) {
	        if (!PRODUCTION) {
	          if (e instanceof MissingIcon) {
	            console.error(e);
	          }
	        }
	      }
	
	      return acc;
	    }, []);
	    return new picked(function (resolve, reject) {
	      picked.all(mutations).then(function (resolvedMutations) {
	        perform(resolvedMutations, function () {
	          hclAdd('active');
	          hclAdd('complete');
	          hclRemove('pending');
	          if (typeof callback === 'function') callback();
	          mark();
	          resolve();
	        });
	      }).catch(function () {
	        mark();
	        reject();
	      });
	    });
	  }
	  function onNode(node) {
	    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    generateMutation(node).then(function (mutation) {
	      if (mutation) {
	        perform([mutation], callback);
	      }
	    });
	  }
	
	  function replaceForPosition(node, position) {
	    var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
	    return new picked(function (resolve, reject) {
	      if (node.getAttribute(pendingAttribute) !== null) {
	        // This node is already being processed
	        return resolve();
	      }
	
	      var children = toArray(node.children);
	      var alreadyProcessedPseudoElement = children.filter(function (c) {
	        return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
	      })[0];
	      var styles = WINDOW.getComputedStyle(node, position);
	      var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
	      var fontWeight = styles.getPropertyValue('font-weight');
	      var content = styles.getPropertyValue('content');
	
	      if (alreadyProcessedPseudoElement && !fontFamily) {
	        // If we've already processed it but the current computed style does not result in a font-family,
	        // that probably means that a class name that was previously present to make the icon has been
	        // removed. So we now should delete the icon.
	        node.removeChild(alreadyProcessedPseudoElement);
	        return resolve();
	      } else if (fontFamily && content !== 'none' && content !== '') {
	        var prefix = ~['Solid', 'Regular', 'Light', 'Duotone', 'Brands'].indexOf(fontFamily[1]) ? STYLE_TO_PREFIX[fontFamily[1].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
	        var hexValue = toHex(content.length === 3 ? content.substr(1, 1) : content);
	        var iconName = byUnicode(prefix, hexValue);
	        var iconIdentifier = iconName; // Only convert the pseudo element in this :before/:after position into an icon if we haven't
	        // already done so with the same prefix and iconName
	
	        if (iconName && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
	          node.setAttribute(pendingAttribute, iconIdentifier);
	
	          if (alreadyProcessedPseudoElement) {
	            // Delete the old one, since we're replacing it with a new one
	            node.removeChild(alreadyProcessedPseudoElement);
	          }
	
	          var meta = blankMeta();
	          var extra = meta.extra;
	          extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
	          findIcon(iconName, prefix).then(function (main) {
	            var abstract = makeInlineSvgAbstract(_objectSpread({}, meta, {
	              icons: {
	                main: main,
	                mask: emptyCanonicalIcon()
	              },
	              prefix: prefix,
	              iconName: iconIdentifier,
	              extra: extra,
	              watchable: true
	            }));
	            var element = DOCUMENT.createElement('svg');
	
	            if (position === ':before') {
	              node.insertBefore(element, node.firstChild);
	            } else {
	              node.appendChild(element);
	            }
	
	            element.outerHTML = abstract.map(function (a) {
	              return toHtml(a);
	            }).join('\n');
	            node.removeAttribute(pendingAttribute);
	            resolve();
	          }).catch(reject);
	        } else {
	          resolve();
	        }
	      } else {
	        resolve();
	      }
	    });
	  }
	
	  function replace(node) {
	    return picked.all([replaceForPosition(node, ':before'), replaceForPosition(node, ':after')]);
	  }
	
	  function processable(node) {
	    return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
	  }
	
	  function searchPseudoElements (root) {
	    if (!IS_DOM) return;
	    return new picked(function (resolve, reject) {
	      var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
	      var end = perf.begin('searchPseudoElements');
	      disableObservation();
	      picked.all(operations).then(function () {
	        end();
	        enableObservation();
	        resolve();
	      }).catch(function () {
	        end();
	        enableObservation();
	        reject();
	      });
	    });
	  }
	
	  var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";
	
	  function css () {
	    var dfp = DEFAULT_FAMILY_PREFIX;
	    var drc = DEFAULT_REPLACEMENT_CLASS;
	    var fp = config.familyPrefix;
	    var rc = config.replacementClass;
	    var s = baseStyles;
	
	    if (fp !== dfp || rc !== drc) {
	      var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
	      var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
	      var rPatt = new RegExp("\\.".concat(drc), 'g');
	      s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
	    }
	
	    return s;
	  }
	
	  var Library =
	  /*#__PURE__*/
	  function () {
	    function Library() {
	      _classCallCheck(this, Library);
	
	      this.definitions = {};
	    }
	
	    _createClass(Library, [{
	      key: "add",
	      value: function add() {
	        var _this = this;
	
	        for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
	          definitions[_key] = arguments[_key];
	        }
	
	        var additions = definitions.reduce(this._pullDefinitions, {});
	        Object.keys(additions).forEach(function (key) {
	          _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
	          defineIcons(key, additions[key]);
	          build();
	        });
	      }
	    }, {
	      key: "reset",
	      value: function reset() {
	        this.definitions = {};
	      }
	    }, {
	      key: "_pullDefinitions",
	      value: function _pullDefinitions(additions, definition) {
	        var normalized = definition.prefix && definition.iconName && definition.icon ? {
	          0: definition
	        } : definition;
	        Object.keys(normalized).map(function (key) {
	          var _normalized$key = normalized[key],
	              prefix = _normalized$key.prefix,
	              iconName = _normalized$key.iconName,
	              icon = _normalized$key.icon;
	          if (!additions[prefix]) additions[prefix] = {};
	          additions[prefix][iconName] = icon;
	        });
	        return additions;
	      }
	    }]);
	
	    return Library;
	  }();
	
	  function ensureCss() {
	    if (config.autoAddCss && !_cssInserted) {
	      insertCss(css());
	
	      _cssInserted = true;
	    }
	  }
	
	  function apiObject(val, abstractCreator) {
	    Object.defineProperty(val, 'abstract', {
	      get: abstractCreator
	    });
	    Object.defineProperty(val, 'html', {
	      get: function get() {
	        return val.abstract.map(function (a) {
	          return toHtml(a);
	        });
	      }
	    });
	    Object.defineProperty(val, 'node', {
	      get: function get() {
	        if (!IS_DOM) return;
	        var container = DOCUMENT.createElement('div');
	        container.innerHTML = val.html;
	        return container.children;
	      }
	    });
	    return val;
	  }
	
	  function findIconDefinition(iconLookup) {
	    var _iconLookup$prefix = iconLookup.prefix,
	        prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
	        iconName = iconLookup.iconName;
	    if (!iconName) return;
	    return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
	  }
	
	  function resolveIcons(next) {
	    return function (maybeIconDefinition) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
	      var mask = params.mask;
	
	      if (mask) {
	        mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
	      }
	
	      return next(iconDefinition, _objectSpread({}, params, {
	        mask: mask
	      }));
	    };
	  }
	
	  var library = new Library();
	  var noAuto = function noAuto() {
	    config.autoReplaceSvg = false;
	    config.observeMutations = false;
	    disconnect();
	  };
	  var _cssInserted = false;
	  var dom = {
	    i2svg: function i2svg() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (IS_DOM) {
	        ensureCss();
	        var _params$node = params.node,
	            node = _params$node === void 0 ? DOCUMENT : _params$node,
	            _params$callback = params.callback,
	            callback = _params$callback === void 0 ? function () {} : _params$callback;
	
	        if (config.searchPseudoElements) {
	          searchPseudoElements(node);
	        }
	
	        return onTree(node, callback);
	      } else {
	        return picked.reject('Operation requires a DOM of some kind.');
	      }
	    },
	    css: css,
	    insertCss: function insertCss$$1() {
	      if (!_cssInserted) {
	        insertCss(css());
	
	        _cssInserted = true;
	      }
	    },
	    watch: function watch() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var autoReplaceSvgRoot = params.autoReplaceSvgRoot,
	          observeMutationsRoot = params.observeMutationsRoot;
	
	      if (config.autoReplaceSvg === false) {
	        config.autoReplaceSvg = true;
	      }
	
	      config.observeMutations = true;
	      domready(function () {
	        autoReplace({
	          autoReplaceSvgRoot: autoReplaceSvgRoot
	        });
	        observe({
	          treeCallback: onTree,
	          nodeCallback: onNode,
	          pseudoElementsCallback: searchPseudoElements,
	          observeMutationsRoot: observeMutationsRoot
	        });
	      });
	    }
	  };
	  var parse = {
	    transform: function transform(transformString) {
	      return parseTransformString(transformString);
	    }
	  };
	  var icon = resolveIcons(function (iconDefinition) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _params$transform = params.transform,
	        transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
	        _params$symbol = params.symbol,
	        symbol = _params$symbol === void 0 ? false : _params$symbol,
	        _params$mask = params.mask,
	        mask = _params$mask === void 0 ? null : _params$mask,
	        _params$maskId = params.maskId,
	        maskId = _params$maskId === void 0 ? null : _params$maskId,
	        _params$title = params.title,
	        title = _params$title === void 0 ? null : _params$title,
	        _params$titleId = params.titleId,
	        titleId = _params$titleId === void 0 ? null : _params$titleId,
	        _params$classes = params.classes,
	        classes = _params$classes === void 0 ? [] : _params$classes,
	        _params$attributes = params.attributes,
	        attributes = _params$attributes === void 0 ? {} : _params$attributes,
	        _params$styles = params.styles,
	        styles = _params$styles === void 0 ? {} : _params$styles;
	    if (!iconDefinition) return;
	    var prefix = iconDefinition.prefix,
	        iconName = iconDefinition.iconName,
	        icon = iconDefinition.icon;
	    return apiObject(_objectSpread({
	      type: 'icon'
	    }, iconDefinition), function () {
	      ensureCss();
	
	      if (config.autoA11y) {
	        if (title) {
	          attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
	        } else {
	          attributes['aria-hidden'] = 'true';
	          attributes['focusable'] = 'false';
	        }
	      }
	
	      return makeInlineSvgAbstract({
	        icons: {
	          main: asFoundIcon(icon),
	          mask: mask ? asFoundIcon(mask.icon) : {
	            found: false,
	            width: null,
	            height: null,
	            icon: {}
	          }
	        },
	        prefix: prefix,
	        iconName: iconName,
	        transform: _objectSpread({}, meaninglessTransform, transform),
	        symbol: symbol,
	        title: title,
	        maskId: maskId,
	        titleId: titleId,
	        extra: {
	          attributes: attributes,
	          styles: styles,
	          classes: classes
	        }
	      });
	    });
	  });
	  var text = function text(content) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _params$transform2 = params.transform,
	        transform = _params$transform2 === void 0 ? meaninglessTransform : _params$transform2,
	        _params$title2 = params.title,
	        title = _params$title2 === void 0 ? null : _params$title2,
	        _params$classes2 = params.classes,
	        classes = _params$classes2 === void 0 ? [] : _params$classes2,
	        _params$attributes2 = params.attributes,
	        attributes = _params$attributes2 === void 0 ? {} : _params$attributes2,
	        _params$styles2 = params.styles,
	        styles = _params$styles2 === void 0 ? {} : _params$styles2;
	    return apiObject({
	      type: 'text',
	      content: content
	    }, function () {
	      ensureCss();
	      return makeLayersTextAbstract({
	        content: content,
	        transform: _objectSpread({}, meaninglessTransform, transform),
	        title: title,
	        extra: {
	          attributes: attributes,
	          styles: styles,
	          classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray(classes))
	        }
	      });
	    });
	  };
	  var counter = function counter(content) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _params$title3 = params.title,
	        title = _params$title3 === void 0 ? null : _params$title3,
	        _params$classes3 = params.classes,
	        classes = _params$classes3 === void 0 ? [] : _params$classes3,
	        _params$attributes3 = params.attributes,
	        attributes = _params$attributes3 === void 0 ? {} : _params$attributes3,
	        _params$styles3 = params.styles,
	        styles = _params$styles3 === void 0 ? {} : _params$styles3;
	    return apiObject({
	      type: 'counter',
	      content: content
	    }, function () {
	      ensureCss();
	      return makeLayersCounterAbstract({
	        content: content.toString(),
	        title: title,
	        extra: {
	          attributes: attributes,
	          styles: styles,
	          classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
	        }
	      });
	    });
	  };
	  var layer = function layer(assembler) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _params$classes4 = params.classes,
	        classes = _params$classes4 === void 0 ? [] : _params$classes4;
	    return apiObject({
	      type: 'layer'
	    }, function () {
	      ensureCss();
	      var children = [];
	      assembler(function (args) {
	        Array.isArray(args) ? args.map(function (a) {
	          children = children.concat(a.abstract);
	        }) : children = children.concat(args.abstract);
	      });
	      return [{
	        tag: 'span',
	        attributes: {
	          class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
	        },
	        children: children
	      }];
	    });
	  };
	  var api = {
	    noAuto: noAuto,
	    config: config,
	    dom: dom,
	    library: library,
	    parse: parse,
	    findIconDefinition: findIconDefinition,
	    icon: icon,
	    text: text,
	    counter: counter,
	    layer: layer,
	    toHtml: toHtml
	  };
	
	  var autoReplace = function autoReplace() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var _params$autoReplaceSv = params.autoReplaceSvgRoot,
	        autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
	    if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
	      node: autoReplaceSvgRoot
	    });
	  };
	
	  exports.icon = icon;
	  exports.noAuto = noAuto;
	  exports.config = config;
	  exports.toHtml = toHtml;
	  exports.layer = layer;
	  exports.text = text;
	  exports.counter = counter;
	  exports.library = library;
	  exports.dom = dom;
	  exports.parse = parse;
	  exports.findIconDefinition = findIconDefinition;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(171).setImmediate))

/***/ },
/* 295 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'box-alt';
	var width = 448;
	var height = 512;
	var ligatures = [];
	var unicode = 'f49a';
	var svgPathData = 'M447.9 176c0-10.6-2.6-21-7.6-30.3l-49.1-91.9c-4.3-13-16.5-21.8-30.3-21.8H87.1c-13.8 0-26 8.8-30.4 21.9L7.6 145.8c-5 9.3-7.6 19.7-7.6 30.3C.1 236.6 0 448 0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32 0 0-.1-211.4-.1-272zm-87-112l50.8 96H286.1l-12-96h86.8zM192 192h64v64h-64v-64zm49.9-128l12 96h-59.8l12-96h35.8zM87.1 64h86.8l-12 96H36.3l50.8-96zM32 448s.1-181.1.1-256H160v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64h127.9c0 74.9.1 256 .1 256H32z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faBoxAlt = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'boxes';
	var width = 640;
	var height = 512;
	var ligatures = [];
	var unicode = 'f468';
	var svgPathData = 'M624 224H480V16c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v208H16c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-176 32h64v62.3l-32-10.7-32 10.7V256zM352 32v62.3l-32-10.7-32 10.7V32h64zm-160 0h64v106.7l64-21.3 64 21.3V32h64v192H192V32zm0 224v62.3l-32-10.7-32 10.7V256h64zm-160 0h64v106.7l64-21.3 64 21.3V256h80v224H32V256zm576 224H336V256h80v106.7l64-21.3 64 21.3V256h64v224z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faBoxes = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 297 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'clipboard-list-check';
	var width = 384;
	var height = 512;
	var ligatures = [];
	var unicode = 'f737';
	var svgPathData = 'M336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16v352zM112 328c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm168 8H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-153.8-65.6l64.2-63.6c2.1-2.1 2.1-5.5 0-7.6l-12.6-12.7c-2.1-2.1-5.5-2.1-7.6 0l-47.6 47.2-20.6-20.9c-2.1-2.1-5.5-2.1-7.6 0l-12.7 12.6c-2.1 2.1-2.1 5.5 0 7.6l37.1 37.4c1.9 2.1 5.3 2.1 7.4 0zM280 240h-77.6l-32.3 32H280c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faClipboardListCheck = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'cogs';
	var width = 640;
	var height = 512;
	var ligatures = [];
	var unicode = 'f085';
	var svgPathData = 'M538.6 196.4l-2.5-3.9c-4.1.3-8.1.3-12.2 0l-2.5 4c-5.8 9.2-17.1 13.4-27.5 10.1-13.8-4.3-23-8.8-34.3-18.1-9-7.4-11.2-20.3-5.4-30.4l2.5-4.3c-2.3-3.4-4.3-6.9-6.1-10.6h-9.1c-11.6 0-21.4-8.2-23.6-19.6-2.6-13.7-2.7-24.2.1-38.5 2.1-11.3 12.1-19.5 23.6-19.5h9c1.8-3.7 3.8-7.2 6.1-10.6l-2.6-4.5c-5.8-10-3.6-22.7 5.2-30.3 10.6-9.1 19.7-14.3 33.5-19 10.8-3.7 22.7.7 28.5 10.6l2.6 4.4c4.1-.3 8.1-.3 12.2 0l2.6-4.4c5.8-9.9 17.7-14.3 28.6-10.5 13.3 4.5 22.3 9.6 33.5 19.1 8.8 7.5 10.9 20.2 5.1 30.2l-2.6 4.4c2.3 3.4 4.3 6.9 6.1 10.6h5.1c11.6 0 21.4 8.2 23.6 19.6 2.6 13.7 2.7 24.2-.1 38.5-2.1 11.3-12.1 19.5-23.6 19.5h-5c-1.8 3.7-3.8 7.2-6.1 10.6l2.5 4.3c5.9 10.2 3.5 23.1-5.5 30.5-10.7 8.8-19.9 13.4-34 17.9-10.5 3.3-21.9-.8-27.7-10.1zm12.2-34.5l10.6 18.3c6.7-2.8 12.9-6.4 18.7-10.8l-10.6-18.3 6.4-7.5c4.8-5.7 8.6-12.1 11-19.1l3.3-9.3h21.1c.9-7.1.9-14.4 0-21.5h-21.1l-3.3-9.3c-2.5-7-6.2-13.4-11-19.1l-6.4-7.5L580 39.4c-5.7-4.4-12-8-18.7-10.8l-10.6 18.3-9.7-1.8c-7.3-1.4-14.8-1.4-22.1 0l-9.7 1.8-10.6-18.3C492 31.3 485.7 35 480 39.4l10.6 18.3-6.4 7.5c-4.8 5.7-8.6 12.1-11 19.1l-3.3 9.3h-21.1c-.9 7.1-.9 14.4 0 21.5h21.1l3.3 9.3c2.5 7 6.2 13.4 11 19.1l6.4 7.5-10.6 18.4c5.7 4.4 12 8 18.7 10.8l10.6-18.3 9.7 1.8c7.3 1.4 14.8 1.4 22.1 0l9.7-1.8zM145.3 454.4v-31.6c-12.9-5.5-25.1-12.6-36.4-21.1l-27.5 15.9c-9.8 5.6-22.1 3.7-29.7-4.6-24.2-26.3-38.5-49.5-50.6-88.1-3.4-10.7 1.1-22.3 10.8-28L39.2 281c-1.7-14-1.7-28.1 0-42.1l-27.3-15.8c-9.7-5.6-14.2-17.3-10.8-28 12.1-38.4 26.2-61.6 50.6-88.1 7.6-8.3 20-10.2 29.7-4.6l27.4 15.9c11.3-8.5 23.5-15.5 36.4-21.1V65.6c0-11.3 7.8-21 18.8-23.4 34.7-7.8 62-8.7 101.7 0 11 2.4 18.9 12.2 18.9 23.4v31.6c12.9 5.5 25.1 12.6 36.4 21l27.4-15.8c9.8-5.6 22.2-3.7 29.8 4.6 26.9 29.6 41.5 55.9 52.1 88.5 3.4 10.5-.8 21.9-10.2 27.7l-25 15.8c1.7 14 1.7 28.1 0 42.1l28.1 17.5c8.6 5.4 13 15.6 10.8 25.5-6.9 31.3-33 64.6-55.9 89.2-7.6 8.2-19.9 10-29.6 4.4L321 401.8c-11.3 8.5-23.5 15.5-36.4 21.1v31.6c0 11.2-7.8 21-18.8 23.4-37.5 8.3-64.9 8.2-101.9 0-10.8-2.5-18.6-12.3-18.6-23.5zm32-6.2c24.8 5 50.5 5 75.3 0v-47.7l10.7-3.8c16.8-5.9 32.3-14.9 45.9-26.5l8.6-7.4 41.4 23.9c16.8-19.1 34-41.3 42.1-65.2l-41.4-23.9 2.1-11.1c3.2-17.6 3.2-35.5 0-53.1l-2.1-11.1 41.4-23.9c-8.1-23.9-25.3-46.2-42.1-65.2l-41.4 23.9-8.6-7.4c-13.6-11.7-29-20.6-45.9-26.5l-10.7-3.8V71.8c-24.8-5-50.5-5-75.3 0v47.7l-10.7 3.8c-16.8 5.9-32.3 14.9-45.9 26.5l-8.6 7.4-41.4-23.9A192.19 192.19 0 0 0 33 198.5l41.4 23.9-2.1 11.1c-3.2 17.6-3.2 35.5 0 53.1l2.1 11.1L33 321.6c8.1 23.9 20.9 46.2 37.7 65.2l41.4-23.9 8.6 7.4c13.6 11.7 29 20.6 45.9 26.5l10.7 3.8v47.6zm38.4-105.3c-45.7 0-82.9-37.2-82.9-82.9s37.2-82.9 82.9-82.9 82.9 37.2 82.9 82.9-37.2 82.9-82.9 82.9zm0-133.8c-28 0-50.9 22.8-50.9 50.9s22.8 50.9 50.9 50.9c28 0 50.9-22.8 50.9-50.9s-22.8-50.9-50.9-50.9zm322.9 291.7l-2.5-3.9c-4.1.3-8.1.3-12.2 0l-2.5 4c-5.8 9.2-17.1 13.4-27.5 10.1-13.8-4.3-23-8.8-34.3-18.1-9-7.4-11.2-20.3-5.4-30.4l2.5-4.3c-2.3-3.4-4.3-6.9-6.1-10.6h-9.1c-11.6 0-21.4-8.2-23.6-19.6-2.6-13.7-2.7-24.2.1-38.5 2.1-11.3 12.1-19.5 23.6-19.5h9c1.8-3.7 3.8-7.2 6.1-10.6l-2.6-4.5c-5.8-10-3.6-22.7 5.2-30.3 10.6-9.1 19.7-14.3 33.5-19 10.8-3.7 22.7.7 28.5 10.6l2.6 4.4c4.1-.3 8.1-.3 12.2 0l2.6-4.4c5.8-9.9 17.7-14.3 28.6-10.5 13.3 4.5 22.3 9.6 33.5 19.1 8.8 7.5 10.9 20.2 5.1 30.2l-2.6 4.4c2.3 3.4 4.3 6.9 6.1 10.6h5.1c11.6 0 21.4 8.2 23.6 19.6 2.6 13.7 2.7 24.2-.1 38.5-2.1 11.3-12.1 19.5-23.6 19.5h-5c-1.8 3.7-3.8 7.2-6.1 10.6l2.5 4.3c5.9 10.2 3.5 23.1-5.5 30.5-10.7 8.8-19.9 13.4-34 17.9-10.5 3.2-21.9-.9-27.7-10.1zm12.2-34.6l10.6 18.3c6.7-2.8 12.9-6.4 18.7-10.8l-10.6-18.3 6.4-7.5c4.8-5.7 8.6-12.1 11-19.1l3.3-9.3h21.1c.9-7.1.9-14.4 0-21.5h-21.1l-3.3-9.3c-2.5-7-6.2-13.4-11-19.1l-6.4-7.5 10.6-18.3c-5.7-4.4-12-8-18.7-10.8l-10.6 18.3-9.7-1.8c-7.3-1.4-14.8-1.4-22.1 0l-9.7 1.8-10.6-18.3c-6.7 2.8-12.9 6.4-18.7 10.8l10.6 18.3-6.4 7.5c-4.8 5.7-8.6 12.1-11 19.1l-3.3 9.3h-21.1c-.9 7.1-.9 14.4 0 21.5h21.1l3.3 9.3c2.5 7 6.2 13.4 11 19.1l6.4 7.5-10.6 18.3c5.7 4.4 12 8 18.7 10.8l10.6-18.3 9.7 1.8c7.3 1.4 14.8 1.4 22.1 0l9.7-1.8zM560 408c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm0-304.3c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.4 32-32z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faCogs = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'compress-alt';
	var width = 448;
	var height = 512;
	var ligatures = [];
	var unicode = 'f422';
	var svgPathData = 'M9.171 476.485l-5.656-5.656c-4.686-4.686-4.686-12.284 0-16.971L169.373 288H108c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h100c8.837 0 16 7.163 16 16v100c0 6.627-5.373 12-12 12h-8c-6.627 0-12-5.373-12-12v-61.373L26.142 476.485c-4.687 4.687-12.285 4.687-16.971 0zM240 256h100c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-61.373L444.485 58.142c4.686-4.686 4.686-12.284 0-16.971l-5.656-5.656c-4.686-4.686-12.284-4.686-16.971 0L256 201.373V140c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v100c0 8.837 7.163 16 16 16z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faCompressAlt = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'credit-card-front';
	var width = 576;
	var height = 512;
	var ligatures = [];
	var unicode = 'f38a';
	var svgPathData = 'M528 31H48C21.5 31 0 52.5 0 79v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V79c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V79c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v352zm-352-68v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12zM488 95h-80c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm-8 64h-64v-32h64v32zM260 319h-56c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm28-12v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12zm-192 0v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12zm384-40v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faCreditCardFront = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 301 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'eye';
	var width = 576;
	var height = 512;
	var ligatures = [];
	var unicode = 'f06e';
	var svgPathData = 'M288 288a64 64 0 0 0 0-128c-1 0-1.88.24-2.85.29a47.5 47.5 0 0 1-60.86 60.86c0 1-.29 1.88-.29 2.85a64 64 0 0 0 64 64zm284.52-46.6C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 96a128 128 0 1 1-128 128A128.14 128.14 0 0 1 288 96zm0 320c-107.36 0-205.46-61.31-256-160a294.78 294.78 0 0 1 129.78-129.33C140.91 153.69 128 187.17 128 224a160 160 0 0 0 320 0c0-36.83-12.91-70.31-33.78-97.33A294.78 294.78 0 0 1 544 256c-50.53 98.69-148.64 160-256 160z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faEye = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 302 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'eye-slash';
	var width = 640;
	var height = 512;
	var ligatures = [];
	var unicode = 'f070';
	var svgPathData = 'M637 485.25L23 1.75A8 8 0 0 0 11.76 3l-10 12.51A8 8 0 0 0 3 26.75l614 483.5a8 8 0 0 0 11.25-1.25l10-12.51a8 8 0 0 0-1.25-11.24zM320 96a128.14 128.14 0 0 1 128 128c0 21.62-5.9 41.69-15.4 59.57l25.45 20C471.65 280.09 480 253.14 480 224c0-36.83-12.91-70.31-33.78-97.33A294.88 294.88 0 0 1 576.05 256a299.73 299.73 0 0 1-67.77 87.16l25.32 19.94c28.47-26.28 52.87-57.26 70.93-92.51a32.35 32.35 0 0 0 0-29.19C550.3 135.59 442.94 64 320 64a311.23 311.23 0 0 0-130.12 28.43l45.77 36C258.24 108.52 287.56 96 320 96zm60.86 146.83A63.15 63.15 0 0 0 320 160c-1 0-1.89.24-2.85.29a45.11 45.11 0 0 1-.24 32.19zm-217.62-49.16A154.29 154.29 0 0 0 160 224a159.39 159.39 0 0 0 226.27 145.29L356.69 346c-11.7 3.53-23.85 6-36.68 6A128.15 128.15 0 0 1 192 224c0-2.44.59-4.72.72-7.12zM320 416c-107.36 0-205.47-61.31-256-160 17.43-34 41.09-62.72 68.31-86.72l-25.86-20.37c-28.48 26.28-52.87 57.25-70.93 92.5a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448a311.25 311.25 0 0 0 130.12-28.43l-29.25-23C389.06 408.84 355.15 416 320 416z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faEyeSlash = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'globe';
	var width = 496;
	var height = 512;
	var ligatures = [];
	var unicode = 'f0ac';
	var svgPathData = 'M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faGlobe = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 304 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'info-circle';
	var width = 512;
	var height = 512;
	var ligatures = [];
	var unicode = 'f05a';
	var svgPathData = 'M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faInfoCircle = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 305 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'lock';
	var width = 448;
	var height = 512;
	var ligatures = [];
	var unicode = 'f023';
	var svgPathData = 'M400 224h-16v-62.5C384 73.1 312.9.3 224.5 0 136-.3 64 71.6 64 160v64H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM96 160c0-70.6 57.4-128 128-128s128 57.4 128 128v64H96v-64zm304 320H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faLock = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 306 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'minus';
	var width = 384;
	var height = 512;
	var ligatures = [];
	var unicode = 'f068';
	var svgPathData = 'M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faMinus = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'shopping-basket';
	var width = 576;
	var height = 512;
	var ligatures = [];
	var unicode = 'f291';
	var svgPathData = 'M564 192h-76.875L347.893 37.297c-5.91-6.568-16.027-7.101-22.596-1.189s-7.101 16.028-1.189 22.596L444.075 192h-312.15L251.893 58.703c5.912-6.567 5.379-16.685-1.189-22.596-6.569-5.912-16.686-5.38-22.596 1.189L88.875 192H12c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h16.444L58.25 438.603C61.546 462.334 81.836 480 105.794 480h364.412c23.958 0 44.248-17.666 47.544-41.397L547.556 224H564c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12zm-77.946 242.201c-1.093 7.867-7.906 13.799-15.848 13.799H105.794c-7.942 0-14.755-5.932-15.848-13.799L60.752 224h454.497l-29.195 210.201zM304 280v112c0 8.837-7.163 16-16 16-8.836 0-16-7.163-16-16V280c0-8.837 7.164-16 16-16 8.837 0 16 7.163 16 16zm112 0v112c0 8.837-7.163 16-16 16s-16-7.163-16-16V280c0-8.837 7.163-16 16-16s16 7.163 16 16zm-224 0v112c0 8.837-7.164 16-16 16s-16-7.163-16-16V280c0-8.837 7.164-16 16-16s16 7.163 16 16z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faShoppingBasket = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 308 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fal';
	var iconName = 'user';
	var width = 448;
	var height = 512;
	var ligatures = [];
	var unicode = 'f007';
	var svgPathData = 'M313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faUser = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ },
/* 309 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 310 */,
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.generateProjectPassword = undefined;
	
	var _util = __webpack_require__(9);
	
	var _reduxForm = __webpack_require__(12);
	
	var generateProjectPassword = exports.generateProjectPassword = function generateProjectPassword(formIdentifier) {
	    return function (dispatch, getState) {
	
	        var generatedPasswordChars = [];
	
	        var uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	        var lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
	        var digits = '0123456789';
	        var special = '$!#*+,-.;_:/';
	        var random = uppercaseChars + lowercaseChars + digits + special;
	
	        // 20 chars, 4 : upper case, lower case, digit, special 16 : random
	        generatedPasswordChars.push(uppercaseChars.charAt((0, _util.getRandomInt)(uppercaseChars.length - 1)));
	        generatedPasswordChars.push(lowercaseChars.charAt((0, _util.getRandomInt)(lowercaseChars.length - 1)));
	        generatedPasswordChars.push(digits.charAt((0, _util.getRandomInt)(digits.length - 1)));
	        generatedPasswordChars.push(special.charAt((0, _util.getRandomInt)(special.length - 1)));
	
	        for (var i = 0; i < 16; i++) {
	            generatedPasswordChars.push(random.charAt((0, _util.getRandomInt)(random.length - 1)));
	        }
	
	        var generatedPassword = (0, _util.shuffleArray)(generatedPasswordChars).join('');
	
	        if (generatedPassword[0] === '-') {
	            generatedPassword = '.' + generatedPassword.slice(1);
	        }
	
	        // temporarily set a valid password so that the hint stays visible
	        dispatch((0, _reduxForm.change)(formIdentifier, 'projectPassword', 'Abcabc123!'));
	        dispatch((0, _reduxForm.change)(formIdentifier, 'projectPasswordRepeat', 'Abcabc123!'));
	
	        setTimeout(function () {
	            dispatch((0, _reduxForm.change)(formIdentifier, 'projectPassword', generatedPassword));
	            dispatch((0, _reduxForm.change)(formIdentifier, 'projectPasswordRepeat', generatedPassword));
	            dispatch((0, _reduxForm.touch)(formIdentifier, 'projectPassword', 'projectPasswordRepeat'));
	        }, 25);
	    };
	};

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FadingImage = function (_Component) {
	    _inherits(FadingImage, _Component);
	
	    function FadingImage(props) {
	        _classCallCheck(this, FadingImage);
	
	        var _this = _possibleConstructorReturn(this, (FadingImage.__proto__ || Object.getPrototypeOf(FadingImage)).call(this, props));
	
	        _this.handleImageLoaded = function (e) {
	
	            _this.setState({
	                imageLoaded: true
	            });
	        };
	
	        _this.state = {
	            imageLoaded: false
	        };
	
	        return _this;
	    }
	
	    _createClass(FadingImage, [{
	        key: 'render',
	        value: function render() {
	
	            var className = (this.props.className ? this.props.className : '') + (this.state.imageLoaded ? ' fd-img' : ' fd-img fd-img--loading');
	
	            return _react2.default.createElement('img', _extends({}, this.props, { role: 'presentation', onLoad: this.handleImageLoaded, className: className }));
	        }
	    }]);
	
	    return FadingImage;
	}(_react.Component);
	
	FadingImage.propTypes = {};
	exports.default = FadingImage;

/***/ },
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _faTimes = __webpack_require__(129);
	
	var _reactTooltip = __webpack_require__(61);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TooltipClose = function (_Component) {
	    _inherits(TooltipClose, _Component);
	
	    function TooltipClose() {
	        _classCallCheck(this, TooltipClose);
	
	        return _possibleConstructorReturn(this, (TooltipClose.__proto__ || Object.getPrototypeOf(TooltipClose)).apply(this, arguments));
	    }
	
	    _createClass(TooltipClose, [{
	        key: "handleCloseClick",
	        value: function handleCloseClick(e) {
	            this.props.tooltip.current.tooltipRef = null;
	            _reactTooltip2.default.hide();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                {
	                    key: "tooltip-close-button",
	                    className: "tooltip__close",
	                    onClick: this.handleCloseClick.bind(this)
	                },
	                _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faTimes.faTimes })
	            );
	        }
	    }]);
	
	    return TooltipClose;
	}(_react.Component);
	
	exports.default = TooltipClose;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _General = __webpack_require__(10);
	
	var _Cart = __webpack_require__(36);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reactTooltip = __webpack_require__(61);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Mode = __webpack_require__(18);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _faPlus = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleConfiguratorCostsDisplay = function (_Component) {
	    _inherits(ArticleConfiguratorCostsDisplay, _Component);
	
	    function ArticleConfiguratorCostsDisplay() {
	        _classCallCheck(this, ArticleConfiguratorCostsDisplay);
	
	        return _possibleConstructorReturn(this, (ArticleConfiguratorCostsDisplay.__proto__ || Object.getPrototypeOf(ArticleConfiguratorCostsDisplay)).apply(this, arguments));
	    }
	
	    _createClass(ArticleConfiguratorCostsDisplay, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	
	            if (nextProps.cartIsSwappingProgress) {
	                return false;
	            }
	
	            return this.props.costs !== nextProps.costs || this.props.mode !== nextProps.mode || this.props.cartIsSwapping !== nextProps.cartIsSwapping;
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            _reactTooltip2.default.rebuild();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	
	            var props = this.props;
	
	            var ctaLabel = "";
	            var ctaHref = "";
	            var websiteLabel = "";
	
	            switch (props.mode) {
	                case _General.ARTICLE_CONFIGURATOR_MODE_SHARED:
	                    ctaLabel = "Agentur-Server und erstes Projekt buchen";
	                    ctaHref = "https://bestellung.mittwald.de/v3/?article=72000&useConfiguration=shared";
	
	                    if (props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY) {
	                        websiteLabel = 'Für dein 1. Projekt (' + (props.state === _General.PROJECT_STATE_DEV ? 'DEV-Projekt' : 'LIVE-Projekt') + ')';
	                        ctaLabel = props.state === _General.PROJECT_STATE_DEV ? "Agentur-Server &\nDEV\u2011Projekt\xA0buchen" : "Agentur-Server &\nLIVE\u2011Projekt\xA0buchen";
	                    } else if (props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE) {
	                        websiteLabel = _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            "Dein erstes Projekt",
	                            _react2.default.createElement("br", null),
	                            "auf dem Agentur-Server"
	                        );
	                    }
	                    break;
	
	                case "cms":
	                    ctaLabel = "Jetzt buchen";
	                    ctaHref = "https://bestellung.mittwald.de/v3/?&useConfiguration=cms";
	                    websiteLabel = "Dein CMS-Hosting";
	                    break;
	
	                case "shop":
	                    ctaLabel = "Jetzt buchen";
	                    ctaHref = "https://bestellung.mittwald.de/v3/?&useConfiguration=shop";
	                    websiteLabel = "Dein Shop-Hosting";
	                    break;
	
	                default:
	                    ctaLabel = "Jetzt bestellen";
	                    break;
	            }
	
	            var priceDisplay = void 0;
	            // mode shared also covers outsourcing case
	            var showDifference = props.mode === 'shared' || (0, _Mode.isMode)(_General.APP_MODE_PRODUCT_CHANGE) || (0, _Mode.isMode)(_General.APP_MODE_OUTSOURCING);
	
	            if (props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY) {
	                priceDisplay = _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "article-configurator__price__main__block" },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "f\xFCr den Agentur-Server"
	                        ),
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "10.00 \u20AC"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "pro Monat zzgl. USt.*"
	                        )
	                    ),
	                    _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { fixedWidth: true, icon: _faPlus.faPlus }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "article-configurator__price__main__block" },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "f\xFCr dein 1. Projekt (",
	                            props.state === _General.PROJECT_STATE_DEV ? 'DEV-Projekt' : 'LIVE-Projekt',
	                            ")"
	                        ),
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            Number(props.costs).toFixed(props.costs > 0 ? 2 : 0),
	                            " \u20AC"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "pro Monat zzgl. USt.*"
	                        )
	                    ),
	                    _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { fixedWidth: true, icon: _faPlus.faPlus }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "article-configurator__price__main__info" },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "Weitere Projekte"
	                            ),
	                            " lassen sich jederzeit Im Kundencenter hinzubuchen und konfigurieren."
	                        )
	                    )
	                );
	            } else if (props.costs > 0) {
	                priceDisplay = _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        showDifference ? '+ ' : '',
	                        Number(props.costs).toFixed(props.costs > 0 ? 2 : 0),
	                        " \u20AC"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "pro Monat, zzgl. USt.*"
	                    )
	                );
	            } else if (props.costs < 0) {
	                priceDisplay = _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "- ",
	                        Number(Math.abs(props.costs)).toFixed(2),
	                        " \u20AC"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "pro Monat, zzgl. USt.*"
	                    )
	                );
	            } else if (props.isDevProjectInCart) {
	                priceDisplay = _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "kostenlos"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "w\xE4hrend deiner Projektentwicklung"
	                    )
	                );
	            } else {
	                priceDisplay = _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "+ 0 \u20AC"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "pro Monat, zzgl. USt.*"
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    "data-tip": ((0, _Mode.isMode)(_General.APP_MODE_PRODUCT_CHANGE) || (0, _Mode.isMode)(_General.APP_MODE_OUTSOURCING)) && showDifference ? 'Dies ist der Differenzbetrag zu deinem aktuell gebuchten Tarif.' : null,
	                    "data-for": "global",
	                    "data-place": "right",
	                    "data-effect": "solid",
	                    "data-delay-show": "500",
	                    className: "article-configurator__price" + (props.layout ? " article-configurator__price--layout-" + props.layout : '')
	                },
	                props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE ? _react2.default.createElement(
	                    "div",
	                    { className: "article-configurator__price__label" },
	                    websiteLabel
	                ) : null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "article-configurator__price__main" },
	                    priceDisplay
	                ),
	                props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE ? _react2.default.createElement(
	                    "a",
	                    {
	                        target: "_top",
	                        href: ctaHref,
	                        className: "article-configurator__price__order"
	                    },
	                    ctaLabel
	                ) : null,
	                props.layout === _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY ? _react2.default.createElement(
	                    "a",
	                    {
	                        target: "_top",
	                        href: ctaHref,
	                        className: "article-configurator__price__order"
	                    },
	                    ctaLabel
	                ) : null
	            );
	        }
	    }]);
	
	    return ArticleConfiguratorCostsDisplay;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isFetching: state.cart && state.cart.isFetching,
	        cartIsSwapping: state.cart && state.cart.isSwapping,
	        cartIsSwappingProgress: state.cart && state.cart.isSwappingProgress,
	        isDevProjectInCart: (0, _Cart.isDevProjectInCart)(state)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, getState) {
	
	    return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArticleConfiguratorCostsDisplay);

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _reactTooltip = __webpack_require__(61);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _TooltipClose = __webpack_require__(316);
	
	var _TooltipClose2 = _interopRequireDefault(_TooltipClose);
	
	var _clsx = __webpack_require__(66);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _faInfoCircle = __webpack_require__(304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleConfiguratorFormField = function (_Component) {
	    _inherits(ArticleConfiguratorFormField, _Component);
	
	    function ArticleConfiguratorFormField(props) {
	        _classCallCheck(this, ArticleConfiguratorFormField);
	
	        var _this = _possibleConstructorReturn(this, (ArticleConfiguratorFormField.__proto__ || Object.getPrototypeOf(ArticleConfiguratorFormField)).call(this, props));
	
	        _this.showRef = props.showRef || _react2.default.createRef();
	        _this.tooltipRef = _react2.default.createRef();
	        _this.labelRef = _react2.default.createRef();
	        return _this;
	    }
	
	    _createClass(ArticleConfiguratorFormField, [{
	        key: "render",
	        value: function render() {
	
	            var props = this.props;
	            var eventProps = {};
	
	            if (!props.label) {
	                eventProps.event = 'custom';
	                eventProps.eventOff = 'custom';
	            }
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _clsx2.default)("article-configurator__form-field", !this.props.label && "article-configurator__form-field--hidden")
	                },
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: "article-configurator__form-field__label"
	                    },
	                    props.tooltip ? _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button",
	                            className: "tooltip-wrapper",
	                            "data-for": "lswitcher_" + props.tooltipId,
	                            "data-tip": "",
	                            "data-event": "click mouseenter focusin",
	                            "data-event-off": "focusout mouseleave",
	                            ref: this.showRef
	                        },
	                        props.label ? _react2.default.createElement(
	                            "span",
	                            { ref: this.labelRef },
	                            props.label
	                        ) : null,
	                        _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faInfoCircle.faInfoCircle }),
	                        _react2.default.createElement(
	                            _reactTooltip2.default,
	                            _extends({
	                                className: (0, _clsx2.default)("global-tooltip tooltip", !props.label && "tooltip--fixed"),
	                                delayShow: props.label ? 250 : 0,
	                                delayHide: 150,
	                                clickable: true,
	                                place: props.tooltipPlace || (props.windowWidth < 768 ? "bottom" : "right"),
	                                ref: this.tooltipRef,
	                                offset: { left: 10 },
	                                effect: "solid",
	                                type: "light",
	                                border: true,
	                                multiline: true,
	                                scrollHide: false,
	                                id: "lswitcher_" + props.tooltipId
	                            }, eventProps, {
	                                overridePosition: function overridePosition(position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset) {
	                                    var top = position.top,
	                                        left = position.left;
	
	                                    if (document.body.querySelector('#style_' + node.id)) {
	                                        document.body.removeChild(document.body.querySelector('#style_' + node.id));
	                                    }
	
	                                    var sheet = document.createElement('style');
	                                    var svg = currentTarget.querySelector('svg');
	                                    sheet.setAttribute('id', 'style_' + node.id);
	
	                                    if (place === "right") {
	
	                                        // upper bound
	                                        if (top < 84) {
	                                            top = 84;
	                                        }
	                                        // lower bound
	                                        if (top + node.getBoundingClientRect().height > document.body.scrollHeight) {
	                                            top = document.body.scrollHeight - node.getBoundingClientRect().height - 10;
	                                        }
	
	                                        sheet.innerHTML = "\n                                        #" + node.id + " .__react_component_tooltip.place-right::after {\n                                            top: " + (svg.getBoundingClientRect().bottom - top - 8) + "px;\n                                        }\n                                        #" + node.id + " .__react_component_tooltip.place-right::before {\n                                            top: " + (svg.getBoundingClientRect().bottom - top - 8) + "px;\n                                        }\n                                      ";
	                                    } else if (place === "bottom") {
	                                        top -= 4;
	
	                                        // lower bound
	                                        if (top + node.getBoundingClientRect().height > document.body.scrollHeight) {
	                                            top = document.body.scrollHeight - node.getBoundingClientRect().height - 10;
	                                        }
	
	                                        if (left < 0) {
	                                            left = 0;
	                                        }
	
	                                        sheet.innerHTML = "\n                                        #" + node.id + " .__react_component_tooltip.place-bottom::after {\n                                            left: " + (svg.getBoundingClientRect().right - left - 20) + "px;\n                                        }\n                                        #" + node.id + " .__react_component_tooltip.place-bottom::before {\n                                            left: " + (svg.getBoundingClientRect().right - left - 20) + "px;\n                                        }\n                                      ";
	                                    } else if (place === "top") {
	
	                                        if (left < 0) {
	                                            left = 0;
	                                        }
	
	                                        sheet.innerHTML = "\n                                        #" + node.id + " .__react_component_tooltip.place-top::after {\n                                            left: " + (svg.getBoundingClientRect().right - left - 20) + "px;\n                                        }\n                                        #" + node.id + " .__react_component_tooltip.place-top::before {\n                                            left: " + (svg.getBoundingClientRect().right - left - 20) + "px;\n                                        }\n                                      ";
	
	                                        top -= 40;
	                                    }
	
	                                    document.body.appendChild(sheet);
	
	                                    return {
	                                        left: left,
	                                        top: top
	                                    };
	                                }
	                            }),
	                            _react2.default.createElement(_TooltipClose2.default, { tooltip: this.tooltipRef }),
	                            props.tooltip
	                        )
	                    ) : props.label ? _react2.default.createElement(
	                        "span",
	                        { ref: this.labelRef },
	                        props.label
	                    ) : null
	                ),
	                props.children
	            );
	        }
	    }]);
	
	    return ArticleConfiguratorFormField;
	}(_react.Component);
	
	exports.default = ArticleConfiguratorFormField;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.backupHint = exports.storageHint = exports.visitorHint = exports.softwareHint = exports.securityHint = exports.typeHint = exports.projectStateHint = exports.projectNameHint = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectNameHint = exports.projectNameHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "Gib deinem neuen Projekt einen passenden Namen, damit du es im Kundencenter besser wiederfinden kannst. Diesen Projekt-Namen kannst du sp\xE4ter jederzeit \xE4ndern."
	    )
	);
	
	var projectStateHint = exports.projectStateHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "Bei Mittwald unterscheiden wir zwischen DEV und LIVE. Nutze DEV-Projekte f\xFCr die Test- und Entwicklungsphase. Sobald dein Projekt produktiv genutzt wird, \xFCberf\xFChrst du es per Klick in ein kostenpflichtiges LIVE-Projekt."
	    )
	);
	
	var typeHint = exports.typeHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "Dein Hosting wird f\xFCr den Betrieb eines ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "Shops"
	        ),
	        " bzw. einer ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "Website"
	        ),
	        " optimiert. Shopsysteme sind h\xE4ufig ressourcenhungriger und erfordern serverseitig andere Konfigurationen als CMS- oder Webprojekte. Nat\xFCrlich kannst du jeweils auch ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "eigenentwickelte"
	        ),
	        " oder ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "statische Projekte"
	        ),
	        " hosten."
	    )
	);
	
	var securityHint = exports.securityHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "Das Projekt-Passwort nutzt du f\xFCr den Zugriff auf dein Projekt in unserem Kundencenter unter ",
	        _react2.default.createElement(
	            "a",
	            { href: "https://login.mittwald.de", target: "_blank" },
	            "https://login.mittwald.de"
	        ),
	        " und auf deine vorinstallierte Software. Den zugeh\xF6rigen Benutzernamen zum Login in dein Projekt bekommst du von uns per E-Mail zugeschickt. Als Agentur-Server-Neukunde erh\xE4ltst du einen weiteren separaten Zugang per E-Mail, um gesammelt auf alle deine Projekte zugreifen zu k\xF6nnen."
	    )
	);
	
	var softwareHint = exports.softwareHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "W\xE4hle deine bevorzugte Software bereits jetzt aus, damit wir alle Komponenten f\xFCr dich installieren k\xF6nnen und du direkt loslegen kannst. Du bist dir noch unsicher, welche Software du ben\xF6tigst? Kein Problem. Deine Softwareauswahl kannst du auch jederzeit im Kundencenter vornehmen."
	    )
	);
	
	var visitorHint = exports.visitorHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "Als ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "ein Besucher"
	        ),
	        " wird jeder User gez\xE4hlt, der die Website mit ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "einer IP-Adresse"
	        ),
	        " binnen ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "24 Std."
	        ),
	        " beliebig oft besucht."
	    ),
	    _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	            "strong",
	            null,
	            "Bots und API-Aufrufe"
	        ),
	        " werden herausgefiltert und somit aus der Berechnung ausgeschlossen."
	    ),
	    _react2.default.createElement(
	        "p",
	        null,
	        "Kommt es zur ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "konstanten \xDCberschreitung"
	        ),
	        " der oben aufgef\xFChrten Besucherzahl, erfolgt eine ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "Performance-Einschr\xE4nkung"
	        ),
	        " in Form einer verlangsamten Seitenauslieferung."
	    )
	);
	
	var storageHint = exports.storageHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "Mehr als Speicherplatz. Alle ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "CMS, Shop und Agentur-Tools"
	        ),
	        " sind ab dem kleinsten Projekt schon ",
	        _react2.default.createElement(
	            "strong",
	            null,
	            "inklusive"
	        ),
	        " und k\xF6nnen so lange genutzt werden, bis dein Speicherplatz voll ist. Dein Speicherplatz steckt also voller M\xF6glichkeiten."
	    )
	);
	
	var backupHint = exports.backupHint = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "p",
	        null,
	        "Backups vom Vortag sind inklusive \u2013 l\xE4ngere Backupzeitr\xE4ume optional w\xE4hlbar. Diese werden vom Speicherplatz abgezogen. Da die Daten inkrementell gesichert werden, vervielfacht sich aber nicht dein Speicherplatzbedarf. So kannst du rechnen:"
	    ),
	    _react2.default.createElement(
	        "p",
	        null,
	        "1 Tag (inkl. - kein Abzug)",
	        _react2.default.createElement("br", null),
	        "7 Tage (verbrauchter Speicherplatz * 0,2)",
	        _react2.default.createElement("br", null),
	        "14 Tage (verbrauchter Speicherplatz * 0,5)",
	        _react2.default.createElement("br", null),
	        "28 Tage (verbrauchter Speicherplatz * 1,0)"
	    ),
	    _react2.default.createElement(
	        "p",
	        null,
	        "Die Einspielung eines Backups wird mit 50 Euro (zzgl. Ust.) berechnet."
	    )
	);

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _clsx = __webpack_require__(66);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	var _reduxForm = __webpack_require__(12);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabeledSliderComponent = function (_Component) {
	    _inherits(LabeledSliderComponent, _Component);
	
	    function LabeledSliderComponent(props) {
	        _classCallCheck(this, LabeledSliderComponent);
	
	        var _this = _possibleConstructorReturn(this, (LabeledSliderComponent.__proto__ || Object.getPrototypeOf(LabeledSliderComponent)).call(this, props));
	
	        _this.handleOnKeyDown = function (e) {
	
	            var currentlySelectedIndex = _this.state.selectedIndex;
	
	            if (_this.changeTimeout) {
	                clearTimeout(_this.changeTimeout);
	                _this.changeTimeout = 0;
	            }
	
	            if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
	                e.preventDefault();
	                var targetIndex = _this.state.selectedIndex - 1 < 0 ? 0 : _this.state.selectedIndex - 1;
	                _this.selectIndex(targetIndex);
	                _this.changeTimeout = setTimeout(function () {
	                    _this.triggerChange(currentlySelectedIndex);
	                }, 500);
	            }
	            if (e.key === "ArrowRight" || e.key === "ArrowDown") {
	                e.preventDefault();
	                var _targetIndex = _this.state.selectedIndex + 1 > _this.props.options.length - 1 ? _this.props.options.length - 1 : _this.state.selectedIndex + 1;
	                _this.selectIndex(_targetIndex);
	                _this.changeTimeout = setTimeout(function () {
	                    _this.triggerChange(currentlySelectedIndex);
	                }, 500);
	            }
	            if (e.key === "Home") {
	                e.preventDefault();
	                _this.selectIndex(0);
	                _this.changeTimeout = setTimeout(function () {
	                    _this.triggerChange(currentlySelectedIndex);
	                }, 500);
	            }
	            if (e.key === "End") {
	                e.preventDefault();
	                _this.selectIndex(_this.props.options.length - 1);
	                _this.changeTimeout = setTimeout(function () {
	                    _this.triggerChange(currentlySelectedIndex);
	                }, 500);
	            }
	        };
	
	        _this.handleRef = _react2.default.createRef();
	        _this.trackRef = _react2.default.createRef();
	
	        var initiallySelectedIndex = Math.max(0, _this.props.options.findIndex(function (option) {
	            return option.value === _this.props.input.value;
	        }));
	
	        _this.state = {
	            dragStartClientX: 0,
	            dragStart: 0,
	            dragPercentage: _this.getDragPercentageByIndex(initiallySelectedIndex),
	            selectedIndex: initiallySelectedIndex,
	            isDragging: false,
	            canTriggerNegativeRepeat: false,
	            negativeRepeatCount: 0
	        };
	
	        _this.changeTimeout = 0;
	
	        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	        _this.handleDragStart = _this.handleDragStart.bind(_this);
	        _this.handleDragMove = _this.handleDragMove.bind(_this);
	        _this.handleTrackPress = _this.handleTrackPress.bind(_this);
	        return _this;
	    }
	
	    _createClass(LabeledSliderComponent, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("mousemove", this.handleDragMove);
	            document.removeEventListener("mouseup", this.handleDragEnd);
	            document.removeEventListener("mouseleave", this.handleDragEnd);
	            document.removeEventListener("touchmove", this.handleDragMove);
	            document.removeEventListener("touchend", this.handleDragEnd);
	            if (this.trackRef && this.trackRef.current) {
	                this.trackRef.current.removeEventListener("mousedown", this.handleTrackPress);
	                this.trackRef.current.removeEventListener("touchstart", this.handleTrackPress);
	            }
	            if (this.handleRef && this.handleRef.current) {
	                this.handleRef.current.removeEventListener("mousedown", this.handleTrackPress);
	                this.handleRef.current.removeEventListener("touchstart", this.handleTrackPress);
	            }
	            if (this.changeTimeout) {
	                this.triggerChange(this.state.selectedIndex);
	                clearTimeout(this.changeTimeout);
	                this.changeTimeout = 0;
	            }
	        }
	    }, {
	        key: 'getDragPercentageByIndex',
	        value: function getDragPercentageByIndex(index) {
	            return index / (this.props.options.length - 1);
	        }
	    }, {
	        key: 'getIndexByDragPercentage',
	        value: function getIndexByDragPercentage(percentage) {
	            // Assume even spread, round and -1 := nearest to cursor
	            var amountValues = this.props.options.length;
	            return Math.max(0, Math.min(amountValues, Math.round(percentage * (amountValues - 1))));
	            //return Math.max(0, Math.min(amountValues - 1, Math.floor(percentage * (amountValues))))
	        }
	    }, {
	        key: 'triggerChange',
	        value: function triggerChange(previouslySelectedIndex) {
	            this.props.input.onChange(this.props.options[this.state.selectedIndex].value);
	            if (this.props.onMaximumSelected && this.state.selectedIndex === this.props.options.length - 1 && this.state.selectedIndex > 0) {
	                this.props.onMaximumSelected();
	            }
	            if (this.props.onMaximumDeselected && previouslySelectedIndex > 0 && this.state.selectedIndex !== this.props.options.length - 1 && previouslySelectedIndex !== this.state.selectedIndex) {
	                this.props.onMaximumDeselected();
	            }
	        }
	    }, {
	        key: 'updateDragPercentage',
	        value: function updateDragPercentage(percentage) {
	            var _this2 = this;
	
	            var selectedIndex = this.getIndexByDragPercentage(percentage);
	            var currentlySelectedIndex = this.state.selectedIndex;
	
	            if (currentlySelectedIndex !== selectedIndex) {
	                // set index before calling input.onChange, else componentDidUpdate has wrong state
	                this.setState({
	                    selectedIndex: selectedIndex
	                });
	
	                if (this.changeTimeout) {
	                    clearTimeout(this.changeTimeout);
	                    this.changeTimeout = 0;
	                }
	
	                if (!this.props.disabled) {
	                    this.changeTimeout = setTimeout(function () {
	                        _this2.triggerChange(currentlySelectedIndex);
	                    }, 50);
	                }
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	            if (nextState.isDragging !== this.state.isDragging) {
	                return true;
	            }
	            if (nextState.selectedIndex !== this.state.selectedIndex) {
	                return true;
	            }
	            if (nextProps.disabled !== this.props.disabled) {
	                return true;
	            }
	            if (nextState.dragPercentage !== this.state.dragPercentage) {
	                return true;
	            }
	            if (nextProps.options.length !== this.props.options.length || nextProps.options[0].value !== this.props.options[0].value) {
	                return true;
	            }
	            if (JSON.stringify(nextProps.options) !== JSON.stringify(this.options)) {
	                return true;
	            }
	            if (nextProps.input.value !== this.props.input.value) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            var _this3 = this;
	
	            if (prevProps.options.length !== this.props.options.length || JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options)) {
	                // set drag percentage when value changes without dragging
	                var selectedIndexUpdate = Math.max(0, this.props.options.findIndex(function (option) {
	                    return option.value === _this3.props.input.value;
	                }));
	
	                this.setState({
	                    selectedIndex: selectedIndexUpdate,
	                    dragPercentage: this.getDragPercentageByIndex(selectedIndexUpdate)
	                });
	
	                this.initEventListeners();
	            }
	
	            if (prevProps.input.value !== this.props.input.value) {
	                var _selectedIndexUpdate = Math.max(0, this.props.options.findIndex(function (option) {
	                    return option.value === _this3.props.input.value;
	                }));
	                if (this.state.selectedIndex !== _selectedIndexUpdate && !this.state.isDragging) {
	                    // value changed, drag percentage needs to be updated, only when not dragging manually
	                    this.setState({
	                        selectedIndex: _selectedIndexUpdate,
	                        dragPercentage: this.getDragPercentageByIndex(_selectedIndexUpdate)
	                    });
	                }
	            }
	
	            if (prevProps.disabled && !this.props.disabled) {
	                // when api is ready, check if value is up to date
	                if (this.props.options[this.state.selectedIndex].value !== this.props.input.value) {
	                    if (this.changeTimeout) {
	                        clearTimeout(this.changeTimeout);
	                        this.changeTimeout = 0;
	                    }
	                    this.changeTimeout = setTimeout(function () {
	                        _this3.triggerChange(prevState.selectedIndex);
	                    }, 350);
	                }
	            }
	
	            if (!prevProps.disabled && this.props.disabled) {
	                if (this.changeTimeout) {
	                    clearTimeout(this.changeTimeout);
	                    this.changeTimeout = 0;
	                }
	            }
	        }
	    }, {
	        key: 'handleDragMove',
	        value: function handleDragMove(e) {
	            var _this4 = this;
	
	            var dragTrackWidth = this.trackRef.current.getBoundingClientRect().width;
	            var x = e.clientX || e.touches && e.touches[0] && e.touches[0].clientX;
	
	            if (!x) {
	                // x undefined on window border
	                return;
	            }
	
	            // limit dragCurrent between 0 and width - 24
	            var dragCurrent = Math.max(0, Math.min(dragTrackWidth - 24, this.state.dragStart + (x - this.state.dragStartClientX)));
	
	            var dragPercentage = dragCurrent / (dragTrackWidth - 24);
	
	            if (Math.min(dragTrackWidth - 24, this.state.dragStart + (x - this.state.dragStartClientX)) < 0) {
	                if (this.state.canTriggerNegativeRepeat) {
	                    this.setState({
	                        canTriggerNegativeRepeat: false,
	                        negativeRepeatCount: this.state.negativeRepeatCount + 1
	                    });
	                    setTimeout(function () {
	                        _this4.setState({
	                            negativeRepeatCount: Math.max(0, _this4.state.negativeRepeatCount - 1)
	                        });
	                    }, 5000);
	                    if (this.state.negativeRepeatCount === 3 && this.props.onRepeatableNegativeDrag) {
	                        this.props.onRepeatableNegativeDrag.call();
	                        this.setState({
	                            negativeRepeatTriggered: true
	                        });
	                    }
	                }
	            } else {
	                this.setState({
	                    canTriggerNegativeRepeat: true
	                });
	                if (this.getIndexByDragPercentage(dragPercentage) > 0 && this.state.negativeRepeatTriggered && this.props.onClearPositiveDrag) {
	                    this.setState({
	                        negativeRepeatTriggered: false,
	                        negativeRepeatCount: 0
	                    });
	                    this.props.onClearPositiveDrag.call();
	                }
	            }
	
	            this.setState({
	                dragPercentage: dragPercentage
	            });
	
	            this.updateDragPercentage(dragPercentage);
	
	            e.stopPropagation();
	            e.preventDefault();
	        }
	    }, {
	        key: 'handleDragEnd',
	        value: function handleDragEnd(e) {
	
	            document.removeEventListener("mousemove", this.handleDragMove);
	            document.removeEventListener("mouseup", this.handleDragEnd);
	            document.removeEventListener("mouseleave", this.handleDragEnd);
	
	            document.removeEventListener("touchmove", this.handleDragMove);
	            document.removeEventListener("touchend", this.handleDragEnd);
	
	            var dragPercentage = this.getDragPercentageByIndex(this.state.selectedIndex);
	
	            this.setState({
	                isDragging: false,
	                dragPercentage: dragPercentage
	            });
	        }
	    }, {
	        key: 'handleDragStart',
	        value: function handleDragStart(e) {
	
	            var dragTrackWidth = this.trackRef.current.getBoundingClientRect().width;
	            var x = e.clientX || e.touches && e.touches[0] && e.touches[0].pageX;
	
	            document.addEventListener("mousemove", this.handleDragMove);
	            document.addEventListener("mouseup", this.handleDragEnd);
	            document.addEventListener("mouseleave", this.handleDragEnd);
	
	            document.addEventListener("touchmove", this.handleDragMove, { passive: false });
	            document.addEventListener("touchend", this.handleDragEnd, { passive: false });
	
	            this.setState({
	                dragStartClientX: x,
	                dragStart: this.state.dragPercentage * (dragTrackWidth - 24),
	                isDragging: true,
	                canTriggerNegativeRepeat: true
	            });
	
	            e.stopPropagation();
	            e.preventDefault();
	        }
	    }, {
	        key: 'handleTrackPress',
	        value: function handleTrackPress(e) {
	
	            var dragTrackLeft = this.trackRef.current.getBoundingClientRect().left;
	            var dragTrackWidth = this.trackRef.current.getBoundingClientRect().width;
	            var x = e.clientX || e.touches && e.touches[0] && e.touches[0].pageX;
	
	            var dragCurrent = Math.max(0, Math.min(dragTrackWidth - 24, x - dragTrackLeft - 12));
	            var dragPercentage = dragCurrent / (dragTrackWidth - 24);
	
	            this.updateDragPercentage(dragPercentage);
	
	            document.addEventListener("mousemove", this.handleDragMove);
	            document.addEventListener("mouseup", this.handleDragEnd);
	            document.addEventListener("mouseleave", this.handleDragEnd);
	
	            document.addEventListener("touchmove", this.handleDragMove, { passive: false });
	            document.addEventListener("touchend", this.handleDragEnd, { passive: false });
	
	            this.setState({
	                dragStartClientX: x,
	                dragStart: x - dragTrackLeft - 12,
	                dragPercentage: dragPercentage,
	                isDragging: true
	            });
	
	            e.stopPropagation();
	            e.preventDefault();
	        }
	    }, {
	        key: 'initEventListeners',
	        value: function initEventListeners() {
	            if (this.trackRef.current) {
	                this.trackRef.current.removeEventListener("mousedown", this.handleTrackPress);
	                this.trackRef.current.addEventListener("mousedown", this.handleTrackPress);
	                this.trackRef.current.removeEventListener("touchstart", this.handleTrackPress);
	                this.trackRef.current.addEventListener("touchstart", this.handleTrackPress, { passive: false });
	            }
	            if (this.handleRef.current) {
	                this.handleRef.current.removeEventListener("mousedown", this.handleTrackPress);
	                this.handleRef.current.addEventListener("mousedown", this.handleDragStart);
	                this.handleRef.current.removeEventListener("touchstart", this.handleTrackPress);
	                this.handleRef.current.addEventListener("touchstart", this.handleDragStart, { passive: false });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initEventListeners();
	        }
	    }, {
	        key: 'selectIndex',
	        value: function selectIndex(targetIndex) {
	            this.setState({
	                selectedIndex: targetIndex,
	                dragPercentage: this.getDragPercentageByIndex(targetIndex)
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var targetPercentage = this.getDragPercentageByIndex(this.state.selectedIndex);
	
	            var selectedOptionLabel = (0, _util.delve)(this.props.options, this.state.selectedIndex + ".label");
	            var selectedOptionDisabled = (0, _util.delve)(this.props.options, this.state.selectedIndex + ".disabled");
	            var selectedOptionDisabledSuffix = (0, _util.delve)(this.props.options, this.state.selectedIndex + ".disabledSuffix");
	
	            var markerAtOptionIndex = this.props.markerAtIndex === 0 || this.props.markerAtIndex > 0 ? this.props.markerAtIndex : -1;
	
	            if (this.props.markerAtOption) {
	                markerAtOptionIndex = this.props.options.findIndex(function (element) {
	                    return element.value === '' + _this5.props.markerAtOption;
	                });
	            }
	
	            if (this.props.options && this.props.options.length === 1) {
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _clsx2.default)("labeled-slider labeled-slider--single", this.props.layout && "labeled-slider--layout-" + this.props.layout) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: "labeled-slider__track__label" },
	                        selectedOptionLabel,
	                        selectedOptionDisabled ? _react2.default.createElement(
	                            'span',
	                            { className: "labeled-slider__label__error" },
	                            selectedOptionDisabledSuffix
	                        ) : null
	                    )
	                );
	            }
	
	            var inlineDisplayTheme = false;
	
	            if (this.props.inlineDisplayPercent) {
	                inlineDisplayTheme = 'green';
	                if (this.props.inlineDisplayPercent >= 100) {
	                    inlineDisplayTheme = 'red';
	                } else if (this.props.inlineDisplayPercent > 90) {
	                    inlineDisplayTheme = 'orange';
	                }
	            }
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    tabIndex: 0,
	                    role: "slider",
	                    'aria-valuemax': this.props.options[this.props.options.length - 1].label,
	                    'aria-valuemin': this.props.options[0].label,
	                    'aria-valuenow': selectedOptionLabel,
	                    onKeyDown: this.handleOnKeyDown,
	                    className: (0, _clsx2.default)("labeled-slider", this.state.isDragging && "dragging", this.props.layout && "labeled-slider--layout-" + this.props.layout, this.props.inlineDisplay && 'labeled-slider--inline-display')
	                },
	                this.props.inlineDisplay ? _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _clsx2.default)("labeled-slider__inline-display", inlineDisplayTheme && "labeled-slider__inline-display--theme-" + inlineDisplayTheme)
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: "labeled-slider__inline-display__label"
	                        },
	                        this.props.inlineDisplayLabel
	                    ),
	                    _react2.default.createElement('div', {
	                        className: "labeled-slider__inline-display__active",
	                        style: { width: this.props.inlineDisplayPercent + "%" }
	                    }),
	                    _react2.default.createElement('div', {
	                        className: "labeled-slider__inline-display__background"
	                    })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    {
	                        ref: this.trackRef,
	                        className: (0, _clsx2.default)("labeled-slider__track", this.state.isDragging && "dragging")
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: "labeled-slider__track__label",
	                            style: {
	                                left: 'calc(' + targetPercentage + ' * 100%)',
	                                transform: 'translateX(calc(-1 * ' + targetPercentage + ' * 100%))'
	                            }
	                        },
	                        selectedOptionLabel,
	                        selectedOptionDisabled ? _react2.default.createElement(
	                            'span',
	                            {
	                                className: "labeled-slider__label__error" },
	                            selectedOptionDisabledSuffix
	                        ) : null
	                    ),
	                    _react2.default.createElement('div', {
	                        className: (0, _clsx2.default)("labeled-slider__track__handle", this.state.isDragging && "dragging"),
	                        style: { left: 'calc(' + targetPercentage + ' * (100% - 24px))' },
	                        ref: this.handleRef
	                    }),
	                    _react2.default.createElement('div', {
	                        className: "labeled-slider__track__active",
	                        style: { width: 'calc(' + targetPercentage + ' * (100% - 24px) + 12px)' }
	                    }),
	                    markerAtOptionIndex === 0 || markerAtOptionIndex > 0 ? _react2.default.createElement('div', {
	                        className: "labeled-slider__track__marker",
	                        style: { left: 'calc(' + this.getDragPercentageByIndex(markerAtOptionIndex) + ' * (100% - 24px))' }
	                    }) : null,
	                    _react2.default.createElement('div', {
	                        className: "labeled-slider__track__exceeding",
	                        style: { width: 'calc(' + (this.props.exceedingSteps || 0) + ' * (100% - 24px))' }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: "labeled-slider__track__steps" },
	                        this.props.options.map(function (option, index) {
	                            return index > 0 ? _react2.default.createElement('div', {
	                                key: 'lbl_sld_stp_' + index,
	                                className: (0, _clsx2.default)(index === _this5.state.selectedIndex && "active")
	                            }) : null;
	                        })
	                    ),
	                    _react2.default.createElement('div', { className: "labeled-slider__track__background" })
	                )
	            );
	        }
	    }]);
	
	    return LabeledSliderComponent;
	}(_react.Component);
	
	function LabeledSlider(props) {
	    return _react2.default.createElement(_reduxForm.Field, {
	        name: props.fieldId,
	        forceValidation: props.forceValidation,
	        component: LabeledSliderComponent,
	        props: props
	    });
	}
	
	LabeledSlider.propTypes = {
	    options: _propTypes2.default.array.isRequired,
	    inlineDisplay: _propTypes2.default.bool,
	    inlineDisplayLabel: _propTypes2.default.string,
	    inlineDisplayPercent: _propTypes2.default.number,
	    exceedingSteps: _propTypes2.default.any,
	    inlineDisplayTheme: _propTypes2.default.string,
	    markerAtOption: _propTypes2.default.any,
	    markerAtIndex: _propTypes2.default.number,
	    fieldId: _propTypes2.default.string.isRequired,
	    onMaximumSelected: _propTypes2.default.func,
	    onRepeatableNegativeDrag: _propTypes2.default.func,
	    onMaximumDeselected: _propTypes2.default.func
	};
	
	exports.default = LabeledSlider;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(12);
	
	var _clsx = __webpack_require__(66);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabeledToggleSelectionComponent = function (_Component) {
	    _inherits(LabeledToggleSelectionComponent, _Component);
	
	    function LabeledToggleSelectionComponent() {
	        _classCallCheck(this, LabeledToggleSelectionComponent);
	
	        return _possibleConstructorReturn(this, (LabeledToggleSelectionComponent.__proto__ || Object.getPrototypeOf(LabeledToggleSelectionComponent)).apply(this, arguments));
	    }
	
	    _createClass(LabeledToggleSelectionComponent, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var selectedOption = this.props.options.find(function (option) {
	                return option.value === _this2.props.input.value;
	            });
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _clsx2.default)("labeled-toggle-selection", this.props.layout && "labeled-toggle-selection--layout-" + this.props.layout) },
	                this.props.options.map(function (option) {
	                    return _react2.default.createElement(
	                        "button",
	                        { type: "button", key: "lbl_tgl_s_" + option.value, onClick: function onClick(e) {
	                                _this2.props.input.onChange(option.value);
	                            }, className: (0, _clsx2.default)("labeled-toggle-selection__button", selectedOption === option && "selected") },
	                        option.label
	                    );
	                })
	            );
	        }
	    }]);
	
	    return LabeledToggleSelectionComponent;
	}(_react.Component);
	
	function LabeledToggleSelection(props) {
	    return _react2.default.createElement(_reduxForm.Field, {
	        name: props.fieldId,
	        forceValidation: props.forceValidation,
	        component: LabeledToggleSelectionComponent,
	        props: props
	    });
	}
	
	exports.default = LabeledToggleSelection;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reduxForm = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _PasswordStrength = __webpack_require__(135);
	
	var _faTimes = __webpack_require__(129);
	
	var _faCheck = __webpack_require__(98);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorIcon = function ErrorIcon(props) {
	    return _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { fixedWidth: true, className: "error", icon: _faTimes.faTimes });
	};
	
	var CorrectIcon = function CorrectIcon(props) {
	    return _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { fixedWidth: true, className: "correct", icon: _faCheck.faCheck });
	};
	
	var PasswordStrengthTooltip = function (_Component) {
	    _inherits(PasswordStrengthTooltip, _Component);
	
	    function PasswordStrengthTooltip() {
	        _classCallCheck(this, PasswordStrengthTooltip);
	
	        return _possibleConstructorReturn(this, (PasswordStrengthTooltip.__proto__ || Object.getPrototypeOf(PasswordStrengthTooltip)).apply(this, arguments));
	    }
	
	    _createClass(PasswordStrengthTooltip, [{
	        key: 'render',
	        value: function render() {
	            var passwordErrors = this.props.passwordErrors["projectPasswordErrors"] || {};
	
	            if (!((0, _util.delve)(this.props.registeredFormFields, "projectPassword.active") || (0, _util.delve)(this.props.registeredFormFields, "projectPasswordRepeat.active"))) {
	                // only render if one field is active or if there are password error
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: "password-strength-tooltip" },
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-strength-tooltip__group" },
	                    passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_LENGTH] ? _react2.default.createElement(ErrorIcon, null) : _react2.default.createElement(CorrectIcon, null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'min. 12 Zeichen'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-strength-tooltip__group" },
	                    passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_UPPER_LOWER] ? _react2.default.createElement(ErrorIcon, null) : _react2.default.createElement(CorrectIcon, null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'min. je 1 Klein- und Gro\xDFbuchstabe (keine Umlaute)'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-strength-tooltip__group" },
	                    passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_DIGIT] ? _react2.default.createElement(ErrorIcon, null) : _react2.default.createElement(CorrectIcon, null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'min. 1 Ziffer'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-strength-tooltip__group" },
	                    passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_SPECIAL] ? _react2.default.createElement(ErrorIcon, null) : _react2.default.createElement(CorrectIcon, null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'min. 1 Sonderzeichen aus $ ! # * + , - . ; _ : /'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-strength-tooltip__group" },
	                    passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_DISALLOWED] ? _react2.default.createElement(ErrorIcon, null) : _react2.default.createElement(CorrectIcon, null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'kein unerlaubtes Zeichen'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-strength-tooltip__group" },
	                    passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_NODASHBEGIN] ? _react2.default.createElement(ErrorIcon, null) : _react2.default.createElement(CorrectIcon, null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'kein Bindestrich am Anfang'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-strength-tooltip__group" },
	                    passwordErrors[_PasswordStrength.PASSWORD_VALIDATION_MATCHING] ? _react2.default.createElement(ErrorIcon, null) : _react2.default.createElement(CorrectIcon, null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Passw\xF6rter stimmen \xFCberein'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PasswordStrengthTooltip;
	}(_react.Component);
	
	function mapStateToProps(state, props) {
	    return {
	        passwordErrors: (0, _reduxForm.getFormSyncErrors)(props.formIdentifier)(state),
	        registeredFormFields: (0, _reduxForm.getFormMeta)(props.formIdentifier)(state)
	    };
	}
	
	PasswordStrengthTooltip.propTypes = {
	    formIdentifier: _propTypes2.default.string.isRequired,
	    registeredFormFields: _propTypes2.default.any
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PasswordStrengthTooltip);

/***/ },
/* 323 */,
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArticleSelection = __webpack_require__(325);
	
	var _ArticleSelection2 = _interopRequireDefault(_ArticleSelection);
	
	var _dompurify = __webpack_require__(428);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _FadingImage = __webpack_require__(312);
	
	var _FadingImage2 = _interopRequireDefault(_FadingImage);
	
	var _TaxTag = __webpack_require__(282);
	
	var _TaxTag2 = _interopRequireDefault(_TaxTag);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _faCheck = __webpack_require__(98);
	
	var _clsx = __webpack_require__(66);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleInlineSelection = function (_Component) {
	    _inherits(ArticleInlineSelection, _Component);
	
	    function ArticleInlineSelection(props) {
	        _classCallCheck(this, ArticleInlineSelection);
	
	        var _this = _possibleConstructorReturn(this, (ArticleInlineSelection.__proto__ || Object.getPrototypeOf(ArticleInlineSelection)).call(this, props));
	
	        _this.renderArticleBadge = function (badgeData) {
	
	            if (!badgeData) {
	                return null;
	            }
	
	            switch (badgeData.view) {
	
	                case 'rectangle':
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'article-inline-selection__selector__badge' },
	                        badgeData.label
	                    );
	
	                default:
	                    return null;
	
	            }
	        };
	
	        _this.renderSelection = function (handleArticleSelect, handleArticleDeSelect, articleSelectionState) {
	            var defaultOption = articleSelectionState.defaultOption,
	                selectedArticle = articleSelectionState.selectedArticle,
	                selectionLocked = articleSelectionState.selectionLocked;
	
	            var hasMoreThanMax = _this.props.max && _this.props.articleOptions.length > _this.props.max;
	
	            var articleOptions = _this.props.articleOptions.map(function (articleOption, index) {
	
	                if (!_this.state.showMore && _this.props.max && index >= _this.props.max && selectedArticle !== articleOption.value) {
	                    return null;
	                }
	
	                var price = articleOption.display.price;
	                var priceTag = articleOption.value === defaultOption ? _react2.default.createElement(
	                    'div',
	                    { key: articleOption.value + "price", className: 'article-inline-selection__selector__price' },
	                    articleOption.display.inclusiveLabel ? articleOption.display.inclusiveLabel : 'inklusive'
	                ) : _react2.default.createElement(
	                    'div',
	                    {
	                        key: articleOption.value + "price",
	                        className: 'article-inline-selection__selector__price'
	                    },
	                    price.setupFee > 0 ? ["+", price.setupFee.toFixed(2), " € einmalig ", _react2.default.createElement(_TaxTag2.default, { key: 'taxsetup' }), price.priceMonthly > 0 ? _react2.default.createElement('br', { key: "taxbr" }) : ""] : "",
	                    price.priceMonthly > 0 ? ["+", price.priceMonthly.toFixed(2), " € mtl. ", _react2.default.createElement(_TaxTag2.default, { key: 'taxmonthly' })] : ""
	                );
	
	                var isSelected = selectedArticle === articleOption.value;
	                var isDisabled = articleOption.disabled;
	
	                switch (_this.props.inlineOptionStyle) {
	
	                    /*
	                     extended theme contains bigger title and additional description
	                     */
	                    case 'extended':
	                        return _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                key: articleOption.value,
	                                className: (0, _clsx2.default)("article-inline-selection__selector", "article-inline-selection__selector--extended", isSelected && "selected", isDisabled && "disabled"),
	                                onClick: function onClick(e) {
	                                    if (!isDisabled) {
	                                        handleArticleSelect(articleOption.value);
	                                    }
	                                }
	                            },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                articleOption.display.title
	                            ),
	                            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(articleOption.display.description) } }),
	                            (price.setupFee > 0 || price.priceMonthly > 0 || articleOption.value === defaultOption) && priceTag,
	                            _this.renderArticleBadge(articleOption.display.badge),
	                            articleOption.display.background ? _react2.default.createElement(
	                                'div',
	                                { className: 'article-inline-selection__selector__background' },
	                                _react2.default.createElement(_FadingImage2.default, { src: articleOption.display.background })
	                            ) : null,
	                            isSelected ? _react2.default.createElement(
	                                'div',
	                                { className: "article-inline-selection__selector__check" },
	                                _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faCheck.faCheck })
	                            ) : null
	                        );
	
	                    /*
	                     simple theme with only headline and price
	                     */
	                    case 'simple':
	                    default:
	                        return _react2.default.createElement(
	                            'a',
	                            {
	                                key: articleOption.value,
	                                className: (0, _clsx2.default)("article-inline-selection__selector--simple", "article-inline-selection__selector", isSelected && "selected", isDisabled && "disabled"),
	                                onClick: function onClick(e) {
	                                    if (!isDisabled) {
	                                        handleArticleSelect(articleOption.value);
	                                    }
	                                }
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                articleOption.display.title
	                            ),
	                            (price.setupFee > 0 || price.priceMonthly > 0 || articleOption.value === defaultOption) && priceTag,
	                            _this.renderArticleBadge(articleOption.display.badge),
	                            isSelected ? _react2.default.createElement(
	                                'div',
	                                { className: "article-inline-selection__selector__check" },
	                                _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faCheck.faCheck })
	                            ) : null
	                        );
	                }
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: "article-inline-selection article-inline-selection--max-" + _this.props.itemsPerRow + (selectionLocked ? ' article-inline-selection--locked' : '') },
	                articleOptions,
	                hasMoreThanMax && !_this.state.showMore ? _react2.default.createElement(
	                    'div',
	                    { className: "article-inline-selection__expand" },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            onClick: function onClick(e) {
	                                _this.setState({ showMore: true });
	                            } },
	                        _this.props.moreLabel
	                    )
	                ) : hasMoreThanMax && _this.state.showMore ? _react2.default.createElement(
	                    'div',
	                    { className: "article-inline-selection__expand" },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            onClick: function onClick(e) {
	                                _this.setState({ showMore: false });
	                            } },
	                        _this.props.lessLabel
	                    )
	                ) : null
	            );
	        };
	
	        _this.state = {
	            showMore: false
	        };
	
	        return _this;
	    }
	
	    _createClass(ArticleInlineSelection, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _ArticleSelection2.default,
	                this.props,
	                function (handleArticleSelect, handleArticleDeSelect, articleSelectionState) {
	                    return _this2.renderSelection(handleArticleSelect, handleArticleDeSelect, articleSelectionState);
	                }
	            );
	        }
	    }]);
	
	    return ArticleInlineSelection;
	}(_react.Component);
	
	ArticleInlineSelection.propTypes = _extends({}, _ArticleSelection2.default.articleOptions, {
	    itemsPerRow: _propTypes2.default.number,
	    inlineOptionStyle: _propTypes2.default.string
	});
	ArticleInlineSelection.defaultProps = {
	    itemsPerRow: 2,
	    canClearOnDoubleSelect: false,
	    inlineOptionStyle: 'simple'
	};
	exports.default = ArticleInlineSelection;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _Cart = __webpack_require__(28);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _CartUtil = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleSelection = function (_Component) {
	    _inherits(ArticleSelection, _Component);
	
	    function ArticleSelection(props) {
	        _classCallCheck(this, ArticleSelection);
	
	        var _this = _possibleConstructorReturn(this, (ArticleSelection.__proto__ || Object.getPrototypeOf(ArticleSelection)).call(this, props));
	
	        _this.handleArticleDeSelect = function () {
	
	            var selectedArticle = _this.state.selectedArticle;
	
	            if (_this.props.cartIsBusy || _this.state.selectionLocked || _this.state.selectionInProgress) {
	                return;
	            }
	
	            if (selectedArticle !== _this.state.defaultOption) {
	                _this.props.removeItemFromCart("" + selectedArticle);
	            }
	
	            if (_this.state.defaultOption) {
	
	                _this.setState({
	                    selectedArticle: _this.state.defaultOption
	                });
	            } else {
	
	                _this.setState({
	                    selectedArticle: false
	                });
	            }
	        };
	
	        _this.handleArticleSelect = function (clickedArticle) {
	
	            var selectedArticle = _this.state.selectedArticle;
	
	            if (_this.props.cartIsBusy || _this.state.selectionLocked || _this.state.selectionInProgress) {
	                return;
	            }
	
	            if (selectedArticle !== clickedArticle) {
	
	                // add item if different article, remove old
	                _this.setState({
	                    selectedArticle: clickedArticle,
	                    selectionInProgress: true
	                });
	
	                // unselect previos
	                if (selectedArticle !== _this.state.defaultOption) {
	                    _this.props.removeItemFromCart("" + _this.state.selectedArticle, clickedArticle !== _this.state.defaultOption).then(function (args) {
	                        if (clickedArticle !== _this.state.defaultOption) {
	                            _this.props.addItemToCart("" + clickedArticle).then(function (args) {
	                                _this.setState({ selectionInProgress: false });
	                            });
	                        } else {
	                            _this.setState({ selectionInProgress: false });
	                        }
	                    });
	                } else {
	                    if (clickedArticle !== _this.state.defaultOption) {
	                        _this.props.addItemToCart("" + clickedArticle).then(function (args) {
	                            _this.setState({ selectionInProgress: false });
	                        });
	                    } else {
	                        _this.setState({ selectionInProgress: false });
	                    }
	                }
	            } else {
	
	                if (clickedArticle !== _this.state.defaultOption && _this.props.canClearOnDoubleSelect) {
	                    _this.handleArticleDeSelect();
	                }
	            }
	        };
	
	        var initialArticle = false;
	        var defaultOption = false;
	        var disableSelection = props.disableSelection;
	        var initialLock = false;
	
	        // check if one of the article options is contained in cart
	        props.articleOptions.forEach(function (articleOption) {
	
	            if (props.initialAddons && props.initialAddons.includes("" + articleOption.value) && props.lockInitialAddons) {
	                disableSelection = true;
	                initialLock = true;
	            }
	
	            // set default if still empty
	            if (("" + articleOption.value).includes('default_')) {
	                defaultOption = articleOption.value;
	                if (!initialArticle) {
	                    initialArticle = articleOption.value;
	                }
	            }
	
	            // set cart
	            if (props.articleOptionsInCart.includes("" + articleOption.value)) {
	                initialArticle = articleOption.value;
	            }
	        });
	
	        _this.state = {
	            selectedArticle: initialArticle,
	            defaultOption: defaultOption,
	            initialLock: initialLock,
	            selectionLocked: disableSelection,
	            selectionInProgress: false
	        };
	
	        return _this;
	    }
	
	    _createClass(ArticleSelection, [{
	        key: 'UNSAFE_componentWillReceiveProps',
	        value: function UNSAFE_componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.disableSelection !== this.state.selectionLocked && !this.state.initialLock) {
	
	                this.setState({
	                    selectionLocked: nextProps.disableSelection
	                });
	
	                // check if items are in cart that are no longer possible to be in cart
	
	                if (nextProps.disableSelection) {
	                    this.props.articleOptions.forEach(function (articleOption) {
	
	                        if (nextProps.articleOptionsInCart.includes("" + articleOption.value) || _this2.props.articleOptionsInCart.includes("" + articleOption.value)) {
	
	                            _this2.handleArticleDeSelect();
	                        }
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!this.state.selectionInProgress) {
	                if (this.state.selectedArticle !== this.state.defaultOption && this.state.selectedArticle && !this.props.articleOptionsInCart.includes("" + this.state.selectedArticle)) {
	
	                    if (this.state.defaultOption) {
	
	                        this.setState({
	                            selectedArticle: this.state.defaultOption
	                        });
	                    } else {
	
	                        this.setState({
	                            selectedArticle: false
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.Children.only(this.props.children(this.handleArticleSelect, this.handleArticleDeSelect, _extends({}, this.state)));
	        }
	    }]);
	
	    return ArticleSelection;
	}(_react.Component);
	
	ArticleSelection.propTypes = {
	    articleOptions: _propTypes2.default.array.isRequired,
	    canClearOnDoubleSelect: _propTypes2.default.bool,
	    disableSelection: _propTypes2.default.bool
	};
	ArticleSelection.defaultProps = {
	    articleOptions: [],
	    canClearOnDoubleSelect: false,
	    disableSelection: false
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        initialAddons: (0, _SimpleSelectors.getInitialCartAddons)(state),
	        lockInitialAddons: (0, _SimpleSelectors.getInitialAddonLock)(state),
	        articleOptionsInCart: (0, _CartUtil.getArticleOptionsInCartList)(state),
	        cartIsBusy: state.cart.isFetching
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	
	    return {
	        addItemToCart: function addItemToCart(articleNumber) {
	            return dispatch((0, _Cart.addItemToCart)(articleNumber));
	        },
	        removeItemFromCart: function removeItemFromCart(articleNumber, isSwapping) {
	            return dispatch((0, _Cart.removeItemFromCartByArticleNumber)(articleNumber, isSwapping));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArticleSelection);

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CartPropertySelection = __webpack_require__(285);
	
	var _CartPropertySelection2 = _interopRequireDefault(_CartPropertySelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartPropertyDropdownSelection = function (_Component) {
	    _inherits(CartPropertyDropdownSelection, _Component);
	
	    function CartPropertyDropdownSelection(props) {
	        _classCallCheck(this, CartPropertyDropdownSelection);
	
	        var _this = _possibleConstructorReturn(this, (CartPropertyDropdownSelection.__proto__ || Object.getPrototypeOf(CartPropertyDropdownSelection)).call(this, props));
	
	        _this.handleDocumentClick = function (e) {
	
	            var area = _this.areaRef.current;
	
	            if (!area.contains(e.target)) {
	                _this.setState({
	                    isOpened: false
	                });
	            }
	        };
	
	        _this.handleOptionSelect = function (clickedOption, defaultOption, selectedProperty, handleOptionSelect) {
	
	            handleOptionSelect(clickedOption);
	
	            _this.triggerRef.current.focus();
	
	            _this.setState({
	                isOpened: false,
	                focusedIndex: 0
	            });
	        };
	
	        _this.handleTriggerClick = function (e) {
	
	            _this.setState({
	                isOpened: !_this.state.isOpened
	            });
	        };
	
	        _this.renderOptions = function (handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) {
	            _this.optionRefs = []; // Reset refs
	
	            var propertyOptionsListing = _this.props.propertyOptions.map(function (propertyOption) {
	
	                var isDisabled = propertyOption.disabled;
	
	                return _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        key: propertyOption.value,
	                        ref: function ref(el) {
	                            if (!isDisabled && el != null) _this.optionRefs.push(el);
	                        } // Store non-disabled refs
	                        , onClick: function onClick(e) {
	                            if (isDisabled) {
	                                return;
	                            }
	                            _this.handleOptionSelect(propertyOption.value, defaultOption, selectedProperty, handleOptionSelect);
	                        },
	                        className: 'article-simple-dropdown__options__option' + (propertyOption.value === selectedProperty ? " article-simple-dropdown__options__option--selected" : '') + (isDisabled ? ' article-simple-dropdown__options__option--disabled' : '')
	                    },
	                    propertyOption.display.icon ? _react2.default.createElement('img', { role: 'presentation', src: propertyOption.display.icon }) : null,
	                    propertyOption.display.title
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'article-simple-dropdown__options' },
	                propertyOptionsListing
	            );
	        };
	
	        _this.handleKeyDown = function (event) {
	            var propertyOptions = _this.props.propertyOptions;
	            var focusedIndex = _this.state.focusedIndex;
	
	            // Filter out disabled options
	
	            var focusableOptions = propertyOptions.filter(function (option) {
	                return !option.disabled;
	            });
	            var totalOptions = focusableOptions.length;
	            if (totalOptions === 0) return;
	
	            if (event.key === "ArrowDown") {
	                event.preventDefault();
	                if (_this.state.isOpened) {
	                    focusedIndex = (focusedIndex + 1) % totalOptions;
	                } else {
	                    _this.setState({ isOpened: true });
	                    focusedIndex = 0;
	                }
	            } else if (_this.state.isOpened && event.key === "ArrowUp") {
	                event.preventDefault();
	                focusedIndex = (focusedIndex - 1 + totalOptions) % totalOptions;
	            } else if (_this.state.isOpened && event.key === "Escape") {
	                _this.setState({ isOpened: false });
	                _this.triggerRef.current.focus();
	                focusedIndex = 0;
	            }
	
	            _this.setState({ focusedIndex: focusedIndex }, function () {
	                if (_this.optionRefs[focusedIndex]) {
	                    _this.optionRefs[focusedIndex].focus();
	                }
	            });
	        };
	
	        _this.state = {
	            isOpened: false,
	            focusedIndex: 0 // Track the focused button index
	        };
	
	        _this.optionRefs = []; // Store refs for buttons
	        _this.areaRef = _react2.default.createRef();
	        _this.triggerRef = _react2.default.createRef();
	
	        return _this;
	    }
	
	    _createClass(CartPropertyDropdownSelection, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	
	            window.removeEventListener('click', this.handleDocumentClick);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	
	            if (this.state.isOpened) {
	                window.addEventListener('click', this.handleDocumentClick);
	            } else {
	                window.removeEventListener('click', this.handleDocumentClick);
	            }
	        }
	    }, {
	        key: 'renderDropdown',
	        value: function renderDropdown(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) {
	
	            var hasCustomSelection = selectedProperty && selectedProperty !== defaultOption;
	            var isDefaultSelected = defaultOption && selectedProperty === defaultOption;
	
	            var selectedPropertyOption = this.props.propertyOptions.find(function (propertyOption) {
	                return propertyOption.value === selectedProperty;
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { ref: this.areaRef,
	                    className: "article-simple-dropdown" + (this.state.isOpened ? ' article-simple-dropdown--opened' : ''),
	                    onKeyDown: this.handleKeyDown
	                },
	                hasCustomSelection ? _react2.default.createElement(
	                    'button',
	                    { type: 'button', onClick: handleOptionDeSelect, className: 'article-simple-dropdown__clear' },
	                    'x'
	                ) : null,
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', ref: this.triggerRef, onClick: this.handleTriggerClick,
	                        className: "article-simple-dropdown__trigger" + (hasCustomSelection ? ' article-simple-dropdown__trigger--selected' : '') + (isDefaultSelected ? ' article-simple-dropdown__trigger--default' : '') },
	                    selectedProperty && selectedPropertyOption.display.icon ? _react2.default.createElement('img', { role: 'presentation', src: selectedPropertyOption.display.icon }) : null,
	                    selectedProperty ? _react2.default.createElement(
	                        'span',
	                        null,
	                        selectedPropertyOption.display.title,
	                        isDefaultSelected && !this.props.hideDefaultInclusiveTag ? this.props.inclusiveLabel : null,
	                        (isDefaultSelected || hasCustomSelection) && this.props.selectionSuffix ? this.props.selectionSuffix : null
	                    ) : this.props.placeHolder ? this.props.placeHolder : null
	                ),
	                this.state.isOpened ? this.renderOptions(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) : null
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _CartPropertySelection2.default,
	                {
	                    propertyOptions: this.props.propertyOptions,
	                    activeCartProperty: this.props.activeCartProperty,
	                    selectPropertyCallback: this.props.selectPropertyCallback
	                },
	                function (handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) {
	                    return _this2.renderDropdown(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty);
	                }
	            );
	        }
	    }]);
	
	    return CartPropertyDropdownSelection;
	}(_react.Component);
	
	CartPropertyDropdownSelection.propTypes = _extends({}, _CartPropertySelection2.default.propTypes, {
	    placeHolder: _propTypes2.default.string,
	    hideDefaultInclusiveTag: _propTypes2.default.bool,
	    selectionSuffix: _propTypes2.default.string,
	    inclusiveLabel: _propTypes2.default.string
	});
	CartPropertyDropdownSelection.defaultProps = {
	    placeHolder: "",
	    inclusiveLabel: " (inklusive)"
	};
	exports.default = CartPropertyDropdownSelection;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reduxForm = __webpack_require__(12);
	
	var _password = __webpack_require__(181);
	
	var _reactFontawesome = __webpack_require__(26);
	
	var _faLock = __webpack_require__(305);
	
	var _Button = __webpack_require__(284);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	    return {
	        formValues: (0, _reduxForm.getFormValues)(ownProps.formIdentifier)(state),
	        showPassword: (0, _util.delve)(state, "ui.showPassword")
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        copyPassword: function copyPassword(e) {}
	    };
	}
	
	var PasswordHint = function (_Component) {
	    _inherits(PasswordHint, _Component);
	
	    function PasswordHint(props) {
	        _classCallCheck(this, PasswordHint);
	
	        var _this = _possibleConstructorReturn(this, (PasswordHint.__proto__ || Object.getPrototypeOf(PasswordHint)).call(this, props));
	
	        _this.state = {
	            passwordCopied: false
	        };
	        _this.copyPassword = _this.copyPassword.bind(_this);
	        return _this;
	    }
	
	    _createClass(PasswordHint, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	            if (this.state.passwordCopied !== nextState.passwordCopied) {
	                return true;
	            }
	            if (!this.props.formValues && !nextProps.formValues) {
	                return false;
	            }
	            if (nextProps.formValues && this.props.formValues && nextProps.formValues.projectPassword !== this.props.formValues.projectPassword) {
	                return true;
	            }
	            if (nextProps.formValues && this.props.formValues && nextProps.formValues.projectPasswordRepeat !== this.props.formValues.projectPasswordRepeat) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'copyPassword',
	        value: function copyPassword(e) {
	            this.setState({
	                passwordCopied: true
	            });
	            var passwordInput = document.querySelector('input[name="projectPassword"]');
	            passwordInput.setAttribute('type', 'text');
	            if (navigator.clipboard) {
	                navigator.clipboard.writeText(passwordInput.value);
	            } else {
	                passwordInput.select();
	                try {
	                    document.execCommand('copy');
	                } catch (err) {
	                    alert("Dein Passwort konnte nicht kopiert werden!");
	                }
	                if (window.getSelection) {
	                    if (window.getSelection().empty) {
	                        // Chrome
	                        window.getSelection().empty();
	                    } else if (window.getSelection().removeAllRanges) {
	                        // Firefox
	                        window.getSelection().removeAllRanges();
	                    }
	                } else if (document.selection) {
	                    // IE?
	                    document.selection.empty();
	                }
	            }
	            if (!this.props.showPassword) {
	                passwordInput.setAttribute('type', 'password');
	            }
	            passwordInput.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (!this.props.formValues || !this.props.formValues.projectPassword || !this.props.formValues.projectPasswordRepeat) {
	                return null;
	            }
	            var isValidPassword = Object.keys((0, _password.validatePassword)(this.props.formValues.projectPassword, this.props.formValues.projectPasswordRepeat)).length === 0;
	            if (!isValidPassword) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: "password-copy-hint" },
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-copy-hint__icon" },
	                    _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { fixedWidth: true, icon: _faLock.faLock })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "password-copy-hint__content" },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Passwort gespeichert?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Vergiss nicht dir dein hier gesetztes Passwort zu speichern. Du ben\xF6tigst es sp\xE4ter, um auf dein neu angelegtes Projekt im Kundencenter und das Konfigurations-Backend deiner installierten Software zugreifen zu k\xF6nnen. '
	                    ),
	                    this.state.passwordCopied ? _react2.default.createElement(_Button2.default, { onMouseEnter: function onMouseEnter(e) {
	                            _this2.setState({ passwordCopied: false });
	                        }, onClick: this.copyPassword, label: "Passwort kopiert" }) : _react2.default.createElement(_Button2.default, { onClick: this.copyPassword, label: "Passwort kopieren" })
	                )
	            );
	        }
	    }]);
	
	    return PasswordHint;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PasswordHint);

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _CartPropertyDropdownSelection = __webpack_require__(326);
	
	var _CartPropertyDropdownSelection2 = _interopRequireDefault(_CartPropertyDropdownSelection);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _Software = __webpack_require__(180);
	
	var _Properties = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state) {
	    return {
	        softwareInCart: (0, _SimpleSelectors.getCartSoftware)(state),
	        softwareOptions: (0, _Software.getSoftwareOptions)(state),
	        cartIsBusy: state.cart && state.cart.isFetching
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        selectSoftware: function selectSoftware(value) {
	            return dispatch((0, _Properties.querySelectCartProperty)("software", value));
	        }
	    };
	}
	
	var SoftwareSelect = function (_Component) {
	    _inherits(SoftwareSelect, _Component);
	
	    function SoftwareSelect() {
	        _classCallCheck(this, SoftwareSelect);
	
	        return _possibleConstructorReturn(this, (SoftwareSelect.__proto__ || Object.getPrototypeOf(SoftwareSelect)).apply(this, arguments));
	    }
	
	    _createClass(SoftwareSelect, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.softwareOptions) {
	                return null;
	            }
	            return _react2.default.createElement(_CartPropertyDropdownSelection2.default, {
	                propertyOptions: this.props.softwareOptions,
	                activeCartProperty: this.props.softwareInCart,
	                selectPropertyCallback: this.props.selectSoftware,
	                placeHolder: 'Gew\xFCnschte Software zur Vorinstallation w\xE4hlen',
	                selectionSuffix: '',
	                hideDefaultInclusiveTag: true
	            });
	        }
	    }]);
	
	    return SoftwareSelect;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SoftwareSelect);

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.appStateReducer = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _Mode = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// **************************************************************************************************************
	var appStateReducer = exports.appStateReducer = function appStateReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        isInitialized: false,
	        isFetchingFormData: false,
	        orderComplete: false,
	        pinCodeVerified: false,
	        mode: (0, _Mode.getAppMode)()
	    };
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case ActionTypes.APP_INITIALIZED:
	            return Object.assign({}, state, { isInitialized: true });
	
	        case ActionTypes.CART_PINCODE_VERIFY_REQUEST:
	            return Object.assign({}, state, { pinCodeVerified: false });
	
	        case ActionTypes.CART_PINCODE_VERIFY_SUCCESS:
	            return Object.assign({}, state, { pinCodeVerified: true });
	
	        case ActionTypes.CART_PUT_FORM_DATA_REQUEST:
	
	            return Object.assign({}, state, { isFetchingFormData: true });
	
	        case ActionTypes.CART_PUT_FORM_DATA_SUCCESS:
	        case ActionTypes.CART_PUT_FORM_DATA_FAILURE:
	
	            return Object.assign({}, state, { isFetchingFormData: false });
	
	        case ActionTypes.CART_CHECKOUT_REQUEST:
	        case ActionTypes.CART_CHECKOUT_SUCCESS:
	
	            return Object.assign({}, state, { orderComplete: true });
	
	        case ActionTypes.CLIENTDATA_SUCCESS:
	
	            return Object.assign({}, state, { isAuthenticatedUser: true });
	
	        default:
	
	            return state;
	
	    }
	};

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.articleDataReducer = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _General = __webpack_require__(10);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// **************************************************************************************************************
	var articleDataReducer = exports.articleDataReducer = function articleDataReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { baseArticle: {}, articleOptions: {}, articleOptionCollection: {} };
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case _ActionTypes.TOGGLE_SELECTION_TRIGGERED:
	            if (action && action.selectedContentId === _General.OUTSOURCING_ADDPROJECT) {
	
	                return Object.assign({}, state, { baseArticle: {} });
	            } else {
	                return state;
	            }
	
	        case ActionTypes.BASE_ARTICLE_SUCCESS:
	            if (action.response && action.response.entities) {
	
	                var baseArticleData = action.response.entities.article.baseArticle;
	
	                baseArticleData.limits = baseArticleData.configurationData && baseArticleData.configurationData.limits;
	
	                var articleOptionCollection = action.response.entities.articleOptionCollection;
	                var baseHddSwGroup = articleOptionCollection && articleOptionCollection[baseArticleData.articleNumber].hardware && articleOptionCollection[baseArticleData.articleNumber].hardware.hddSw;
	
	                // modify action.response.entities.articleOptionGroup and add default hdd-sw article
	
	                if (baseArticleData.type === 'vserver' || baseArticleData.type === 'shared') {
	                    if (baseHddSwGroup) {
	                        articleOptionCollection[baseArticleData.articleNumber].hardware.hddSw = ["default_hddSw"].concat(_toConsumableArray(baseHddSwGroup));
	                        action.response.entities.articleOption = Object.assign(action.response.entities.articleOption, {
	                            "default_hddSw": {
	                                default: true,
	                                title: Math.round(baseArticleData.projectSpace / 1024 / 1024) + " GB Speicherplatz",
	                                price: { default: { setupFee: 0, priceMonthly: 0, net: 0 } }
	                                /*inclusiveLabel: "Standardvolumen"*/
	                            }
	                        });
	                    }
	                }
	
	                if ((0, _util.delve)(baseArticleData, 'description.default.title')) {
	                    baseArticleData.title = baseArticleData.description.default.title;
	                }
	
	                if ((0, _util.delve)(baseArticleData, 'description.default.text')) {
	                    baseArticleData.description = baseArticleData.description.default.text;
	                }
	
	                // merge articleOptions
	                var articleOptionData = action.response.entities.articleOption;
	
	                var articleOptionsMerged = Object.assign({}, state.articleOptions, _defineProperty({}, baseArticleData.articleNumber, baseArticleData));
	
	                if (articleOptionData) {
	
	                    Object.keys(articleOptionData).forEach(function (articleId) {
	
	                        var articleOptionMerged = {};
	
	                        if (state.articleOptions[articleId]) {
	                            articleOptionMerged = Object.assign({}, state.articleOptions[articleId]);
	                        }
	
	                        // merge price differently since MW API has another price tag, so merge both objects
	                        articleOptionMerged.price = Object.assign(articleOptionMerged.price ? articleOptionMerged.price : {}, articleOptionData[articleId].article && articleOptionData[articleId].article.price ? articleOptionData[articleId].article.price : {}, articleOptionData[articleId].price ? articleOptionData[articleId].price : {});
	
	                        articleOptionMerged.articleNumber = articleOptionData[articleId].article ? articleOptionData[articleId].article.articleNumber : false;
	
	                        articleOptionMerged.limits = articleOptionData[articleId].configurationData && articleOptionData[articleId].configurationData.limits;
	                        articleOptionMerged.inclusiveLabel = articleOptionData[articleId].inclusiveLabel;
	
	                        var articleDescriptionDefault = (0, _util.delve)(articleOptionData[articleId], 'article.description.default');
	
	                        if (articleDescriptionDefault) {
	                            articleOptionMerged.title = articleDescriptionDefault.title;
	                        } else if ((0, _util.delve)(articleOptionData[articleId], 'title')) {
	                            articleOptionMerged.title = articleOptionData[articleId].title ? articleOptionData[articleId].title : articleOptionData[articleId].article ? articleOptionData[articleId].article.title : false;
	                        }
	
	                        if (articleDescriptionDefault) {
	                            articleOptionMerged.description = articleDescriptionDefault.text;
	                        }
	
	                        articleOptionsMerged[articleId] = articleOptionMerged;
	                    });
	                }
	
	                return Object.assign(state, {}, {
	                    baseArticle: action.response.entities.article.baseArticle,
	                    articleOptions: articleOptionsMerged,
	                    articleOptionCollection: Object.assign({}, state.articleOptionCollection, action.response.entities.articleOptionCollection)
	                });
	            }
	            return state;
	
	        case ActionTypes.ARTICLEOPTION_DATA_SUCCESS:
	
	            var stateNew = Object.assign(state, {}, {});
	
	            // mergo extended data into articleOptions
	            if (action.response && action.response.result) {
	
	                var _articleOptionData = action.response.entities.articleOption;
	
	                // get hardware articles by preselecting hardware articles from action response
	                /*const hardwareArticles = getHardwareArticles(state)*/
	
	                Object.keys(action.response.entities.articleOption).forEach(function (articleId) {
	
	                    var articleOptionMerged = Object.assign({}, state.articleOptions[articleId] ? state.articleOptions[articleId] : {}, {
	                        price: Object.assign({}, _articleOptionData[articleId].article && _articleOptionData[articleId].article.price ? _articleOptionData[articleId].article.price : {}, _articleOptionData[articleId].price ? _articleOptionData[articleId].price : {}),
	                        contract: _articleOptionData[articleId].contract ? _articleOptionData[articleId].contract : _articleOptionData[articleId].article ? _articleOptionData[articleId].article.contract : false,
	                        billing: _articleOptionData[articleId].billing ? _articleOptionData[articleId].billing : _articleOptionData[articleId].article ? _articleOptionData[articleId].article.billing : false
	                    });
	
	                    articleOptionMerged.limits = _articleOptionData[articleId].configurationData && _articleOptionData[articleId].configurationData.limits;
	                    articleOptionMerged.projectSpace = _articleOptionData[articleId].projectSpace;
	
	                    // specific for hddsw articles
	                    if ((0, _util.delve)(_articleOptionData[articleId], 'article.configurationData.increaseBenefits.garbageSpaceKb')) {
	                        articleOptionMerged.storageSpaceKb = (0, _util.delve)(_articleOptionData[articleId], 'article.configurationData.increaseBenefits.garbageSpaceKb');
	                    }
	
	                    //todo: awaiting fix from mittwald api
	                    if (articleOptionMerged.contract.contractDuration === 0) {
	                        articleOptionMerged.price.default.setupFee = articleOptionMerged.price.default.net;
	                        articleOptionMerged.price.default.net = 0;
	                    }
	
	                    if (_articleOptionData[articleId].type) {
	                        articleOptionMerged.type = _articleOptionData[articleId].type;
	                    }
	
	                    var articleDescriptionDefault = (0, _util.delve)(_articleOptionData[articleId], 'article.description.default');
	
	                    if (articleDescriptionDefault) {
	                        articleOptionMerged.title = articleDescriptionDefault.title;
	                    } else if ((0, _util.delve)(_articleOptionData[articleId], 'description.default.title')) {
	                        articleOptionMerged.title = _articleOptionData[articleId].description.default.title;
	                    } else if ((0, _util.delve)(_articleOptionData[articleId], 'title')) {
	                        articleOptionMerged.title = _articleOptionData[articleId].title;
	                    }
	
	                    if (articleDescriptionDefault) {
	                        articleOptionMerged.description = articleDescriptionDefault.text;
	                    } else if ((0, _util.delve)(_articleOptionData[articleId], 'description.default.text')) {
	                        articleOptionMerged.description = _articleOptionData[articleId].description.default.text;
	                    } else if ((0, _util.delve)(_articleOptionData[articleId], 'description')) {
	                        articleOptionMerged.description = _articleOptionData[articleId].description;
	                    }
	
	                    var articleOptionsMerged = Object.assign({}, state.articleOptions, _defineProperty({}, articleId, articleOptionMerged));
	                    stateNew = Object.assign(state, {}, { articleOptions: articleOptionsMerged, articleOptionCollection: Object.assign({}, state.articleOptionCollection, action.response.entities.articleOptionCollection) });
	
	                    /* debugging: if(""+articleId==="72203") {
	                        stateNew.articleOptionCollection["72203"].hardware.hddSw = Object.assign(stateNew.articleOptionCollection["72203"].hardware.hddSw, {5:"12345"})
	                        stateNew.articleOptions = Object.assign(stateNew.articleOptions, {12345:{title:"12345", price:{default:{net:20, setupFee:0}}}})
	                    }*/
	                });
	
	                return stateNew;
	            }
	
	            return state;
	
	        default:
	            return state;
	    }
	};

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleSelectionReducer = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// **************************************************************************************************************
	var toggleSelectionReducer = exports.toggleSelectionReducer = function toggleSelectionReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case ActionTypes.TOGGLE_SELECTION_TRIGGERED:
	
	            return Object.assign({}, state, _defineProperty({}, action.selectionId, action.selectedContentId));
	
	        default:
	            return state;
	
	    }
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.tokenReducer = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var tokenReducer = exports.tokenReducer = function tokenReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { bearer: "", expires: "", isAuthenticatedUser: false };
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case ActionTypes.AUTHENTICATION_SUCCESS:
	            if (!action.response) {
	                return state;
	            }
	            return Object.assign({}, state, {
	                bearer: action.response.entities.tokens.token.token,
	                expires: action.response.entities.tokens.token.expires,
	                isAuthenticatedUser: true
	            });
	
	        case ActionTypes.BEARER_TOKEN_SUCCESS:
	            if (!action.response) {
	                return state;
	            }
	            return Object.assign({}, state, {
	                bearer: action.response.entities.tokens.token.token,
	                expires: action.response.entities.tokens.token.expires,
	                isAuthenticatedUser: false
	            });
	
	        case ActionTypes.CLIENTDATA_SELECT_NEW:
	            return Object.assign({}, state, {
	                isAuthenticatedUser: false
	            });
	        default:
	            return state;
	
	    }
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uiReducer = undefined;
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _StepLabels = __webpack_require__(41);
	
	var StepLabels = _interopRequireWildcard(_StepLabels);
	
	var _UserInterface = __webpack_require__(70);
	
	var _Mode = __webpack_require__(18);
	
	var _General = __webpack_require__(10);
	
	var _Cart = __webpack_require__(36);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// **************************************************************************************************************
	
	var uiReducer = exports.uiReducer = function uiReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stepConfiguration: {}, currentStep: false, stepsCompleted: [], forcedValidationSteps: [], supportBoxVisible: true, configurationScrollProgress: 0 };
	    var action = arguments[1];
	
	
	    var calculateNextStep = function calculateNextStep(currentStep) {
	        var stepOrder = (0, _UserInterface.getStepOrder)(action.payload.state);
	        return stepOrder[Math.min(stepOrder.length - 1, stepOrder.indexOf(currentStep) + 1)];
	    };
	
	    var calculatePrevStep = function calculatePrevStep(currentStep) {
	        var stepOrder = (0, _UserInterface.getStepOrder)(action.payload.state);
	        return stepOrder[Math.max(0, stepOrder.indexOf(currentStep) - 1)];
	    };
	
	    switch (action.type) {
	
	        case ActionTypes.STEP_UNDONE:
	
	            return Object.assign({}, state, { stepsCompleted: state.stepsCompleted.filter(function (elem) {
	                    return elem !== action.stepLabel;
	                }) });
	
	        case ActionTypes.FORM_TOGGLE_PASSWORD_VISIBILITY:
	
	            // might need key-object-storage if more password fields get added
	            return Object.assign({}, state, { showPassword: !!!state.showPassword });
	
	        /*        case ActionTypes.BASE_ARTICLE_SELECT:
	        
	                    // force users to revisit config step as the config steps are responsible for loading article data
	                    if (isMode(APP_MODE_REGULAR)) {
	                        return state;
	                    }
	                    return Object.assign({}, state, {stepsCompleted: state.stepsCompleted.filter(elem => elem !== StepLabels.OUTSOURCING_CONFIG && elem !== StepLabels.CONFIG)})*/
	
	        case ActionTypes.CONFIGURATION_SCROLL_PROGRESS:
	
	            return Object.assign({}, state, { configurationScrollProgress: action.configurationScrollProgress });
	
	        case ActionTypes.APP_INITIALIZED:
	
	            if (state.currentStep) {
	                return state;
	            }
	
	            return Object.assign({}, state, { currentStep: action.payload && action.payload.initialStep ? action.payload.initialStep : StepLabels.CONFIG });
	
	        case ActionTypes.SUPPORT_BOX_HIDDEN:
	
	            return Object.assign({}, state, { supportBoxVisible: false });
	
	        case ActionTypes.SUPPORT_BOX_SHOWN:
	
	            return Object.assign({}, state, { supportBoxVisible: true });
	
	        case ActionTypes.STEP_FORCE_VALIDATION:
	
	            return Object.assign({}, state, { forcedValidationSteps: action.stepsToBeValidated });
	
	        case ActionTypes.STEP_SELECTED:
	
	            // don't do anything if going to same step
	            if (action.goingTo === state.currentStep) {
	                return state;
	            }
	
	            var newStepState = Object.assign({}, state, { currentStep: action.goingTo, configurationScrollProgress: 0 });
	
	            // add currentStep to completed list only if not already completed and only if not going to a previously completed step
	            if (!state.stepsCompleted.includes(state.currentStep) && !state.stepsCompleted.includes(action.goingTo)) {
	                newStepState.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [state.currentStep]);
	            }
	
	            return newStepState;
	
	        case ActionTypes.CLIENTDATA_SELECT_NEW:
	
	            // remove completed steps on setting new customer
	
	            var stepsCompleted = state.stepsCompleted.filter(function (elem) {
	                if ([StepLabels.PAYMENT].includes(elem)) {
	                    return null;
	                } else {
	                    return elem;
	                }
	            });
	
	            return Object.assign({}, state, { stepsCompleted: stepsCompleted });
	
	        case ActionTypes.STEP_SELECT_LATEST:
	
	            var stepConfig = (0, _UserInterface.getLabeledStepOrder)(action.payload.state);
	            var stepsCompletedFiltered = state.stepsCompleted.filter(function (elem) {
	                return !!stepConfig[elem];
	            });
	
	            return Object.assign({}, state, { currentStep: calculateNextStep(state.stepsCompleted[stepsCompletedFiltered.length - 1]), configurationScrollProgress: 0 });
	
	        case ActionTypes.STEP_CONTROL_NEXT:
	
	            var newState = Object.assign({}, state, { currentStep: calculateNextStep(state.currentStep), configurationScrollProgress: 0 });
	
	            if (!newState.stepsCompleted.includes(state.currentStep)) {
	                newState.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [state.currentStep]);
	            }
	
	            // skip payment step if payload in action
	            if (action.payload && action.payload.skipPaymentStep) {
	
	                if (newState.currentStep === StepLabels.PAYMENT) {
	                    if (!newState.stepsCompleted.includes(StepLabels.PAYMENT)) {
	                        newState.stepsCompleted = [].concat(_toConsumableArray(newState.stepsCompleted), [StepLabels.PAYMENT]);
	                    }
	                    newState.currentStep = calculateNextStep(StepLabels.PAYMENT);
	                }
	            }
	
	            return newState;
	
	        case ActionTypes.STEP_CONTROL_PREV:
	
	            newState = Object.assign({}, state, { currentStep: calculatePrevStep(state.currentStep), configurationScrollProgress: 0 });
	
	            // skip payment step if payload in action
	            if (action.payload && action.payload.skipPaymentStep) {
	
	                if (newState.currentStep === StepLabels.PAYMENT) {
	                    newState.currentStep = calculatePrevStep(StepLabels.PAYMENT);
	                }
	            }
	
	            return newState;
	
	        case ActionTypes.CART_PUT_FORM_DATA_SUCCESS:
	        case ActionTypes.CART_ADD_ITEM_SUCCESS:
	        case ActionTypes.CART_UPDATE_SUCCESS:
	        case ActionTypes.CART_CREATE_SUCCESS:
	
	            if (!(action.payload && action.payload.updateSteps)) {
	                return state;
	            }
	
	            state = Object.assign({}, state);
	
	            var cartData = action.response.result;
	
	            // set completed steps according to cart data ////////////////////////////////////
	
	            // if domains in cart, unlock domain
	
	            if (cartData.items) {
	
	                var mainArticle = (0, _Cart.getMainArticleByItems)(cartData.items);
	
	                var articleItems = cartData.items.filter(function (cartItem) {
	                    return cartItem.itemType !== "DOMAIN" && cartItem.identifier !== mainArticle;
	                });
	
	                var domainItems = cartData.items.filter(function (cartItem) {
	                    return cartItem.itemType === "DOMAIN";
	                });
	
	                if (articleItems.length > 0) {
	                    if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {}
	                    //state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
	
	                    //comment: don't unlock domainstep when items in cart
	                    //state.currentStep = StepLabels.DOMAIN
	                }
	
	                if (domainItems.length > 0) {
	
	                    if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
	                        state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.CONFIG]);
	                    }
	
	                    if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
	                        state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.DOMAIN]);
	                        //state.currentStep = StepLabels.CLIENTDATA
	                    }
	                }
	            }
	            // if any form data is set, unlock clientstepdata
	            if (cartData.contractPartner || cartData.billingAddress || cartData.contactPerson) {
	
	                if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
	                    state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.CONFIG]);
	                }
	
	                if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
	                    state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.DOMAIN]);
	                }
	
	                if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {
	                    state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.CLIENTDATA]);
	                    //state.currentStep = StepLabels.PAYMENT
	                }
	            }
	
	            // if any payment setting is chosen, unlock paymentdata
	            if (cartData.paymentSettings) {
	
	                if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
	                    //state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
	                }
	
	                if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
	                    //state.stepsCompleted = [...state.stepsCompleted, StepLabels.DOMAIN]
	                }
	
	                if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {}
	                //state.stepsCompleted = [...state.stepsCompleted, StepLabels.CLIENTDATA]
	
	
	                // if everything is unlocked, unlock summary)
	                if ('postalInvoice' in cartData.paymentSettings && cartData.paymentSettings.billingType && cartData.contractPartner) {
	                    if (!state.stepsCompleted.includes(StepLabels.PAYMENT)) {
	                        //state.stepsCompleted = [...state.stepsCompleted, StepLabels.PAYMENT]
	                        //state.currentStep = StepLabels.SUMMARY
	                    }
	                }
	            }
	
	            if (action.payload && action.payload.isUserAuthenticated) {
	
	                if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
	                    state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.CONFIG]);
	                }
	
	                if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
	                    state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.DOMAIN]);
	                }
	
	                if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {
	                    state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.CLIENTDATA]);
	                }
	
	                /*if (!state.stepsCompleted.includes(StepLabels.PAYMENT))
	                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.PAYMENT]*/
	            }
	
	            return state;
	
	        case ActionTypes.AUTHENTICATION_CACHED:
	
	            state = Object.assign({}, state);
	
	            if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
	                state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.CONFIG]);
	            }
	
	            if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
	                state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.DOMAIN]);
	            }
	
	            if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {
	                state.stepsCompleted = [].concat(_toConsumableArray(state.stepsCompleted), [StepLabels.CLIENTDATA]);
	                //state.currentStep = StepLabels.PAYMENT
	            }
	
	            return state;
	
	        default:
	            return state;
	
	    }
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCustomDisplayData = exports.getHddOptionDisplayData = undefined;
	
	var _reselect = __webpack_require__(31);
	
	var _Util = __webpack_require__(335);
	
	var _ProductSelection = __webpack_require__(48);
	
	var _SimpleSelectors = __webpack_require__(7);
	
	var _util = __webpack_require__(9);
	
	var _CartUtil = __webpack_require__(37);
	
	// **************************************************************************************************************
	
	var getHddOptionDisplayData = exports.getHddOptionDisplayData = (0, _reselect.createSelector)([function (state) {
	    return state.articleData.articleOptions;
	}, function (state) {
	    return state.articleData.articleOptionCollection[state.articleData.baseArticle.articleNumber].hardware.hddSw;
	}, _ProductSelection.getCurrentProduct, _ProductSelection.getSelectedAccount, _SimpleSelectors.getAccounts, _ProductSelection.getSelectedArticle, _SimpleSelectors.getCart, _CartUtil.getArticleOptionsInCartObject], function (articleOptions, articleNumbers, currentProduct, account, accounts, selectedArticle, cart) {
	
	    if (articleNumbers) {
	
	        var regex = /(\d{1,})/;
	
	        // calculate minUsageGb if different product is selected
	        var minUsageGB = currentProduct !== selectedArticle ? account ? (0, _util.delve)(accounts, account + ".stats.summary") / 1024 / 1024 : 0 : 0;
	
	        var inclusiveStorageGB = articleNumbers.indexOf("default_hddSw") >= 0 ? regex.exec(articleOptions["default_hddSw"].title)[1] : 0;
	
	        if ((0, _util.delve)(cart, "initParams.minSelectedUsageGB")) {
	            minUsageGB = Math.max(minUsageGB, Number(inclusiveStorageGB) + Number((0, _util.delve)(cart, "initParams.minSelectedUsageGB")));
	        }
	
	        return articleNumbers.map(function (articleNumber) {
	            return (0, _Util.buildArticleOptionDisplayData)(articleOptions, articleNumber);
	        }).sort(function (a, b) {
	            return a.display.price.priceMonthly - b.display.price.priceMonthly;
	        }).map(function (option) {
	
	            var optionMaxUsageGB = regex.exec(option.display.title)[1];
	            var isInclusiveOption = option.value.indexOf("default_") >= 0;
	
	            var disabled = false;
	
	            // check if inclusive storage plus option storage would be enough to fit the minUsageGB
	            return Object.assign({}, option, { disabled: disabled });
	        });
	    } else {
	        return [];
	    }
	});
	
	var getCustomDisplayData = exports.getCustomDisplayData = function getCustomDisplayData(state, articleNumbers) {
	    var articleOptions = state.articleData.articleOptions;
	    if (articleNumbers) {
	        return articleNumbers.map(function (articleNumber) {
	            return (0, _Util.buildArticleOptionDisplayData)(articleOptions, articleNumber);
	        }).filter(Boolean);
	    } else {
	        return [];
	    }
	};

/***/ },
/* 335 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// **************************************************************************************************************
	var buildArticleOptionDisplayData = exports.buildArticleOptionDisplayData = function buildArticleOptionDisplayData(articleOptions, articleNumber) {
	
	    var articleData = articleOptions[articleNumber];
	
	    if (!articleData) {
	        return null;
	    }
	
	    var badge = false;
	
	    if (articleData.view && articleData.view.badge && articleData.view.badge.enabled) {
	        badge = {
	            view: articleData.view.badge.view,
	            label: articleData.view.badge.label
	        };
	    }
	
	    return {
	        value: articleNumber,
	        display: {
	            title: articleData.title,
	            description: articleData.description,
	            badge: badge,
	            inclusiveLabel: articleData.inclusiveLabel,
	            background: articleData.view && articleData.view.background ? articleData.view.background : false,
	            price: {
	                setupFee: articleData.price && articleData.price.default.setupFee ? articleData.price.default.setupFee : 0,
	                priceMonthly: articleData.price && articleData.price.default.net ? articleData.price.default.net : 0
	            }
	        }
	    };
	};

/***/ },
/* 336 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(211);
	__webpack_require__(213);
	__webpack_require__(212);
	__webpack_require__(215);
	__webpack_require__(217);
	__webpack_require__(221);
	__webpack_require__(216);
	__webpack_require__(214);
	__webpack_require__(223);
	__webpack_require__(222);
	__webpack_require__(219);
	__webpack_require__(220);
	__webpack_require__(218);
	__webpack_require__(376);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(208);
	__webpack_require__(210);
	__webpack_require__(200);
	__webpack_require__(205);
	__webpack_require__(199);
	__webpack_require__(209);
	__webpack_require__(198);
	__webpack_require__(207);
	__webpack_require__(206);
	__webpack_require__(201);
	__webpack_require__(204);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(373);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(384);
	__webpack_require__(383);
	__webpack_require__(225);
	__webpack_require__(391);
	module.exports = __webpack_require__(32);


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224);
	__webpack_require__(202);
	__webpack_require__(369);
	__webpack_require__(371);
	__webpack_require__(203);
	__webpack_require__(208);
	__webpack_require__(210);
	__webpack_require__(200);
	__webpack_require__(205);
	__webpack_require__(199);
	__webpack_require__(209);
	__webpack_require__(198);
	__webpack_require__(207);
	__webpack_require__(206);
	__webpack_require__(201);
	__webpack_require__(204);
	__webpack_require__(365);
	__webpack_require__(366);
	__webpack_require__(368);
	__webpack_require__(367);
	__webpack_require__(372);
	__webpack_require__(370);
	module.exports = __webpack_require__(32).Array;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(412);
	__webpack_require__(211);
	__webpack_require__(213);
	__webpack_require__(212);
	__webpack_require__(215);
	__webpack_require__(217);
	__webpack_require__(221);
	__webpack_require__(216);
	__webpack_require__(214);
	__webpack_require__(223);
	__webpack_require__(222);
	__webpack_require__(219);
	__webpack_require__(220);
	__webpack_require__(218);
	__webpack_require__(379);
	__webpack_require__(380);
	__webpack_require__(381);
	__webpack_require__(382);
	
	module.exports = __webpack_require__(32).Object;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(401);
	__webpack_require__(405);
	__webpack_require__(225);
	__webpack_require__(224);
	__webpack_require__(396);
	__webpack_require__(397);
	__webpack_require__(402);
	__webpack_require__(406);
	__webpack_require__(408);
	__webpack_require__(392);
	__webpack_require__(393);
	__webpack_require__(394);
	__webpack_require__(395);
	__webpack_require__(398);
	__webpack_require__(399);
	__webpack_require__(400);
	__webpack_require__(403);
	__webpack_require__(404);
	__webpack_require__(407);
	__webpack_require__(409);
	__webpack_require__(410);
	__webpack_require__(411);
	__webpack_require__(387);
	__webpack_require__(388);
	__webpack_require__(389);
	__webpack_require__(390);
	module.exports = __webpack_require__(32).String;


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(415);
	__webpack_require__(413);
	__webpack_require__(414);
	module.exports = __webpack_require__(32).Array;


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(419);
	__webpack_require__(422);
	__webpack_require__(418);
	__webpack_require__(416);
	__webpack_require__(417);
	__webpack_require__(420);
	__webpack_require__(421);
	module.exports = __webpack_require__(32).Object;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(15);
	var toAbsoluteIndex = __webpack_require__(88);
	var toLength = __webpack_require__(20);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(15);
	var toAbsoluteIndex = __webpack_require__(88);
	var toLength = __webpack_require__(20);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	var isArray = __webpack_require__(101);
	var SPECIES = __webpack_require__(16)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(49);
	var isObject = __webpack_require__(21);
	var invoke = __webpack_require__(350);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(13);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(73);
	var gOPS = __webpack_require__(105);
	var pIE = __webpack_require__(86);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(108)('native-function-to-string', Function.toString);


/***/ },
/* 350 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(102);
	var ITERATOR = __webpack_require__(16)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(25);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(144);
	var descriptor = __webpack_require__(87);
	var setToStringTag = __webpack_require__(147);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(57)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(16)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 355 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(19);
	var getKeys = __webpack_require__(73);
	var gOPS = __webpack_require__(105);
	var pIE = __webpack_require__(86);
	var toObject = __webpack_require__(15);
	var IObject = __webpack_require__(84);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(13)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(145);
	var gOPS = __webpack_require__(105);
	var anObject = __webpack_require__(25);
	var Reflect = __webpack_require__(29).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(29).parseFloat;
	var $trim = __webpack_require__(151).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(152) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(29).parseInt;
	var $trim = __webpack_require__(151).trim;
	var ws = __webpack_require__(152);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(21);
	var anObject = __webpack_require__(25);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(83)(Function.call, __webpack_require__(72).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(29);
	var dP = __webpack_require__(33);
	var DESCRIPTORS = __webpack_require__(19);
	var SPECIES = __webpack_require__(16)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(25);
	var aFunction = __webpack_require__(49);
	var SPECIES = __webpack_require__(16)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var core = __webpack_require__(32);
	var LIBRARY = __webpack_require__(85);
	var wksExt = __webpack_require__(197);
	var defineProperty = __webpack_require__(33).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(139);
	var ITERATOR = __webpack_require__(16)('iterator');
	var Iterators = __webpack_require__(102);
	module.exports = __webpack_require__(32).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(343) });
	
	__webpack_require__(50)('copyWithin');


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { fill: __webpack_require__(344) });
	
	__webpack_require__(50)('fill');


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(55)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(50)(KEY);


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(55)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(50)(KEY);


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(83);
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(15);
	var call = __webpack_require__(352);
	var isArrayIter = __webpack_require__(351);
	var toLength = __webpack_require__(20);
	var createProperty = __webpack_require__(140);
	var getIterFn = __webpack_require__(364);
	
	$export($export.S + $export.F * !__webpack_require__(354)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(50);
	var step = __webpack_require__(355);
	var Iterators = __webpack_require__(102);
	var toIObject = __webpack_require__(34);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(190)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var createProperty = __webpack_require__(140);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(361)('Array');


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(4);
	var toISOString = __webpack_require__(347);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(75);
	
	$export($export.P + $export.F * __webpack_require__(13)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Function', { bind: __webpack_require__(346) });


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toInteger = __webpack_require__(52);
	var aNumberValue = __webpack_require__(183);
	var repeat = __webpack_require__(196);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(13)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $fails = __webpack_require__(13);
	var aNumberValue = __webpack_require__(183);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(4);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(356) });


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { is: __webpack_require__(195) });


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(360).set });


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(139);
	var test = {};
	test[__webpack_require__(16)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(74)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(358);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(359);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(146);
	__webpack_require__(4)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(19) && /./g.flags != 'g') __webpack_require__(33).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(143)
	});


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(25);
	var toLength = __webpack_require__(20);
	var advanceStringIndex = __webpack_require__(136);
	var regExpExec = __webpack_require__(107);
	
	// @@match logic
	__webpack_require__(100)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(25);
	var toObject = __webpack_require__(15);
	var toLength = __webpack_require__(20);
	var toInteger = __webpack_require__(52);
	var advanceStringIndex = __webpack_require__(136);
	var regExpExec = __webpack_require__(107);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(100)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(25);
	var sameValue = __webpack_require__(195);
	var regExpExec = __webpack_require__(107);
	
	// @@search logic
	__webpack_require__(100)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(189);
	var anObject = __webpack_require__(25);
	var speciesConstructor = __webpack_require__(362);
	var advanceStringIndex = __webpack_require__(136);
	var toLength = __webpack_require__(20);
	var callRegExpExec = __webpack_require__(107);
	var regexpExec = __webpack_require__(146);
	var fails = __webpack_require__(13);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(100)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(386);
	var anObject = __webpack_require__(25);
	var $flags = __webpack_require__(143);
	var DESCRIPTORS = __webpack_require__(19);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(74)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(13)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(30)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(30)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(30)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(30)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(149)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(20);
	var context = __webpack_require__(150);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(142)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(30)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(30)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(30)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(88);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(4);
	var context = __webpack_require__(150);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(142)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(30)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(30)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(34);
	var toLength = __webpack_require__(20);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(196)
	});


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(30)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(20);
	var context = __webpack_require__(150);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(142)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(30)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(30)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(30)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(29);
	var has = __webpack_require__(56);
	var DESCRIPTORS = __webpack_require__(19);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(74);
	var META = __webpack_require__(103).KEY;
	var $fails = __webpack_require__(13);
	var shared = __webpack_require__(108);
	var setToStringTag = __webpack_require__(147);
	var uid = __webpack_require__(89);
	var wks = __webpack_require__(16);
	var wksExt = __webpack_require__(197);
	var wksDefine = __webpack_require__(363);
	var enumKeys = __webpack_require__(348);
	var isArray = __webpack_require__(101);
	var anObject = __webpack_require__(25);
	var isObject = __webpack_require__(21);
	var toObject = __webpack_require__(15);
	var toIObject = __webpack_require__(34);
	var toPrimitive = __webpack_require__(75);
	var createDesc = __webpack_require__(87);
	var _create = __webpack_require__(144);
	var gOPNExt = __webpack_require__(192);
	var $GOPD = __webpack_require__(72);
	var $GOPS = __webpack_require__(105);
	var $DP = __webpack_require__(33);
	var $keys = __webpack_require__(73);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(145).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(86).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(85)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(57)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(186);
	var toObject = __webpack_require__(15);
	var toLength = __webpack_require__(20);
	var aFunction = __webpack_require__(49);
	var arraySpeciesCreate = __webpack_require__(138);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(50)('flatMap');


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(186);
	var toObject = __webpack_require__(15);
	var toLength = __webpack_require__(20);
	var toInteger = __webpack_require__(52);
	var arraySpeciesCreate = __webpack_require__(138);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(50)('flatten');


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(4);
	var $includes = __webpack_require__(137)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(50)('includes');


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(15);
	var aFunction = __webpack_require__(49);
	var $defineProperty = __webpack_require__(33);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(19) && $export($export.P + __webpack_require__(104), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(15);
	var aFunction = __webpack_require__(49);
	var $defineProperty = __webpack_require__(33);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(19) && $export($export.P + __webpack_require__(104), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $entries = __webpack_require__(194)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(4);
	var ownKeys = __webpack_require__(357);
	var toIObject = __webpack_require__(34);
	var gOPD = __webpack_require__(72);
	var createProperty = __webpack_require__(140);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(75);
	var getPrototypeOf = __webpack_require__(106);
	var getOwnPropertyDescriptor = __webpack_require__(72).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(19) && $export($export.P + __webpack_require__(104), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(75);
	var getPrototypeOf = __webpack_require__(106);
	var getOwnPropertyDescriptor = __webpack_require__(72).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(19) && $export($export.P + __webpack_require__(104), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $values = __webpack_require__(194)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(424));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 424 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(226));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(226));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function(factory) {
	    'use strict';
	    /* global window: false, define: false, module: false */
	    var root = typeof window === 'undefined' ? null : window;
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){ return factory(root); }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined') {
	        module.exports = factory(root);
	    } else {
	        root.DOMPurify = factory(root);
	    }
	}(function factory(window) {
	    'use strict';
	
	    var DOMPurify = function(window) {
	        return factory(window);
	    };
	
	    /**
	     * Version label, exposed for easier checks
	     * if DOMPurify is up to date or not
	     */
	    DOMPurify.version = '0.8.9';
	
	    /**
	     * Array of elements that DOMPurify removed during sanitation.
	     * Empty if nothing was removed.
	     */
	    DOMPurify.removed = [];
	
	    if (!window || !window.document || window.document.nodeType !== 9) {
	        // not running in a browser, provide a factory function
	        // so that you can pass your own Window
	        DOMPurify.isSupported = false;
	        return DOMPurify;
	    }
	
	    var document = window.document;
	    var originalDocument = document;
	    var DocumentFragment = window.DocumentFragment;
	    var HTMLTemplateElement = window.HTMLTemplateElement;
	    var Node = window.Node;
	    var NodeFilter = window.NodeFilter;
	    var NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap;
	    var Text = window.Text;
	    var Comment = window.Comment;
	    var DOMParser = window.DOMParser;
	    var useDOMParser = false; // See comment below
	
	    // As per issue #47, the web-components registry is inherited by a
	    // new document created via createHTMLDocument. As per the spec
	    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
	    // a new empty registry is used when creating a template contents owner
	    // document, so we use that as our parent document to ensure nothing
	    // is inherited.
	    if (typeof HTMLTemplateElement === 'function') {
	        var template = document.createElement('template');
	        if (template.content && template.content.ownerDocument) {
	            document = template.content.ownerDocument;
	        }
	    }
	    var implementation = document.implementation;
	    var createNodeIterator = document.createNodeIterator;
	    var getElementsByTagName = document.getElementsByTagName;
	    var createDocumentFragment = document.createDocumentFragment;
	    var importNode = originalDocument.importNode;
	
	    var hooks = {};
	
	    /**
	     * Expose whether this browser supports running the full DOMPurify.
	     */
	    DOMPurify.isSupported =
	        typeof implementation.createHTMLDocument !== 'undefined' &&
	        document.documentMode !== 9;
	
	    /* Add properties to a lookup table */
	    var _addToSet = function(set, array) {
	        var l = array.length;
	        while (l--) {
	            if (typeof array[l] === 'string') {
	                array[l] = array[l].toLowerCase();
	            }
	            set[array[l]] = true;
	        }
	        return set;
	    };
	
	    /* Shallow clone an object */
	    var _cloneObj = function(object) {
	        var newObject = {};
	        var property;
	        for (property in object) {
	            if (object.hasOwnProperty(property)) {
	                newObject[property] = object[property];
	            }
	        }
	        return newObject;
	    };
	
	    /**
	     * We consider the elements and attributes below to be safe. Ideally
	     * don't add any new ones but feel free to remove unwanted ones.
	     */
	
	    /* allowed element names */
	    var ALLOWED_TAGS = null;
	    var DEFAULT_ALLOWED_TAGS = _addToSet({}, [
	
	        // HTML
	        'a','abbr','acronym','address','area','article','aside','audio','b',
	        'bdi','bdo','big','blink','blockquote','body','br','button','canvas',
	        'caption','center','cite','code','col','colgroup','content','data',
	        'datalist','dd','decorator','del','details','dfn','dir','div','dl','dt',
	        'element','em','fieldset','figcaption','figure','font','footer','form',
	        'h1','h2','h3','h4','h5','h6','head','header','hgroup','hr','html','i',
	        'img','input','ins','kbd','label','legend','li','main','map','mark',
	        'marquee','menu','menuitem','meter','nav','nobr','ol','optgroup',
	        'option','output','p','pre','progress','q','rp','rt','ruby','s','samp',
	        'section','select','shadow','small','source','spacer','span','strike',
	        'strong','style','sub','summary','sup','table','tbody','td','template',
	        'textarea','tfoot','th','thead','time','tr','track','tt','u','ul','var',
	        'video','wbr',
	
	        // SVG
	        'svg','altglyph','altglyphdef','altglyphitem','animatecolor',
	        'animatemotion','animatetransform','circle','clippath','defs','desc',
	        'ellipse','filter','font','g','glyph','glyphref','hkern','image','line',
	        'lineargradient','marker','mask','metadata','mpath','path','pattern',
	        'polygon','polyline','radialgradient','rect','stop','switch','symbol',
	        'text','textpath','title','tref','tspan','view','vkern',
	
	        // SVG Filters
	        'feBlend','feColorMatrix','feComponentTransfer','feComposite',
	        'feConvolveMatrix','feDiffuseLighting','feDisplacementMap',
	        'feFlood','feFuncA','feFuncB','feFuncG','feFuncR','feGaussianBlur',
	        'feMerge','feMergeNode','feMorphology','feOffset',
	        'feSpecularLighting','feTile','feTurbulence',
	
	        //MathML
	        'math','menclose','merror','mfenced','mfrac','mglyph','mi','mlabeledtr',
	        'mmuliscripts','mn','mo','mover','mpadded','mphantom','mroot','mrow',
	        'ms','mpspace','msqrt','mystyle','msub','msup','msubsup','mtable','mtd',
	        'mtext','mtr','munder','munderover',
	
	        //Text
	        '#text'
	    ]);
	
	    /* Allowed attribute names */
	    var ALLOWED_ATTR = null;
	    var DEFAULT_ALLOWED_ATTR = _addToSet({}, [
	
	        // HTML
	        'accept','action','align','alt','autocomplete','background','bgcolor',
	        'border','cellpadding','cellspacing','checked','cite','class','clear','color',
	        'cols','colspan','coords','datetime','default','dir','disabled',
	        'download','enctype','face','for','headers','height','hidden','high','href',
	        'hreflang','id','ismap','label','lang','list','loop', 'low','max',
	        'maxlength','media','method','min','multiple','name','noshade','novalidate',
	        'nowrap','open','optimum','pattern','placeholder','poster','preload','pubdate',
	        'radiogroup','readonly','rel','required','rev','reversed','role','rows',
	        'rowspan','spellcheck','scope','selected','shape','size','span',
	        'srclang','start','src','step','style','summary','tabindex','title',
	        'type','usemap','valign','value','width','xmlns',
	
	        // SVG
	        'accent-height','accumulate','additivive','alignment-baseline',
	        'ascent','attributename','attributetype','azimuth','basefrequency',
	        'baseline-shift','begin','bias','by','clip','clip-path','clip-rule',
	        'color','color-interpolation','color-interpolation-filters','color-profile',
	        'color-rendering','cx','cy','d','dx','dy','diffuseconstant','direction',
	        'display','divisor','dur','edgemode','elevation','end','fill','fill-opacity',
	        'fill-rule','filter','flood-color','flood-opacity','font-family','font-size',
	        'font-size-adjust','font-stretch','font-style','font-variant','font-weight',
	        'fx', 'fy','g1','g2','glyph-name','glyphref','gradientunits','gradienttransform',
	        'image-rendering','in','in2','k','k1','k2','k3','k4','kerning','keypoints',
	        'keysplines','keytimes','lengthadjust','letter-spacing','kernelmatrix',
	        'kernelunitlength','lighting-color','local','marker-end','marker-mid',
	        'marker-start','markerheight','markerunits','markerwidth','maskcontentunits',
	        'maskunits','max','mask','mode','min','numoctaves','offset','operator',
	        'opacity','order','orient','orientation','origin','overflow','paint-order',
	        'path','pathlength','patterncontentunits','patterntransform','patternunits',
	        'points','preservealpha','r','rx','ry','radius','refx','refy','repeatcount',
	        'repeatdur','restart','result','rotate','scale','seed','shape-rendering',
	        'specularconstant','specularexponent','spreadmethod','stddeviation','stitchtiles',
	        'stop-color','stop-opacity','stroke-dasharray','stroke-dashoffset','stroke-linecap',
	        'stroke-linejoin','stroke-miterlimit','stroke-opacity','stroke','stroke-width',
	        'surfacescale','targetx','targety','transform','text-anchor','text-decoration',
	        'text-rendering','textlength','u1','u2','unicode','values','viewbox',
	        'visibility','vert-adv-y','vert-origin-x','vert-origin-y','word-spacing',
	        'wrap','writing-mode','xchannelselector','ychannelselector','x','x1','x2',
	        'y','y1','y2','z','zoomandpan',
	
	        // MathML
	        'accent','accentunder','bevelled','close','columnsalign','columnlines',
	        'columnspan','denomalign','depth','display','displaystyle','fence',
	        'frame','largeop','length','linethickness','lspace','lquote',
	        'mathbackground','mathcolor','mathsize','mathvariant','maxsize',
	        'minsize','movablelimits','notation','numalign','open','rowalign',
	        'rowlines','rowspacing','rowspan','rspace','rquote','scriptlevel',
	        'scriptminsize','scriptsizemultiplier','selection','separator',
	        'separators','stretchy','subscriptshift','supscriptshift','symmetric',
	        'voffset',
	
	        // XML
	        'xlink:href','xml:id','xlink:title','xml:space','xmlns:xlink'
	    ]);
	
	    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
	    var FORBID_TAGS = null;
	
	    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
	    var FORBID_ATTR = null;
	
	    /* Decide if ARIA attributes are okay */
	    var ALLOW_ARIA_ATTR = true;
	
	    /* Decide if custom data attributes are okay */
	    var ALLOW_DATA_ATTR = true;
	
	    /* Decide if unknown protocols are okay */
	    var ALLOW_UNKNOWN_PROTOCOLS = false;
	
	    /* Output should be safe for jQuery's $() factory? */
	    var SAFE_FOR_JQUERY = false;
	
	    /* Output should be safe for common template engines.
	     * This means, DOMPurify removes data attributes, mustaches and ERB
	     */
	    var SAFE_FOR_TEMPLATES = false;
	
	    /* Specify template detection regex for SAFE_FOR_TEMPLATES mode */
	    var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm;
	    var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;
	
	    /* Decide if document with <html>... should be returned */
	    var WHOLE_DOCUMENT = false;
	
	    /* Decide if all elements (e.g. style, script) must be children of
	     * document.body. By default, browsers might move them to document.head */
	    var FORCE_BODY = false;
	
	    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
	     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
	     */
	    var RETURN_DOM = false;
	
	    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
	    var RETURN_DOM_FRAGMENT = false;
	
	    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
	     * `Node` is imported into the current `Document`. If this flag is not enabled the
	     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
	     * DOMPurify. */
	    var RETURN_DOM_IMPORT = false;
	
	    /* Output should be free from DOM clobbering attacks? */
	    var SANITIZE_DOM = true;
	
	    /* Keep element content when removing element? */
	    var KEEP_CONTENT = true;
	
	    /* Tags to ignore content of when KEEP_CONTENT is true */
	    var FORBID_CONTENTS = _addToSet({}, [
	        'audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video'
	    ]);
	
	    /* Tags that are safe for data: URIs */
	    var DATA_URI_TAGS = _addToSet({}, [
	        'audio', 'video', 'img', 'source', 'image'
	    ]);
	
	    /* Attributes safe for values like "javascript:" */
	    var URI_SAFE_ATTRIBUTES = _addToSet({}, [
	        'alt','class','for','id','label','name','pattern','placeholder',
	        'summary','title','value','style','xmlns'
	    ]);
	
	    /* Keep a reference to config to pass to hooks */
	    var CONFIG = null;
	
	    /* Ideally, do not touch anything below this line */
	    /* ______________________________________________ */
	
	    var formElement = document.createElement('form');
	
	    /**
	     * _parseConfig
	     *
	     * @param  optional config literal
	     */
	    var _parseConfig = function(cfg) {
	        /* Shield configuration object from tampering */
	        if (typeof cfg !== 'object') {
	            cfg = {};
	        }
	
	        /* Set configuration parameters */
	        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ?
	            _addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
	        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ?
	            _addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
	        FORBID_TAGS = 'FORBID_TAGS' in cfg ?
	            _addToSet({}, cfg.FORBID_TAGS) : {};
	        FORBID_ATTR = 'FORBID_ATTR' in cfg ?
	            _addToSet({}, cfg.FORBID_ATTR) : {};
	        ALLOW_ARIA_ATTR     = cfg.ALLOW_ARIA_ATTR     !== false; // Default true
	        ALLOW_DATA_ATTR     = cfg.ALLOW_DATA_ATTR     !== false; // Default true
	        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
	        SAFE_FOR_JQUERY     = cfg.SAFE_FOR_JQUERY     ||  false; // Default false
	        SAFE_FOR_TEMPLATES  = cfg.SAFE_FOR_TEMPLATES  ||  false; // Default false
	        WHOLE_DOCUMENT      = cfg.WHOLE_DOCUMENT      ||  false; // Default false
	        RETURN_DOM          = cfg.RETURN_DOM          ||  false; // Default false
	        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT ||  false; // Default false
	        RETURN_DOM_IMPORT   = cfg.RETURN_DOM_IMPORT   ||  false; // Default false
	        FORCE_BODY          = cfg.FORCE_BODY          ||  false; // Default false
	        SANITIZE_DOM        = cfg.SANITIZE_DOM        !== false; // Default true
	        KEEP_CONTENT        = cfg.KEEP_CONTENT        !== false; // Default true
	
	        if (SAFE_FOR_TEMPLATES) {
	            ALLOW_DATA_ATTR = false;
	        }
	
	        if (RETURN_DOM_FRAGMENT) {
	            RETURN_DOM = true;
	        }
	
	        /* Merge configuration parameters */
	        if (cfg.ADD_TAGS) {
	            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
	                ALLOWED_TAGS = _cloneObj(ALLOWED_TAGS);
	            }
	            _addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
	        }
	        if (cfg.ADD_ATTR) {
	            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
	                ALLOWED_ATTR = _cloneObj(ALLOWED_ATTR);
	            }
	            _addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
	        }
	        if (cfg.ADD_URI_SAFE_ATTR) {
	            _addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
	        }
	
	        /* Add #text in case KEEP_CONTENT is set to true */
	        if (KEEP_CONTENT) { ALLOWED_TAGS['#text'] = true; }
	
	        // Prevent further manipulation of configuration.
	        // Not available in IE8, Safari 5, etc.
	        if (Object && 'freeze' in Object) { Object.freeze(cfg); }
	
	        CONFIG = cfg;
	    };
	
	   /**
	     * _forceRemove
	     *
	     * @param  a DOM node
	     */
	    var _forceRemove = function(node) {
	        DOMPurify.removed.push({element: node});
	        try {
	            node.parentNode.removeChild(node);
	        } catch (e) {
	            node.outerHTML = '';
	        }
	    };
	
	   /**
	     * _removeAttribute
	     *
	     * @param  an Attribute name
	     * @param  a DOM node
	     */
	    var _removeAttribute = function(name, node) {
	        DOMPurify.removed.push({
	            attribute: node.getAttributeNode(name),
	            from: node
	        });
	        node.removeAttribute(name);
	    };
	
	   /**
	     * _initDocument
	     *
	     * @param  a string of dirty markup
	     * @return a DOM, filled with the dirty markup
	     */
	    var _initDocument = function(dirty) {
	        /* Create a HTML document */
	        var doc, body;
	
	        /* Fill body with bogus element */
	        if (FORCE_BODY) {
	            dirty = '<remove></remove>' + dirty;
	        }
	
	        /* Use DOMParser to workaround Firefox bug (see comment below) */
	        if (useDOMParser) {
	            try {
	                doc = new DOMParser().parseFromString(dirty, 'text/html');
	            } catch (e) {}
	        }
	
	        /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
	           Safari (see comment below) */
	        if (!doc || !doc.documentElement) {
	            doc = implementation.createHTMLDocument('');
	            body = doc.body;
	            body.parentNode.removeChild(body.parentNode.firstElementChild);
	            body.outerHTML = dirty;
	        }
	
	        /* Work on whole document or just its body */
	        return getElementsByTagName.call(doc,
	            WHOLE_DOCUMENT ? 'html' : 'body')[0];
	    };
	
	    // Safari 10.1+ (unfixed as of time of writing) has a catastrophic bug in
	    // its implementation of DOMParser such that the following executes the
	    // JavaScript:
	    //
	    // new DOMParser()
	    //   .parseFromString('<svg onload=alert(document.domain)>', 'text/html');
	    //
	    // However, Firefox uses a different parser for innerHTML rather than
	    // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
	    // which means that you *must* use DOMParser, otherwise the output may
	    // not be safe if used in a document.write context later.
	    //
	    // So we feature detect the Firefox bug and use the DOMParser if necessary.
	    if (DOMPurify.isSupported) {
	        (function () {
	            var doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
	            if (doc.querySelector('svg img')) {
	                useDOMParser = true;
	            }
	        }());
	    }
	
	    /**
	     * _createIterator
	     *
	     * @param  document/fragment to create iterator for
	     * @return iterator instance
	     */
	    var _createIterator = function(root) {
	        return createNodeIterator.call(root.ownerDocument || root,
	            root,
	            NodeFilter.SHOW_ELEMENT
	            | NodeFilter.SHOW_COMMENT
	            | NodeFilter.SHOW_TEXT,
	            function() { return NodeFilter.FILTER_ACCEPT; },
	            false
	        );
	    };
	
	    /**
	     * _isClobbered
	     *
	     * @param  element to check for clobbering attacks
	     * @return true if clobbered, false if safe
	     */
	    var _isClobbered = function(elm) {
	        if (elm instanceof Text || elm instanceof Comment) {
	            return false;
	        }
	        if (  typeof elm.nodeName !== 'string'
	           || typeof elm.textContent !== 'string'
	           || typeof elm.removeChild !== 'function'
	           || !(elm.attributes instanceof NamedNodeMap)
	           || typeof elm.removeAttribute !== 'function'
	           || typeof elm.setAttribute !== 'function'
	        ) {
	            return true;
	        }
	        return false;
	    };
	
	    /**
	     * _isNode
	     *
	     * @param object to check whether it's a DOM node
	     * @return true is object is a DOM node
	     */
	    var _isNode = function(obj) {
	        return (
	            typeof Node === "object" ? obj instanceof Node : obj
	                && typeof obj === "object" && typeof obj.nodeType === "number"
	                && typeof obj.nodeName==="string"
	        );
	    };
	
	    /**
	     * _sanitizeElements
	     *
	     * @protect nodeName
	     * @protect textContent
	     * @protect removeChild
	     *
	     * @param   node to check for permission to exist
	     * @return  true if node was killed, false if left alive
	     */
	    var _sanitizeElements = function(currentNode) {
	        var tagName, content;
	
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeElements', currentNode, null);
	
	        /* Check if element is clobbered or can clobber */
	        if (_isClobbered(currentNode)) {
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Now let's check the element's type and name */
	        tagName = currentNode.nodeName.toLowerCase();
	
	        /* Execute a hook if present */
	        _executeHook('uponSanitizeElement', currentNode, {
	            tagName: tagName,
	            allowedTags: ALLOWED_TAGS
	        });
	
	        /* Remove element if anything forbids its presence */
	        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
	            /* Keep content except for black-listed elements */
	            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]
	                    && typeof currentNode.insertAdjacentHTML === 'function') {
	                try {
	                    currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
	                } catch (e) {}
	            }
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Convert markup to cover jQuery behavior */
	        if (SAFE_FOR_JQUERY && !currentNode.firstElementChild &&
	                (!currentNode.content || !currentNode.content.firstElementChild) &&
	                /</g.test(currentNode.textContent)) {
	            DOMPurify.removed.push({element: currentNode.cloneNode()});
	            currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
	        }
	
	        /* Sanitize element content to be template-safe */
	        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
	            /* Get the element's text content */
	            content = currentNode.textContent;
	            content = content.replace(MUSTACHE_EXPR, ' ');
	            content = content.replace(ERB_EXPR, ' ');
	            if (currentNode.textContent !== content) {
	                DOMPurify.removed.push({element: currentNode.cloneNode()});
	                currentNode.textContent = content;
	            }
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeElements', currentNode, null);
	
	        return false;
	    };
	
	    var DATA_ATTR = /^data-[\-\w.\u00B7-\uFFFF]/;
	    var ARIA_ATTR = /^aria-[\-\w]+$/;
	    var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;
	    var IS_SCRIPT_OR_DATA = /^(?:\w+script|data):/i;
	    /* This needs to be extensive thanks to Webkit/Blink's behavior */
	    var ATTR_WHITESPACE = /[\x00-\x20\xA0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
	
	    /**
	     * _sanitizeAttributes
	     *
	     * @protect attributes
	     * @protect nodeName
	     * @protect removeAttribute
	     * @protect setAttribute
	     *
	     * @param   node to sanitize
	     * @return  void
	     */
	    var _sanitizeAttributes = function(currentNode) {
	        var attr, name, value, lcName, idAttr, attributes, hookEvent, l;
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeAttributes', currentNode, null);
	
	        attributes = currentNode.attributes;
	
	        /* Check if we have attributes; if not we might have a text node */
	        if (!attributes) { return; }
	
	        hookEvent = {
	            attrName: '',
	            attrValue: '',
	            keepAttr: true,
	            allowedAttributes: ALLOWED_ATTR
	        };
	        l = attributes.length;
	
	        /* Go backwards over all attributes; safely remove bad ones */
	        while (l--) {
	            attr = attributes[l];
	            name = attr.name;
	            value = attr.value.trim();
	            lcName = name.toLowerCase();
	
	            /* Execute a hook if present */
	            hookEvent.attrName = lcName;
	            hookEvent.attrValue = value;
	            hookEvent.keepAttr = true;
	            _executeHook('uponSanitizeAttribute', currentNode, hookEvent );
	            value = hookEvent.attrValue;
	
	            /* Remove attribute */
	            // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
	            // remove a "name" attribute from an <img> tag that has an "id"
	            // attribute at the time.
	            if (lcName === 'name'  &&
	                    currentNode.nodeName === 'IMG' && attributes.id) {
	                idAttr = attributes.id;
	                attributes = Array.prototype.slice.apply(attributes);
	                _removeAttribute('id', currentNode);
	                _removeAttribute(name, currentNode);
	                if (attributes.indexOf(idAttr) > l) {
	                    currentNode.setAttribute('id', idAttr.value);
	                }
	            } else if (
	                  // This works around a bug in Safari, where input[type=file]
	                  // cannot be dynamically set after type has been removed
	                  currentNode.nodeName === 'INPUT' && lcName === 'type' &&
	                  value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
	                  continue;
	            } else {
	                // This avoids a crash in Safari v9.0 with double-ids.
	                // The trick is to first set the id to be empty and then to
	                // remove the attribute
	                if (name === 'id') {
	                    currentNode.setAttribute(name, '');
	                }
	                _removeAttribute(name, currentNode);
	            }
	
	            /* Did the hooks approve of the attribute? */
	            if (!hookEvent.keepAttr) {
	                continue;
	            }
	
	            /* Make sure attribute cannot clobber */
	            if (SANITIZE_DOM &&
	                    (lcName === 'id' || lcName === 'name') &&
	                    (value in window || value in document || value in formElement)) {
	                continue;
	            }
	
	            /* Sanitize attribute content to be template-safe */
	            if (SAFE_FOR_TEMPLATES) {
	                value = value.replace(MUSTACHE_EXPR, ' ');
	                value = value.replace(ERB_EXPR, ' ');
	            }
	
	            /* Allow valid data-* attributes: At least one character after "-"
	               (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
	               XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
	               We don't need to check the value; it's always URI safe. */
	            if (ALLOW_DATA_ATTR && DATA_ATTR.test(lcName)) {
	                // This attribute is safe
	            }
	            else if (ALLOW_ARIA_ATTR && ARIA_ATTR.test(lcName)) {
	                // This attribute is safe
	            }
	            /* Otherwise, check the name is permitted */
	            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
	                continue;
	            }
	            /* Check value is safe. First, is attr inert? If so, is safe */
	            else if (URI_SAFE_ATTRIBUTES[lcName]) {
	                // This attribute is safe
	            }
	            /* Check no script, data or unknown possibly unsafe URI
	               unless we know URI values are safe for that attribute */
	            else if (IS_ALLOWED_URI.test(value.replace(ATTR_WHITESPACE,''))) {
	                // This attribute is safe
	            }
	            /* Keep image data URIs alive if src/xlink:href is allowed */
	            else if (
	                (lcName === 'src' || lcName === 'xlink:href') &&
	                value.indexOf('data:') === 0 &&
	                DATA_URI_TAGS[currentNode.nodeName.toLowerCase()]) {
	                // This attribute is safe
	            }
	            /* Allow unknown protocols: This provides support for links that
	               are handled by protocol handlers which may be unknown ahead of
	               time, e.g. fb:, spotify: */
	            else if (
	                ALLOW_UNKNOWN_PROTOCOLS &&
	                !IS_SCRIPT_OR_DATA.test(value.replace(ATTR_WHITESPACE,''))) {
	                // This attribute is safe
	            }
	            /* Check for binary attributes */
	            else if (!value) {
	                // binary attributes are safe at this point
	            }
	            /* Anything else, presume unsafe, do not add it back */
	            else {
	                continue;
	            }
	
	            /* Handle invalid data-* attribute set by try-catching it */
	            try {
	                currentNode.setAttribute(name, value);
	                DOMPurify.removed.pop();
	            } catch (e) {}
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeAttributes', currentNode, null);
	    };
	
	    /**
	     * _sanitizeShadowDOM
	     *
	     * @param  fragment to iterate over recursively
	     * @return void
	     */
	    var _sanitizeShadowDOM = function(fragment) {
	        var shadowNode;
	        var shadowIterator = _createIterator(fragment);
	
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeShadowDOM', fragment, null);
	
	        while ( (shadowNode = shadowIterator.nextNode()) ) {
	            /* Execute a hook if present */
	            _executeHook('uponSanitizeShadowNode', shadowNode, null);
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(shadowNode)) {
	                continue;
	            }
	
	            /* Deep shadow DOM detected */
	            if (shadowNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(shadowNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(shadowNode);
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeShadowDOM', fragment, null);
	    };
	
	    /**
	     * _executeHook
	     * Execute user configurable hooks
	     *
	     * @param  {String} entryPoint  Name of the hook's entry point
	     * @param  {Node} currentNode
	     */
	    var _executeHook = function(entryPoint, currentNode, data) {
	        if (!hooks[entryPoint]) { return; }
	
	        hooks[entryPoint].forEach(function(hook) {
	            hook.call(DOMPurify, currentNode, data, CONFIG);
	        });
	    };
	
	    /**
	     * sanitize
	     * Public method providing core sanitation functionality
	     *
	     * @param {String|Node} dirty string or DOM node
	     * @param {Object} configuration object
	     */
	    DOMPurify.sanitize = function(dirty, cfg) {
	        var body, importedNode, currentNode, oldNode, nodeIterator, returnNode;
	        /* Make sure we have a string to sanitize.
	           DO NOT return early, as this will return the wrong type if
	           the user has requested a DOM object rather than a string */
	        if (!dirty) {
	            dirty = '<!-->';
	        }
	
	        /* Stringify, in case dirty is an object */
	        if (typeof dirty !== 'string' && !_isNode(dirty)) {
	            if (typeof dirty.toString !== 'function') {
	                throw new TypeError('toString is not a function');
	            } else {
	                dirty = dirty.toString();
	            }
	        }
	
	        /* Check we can run. Otherwise fall back or ignore */
	        if (!DOMPurify.isSupported) {
	            if (typeof window.toStaticHTML === 'object'
	                || typeof window.toStaticHTML === 'function') {
	                if (typeof dirty === 'string') {
	                    return window.toStaticHTML(dirty);
	                } else if (_isNode(dirty)) {
	                    return window.toStaticHTML(dirty.outerHTML);
	                }
	            }
	            return dirty;
	        }
	
	        /* Assign config vars */
	        _parseConfig(cfg);
	
	        /* Clean up removed elements */
	        DOMPurify.removed = [];
	
	        if (dirty instanceof Node) {
	            /* If dirty is a DOM element, append to an empty document to avoid
	               elements being stripped by the parser */
	            body = _initDocument('<!-->');
	            importedNode = body.ownerDocument.importNode(dirty, true);
	            if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
	                /* Node is already a body, use as is */
	                body = importedNode;
	            } else {
	                body.appendChild(importedNode);
	            }
	        } else {
	            /* Exit directly if we have nothing to do */
	            if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
	                return dirty;
	            }
	
	            /* Initialize the document to work on */
	            body = _initDocument(dirty);
	
	            /* Check we have a DOM node from the data */
	            if (!body) {
	                return RETURN_DOM ? null : '';
	            }
	        }
	
	        /* Remove first element node (ours) if FORCE_BODY is set */
	        if (FORCE_BODY) {
	            _forceRemove(body.firstChild);
	        }
	
	        /* Get node iterator */
	        nodeIterator = _createIterator(body);
	
	        /* Now start iterating over the created document */
	        while ( (currentNode = nodeIterator.nextNode()) ) {
	
	            /* Fix IE's strange behavior with manipulated textNodes #89 */
	            if (currentNode.nodeType === 3 && currentNode === oldNode) {
	                continue;
	            }
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(currentNode)) {
	                continue;
	            }
	
	            /* Shadow DOM detected, sanitize it */
	            if (currentNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(currentNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(currentNode);
	
	            oldNode = currentNode;
	        }
	
	        /* Return sanitized string or DOM */
	        if (RETURN_DOM) {
	
	            if (RETURN_DOM_FRAGMENT) {
	                returnNode = createDocumentFragment.call(body.ownerDocument);
	
	                while (body.firstChild) {
	                    returnNode.appendChild(body.firstChild);
	                }
	            } else {
	                returnNode = body;
	            }
	
	            if (RETURN_DOM_IMPORT) {
	                /* adoptNode() is not used because internal state is not reset
	                   (e.g. the past names map of a HTMLFormElement), this is safe
	                   in theory but we would rather not risk another attack vector.
	                   The state that is cloned by importNode() is explicitly defined
	                   by the specs. */
	                returnNode = importNode.call(originalDocument, returnNode, true);
	            }
	
	            return returnNode;
	        }
	
	        return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
	    };
	
	    /**
	     * addHook
	     * Public method to add DOMPurify hooks
	     *
	     * @param {String} entryPoint
	     * @param {Function} hookFunction
	     */
	    DOMPurify.addHook = function(entryPoint, hookFunction) {
	        if (typeof hookFunction !== 'function') { return; }
	        hooks[entryPoint] = hooks[entryPoint] || [];
	        hooks[entryPoint].push(hookFunction);
	    };
	
	    /**
	     * removeHook
	     * Public method to remove a DOMPurify hook at a given entryPoint
	     * (pops it from the stack of hooks if more are present)
	     *
	     * @param {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHook = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint].pop();
	        }
	    };
	
	    /**
	     * removeHooks
	     * Public method to remove all DOMPurify hooks at a given entryPoint
	     *
	     * @param  {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHooks = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint] = [];
	        }
	    };
	
	    /**
	     * removeAllHooks
	     * Public method to remove all DOMPurify hooks
	     *
	     * @return void
	     */
	    DOMPurify.removeAllHooks = function() {
	        hooks = {};
	    };
	
	    return DOMPurify;
	}));


/***/ },
/* 429 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// =========
	// = humps =
	// =========
	// Underscore-to-camelCase converter (and vice versa)
	// for strings and object keys
	
	// humps is copyright © 2012+ Dom Christie
	// Released under the MIT license.
	
	
	;(function(global) {
	
	  var _processKeys = function(convert, obj, options) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
	      return obj;
	    }
	
	    var output,
	        i = 0,
	        l = 0;
	
	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], options));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(Object.prototype.hasOwnProperty.call(obj, key)) {
	          output[convert(key, options)] = _processKeys(convert, obj[key], options);
	        }
	      }
	    }
	    return output;
	  };
	
	  // String conversion methods
	
	  var separateWords = function(string, options) {
	    options = options || {};
	    var separator = options.separator || '_';
	    var split = options.split || /(?=[A-Z])/;
	
	    return string.split(split).join(separator);
	  };
	
	  var camelize = function(string) {
	    if (_isNumerical(string)) {
	      return string;
	    }
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  };
	
	  var pascalize = function(string) {
	    var camelized = camelize(string);
	    // Ensure 1st char is always uppercase
	    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
	  };
	
	  var decamelize = function(string, options) {
	    return separateWords(string, options).toLowerCase();
	  };
	
	  // Utilities
	  // Taken from Underscore.js
	
	  var toString = Object.prototype.toString;
	
	  var _isFunction = function(obj) {
	    return typeof(obj) === 'function';
	  };
	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };
	  var _isBoolean = function(obj) {
	    return toString.call(obj) == '[object Boolean]';
	  };
	
	  // Performant way to determine if obj coerces to a number
	  var _isNumerical = function(obj) {
	    obj = obj - 0;
	    return obj === obj;
	  };
	
	  // Sets up function which handles processing keys
	  // allowing the convert function to be modified by a callback
	  var _processor = function(convert, options) {
	    var callback = options && 'process' in options ? options.process : options;
	
	    if(typeof(callback) !== 'function') {
	      return convert;
	    }
	
	    return function(string, options) {
	      return callback(string, convert, options);
	    }
	  };
	
	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object, options) {
	      return _processKeys(_processor(camelize, options), object);
	    },
	    decamelizeKeys: function(object, options) {
	      return _processKeys(_processor(decamelize, options), object, options);
	    },
	    pascalizeKeys: function(object, options) {
	      return _processKeys(_processor(pascalize, options), object);
	    },
	    depascalizeKeys: function () {
	      return this.decamelizeKeys.apply(this, arguments);
	    }
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (humps), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }
	
	})(this);


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
	        // CommonJS
	        factory(exports);
	    } else {
	        // Browser globals
	        factory(root.IBAN = {});
	    }
	}(this, function(exports){
	
	    // Array.prototype.map polyfill
	    // code from https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/map
	    if (!Array.prototype.map){
	        Array.prototype.map = function(fun /*, thisArg */){
	            "use strict";
	
	            if (this === void 0 || this === null)
	                throw new TypeError();
	
	            var t = Object(this);
	            var len = t.length >>> 0;
	            if (typeof fun !== "function")
	                throw new TypeError();
	
	            var res = new Array(len);
	            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	            for (var i = 0; i < len; i++)
	            {
	                // NOTE: Absolute correctness would demand Object.defineProperty
	                //       be used.  But this method is fairly new, and failure is
	                //       possible only if Object.prototype or Array.prototype
	                //       has a property |i| (very unlikely), so use a less-correct
	                //       but more portable alternative.
	                if (i in t)
	                    res[i] = fun.call(thisArg, t[i], i, t);
	            }
	
	            return res;
	        };
	    }
	
	    var A = 'A'.charCodeAt(0),
	        Z = 'Z'.charCodeAt(0);
	
	    /**
	     * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
	     * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
	     *
	     * @param {string} iban the IBAN
	     * @returns {string} the prepared IBAN
	     */
	    function iso13616Prepare(iban) {
	        iban = iban.toUpperCase();
	        iban = iban.substr(4) + iban.substr(0,4);
	
	        return iban.split('').map(function(n){
	            var code = n.charCodeAt(0);
	            if (code >= A && code <= Z){
	                // A = 10, B = 11, ... Z = 35
	                return code - A + 10;
	            } else {
	                return n;
	            }
	        }).join('');
	    }
	
	    /**
	     * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
	     *
	     * @param iban
	     * @returns {number}
	     */
	    function iso7064Mod97_10(iban) {
	        var remainder = iban,
	            block;
	
	        while (remainder.length > 2){
	            block = remainder.slice(0, 9);
	            remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
	        }
	
	        return parseInt(remainder, 10) % 97;
	    }
	
	    /**
	     * Parse the BBAN structure used to configure each IBAN Specification and returns a matching regular expression.
	     * A structure is composed of blocks of 3 characters (one letter and 2 digits). Each block represents
	     * a logical group in the typical representation of the BBAN. For each group, the letter indicates which characters
	     * are allowed in this group and the following 2-digits number tells the length of the group.
	     *
	     * @param {string} structure the structure to parse
	     * @returns {RegExp}
	     */
	    function parseStructure(structure){
	        // split in blocks of 3 chars
	        var regex = structure.match(/(.{3})/g).map(function(block){
	
	            // parse each structure block (1-char + 2-digits)
	            var format,
	                pattern = block.slice(0, 1),
	                repeats = parseInt(block.slice(1), 10);
	
	            switch (pattern){
	                case "A": format = "0-9A-Za-z"; break;
	                case "B": format = "0-9A-Z"; break;
	                case "C": format = "A-Za-z"; break;
	                case "F": format = "0-9"; break;
	                case "L": format = "a-z"; break;
	                case "U": format = "A-Z"; break;
	                case "W": format = "0-9a-z"; break;
	            }
	
	            return '([' + format + ']{' + repeats + '})';
	        });
	
	        return new RegExp('^' + regex.join('') + '$');
	    }
	
	    /**
	     *
	     * @param iban
	     * @returns {string}
	     */
	    function electronicFormat(iban){
	        return iban.replace(NON_ALPHANUM, '').toUpperCase();
	    }
	
	
	    /**
	     * Create a new Specification for a valid IBAN number.
	     *
	     * @param countryCode the code of the country
	     * @param length the length of the IBAN
	     * @param structure the structure of the underlying BBAN (for validation and formatting)
	     * @param example an example valid IBAN
	     * @constructor
	     */
	    function Specification(countryCode, length, structure, example){
	
	        this.countryCode = countryCode;
	        this.length = length;
	        this.structure = structure;
	        this.example = example;
	    }
	
	    /**
	     * Lazy-loaded regex (parse the structure and construct the regular expression the first time we need it for validation)
	     */
	    Specification.prototype._regex = function(){
	        return this._cachedRegex || (this._cachedRegex = parseStructure(this.structure))
	    };
	
	    /**
	     * Check if the passed iban is valid according to this specification.
	     *
	     * @param {String} iban the iban to validate
	     * @returns {boolean} true if valid, false otherwise
	     */
	    Specification.prototype.isValid = function(iban){
	        return this.length == iban.length
	            && this.countryCode === iban.slice(0,2)
	            && this._regex().test(iban.slice(4))
	            && iso7064Mod97_10(iso13616Prepare(iban)) == 1;
	    };
	
	    /**
	     * Convert the passed IBAN to a country-specific BBAN.
	     *
	     * @param iban the IBAN to convert
	     * @param separator the separator to use between BBAN blocks
	     * @returns {string} the BBAN
	     */
	    Specification.prototype.toBBAN = function(iban, separator) {
	        return this._regex().exec(iban.slice(4)).slice(1).join(separator);
	    };
	
	    /**
	     * Convert the passed BBAN to an IBAN for this country specification.
	     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
	     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
	     *
	     * @param bban the BBAN to convert to IBAN
	     * @returns {string} the IBAN
	     */
	    Specification.prototype.fromBBAN = function(bban) {
	        if (!this.isValidBBAN(bban)){
	            throw new Error('Invalid BBAN');
	        }
	
	        var remainder = iso7064Mod97_10(iso13616Prepare(this.countryCode + '00' + bban)),
	            checkDigit = ('0' + (98 - remainder)).slice(-2);
	
	        return this.countryCode + checkDigit + bban;
	    };
	
	    /**
	     * Check of the passed BBAN is valid.
	     * This function only checks the format of the BBAN (length and matching the letetr/number specs) but does not
	     * verify the check digit.
	     *
	     * @param bban the BBAN to validate
	     * @returns {boolean} true if the passed bban is a valid BBAN according to this specification, false otherwise
	     */
	    Specification.prototype.isValidBBAN = function(bban) {
	        return this.length - 4 == bban.length
	            && this._regex().test(bban);
	    };
	
	    var countries = {};
	
	    function addSpecification(IBAN){
	        countries[IBAN.countryCode] = IBAN;
	    }
	
	    addSpecification(new Specification("AD", 24, "F04F04A12",          "AD1200012030200359100100"));
	    addSpecification(new Specification("AE", 23, "F03F16",             "AE070331234567890123456"));
	    addSpecification(new Specification("AL", 28, "F08A16",             "AL47212110090000000235698741"));
	    addSpecification(new Specification("AT", 20, "F05F11",             "AT611904300234573201"));
	    addSpecification(new Specification("AZ", 28, "U04A20",             "AZ21NABZ00000000137010001944"));
	    addSpecification(new Specification("BA", 20, "F03F03F08F02",       "BA391290079401028494"));
	    addSpecification(new Specification("BE", 16, "F03F07F02",          "BE68539007547034"));
	    addSpecification(new Specification("BG", 22, "U04F04F02A08",       "BG80BNBG96611020345678"));
	    addSpecification(new Specification("BH", 22, "U04A14",             "BH67BMAG00001299123456"));
	    addSpecification(new Specification("BR", 29, "F08F05F10U01A01",    "BR9700360305000010009795493P1"));
	    addSpecification(new Specification("BY", 28, "A04F04A16",          "BY13NBRB3600900000002Z00AB00"));
	    addSpecification(new Specification("CH", 21, "F05A12",             "CH9300762011623852957"));
	    addSpecification(new Specification("CR", 22, "F04F14",             "CR72012300000171549015"));
	    addSpecification(new Specification("CY", 28, "F03F05A16",          "CY17002001280000001200527600"));
	    addSpecification(new Specification("CZ", 24, "F04F06F10",          "CZ6508000000192000145399"));
	    addSpecification(new Specification("DE", 22, "F08F10",             "DE89370400440532013000"));
	    addSpecification(new Specification("DK", 18, "F04F09F01",          "DK5000400440116243"));
	    addSpecification(new Specification("DO", 28, "U04F20",             "DO28BAGR00000001212453611324"));
	    addSpecification(new Specification("EE", 20, "F02F02F11F01",       "EE382200221020145685"));
	    addSpecification(new Specification("EG", 29, "F04F04F17",          "EG800002000156789012345180002"));
	    addSpecification(new Specification("ES", 24, "F04F04F01F01F10",    "ES9121000418450200051332"));
	    addSpecification(new Specification("FI", 18, "F06F07F01",          "FI2112345600000785"));
	    addSpecification(new Specification("FO", 18, "F04F09F01",          "FO6264600001631634"));
	    addSpecification(new Specification("FR", 27, "F05F05A11F02",       "FR1420041010050500013M02606"));
	    addSpecification(new Specification("GB", 22, "U04F06F08",          "GB29NWBK60161331926819"));
	    addSpecification(new Specification("GE", 22, "U02F16",             "GE29NB0000000101904917"));
	    addSpecification(new Specification("GI", 23, "U04A15",             "GI75NWBK000000007099453"));
	    addSpecification(new Specification("GL", 18, "F04F09F01",          "GL8964710001000206"));
	    addSpecification(new Specification("GR", 27, "F03F04A16",          "GR1601101250000000012300695"));
	    addSpecification(new Specification("GT", 28, "A04A20",             "GT82TRAJ01020000001210029690"));
	    addSpecification(new Specification("HR", 21, "F07F10",             "HR1210010051863000160"));
	    addSpecification(new Specification("HU", 28, "F03F04F01F15F01",    "HU42117730161111101800000000"));
	    addSpecification(new Specification("IE", 22, "U04F06F08",          "IE29AIBK93115212345678"));
	    addSpecification(new Specification("IL", 23, "F03F03F13",          "IL620108000000099999999"));
	    addSpecification(new Specification("IS", 26, "F04F02F06F10",       "IS140159260076545510730339"));
	    addSpecification(new Specification("IT", 27, "U01F05F05A12",       "IT60X0542811101000000123456"));
	    addSpecification(new Specification("IQ", 23, "U04F03A12",          "IQ98NBIQ850123456789012"));
	    addSpecification(new Specification("JO", 30, "A04F22",             "JO15AAAA1234567890123456789012"));
	    addSpecification(new Specification("KW", 30, "U04A22",             "KW81CBKU0000000000001234560101"));
	    addSpecification(new Specification("KZ", 20, "F03A13",             "KZ86125KZT5004100100"));
	    addSpecification(new Specification("LB", 28, "F04A20",             "LB62099900000001001901229114"));
	    addSpecification(new Specification("LC", 32, "U04F24",             "LC07HEMM000100010012001200013015"));
	    addSpecification(new Specification("LI", 21, "F05A12",             "LI21088100002324013AA"));
	    addSpecification(new Specification("LT", 20, "F05F11",             "LT121000011101001000"));
	    addSpecification(new Specification("LU", 20, "F03A13",             "LU280019400644750000"));
	    addSpecification(new Specification("LV", 21, "U04A13",             "LV80BANK0000435195001"));
	    addSpecification(new Specification("MC", 27, "F05F05A11F02",       "MC5811222000010123456789030"));
	    addSpecification(new Specification("MD", 24, "U02A18",             "MD24AG000225100013104168"));
	    addSpecification(new Specification("ME", 22, "F03F13F02",          "ME25505000012345678951"));
	    addSpecification(new Specification("MK", 19, "F03A10F02",          "MK07250120000058984"));
	    addSpecification(new Specification("MR", 27, "F05F05F11F02",       "MR1300020001010000123456753"));
	    addSpecification(new Specification("MT", 31, "U04F05A18",          "MT84MALT011000012345MTLCAST001S"));
	    addSpecification(new Specification("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR"));
	    addSpecification(new Specification("NL", 18, "U04F10",             "NL91ABNA0417164300"));
	    addSpecification(new Specification("NO", 15, "F04F06F01",          "NO9386011117947"));
	    addSpecification(new Specification("PK", 24, "U04A16",             "PK36SCBL0000001123456702"));
	    addSpecification(new Specification("PL", 28, "F08F16",             "PL61109010140000071219812874"));
	    addSpecification(new Specification("PS", 29, "U04A21",             "PS92PALS000000000400123456702"));
	    addSpecification(new Specification("PT", 25, "F04F04F11F02",       "PT50000201231234567890154"));
	    addSpecification(new Specification("QA", 29, "U04A21",             "QA30AAAA123456789012345678901"));
	    addSpecification(new Specification("RO", 24, "U04A16",             "RO49AAAA1B31007593840000"));
	    addSpecification(new Specification("RS", 22, "F03F13F02",          "RS35260005601001611379"));
	    addSpecification(new Specification("SA", 24, "F02A18",             "SA0380000000608010167519"));
	    addSpecification(new Specification("SC", 31, "U04F04F16U03",       "SC18SSCB11010000000000001497USD"));
	    addSpecification(new Specification("SE", 24, "F03F16F01",          "SE4550000000058398257466"));
	    addSpecification(new Specification("SI", 19, "F05F08F02",          "SI56263300012039086"));
	    addSpecification(new Specification("SK", 24, "F04F06F10",          "SK3112000000198742637541"));
	    addSpecification(new Specification("SM", 27, "U01F05F05A12",       "SM86U0322509800000000270100"));
	    addSpecification(new Specification("ST", 25, "F08F11F02",          "ST68000100010051845310112"));
	    addSpecification(new Specification("SV", 28, "U04F20",             "SV62CENR00000000000000700025"));
	    addSpecification(new Specification("TL", 23, "F03F14F02",          "TL380080012345678910157"));
	    addSpecification(new Specification("TN", 24, "F02F03F13F02",       "TN5910006035183598478831"));
	    addSpecification(new Specification("TR", 26, "F05F01A16",          "TR330006100519786457841326"));
	    addSpecification(new Specification("UA", 29, "F25",                "UA511234567890123456789012345"));
	    addSpecification(new Specification("VA", 22, "F18",                "VA59001123000012345678"));
	    addSpecification(new Specification("VG", 24, "U04F16",             "VG96VPVG0000012345678901"));
	    addSpecification(new Specification("XK", 20, "F04F10F02",          "XK051212012345678906"));
	
	
	    // The following countries are not included in the official IBAN registry but use the IBAN specification
	
	    // Angola
	    addSpecification(new Specification("AO", 25, "F21",                "AO69123456789012345678901"));
	    // Burkina
	    addSpecification(new Specification("BF", 27, "F23",                "BF2312345678901234567890123"));
	    // Burundi
	    addSpecification(new Specification("BI", 16, "F12",                "BI41123456789012"));
	    // Benin
	    addSpecification(new Specification("BJ", 28, "F24",                "BJ39123456789012345678901234"));
	    // Ivory
	    addSpecification(new Specification("CI", 28, "U02F22",             "CI70CI1234567890123456789012"));
	    // Cameron
	    addSpecification(new Specification("CM", 27, "F23",                "CM9012345678901234567890123"));
	    // Cape Verde
	    addSpecification(new Specification("CV", 25, "F21",                "CV30123456789012345678901"));
	    // Algeria
	    addSpecification(new Specification("DZ", 24, "F20",                "DZ8612345678901234567890"));
	    // Iran
	    addSpecification(new Specification("IR", 26, "F22",                "IR861234568790123456789012"));
	    // Madagascar
	    addSpecification(new Specification("MG", 27, "F23",                "MG1812345678901234567890123"));
	    // Mali
	    addSpecification(new Specification("ML", 28, "U01F23",             "ML15A12345678901234567890123"));
	    // Mozambique
	    addSpecification(new Specification("MZ", 25, "F21",                "MZ25123456789012345678901"));
	    // Senegal
	    addSpecification(new Specification("SN", 28, "U01F23",             "SN52A12345678901234567890123"));
	
	    // The following are regional and administrative French Republic subdivision IBAN specification (same structure as FR, only country code vary)
	    addSpecification(new Specification("GF", 27, "F05F05A11F02",       "GF121234512345123456789AB13"));
	    addSpecification(new Specification("GP", 27, "F05F05A11F02",       "GP791234512345123456789AB13"));
	    addSpecification(new Specification("MQ", 27, "F05F05A11F02",       "MQ221234512345123456789AB13"));
	    addSpecification(new Specification("RE", 27, "F05F05A11F02",       "RE131234512345123456789AB13"));
	    addSpecification(new Specification("PF", 27, "F05F05A11F02",       "PF281234512345123456789AB13"));
	    addSpecification(new Specification("TF", 27, "F05F05A11F02",       "TF891234512345123456789AB13"));
	    addSpecification(new Specification("YT", 27, "F05F05A11F02",       "YT021234512345123456789AB13"));
	    addSpecification(new Specification("NC", 27, "F05F05A11F02",       "NC551234512345123456789AB13"));
	    addSpecification(new Specification("BL", 27, "F05F05A11F02",       "BL391234512345123456789AB13"));
	    addSpecification(new Specification("MF", 27, "F05F05A11F02",       "MF551234512345123456789AB13"));
	    addSpecification(new Specification("PM", 27, "F05F05A11F02",       "PM071234512345123456789AB13"));
	    addSpecification(new Specification("WF", 27, "F05F05A11F02",       "WF621234512345123456789AB13"));
	
	    var NON_ALPHANUM = /[^a-zA-Z0-9]/g,
	        EVERY_FOUR_CHARS =/(.{4})(?!$)/g;
	
	    /**
	     * Utility function to check if a variable is a String.
	     *
	     * @param v
	     * @returns {boolean} true if the passed variable is a String, false otherwise.
	     */
	    function isString(v){
	        return (typeof v == 'string' || v instanceof String);
	    }
	
	    /**
	     * Check if an IBAN is valid.
	     *
	     * @param {String} iban the IBAN to validate.
	     * @returns {boolean} true if the passed IBAN is valid, false otherwise
	     */
	    exports.isValid = function(iban){
	        if (!isString(iban)){
	            return false;
	        }
	        iban = electronicFormat(iban);
	        var countryStructure = countries[iban.slice(0,2)];
	        return !!countryStructure && countryStructure.isValid(iban);
	    };
	
	    /**
	     * Convert an IBAN to a BBAN.
	     *
	     * @param iban
	     * @param {String} [separator] the separator to use between the blocks of the BBAN, defaults to ' '
	     * @returns {string|*}
	     */
	    exports.toBBAN = function(iban, separator){
	        if (typeof separator == 'undefined'){
	            separator = ' ';
	        }
	        iban = electronicFormat(iban);
	        var countryStructure = countries[iban.slice(0,2)];
	        if (!countryStructure) {
	            throw new Error('No country with code ' + iban.slice(0,2));
	        }
	        return countryStructure.toBBAN(iban, separator);
	    };
	
	    /**
	     * Convert the passed BBAN to an IBAN for this country specification.
	     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
	     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
	     *
	     * @param countryCode the country of the BBAN
	     * @param bban the BBAN to convert to IBAN
	     * @returns {string} the IBAN
	     */
	    exports.fromBBAN = function(countryCode, bban){
	        var countryStructure = countries[countryCode];
	        if (!countryStructure) {
	            throw new Error('No country with code ' + countryCode);
	        }
	        return countryStructure.fromBBAN(electronicFormat(bban));
	    };
	
	    /**
	     * Check the validity of the passed BBAN.
	     *
	     * @param countryCode the country of the BBAN
	     * @param bban the BBAN to check the validity of
	     */
	    exports.isValidBBAN = function(countryCode, bban){
	        if (!isString(bban)){
	            return false;
	        }
	        var countryStructure = countries[countryCode];
	        return countryStructure && countryStructure.isValidBBAN(electronicFormat(bban));
	    };
	
	    /**
	     *
	     * @param iban
	     * @param separator
	     * @returns {string}
	     */
	    exports.printFormat = function(iban, separator){
	        if (typeof separator == 'undefined'){
	            separator = ' ';
	        }
	        return electronicFormat(iban).replace(EVERY_FOUR_CHARS, "$1" + separator);
	    };
	
	    exports.electronicFormat = electronicFormat;
	    /**
	     * An object containing all the known IBAN specifications.
	     */
	    exports.countries = countries;
	
	}));


/***/ },
/* 432 */
/***/ function(module, exports) {

	module.exports = [
		[
			"AF",
			"AFG",
			"004",
			"ISO 3166-2:AF"
		],
		[
			"AX",
			"ALA",
			"248",
			"ISO 3166-2:AX"
		],
		[
			"AL",
			"ALB",
			"008",
			"ISO 3166-2:AL"
		],
		[
			"DZ",
			"DZA",
			"012",
			"ISO 3166-2:DZ"
		],
		[
			"AS",
			"ASM",
			"016",
			"ISO 3166-2:AS"
		],
		[
			"AD",
			"AND",
			"020",
			"ISO 3166-2:AD"
		],
		[
			"AO",
			"AGO",
			"024",
			"ISO 3166-2:AO"
		],
		[
			"AI",
			"AIA",
			"660",
			"ISO 3166-2:AI"
		],
		[
			"AQ",
			"ATA",
			"010",
			"ISO 3166-2:AQ"
		],
		[
			"AG",
			"ATG",
			"028",
			"ISO 3166-2:AG"
		],
		[
			"AR",
			"ARG",
			"032",
			"ISO 3166-2:AR"
		],
		[
			"AM",
			"ARM",
			"051",
			"ISO 3166-2:AM"
		],
		[
			"AW",
			"ABW",
			"533",
			"ISO 3166-2:AW"
		],
		[
			"AU",
			"AUS",
			"036",
			"ISO 3166-2:AU"
		],
		[
			"AT",
			"AUT",
			"040",
			"ISO 3166-2:AT"
		],
		[
			"AZ",
			"AZE",
			"031",
			"ISO 3166-2:AZ"
		],
		[
			"BS",
			"BHS",
			"044",
			"ISO 3166-2:BS"
		],
		[
			"BH",
			"BHR",
			"048",
			"ISO 3166-2:BH"
		],
		[
			"BD",
			"BGD",
			"050",
			"ISO 3166-2:BD"
		],
		[
			"BB",
			"BRB",
			"052",
			"ISO 3166-2:BB"
		],
		[
			"BY",
			"BLR",
			"112",
			"ISO 3166-2:BY"
		],
		[
			"BE",
			"BEL",
			"056",
			"ISO 3166-2:BE"
		],
		[
			"BZ",
			"BLZ",
			"084",
			"ISO 3166-2:BZ"
		],
		[
			"BJ",
			"BEN",
			"204",
			"ISO 3166-2:BJ"
		],
		[
			"BM",
			"BMU",
			"060",
			"ISO 3166-2:BM"
		],
		[
			"BT",
			"BTN",
			"064",
			"ISO 3166-2:BT"
		],
		[
			"BO",
			"BOL",
			"068",
			"ISO 3166-2:BO"
		],
		[
			"BQ",
			"BES",
			"535",
			"ISO 3166-2:BQ"
		],
		[
			"BA",
			"BIH",
			"070",
			"ISO 3166-2:BA"
		],
		[
			"BW",
			"BWA",
			"072",
			"ISO 3166-2:BW"
		],
		[
			"BV",
			"BVT",
			"074",
			"ISO 3166-2:BV"
		],
		[
			"BR",
			"BRA",
			"076",
			"ISO 3166-2:BR"
		],
		[
			"IO",
			"IOT",
			"086",
			"ISO 3166-2:IO"
		],
		[
			"BN",
			"BRN",
			"096",
			"ISO 3166-2:BN"
		],
		[
			"BG",
			"BGR",
			"100",
			"ISO 3166-2:BG"
		],
		[
			"BF",
			"BFA",
			"854",
			"ISO 3166-2:BF"
		],
		[
			"BI",
			"BDI",
			"108",
			"ISO 3166-2:BI"
		],
		[
			"KH",
			"KHM",
			"116",
			"ISO 3166-2:KH"
		],
		[
			"CM",
			"CMR",
			"120",
			"ISO 3166-2:CM"
		],
		[
			"CA",
			"CAN",
			"124",
			"ISO 3166-2:CA"
		],
		[
			"CV",
			"CPV",
			"132",
			"ISO 3166-2:CV"
		],
		[
			"KY",
			"CYM",
			"136",
			"ISO 3166-2:KY"
		],
		[
			"CF",
			"CAF",
			"140",
			"ISO 3166-2:CF"
		],
		[
			"TD",
			"TCD",
			"148",
			"ISO 3166-2:TD"
		],
		[
			"CL",
			"CHL",
			"152",
			"ISO 3166-2:CL"
		],
		[
			"CN",
			"CHN",
			"156",
			"ISO 3166-2:CN"
		],
		[
			"CX",
			"CXR",
			"162",
			"ISO 3166-2:CX"
		],
		[
			"CC",
			"CCK",
			"166",
			"ISO 3166-2:CC"
		],
		[
			"CO",
			"COL",
			"170",
			"ISO 3166-2:CO"
		],
		[
			"KM",
			"COM",
			"174",
			"ISO 3166-2:KM"
		],
		[
			"CG",
			"COG",
			"178",
			"ISO 3166-2:CG"
		],
		[
			"CD",
			"COD",
			"180",
			"ISO 3166-2:CD"
		],
		[
			"CK",
			"COK",
			"184",
			"ISO 3166-2:CK"
		],
		[
			"CR",
			"CRI",
			"188",
			"ISO 3166-2:CR"
		],
		[
			"CI",
			"CIV",
			"384",
			"ISO 3166-2:CI"
		],
		[
			"HR",
			"HRV",
			"191",
			"ISO 3166-2:HR"
		],
		[
			"CU",
			"CUB",
			"192",
			"ISO 3166-2:CU"
		],
		[
			"CW",
			"CUW",
			"531",
			"ISO 3166-2:CW"
		],
		[
			"CY",
			"CYP",
			"196",
			"ISO 3166-2:CY"
		],
		[
			"CZ",
			"CZE",
			"203",
			"ISO 3166-2:CZ"
		],
		[
			"DK",
			"DNK",
			"208",
			"ISO 3166-2:DK"
		],
		[
			"DJ",
			"DJI",
			"262",
			"ISO 3166-2:DJ"
		],
		[
			"DM",
			"DMA",
			"212",
			"ISO 3166-2:DM"
		],
		[
			"DO",
			"DOM",
			"214",
			"ISO 3166-2:DO"
		],
		[
			"EC",
			"ECU",
			"218",
			"ISO 3166-2:EC"
		],
		[
			"EG",
			"EGY",
			"818",
			"ISO 3166-2:EG"
		],
		[
			"SV",
			"SLV",
			"222",
			"ISO 3166-2:SV"
		],
		[
			"GQ",
			"GNQ",
			"226",
			"ISO 3166-2:GQ"
		],
		[
			"ER",
			"ERI",
			"232",
			"ISO 3166-2:ER"
		],
		[
			"EE",
			"EST",
			"233",
			"ISO 3166-2:EE"
		],
		[
			"ET",
			"ETH",
			"231",
			"ISO 3166-2:ET"
		],
		[
			"FK",
			"FLK",
			"238",
			"ISO 3166-2:FK"
		],
		[
			"FO",
			"FRO",
			"234",
			"ISO 3166-2:FO"
		],
		[
			"FJ",
			"FJI",
			"242",
			"ISO 3166-2:FJ"
		],
		[
			"FI",
			"FIN",
			"246",
			"ISO 3166-2:FI"
		],
		[
			"FR",
			"FRA",
			"250",
			"ISO 3166-2:FR"
		],
		[
			"GF",
			"GUF",
			"254",
			"ISO 3166-2:GF"
		],
		[
			"PF",
			"PYF",
			"258",
			"ISO 3166-2:PF"
		],
		[
			"TF",
			"ATF",
			"260",
			"ISO 3166-2:TF"
		],
		[
			"GA",
			"GAB",
			"266",
			"ISO 3166-2:GA"
		],
		[
			"GM",
			"GMB",
			"270",
			"ISO 3166-2:GM"
		],
		[
			"GE",
			"GEO",
			"268",
			"ISO 3166-2:GE"
		],
		[
			"DE",
			"DEU",
			"276",
			"ISO 3166-2:DE"
		],
		[
			"GH",
			"GHA",
			"288",
			"ISO 3166-2:GH"
		],
		[
			"GI",
			"GIB",
			"292",
			"ISO 3166-2:GI"
		],
		[
			"GR",
			"GRC",
			"300",
			"ISO 3166-2:GR"
		],
		[
			"GL",
			"GRL",
			"304",
			"ISO 3166-2:GL"
		],
		[
			"GD",
			"GRD",
			"308",
			"ISO 3166-2:GD"
		],
		[
			"GP",
			"GLP",
			"312",
			"ISO 3166-2:GP"
		],
		[
			"GU",
			"GUM",
			"316",
			"ISO 3166-2:GU"
		],
		[
			"GT",
			"GTM",
			"320",
			"ISO 3166-2:GT"
		],
		[
			"GG",
			"GGY",
			"831",
			"ISO 3166-2:GG"
		],
		[
			"GN",
			"GIN",
			"324",
			"ISO 3166-2:GN"
		],
		[
			"GW",
			"GNB",
			"624",
			"ISO 3166-2:GW"
		],
		[
			"GY",
			"GUY",
			"328",
			"ISO 3166-2:GY"
		],
		[
			"HT",
			"HTI",
			"332",
			"ISO 3166-2:HT"
		],
		[
			"HM",
			"HMD",
			"334",
			"ISO 3166-2:HM"
		],
		[
			"VA",
			"VAT",
			"336",
			"ISO 3166-2:VA"
		],
		[
			"HN",
			"HND",
			"340",
			"ISO 3166-2:HN"
		],
		[
			"HK",
			"HKG",
			"344",
			"ISO 3166-2:HK"
		],
		[
			"HU",
			"HUN",
			"348",
			"ISO 3166-2:HU"
		],
		[
			"IS",
			"ISL",
			"352",
			"ISO 3166-2:IS"
		],
		[
			"IN",
			"IND",
			"356",
			"ISO 3166-2:IN"
		],
		[
			"ID",
			"IDN",
			"360",
			"ISO 3166-2:ID"
		],
		[
			"IR",
			"IRN",
			"364",
			"ISO 3166-2:IR"
		],
		[
			"IQ",
			"IRQ",
			"368",
			"ISO 3166-2:IQ"
		],
		[
			"IE",
			"IRL",
			"372",
			"ISO 3166-2:IE"
		],
		[
			"IM",
			"IMN",
			"833",
			"ISO 3166-2:IM"
		],
		[
			"IL",
			"ISR",
			"376",
			"ISO 3166-2:IL"
		],
		[
			"IT",
			"ITA",
			"380",
			"ISO 3166-2:IT"
		],
		[
			"JM",
			"JAM",
			"388",
			"ISO 3166-2:JM"
		],
		[
			"JP",
			"JPN",
			"392",
			"ISO 3166-2:JP"
		],
		[
			"JE",
			"JEY",
			"832",
			"ISO 3166-2:JE"
		],
		[
			"JO",
			"JOR",
			"400",
			"ISO 3166-2:JO"
		],
		[
			"KZ",
			"KAZ",
			"398",
			"ISO 3166-2:KZ"
		],
		[
			"KE",
			"KEN",
			"404",
			"ISO 3166-2:KE"
		],
		[
			"KI",
			"KIR",
			"296",
			"ISO 3166-2:KI"
		],
		[
			"KP",
			"PRK",
			"408",
			"ISO 3166-2:KP"
		],
		[
			"KR",
			"KOR",
			"410",
			"ISO 3166-2:KR"
		],
		[
			"KW",
			"KWT",
			"414",
			"ISO 3166-2:KW"
		],
		[
			"KG",
			"KGZ",
			"417",
			"ISO 3166-2:KG"
		],
		[
			"LA",
			"LAO",
			"418",
			"ISO 3166-2:LA"
		],
		[
			"LV",
			"LVA",
			"428",
			"ISO 3166-2:LV"
		],
		[
			"LB",
			"LBN",
			"422",
			"ISO 3166-2:LB"
		],
		[
			"LS",
			"LSO",
			"426",
			"ISO 3166-2:LS"
		],
		[
			"LR",
			"LBR",
			"430",
			"ISO 3166-2:LR"
		],
		[
			"LY",
			"LBY",
			"434",
			"ISO 3166-2:LY"
		],
		[
			"LI",
			"LIE",
			"438",
			"ISO 3166-2:LI"
		],
		[
			"LT",
			"LTU",
			"440",
			"ISO 3166-2:LT"
		],
		[
			"LU",
			"LUX",
			"442",
			"ISO 3166-2:LU"
		],
		[
			"MO",
			"MAC",
			"446",
			"ISO 3166-2:MO"
		],
		[
			"MK",
			"MKD",
			"807",
			"ISO 3166-2:MK"
		],
		[
			"MG",
			"MDG",
			"450",
			"ISO 3166-2:MG"
		],
		[
			"MW",
			"MWI",
			"454",
			"ISO 3166-2:MW"
		],
		[
			"MY",
			"MYS",
			"458",
			"ISO 3166-2:MY"
		],
		[
			"MV",
			"MDV",
			"462",
			"ISO 3166-2:MV"
		],
		[
			"ML",
			"MLI",
			"466",
			"ISO 3166-2:ML"
		],
		[
			"MT",
			"MLT",
			"470",
			"ISO 3166-2:MT"
		],
		[
			"MH",
			"MHL",
			"584",
			"ISO 3166-2:MH"
		],
		[
			"MQ",
			"MTQ",
			"474",
			"ISO 3166-2:MQ"
		],
		[
			"MR",
			"MRT",
			"478",
			"ISO 3166-2:MR"
		],
		[
			"MU",
			"MUS",
			"480",
			"ISO 3166-2:MU"
		],
		[
			"YT",
			"MYT",
			"175",
			"ISO 3166-2:YT"
		],
		[
			"MX",
			"MEX",
			"484",
			"ISO 3166-2:MX"
		],
		[
			"FM",
			"FSM",
			"583",
			"ISO 3166-2:FM"
		],
		[
			"MD",
			"MDA",
			"498",
			"ISO 3166-2:MD"
		],
		[
			"MC",
			"MCO",
			"492",
			"ISO 3166-2:MC"
		],
		[
			"MN",
			"MNG",
			"496",
			"ISO 3166-2:MN"
		],
		[
			"ME",
			"MNE",
			"499",
			"ISO 3166-2:ME"
		],
		[
			"MS",
			"MSR",
			"500",
			"ISO 3166-2:MS"
		],
		[
			"MA",
			"MAR",
			"504",
			"ISO 3166-2:MA"
		],
		[
			"MZ",
			"MOZ",
			"508",
			"ISO 3166-2:MZ"
		],
		[
			"MM",
			"MMR",
			"104",
			"ISO 3166-2:MM"
		],
		[
			"NA",
			"NAM",
			"516",
			"ISO 3166-2:NA"
		],
		[
			"NR",
			"NRU",
			"520",
			"ISO 3166-2:NR"
		],
		[
			"NP",
			"NPL",
			"524",
			"ISO 3166-2:NP"
		],
		[
			"NL",
			"NLD",
			"528",
			"ISO 3166-2:NL"
		],
		[
			"NC",
			"NCL",
			"540",
			"ISO 3166-2:NC"
		],
		[
			"NZ",
			"NZL",
			"554",
			"ISO 3166-2:NZ"
		],
		[
			"NI",
			"NIC",
			"558",
			"ISO 3166-2:NI"
		],
		[
			"NE",
			"NER",
			"562",
			"ISO 3166-2:NE"
		],
		[
			"NG",
			"NGA",
			"566",
			"ISO 3166-2:NG"
		],
		[
			"NU",
			"NIU",
			"570",
			"ISO 3166-2:NU"
		],
		[
			"NF",
			"NFK",
			"574",
			"ISO 3166-2:NF"
		],
		[
			"MP",
			"MNP",
			"580",
			"ISO 3166-2:MP"
		],
		[
			"NO",
			"NOR",
			"578",
			"ISO 3166-2:NO"
		],
		[
			"OM",
			"OMN",
			"512",
			"ISO 3166-2:OM"
		],
		[
			"PK",
			"PAK",
			"586",
			"ISO 3166-2:PK"
		],
		[
			"PW",
			"PLW",
			"585",
			"ISO 3166-2:PW"
		],
		[
			"PS",
			"PSE",
			"275",
			"ISO 3166-2:PS"
		],
		[
			"PA",
			"PAN",
			"591",
			"ISO 3166-2:PA"
		],
		[
			"PG",
			"PNG",
			"598",
			"ISO 3166-2:PG"
		],
		[
			"PY",
			"PRY",
			"600",
			"ISO 3166-2:PY"
		],
		[
			"PE",
			"PER",
			"604",
			"ISO 3166-2:PE"
		],
		[
			"PH",
			"PHL",
			"608",
			"ISO 3166-2:PH"
		],
		[
			"PN",
			"PCN",
			"612",
			"ISO 3166-2:PN"
		],
		[
			"PL",
			"POL",
			"616",
			"ISO 3166-2:PL"
		],
		[
			"PT",
			"PRT",
			"620",
			"ISO 3166-2:PT"
		],
		[
			"PR",
			"PRI",
			"630",
			"ISO 3166-2:PR"
		],
		[
			"QA",
			"QAT",
			"634",
			"ISO 3166-2:QA"
		],
		[
			"RE",
			"REU",
			"638",
			"ISO 3166-2:RE"
		],
		[
			"RO",
			"ROU",
			"642",
			"ISO 3166-2:RO"
		],
		[
			"RU",
			"RUS",
			"643",
			"ISO 3166-2:RU"
		],
		[
			"RW",
			"RWA",
			"646",
			"ISO 3166-2:RW"
		],
		[
			"BL",
			"BLM",
			"652",
			"ISO 3166-2:BL"
		],
		[
			"SH",
			"SHN",
			"654",
			"ISO 3166-2:SH"
		],
		[
			"KN",
			"KNA",
			"659",
			"ISO 3166-2:KN"
		],
		[
			"LC",
			"LCA",
			"662",
			"ISO 3166-2:LC"
		],
		[
			"MF",
			"MAF",
			"663",
			"ISO 3166-2:MF"
		],
		[
			"PM",
			"SPM",
			"666",
			"ISO 3166-2:PM"
		],
		[
			"VC",
			"VCT",
			"670",
			"ISO 3166-2:VC"
		],
		[
			"WS",
			"WSM",
			"882",
			"ISO 3166-2:WS"
		],
		[
			"SM",
			"SMR",
			"674",
			"ISO 3166-2:SM"
		],
		[
			"ST",
			"STP",
			"678",
			"ISO 3166-2:ST"
		],
		[
			"SA",
			"SAU",
			"682",
			"ISO 3166-2:SA"
		],
		[
			"SN",
			"SEN",
			"686",
			"ISO 3166-2:SN"
		],
		[
			"RS",
			"SRB",
			"688",
			"ISO 3166-2:RS"
		],
		[
			"SC",
			"SYC",
			"690",
			"ISO 3166-2:SC"
		],
		[
			"SL",
			"SLE",
			"694",
			"ISO 3166-2:SL"
		],
		[
			"SG",
			"SGP",
			"702",
			"ISO 3166-2:SG"
		],
		[
			"SX",
			"SXM",
			"534",
			"ISO 3166-2:SX"
		],
		[
			"SK",
			"SVK",
			"703",
			"ISO 3166-2:SK"
		],
		[
			"SI",
			"SVN",
			"705",
			"ISO 3166-2:SI"
		],
		[
			"SB",
			"SLB",
			"090",
			"ISO 3166-2:SB"
		],
		[
			"SO",
			"SOM",
			"706",
			"ISO 3166-2:SO"
		],
		[
			"ZA",
			"ZAF",
			"710",
			"ISO 3166-2:ZA"
		],
		[
			"GS",
			"SGS",
			"239",
			"ISO 3166-2:GS"
		],
		[
			"SS",
			"SSD",
			"728",
			"ISO 3166-2:SS"
		],
		[
			"ES",
			"ESP",
			"724",
			"ISO 3166-2:ES"
		],
		[
			"LK",
			"LKA",
			"144",
			"ISO 3166-2:LK"
		],
		[
			"SD",
			"SDN",
			"729",
			"ISO 3166-2:SD"
		],
		[
			"SR",
			"SUR",
			"740",
			"ISO 3166-2:SR"
		],
		[
			"SJ",
			"SJM",
			"744",
			"ISO 3166-2:SJ"
		],
		[
			"SZ",
			"SWZ",
			"748",
			"ISO 3166-2:SZ"
		],
		[
			"SE",
			"SWE",
			"752",
			"ISO 3166-2:SE"
		],
		[
			"CH",
			"CHE",
			"756",
			"ISO 3166-2:CH"
		],
		[
			"SY",
			"SYR",
			"760",
			"ISO 3166-2:SY"
		],
		[
			"TW",
			"TWN",
			"158",
			"ISO 3166-2:TW"
		],
		[
			"TJ",
			"TJK",
			"762",
			"ISO 3166-2:TJ"
		],
		[
			"TZ",
			"TZA",
			"834",
			"ISO 3166-2:TZ"
		],
		[
			"TH",
			"THA",
			"764",
			"ISO 3166-2:TH"
		],
		[
			"TL",
			"TLS",
			"626",
			"ISO 3166-2:TL"
		],
		[
			"TG",
			"TGO",
			"768",
			"ISO 3166-2:TG"
		],
		[
			"TK",
			"TKL",
			"772",
			"ISO 3166-2:TK"
		],
		[
			"TO",
			"TON",
			"776",
			"ISO 3166-2:TO"
		],
		[
			"TT",
			"TTO",
			"780",
			"ISO 3166-2:TT"
		],
		[
			"TN",
			"TUN",
			"788",
			"ISO 3166-2:TN"
		],
		[
			"TR",
			"TUR",
			"792",
			"ISO 3166-2:TR"
		],
		[
			"TM",
			"TKM",
			"795",
			"ISO 3166-2:TM"
		],
		[
			"TC",
			"TCA",
			"796",
			"ISO 3166-2:TC"
		],
		[
			"TV",
			"TUV",
			"798",
			"ISO 3166-2:TV"
		],
		[
			"UG",
			"UGA",
			"800",
			"ISO 3166-2:UG"
		],
		[
			"UA",
			"UKR",
			"804",
			"ISO 3166-2:UA"
		],
		[
			"AE",
			"ARE",
			"784",
			"ISO 3166-2:AE"
		],
		[
			"GB",
			"GBR",
			"826",
			"ISO 3166-2:GB"
		],
		[
			"US",
			"USA",
			"840",
			"ISO 3166-2:US"
		],
		[
			"UM",
			"UMI",
			"581",
			"ISO 3166-2:UM"
		],
		[
			"UY",
			"URY",
			"858",
			"ISO 3166-2:UY"
		],
		[
			"UZ",
			"UZB",
			"860",
			"ISO 3166-2:UZ"
		],
		[
			"VU",
			"VUT",
			"548",
			"ISO 3166-2:VU"
		],
		[
			"VE",
			"VEN",
			"862",
			"ISO 3166-2:VE"
		],
		[
			"VN",
			"VNM",
			"704",
			"ISO 3166-2:VN"
		],
		[
			"VG",
			"VGB",
			"092",
			"ISO 3166-2:VG"
		],
		[
			"VI",
			"VIR",
			"850",
			"ISO 3166-2:VI"
		],
		[
			"WF",
			"WLF",
			"876",
			"ISO 3166-2:WF"
		],
		[
			"EH",
			"ESH",
			"732",
			"ISO 3166-2:EH"
		],
		[
			"YE",
			"YEM",
			"887",
			"ISO 3166-2:YE"
		],
		[
			"ZM",
			"ZMB",
			"894",
			"ISO 3166-2:ZM"
		],
		[
			"ZW",
			"ZWE",
			"716",
			"ISO 3166-2:ZW"
		],
		[
			"XK",
			"XKX",
			"",
			"ISO 3166-2:XK"
		]
	];

/***/ },
/* 433 */
/***/ function(module, exports) {

	module.exports = {
		"AF": " أفغانستان",
		"AL": " ألبانيا",
		"DZ": " الجزائر",
		"AS": " ساموا الأمريكية",
		"AD": " أندورا",
		"AO": " أنغولا",
		"AI": " أنغويلا",
		"AQ": " القارة القطبية الجنوبية",
		"AG": " أنتيغوا وباربودا",
		"AR": " الأرجنتين",
		"AM": " أرمينيا",
		"AW": " أروبا",
		"AU": " أستراليا",
		"AT": " النمسا",
		"AZ": " أذربيجان",
		"BS": " باهاماس",
		"BH": " البحرين",
		"BD": " بنغلاديش",
		"BB": " باربادوس",
		"BY": " روسيا البيضاء",
		"BE": " بلجيكا",
		"BZ": " بليز",
		"BJ": " بنين",
		"BM": " برمودا",
		"BT": " بوتان",
		"BO": " بوليفيا",
		"BA": " البوسنة والهرسك",
		"BW": " بوتسوانا",
		"BV": " جزيرة بوفيه",
		"BR": " البرازيل",
		"IO": " إقليم المحيط الهندي البريطاني",
		"BN": " بروناي",
		"BG": " بلغاريا",
		"BF": " بوركينا فاسو",
		"BI": " بوروندي",
		"KH": " كمبوديا",
		"CM": " الكاميرون",
		"CA": " كندا",
		"CV": " الرأس الأخضر",
		"KY": " جزر كايمان",
		"CF": " جمهورية أفريقيا الوسطى",
		"TD": " تشاد",
		"CL": " تشيلي",
		"CN": " الصين",
		"CX": " جزيرة عيد الميلاد",
		"CC": " جزر كوكوس",
		"CO": " كولومبيا",
		"KM": " جزر القمر",
		"CG": " جمهورية الكونغو",
		"CD": " جمهورية الكونغو الديمقراطية",
		"CK": " جزر كوك",
		"CR": " كوستاريكا",
		"CI": " ساحل العاج",
		"HR": " كرواتيا",
		"CU": " كوبا",
		"CY": " قبرص",
		"CZ": " جمهورية التشيك",
		"DK": " الدنمارك",
		"DJ": " جيبوتي",
		"DM": " دومينيكا",
		"DO": " جمهورية الدومينيكان",
		"EC": " الإكوادور",
		"EG": " مصر",
		"SV": " السلفادور",
		"GQ": " غينيا الاستوائية",
		"ER": " إريتريا",
		"EE": " إستونيا",
		"ET": " إثيوبيا",
		"FK": " جزر فوكلاند",
		"FO": " جزر فارو",
		"FJ": " فيجي",
		"FI": " فنلندا",
		"FR": " فرنسا",
		"GF": " غويانا الفرنسية",
		"PF": " بولينزيا الفرنسية",
		"TF": " أراض فرنسية جنوبية وأنتارتيكية",
		"GA": " الغابون",
		"GM": " غامبيا",
		"GE": " جورجيا",
		"DE": " ألمانيا",
		"GH": " غانا",
		"GI": " جبل طارق",
		"GR": " اليونان",
		"GL": " جرينلاند",
		"GD": " غرينادا",
		"GP": " غوادلوب",
		"GU": " غوام",
		"GT": " غواتيمالا",
		"GN": " غينيا",
		"GW": " غينيا بيساو",
		"GY": " غيانا",
		"HT": " هايتي",
		"HM": " جزيرة هيرد وجزر ماكدونالد",
		"VA": "  الفاتيكان",
		"HN": " هندوراس",
		"HK": " هونغ كونغ",
		"HU": " المجر",
		"IS": " آيسلندا",
		"IN": " الهند",
		"ID": " إندونيسيا",
		"IR": " إيران",
		"IQ": " العراق",
		"IE": " أيرلندا",
		"IL": " إسرائيل",
		"IT": " إيطاليا",
		"JM": " جامايكا",
		"JP": " اليابان",
		"JO": " الأردن",
		"KZ": " كازاخستان",
		"KE": " كينيا",
		"KI": " كيريباتي",
		"KP": " كوريا الشمالية",
		"KR": " كوريا الجنوبية",
		"KW": " الكويت",
		"KG": " قيرغيزستان",
		"LA": " لاوس",
		"LV": " لاتفيا",
		"LB": " لبنان",
		"LS": " ليسوتو",
		"LR": " ليبيريا",
		"LY": " ليبيا",
		"LI": " ليختنشتاين",
		"LT": " ليتوانيا",
		"LU": " لوكسمبورغ",
		"MO": " ماكاو",
		"MK": " مقدونيا",
		"MG": " مدغشقر",
		"MW": " مالاوي",
		"MY": " ماليزيا",
		"MV": " جزر المالديف",
		"ML": " مالي",
		"MT": " مالطا",
		"MH": " جزر مارشال",
		"MQ": " مارتينيك",
		"MR": " موريتانيا",
		"MU": " موريشيوس",
		"YT": " مايوت",
		"MX": " المكسيك",
		"FM": " ولايات ميكرونيسيا المتحدة",
		"MD": " مولدوفا",
		"MC": " موناكو",
		"MN": " منغوليا",
		"MS": " مونتسرات",
		"MA": " المغرب",
		"MZ": " موزمبيق",
		"MM": " بورما",
		"NA": " ناميبيا",
		"NR": " ناورو",
		"NP": " نيبال",
		"NL": " هولندا",
		"NC": " كاليدونيا الجديدة",
		"NZ": " نيوزيلندا",
		"NI": " نيكاراغوا",
		"NE": " النيجر",
		"NG": " نيجيريا",
		"NU": " نييوي",
		"NF": " جزيرة نورفولك",
		"MP": " جزر ماريانا الشمالية",
		"NO": " النرويج",
		"OM": " عمان",
		"PK": " باكستان",
		"PW": " بالاو",
		"PS": " فلسطين",
		"PA": " بنما",
		"PG": " بابوا غينيا الجديدة",
		"PY": " باراغواي",
		"PE": " بيرو",
		"PH": " الفلبين",
		"PN": " جزر بيتكيرن",
		"PL": " بولندا",
		"PT": " البرتغال",
		"PR": " بورتوريكو",
		"QA": " قطر",
		"RE": " لا ريونيون",
		"RO": " رومانيا",
		"RU": " روسيا",
		"RW": " رواندا",
		"SH": " سانت هيلينا وأسينشين وتريستان دا كونا",
		"KN": " سانت كيتس ونيفيس",
		"LC": " سانت لوسيا",
		"PM": " سان بيير وميكلون",
		"VC": " سانت فينسنت والغرينادين",
		"WS": " ساموا",
		"SM": " سان مارينو",
		"ST": " ساو تومي وبرينسيب",
		"SA": " السعودية",
		"SN": " السنغال",
		"SC": " سيشل",
		"SL": " سيراليون",
		"SG": " سنغافورة",
		"SK": " سلوفاكيا",
		"SI": " سلوفينيا",
		"SB": " جزر سليمان",
		"SO": " الصومال",
		"ZA": " جنوب أفريقيا",
		"GS": " جورجيا الجنوبية وجزر ساندويتش الجنوبية",
		"ES": " إسبانيا",
		"LK": " سريلانكا",
		"SD": " السودان",
		"SR": " سورينام",
		"SJ": " سفالبارد ويان ماين",
		"SZ": " سوازيلاند",
		"SE": " السويد",
		"CH": " سويسرا",
		"SY": " سوريا",
		"TW": " تايوان",
		"TJ": " طاجيكستان",
		"TZ": " تانزانيا",
		"TH": " تايلاند",
		"TL": " تيمور الشرقية",
		"TG": " توغو",
		"TK": " توكيلاو",
		"TO": " تونغا",
		"TT": "ترينيداد وتوباغو",
		"TN": " تونس",
		"TR": " تركيا",
		"TM": " تركمانستان",
		"TC": " جزر توركس وكايكوس",
		"TV": " توفالو",
		"UG": " أوغندا",
		"UA": " أوكرانيا",
		"AE": " الإمارات العربية المتحدة",
		"GB": " المملكة المتحدة",
		"US": " الولايات المتحدة",
		"UM": " جزر الولايات المتحدة",
		"UY": " الأوروغواي",
		"UZ": " أوزبكستان",
		"VU": " فانواتو",
		"VE": " فنزويلا",
		"VN": " فيتنام",
		"VG": " جزر العذراء البريطانية",
		"VI": " جزر العذراء الأمريكية",
		"WF": " والس وفوتونا",
		"EH": " الصحراء الغربية",
		"YE": " اليمن",
		"ZM": " زامبيا",
		"ZW": " زيمبابوي",
		"AX": " جزر أولاند",
		"BQ": " الجزر الكاريبية الهولندية",
		"CW": " كوراساو",
		"GG": " غيرنزي",
		"IM": " جزيرة مان",
		"JE": " جيرزي",
		"ME": " الجبل الأسود",
		"BL": " سان بارتيلمي",
		"MF": " سانت مارتن (الجزء الفرنسي)",
		"RS": " صربيا",
		"SX": " سانت مارتن (الجزء الهولندي)",
		"SS": " جنوب السودان",
		"XK": " كوسوفو"
	};

/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afghánistán",
		"AX": "Ålandy",
		"AL": "Albánie",
		"DZ": "Alžírsko",
		"AS": "Americká Samoa",
		"VI": "Americké Panenské ostrovy",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarktida",
		"AG": "Antigua a Barbuda",
		"AR": "Argentina",
		"AM": "Arménie",
		"AW": "Aruba",
		"AU": "Austrálie",
		"AZ": "Ázerbájdžán",
		"BS": "Bahamy",
		"BH": "Bahrajn",
		"BD": "Bangladéš",
		"BB": "Barbados",
		"BE": "Belgie",
		"BZ": "Belize",
		"BY": "Bělorusko",
		"BJ": "Benin",
		"BM": "Bermudy",
		"BT": "Bhútán",
		"BO": "Bolívie",
		"BQ": "Bonaire, Svatý Eustach a Saba",
		"BA": "Bosna a Hercegovina",
		"BW": "Botswana",
		"BV": "Bouvetův ostrov",
		"BR": "Brazílie",
		"IO": "Britské indickooceánské území",
		"VG": "Britské Panenské ostrovy",
		"BN": "Brunej",
		"BG": "Bulharsko",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"CK": "Cookovy ostrovy",
		"CW": "Curaçao",
		"TD": "Čad",
		"ME": "Černá Hora",
		"CZ": "Česko",
		"CN": "Čína",
		"DK": "Dánsko",
		"CD": "Demokratická republika Kongo",
		"DM": "Dominika",
		"DO": "Dominikánská republika",
		"DJ": "Džibutsko",
		"EG": "Egypt",
		"EC": "Ekvádor",
		"ER": "Eritrea",
		"EE": "Estonsko",
		"ET": "Etiopie",
		"FO": "Faerské ostrovy",
		"FK": "Falklandy (Malvíny)",
		"FJ": "Fidži",
		"PH": "Filipíny",
		"FI": "Finsko",
		"FR": "Francie",
		"GF": "Francouzská Guyana",
		"TF": "Francouzská jižní a antarktická území",
		"PF": "Francouzská Polynésie",
		"GA": "Gabon",
		"GM": "Gambie",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GD": "Grenada",
		"GL": "Grónsko",
		"GE": "Gruzie",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GN": "Guinea",
		"GW": "Guinea-Bissau",
		"GG": "Guernsey",
		"GY": "Guyana",
		"HT": "Haiti",
		"HM": "Heardův ostrov a McDonaldovy ostrovy",
		"HN": "Honduras",
		"HK": "Hongkong",
		"CL": "Chile",
		"HR": "Chorvatsko",
		"IN": "Indie",
		"ID": "Indonésie",
		"IQ": "Irák",
		"IR": "Írán",
		"IE": "Irsko",
		"IS": "Island",
		"IT": "Itálie",
		"IL": "Izrael",
		"JM": "Jamajka",
		"JP": "Japonsko",
		"YE": "Jemen",
		"JE": "Jersey",
		"ZA": "Jihoafrická republika",
		"GS": "Jižní Georgie a Jižní Sandwichovy ostrovy",
		"KR": "Jižní Korea",
		"SS": "Jižní Súdán",
		"JO": "Jordánsko",
		"KY": "Kajmanské ostrovy",
		"KH": "Kambodža",
		"CM": "Kamerun",
		"CA": "Kanada",
		"CV": "Kapverdy",
		"QA": "Katar",
		"KZ": "Kazachstán",
		"KE": "Keňa",
		"KI": "Kiribati",
		"CC": "Kokosové ostrovy",
		"CO": "Kolumbie",
		"KM": "Komory",
		"CG": "Kongo",
		"CR": "Kostarika",
		"CU": "Kuba",
		"KW": "Kuvajt",
		"CY": "Kypr",
		"KG": "Kyrgyzstán",
		"LA": "Laos",
		"LS": "Lesotho",
		"LB": "Libanon",
		"LR": "Libérie",
		"LY": "Libye",
		"LI": "Lichtenštejnsko",
		"LT": "Litva",
		"LV": "Lotyšsko",
		"LU": "Lucembursko",
		"MO": "Macao",
		"MG": "Madagaskar",
		"HU": "Maďarsko",
		"MK": "Makedonie",
		"MY": "Malajsie",
		"MW": "Malawi",
		"MV": "Maledivy",
		"ML": "Mali",
		"MT": "Malta",
		"IM": "Ostrov Man",
		"MA": "Maroko",
		"MH": "Marshallovy ostrovy",
		"MQ": "Martinik",
		"MU": "Mauricius",
		"MR": "Mauritánie",
		"YT": "Mayotte",
		"UM": "Menší odlehlé ostrovy USA",
		"MX": "Mexiko",
		"FM": "Mikronésie",
		"MD": "Moldavsko",
		"MC": "Monako",
		"MN": "Mongolsko",
		"MS": "Montserrat",
		"MZ": "Mosambik",
		"MM": "Myanmar",
		"NA": "Namibie",
		"NR": "Nauru",
		"DE": "Německo",
		"NP": "Nepál",
		"NE": "Niger",
		"NG": "Nigérie",
		"NI": "Nikaragua",
		"NU": "Niue",
		"NL": "Nizozemsko",
		"NF": "Norfolk",
		"NO": "Norsko",
		"NC": "Nová Kaledonie",
		"NZ": "Nový Zéland",
		"OM": "Omán",
		"PK": "Pákistán",
		"PW": "Palau",
		"PS": "Palestinská autonomie",
		"PA": "Panama",
		"PG": "Papua-Nová Guinea",
		"PY": "Paraguay",
		"PE": "Peru",
		"PN": "Pitcairnovy ostrovy",
		"CI": "Pobřeží slonoviny",
		"PL": "Polsko",
		"PR": "Portoriko",
		"PT": "Portugalsko",
		"AT": "Rakousko",
		"RE": "Réunion",
		"GQ": "Rovníková Guinea",
		"RO": "Rumunsko",
		"RU": "Rusko",
		"RW": "Rwanda",
		"GR": "Řecko",
		"PM": "Saint-Pierre a Miquelon",
		"SV": "Salvador",
		"WS": "Samoa",
		"SM": "San Marino",
		"SA": "Saúdská Arábie",
		"SN": "Senegal",
		"KP": "Severní Korea",
		"MP": "Severní Mariany",
		"SC": "Seychely",
		"SL": "Sierra Leone",
		"SG": "Singapur",
		"SK": "Slovensko",
		"SI": "Slovinsko",
		"SO": "Somálsko",
		"AE": "Spojené arabské emiráty",
		"GB": "Spojené království",
		"US": "Spojené státy americké",
		"RS": "Srbsko",
		"CF": "Středoafrická republika",
		"SD": "Súdán",
		"SR": "Surinam",
		"SH": "Svatá Helena, Ascension a Tristan da Cunha",
		"LC": "Svatá Lucie",
		"BL": "Svatý Bartoloměj",
		"KN": "Svatý Kryštof a Nevis",
		"MF": "Svatý Martin (francouzská část)",
		"SX": "Svatý Martin (nizozemská část)",
		"ST": "Svatý Tomáš a Princův ostrov",
		"VC": "Svatý Vincenc a Grenadiny",
		"SZ": "Svazijsko",
		"SY": "Sýrie",
		"SB": "Šalamounovy ostrovy",
		"ES": "Španělsko",
		"SJ": "Špicberky a Jan Mayen",
		"LK": "Šrí Lanka",
		"SE": "Švédsko",
		"CH": "Švýcarsko",
		"TJ": "Tádžikistán",
		"TZ": "Tanzanie",
		"TH": "Thajsko",
		"TW": "Tchaj-wan",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad a Tobago",
		"TN": "Tunisko",
		"TR": "Turecko",
		"TM": "Turkmenistán",
		"TC": "Turks a Caicos",
		"TV": "Tuvalu",
		"UG": "Uganda",
		"UA": "Ukrajina",
		"UY": "Uruguay",
		"UZ": "Uzbekistán",
		"CX": "Vánoční ostrov",
		"VU": "Vanuatu",
		"VA": "Vatikán",
		"VE": "Venezuela",
		"VN": "Vietnam",
		"TL": "Východní Timor",
		"WF": "Wallis a Futuna",
		"ZM": "Zambie",
		"EH": "Západní Sahara",
		"ZW": "Zimbabwe",
		"XK": "Kosovo"
	};

/***/ },
/* 435 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afghanistan",
		"EG": "Ägypten",
		"AX": "Åland",
		"AL": "Albanien",
		"DZ": "Algerien",
		"AS": "Amerikanisch-Samoa",
		"VI": "Amerikanische Jungferninseln",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarktika",
		"AG": "Antigua und Barbuda",
		"GQ": "Äquatorialguinea",
		"AR": "Argentinien",
		"AM": "Armenien",
		"AW": "Aruba",
		"AZ": "Aserbaidschan",
		"ET": "Äthiopien",
		"AU": "Australien",
		"BS": "Bahamas",
		"BH": "Bahrain",
		"BD": "Bangladesch",
		"BB": "Barbados",
		"BY": "Weißrussland",
		"BE": "Belgien",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermuda",
		"BT": "Bhutan",
		"BO": "Bolivien",
		"BQ": "Bonaire",
		"BA": "Bosnien und Herzegowina",
		"BW": "Botswana",
		"BV": "Bouvetinsel",
		"BR": "Brasilien",
		"VG": "Britische Jungferninseln",
		"IO": "Britisches Territorium im Indischen Ozean",
		"BN": "Brunei Darussalam",
		"BG": "Bulgarien",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"CL": "Chile",
		"CN": "China",
		"CK": "Cookinseln",
		"CR": "Costa Rica",
		"CI": "Elfenbeinküste",
		"CW": "Curaçao",
		"DK": "Dänemark",
		"DE": "Deutschland",
		"DM": "Dominica",
		"DO": "Dominikanische Republik",
		"DJ": "Dschibuti",
		"EC": "Ecuador",
		"SV": "El Salvador",
		"ER": "Eritrea",
		"EE": "Estland",
		"FK": "Falklandinseln",
		"FO": "Färöer",
		"FJ": "Fidschi",
		"FI": "Finnland",
		"FR": "Frankreich",
		"GF": "Französisch-Guayana",
		"PF": "Französisch-Polynesien",
		"TF": "Französische Süd- und Antarktisgebiete",
		"GA": "Gabun",
		"GM": "Gambia",
		"GE": "Georgien",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GD": "Grenada",
		"GR": "Griechenland",
		"GL": "Grönland",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GG": "Guernsey",
		"GN": "Guinea",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HT": "Haiti",
		"HM": "Heard und McDonaldinseln",
		"HN": "Honduras",
		"HK": "Hongkong",
		"IN": "Indien",
		"ID": "Indonesien",
		"IM": "Insel Man",
		"IQ": "Irak",
		"IR": "Iran",
		"IE": "Irland",
		"IS": "Island",
		"IL": "Israel",
		"IT": "Italien",
		"JM": "Jamaika",
		"JP": "Japan",
		"YE": "Jemen",
		"JE": "Jersey",
		"JO": "Jordanien",
		"KY": "Kaimaninseln",
		"KH": "Kambodscha",
		"CM": "Kamerun",
		"CA": "Kanada",
		"CV": "Kap Verde",
		"KZ": "Kasachstan",
		"QA": "Katar",
		"KE": "Kenia",
		"KG": "Kirgisistan",
		"KI": "Kiribati",
		"CC": "Kokosinseln",
		"CO": "Kolumbien",
		"KM": "Komoren",
		"CD": "Kongo",
		"KP": "Nordkorea",
		"KR": "Südkorea",
		"HR": "Kroatien",
		"CU": "Kuba",
		"KW": "Kuwait",
		"LA": "Laos",
		"LS": "Lesotho",
		"LV": "Lettland",
		"LB": "Libanon",
		"LR": "Liberia",
		"LY": "Libyen",
		"LI": "Liechtenstein",
		"LT": "Litauen",
		"LU": "Luxemburg",
		"MO": "Macao",
		"MG": "Madagaskar",
		"MW": "Malawi",
		"MY": "Malaysia",
		"MV": "Malediven",
		"ML": "Mali",
		"MT": "Malta",
		"MA": "Marokko",
		"MH": "Marshallinseln",
		"MQ": "Martinique",
		"MR": "Mauretanien",
		"MU": "Mauritius",
		"YT": "Mayotte",
		"MK": "Mazedonien",
		"MX": "Mexiko",
		"FM": "Mikronesien",
		"MD": "Moldawien",
		"MC": "Monaco",
		"MN": "Mongolei",
		"ME": "Montenegro",
		"MS": "Montserrat",
		"MZ": "Mosambik",
		"MM": "Myanmar",
		"NA": "Namibia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NC": "Neukaledonien",
		"NZ": "Neuseeland",
		"NI": "Nicaragua",
		"NL": "Niederlande",
		"NE": "Niger",
		"NG": "Nigeria",
		"NU": "Niue",
		"MP": "Nördliche Marianen",
		"NF": "Norfolkinsel",
		"NO": "Norwegen",
		"OM": "Oman",
		"AT": "Österreich",
		"TL": "Osttimor",
		"PK": "Pakistan",
		"PS": "Staat Palästina",
		"PW": "Palau",
		"PA": "Panama",
		"PG": "Papua-Neuguinea",
		"PY": "Paraguay",
		"PE": "Peru",
		"PH": "Philippinen",
		"PN": "Pitcairninseln",
		"PL": "Polen",
		"PT": "Portugal",
		"PR": "Puerto Rico",
		"TW": "Taiwan",
		"CG": "Republik Kongo",
		"RE": "Réunion",
		"RW": "Ruanda",
		"RO": "Rumänien",
		"RU": "Russische Föderation",
		"BL": "Saint-Barthélemy",
		"MF": "Saint-Martin",
		"SB": "Salomonen",
		"ZM": "Sambia",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "São Tomé und Príncipe",
		"SA": "Saudi-Arabien",
		"SE": "Schweden",
		"CH": "Schweiz",
		"SN": "Senegal",
		"RS": "Serbien",
		"SC": "Seychellen",
		"SL": "Sierra Leone",
		"ZW": "Simbabwe",
		"SG": "Singapur",
		"SX": "Sint Maarten",
		"SK": "Slowakei",
		"SI": "Slowenien",
		"SO": "Somalia",
		"ES": "Spanien",
		"LK": "Sri Lanka",
		"SH": "St. Helena",
		"KN": "St. Kitts und Nevis",
		"LC": "St. Lucia",
		"PM": "Saint-Pierre und Miquelon",
		"VC": "St. Vincent und die Grenadinen",
		"ZA": "Südafrika",
		"SD": "Sudan",
		"GS": "Südgeorgien und die Südlichen Sandwichinseln",
		"SS": "Südsudan",
		"SR": "Suriname",
		"SJ": "Svalbard und Jan Mayen",
		"SZ": "Swasiland",
		"SY": "Syrien, Arabische Republik",
		"TJ": "Tadschikistan",
		"TZ": "Tansania, Vereinigte Republik",
		"TH": "Thailand",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad und Tobago",
		"TD": "Tschad",
		"CZ": "Tschechische Republik",
		"TN": "Tunesien",
		"TR": "Türkei",
		"TM": "Turkmenistan",
		"TC": "Turks- und Caicosinseln",
		"TV": "Tuvalu",
		"UG": "Uganda",
		"UA": "Ukraine",
		"HU": "Ungarn",
		"UM": "United States Minor Outlying Islands",
		"UY": "Uruguay",
		"UZ": "Usbekistan",
		"VU": "Vanuatu",
		"VA": "Vatikanstadt",
		"VE": "Venezuela",
		"AE": "Vereinigte Arabische Emirate",
		"US": "Vereinigte Staaten von Amerika",
		"GB": "Vereinigtes Königreich Großbritannien und Nordirland",
		"VN": "Vietnam",
		"WF": "Wallis und Futuna",
		"CX": "Weihnachtsinsel",
		"EH": "Westsahara",
		"CF": "Zentralafrikanische Republik",
		"CY": "Zypern",
		"XK": "Kosovo"
	};

/***/ },
/* 436 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afghanistan",
		"AL": "Albania",
		"DZ": "Algeria",
		"AS": "American Samoa",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarctica",
		"AG": "Antigua and Barbuda",
		"AR": "Argentina",
		"AM": "Armenia",
		"AW": "Aruba",
		"AU": "Australia",
		"AT": "Austria",
		"AZ": "Azerbaijan",
		"BS": "Bahamas",
		"BH": "Bahrain",
		"BD": "Bangladesh",
		"BB": "Barbados",
		"BY": "Belarus",
		"BE": "Belgium",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermuda",
		"BT": "Bhutan",
		"BO": "Bolivia",
		"BA": "Bosnia and Herzegovina",
		"BW": "Botswana",
		"BV": "Bouvet Island",
		"BR": "Brazil",
		"IO": "British Indian Ocean Territory",
		"BN": "Brunei Darussalam",
		"BG": "Bulgaria",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KH": "Cambodia",
		"CM": "Cameroon",
		"CA": "Canada",
		"CV": "Cape Verde",
		"KY": "Cayman Islands",
		"CF": "Central African Republic",
		"TD": "Chad",
		"CL": "Chile",
		"CN": "China",
		"CX": "Christmas Island",
		"CC": "Cocos (Keeling) Islands",
		"CO": "Colombia",
		"KM": "Comoros",
		"CG": "Congo",
		"CD": "Congo, the Democratic Republic of the",
		"CK": "Cook Islands",
		"CR": "Costa Rica",
		"CI": "Cote D'Ivoire",
		"HR": "Croatia",
		"CU": "Cuba",
		"CY": "Cyprus",
		"CZ": "Czech Republic",
		"DK": "Denmark",
		"DJ": "Djibouti",
		"DM": "Dominica",
		"DO": "Dominican Republic",
		"EC": "Ecuador",
		"EG": "Egypt",
		"SV": "El Salvador",
		"GQ": "Equatorial Guinea",
		"ER": "Eritrea",
		"EE": "Estonia",
		"ET": "Ethiopia",
		"FK": "Falkland Islands (Malvinas)",
		"FO": "Faroe Islands",
		"FJ": "Fiji",
		"FI": "Finland",
		"FR": "France",
		"GF": "French Guiana",
		"PF": "French Polynesia",
		"TF": "French Southern Territories",
		"GA": "Gabon",
		"GM": "Gambia",
		"GE": "Georgia",
		"DE": "Germany",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GR": "Greece",
		"GL": "Greenland",
		"GD": "Grenada",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GN": "Guinea",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HT": "Haiti",
		"HM": "Heard Island and Mcdonald Islands",
		"VA": "Holy See (Vatican City State)",
		"HN": "Honduras",
		"HK": "Hong Kong",
		"HU": "Hungary",
		"IS": "Iceland",
		"IN": "India",
		"ID": "Indonesia",
		"IR": "Iran, Islamic Republic of",
		"IQ": "Iraq",
		"IE": "Ireland",
		"IL": "Israel",
		"IT": "Italy",
		"JM": "Jamaica",
		"JP": "Japan",
		"JO": "Jordan",
		"KZ": "Kazakhstan",
		"KE": "Kenya",
		"KI": "Kiribati",
		"KP": "Korea, Democratic People's Republic of",
		"KR": "Korea, Republic of",
		"KW": "Kuwait",
		"KG": "Kyrgyzstan",
		"LA": "Lao People's Democratic Republic",
		"LV": "Latvia",
		"LB": "Lebanon",
		"LS": "Lesotho",
		"LR": "Liberia",
		"LY": "Libyan Arab Jamahiriya",
		"LI": "Liechtenstein",
		"LT": "Lithuania",
		"LU": "Luxembourg",
		"MO": "Macao",
		"MK": "Macedonia, the Former Yugoslav Republic of",
		"MG": "Madagascar",
		"MW": "Malawi",
		"MY": "Malaysia",
		"MV": "Maldives",
		"ML": "Mali",
		"MT": "Malta",
		"MH": "Marshall Islands",
		"MQ": "Martinique",
		"MR": "Mauritania",
		"MU": "Mauritius",
		"YT": "Mayotte",
		"MX": "Mexico",
		"FM": "Micronesia, Federated States of",
		"MD": "Moldova, Republic of",
		"MC": "Monaco",
		"MN": "Mongolia",
		"MS": "Montserrat",
		"MA": "Morocco",
		"MZ": "Mozambique",
		"MM": "Myanmar",
		"NA": "Namibia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NL": "Netherlands",
		"NC": "New Caledonia",
		"NZ": "New Zealand",
		"NI": "Nicaragua",
		"NE": "Niger",
		"NG": "Nigeria",
		"NU": "Niue",
		"NF": "Norfolk Island",
		"MP": "Northern Mariana Islands",
		"NO": "Norway",
		"OM": "Oman",
		"PK": "Pakistan",
		"PW": "Palau",
		"PS": "Palestinian Territory, Occupied",
		"PA": "Panama",
		"PG": "Papua New Guinea",
		"PY": "Paraguay",
		"PE": "Peru",
		"PH": "Philippines",
		"PN": "Pitcairn",
		"PL": "Poland",
		"PT": "Portugal",
		"PR": "Puerto Rico",
		"QA": "Qatar",
		"RE": "Reunion",
		"RO": "Romania",
		"RU": "Russian Federation",
		"RW": "Rwanda",
		"SH": "Saint Helena",
		"KN": "Saint Kitts and Nevis",
		"LC": "Saint Lucia",
		"PM": "Saint Pierre and Miquelon",
		"VC": "Saint Vincent and the Grenadines",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "Sao Tome and Principe",
		"SA": "Saudi Arabia",
		"SN": "Senegal",
		"SC": "Seychelles",
		"SL": "Sierra Leone",
		"SG": "Singapore",
		"SK": "Slovakia",
		"SI": "Slovenia",
		"SB": "Solomon Islands",
		"SO": "Somalia",
		"ZA": "South Africa",
		"GS": "South Georgia and the South Sandwich Islands",
		"ES": "Spain",
		"LK": "Sri Lanka",
		"SD": "Sudan",
		"SR": "Suriname",
		"SJ": "Svalbard and Jan Mayen",
		"SZ": "Swaziland",
		"SE": "Sweden",
		"CH": "Switzerland",
		"SY": "Syrian Arab Republic",
		"TW": "Taiwan",
		"TJ": "Tajikistan",
		"TZ": "Tanzania, United Republic of",
		"TH": "Thailand",
		"TL": "Timor-Leste",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad and Tobago",
		"TN": "Tunisia",
		"TR": "Turkey",
		"TM": "Turkmenistan",
		"TC": "Turks and Caicos Islands",
		"TV": "Tuvalu",
		"UG": "Uganda",
		"UA": "Ukraine",
		"AE": "United Arab Emirates",
		"GB": "United Kingdom",
		"US": "United States of America",
		"UM": "United States Minor Outlying Islands",
		"UY": "Uruguay",
		"UZ": "Uzbekistan",
		"VU": "Vanuatu",
		"VE": "Venezuela",
		"VN": "Viet Nam",
		"VG": "Virgin Islands, British",
		"VI": "Virgin Islands, U.s.",
		"WF": "Wallis and Futuna",
		"EH": "Western Sahara",
		"YE": "Yemen",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"AX": "Åland Islands",
		"BQ": "Bonaire, Sint Eustatius and Saba",
		"CW": "Curaçao",
		"GG": "Guernsey",
		"IM": "Isle of Man",
		"JE": "Jersey",
		"ME": "Montenegro",
		"BL": "Saint Barthélemy",
		"MF": "Saint Martin (French part)",
		"RS": "Serbia",
		"SX": "Sint Maarten (Dutch part)",
		"SS": "South Sudan",
		"XK": "Kosovo"
	};

/***/ },
/* 437 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afganistán",
		"AL": "Albania",
		"DZ": "Argelia",
		"AS": "Samoa Americana",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguila",
		"AQ": "Antártida",
		"AG": "Antigua y Barbuda",
		"AR": "Argentina",
		"AM": "Armenia",
		"AW": "Aruba",
		"AU": "Australia",
		"AT": "Austria",
		"AZ": "Azerbaiyán",
		"BS": "Bahamas",
		"BH": "Bahrein",
		"BD": "Bangladesh",
		"BB": "Barbados",
		"BY": "Belarús",
		"BE": "Bélgica",
		"BZ": "Belice",
		"BJ": "Benin",
		"BM": "Bermudas",
		"BT": "Bhután",
		"BO": "Bolivia",
		"BA": "Bosnia y Herzegovina",
		"BW": "Botswana",
		"BV": "Isla Bouvet",
		"BR": "Brasil",
		"IO": "Territorio Británico del Océano Índico",
		"BN": "Brunei Darussalam",
		"BG": "Bulgaria",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KH": "Camboya",
		"CM": "Camerún",
		"CA": "Canadá",
		"CV": "Cabo Verde",
		"KY": "Islas Caimán",
		"CF": "República Centroafricana",
		"TD": "Chad",
		"CL": "Chile",
		"CN": "China",
		"CX": "Isla de Navidad",
		"CC": "Islas Cocos (Keeling)",
		"CO": "Colombia",
		"KM": "Comoras",
		"CG": "Congo",
		"CD": "Congo (República Democrática del)",
		"CK": "Islas Cook",
		"CR": "Costa Rica",
		"CI": "Côte d'Ivoire",
		"HR": "Croacia",
		"CU": "Cuba",
		"CY": "Chipre",
		"CZ": "República Checa",
		"DK": "Dinamarca",
		"DJ": "Djibouti",
		"DM": "Dominica",
		"DO": "República Dominicana",
		"EC": "Ecuador",
		"EG": "Egipto",
		"SV": "El Salvador",
		"GQ": "Guinea Ecuatorial",
		"ER": "Eritrea",
		"EE": "Estonia",
		"ET": "Etiopía",
		"FK": "Islas Malvinas",
		"FO": "Islas Feroe",
		"FJ": "Fiji",
		"FI": "Finlandia",
		"FR": "Francia",
		"GF": "Guayana Francesa",
		"PF": "Polinesia Francesa",
		"TF": "Tierras Australes Francesas",
		"GA": "Gabón",
		"GM": "Gambia",
		"GE": "Georgia",
		"DE": "Alemania",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GR": "Grecia",
		"GL": "Groenlandia",
		"GD": "Granada",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GN": "Guinea",
		"GW": "Guinea Bissau",
		"GY": "Guyana",
		"HT": "Haití",
		"HM": "Heard e Islas McDonald",
		"VA": "Santa Sede",
		"HN": "Honduras",
		"HK": "Hong Kong",
		"HU": "Hungría",
		"IS": "Islandia",
		"IN": "India",
		"ID": "Indonesia",
		"IR": "Irán (República Islámica de)",
		"IQ": "Iraq",
		"IE": "Irlanda",
		"IL": "Israel",
		"IT": "Italia",
		"JM": "Jamaica",
		"JP": "Japón",
		"JO": "Jordania",
		"KZ": "Kazajstán",
		"KE": "Kenya",
		"KI": "Kiribati",
		"KP": "República Popular Democrática de Corea",
		"KR": "República de Corea",
		"KW": "Kuwait",
		"KG": "Kirguistán",
		"LA": "República Democrática Popular de Lao",
		"LV": "Letonia",
		"LB": "Líbano",
		"LS": "Lesotho",
		"LR": "Liberia",
		"LY": "Libia",
		"LI": "Liechtenstein",
		"LT": "Lituania",
		"LU": "Luxemburgo",
		"MO": "Macao",
		"MK": "Macedonia",
		"MG": "Madagascar",
		"MW": "Malawi",
		"MY": "Malasia",
		"MV": "Maldivas",
		"ML": "Malí",
		"MT": "Malta",
		"MH": "Islas Marshall",
		"MQ": "Martinique",
		"MR": "Mauritania",
		"MU": "Mauricio",
		"YT": "Mayotte",
		"MX": "México",
		"FM": "Micronesia",
		"MD": "Moldavia",
		"MC": "Mónaco",
		"MN": "Mongolia",
		"MS": "Montserrat",
		"MA": "Marruecos",
		"MZ": "Mozambique",
		"MM": "Myanmar",
		"NA": "Namibia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NL": "Países Bajos",
		"NC": "Nueva Caledonia",
		"NZ": "Nueva Zelandia",
		"NI": "Nicaragua",
		"NE": "Níger",
		"NG": "Nigeria",
		"NU": "Niue",
		"NF": "Isla Norfolk",
		"MP": "Isla Marianas del Norte",
		"NO": "Noruega",
		"OM": "Omán",
		"PK": "Pakistán",
		"PW": "Palau",
		"PS": "Palestina",
		"PA": "Panamá",
		"PG": "Papua Nueva Guinea",
		"PY": "Paraguay",
		"PE": "Perú",
		"PH": "Filipinas",
		"PN": "Pitcairn",
		"PL": "Polonia",
		"PT": "Portugal",
		"PR": "Puerto Rico",
		"QA": "Qatar",
		"RE": "Reunión",
		"RO": "Rumania",
		"RU": "Rusia",
		"RW": "Rwanda",
		"SH": "Santa Helena, Ascensión y Tristán de Acuña",
		"KN": "Saint Kitts y Nevis",
		"LC": "Santa Lucía",
		"PM": "San Pedro y Miquelón",
		"VC": "San Vicente y las Granadinas",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "Santo Tomé y Príncipe",
		"SA": "Arabia Saudita",
		"SN": "Senegal",
		"SC": "Seychelles",
		"SL": "Sierra Leona",
		"SG": "Singapur",
		"SK": "Eslovaquia",
		"SI": "Eslovenia",
		"SB": "Islas Salomón",
		"SO": "Somalia",
		"ZA": "Sudáfrica",
		"GS": "Georgia del Sur y las Islas Sandwich del Sur",
		"ES": "España",
		"LK": "Sri Lanka",
		"SD": "Sudan",
		"SR": "Suriname",
		"SJ": "Svalbard y Jan Mayen",
		"SZ": "Swazilandia",
		"SE": "Suecia",
		"CH": "Suiza",
		"SY": "República Árabe Siria",
		"TW": "Taiwán",
		"TJ": "Tayikistán",
		"TZ": "Tanzania",
		"TH": "Tailandia",
		"TL": "Timor-Leste",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad y Tobago",
		"TN": "Túnez",
		"TR": "Turquía",
		"TM": "Turkmenistán",
		"TC": "Islas Turcas y Caicos",
		"TV": "Tuvalu",
		"UG": "Uganda",
		"UA": "Ucrania",
		"AE": "Emiratos Árabes Unido",
		"GB": "Reino Unido",
		"US": "Estados Unidos",
		"UM": "Islas Ultramarinas Menores de los Estados Unidos",
		"UY": "Uruguay",
		"UZ": "Uzbekistán",
		"VU": "Vanuatu",
		"VE": "Venezuela",
		"VN": "Vietnam",
		"VG": "Islas Vírgenes británicas",
		"VI": "Islas Vírgenes de los Estados Unidos",
		"WF": "Wallis y Futuna",
		"EH": "Sahara Occidental",
		"YE": "Yemen",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"AX": "Islas Åland",
		"BQ": "Bonaire, San Eustaquio y Saba",
		"CW": "Curaçao",
		"GG": "Guernsey",
		"IM": "Isla de Man",
		"JE": "Jersey",
		"ME": "Montenegro",
		"BL": "Saint Barthélemy",
		"MF": "Saint Martin (francesa)",
		"RS": "Serbia",
		"SX": "Sint Maarten (neerlandesa)",
		"SS": "Sudán del Sur",
		"XK": "Kosovo"
	};

/***/ },
/* 438 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afganistan",
		"AX": "Ahvenamaa",
		"AL": "Albaania",
		"DZ": "Alžeeria",
		"AS": "Ameerika Samoa",
		"US": "Ameerika Ühendriigid",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarktis",
		"AG": "Antigua ja Barbuda",
		"MO": "Aomen - Hiina erihalduspiirkond",
		"AE": "Araabia Ühendemiraadid",
		"AR": "Argentina",
		"AM": "Armeenia",
		"AW": "Aruba",
		"AZ": "Aserbaidžaan",
		"AU": "Austraalia",
		"AT": "Austria",
		"BS": "Bahama",
		"BH": "Bahrein",
		"BD": "Bangladesh",
		"BB": "Barbados",
		"PW": "Belau",
		"BE": "Belgia",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermuda",
		"BT": "Bhutan",
		"BO": "Boliivia",
		"BA": "Bosnia ja Hertsegoviina",
		"BW": "Botswana",
		"BV": "Bouvet’i saar",
		"BR": "Brasiilia",
		"BQ": "Bonaire, Sint Eustatius ja Saba",
		"IO": "Briti India ookeani ala",
		"VG": "Briti Neitsisaared",
		"BN": "Brunei",
		"BG": "Bulgaaria",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"CO": "Colombia",
		"CK": "Cooki saared",
		"CR": "Costa Rica",
		"CI": "Côte d'Ivoire",
		"CW": "Curaçao",
		"DJ": "Djibouti",
		"DM": "Dominica",
		"DO": "Dominikaani Vabariik",
		"EC": "Ecuador",
		"EE": "Eesti",
		"EG": "Egiptus",
		"GQ": "Ekvatoriaal-Guinea",
		"SV": "El Salvador",
		"ER": "Eritrea",
		"ET": "Etioopia",
		"FK": "Falklandi saared",
		"FJ": "Fidži",
		"PH": "Filipiinid",
		"FO": "Fääri saared",
		"GA": "Gabon",
		"GM": "Gambia",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GD": "Grenada",
		"GE": "Gruusia",
		"GL": "Gröönimaa",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GG": "Guernsey",
		"GN": "Guinea",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HT": "Haiti",
		"HM": "Heard ja McDonald saared",
		"CN": "Hiina",
		"ES": "Hispaania",
		"NL": "Holland",
		"HN": "Honduras",
		"HK": "Hongkong - Hiina erihalduspiirkond",
		"HR": "Horvaatia",
		"TL": "Ida-Timor",
		"IE": "Iirimaa",
		"IL": "Iisrael",
		"IN": "India",
		"ID": "Indoneesia",
		"IQ": "Iraak",
		"IR": "Iraan",
		"IS": "Island",
		"IT": "Itaalia",
		"JP": "Jaapan",
		"JM": "Jamaica",
		"YE": "Jeemen",
		"JE": "Jersey",
		"JO": "Jordaania",
		"CX": "Jõulusaar",
		"KY": "Kaimanisaared",
		"KH": "Kambodža",
		"CM": "Kamerun",
		"CA": "Kanada",
		"KZ": "Kasahstan",
		"QA": "Katar",
		"KE": "Kenya",
		"CF": "Kesk-Aafrika Vabariik",
		"KI": "Kiribati",
		"KM": "Komoorid",
		"CD": "Kongo DV",
		"CG": "Kongo-Brazzaville",
		"CC": "Kookossaared",
		"GR": "Kreeka",
		"CU": "Kuuba",
		"KW": "Kuveit",
		"KG": "Kõrgõzstan",
		"CY": "Küpros",
		"LA": "Laos",
		"LT": "Leedu",
		"LS": "Lesotho",
		"LR": "Libeeria",
		"LI": "Liechtenstein",
		"LB": "Liibanon",
		"LY": "Liibüa",
		"LU": "Luksemburg",
		"ZA": "Lõuna-Aafrika Vabariik",
		"GS": "Lõuna-Georgia ja Lõuna-Sandwichi saared",
		"KR": "Lõuna-Korea",
		"LV": "Läti",
		"EH": "Lääne-Sahara",
		"MG": "Madagaskar",
		"MK": "Makedoonia",
		"MY": "Malaisia",
		"MW": "Malawi",
		"MV": "Maldiivid",
		"ML": "Mali",
		"MT": "Malta",
		"IM": "Mani saar",
		"MA": "Maroko",
		"MH": "Marshalli saared",
		"MQ": "Martinique",
		"MR": "Mauritaania",
		"MU": "Mauritius",
		"YT": "Mayotte",
		"MX": "Mehhiko",
		"FM": "Mikroneesia Liiduriigid",
		"MD": "Moldova",
		"MC": "Monaco",
		"MN": "Mongoolia",
		"ME": "Montenegro",
		"MS": "Montserrat",
		"MZ": "Mosambiik",
		"MM": "Myanmar",
		"NA": "Namiibia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NI": "Nicaragua",
		"NG": "Nigeeria",
		"NE": "Niger",
		"NU": "Niue",
		"NF": "Norfolk",
		"NO": "Norra",
		"OM": "Omaan",
		"PG": "Paapua Uus-Guinea",
		"PK": "Pakistan",
		"PS": "Palestiina ala",
		"PA": "Panama",
		"PY": "Paraguay",
		"PE": "Peruu",
		"PN": "Pitcairn",
		"PL": "Poola",
		"PT": "Portugal",
		"GF": "Prantsuse Guajaana",
		"TF": "Prantsuse Lõunaalad",
		"PF": "Prantsuse Polüneesia",
		"FR": "Prantsusmaa",
		"PR": "Puerto Rico",
		"KP": "Põhja-Korea",
		"MP": "Põhja-Mariaanid",
		"RE": "Réunion",
		"CV": "Roheneemesaared",
		"SE": "Rootsi",
		"SX": "Sint Maarten",
		"RO": "Rumeenia",
		"RW": "Rwanda",
		"SB": "Saalomoni Saared",
		"BL": "Saint Barthélemy",
		"SH": "Saint Helena",
		"KN": "Saint Kitts ja Nevis",
		"LC": "Saint Lucia",
		"MF": "Saint Martin",
		"PM": "Saint Pierre ja Miquelon",
		"VC": "Saint Vincent ja Grenadiinid",
		"DE": "Saksamaa",
		"ZM": "Sambia",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "São Tomé ja Príncipe",
		"SA": "Saudi Araabia",
		"SC": "Seišellid",
		"SN": "Senegal",
		"RS": "Serbia",
		"SL": "Sierra Leone",
		"SG": "Singapur",
		"SK": "Slovakkia",
		"SI": "Sloveenia",
		"SO": "Somaalia",
		"FI": "Soome",
		"LK": "Sri Lanka",
		"SD": "Sudaan",
		"SS": "Lõuna-Sudaan",
		"SR": "Suriname",
		"GB": "Suurbritannia",
		"SZ": "Svaasimaa",
		"SJ": "Svalbard ja Jan Mayen",
		"SY": "Süüria",
		"CH": "Šveits",
		"ZW": "Zimbabwe",
		"DK": "Taani",
		"TJ": "Tadžikistan",
		"TH": "Tai",
		"TW": "Taiwan",
		"TZ": "Tansaania",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad ja Tobago",
		"TD": "Tšaad",
		"CZ": "Tšehhi",
		"CL": "Tšiili",
		"TN": "Tuneesia",
		"TC": "Turks ja Caicos",
		"TV": "Tuvalu",
		"TR": "Türgi",
		"TM": "Türkmenistan",
		"UG": "Uganda",
		"UA": "Ukraina",
		"HU": "Ungari",
		"UY": "Uruguay",
		"VI": "USA Neitsisaared",
		"UZ": "Usbekistan",
		"NC": "Uus-Kaledoonia",
		"NZ": "Uus-Meremaa",
		"BY": "Valgevene",
		"WF": "Wallis ja Futuna",
		"VU": "Vanuatu",
		"VA": "Vatikan",
		"RU": "Venemaa",
		"VE": "Venezuela",
		"VN": "Vietnam",
		"UM": "Ühendriikide hajasaared",
		"XK": "Kosovo"
	};

/***/ },
/* 439 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afganistan",
		"AX": "Ahvenanmaa",
		"NL": "Alankomaat",
		"AL": "Albania",
		"DZ": "Algeria",
		"AS": "Amerikan Samoa",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarktis",
		"AG": "Antigua ja Barbuda",
		"AE": "Arabiemiirikunnat",
		"AR": "Argentiina",
		"AM": "Armenia",
		"AW": "Aruba",
		"AU": "Australia",
		"AZ": "Azerbaidžan",
		"BS": "Bahama",
		"BH": "Bahrain",
		"BD": "Bangladesh",
		"BB": "Barbados",
		"BE": "Belgia",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermuda",
		"BT": "Bhutan",
		"BO": "Bolivia",
		"BQ": "Bonaire, Sint Eustatius ja Saba",
		"BA": "Bosnia ja Hertsegovina",
		"BW": "Botswana",
		"BV": "Bouvet’nsaari",
		"BR": "Brasilia",
		"IO": "Brittiläinen Intian valtameren alue",
		"VG": "Brittiläiset Neitsytsaaret",
		"BN": "Brunei",
		"BG": "Bulgaria",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KY": "Caymansaaret",
		"CL": "Chile",
		"CK": "Cookinsaaret",
		"CR": "Costa Rica",
		"CW": "Curaçao",
		"DJ": "Djibouti",
		"DM": "Dominica",
		"DO": "Dominikaaninen tasavalta",
		"EC": "Ecuador",
		"EG": "Egypti",
		"SV": "El Salvador",
		"ER": "Eritrea",
		"ES": "Espanja",
		"ET": "Etiopia",
		"ZA": "Etelä-Afrikka",
		"GS": "Etelä-Georgia ja Eteläiset Sandwichsaaret",
		"SS": "Etelä-Sudan",
		"FK": "Falklandinsaaret",
		"FO": "Färsaaret",
		"FJ": "Fidži",
		"PH": "Filippiinit",
		"GA": "Gabon",
		"GM": "Gambia",
		"GE": "Georgia",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GD": "Grenada",
		"GL": "Grönlanti",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GG": "Guernsey",
		"GN": "Guinea",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HT": "Haiti",
		"HM": "Heard ja McDonaldinsaaret",
		"HN": "Honduras",
		"HK": "Hongkong",
		"ID": "Indonesia",
		"IN": "Intia",
		"IQ": "Irak",
		"IR": "Iran",
		"IE": "Irlanti",
		"IS": "Islanti",
		"IL": "Israel",
		"IT": "Italia",
		"TL": "Itä-Timor",
		"AT": "Itävalta",
		"JM": "Jamaika",
		"JP": "Japani",
		"YE": "Jemen",
		"JE": "Jersey",
		"JO": "Jordania",
		"CX": "Joulusaari",
		"KH": "Kambodža",
		"CM": "Kamerun",
		"CA": "Kanada",
		"CV": "Kap Verde",
		"KZ": "Kazakstan",
		"KE": "Kenia",
		"CF": "Keski-Afrikan tasavalta",
		"CN": "Kiina",
		"KG": "Kirgisia",
		"KI": "Kiribati",
		"CO": "Kolumbia",
		"KM": "Komorit",
		"CD": "Kongon demokraattinen tasavalta",
		"CG": "Kongon tasavalta",
		"CC": "Kookossaaret",
		"KP": "Korean demokraattinen kansantasavalta",
		"KR": "Korean tasavalta",
		"GR": "Kreikka",
		"HR": "Kroatia",
		"CU": "Kuuba",
		"KW": "Kuwait",
		"CY": "Kypros",
		"LA": "Laos",
		"LV": "Latvia",
		"LS": "Lesotho",
		"LB": "Libanon",
		"LR": "Liberia",
		"LY": "Libya",
		"LI": "Liechtenstein",
		"LT": "Liettua",
		"LU": "Luxemburg",
		"EH": "Länsi-Sahara",
		"MO": "Macao",
		"MG": "Madagaskar",
		"MK": "Makedonia",
		"MW": "Malawi",
		"MV": "Malediivit",
		"MY": "Malesia",
		"ML": "Mali",
		"MT": "Malta",
		"IM": "Mansaari",
		"MA": "Marokko",
		"MH": "Marshallinsaaret",
		"MQ": "Martinique",
		"MR": "Mauritania",
		"MU": "Mauritius",
		"YT": "Mayotte",
		"MX": "Meksiko",
		"FM": "Mikronesian liittovaltio",
		"MD": "Moldova",
		"MC": "Monaco",
		"MN": "Mongolia",
		"ME": "Montenegro",
		"MS": "Montserrat",
		"MZ": "Mosambik",
		"MM": "Myanmar",
		"NA": "Namibia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NI": "Nicaragua",
		"NE": "Niger",
		"NG": "Nigeria",
		"NU": "Niue",
		"NF": "Norfolkinsaari",
		"NO": "Norja",
		"CI": "Norsunluurannikko",
		"OM": "Oman",
		"PK": "Pakistan",
		"PW": "Palau",
		"PS": "Palestiina",
		"PA": "Panama",
		"PG": "Papua-Uusi-Guinea",
		"PY": "Paraguay",
		"PE": "Peru",
		"MP": "Pohjois-Mariaanit",
		"PN": "Pitcairn",
		"PT": "Portugali",
		"PR": "Puerto Rico",
		"PL": "Puola",
		"GQ": "Päiväntasaajan Guinea",
		"QA": "Qatar",
		"FR": "Ranska",
		"TF": "Ranskan eteläiset alueet",
		"GF": "Ranskan Guayana",
		"PF": "Ranskan Polynesia",
		"RE": "Réunion",
		"RO": "Romania",
		"RW": "Ruanda",
		"SE": "Ruotsi",
		"BL": "Saint-Barthélemy",
		"SH": "Saint Helena",
		"KN": "Saint Kitts ja Nevis",
		"LC": "Saint Lucia",
		"MF": "Saint-Martin",
		"PM": "Saint-Pierre ja Miquelon",
		"VC": "Saint Vincent ja Grenadiinit",
		"DE": "Saksa",
		"SB": "Salomonsaaret",
		"ZM": "Sambia",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "São Tomé ja Príncipe",
		"SA": "Saudi-Arabia",
		"SN": "Senegal",
		"RS": "Serbia",
		"SC": "Seychellit",
		"SL": "Sierra Leone",
		"SG": "Singapore",
		"SX": "Sint Maarten",
		"SK": "Slovakia",
		"SI": "Slovenia",
		"SO": "Somalia",
		"LK": "Sri Lanka",
		"SD": "Sudan",
		"FI": "Suomi",
		"SR": "Suriname",
		"SJ": "Svalbard ja Jan Mayen",
		"SZ": "Swazimaa",
		"CH": "Sveitsi",
		"SY": "Syyria",
		"TJ": "Tadžikistan",
		"TW": "Taiwan",
		"TZ": "Tansania",
		"DK": "Tanska",
		"TH": "Thaimaa",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad ja Tobago",
		"TD": "Tšad",
		"CZ": "Tšekki",
		"TN": "Tunisia",
		"TR": "Turkki",
		"TM": "Turkmenistan",
		"TC": "Turks- ja Caicossaaret",
		"TV": "Tuvalu",
		"UG": "Uganda",
		"UA": "Ukraina",
		"HU": "Unkari",
		"UY": "Uruguay",
		"NC": "Uusi-Kaledonia",
		"NZ": "Uusi-Seelanti",
		"UZ": "Uzbekistan",
		"BY": "Valko-Venäjä",
		"VU": "Vanuatu",
		"VA": "Vatikaanivaltio",
		"VE": "Venezuela",
		"RU": "Venäjä",
		"VN": "Vietnam",
		"EE": "Viro",
		"WF": "Wallis ja Futunasaaret",
		"GB": "Yhdistynyt kuningaskunta",
		"US": "Yhdysvallat",
		"VI": "Yhdysvaltain Neitsytsaaret",
		"UM": "Yhdysvaltain pienet erillissaaret",
		"ZW": "Zimbabwe",
		"XK": "Kosovo"
	};

/***/ },
/* 440 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afghanistan",
		"AL": "Albanie",
		"DZ": "Algérie",
		"AS": "Samoa américaine",
		"AD": "Andorre",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarctique",
		"AG": "Antigua et Barbuda",
		"AR": "Argentine",
		"AM": "Arménie",
		"AW": "Aruba",
		"AU": "Australie",
		"AT": "Autriche",
		"AZ": "Azerbaidjan",
		"BS": "Bahamas",
		"BH": "Bahrein",
		"BD": "Bangladesh",
		"BB": "Barbade",
		"BY": "Bielorussie",
		"BE": "Belgique",
		"BZ": "Belize",
		"BJ": "Bénin",
		"BM": "Bermudes",
		"BT": "Bhoutan",
		"BO": "Bolivie",
		"BA": "Bosnie-Herzégovine",
		"BW": "Botswana",
		"BV": "Île Bouvet",
		"BR": "Brésil",
		"IO": "Océan Indien Britannique",
		"BN": "Brunei Darussalam",
		"BG": "Bulgarie",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KH": "Cambodge",
		"CM": "Cameroun",
		"CA": "Canada",
		"CV": "Cap-Vert",
		"KY": "Caïmanes",
		"CF": "Centrafricaine, République",
		"TD": "Tchad",
		"CL": "Chili",
		"CN": "Chine",
		"CX": "Île Christmas",
		"CC": "Cocos",
		"CO": "Colombie",
		"KM": "Comores",
		"CG": "Congo, République populaire",
		"CD": "Congo, République démocratique",
		"CK": "Îles Cook",
		"CR": "Costa Rica",
		"CI": "Côte-d'Ivoire",
		"HR": "Croatie",
		"CU": "Cuba",
		"CY": "Chypre",
		"CZ": "Tchéquie",
		"DK": "Danemark",
		"DJ": "Djibouti",
		"DM": "Dominique",
		"DO": "République Dominicaine",
		"EC": "Équateur",
		"EG": "Égypte",
		"SV": "El Salvador",
		"GQ": "Guinée équatoriale",
		"ER": "Érythrée",
		"EE": "Estonie",
		"ET": "Éthiopie",
		"FK": "Îles Malouines",
		"FO": "Îles Féroé",
		"FJ": "Fidji",
		"FI": "Finlande",
		"FR": "France",
		"GF": "Guyane française",
		"PF": "Polynésie française",
		"TF": "Terres australes françaises",
		"GA": "Gabon",
		"GM": "Gambie",
		"GE": "Géorgie",
		"DE": "Allemagne",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GR": "Grèce",
		"GL": "Groenland",
		"GD": "Grenada",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GN": "Guinée",
		"GW": "Guinée-Bissau",
		"GY": "Guyana",
		"HT": "Haïti",
		"HM": "Îles Heard-et-MacDonald",
		"VA": "Saint-Siège",
		"HN": "Honduras",
		"HK": "Hong Kong",
		"HU": "Hongrie",
		"IS": "Islande",
		"IN": "Inde",
		"ID": "Indonésie",
		"IR": "Iran",
		"IQ": "Irak",
		"IE": "Irlande",
		"IL": "Israël",
		"IT": "Italie",
		"JM": "Jamaïque",
		"JP": "Japon",
		"JO": "Jordanie",
		"KZ": "Kazakhstan",
		"KE": "Kenya",
		"KI": "Kiribati",
		"KP": "Corée du Nord, République populaire démocratique",
		"KR": "Corée du Sud, République",
		"KW": "Koweit",
		"KG": "Kirghistan",
		"LA": "Laos",
		"LV": "Lettonie",
		"LB": "Liban",
		"LS": "Lesotho",
		"LR": "Libéria",
		"LY": "Libye",
		"LI": "Liechtenstein",
		"LT": "Lituanie",
		"LU": "Luxembourg, Grand-Duché",
		"MO": "Macao",
		"MK": "Macédoine, Ex-République yougoslave",
		"MG": "Madagascar",
		"MW": "Malawi",
		"MY": "Malaisie",
		"MV": "Maldives",
		"ML": "Mali",
		"MT": "Malte",
		"MH": "Îles Marshall",
		"MQ": "Martinique",
		"MR": "Mauritanie",
		"MU": "Maurice",
		"YT": "Mayotte",
		"MX": "Mexique",
		"FM": "Micronésie",
		"MD": "Moldavie",
		"MC": "Monaco",
		"MN": "Mongolie",
		"MS": "Montserrat",
		"MA": "Maroc",
		"MZ": "Mozambique",
		"MM": "Myanmar",
		"NA": "Namibie",
		"NR": "Nauru",
		"NP": "Népal",
		"NL": "Pays-Bas",
		"NC": "Nouvelle-Calédonie",
		"NZ": "Nouvelle-Zélande",
		"NI": "Nicaragua",
		"NE": "Niger",
		"NG": "Nigéria",
		"NU": "Niué",
		"NF": "Île Norfolk",
		"MP": "Mariannes du Nord",
		"NO": "Norvège",
		"OM": "Oman",
		"PK": "Pakistan",
		"PW": "Palau",
		"PS": "Palestine",
		"PA": "Panama",
		"PG": "Papouasie-Nouvelle-Guinée",
		"PY": "Paraguay",
		"PE": "Pérou",
		"PH": "Philippines",
		"PN": "Pitcairn",
		"PL": "Pologne",
		"PT": "Portugal",
		"PR": "Porto Rico",
		"QA": "Qatar",
		"RE": "Réunion",
		"RO": "Roumanie",
		"RU": "Russie",
		"RW": "Rwanda",
		"SH": "Sainte-Hélène",
		"KN": "Saint-Christophe-et-Niévès",
		"LC": "Sainte-Lucie",
		"PM": "Saint Pierre and Miquelon",
		"VC": "Saint-Vincent et les Grenadines",
		"WS": "Samoa",
		"SM": "Saint-Marin",
		"ST": "São Tomé et Principe",
		"SA": "Arabie Saoudite",
		"SN": "Sénégal",
		"SC": "Seychelles",
		"SL": "Sierra Leone",
		"SG": "Singapour",
		"SK": "Slovaquie",
		"SI": "Slovénie",
		"SB": "Salomon",
		"SO": "Somalie",
		"ZA": "Afrique du Sud",
		"GS": "Géorgie du Sud-et-les Îles Sandwich du Sud",
		"ES": "Espagne",
		"LK": "Sri Lanka",
		"SD": "Soudan",
		"SR": "Suriname",
		"SJ": "Svalbard et Île Jan Mayen",
		"SZ": "Ngwane, Royaume du Swaziland",
		"SE": "Suède",
		"CH": "Suisse",
		"SY": "Syrie",
		"TW": "Taïwan",
		"TJ": "Tadjikistan",
		"TZ": "Tanzanie, République unie",
		"TH": "Thaïlande",
		"TL": "Timor Leste",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad et Tobago",
		"TN": "Tunisie",
		"TR": "Turquie",
		"TM": "Turkménistan",
		"TC": "Îles Turques-et-Caïques",
		"TV": "Tuvalu",
		"UG": "Ouganda",
		"UA": "Ukraine",
		"AE": "Émirats arabes unis",
		"GB": "Royaume-Uni",
		"US": "États-Unis",
		"UM": "États-Unis d'Amérique",
		"UY": "Uruguay",
		"UZ": "Ouzbékistan",
		"VU": "Vanuatu",
		"VE": "Venezuela",
		"VN": "Vietnam",
		"VG": "Îles vierges britanniques",
		"VI": "Îles vierges américaines",
		"WF": "Wallis et Futuna",
		"EH": "Sahara occidental",
		"YE": "Yémen",
		"ZM": "Zambie",
		"ZW": "Zimbabwe",
		"AX": "Åland",
		"BQ": "Bonaire, Saint-Eustache et Saba",
		"CW": "Curaçao",
		"GG": "Guernesey",
		"IM": "Île de Man",
		"JE": "Jersey",
		"ME": "Monténégro",
		"BL": "Saint-Barthélemy",
		"MF": "Saint-Martin (partie française)",
		"RS": "Serbie",
		"SX": "Saint-Martin (partie néerlandaise)",
		"SS": "Sud-Soudan",
		"XK": "Kosovo"
	};

/***/ },
/* 441 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afganisztán",
		"AL": "Albánia",
		"DZ": "Algéria",
		"AS": "Amerikai Szamoa",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarktisz",
		"AG": "Antigua és Barbuda",
		"AR": "Argentína",
		"AM": "Örményország",
		"AW": "Aruba",
		"AU": "Ausztrália",
		"AT": "Ausztria",
		"AZ": "Azerbajdzsán",
		"BS": "Bahama-szigetek",
		"BH": "Bahrein",
		"BD": "Banglades",
		"BB": "Barbados",
		"BY": "Fehéroroszország",
		"BE": "Belgium",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermuda",
		"BT": "Bhután",
		"BO": "Bolívia",
		"BA": "Bosznia-Hercegovina",
		"BW": "Botswana",
		"BV": "Bouvet-sziget",
		"BR": "Brazília",
		"IO": "Brit Indiai-óceáni Terület",
		"BN": "Brunei",
		"BG": "Bulgária",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KH": "Kambodzsa",
		"CM": "Kamerun",
		"CA": "Kanada",
		"CV": "Zöld-foki Köztársaság",
		"KY": "Kajmán-szigetek",
		"CF": "Közép-afrikai Köztársaság",
		"TD": "Csád",
		"CL": "Chile",
		"CN": "Kína",
		"CX": "Karácsony-sziget",
		"CC": "Kókusz (Keeling)-szigetek",
		"CO": "Kolumbia",
		"KM": "Comore-szigetek",
		"CG": "Kongói Köztársaság",
		"CD": "Kongói Demokratikus Köztársaság",
		"CK": "Cook-szigetek",
		"CR": "Costa Rica",
		"CI": "Elefántcsontpart",
		"HR": "Horvátország",
		"CU": "Kuba",
		"CY": "Ciprus",
		"CZ": "Csehország",
		"DK": "Dánia",
		"DJ": "Dzsibuti",
		"DM": "Dominikai Közösség",
		"DO": "Dominikai Köztársaság",
		"EC": "Ecuador",
		"EG": "Egyiptom",
		"SV": "Salvador",
		"GQ": "Egyenlítői-Guinea",
		"ER": "Eritrea",
		"EE": "Észtország",
		"ET": "Etiópia",
		"FK": "Falkland-szigetek",
		"FO": "Feröer",
		"FJ": "Fidzsi-szigetek",
		"FI": "Finnország",
		"FR": "Franciaország",
		"GF": "Francia Guyana",
		"PF": "Francia Polinézia",
		"TF": "Francia déli területek",
		"GA": "Gabon",
		"GM": "Gambia",
		"GE": "Grúzia",
		"DE": "Németország",
		"GH": "Ghána",
		"GI": "Gibraltár",
		"GR": "Görögország",
		"GL": "Grönland",
		"GD": "Grenada",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GN": "Guinea",
		"GW": "Bissau-Guinea",
		"GY": "Guyana",
		"HT": "Haiti",
		"HM": "Heard-sziget és McDonald-szigetek",
		"VA": "Vatikán",
		"HN": "Honduras",
		"HK": "Hong Kong",
		"HU": "Magyarország",
		"IS": "Izland",
		"IN": "India",
		"ID": "Indonézia",
		"IR": "Irán",
		"IQ": "Irak",
		"IE": "Írország",
		"IL": "Izrael",
		"IT": "Olaszország",
		"JM": "Jamaica",
		"JP": "Japán",
		"JO": "Jordánia",
		"KZ": "Kazahsztán",
		"KE": "Kenya",
		"KI": "Kiribati",
		"KP": "Észak-Korea",
		"KR": "Dél-Korea",
		"KW": "Kuvait",
		"KG": "Kirgizisztán",
		"LA": "Laosz",
		"LV": "Lettország",
		"LB": "Libanon",
		"LS": "Lesotho",
		"LR": "Libéria",
		"LY": "Líbia",
		"LI": "Liechtenstein",
		"LT": "Litvánia",
		"LU": "Luxemburg",
		"MO": "Makao",
		"MK": "Macedónia",
		"MG": "Madagaszkár",
		"MW": "Malawi",
		"MY": "Malajzia",
		"MV": "Maldív-szigetek",
		"ML": "Mali",
		"MT": "Málta",
		"MH": "Marshall-szigetek",
		"MQ": "Martinique",
		"MR": "Mauritánia",
		"MU": "Mauritius",
		"YT": "Mayotte",
		"MX": "Mexikó",
		"FM": "Mikronéziai Szövetségi Államok",
		"MD": "Moldova",
		"MC": "Monaco",
		"MN": "Mongólia",
		"MS": "Montserrat",
		"MA": "Marokkó",
		"MZ": "Mozambik",
		"MM": "Mianmar",
		"NA": "Namíbia",
		"NR": "Nauru",
		"NP": "Nepál",
		"NL": "Hollandia",
		"NC": "Új-Kaledónia",
		"NZ": "Új-Zéland",
		"NI": "Nicaragua",
		"NE": "Niger",
		"NG": "Nigéria",
		"NU": "Niue",
		"NF": "Norfolk-sziget",
		"MP": "Északi-Mariana-szigetek",
		"NO": "Norvégia",
		"OM": "Omán",
		"PK": "Pakisztán",
		"PW": "Palau",
		"PS": "Palesztina",
		"PA": "Panama",
		"PG": "Pápua Új-Guinea",
		"PY": "Paraguay",
		"PE": "Peru",
		"PH": "Fülöp-szigetek",
		"PN": "Pitcairn-szigetek",
		"PL": "Lengyelország",
		"PT": "Portugália",
		"PR": "Puerto Rico",
		"QA": "Katar",
		"RE": "Réunion",
		"RO": "Románia",
		"RU": "Oroszország",
		"RW": "Ruanda",
		"SH": "Saint Helena",
		"KN": "Saint Kitts és Nevis",
		"LC": "Saint Lucia",
		"PM": "Saint Pierre and Miquelon",
		"VC": "Saint Vincent és a Grenadine-szigetek",
		"WS": "Szamoa",
		"SM": "San Marino",
		"ST": "São Tomé és Príncipe",
		"SA": "Szaudi-Arábia",
		"SN": "Szenegál",
		"SC": "Seychelle-szigetek",
		"SL": "Sierra Leone",
		"SG": "Szingapúr",
		"SK": "Szlovákia",
		"SI": "Szlovénia",
		"SB": "Salamon-szigetek",
		"SO": "Szomália",
		"ZA": "Dél-Afrika",
		"GS": "Déli-Georgia és Déli-Sandwich-szigetek",
		"ES": "Spanyolország",
		"LK": "Sri Lanka",
		"SD": "Szudán",
		"SR": "Suriname",
		"SJ": "Spitzbergák és Jan Mayen",
		"SZ": "Szváziföld",
		"SE": "Svédország",
		"CH": "Svájc",
		"SY": "Szíria",
		"TW": "Tajvan",
		"TJ": "Tádzsikisztán",
		"TZ": "Tanzánia",
		"TH": "Thaiföld",
		"TL": "Kelet-Timor",
		"TG": "Togo",
		"TK": "Tokelau-szigetek",
		"TO": "Tonga",
		"TT": "Trinidad és Tobago",
		"TN": "Tunézia",
		"TR": "Törökország",
		"TM": "Türkmenisztán",
		"TC": "Turks- és Caicos-szigetek",
		"TV": "Tuvalu",
		"UG": "Uganda",
		"UA": "Ukrajna",
		"AE": "Egyesült Arab Emírségek",
		"GB": "Egyesült Királyság",
		"US": "Amerikai Egyesült Államok",
		"UM": "Az Amerikai Egyesült Államok lakatlan külbirtokai",
		"UY": "Uruguay",
		"UZ": "Üzbegisztán",
		"VU": "Vanuatu",
		"VE": "Venezuela",
		"VN": "Vietnam",
		"VG": "Brit Virgin-szigetek",
		"VI": "Amerikai Virgin-szigetek",
		"WF": "Wallis és Futuna",
		"EH": "Nyugat-Szahara",
		"YE": "Jemen",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"AX": "Åland",
		"BQ": "Karibi Hollandia",
		"CW": "Curaçao",
		"GG": "Guernsey",
		"IM": "Man-sziget",
		"JE": "Jersey",
		"ME": "Montenegró",
		"BL": "Saint Barthélemy",
		"MF": "Szent Márton-sziget (francia rész)",
		"RS": "Szerbia",
		"SX": "Szent Márton-sziget (holland rész)",
		"SS": "Dél-Szudán",
		"XK": "Koszovó"
	};

/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = {
		"AD": "Andorra",
		"AE": "Emirati Arabi Uniti",
		"AF": "Afghanistan",
		"AG": "Antigua e Barbuda",
		"AI": "Anguilla",
		"AL": "Albania",
		"AM": "Armenia",
		"AO": "Angola",
		"AQ": "Antartide",
		"AR": "Argentina",
		"AS": "Samoa Americane",
		"AT": "Austria",
		"AU": "Australia",
		"AW": "Aruba",
		"AX": "Isole Åland",
		"AZ": "Azerbaigian",
		"BA": "Bosnia ed Erzegovina",
		"BB": "Barbados",
		"BD": "Bangladesh",
		"BE": "Belgio",
		"BF": "Burkina Faso",
		"BG": "Bulgaria",
		"BH": "Bahrain",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Saint-Barthélemy",
		"BM": "Bermuda",
		"BN": "Brunei",
		"BO": "Bolivia",
		"BQ": "Isole BES",
		"BR": "Brasile",
		"BS": "Bahamas",
		"BT": "Bhutan",
		"BV": "Isola Bouvet",
		"BW": "Botswana",
		"BY": "Bielorussia",
		"BZ": "Belize",
		"CA": "Canada",
		"CC": "Isole Cocos e Keeling",
		"CD": "Repubblica Democratica del Congo",
		"CF": "Repubblica Centrafricana",
		"CG": "Repubblica del Congo",
		"CH": "Svizzera",
		"CI": "Costa d'Avorio",
		"CK": "Isole Cook",
		"CL": "Cile",
		"CM": "Camerun",
		"CN": "Cina",
		"CO": "Colombia",
		"CR": "Costa Rica",
		"CU": "Cuba",
		"CV": "Capo Verde",
		"CW": "Curaçao",
		"CX": "Isola del Natale",
		"CY": "Cipro",
		"CZ": "Repubblica Ceca",
		"DE": "Germania",
		"DJ": "Gibuti",
		"DK": "Danimarca",
		"DM": "Dominica",
		"DO": "Repubblica Dominicana",
		"DZ": "Algeria",
		"EC": "Ecuador",
		"EE": "Estonia",
		"EG": "Egitto",
		"EH": "Sahara Occidentale",
		"ER": "Eritrea",
		"ES": "Spagna",
		"ET": "Etiopia",
		"FI": "Finlandia",
		"FJ": "Figi",
		"FK": "Isole Falkland",
		"FM": "Stati Federati di Micronesia",
		"FO": "Isole Fær Øer",
		"FR": "Francia",
		"GA": "Gabon",
		"GB": "Regno Unito",
		"GD": "Grenada",
		"GE": "Georgia",
		"GF": "Guyana Francese",
		"GG": "Guernsey",
		"GH": "Ghana",
		"GI": "Gibilterra",
		"GL": "Groenlandia",
		"GM": "Gambia",
		"GN": "Guinea",
		"GP": "Guadalupa",
		"GQ": "Guinea Equatoriale",
		"GR": "Grecia",
		"GS": "Georgia del Sud e isole Sandwich meridionali",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HK": "Hong Kong",
		"HM": "Isole Heard e McDonald",
		"HN": "Honduras",
		"HR": "Croazia",
		"HT": "Haiti",
		"HU": "Ungheria",
		"ID": "Indonesia",
		"IE": "Irlanda",
		"IL": "Israele",
		"IM": "Isola di Man",
		"IN": "India",
		"IO": "Territori Britannici dell'Oceano Indiano",
		"IQ": "Iraq",
		"IR": "Iran",
		"IS": "Islanda",
		"IT": "Italia",
		"JE": "Jersey",
		"JM": "Giamaica",
		"JO": "Giordania",
		"JP": "Giappone",
		"KE": "Kenya",
		"KG": "Kirghizistan",
		"KH": "Cambogia",
		"KI": "Kiribati",
		"KM": "Comore",
		"KN": "Saint Kitts e Nevis",
		"KP": "Corea del Nord",
		"KR": "Corea del Sud",
		"KW": "Kuwait",
		"KY": "Isole Cayman",
		"KZ": "Kazakistan",
		"LA": "Laos",
		"LB": "Libano",
		"LC": "Santa Lucia",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberia",
		"LS": "Lesotho",
		"LT": "Lituania",
		"LU": "Lussemburgo",
		"LV": "Lettonia",
		"LY": "Libia",
		"MA": "Marocco",
		"MC": "Monaco",
		"MD": "Moldavia",
		"ME": "Montenegro",
		"MF": "Saint-Martin",
		"MG": "Madagascar",
		"MH": "Isole Marshall",
		"MK": "Macedonia",
		"ML": "Mali",
		"MM": "Birmania  Myanmar",
		"MN": "Mongolia",
		"MO": "Macao",
		"MP": "Isole Marianne Settentrionali",
		"MQ": "Martinica",
		"MR": "Mauritania",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauritius",
		"MV": "Maldive",
		"MW": "Malawi",
		"MX": "Messico",
		"MY": "Malesia",
		"MZ": "Mozambico",
		"NA": "Namibia",
		"NC": "Nuova Caledonia",
		"NE": "Niger",
		"NF": "Isola Norfolk",
		"NG": "Nigeria",
		"NI": "Nicaragua",
		"NL": "Paesi Bassi",
		"NO": "Norvegia",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "Nuova Zelanda",
		"OM": "Oman",
		"PA": "Panamá",
		"PE": "Perù",
		"PF": "Polinesia Francese",
		"PG": "Papua Nuova Guinea",
		"PH": "Filippine",
		"PK": "Pakistan",
		"PL": "Polonia",
		"PM": "Saint Pierre e Miquelon",
		"PN": "Isole Pitcairn",
		"PR": "Porto Rico",
		"PS": "Stato di Palestina",
		"PT": "Portogallo",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Qatar",
		"RE": "Réunion",
		"RO": "Romania",
		"RS": "Serbia",
		"RU": "Russia",
		"RW": "Ruanda",
		"SA": "Arabia Saudita",
		"SB": "Isole Salomone",
		"SC": "Seychelles",
		"SD": "Sudan",
		"SE": "Svezia",
		"SG": "Singapore",
		"SH": "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
		"SI": "Slovenia",
		"SJ": "Svalbard e Jan Mayen",
		"SK": "Slovacchia",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somalia",
		"SR": "Suriname",
		"SS": "Sudan del Sud",
		"ST": "São Tomé e Príncipe",
		"SV": "El Salvador",
		"SX": "Sint Maarten",
		"SY": "Siria",
		"SZ": "Swaziland",
		"TC": "Isole Turks e Caicos",
		"TD": "Ciad",
		"TF": "Territori Francesi del Sud",
		"TG": "Togo",
		"TH": "Thailandia",
		"TJ": "Tagikistan",
		"TK": "Tokelau",
		"TL": "Timor Est",
		"TM": "Turkmenistan",
		"TN": "Tunisia",
		"TO": "Tonga",
		"TR": "Turchia",
		"TT": "Trinidad e Tobago",
		"TV": "Tuvalu",
		"TW": "Repubblica di Cina",
		"TZ": "Tanzania",
		"UA": "Ucraina",
		"UG": "Uganda",
		"UM": "Isole minori esterne degli Stati Uniti",
		"US": "Stati Uniti d'America",
		"UY": "Uruguay",
		"UZ": "Uzbekistan",
		"VA": "Città del Vaticano",
		"VC": "Saint Vincent e Grenadine",
		"VE": "Venezuela",
		"VG": "Isole Vergini Britanniche",
		"VI": "Isole Vergini Americane",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis e Futuna",
		"WS": "Samoa",
		"YE": "Yemen",
		"YT": "Mayotte",
		"ZA": "Sudafrica",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"XK": "Kosovo"
	};

/***/ },
/* 443 */
/***/ function(module, exports) {

	module.exports = {
		"AD": "Andorra",
		"AE": "De forente arabiske emirater",
		"AF": "Afghanistan",
		"AG": "Antigua og Barbuda",
		"AI": "Anguilla",
		"AL": "Albania",
		"AM": "Armenia",
		"AO": "Angola",
		"AQ": "Antarktis",
		"AR": "Argentina",
		"AS": "Amerikansk Samoa",
		"AT": "Østerrike",
		"AU": "Australia",
		"AW": "Aruba",
		"AX": "Åland",
		"AZ": "Aserbajdsjan",
		"BA": "Bosnia-Hercegovina",
		"BB": "Barbados",
		"BD": "Bangladesh",
		"BE": "Belgia",
		"BF": "Burkina Faso",
		"BG": "Bulgaria",
		"BH": "Bahrain",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Saint-Barthélemy",
		"BM": "Bermuda",
		"BN": "Brunei",
		"BO": "Bolivia",
		"BQ": "Karibisk Nederland",
		"BR": "Brasil",
		"BS": "Bahamas",
		"BT": "Bhutan",
		"BV": "Bouvetøya",
		"BW": "Botswana",
		"BY": "Hviterussland",
		"BZ": "Belize",
		"CA": "Canada",
		"CC": "Kokosøyene",
		"CD": "Kongo",
		"CF": "Den sentralafrikanske republikk",
		"CG": "Kongo-Brazzaville",
		"CH": "Sveits",
		"CI": "Elfenbenskysten",
		"CK": "Cookøyene",
		"CL": "Chile",
		"CM": "Kamerun",
		"CN": "Kina",
		"CO": "Colombia",
		"CR": "Costa Rica",
		"CU": "Cuba",
		"CV": "Kapp Verde",
		"CW": "Curaçao",
		"CX": "Christmasøya",
		"CY": "Kypros",
		"CZ": "Tsjekkia",
		"DE": "Tyskland",
		"DJ": "Djibouti",
		"DK": "Danmark",
		"DM": "Dominica",
		"DO": "Den dominikanske republikk",
		"DZ": "Algerie",
		"EC": "Ecuador",
		"EE": "Estland",
		"EG": "Egypt",
		"EH": "Vest-Sahara",
		"ER": "Eritrea",
		"ES": "Spania",
		"ET": "Etiopia",
		"FI": "Finland",
		"FJ": "Fiji",
		"FK": "Falklandsøyene",
		"FM": "Mikronesiaføderasjonen",
		"FO": "Færøyene",
		"FR": "Frankrike",
		"GA": "Gabon",
		"GB": "Storbritannia",
		"GD": "Grenada",
		"GE": "Georgia",
		"GF": "Fransk Guyana",
		"GG": "Guernsey",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GL": "Grønland",
		"GM": "Gambia",
		"GN": "Guinea",
		"GP": "Guadeloupe",
		"GQ": "Ekvatorial-Guinea",
		"GR": "Hellas",
		"GS": "Sør-Georgia og de søre Sandwichøyene",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HK": "Hongkong",
		"HM": "Heard- og McDonald-øyene",
		"HN": "Honduras",
		"HR": "Kroatia",
		"HT": "Haiti",
		"HU": "Ungarn",
		"ID": "Indonesia",
		"IE": "Irland",
		"IL": "Israel",
		"IM": "Man",
		"IN": "India",
		"IO": "Britisk territorium i Indiahavet",
		"IQ": "Irak",
		"IR": "Iran",
		"IS": "Island",
		"IT": "Italia",
		"JE": "Jersey",
		"JM": "Jamaica",
		"JO": "Jordan",
		"JP": "Japan",
		"KE": "Kenya",
		"KG": "Kirgisistan",
		"KH": "Kambodsja",
		"KI": "Kiribati",
		"KM": "Komorene",
		"KN": "Saint Kitts og Nevis",
		"KP": "Nord-Korea",
		"KR": "Sør-Korea",
		"KW": "Kuwait",
		"KY": "Caymanøyene",
		"KZ": "Kasakhstan",
		"LA": "Laos",
		"LB": "Libanon",
		"LC": "Saint Lucia",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberia",
		"LS": "Lesotho",
		"LT": "Litauen",
		"LU": "Luxembourg",
		"LV": "Latvia",
		"LY": "Libya",
		"MA": "Marokko",
		"MC": "Monaco",
		"MD": "Moldova",
		"ME": "Montenegro",
		"MF": "Saint-Martin",
		"MG": "Madagaskar",
		"MH": "Marshalløyene",
		"MK": "Makedonia",
		"ML": "Mali",
		"MM": "Burma",
		"MN": "Mongolia",
		"MO": "Macao",
		"MP": "Nord-Marianene",
		"MQ": "Martinique",
		"MR": "Mauritania",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauritius",
		"MV": "Maldivene",
		"MW": "Malawi",
		"MX": "Mexico",
		"MY": "Malaysia",
		"MZ": "Mosambik",
		"NA": "Namibia",
		"NC": "Ny-Caledonia",
		"NE": "Niger",
		"NF": "Norfolk Island",
		"NG": "Nigeria",
		"NI": "Nicaragua",
		"NL": "Nederland",
		"NO": "Norge",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "New Zealand",
		"OM": "Oman",
		"PA": "Panama",
		"PE": "Peru",
		"PF": "Fransk Polynesia",
		"PG": "Papua Ny-Guinea",
		"PH": "Filippinene",
		"PK": "Pakistan",
		"PL": "Polen",
		"PM": "Saint-Pierre-et-Miquelon",
		"PN": "Pitcairn",
		"PR": "Puerto Rico",
		"PS": "De okkuperte palestinske områdene",
		"PT": "Portugal",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Qatar",
		"RE": "Réunion",
		"RO": "Romania",
		"RS": "Serbia",
		"RU": "Russland",
		"RW": "Rwanda",
		"SA": "Saudi-Arabia",
		"SB": "Salomonøyene",
		"SC": "Seychellene",
		"SD": "Sudan",
		"SE": "Sverige",
		"SG": "Singapore",
		"SH": "St. Helena",
		"SI": "Slovenia",
		"SJ": "Svalbard og Jan Mayen",
		"SK": "Slovakia",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somalia",
		"SR": "Surinam",
		"SS": "Sør-Sudan",
		"ST": "São Tomé og Príncipe",
		"SV": "El Salvador",
		"SX": "Sint Maarten (Nederlandsk del)",
		"SY": "Syria",
		"SZ": "Swaziland",
		"TC": "Turks- og Caicosøyene",
		"TD": "Tsjad",
		"TF": "Søre franske territorier",
		"TG": "Togo",
		"TH": "Thailand",
		"TJ": "Tadsjikistan",
		"TK": "Tokelau",
		"TL": "Øst-Timor",
		"TM": "Turkmenistan",
		"TN": "Tunisia",
		"TO": "Tonga",
		"TR": "Tyrkia",
		"TT": "Trinidad og Tobago",
		"TV": "Tuvalu",
		"TW": "Taiwan",
		"TZ": "Tanzania",
		"UA": "Ukraina",
		"UG": "Uganda",
		"UM": "USA, mindre, utenforliggende øyer",
		"US": "USA",
		"UY": "Uruguay",
		"UZ": "Usbekistan",
		"VA": "Vatikanstaten",
		"VC": "Saint Vincent og Grenadinene",
		"VE": "Venezuela",
		"VG": "Jomfruøyene (Britisk)",
		"VI": "Jomfruøyene (USA)",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis- og Futunaøyene",
		"WS": "Samoa",
		"YE": "Jemen",
		"YT": "Mayotte",
		"ZA": "Sør-Afrika",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"XK": "Kosovo"
	};

/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afghanistan",
		"AL": "Albanië",
		"DZ": "Algerije",
		"AS": "Amerikaans-Samoa",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarctica",
		"AG": "Antigua en Barbuda",
		"AR": "Argentinië",
		"AM": "Armenië",
		"AW": "Aruba",
		"AU": "Australië",
		"AT": "Oostenrijk",
		"AZ": "Azerbeidzjan",
		"BS": "Bahama's",
		"BH": "Bahrein",
		"BD": "Bangladesh",
		"BB": "Barbados",
		"BY": "Wit-Rusland",
		"BE": "België",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermuda",
		"BT": "Bhutan",
		"BO": "Bolivië",
		"BA": "Bosnië-Herzegovina",
		"BW": "Botswana",
		"BV": "Bouvet Eiland",
		"BR": "Brazilië",
		"IO": "Brits Indische oceaan",
		"BN": "Brunei Darussalam",
		"BG": "Bulgarije",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KH": "Cambodja",
		"CM": "Kameroen",
		"CA": "Canada",
		"CV": "Kaapverdië",
		"KY": "Kaaimaneilanden",
		"CF": "Centraal-Afrikaanse Republiek",
		"TD": "Tsjaad",
		"CL": "Chili",
		"CN": "China",
		"CX": "Christmaseiland",
		"CC": "Cocoseilanden",
		"CO": "Colombia",
		"KM": "Comoren",
		"CG": "Congo, Volksrepubliek",
		"CD": "Congo, Democratische Republiek",
		"CK": "Cookeilanden",
		"CR": "Costa Rica",
		"CI": "Ivoorkust",
		"HR": "Kroatië",
		"CU": "Cuba",
		"CY": "Cyprus",
		"CZ": "Tsjechië",
		"DK": "Denemarken",
		"DJ": "Djibouti",
		"DM": "Dominica",
		"DO": "Dominicaanse Republiek",
		"EC": "Ecuador",
		"EG": "Egypte",
		"SV": "El Salvador",
		"GQ": "Equatoriaal-Guinea",
		"ER": "Eritrea",
		"EE": "Estland",
		"ET": "Ethiopië",
		"FK": "Falklandeilanden",
		"FO": "Faeröer",
		"FJ": "Fiji",
		"FI": "Finland",
		"FR": "Frankrijk",
		"GF": "Frans-Guyana",
		"PF": "Frans-Polynesië",
		"TF": "Franse Zuidelijke Gebieden",
		"GA": "Gabon",
		"GM": "Gambia",
		"GE": "Georgië",
		"DE": "Duitsland",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GR": "Griekenland",
		"GL": "Groenland",
		"GD": "Grenada",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GN": "Guinea",
		"GW": "Guinee-Bissau",
		"GY": "Guyana",
		"HT": "Haïti",
		"HM": "Heard en McDonaldeilanden",
		"VA": "Heilige Stoel",
		"HN": "Honduras",
		"HK": "Hong Kong",
		"HU": "Hongarije",
		"IS": "IJsland",
		"IN": "India",
		"ID": "Indonesia",
		"IR": "Iran",
		"IQ": "Irak",
		"IE": "Ierland",
		"IL": "Israël",
		"IT": "Italië",
		"JM": "Jamaica",
		"JP": "Japan",
		"JO": "Jordanië",
		"KZ": "Kazachstan",
		"KE": "Kenia",
		"KI": "Kiribati",
		"KP": "Noord-Korea, Democratische Volksrepubliek",
		"KR": "Zuid-Korea",
		"KW": "Koeweit",
		"KG": "Kirgizstan",
		"LA": "Laos",
		"LV": "Letland",
		"LB": "Libanon",
		"LS": "Lesotho",
		"LR": "Liberia",
		"LY": "Libië",
		"LI": "Liechtenstein",
		"LT": "Litouwen",
		"LU": "Luxemburg, Groot-Hertogdom",
		"MO": "Macao",
		"MK": "Macedonië, Ex-Joegoslavische Republiek",
		"MG": "Madagaskar",
		"MW": "Malawi",
		"MY": "Maleisië",
		"MV": "Maldiven",
		"ML": "Mali",
		"MT": "Malta",
		"MH": "Marshalleilanden",
		"MQ": "Martinique",
		"MR": "Mauritanië",
		"MU": "Mauritius",
		"YT": "Mayotte",
		"MX": "Mexico",
		"FM": "Micronesië, Federale Staten",
		"MD": "Moldavië",
		"MC": "Monaco",
		"MN": "Mongolië",
		"MS": "Montserrat",
		"MA": "Marokko",
		"MZ": "Mozambique",
		"MM": "Myanmar",
		"NA": "Namibië",
		"NR": "Nauru",
		"NP": "Nepal",
		"NL": "Nederland",
		"NC": "Nieuw-Caledonië",
		"NZ": "Nieuw-Zeeland",
		"NI": "Nicaragua",
		"NE": "Niger",
		"NG": "Nigeria",
		"NU": "Niue",
		"NF": "Norfolk",
		"MP": "Noordelijke Marianen",
		"NO": "Noorwegen",
		"OM": "Oman",
		"PK": "Pakistan",
		"PW": "Palau",
		"PS": "Palestina",
		"PA": "Panama",
		"PG": "Papoea-Nieuw-Guinea",
		"PY": "Paraguay",
		"PE": "Peru",
		"PH": "Filipijnen",
		"PN": "Pitcairn",
		"PL": "Polen",
		"PT": "Portugal",
		"PR": "Puerto Rico",
		"QA": "Qatar",
		"RE": "Réunion",
		"RO": "Roemenië",
		"RU": "Rusland",
		"RW": "Rwanda",
		"SH": "Sint-Helena",
		"KN": "Saint Kitts en Nevis",
		"LC": "Saint Lucia",
		"PM": "Saint-Pierre en Miquelon",
		"VC": "Saint Vincent en de Grenadines",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "São Tomé en Principe",
		"SA": "Saudi-Arabië",
		"SN": "Senegal",
		"SC": "Seychellen",
		"SL": "Sierra Leone",
		"SG": "Singapore",
		"SK": "Slowakije",
		"SI": "Slovenië",
		"SB": "Salomonseilanden",
		"SO": "Somalië",
		"ZA": "Zuid-Afrika",
		"GS": "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
		"ES": "Spanje",
		"LK": "Sri Lanka",
		"SD": "Soedan",
		"SR": "Suriname",
		"SJ": "Spitsbergen en Jan Mayen",
		"SZ": "Ngwane, Koninkrijk Swaziland",
		"SE": "Zweden",
		"CH": "Zwitserland",
		"SY": "Syrië",
		"TW": "Taiwan",
		"TJ": "Tadzjikistan",
		"TZ": "Tanzania, Verenigde Republiek",
		"TH": "Thailand",
		"TL": "Timor Leste",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad en Tobago",
		"TN": "Tunesië",
		"TR": "Turkije",
		"TM": "Turkmenistan",
		"TC": "Turks- en Caicoseilanden",
		"TV": "Tuvalu",
		"UG": "Oeganda",
		"UA": "Oekraïne",
		"AE": "Verenigde Arabische Emiraten",
		"GB": "Verenigd Koninkrijk",
		"US": "Verenigde Staten van Amerika",
		"UM": "Ver afgelegen eilandjes van de Verenigde Staten",
		"UY": "Uruguay",
		"UZ": "Oezbekistan",
		"VU": "Vanuatu",
		"VE": "Venezuela",
		"VN": "Vietnam",
		"VG": "Maagdeneilanden, Britse",
		"VI": "Maagdeneilanden, Amerikaanse",
		"WF": "Wallis en Futuna",
		"EH": "Westelijke Sahara",
		"YE": "Jemen",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"AX": "Åland",
		"BQ": "Bonaire, Sint Eustatius en Saba",
		"CW": "Curaçao",
		"GG": "Guernsey",
		"IM": "Eiland Man",
		"JE": "Jersey",
		"ME": "Montenegro",
		"BL": "Saint Barthélemy",
		"MF": "Sint-Maarten (Frans deel)",
		"RS": "Servië",
		"SX": "Sint Maarten (Nederlands deel)",
		"SS": "Zuid-Soedan",
		"XK": "Kosovo"
	};

/***/ },
/* 445 */
/***/ function(module, exports) {

	module.exports = {
		"AD": "Andorra",
		"AE": "Dei sameinte arabiske emirata",
		"AF": "Afghanistan",
		"AG": "Antigua og Barbuda",
		"AI": "Anguilla",
		"AL": "Albania",
		"AM": "Armenia",
		"AO": "Angola",
		"AQ": "Antarktis",
		"AR": "Argentina",
		"AS": "Amerikansk Samoa",
		"AT": "Austerrike",
		"AU": "Australia",
		"AW": "Aruba",
		"AX": "Åland",
		"AZ": "Aserbajdsjan",
		"BA": "Bosnia-Hercegovina",
		"BB": "Barbados",
		"BD": "Bangladesh",
		"BE": "Belgia",
		"BF": "Burkina Faso",
		"BG": "Bulgaria",
		"BH": "Bahrain",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Saint-Barthélemy",
		"BM": "Bermuda",
		"BN": "Brunei",
		"BO": "Bolivia",
		"BQ": "Karibisk Nederland",
		"BR": "Brasil",
		"BS": "Bahamas",
		"BT": "Bhutan",
		"BV": "Bouvetøya",
		"BW": "Botswana",
		"BY": "Kviterussland",
		"BZ": "Belize",
		"CA": "Canada",
		"CC": "Kokosøyane",
		"CD": "Kongo",
		"CF": "Den sentralafrikanske republikken",
		"CG": "Kongo-Brazzaville",
		"CH": "Sveits",
		"CI": "Elfenbeinskysten",
		"CK": "Cookøyane",
		"CL": "Chile",
		"CM": "Kamerun",
		"CN": "Kina",
		"CO": "Colombia",
		"CR": "Costa Rica",
		"CU": "Cuba",
		"CV": "Kapp Verde",
		"CW": "Curaçao",
		"CX": "Christmasøya",
		"CY": "Kypros",
		"CZ": "Tsjekkia",
		"DE": "Tyskland",
		"DJ": "Djibouti",
		"DK": "Danmark",
		"DM": "Dominica",
		"DO": "Den dominikanske republikken",
		"DZ": "Algerie",
		"EC": "Ecuador",
		"EE": "Estland",
		"EG": "Egypt",
		"EH": "Vest-Sahara",
		"ER": "Eritrea",
		"ES": "Spania",
		"ET": "Etiopia",
		"FI": "Finland",
		"FJ": "Fiji",
		"FK": "Falklandsøyane",
		"FM": "Mikronesiaføderasjonen",
		"FO": "Færøyane",
		"FR": "Frankrike",
		"GA": "Gabon",
		"GB": "Storbritannia",
		"GD": "Grenada",
		"GE": "Georgia",
		"GF": "Fransk Guyana",
		"GG": "Guernsey",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GL": "Grønland",
		"GM": "Gambia",
		"GN": "Guinea",
		"GP": "Guadeloupe",
		"GQ": "Ekvatorial-Guinea",
		"GR": "Hellas",
		"GS": "Sør-Georgia og de søre Sandwichøyane",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HK": "Hongkong",
		"HM": "Heard- og McDonald-øyane",
		"HN": "Honduras",
		"HR": "Kroatia",
		"HT": "Haiti",
		"HU": "Ungarn",
		"ID": "Indonesia",
		"IE": "Irland",
		"IL": "Israel",
		"IM": "Man",
		"IN": "India",
		"IO": "Britisk territorium i Indiahavet",
		"IQ": "Irak",
		"IR": "Iran",
		"IS": "Island",
		"IT": "Italia",
		"JE": "Jersey",
		"JM": "Jamaica",
		"JO": "Jordan",
		"JP": "Japan",
		"KE": "Kenya",
		"KG": "Kirgisistan",
		"KH": "Kambodsja",
		"KI": "Kiribati",
		"KM": "Komorane",
		"KN": "Saint Kitts og Nevis",
		"KP": "Nord-Korea",
		"KR": "Sør-Korea",
		"KW": "Kuwait",
		"KY": "Caymanøyane",
		"KZ": "Kasakhstan",
		"LA": "Laos",
		"LB": "Libanon",
		"LC": "Saint Lucia",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberia",
		"LS": "Lesotho",
		"LT": "Litauen",
		"LU": "Luxembourg",
		"LV": "Latvia",
		"LY": "Libya",
		"MA": "Marokko",
		"MC": "Monaco",
		"MD": "Moldova",
		"ME": "Montenegro",
		"MF": "Saint-Martin",
		"MG": "Madagaskar",
		"MH": "Marshalløyane",
		"MK": "Makedonia",
		"ML": "Mali",
		"MM": "Burma",
		"MN": "Mongolia",
		"MO": "Macao",
		"MP": "Nord-Marianane",
		"MQ": "Martinique",
		"MR": "Mauritania",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauritius",
		"MV": "Maldivane",
		"MW": "Malawi",
		"MX": "Mexico",
		"MY": "Malaysia",
		"MZ": "Mosambik",
		"NA": "Namibia",
		"NC": "Ny-Caledonia",
		"NE": "Niger",
		"NF": "Norfolk Island",
		"NG": "Nigeria",
		"NI": "Nicaragua",
		"NL": "Nederland",
		"NO": "Noreg",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "New Zealand",
		"OM": "Oman",
		"PA": "Panama",
		"PE": "Peru",
		"PF": "Fransk Polynesia",
		"PG": "Papua Ny-Guinea",
		"PH": "Filippinane",
		"PK": "Pakistan",
		"PL": "Polen",
		"PM": "Saint-Pierre-et-Miquelon",
		"PN": "Pitcairn",
		"PR": "Puerto Rico",
		"PS": "Dei okkuperte palestinske områda",
		"PT": "Portugal",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Qatar",
		"RE": "Réunion",
		"RO": "Romania",
		"RS": "Serbia",
		"RU": "Russland",
		"RW": "Rwanda",
		"SA": "Saudi-Arabia",
		"SB": "Salomonøyane",
		"SC": "Seychellane",
		"SD": "Sudan",
		"SE": "Sverige",
		"SG": "Singapore",
		"SH": "St. Helena",
		"SI": "Slovenia",
		"SJ": "Svalbard og Jan Mayen",
		"SK": "Slovakia",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somalia",
		"SR": "Surinam",
		"SS": "Sør-Sudan",
		"ST": "São Tomé og Príncipe",
		"SV": "El Salvador",
		"SX": "Sint Maarten (Nederlandsk del)",
		"SY": "Syria",
		"SZ": "Swaziland",
		"TC": "Turks- og Caicosøyane",
		"TD": "Tsjad",
		"TF": "Søre franske territorier",
		"TG": "Togo",
		"TH": "Thailand",
		"TJ": "Tadsjikistan",
		"TK": "Tokelau",
		"TL": "Aust-Timor",
		"TM": "Turkmenistan",
		"TN": "Tunisia",
		"TO": "Tonga",
		"TR": "Tyrkia",
		"TT": "Trinidad og Tobago",
		"TV": "Tuvalu",
		"TW": "Taiwan",
		"TZ": "Tanzania",
		"UA": "Ukraina",
		"UG": "Uganda",
		"UM": "USA, mindre, utanforliggande øyar",
		"US": "USA",
		"UY": "Uruguay",
		"UZ": "Usbekistan",
		"VA": "Vatikanstaten",
		"VC": "Saint Vincent og Grenadinane",
		"VE": "Venezuela",
		"VG": "Jomfruøyane (Britisk)",
		"VI": "Jomfruøyane (USA)",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis- og Futunaøyane",
		"WS": "Samoa",
		"YE": "Jemen",
		"YT": "Mayotte",
		"ZA": "Sør-Afrika",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"XK": "Kosovo"
	};

/***/ },
/* 446 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afganistan",
		"AL": "Albania",
		"DZ": "Algieria",
		"AS": "Samoa Amerykańskie",
		"AD": "Andora",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarktyka",
		"AG": "Antigua i Barbuda",
		"AR": "Argentyna",
		"AM": "Armenia",
		"AW": "Aruba",
		"AU": "Australia",
		"AT": "Austria",
		"AZ": "Azerbejdżan",
		"BS": "Bahamy",
		"BH": "Bahrajn",
		"BD": "Bangladesz",
		"BB": "Barbados",
		"BY": "Białoruś",
		"BE": "Belgia",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermudy",
		"BT": "Bhutan",
		"BO": "Boliwia",
		"BA": "Bośnia i Hercegowina",
		"BW": "Botswana",
		"BV": "Wyspa Bouveta",
		"BR": "Brazylia",
		"IO": "Brytyjskie Terytorium Oceanu Indyjskiego",
		"BN": "Brunei",
		"BG": "Bułgaria",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KH": "Kambodża",
		"CM": "Kamerun",
		"CA": "Kanada",
		"CV": "Republika Zielonego Przylądka",
		"KY": "Kajmany",
		"CF": "Republika Środkowoafrykańska",
		"TD": "Czad",
		"CL": "Chile",
		"CN": "Chiny",
		"CX": "Wyspa Bożego Narodzenia",
		"CC": "Wyspy Kokosowe",
		"CO": "Kolumbia",
		"KM": "Komory",
		"CG": "Kongo",
		"CD": "Demokratyczna Republika Konga",
		"CK": "Wyspy Cooka",
		"CR": "Kostaryka",
		"CI": "Wybrzeże Kości Słoniowej",
		"HR": "Chorwacja",
		"CU": "Kuba",
		"CY": "Cypr",
		"CZ": "Czechy",
		"DK": "Dania",
		"DJ": "Dżibuti",
		"DM": "Dominika",
		"DO": "Dominikana",
		"EC": "Ekwador",
		"EG": "Egipt",
		"SV": "Salwador",
		"GQ": "Gwinea Równikowa",
		"ER": "Erytrea",
		"EE": "Estonia",
		"ET": "Etiopia",
		"FK": "Falklandy",
		"FO": "Wyspy Owcze",
		"FJ": "Fidżi",
		"FI": "Finlandia",
		"FR": "Francja",
		"GF": "Gujana Francuska",
		"PF": "Polinezja Francuska",
		"TF": "Francuskie Terytoria Południowe i Antarktyczne",
		"GA": "Gabon",
		"GM": "Gambia",
		"GE": "Gruzja",
		"DE": "Niemcy",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GR": "Grecja",
		"GL": "Grenlandia",
		"GD": "Grenada",
		"GP": "Gwadelupa",
		"GU": "Guam",
		"GT": "Gwatemala",
		"GN": "Gwinea",
		"GW": "Gwinea Bissau",
		"GY": "Gujana",
		"HT": "Haiti",
		"HM": "Wyspy Heard i McDonalda",
		"VA": "Watykan",
		"HN": "Honduras",
		"HK": "Hongkong",
		"HU": "Węgry",
		"IS": "Islandia",
		"IN": "Indie",
		"ID": "Indonezja",
		"IR": "Iran",
		"IQ": "Irak",
		"IE": "Irlandia",
		"IL": "Izrael",
		"IT": "Włochy",
		"JM": "Jamajka",
		"JP": "Japonia",
		"JO": "Jordania",
		"KZ": "Kazachstan",
		"KE": "Kenia",
		"KI": "Kiribati",
		"KP": "Korea Północna",
		"KR": "Korea Południowa",
		"KW": "Kuwejt",
		"KG": "Kirgistan",
		"LA": "Laos",
		"LV": "Łotwa",
		"LB": "Liban",
		"LS": "Lesotho",
		"LR": "Liberia",
		"LY": "Libia",
		"LI": "Liechtenstein",
		"LT": "Litwa",
		"LU": "Luksemburg",
		"MO": "Makau",
		"MK": "Macedonia",
		"MG": "Madagaskar",
		"MW": "Malawi",
		"MY": "Malezja",
		"MV": "Malediwy",
		"ML": "Mali",
		"MT": "Malta",
		"MH": "Wyspy Marshalla",
		"MQ": "Martynika",
		"MR": "Mauretania",
		"MU": "Mauritius",
		"YT": "Majotta",
		"MX": "Meksyk",
		"FM": "Mikronezja",
		"MD": "Mołdawia",
		"MC": "Monako",
		"MN": "Mongolia",
		"MS": "Montserrat",
		"MA": "Maroko",
		"MZ": "Mozambik",
		"MM": "Mjanma",
		"NA": "Namibia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NL": "Holandia",
		"NC": "Nowa Kaledonia",
		"NZ": "Nowa Zelandia",
		"NI": "Nikaragua",
		"NE": "Niger",
		"NG": "Nigeria",
		"NU": "Niue",
		"NF": "Norfolk",
		"MP": "Mariany Północne",
		"NO": "Norwegia",
		"OM": "Oman",
		"PK": "Pakistan",
		"PW": "Palau",
		"PS": "Palestyna",
		"PA": "Panama",
		"PG": "Papua-Nowa Gwinea",
		"PY": "Paragwaj",
		"PE": "Peru",
		"PH": "Filipiny",
		"PN": "Pitcairn",
		"PL": "Polska",
		"PT": "Portugalia",
		"PR": "Portoryko",
		"QA": "Katar",
		"RE": "Reunion",
		"RO": "Rumunia",
		"RU": "Rosja",
		"RW": "Rwanda",
		"SH": "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
		"KN": "Saint Kitts i Nevis",
		"LC": "Saint Lucia",
		"PM": "Saint-Pierre i Miquelon",
		"VC": "Saint Vincent i Grenadyny",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "Wyspy Świętego Tomasza i Książęca",
		"SA": "Arabia Saudyjska",
		"SN": "Senegal",
		"SC": "Seszele",
		"SL": "Sierra Leone",
		"SG": "Singapur",
		"SK": "Słowacja",
		"SI": "Słowenia",
		"SB": "Wyspy Salomona",
		"SO": "Somalia",
		"ZA": "Południowa Afryka",
		"GS": "Georgia Południowa i Sandwich Południowy",
		"ES": "Hiszpania",
		"LK": "Sri Lanka",
		"SD": "Sudan",
		"SR": "Surinam",
		"SJ": "Svalbard i Jan Mayen",
		"SZ": "Suazi",
		"SE": "Szwecja",
		"CH": "Szwajcaria",
		"SY": "Syria",
		"TW": "Tajwan",
		"TJ": "Tadżykistan",
		"TZ": "Tanzania",
		"TH": "Tajlandia",
		"TL": "Timor Wschodni",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trynidad i Tobago",
		"TN": "Tunezja",
		"TR": "Turcja",
		"TM": "Turkmenistan",
		"TC": "Turks i Caicos",
		"TV": "Tuvalu",
		"UG": "Uganda",
		"UA": "Ukraina",
		"AE": "Zjednoczone Emiraty Arabskie",
		"GB": "Wielka Brytania",
		"US": "Stany Zjednoczone",
		"UM": "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
		"UY": "Urugwaj",
		"UZ": "Uzbekistan",
		"VU": "Vanuatu",
		"VE": "Wenezuela",
		"VN": "Wietnam",
		"VG": "Brytyjskie Wyspy Dziewicze",
		"VI": "Wyspy Dziewicze Stanów Zjednoczonych",
		"WF": "Wallis i Futuna",
		"EH": "Sahara Zachodnia",
		"YE": "Jemen",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"AX": "Wyspy Alandzkie",
		"BQ": "Bonaire, Sint Eustatius i Saba",
		"CW": "Curaçao",
		"GG": "Guernsey",
		"IM": "Wyspa Man",
		"JE": "Jersey",
		"ME": "Czarnogóra",
		"BL": "Saint-Barthélemy",
		"MF": "Saint-Martin",
		"RS": "Serbia",
		"SX": "Sint Maarten",
		"SS": "Sudan Południowy",
		"XK": "Kosowo"
	};

/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = {
		"AF": "Afeganistão",
		"ZA": "África do Sul",
		"AL": "Albânia",
		"DE": "Alemanha",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antártida",
		"AG": "Antígua e Barbuda",
		"SA": "Arábia Saudita",
		"DZ": "Argélia",
		"AR": "Argentina",
		"AM": "Armênia",
		"AW": "Aruba",
		"AU": "Austrália",
		"AT": "Áustria",
		"AZ": "Azerbaijão",
		"BS": "Bahamas",
		"BH": "Bahrein",
		"BD": "Bangladesh",
		"BB": "Barbados",
		"BE": "Bélgica",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermudas",
		"BY": "Bielorrússia",
		"BO": "Bolívia",
		"BA": "Bósnia e Herzegovina",
		"BW": "Botsuana",
		"BR": "Brasil",
		"BN": "Brunei",
		"BG": "Bulgária",
		"BF": "Burquina Faso",
		"BI": "Burundi",
		"BT": "Butão",
		"CV": "Cabo Verde",
		"KH": "Camboja",
		"CA": "Canadá",
		"QA": "Catar",
		"KZ": "Cazaquistão",
		"TD": "Chade",
		"CL": "Chile",
		"CN": "China",
		"CY": "Chipre",
		"VA": "Cidade do Vaticano",
		"SG": "Cingapura",
		"CO": "Colômbia",
		"KM": "Comores",
		"CG": "Congo - Brazzaville",
		"CD": "Congo - Kinshasa",
		"KP": "Coreia do Norte",
		"KR": "Coreia do Sul",
		"CI": "Costa do Marfim",
		"CR": "Costa Rica",
		"HR": "Croácia",
		"CU": "Cuba",
		"CW": "Curaçao",
		"DK": "Dinamarca",
		"DJ": "Djibuti",
		"DM": "Dominica",
		"EG": "Egito",
		"SV": "El Salvador",
		"AE": "Emirados Árabes Unidos",
		"EC": "Equador",
		"ER": "Eritreia",
		"SK": "Eslováquia",
		"SI": "Eslovênia",
		"ES": "Espanha",
		"US": "Estados Unidos",
		"EE": "Estônia",
		"ET": "Etiópia",
		"FJ": "Fiji",
		"PH": "Filipinas",
		"FI": "Finlândia",
		"FR": "França",
		"GA": "Gabão",
		"GM": "Gâmbia",
		"GH": "Gana",
		"GE": "Geórgia",
		"GS": "Geórgia do Sul e Ilhas Sandwich do Sul",
		"GI": "Gibraltar",
		"GD": "Granada",
		"GR": "Grécia",
		"GL": "Groenlândia",
		"GP": "Guadalupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GG": "Guernsey",
		"GY": "Guiana",
		"GF": "Guiana Francesa",
		"GN": "Guiné",
		"GW": "Guiné Bissau",
		"GQ": "Guiné Equatorial",
		"HT": "Haiti",
		"NL": "Holanda",
		"HN": "Honduras",
		"HK": "Hong Kong, RAE da China",
		"HU": "Hungria",
		"YE": "Iêmen",
		"BV": "Ilhas Bouvet",
		"CX": "Ilha Christmas",
		"IM": "Ilha de Man",
		"NF": "Ilha Norfolk",
		"AX": "Ilhas Åland",
		"KY": "Ilhas Caiman",
		"CC": "Ilhas Cocos (Keeling)",
		"CK": "Ilhas Cook",
		"UM": "Ilhas Distantes dos EUA",
		"HM": "Ilha Heard e Ilha McDonald",
		"FO": "Ilhas Faroe",
		"FK": "Ilhas Malvinas",
		"MP": "Ilhas Marianas do Norte",
		"MH": "Ilhas Marshall",
		"PN": "Ilhas Pitcairn",
		"SB": "Ilhas Salomão",
		"TC": "Ilhas Turks e Caicos",
		"VG": "Ilhas Virgens Britânicas",
		"VI": "Ilhas Virgens dos EUA",
		"IN": "Índia",
		"ID": "Indonésia",
		"IR": "Irã",
		"IQ": "Iraque",
		"IE": "Irlanda",
		"IS": "Islândia",
		"IL": "Israel",
		"IT": "Itália",
		"JM": "Jamaica",
		"JP": "Japão",
		"JE": "Jersey",
		"JO": "Jordânia",
		"KW": "Kuwait",
		"LA": "Laos",
		"LS": "Lesoto",
		"LV": "Letônia",
		"LB": "Líbano",
		"LR": "Libéria",
		"LY": "Líbia",
		"LI": "Liechtenstein",
		"LT": "Lituânia",
		"LU": "Luxemburgo",
		"MO": "Macau, RAE da China",
		"MK": "Macedônia",
		"MG": "Madagascar",
		"MY": "Malásia",
		"MW": "Malawi",
		"MV": "Maldivas",
		"ML": "Mali",
		"MT": "Malta",
		"MA": "Marrocos",
		"MQ": "Martinica",
		"MU": "Maurício",
		"MR": "Mauritânia",
		"YT": "Mayotte",
		"MX": "México",
		"MM": "Mianmar (Birmânia)",
		"FM": "Micronésia",
		"MZ": "Moçambique",
		"MD": "Moldávia",
		"MC": "Mônaco",
		"MN": "Mongólia",
		"ME": "Montenegro",
		"MS": "Montserrat",
		"NA": "Namíbia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NI": "Nicarágua",
		"NE": "Níger",
		"NG": "Nigéria",
		"NU": "Niue",
		"NO": "Noruega",
		"NC": "Nova Caledônia",
		"NZ": "Nova Zelândia",
		"OM": "Omã",
		"BQ": "Países Baixos Caribenhos",
		"PW": "Palau",
		"PA": "Panamá",
		"PG": "Papua-Nova Guiné",
		"PK": "Paquistão",
		"PY": "Paraguai",
		"PE": "Peru",
		"PF": "Polinésia Francesa",
		"PL": "Polônia",
		"PR": "Porto Rico",
		"PT": "Portugal",
		"KE": "Quênia",
		"KG": "Quirguistão",
		"KI": "Quiribati",
		"GB": "Reino Unido",
		"CF": "República Centro-Africana",
		"DO": "República Dominicana",
		"CM": "República dos Camarões",
		"CZ": "República Tcheca",
		"RE": "Reunião",
		"RO": "Romênia",
		"RW": "Ruanda",
		"RU": "Rússia",
		"EH": "Saara Ocidental",
		"PM": "Saint Pierre e Miquelon",
		"WS": "Samoa",
		"AS": "Samoa Americana",
		"SM": "San Marino",
		"SH": "Santa Helena",
		"LC": "Santa Lúcia",
		"BL": "São Bartolomeu",
		"KN": "São Cristóvão e Nevis",
		"MF": "São Martinho",
		"ST": "São Tomé e Príncipe",
		"VC": "São Vicente e Granadinas",
		"SN": "Senegal",
		"SL": "Serra Leoa",
		"RS": "Sérvia",
		"SC": "Seychelles",
		"SX": "Sint Maarten",
		"SY": "Síria",
		"SO": "Somália",
		"LK": "Sri Lanka",
		"SZ": "Suazilândia",
		"SD": "Sudão",
		"SS": "Sudão do Sul",
		"SE": "Suécia",
		"CH": "Suíça",
		"SR": "Suriname",
		"SJ": "Svalbard e Jan Mayen",
		"TH": "Tailândia",
		"TW": "Taiwan",
		"TJ": "Tajiquistão",
		"TZ": "Tanzânia",
		"IO": "Território Britânico do Oceano Índico",
		"TF": "Territórios Franceses do Sul",
		"PS": "Territórios palestinos",
		"TL": "Timor-Leste",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad e Tobago",
		"TN": "Tunísia",
		"TM": "Turcomenistão",
		"TR": "Turquia",
		"TV": "Tuvalu",
		"UA": "Ucrânia",
		"UG": "Uganda",
		"UY": "Uruguai",
		"UZ": "Uzbequistão",
		"VU": "Vanuatu",
		"VE": "Venezuela",
		"VN": "Vietnã",
		"WF": "Wallis e Futuna",
		"ZM": "Zâmbia",
		"ZW": "Zimbábue",
		"XK": "Kosovo"
	};

/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = {
		"AU": "Австралия",
		"AT": "Австрия",
		"AZ": "Азербайджан",
		"AX": "Аландские острова",
		"AL": "Албания",
		"DZ": "Алжир",
		"VI": "Виргинские Острова (США)",
		"AS": "Американское Самоа",
		"AI": "Ангилья",
		"AO": "Ангола",
		"AD": "Андорра",
		"AQ": "Антарктида",
		"AG": "Антигуа и Барбуда",
		"AR": "Аргентина",
		"AM": "Армения",
		"AW": "Аруба",
		"AF": "Афганистан",
		"BS": "Багамы",
		"BD": "Бангладеш",
		"BB": "Барбадос",
		"BH": "Бахрейн",
		"BZ": "Белиз",
		"BY": "Белоруссия",
		"BE": "Бельгия",
		"BJ": "Бенин",
		"BM": "Бермуды",
		"BG": "Болгария",
		"BO": "Боливия",
		"BQ": "Бонэйр, Синт-Эстатиус и Саба",
		"BA": "Босния и Герцеговина",
		"BW": "Ботсвана",
		"BR": "Бразилия",
		"IO": "Британская территория в Индийском океане",
		"VG": "Виргинские Острова (Великобритания)",
		"BN": "Бруней",
		"BF": "Буркина-Фасо",
		"BI": "Бурунди",
		"BT": "Бутан",
		"VU": "Вануату",
		"VA": "Ватикан",
		"GB": "Великобритания",
		"HU": "Венгрия",
		"VE": "Венесуэла",
		"UM": "Внешние малые острова (США)",
		"TL": "Восточный Тимор",
		"VN": "Вьетнам",
		"GA": "Габон",
		"HT": "Гаити",
		"GY": "Гайана",
		"GM": "Гамбия",
		"GH": "Гана",
		"GP": "Гваделупа",
		"GT": "Гватемала",
		"GF": "Гвиана",
		"GN": "Гвинея",
		"GW": "Гвинея-Бисау",
		"DE": "Германия",
		"GG": "Гернси",
		"GI": "Гибралтар",
		"HN": "Гондурас",
		"HK": "Гонконг",
		"GD": "Гренада",
		"GL": "Гренландия",
		"GR": "Греция",
		"GE": "Грузия",
		"GU": "Гуам",
		"DK": "Дания",
		"JE": "Джерси",
		"DJ": "Джибути",
		"DM": "Доминика",
		"DO": "Доминиканская Республика",
		"CD": "Демократическая Республика Конго",
		"EG": "Египет",
		"ZM": "Замбия",
		"EH": "САДР",
		"ZW": "Зимбабве",
		"IL": "Израиль",
		"IN": "Индия",
		"ID": "Индонезия",
		"JO": "Иордания",
		"IQ": "Ирак",
		"IR": "Иран",
		"IE": "Ирландия",
		"IS": "Исландия",
		"ES": "Испания",
		"IT": "Италия",
		"YE": "Йемен",
		"CV": "Кабо-Верде",
		"KZ": "Казахстан",
		"KY": "Острова Кайман",
		"KH": "Камбоджа",
		"CM": "Камерун",
		"CA": "Канада",
		"QA": "Катар",
		"KE": "Кения",
		"CY": "Кипр",
		"KG": "Киргизия",
		"KI": "Кирибати",
		"TW": "Китайская Республика",
		"KP": "КНДР (Корейская Народно-Демократическая Республика)",
		"CN": "КНР (Китайская Народная Республика)",
		"CC": "Кокосовые острова",
		"CO": "Колумбия",
		"KM": "Коморы",
		"CR": "Коста-Рика",
		"CI": "Кот-д’Ивуар",
		"CU": "Куба",
		"KW": "Кувейт",
		"CW": "Кюрасао",
		"LA": "Лаос",
		"LV": "Латвия",
		"LS": "Лесото",
		"LR": "Либерия",
		"LB": "Ливан",
		"LY": "Ливия",
		"LT": "Литва",
		"LI": "Лихтенштейн",
		"LU": "Люксембург",
		"MU": "Маврикий",
		"MR": "Мавритания",
		"MG": "Мадагаскар",
		"YT": "Майотта",
		"MO": "Макао",
		"MK": "Македония",
		"MW": "Малави",
		"MY": "Малайзия",
		"ML": "Мали",
		"MV": "Мальдивы",
		"MT": "Мальта",
		"MA": "Марокко",
		"MQ": "Мартиника",
		"MH": "Маршалловы Острова",
		"MX": "Мексика",
		"FM": "Микронезия",
		"MZ": "Мозамбик",
		"MD": "Молдавия",
		"MC": "Монако",
		"MN": "Монголия",
		"MS": "Монтсеррат",
		"MM": "Мьянма",
		"NA": "Намибия",
		"NR": "Науру",
		"NP": "Непал",
		"NE": "Нигер",
		"NG": "Нигерия",
		"NL": "Нидерланды",
		"NI": "Никарагуа",
		"NU": "Ниуэ",
		"NZ": "Новая Зеландия",
		"NC": "Новая Каледония",
		"NO": "Норвегия",
		"AE": "ОАЭ",
		"OM": "Оман",
		"BV": "Остров Буве",
		"IM": "Остров Мэн",
		"CK": "Острова Кука",
		"NF": "Остров Норфолк",
		"CX": "Остров Рождества",
		"PN": "Острова Питкэрн",
		"SH": "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
		"PK": "Пакистан",
		"PW": "Палау",
		"PS": "Государство Палестина",
		"PA": "Панама",
		"PG": "Папуа — Новая Гвинея",
		"PY": "Парагвай",
		"PE": "Перу",
		"PL": "Польша",
		"PT": "Португалия",
		"PR": "Пуэрто-Рико",
		"CG": "Республика Конго",
		"KR": "Республика Корея",
		"RE": "Реюньон",
		"RU": "Россия",
		"RW": "Руанда",
		"RO": "Румыния",
		"SV": "Сальвадор",
		"WS": "Самоа",
		"SM": "Сан-Марино",
		"ST": "Сан-Томе и Принсипи",
		"SA": "Саудовская Аравия",
		"SZ": "Свазиленд",
		"MP": "Северные Марианские Острова",
		"SC": "Сейшельские Острова",
		"BL": "Сен-Бартелеми",
		"MF": "Сен-Мартен",
		"PM": "Сен-Пьер и Микелон",
		"SN": "Сенегал",
		"VC": "Сент-Винсент и Гренадины",
		"KN": "Сент-Китс и Невис",
		"LC": "Сент-Люсия",
		"RS": "Сербия",
		"SG": "Сингапур",
		"SX": "Синт-Мартен",
		"SY": "Сирия",
		"SK": "Словакия",
		"SI": "Словения",
		"SB": "Соломоновы Острова",
		"SO": "Сомали",
		"SD": "Судан",
		"SR": "Суринам",
		"US": "США",
		"SL": "Сьерра-Леоне",
		"TJ": "Таджикистан",
		"TH": "Таиланд",
		"TZ": "Танзания",
		"TC": "Теркс и Кайкос",
		"TG": "Того",
		"TK": "Токелау",
		"TO": "Тонга",
		"TT": "Тринидад и Тобаго",
		"TV": "Тувалу",
		"TN": "Тунис",
		"TM": "Туркмения",
		"TR": "Турция",
		"UG": "Уганда",
		"UZ": "Узбекистан",
		"UA": "Украина",
		"WF": "Уоллис и Футуна",
		"UY": "Уругвай",
		"FO": "Фареры",
		"FJ": "Фиджи",
		"PH": "Филиппины",
		"FI": "Финляндия",
		"FK": "Фолклендские острова",
		"FR": "Франция",
		"PF": "Французская Полинезия",
		"TF": "Французские Южные и Антарктические Территории",
		"HM": "Херд и Макдональд",
		"HR": "Хорватия",
		"CF": "ЦАР",
		"TD": "Чад",
		"ME": "Черногория",
		"CZ": "Чехия",
		"CL": "Чили",
		"CH": "Швейцария",
		"SE": "Швеция",
		"SJ": "Шпицберген и Ян-Майен",
		"LK": "Шри-Ланка",
		"EC": "Эквадор",
		"GQ": "Экваториальная Гвинея",
		"ER": "Эритрея",
		"EE": "Эстония",
		"ET": "Эфиопия",
		"ZA": "ЮАР",
		"GS": "Южная Георгия и Южные Сандвичевы Острова",
		"SS": "Южный Судан",
		"JM": "Ямайка",
		"JP": "Япония",
		"XK": "Косово"
	};

/***/ },
/* 449 */
/***/ function(module, exports) {

	module.exports = {
		"AD": "Andorra",
		"AE": "Förenade Arabemiraten",
		"AF": "Afghanistan",
		"AG": "Antigua och Barbuda",
		"AI": "Anguilla",
		"AL": "Albanien",
		"AM": "Armenien",
		"AO": "Angola",
		"AQ": "Antarktis",
		"AR": "Argentina",
		"AS": "Amerikanska Samoa",
		"AT": "Österrike",
		"AU": "Australien",
		"AW": "Aruba",
		"AX": "Åland",
		"AZ": "Azerbajdzjan",
		"BA": "Bosnien och Hercegovina",
		"BB": "Barbados",
		"BD": "Bangladesh",
		"BE": "Belgien",
		"BF": "Burkina Faso",
		"BG": "Bulgarien",
		"BH": "Bahrain",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Saint-Barthélemy",
		"BM": "Bermuda",
		"BN": "Brunei",
		"BO": "Bolivia",
		"BQ": "Bonaire, Saint Eustatius och Saba",
		"BR": "Brasilien",
		"BS": "Bahamas",
		"BT": "Bhutan",
		"BV": "Bouvetön",
		"BW": "Botswana",
		"BY": "Vitryssland",
		"BZ": "Belize",
		"CA": "Kanada",
		"CC": "Kokosöarna",
		"CD": "Demokratiska republiken Kongo",
		"CF": "Centralafrikanska republiken",
		"CG": "Kongo-Brazzaville",
		"CH": "Schweiz",
		"CI": "Elfenbenskusten",
		"CK": "Cooköarna",
		"CL": "Chile",
		"CM": "Kamerun",
		"CN": "Kina",
		"CO": "Colombia",
		"CR": "Costa Rica",
		"CU": "Kuba",
		"CV": "Kap Verde",
		"CW": "Curacao",
		"CX": "Julön",
		"CY": "Cypern",
		"CZ": "Tjeckien",
		"DE": "Tyskland",
		"DJ": "Djibouti",
		"DK": "Danmark",
		"DM": "Dominica",
		"DO": "Dominikanska republiken",
		"DZ": "Algeriet",
		"EC": "Ecuador",
		"EE": "Estland",
		"EG": "Egypten",
		"EH": "Västsahara",
		"ER": "Eritrea",
		"ES": "Spanien",
		"ET": "Etiopien",
		"FI": "Finland",
		"FJ": "Fiji",
		"FK": "Falklandsöarna",
		"FM": "Mikronesiska federationen",
		"FO": "Färöarna",
		"FR": "Frankrike",
		"GA": "Gabon",
		"GB": "Storbritannien",
		"GD": "Grenada",
		"GE": "Georgien",
		"GF": "Franska Guyana",
		"GG": "Guernsey",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GL": "Grönland",
		"GM": "Gambia",
		"GN": "Guinea",
		"GP": "Guadeloupe",
		"GQ": "Ekvatorialguinea",
		"GR": "Grekland",
		"GS": "Sydgeorgien och Sydsandwichöarna",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea Bissau",
		"GY": "Guyana",
		"HK": "Hongkong",
		"HM": "Heard- och McDonaldsöarna",
		"HN": "Honduras",
		"HR": "Kroatien",
		"HT": "Haiti",
		"HU": "Ungern",
		"ID": "Indonesien",
		"IE": "Irland",
		"IL": "Israel",
		"IM": "Isle of Man",
		"IN": "Indien",
		"IO": "Brittiska territoriet i Indiska Oceanen",
		"IQ": "Irak",
		"IR": "Iran",
		"IS": "Island",
		"IT": "Italien",
		"JE": "Jersey",
		"JM": "Jamaica",
		"JO": "Jordanien",
		"JP": "Japan",
		"KE": "Kenya",
		"KG": "Kirgizistan",
		"KH": "Kambodja",
		"KI": "Kiribati",
		"KM": "Komorerna",
		"KN": "Saint Kitts och Nevis",
		"KP": "Nordkorea",
		"KR": "Sydkorea",
		"KW": "Kuwait",
		"KY": "Caymanöarna",
		"KZ": "Kazakstan",
		"LA": "Laos",
		"LB": "Libanon",
		"LC": "Saint Lucia",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberia",
		"LS": "Lesotho",
		"LT": "Litauen",
		"LU": "Luxemburg",
		"LV": "Lettland",
		"LY": "Libyen",
		"MA": "Marocko",
		"MC": "Monaco",
		"MD": "Moldavien",
		"ME": "Montenegro",
		"MF": "Saint Martin (franska delen)",
		"MG": "Madagaskar",
		"MH": "Marshallöarna",
		"MK": "Makedonien",
		"ML": "Mali",
		"MM": "Burma",
		"MN": "Mongoliet",
		"MO": "Macau",
		"MP": "Nordmarianerna",
		"MQ": "Martinique",
		"MR": "Mauretanien",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauritius",
		"MV": "Maldiverna",
		"MW": "Malawi",
		"MX": "Mexiko",
		"MY": "Malaysia",
		"MZ": "Moçambique",
		"NA": "Namibia",
		"NC": "Nya Kaledonien",
		"NE": "Niger",
		"NF": "Norfolkön",
		"NG": "Nigeria",
		"NI": "Nicaragua",
		"NL": "Nederländerna",
		"NO": "Norge",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "Nya Zeeland",
		"OM": "Oman",
		"PA": "Panama",
		"PE": "Peru",
		"PF": "Franska Polynesien",
		"PG": "Papua Nya Guinea",
		"PH": "Filippinerna",
		"PK": "Pakistan",
		"PL": "Polen",
		"PM": "Saint-Pierre och Miquelon",
		"PN": "Pitcairnöarna",
		"PR": "Puerto Rico",
		"PS": "Palestinska territoriet, ockuperade",
		"PT": "Portugal",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Qatar",
		"RE": "Réunion",
		"RO": "Rumänien",
		"RS": "Serbien",
		"RU": "Ryssland",
		"RW": "Rwanda",
		"SA": "Saudiarabien",
		"SB": "Salomonöarna",
		"SC": "Seychellerna",
		"SD": "Sudan",
		"SE": "Sverige",
		"SG": "Singapore",
		"SH": "Sankta Helena",
		"SI": "Slovenien",
		"SJ": "Svalbard och Jan Mayen",
		"SK": "Slovakien",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somalia",
		"SR": "Surinam",
		"SS": "Sydsudan",
		"ST": "São Tomé och Príncipe",
		"SV": "El Salvador",
		"SX": "Sint Maarten (nederländska delen)",
		"SY": "Syrien",
		"SZ": "Swaziland",
		"TC": "Turks- och Caicosöarna",
		"TD": "Tchad",
		"TF": "Franska södra territorierna",
		"TG": "Togo",
		"TH": "Thailand",
		"TJ": "Tadzjikistan",
		"TK": "Tokelauöarna",
		"TL": "Östtimor",
		"TM": "Turkmenistan",
		"TN": "Tunisien",
		"TO": "Tonga",
		"TR": "Turkiet",
		"TT": "Trinidad och Tobago",
		"TV": "Tuvalu",
		"TW": "Taiwan",
		"TZ": "Tanzania",
		"UA": "Ukraina",
		"UG": "Uganda",
		"UM": "USA:s yttre öar",
		"US": "USA",
		"UY": "Uruguay",
		"UZ": "Uzbekistan",
		"VA": "Vatikanstaten",
		"VC": "Saint Vincent och Grenadinerna",
		"VE": "Venezuela",
		"VG": "Brittiska Jungfruöarna",
		"VI": "Amerikanska Jungfruöarna",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis- och Futunaöarna",
		"WS": "Samoa",
		"YE": "Jemen",
		"YT": "Mayotte",
		"ZA": "Sydafrika",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"XK": "Kosovo"
	};

/***/ },
/* 450 */
/***/ function(module, exports) {

	module.exports = {
		"AD": "Andorra",
		"AE": "Birleşik Arap Emirlikleri",
		"AF": "Afganistan",
		"AG": "Antigua ve Barbuda",
		"AI": "Anguilla",
		"AL": "Arnavutluk",
		"AM": "Ermenistan",
		"AO": "Angola",
		"AQ": "Antarktika",
		"AR": "Arjantin",
		"AS": "Amerikan Samoası",
		"AT": "Avusturya",
		"AU": "Avustralya",
		"AW": "Aruba",
		"AX": "Åland Adaları",
		"AZ": "Azerbaycan",
		"BA": "Bosna Hersek",
		"BB": "Barbados",
		"BD": "Bangladeş",
		"BE": "Belçika",
		"BF": "Burkina Faso",
		"BG": "Bulgaristan",
		"BH": "Bahreyn",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Saint Barthelemy",
		"BM": "Bermuda",
		"BN": "Brunei",
		"BO": "Bolivya",
		"BQ": "Karayip Hollanda",
		"BR": "Brezilya",
		"BS": "Bahamalar",
		"BT": "Butan",
		"BV": "Bouvet Adası",
		"BW": "Botsvana",
		"BY": "Beyaz Rusya",
		"BZ": "Belize",
		"CA": "Kanada",
		"CC": "Cocos (Keeling) Adaları",
		"CD": "Kongo - Kinşasa",
		"CF": "Orta Afrika Cumhuriyeti",
		"CG": "Kongo - Brazavil",
		"CH": "İsviçre",
		"CI": "Fildişi Sahili",
		"CK": "Cook Adaları",
		"CL": "Şili",
		"CM": "Kamerun",
		"CN": "Çin",
		"CO": "Kolombiya",
		"CR": "Kosta Rika",
		"CU": "Küba",
		"CV": "Cape Verde",
		"CW": "Curaçao",
		"CX": "Christmas Adası",
		"CY": "Güney Kıbrıs Rum Kesimi",
		"CZ": "Çek Cumhuriyeti",
		"DE": "Almanya",
		"DJ": "Cibuti",
		"DK": "Danimarka",
		"DM": "Dominika",
		"DO": "Dominik Cumhuriyeti",
		"DZ": "Cezayir",
		"EC": "Ekvador",
		"EE": "Estonya",
		"EG": "Mısır",
		"EH": "Batı Sahara",
		"ER": "Eritre",
		"ES": "İspanya",
		"ET": "Etiyopya",
		"FI": "Finlandiya",
		"FJ": "Fiji",
		"FK": "Falkland Adaları",
		"FM": "Mikronezya",
		"FO": "Faroe Adaları",
		"FR": "Fransa",
		"GA": "Gabon",
		"GB": "Birleşik Krallık",
		"GD": "Grenada",
		"GE": "Gürcistan",
		"GF": "Fransız Guyanası",
		"GG": "Guernsey",
		"GH": "Gana",
		"GI": "Cebelitarık",
		"GL": "Grönland",
		"GM": "Gambiya",
		"GN": "Gine",
		"GP": "Guadalupe",
		"GQ": "Ekvator Ginesi",
		"GR": "Yunanistan",
		"GS": "Güney Georgia ve Güney Sandwich Adaları",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Gine-Bissau",
		"GY": "Guyana",
		"HK": "Çin Hong Kong ÖYB",
		"HM": "Heard Adası ve McDonald Adaları",
		"HN": "Honduras",
		"HR": "Hırvatistan",
		"HT": "Haiti",
		"HU": "Macaristan",
		"ID": "Endonezya",
		"IE": "İrlanda",
		"IL": "İsrail",
		"IM": "Man Adası",
		"IN": "Hindistan",
		"IO": "Britanya Hint Okyanusu Toprakları",
		"IQ": "Irak",
		"IR": "İran",
		"IS": "İzlanda",
		"IT": "İtalya",
		"JE": "Jersey",
		"JM": "Jamaika",
		"JO": "Ürdün",
		"JP": "Japonya",
		"KE": "Kenya",
		"KG": "Kırgızistan",
		"KH": "Kamboçya",
		"KI": "Kiribati",
		"KM": "Komorlar",
		"KN": "Saint Kitts ve Nevis",
		"KP": "Kuzey Kore",
		"KR": "Güney Kore",
		"KW": "Kuveyt",
		"KY": "Cayman Adaları",
		"KZ": "Kazakistan",
		"LA": "Laos",
		"LB": "Lübnan",
		"LC": "Saint Lucia",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberya",
		"LS": "Lesoto",
		"LT": "Litvanya",
		"LU": "Lüksemburg",
		"LV": "Letonya",
		"LY": "Libya",
		"MA": "Fas",
		"MC": "Monako",
		"MD": "Moldova",
		"ME": "Karadağ",
		"MF": "Saint Martin",
		"MG": "Madagaskar",
		"MH": "Marshall Adaları",
		"MK": "Makedonya",
		"ML": "Mali",
		"MM": "Myanmar (Burma)",
		"MN": "Moğolistan",
		"MO": "Çin Makao ÖYB",
		"MP": "Kuzey Mariana Adaları",
		"MQ": "Martinik",
		"MR": "Moritanya",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauritius",
		"MV": "Maldivler",
		"MW": "Malavi",
		"MX": "Meksika",
		"MY": "Malezya",
		"MZ": "Mozambik",
		"NA": "Namibya",
		"NC": "Yeni Kaledonya",
		"NE": "Nijer",
		"NF": "Norfolk Adası",
		"NG": "Nijerya",
		"NI": "Nikaragua",
		"NL": "Hollanda",
		"NO": "Norveç",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "Yeni Zelanda",
		"OM": "Umman",
		"PA": "Panama",
		"PE": "Peru",
		"PF": "Fransız Polinezyası",
		"PG": "Papua Yeni Gine",
		"PH": "Filipinler",
		"PK": "Pakistan",
		"PL": "Polonya",
		"PM": "Saint Pierre ve Miquelon",
		"PN": "Pitcairn Adaları",
		"PR": "Porto Riko",
		"PS": "Filistin Bölgeleri",
		"PT": "Portekiz",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Katar",
		"RE": "Réunion",
		"RO": "Romanya",
		"RS": "Sırbistan",
		"RU": "Rusya",
		"RW": "Ruanda",
		"SA": "Suudi Arabistan",
		"SB": "Solomon Adaları",
		"SC": "Seyşeller",
		"SD": "Sudan",
		"SE": "İsveç",
		"SG": "Singapur",
		"SH": "Saint Helena",
		"SI": "Slovenya",
		"SJ": "Svalbard ve Jan Mayen Adaları",
		"SK": "Slovakya",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somali",
		"SR": "Surinam",
		"SS": "Güney Sudan",
		"ST": "São Tomé ve Príncipe",
		"SV": "El Salvador",
		"SX": "Sint Maarten",
		"SY": "Suriye",
		"SZ": "Svaziland",
		"TC": "Turks ve Caicos Adaları",
		"TD": "Çad",
		"TF": "Fransız Güney Toprakları",
		"TG": "Togo",
		"TH": "Tayland",
		"TJ": "Tacikistan",
		"TK": "Tokelau",
		"TL": "Timor-Leste",
		"TM": "Türkmenistan",
		"TN": "Tunus",
		"TO": "Tonga",
		"TR": "Türkiye",
		"TT": "Trinidad ve Tobago",
		"TV": "Tuvalu",
		"TW": "Tayvan",
		"TZ": "Tanzanya",
		"UA": "Ukrayna",
		"UG": "Uganda",
		"UM": "ABD Uzak Adaları",
		"US": "ABD",
		"UY": "Uruguay",
		"UZ": "Özbekistan",
		"VA": "Vatikan",
		"VC": "Saint Vincent ve Grenadinler",
		"VE": "Venezuela",
		"VG": "Britanya Virjin Adaları",
		"VI": "ABD Virjin Adaları",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis ve Futuna Adaları",
		"WS": "Samoa",
		"YE": "Yemen",
		"YT": "Mayotte",
		"ZA": "Güney Afrika",
		"ZM": "Zambiya",
		"ZW": "Zimbabve",
		"XK": "Kosova"
	};

/***/ },
/* 451 */
/***/ function(module, exports) {

	module.exports = {
		"AD": "安道尔",
		"AE": "阿联酋",
		"AF": "阿富汗",
		"AG": "安地卡及巴布達",
		"AI": "安圭拉",
		"AL": "阿尔巴尼亚",
		"AM": "亞美尼亞",
		"AO": "安哥拉",
		"AQ": "南极洲",
		"AR": "阿根廷",
		"AS": "美属萨摩亚",
		"AT": "奥地利",
		"AU": "澳大利亚",
		"AW": "阿鲁巴",
		"AX": "奧蘭",
		"AZ": "阿塞拜疆",
		"BA": "波斯尼亚和黑塞哥维那",
		"BB": "巴巴多斯",
		"BD": "孟加拉国",
		"BE": "比利時",
		"BF": "布吉納法索",
		"BG": "保加利亚",
		"BH": "巴林",
		"BI": "布隆迪",
		"BJ": "贝宁",
		"BL": "圣巴泰勒米",
		"BM": "百慕大",
		"BN": "文莱",
		"BO": "玻利维亚",
		"BQ": "加勒比荷兰",
		"BR": "巴西",
		"BS": "巴哈马",
		"BT": "不丹",
		"BV": "布韦岛",
		"BW": "博茨瓦纳",
		"BY": "白俄羅斯",
		"BZ": "伯利兹",
		"CA": "加拿大",
		"CC": "科科斯（基林）群島",
		"CD": "刚果（金)",
		"CF": "中非",
		"CG": "刚果（布)",
		"CH": "瑞士",
		"CI": "科特迪瓦",
		"CK": "庫克群島",
		"CL": "智利",
		"CM": "喀麦隆",
		"CN": "中国",
		"CO": "哥伦比亚",
		"CR": "哥斯达黎加",
		"CU": "古巴",
		"CV": "佛得角",
		"CW": "库拉索",
		"CX": "圣诞岛",
		"CY": "賽普勒斯",
		"CZ": "捷克",
		"DE": "德國",
		"DJ": "吉布提",
		"DK": "丹麥",
		"DM": "多米尼克",
		"DO": "多米尼加",
		"DZ": "阿尔及利亚",
		"EC": "厄瓜多尔",
		"EE": "爱沙尼亚",
		"EG": "埃及",
		"EH": "阿拉伯撒哈拉民主共和国",
		"ER": "厄立特里亚",
		"ES": "西班牙",
		"ET": "衣索比亞",
		"FI": "芬兰",
		"FJ": "斐济",
		"FK": "福克蘭群島",
		"FM": "密克羅尼西亞聯邦",
		"FO": "法罗群岛",
		"FR": "法国",
		"GA": "加彭",
		"GB": "英國",
		"GD": "格瑞那達",
		"GE": "格鲁吉亚",
		"GF": "法属圭亚那",
		"GG": "根西",
		"GH": "加纳",
		"GI": "直布罗陀",
		"GL": "格陵兰",
		"GM": "冈比亚",
		"GN": "几内亚",
		"GP": "瓜德罗普",
		"GQ": "赤道几内亚",
		"GR": "希臘",
		"GS": "南乔治亚和南桑威奇群岛",
		"GT": "危地马拉",
		"GU": "關島",
		"GW": "几内亚比绍",
		"GY": "圭亚那",
		"HK": "香港",
		"HM": "赫德岛和麦克唐纳群岛",
		"HN": "宏都拉斯",
		"HR": "克罗地亚",
		"HT": "海地",
		"HU": "匈牙利",
		"ID": "印尼",
		"IE": "爱尔兰",
		"IL": "以色列",
		"IM": "马恩岛",
		"IN": "印度",
		"IO": "英屬印度洋領地",
		"IQ": "伊拉克",
		"IR": "伊朗",
		"IS": "冰島",
		"IT": "義大利",
		"JE": "澤西",
		"JM": "牙买加",
		"JO": "约旦",
		"JP": "日本",
		"KE": "肯尼亚",
		"KG": "吉尔吉斯斯坦",
		"KH": "柬埔寨",
		"KI": "基里巴斯",
		"KM": "科摩罗",
		"KN": "圣基茨和尼维斯",
		"KP": "朝鲜",
		"KR": "韩国",
		"KW": "科威特",
		"KY": "开曼群岛",
		"KZ": "哈萨克斯坦",
		"LA": "老挝",
		"LB": "黎巴嫩",
		"LC": "圣卢西亚",
		"LI": "列支敦斯登",
		"LK": "斯里蘭卡",
		"LR": "利比里亚",
		"LS": "賴索托",
		"LT": "立陶宛",
		"LU": "卢森堡",
		"LV": "拉脫維亞",
		"LY": "利比亞",
		"MA": "摩洛哥",
		"MC": "摩納哥",
		"MD": "摩尔多瓦",
		"ME": "蒙特內哥羅",
		"MF": "法属圣马丁",
		"MG": "马达加斯加",
		"MH": "马绍尔群岛",
		"MK": "馬其頓",
		"ML": "马里",
		"MM": "緬甸",
		"MN": "蒙古",
		"MO": "澳門",
		"MP": "北馬里亞納群島",
		"MQ": "马提尼克",
		"MR": "毛里塔尼亚",
		"MS": "蒙特塞拉特",
		"MT": "馬爾他",
		"MU": "模里西斯",
		"MV": "馬爾地夫",
		"MW": "马拉维",
		"MX": "墨西哥",
		"MY": "马来西亚",
		"MZ": "莫桑比克",
		"NA": "纳米比亚",
		"NC": "新喀里多尼亞",
		"NE": "尼日尔",
		"NF": "诺福克岛",
		"NG": "奈及利亞",
		"NI": "尼加拉瓜",
		"NL": "荷蘭",
		"NO": "挪威",
		"NP": "尼泊尔",
		"NR": "瑙鲁",
		"NU": "纽埃",
		"NZ": "新西蘭",
		"OM": "阿曼",
		"PA": "巴拿马",
		"PE": "秘魯",
		"PF": "法屬玻里尼西亞",
		"PG": "巴布亚新几内亚",
		"PH": "菲律賓",
		"PK": "巴基斯坦",
		"PL": "波蘭",
		"PM": "圣皮埃尔和密克隆",
		"PN": "皮特凯恩群岛",
		"PR": "波多黎各",
		"PS": "巴勒斯坦",
		"PT": "葡萄牙",
		"PW": "帛琉",
		"PY": "巴拉圭",
		"QA": "卡塔尔",
		"RE": "留尼汪",
		"RO": "羅馬尼亞",
		"RS": "塞爾維亞",
		"RU": "俄羅斯",
		"RW": "卢旺达",
		"SA": "沙烏地阿拉伯",
		"SB": "所罗门群岛",
		"SC": "塞舌尔",
		"SD": "苏丹",
		"SE": "瑞典",
		"SG": "新加坡",
		"SH": "聖赫勒拿",
		"SI": "斯洛維尼亞",
		"SJ": "斯瓦尔巴群岛和扬马延岛",
		"SK": "斯洛伐克",
		"SL": "塞拉利昂",
		"SM": "圣马力诺",
		"SN": "塞内加尔",
		"SO": "索馬利亞",
		"SR": "苏里南",
		"SS": "南蘇丹",
		"ST": "聖多美和普林西比",
		"SV": "薩爾瓦多",
		"SX": "荷屬聖馬丁",
		"SY": "叙利亚",
		"SZ": "斯威士兰",
		"TC": "特克斯和凯科斯群岛",
		"TD": "乍得",
		"TF": "法属南部领地",
		"TG": "多哥",
		"TH": "泰國",
		"TJ": "塔吉克斯坦",
		"TK": "托克勞",
		"TL": "东帝汶",
		"TM": "土库曼斯坦",
		"TN": "突尼西亞",
		"TO": "汤加",
		"TR": "土耳其",
		"TT": "千里達及托巴哥",
		"TV": "图瓦卢",
		"TW": "臺灣",
		"TZ": "坦桑尼亚",
		"UA": "烏克蘭",
		"UG": "乌干达",
		"UM": "美國本土外小島嶼",
		"US": "美國",
		"UY": "乌拉圭",
		"UZ": "乌兹别克斯坦",
		"VA": "梵蒂冈",
		"VC": "聖文森及格瑞那丁",
		"VE": "委內瑞拉",
		"VG": "英屬維爾京群島",
		"VI": "美屬維爾京群島",
		"VN": "越南",
		"VU": "瓦努阿圖",
		"WF": "瓦利斯和富圖納",
		"WS": "萨摩亚",
		"YE": "葉門",
		"YT": "马约特",
		"ZA": "南非",
		"ZM": "尚比亞",
		"ZW": "辛巴威",
		"XK": "科索沃"
	};

/***/ },
/* 452 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(63)(module)))

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = reduce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(63)(module)))

/***/ },
/* 455 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 456 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	  object = parent(object, path);
	
	  var key = toKey(last(path));
	  return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Removes the property at `path` of `object`.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	 * _.unset(object, 'a[0].b.c');
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 *
	 * _.unset(object, ['a', '0', 'b', 'c']);
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 */
	function unset(object, path) {
	  return object == null ? true : baseUnset(object, path);
	}
	
	module.exports = unset;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(59),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(506),
	    hashDelete = __webpack_require__(507),
	    hashGet = __webpack_require__(508),
	    hashHas = __webpack_require__(509),
	    hashSet = __webpack_require__(510);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(59),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(59),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(156),
	    setCacheAdd = __webpack_require__(532),
	    setCacheHas = __webpack_require__(533);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(59),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 463 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 464 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 465 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 466 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(112),
	    eq = __webpack_require__(91);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(233),
	    keys = __webpack_require__(162);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(465),
	    isArray = __webpack_require__(40);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 471 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(77),
	    isObjectLike = __webpack_require__(60);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    equalArrays = __webpack_require__(239),
	    equalByTag = __webpack_require__(498),
	    equalObjects = __webpack_require__(499),
	    getTag = __webpack_require__(242),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(118),
	    isTypedArray = __webpack_require__(121);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    baseIsEqual = __webpack_require__(113);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(119),
	    isMasked = __webpack_require__(514),
	    isObject = __webpack_require__(53),
	    toSource = __webpack_require__(248);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(77),
	    isLength = __webpack_require__(161),
	    isObjectLike = __webpack_require__(60);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(479),
	    baseMatchesProperty = __webpack_require__(480),
	    identity = __webpack_require__(160),
	    isArray = __webpack_require__(40),
	    property = __webpack_require__(551);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53),
	    isPrototype = __webpack_require__(115),
	    nativeKeysIn = __webpack_require__(528);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(474),
	    getMatchData = __webpack_require__(501),
	    matchesStrictComparable = __webpack_require__(244);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(113),
	    get = __webpack_require__(249),
	    hasIn = __webpack_require__(543),
	    isKey = __webpack_require__(159),
	    isStrictComparable = __webpack_require__(243),
	    matchesStrictComparable = __webpack_require__(244),
	    toKey = __webpack_require__(90);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    assignMergeValue = __webpack_require__(232),
	    baseFor = __webpack_require__(233),
	    baseMergeDeep = __webpack_require__(482),
	    isObject = __webpack_require__(53),
	    keysIn = __webpack_require__(251),
	    safeGet = __webpack_require__(246);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(232),
	    cloneBuffer = __webpack_require__(492),
	    cloneTypedArray = __webpack_require__(493),
	    copyArray = __webpack_require__(237),
	    initCloneObject = __webpack_require__(511),
	    isArguments = __webpack_require__(117),
	    isArray = __webpack_require__(40),
	    isArrayLikeObject = __webpack_require__(544),
	    isBuffer = __webpack_require__(118),
	    isFunction = __webpack_require__(119),
	    isObject = __webpack_require__(53),
	    isPlainObject = __webpack_require__(548),
	    isTypedArray = __webpack_require__(121),
	    safeGet = __webpack_require__(246),
	    toPlainObject = __webpack_require__(554);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 483 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(234);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(160),
	    overRest = __webpack_require__(531),
	    setToString = __webpack_require__(535);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(542),
	    defineProperty = __webpack_require__(238),
	    identity = __webpack_require__(160);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 487 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(110),
	    arrayMap = __webpack_require__(231),
	    isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(120);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 489 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 490 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(229);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(44);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(491);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(467),
	    baseAssignValue = __webpack_require__(112);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(44);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(485),
	    isIterateeCall = __webpack_require__(512);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 497 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(110),
	    Uint8Array = __webpack_require__(229),
	    eq = __webpack_require__(91),
	    equalArrays = __webpack_require__(239),
	    mapToArray = __webpack_require__(525),
	    setToArray = __webpack_require__(534);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(500);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(470),
	    getSymbols = __webpack_require__(503),
	    keys = __webpack_require__(162);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(243),
	    keys = __webpack_require__(162);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(110);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(464),
	    stubArray = __webpack_require__(552);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 504 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(236),
	    isArguments = __webpack_require__(117),
	    isArray = __webpack_require__(40),
	    isIndex = __webpack_require__(158),
	    isLength = __webpack_require__(161),
	    toKey = __webpack_require__(90);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(116);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 507 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(116);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(116);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(116);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(468),
	    getPrototype = __webpack_require__(241),
	    isPrototype = __webpack_require__(115);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(91),
	    isArrayLike = __webpack_require__(92),
	    isIndex = __webpack_require__(158),
	    isObject = __webpack_require__(53);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 513 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(495);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 515 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(111);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(111);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(111);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(111);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(458),
	    ListCache = __webpack_require__(109),
	    Map = __webpack_require__(155);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(114);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(114);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(114);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(114);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 525 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(549);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(245);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 528 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(240);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 530 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(463);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 532 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 533 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 534 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(486),
	    shortOut = __webpack_require__(536);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 536 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(109);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 538 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 539 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 540 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(109),
	    Map = __webpack_require__(155),
	    MapCache = __webpack_require__(156);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 542 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(471),
	    hasPath = __webpack_require__(505);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(92),
	    isObjectLike = __webpack_require__(60);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(235),
	    getTag = __webpack_require__(242),
	    isArguments = __webpack_require__(117),
	    isArray = __webpack_require__(40),
	    isArrayLike = __webpack_require__(92),
	    isBuffer = __webpack_require__(118),
	    isPrototype = __webpack_require__(115),
	    isTypedArray = __webpack_require__(121);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(113);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 547 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(77),
	    getPrototype = __webpack_require__(241),
	    isObjectLike = __webpack_require__(60);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(156);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(481),
	    createAssigner = __webpack_require__(496);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(483),
	    basePropertyDeep = __webpack_require__(484),
	    isKey = __webpack_require__(159),
	    toKey = __webpack_require__(90);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 552 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 553 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(494),
	    keysIn = __webpack_require__(251);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.denormalize = exports.normalize = exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Entity = __webpack_require__(557);
	
	var _Entity2 = _interopRequireDefault(_Entity);
	
	var _Union = __webpack_require__(559);
	
	var _Union2 = _interopRequireDefault(_Union);
	
	var _Values = __webpack_require__(560);
	
	var _Values2 = _interopRequireDefault(_Values);
	
	var _Array = __webpack_require__(556);
	
	var ArrayUtils = _interopRequireWildcard(_Array);
	
	var _Object = __webpack_require__(558);
	
	var ObjectUtils = _interopRequireWildcard(_Object);
	
	var _ImmutableUtils = __webpack_require__(123);
	
	var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var visit = function visit(value, parent, key, schema, addEntity) {
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || !value) {
	    return value;
	  }
	
	  if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
	    var method = Array.isArray(schema) ? ArrayUtils.normalize : ObjectUtils.normalize;
	    return method(schema, value, parent, key, visit, addEntity);
	  }
	
	  return schema.normalize(value, parent, key, visit, addEntity);
	};
	
	var addEntities = function addEntities(entities) {
	  return function (schema, processedEntity, value, parent, key) {
	    var schemaKey = schema.key;
	    var id = schema.getId(value, parent, key);
	    if (!(schemaKey in entities)) {
	      entities[schemaKey] = {};
	    }
	
	    var existingEntity = entities[schemaKey][id];
	    if (existingEntity) {
	      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
	    } else {
	      entities[schemaKey][id] = processedEntity;
	    }
	  };
	};
	
	var schema = exports.schema = {
	  Array: ArrayUtils.default,
	  Entity: _Entity2.default,
	  Object: ObjectUtils.default,
	  Union: _Union2.default,
	  Values: _Values2.default
	};
	
	var normalize = exports.normalize = function normalize(input, schema) {
	  if (!input || (typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') {
	    throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + '".');
	  }
	
	  var entities = {};
	  var addEntity = addEntities(entities);
	
	  var result = visit(input, input, null, schema, addEntity);
	  return { entities: entities, result: result };
	};
	
	var unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
	  var entity = getEntity(id, schema);
	  if ((typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) !== 'object' || entity === null) {
	    return entity;
	  }
	
	  if (!cache[schema.key]) {
	    cache[schema.key] = {};
	  }
	
	  if (!cache[schema.key][id]) {
	    // Ensure we don't mutate it non-immutable objects
	    var entityCopy = ImmutableUtils.isImmutable(entity) ? entity : _extends({}, entity);
	
	    // Need to set this first so that if it is referenced further within the
	    // denormalization the reference will already exist.
	    cache[schema.key][id] = entityCopy;
	    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
	  }
	
	  return cache[schema.key][id];
	};
	
	var getUnvisit = function getUnvisit(entities) {
	  var cache = {};
	  var getEntity = getEntities(entities);
	
	  return function unvisit(input, schema) {
	    if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
	      var method = Array.isArray(schema) ? ArrayUtils.denormalize : ObjectUtils.denormalize;
	      return method(schema, input, unvisit);
	    }
	
	    if (input === undefined || input === null) {
	      return input;
	    }
	
	    if (schema instanceof _Entity2.default) {
	      return unvisitEntity(input, schema, unvisit, getEntity, cache);
	    }
	
	    return schema.denormalize(input, unvisit);
	  };
	};
	
	var getEntities = function getEntities(entities) {
	  var isImmutable = ImmutableUtils.isImmutable(entities);
	
	  return function (entityOrId, schema) {
	    var schemaKey = schema.key;
	
	    if ((typeof entityOrId === 'undefined' ? 'undefined' : _typeof(entityOrId)) === 'object') {
	      return entityOrId;
	    }
	
	    return isImmutable ? entities.getIn([schemaKey, entityOrId.toString()]) : entities[schemaKey][entityOrId];
	  };
	};
	
	var denormalize = exports.denormalize = function denormalize(input, schema, entities) {
	  if (typeof input !== 'undefined') {
	    return getUnvisit(entities)(input, schema);
	  }
	};

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.denormalize = exports.normalize = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Polymorphic = __webpack_require__(164);
	
	var _Polymorphic2 = _interopRequireDefault(_Polymorphic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateSchema = function validateSchema(definition) {
	  var isArray = Array.isArray(definition);
	  if (isArray && definition.length > 1) {
	    throw new Error('Expected schema definition to be a single schema, but found ' + definition.length + '.');
	  }
	
	  return definition[0];
	};
	
	var getValues = function getValues(input) {
	  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
	    return input[key];
	  });
	};
	
	var normalize = exports.normalize = function normalize(schema, input, parent, key, visit, addEntity) {
	  schema = validateSchema(schema);
	
	  var values = getValues(input);
	
	  // Special case: Arrays pass *their* parent on to their children, since there
	  // is not any special information that can be gathered from themselves directly
	  return values.map(function (value, index) {
	    return visit(value, parent, key, schema, addEntity);
	  });
	};
	
	var denormalize = exports.denormalize = function denormalize(schema, input, unvisit) {
	  schema = validateSchema(schema);
	  return input && input.map ? input.map(function (entityOrId) {
	    return unvisit(entityOrId, schema);
	  }) : input;
	};
	
	var ArraySchema = function (_PolymorphicSchema) {
	  _inherits(ArraySchema, _PolymorphicSchema);
	
	  function ArraySchema() {
	    _classCallCheck(this, ArraySchema);
	
	    return _possibleConstructorReturn(this, (ArraySchema.__proto__ || Object.getPrototypeOf(ArraySchema)).apply(this, arguments));
	  }
	
	  _createClass(ArraySchema, [{
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      var _this2 = this;
	
	      var values = getValues(input);
	
	      return values.map(function (value, index) {
	        return _this2.normalizeValue(value, parent, key, visit, addEntity);
	      }).filter(function (value) {
	        return value !== undefined && value !== null;
	      });
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(input, unvisit) {
	      var _this3 = this;
	
	      return input && input.map ? input.map(function (value) {
	        return _this3.denormalizeValue(value, unvisit);
	      }) : input;
	    }
	  }]);
	
	  return ArraySchema;
	}(_Polymorphic2.default);
	
	exports.default = ArraySchema;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ImmutableUtils = __webpack_require__(123);
	
	var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var getDefaultGetId = function getDefaultGetId(idAttribute) {
	  return function (input) {
	    return ImmutableUtils.isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
	  };
	};
	
	var EntitySchema = function () {
	  function EntitySchema(key) {
	    var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, EntitySchema);
	
	    if (!key || typeof key !== 'string') {
	      throw new Error('Expected a string key for Entity, but found ' + key + '.');
	    }
	
	    var _options$idAttribute = options.idAttribute,
	        idAttribute = _options$idAttribute === undefined ? 'id' : _options$idAttribute,
	        _options$mergeStrateg = options.mergeStrategy,
	        mergeStrategy = _options$mergeStrateg === undefined ? function (entityA, entityB) {
	      return _extends({}, entityA, entityB);
	    } : _options$mergeStrateg,
	        _options$processStrat = options.processStrategy,
	        processStrategy = _options$processStrat === undefined ? function (input) {
	      return _extends({}, input);
	    } : _options$processStrat;
	
	
	    this._key = key;
	    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
	    this._idAttribute = idAttribute;
	    this._mergeStrategy = mergeStrategy;
	    this._processStrategy = processStrategy;
	    this.define(definition);
	  }
	
	  _createClass(EntitySchema, [{
	    key: 'define',
	    value: function define(definition) {
	      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	        var schema = definition[key];
	        return _extends({}, entitySchema, _defineProperty({}, key, schema));
	      }, this.schema || {});
	    }
	  }, {
	    key: 'getId',
	    value: function getId(input, parent, key) {
	      return this._getId(input, parent, key);
	    }
	  }, {
	    key: 'merge',
	    value: function merge(entityA, entityB) {
	      return this._mergeStrategy(entityA, entityB);
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      var _this = this;
	
	      var processedEntity = this._processStrategy(input, parent, key);
	      Object.keys(this.schema).forEach(function (key) {
	        if (processedEntity.hasOwnProperty(key) && _typeof(processedEntity[key]) === 'object') {
	          var schema = _this.schema[key];
	          processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity);
	        }
	      });
	
	      addEntity(this, processedEntity, input, parent, key);
	      return this.getId(input, parent, key);
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(entity, unvisit) {
	      var _this2 = this;
	
	      if (ImmutableUtils.isImmutable(entity)) {
	        return ImmutableUtils.denormalizeImmutable(this.schema, entity, unvisit);
	      }
	
	      Object.keys(this.schema).forEach(function (key) {
	        if (entity.hasOwnProperty(key)) {
	          var schema = _this2.schema[key];
	          entity[key] = unvisit(entity[key], schema);
	        }
	      });
	      return entity;
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      return this._key;
	    }
	  }, {
	    key: 'idAttribute',
	    get: function get() {
	      return this._idAttribute;
	    }
	  }]);
	
	  return EntitySchema;
	}();
	
	exports.default = EntitySchema;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.denormalize = exports.normalize = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ImmutableUtils = __webpack_require__(123);
	
	var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _normalize = function _normalize(schema, input, parent, key, visit, addEntity) {
	  var object = _extends({}, input);
	  Object.keys(schema).forEach(function (key) {
	    var localSchema = schema[key];
	    var value = visit(input[key], input, key, localSchema, addEntity);
	    if (value === undefined || value === null) {
	      delete object[key];
	    } else {
	      object[key] = value;
	    }
	  });
	  return object;
	};
	
	exports.normalize = _normalize;
	var _denormalize = function _denormalize(schema, input, unvisit) {
	  if (ImmutableUtils.isImmutable(input)) {
	    return ImmutableUtils.denormalizeImmutable(schema, input, unvisit);
	  }
	
	  var object = _extends({}, input);
	  Object.keys(schema).forEach(function (key) {
	    if (object[key]) {
	      object[key] = unvisit(object[key], schema[key]);
	    }
	  });
	  return object;
	};
	
	exports.denormalize = _denormalize;
	
	var ObjectSchema = function () {
	  function ObjectSchema(definition) {
	    _classCallCheck(this, ObjectSchema);
	
	    this.define(definition);
	  }
	
	  _createClass(ObjectSchema, [{
	    key: 'define',
	    value: function define(definition) {
	      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	        var schema = definition[key];
	        return _extends({}, entitySchema, _defineProperty({}, key, schema));
	      }, this.schema || {});
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _normalize.apply(undefined, [this.schema].concat(args));
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _denormalize.apply(undefined, [this.schema].concat(args));
	    }
	  }]);
	
	  return ObjectSchema;
	}();
	
	exports.default = ObjectSchema;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Polymorphic = __webpack_require__(164);
	
	var _Polymorphic2 = _interopRequireDefault(_Polymorphic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnionSchema = function (_PolymorphicSchema) {
	  _inherits(UnionSchema, _PolymorphicSchema);
	
	  function UnionSchema(definition, schemaAttribute) {
	    _classCallCheck(this, UnionSchema);
	
	    if (!schemaAttribute) {
	      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
	    }
	    return _possibleConstructorReturn(this, (UnionSchema.__proto__ || Object.getPrototypeOf(UnionSchema)).call(this, definition, schemaAttribute));
	  }
	
	  _createClass(UnionSchema, [{
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      return this.normalizeValue(input, parent, key, visit, addEntity);
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(input, unvisit) {
	      return this.denormalizeValue(input, unvisit);
	    }
	  }]);
	
	  return UnionSchema;
	}(_Polymorphic2.default);
	
	exports.default = UnionSchema;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Polymorphic = __webpack_require__(164);
	
	var _Polymorphic2 = _interopRequireDefault(_Polymorphic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValuesSchema = function (_PolymorphicSchema) {
	  _inherits(ValuesSchema, _PolymorphicSchema);
	
	  function ValuesSchema() {
	    _classCallCheck(this, ValuesSchema);
	
	    return _possibleConstructorReturn(this, (ValuesSchema.__proto__ || Object.getPrototypeOf(ValuesSchema)).apply(this, arguments));
	  }
	
	  _createClass(ValuesSchema, [{
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      var _this2 = this;
	
	      return Object.keys(input).reduce(function (output, key, index) {
	        var value = input[key];
	        return value !== undefined && value !== null ? _extends({}, output, _defineProperty({}, key, _this2.normalizeValue(value, input, key, visit, addEntity))) : output;
	      }, {});
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(input, unvisit) {
	      var _this3 = this;
	
	      return Object.keys(input).reduce(function (output, key) {
	        var entityOrId = input[key];
	        return _extends({}, output, _defineProperty({}, key, _this3.denormalizeValue(entityOrId, unvisit)));
	      }, {});
	    }
	  }]);
	
	  return ValuesSchema;
	}(_Polymorphic2.default);
	
	exports.default = ValuesSchema;

/***/ },
/* 561 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 562 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.9.3
	module.exports = function(text, length, options) {
	  var escapecolor, i, invert, j, pad, padlength, ref, ref1;
	  if (options == null) {
	    options = {};
	  }
	  invert = typeof text === 'number';
	  if (invert) {
	    ref = [text, length], length = ref[0], text = ref[1];
	  }
	  if (typeof options === 'string') {
	    options = {
	      char: options
	    };
	  }
	  if (options.char == null) {
	    options.char = ' ';
	  }
	  if (options.strip == null) {
	    options.strip = false;
	  }
	  text = text.toString();
	  pad = '';
	  if (options.colors) {
	    escapecolor = /\x1B\[([0-9]{1,2}(;[0-9]{1,2})?)?[m|K]/g;
	    length += text.length - text.replace(escapecolor, '').length;
	  }
	  padlength = length - text.length;
	  if (padlength < 0) {
	    if (options.strip) {
	      if (invert) {
	        return text.substr(length * -1);
	      } else {
	        return text.substr(0, length);
	      }
	    }
	    return text;
	  }
	  for (i = j = 0, ref1 = padlength; 0 <= ref1 ? j < ref1 : j > ref1; i = 0 <= ref1 ? ++j : --j) {
	    pad += options.char;
	  }
	  if (invert) {
	    return pad + text;
	  } else {
	    return text + pad;
	  }
	};


/***/ },
/* 563 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(253);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(253);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(567);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 567 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(569),r=__webpack_require__(678);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ },
/* 569 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 570 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _PropTypes = __webpack_require__(256);
	
	var _warning = _interopRequireDefault(__webpack_require__(166));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(254));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(580));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(573));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(574));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(575));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(576));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(95);
	
	var _wrapMapToProps = __webpack_require__(255);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(255);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(257));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(577));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(166));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 578 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 579 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 580 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 581 */,
/* 582 */,
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "v1", {
	  enumerable: true,
	  get: function () {
	    return _v.default;
	  }
	});
	Object.defineProperty(exports, "v3", {
	  enumerable: true,
	  get: function () {
	    return _v2.default;
	  }
	});
	Object.defineProperty(exports, "v4", {
	  enumerable: true,
	  get: function () {
	    return _v3.default;
	  }
	});
	Object.defineProperty(exports, "v5", {
	  enumerable: true,
	  get: function () {
	    return _v4.default;
	  }
	});
	
	var _v = _interopRequireDefault(__webpack_require__(586));
	
	var _v2 = _interopRequireDefault(__webpack_require__(587));
	
	var _v3 = _interopRequireDefault(__webpack_require__(588));
	
	var _v4 = _interopRequireDefault(__webpack_require__(589));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 584 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/*
	 * Browser-compatible JavaScript MD5
	 *
	 * Modification of JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	function md5(bytes) {
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
	}
	/*
	 * Convert an array of little-endian words to an array of bytes
	 */
	
	
	function md5ToHexEncodedArray(input) {
	  var i;
	  var x;
	  var output = [];
	  var length32 = input.length * 32;
	  var hexTab = '0123456789abcdef';
	  var hex;
	
	  for (i = 0; i < length32; i += 8) {
	    x = input[i >> 5] >>> i % 32 & 0xff;
	    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
	    output.push(hex);
	  }
	
	  return output;
	}
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length.
	 */
	
	
	function wordsToMd5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	
	  return [a, b, c, d];
	}
	/*
	 * Convert an array bytes to an array of little-endian words
	 * Characters >255 have their high-byte silently ignored.
	 */
	
	
	function bytesToWords(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	
	  var length8 = input.length * 8;
	
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
	  }
	
	  return output;
	}
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	
	
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xffff;
	}
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	
	
	function bitRotateLeft(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	}
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	
	
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn(b & c | ~b & d, a, b, x, s, t);
	}
	
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn(b & d | c & ~d, a, b, x, s, t);
	}
	
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	var _default = md5;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 585 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	// Adapted from Chris Veness' SHA1 code at
	// http://www.movable-type.co.uk/scripts/sha1.html
	function f(s, x, y, z) {
	  switch (s) {
	    case 0:
	      return x & y ^ ~x & z;
	
	    case 1:
	      return x ^ y ^ z;
	
	    case 2:
	      return x & y ^ x & z ^ y & z;
	
	    case 3:
	      return x ^ y ^ z;
	  }
	}
	
	function ROTL(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function sha1(bytes) {
	  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
	  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  bytes.push(0x80);
	  var l = bytes.length / 4 + 2;
	  var N = Math.ceil(l / 16);
	  var M = new Array(N);
	
	  for (var i = 0; i < N; i++) {
	    M[i] = new Array(16);
	
	    for (var j = 0; j < 16; j++) {
	      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
	    }
	  }
	
	  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
	  M[N - 1][14] = Math.floor(M[N - 1][14]);
	  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
	
	  for (var i = 0; i < N; i++) {
	    var W = new Array(80);
	
	    for (var t = 0; t < 16; t++) W[t] = M[i][t];
	
	    for (var t = 16; t < 80; t++) {
	      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
	    }
	
	    var a = H[0];
	    var b = H[1];
	    var c = H[2];
	    var d = H[3];
	    var e = H[4];
	
	    for (var t = 0; t < 80; t++) {
	      var s = Math.floor(t / 20);
	      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
	      e = d;
	      d = c;
	      c = ROTL(b, 30) >>> 0;
	      b = a;
	      a = T;
	    }
	
	    H[0] = H[0] + a >>> 0;
	    H[1] = H[1] + b >>> 0;
	    H[2] = H[2] + c >>> 0;
	    H[3] = H[3] + d >>> 0;
	    H[4] = H[4] + e >>> 0;
	  }
	
	  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
	}
	
	var _default = sha1;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(258));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(167));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	var _nodeId;
	
	var _clockseq; // Previous uuid creation time
	
	
	var _lastMSecs = 0;
	var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
	
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	
	  if (node == null || clockseq == null) {
	    var seedBytes = options.random || (options.rng || _rng.default)();
	
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
	    }
	
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	
	
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
	
	  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
	
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	
	
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  } // Per 4.2.1.2 Throw error if too many uuids are requested
	
	
	  if (nsecs >= 10000) {
	    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	
	  msecs += 12219292800000; // `time_low`
	
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff; // `time_mid`
	
	  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff; // `time_high_and_version`
	
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	
	  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	
	  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
	
	  b[i++] = clockseq & 0xff; // `node`
	
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : (0, _bytesToUuid.default)(b);
	}
	
	var _default = v1;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(259));
	
	var _md = _interopRequireDefault(__webpack_require__(584));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v3 = (0, _v.default)('v3', 0x30, _md.default);
	var _default = v3;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(258));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(167));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof options == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	
	
	  rnds[6] = rnds[6] & 0x0f | 0x40;
	  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
	
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || (0, _bytesToUuid.default)(rnds);
	}
	
	var _default = v4;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(259));
	
	var _sha = _interopRequireDefault(__webpack_require__(585));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v5 = (0, _v.default)('v5', 0x50, _sha.default);
	var _default = v5;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(260);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(591);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(423);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(425);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(427);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(426);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(47);
	
	var _PropTypes = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(594),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ },
/* 594 */
569,
/* 595 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	};
	
	module.exports = exports["default"];

/***/ },
/* 596 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAction;
	function identity(t) {
	  return t;
	}
	
	function createAction(type, actionCreator, metaCreator) {
	  var finalActionCreator = typeof actionCreator === 'function' ? actionCreator : identity;
	
	  var actionHandler = function actionHandler() {
	    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;
	
	    var action = {
	      type: type
	    };
	
	    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalActionCreator.apply(undefined, arguments);
	    if (!(payload === null || payload === undefined)) {
	      action.payload = payload;
	    }
	
	    if (hasError) {
	      // Handle FSA errors where the payload is an Error object. Set error.
	      action.error = true;
	    }
	
	    if (typeof metaCreator === 'function') {
	      action.meta = metaCreator.apply(undefined, arguments);
	    }
	
	    return action;
	  };
	
	  actionHandler.toString = function () {
	    return type;
	  };
	
	  return actionHandler;
	}

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleActions;
	
	var _handleAction = __webpack_require__(262);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _ownKeys = __webpack_require__(599);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _reduceReducers = __webpack_require__(595);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function handleActions(handlers, defaultState) {
	  var reducers = (0, _ownKeys2.default)(handlers).map(function (type) {
	    return (0, _handleAction2.default)(type, handlers[type]);
	  });
	  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
	
	  return typeof defaultState !== 'undefined' ? function () {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	    var action = arguments[1];
	    return reducer(state, action);
	  } : reducer;
	}

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleActions = exports.handleAction = exports.createAction = undefined;
	
	var _createAction = __webpack_require__(596);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _handleAction = __webpack_require__(262);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(597);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createAction = _createAction2.default;
	exports.handleAction = _handleAction2.default;
	exports.handleActions = _handleActions2.default;

/***/ },
/* 599 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownKeys;
	function ownKeys(object) {
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactRedux = __webpack_require__(8);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(265));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(270));
	
	var _eventConsts = __webpack_require__(668);
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(272));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(62));
	
	var _isEvent = _interopRequireDefault(__webpack_require__(169));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && typeof entity === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	function createConnectedField(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain["default"].getIn(syncErrors, name); // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	
	
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedField, _Component);
	
	    function ConnectedField() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.isPristine = function () {
	        return _this.props.pristine;
	      };
	
	      _this.getValue = function () {
	        return _this.props.value;
	      };
	
	      _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            name = _this$props.name,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            normalize = _this$props.normalize,
	            onChange = _this$props.onChange,
	            _reduxForm = _this$props._reduxForm,
	            previousValue = _this$props.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        });
	        var defaultPrevented = false;
	
	        if (onChange) {
	          // Can't seem to find a way to extend Event in React Native,
	          // thus I simply avoid adding preventDefault() in a RN environment
	          // to prevent the following error:
	          // `One of the sources for assign has an enumerable key on the prototype chain`
	          // Reference: https://github.com/facebook/react-native/issues/5507
	          if (!_isReactNative["default"] && (0, _isEvent["default"])(event)) {
	            onChange((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            var onChangeResult = onChange(event, newValue, previousValue, name); // Return value of change handler affecting preventDefault is RN
	            // specific behavior.
	
	            if (_isReactNative["default"]) {
	              defaultPrevented = onChangeResult;
	            }
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue)); // call post-change callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'change');
	          }
	        }
	      };
	
	      _this.handleFocus = function (event) {
	        var _this$props2 = _this.props,
	            name = _this$props2.name,
	            dispatch = _this$props2.dispatch,
	            onFocus = _this$props2.onFocus,
	            _reduxForm = _this$props2._reduxForm;
	        var defaultPrevented = false;
	
	        if (onFocus) {
	          if (!_isReactNative["default"]) {
	            onFocus((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), name);
	          } else {
	            defaultPrevented = onFocus(event, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      };
	
	      _this.handleBlur = function (event) {
	        var _this$props3 = _this.props,
	            name = _this$props3.name,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            normalize = _this$props3.normalize,
	            onBlur = _this$props3.onBlur,
	            _reduxForm = _this$props3._reduxForm,
	            _value = _this$props3._value,
	            previousValue = _this$props3.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        }); // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	
	        if (onBlur) {
	          if (!_isReactNative["default"]) {
	            onBlur((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            defaultPrevented = onBlur(event, newValue, previousValue, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue)); // call post-blur callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'blur');
	          }
	        }
	      };
	
	      _this.handleDragStart = function (event) {
	        var _this$props4 = _this.props,
	            name = _this$props4.name,
	            onDragStart = _this$props4.onDragStart,
	            value = _this$props4.value;
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event, name);
	        }
	      };
	
	      _this.handleDrop = function (event) {
	        var _this$props5 = _this.props,
	            name = _this$props5.name,
	            dispatch = _this$props5.dispatch,
	            onDrop = _this$props5.onDrop,
	            _reduxForm = _this$props5._reduxForm,
	            previousValue = _this$props5.value;
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	        var defaultPrevented = false;
	
	        if (onDrop) {
	          onDrop((0, _extends2["default"])({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue, name);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedField.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        if (~(nextProps.immutableProps || []).indexOf(prop)) {
	          return _this2.props[prop] !== nextProps[prop];
	        }
	
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props6 = this.props,
	          component = _this$props6.component,
	          forwardRef = _this$props6.forwardRef,
	          name = _this$props6.name,
	          _reduxForm = _this$props6._reduxForm,
	          normalize = _this$props6.normalize,
	          onBlur = _this$props6.onBlur,
	          onChange = _this$props6.onChange,
	          onFocus = _this$props6.onFocus,
	          onDragStart = _this$props6.onDragStart,
	          onDrop = _this$props6.onDrop,
	          immutableProps = _this$props6.immutableProps,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props6, ["component", "forwardRef", "name", "_reduxForm", "normalize", "onBlur", "onChange", "onFocus", "onDragStart", "onDrop", "immutableProps"]);
	
	      var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, rest, {
	        form: _reduxForm.form,
	        onBlur: this.handleBlur,
	        onChange: this.handleChange,
	        onDrop: this.handleDrop,
	        onDragStart: this.handleDragStart,
	        onFocus: this.handleFocus
	      })),
	          custom = _createFieldProps.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	      if (forwardRef) {
	        custom.ref = this.ref;
	      }
	
	      if (typeof component === 'string') {
	        var input = props.input,
	            meta = props.meta; // eslint-disable-line no-unused-vars
	        // flatten input into other props
	
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, input, {}, custom));
	      } else {
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, props, {}, custom));
	      }
	    };
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initialState = getIn(formState, "initial." + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for radios)
	
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedField);
	}
	
	var _default = createConnectedField;
	exports["default"] = _default;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFieldArray;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(80));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(163));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactRedux = __webpack_require__(8);
	
	var _redux = __webpack_require__(95);
	
	var _createFieldArrayProps = _interopRequireDefault(__webpack_require__(612));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(62));
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	function createConnectedFieldArray(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size,
	      equals = structure.equals,
	      orderChanged = structure.orderChanged;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain["default"].getIn(syncErrors, name + "._error");
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + "._warning");
	  };
	
	  var ConnectedFieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.getValue = function (index) {
	        return _this.props.value && getIn(_this.props.value, String(index));
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedFieldArray.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      // Update if the elements of the value array was updated.
	      var thisValue = this.props.value;
	      var nextValue = nextProps.value;
	
	      if (thisValue && nextValue) {
	        var nextValueItemsSame = equals(nextValue, thisValue); //.every(val => ~thisValue.indexOf(val))
	
	        var nextValueItemsOrderChanged = orderChanged(thisValue, nextValue);
	        var thisValueLength = thisValue.length || thisValue.size;
	        var nextValueLength = nextValue.length || nextValue.size;
	
	        if (thisValueLength !== nextValueLength || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
	          return !deepEqual(val, nextValue[index]);
	        })) {
	          return true;
	        }
	      }
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        // useful to debug rerenders
	        // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	        //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	        // }
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props = this.props,
	          component = _this$props.component,
	          forwardRef = _this$props.forwardRef,
	          name = _this$props.name,
	          _reduxForm = _this$props._reduxForm,
	          validate = _this$props.validate,
	          warn = _this$props.warn,
	          rerenderOnEveryChange = _this$props.rerenderOnEveryChange,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["component", "forwardRef", "name", "_reduxForm", "validate", "warn", "rerenderOnEveryChange"]);
	      var props = (0, _createFieldArrayProps["default"])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return (0, _react.createElement)(component, props);
	    };
	
	    (0, _createClass2["default"])(ConnectedFieldArray, [{
	      key: "dirty",
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    rerenderOnEveryChange: _propTypes["default"].bool
	  };
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initial = getIn(formState, "initial." + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name + "._error"),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name + "._error"),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	    return (0, _mapValues2["default"])({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFieldArray);
	}

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactRedux = __webpack_require__(8);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(265));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(270));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(62));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	function createConnectedFields(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain["default"].getIn(syncErrors, name + "._error") || _plain["default"].getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFields, _React$Component);
	
	    function ConnectedFields(props) {
	      var _this;
	
	      _this = _React$Component.call(this, props) || this;
	      _this.onChangeFns = {};
	      _this.onFocusFns = {};
	      _this.onBlurFns = {};
	      _this.ref = _react["default"].createRef();
	
	      _this.prepareEventHandlers = function (_ref) {
	        var names = _ref.names;
	        return names.forEach(function (name) {
	          _this.onChangeFns[name] = function (event) {
	            return _this.handleChange(name, event);
	          };
	
	          _this.onFocusFns[name] = function () {
	            return _this.handleFocus(name);
	          };
	
	          _this.onBlurFns[name] = function (event) {
	            return _this.handleBlur(name, event);
	          };
	        });
	      };
	
	      _this.handleChange = function (name, event) {
	        var _this$props = _this.props,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            _reduxForm = _this$props._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        });
	        dispatch(_reduxForm.change(name, value)); // call post-change callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'change');
	        }
	      };
	
	      _this.handleFocus = function (name) {
	        var _this$props2 = _this.props,
	            dispatch = _this$props2.dispatch,
	            _reduxForm = _this$props2._reduxForm;
	        dispatch(_reduxForm.focus(name));
	      };
	
	      _this.handleBlur = function (name, event) {
	        var _this$props3 = _this.props,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            _reduxForm = _this$props3._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        }); // dispatch blur action
	
	        dispatch(_reduxForm.blur(name, value)); // call post-blur callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'blur');
	        }
	      };
	
	      _this.prepareEventHandlers(props);
	
	      return _this;
	    }
	
	    var _proto = ConnectedFields.prototype;
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	        return !_this2.props._fields[nextName];
	      }))) {
	        // names has changed. The cached event handlers need to be updated
	        this.prepareEventHandlers(nextProps);
	      }
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this3 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.isDirty = function isDirty() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).some(function (name) {
	        return _fields[name].dirty;
	      });
	    };
	
	    _proto.getValues = function getValues() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).reduce(function (accumulator, name) {
	        return _plain["default"].setIn(accumulator, name, _fields[name].value);
	      }, {});
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          component = _this$props4.component,
	          forwardRef = _this$props4.forwardRef,
	          _fields = _this$props4._fields,
	          _reduxForm = _this$props4._reduxForm,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props4, ["component", "forwardRef", "_fields", "_reduxForm"]);
	      var sectionPrefix = _reduxForm.sectionPrefix,
	          form = _reduxForm.form;
	
	      var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	        var connectedProps = _fields[name];
	
	        var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, connectedProps, {}, rest, {
	          form: form,
	          onBlur: _this4.onBlurFns[name],
	          onChange: _this4.onChangeFns[name],
	          onFocus: _this4.onFocusFns[name]
	        })),
	            custom = _createFieldProps.custom,
	            fieldProps = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	        accumulator.custom = custom;
	        var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	        return _plain["default"].setIn(accumulator, fieldName, fieldProps);
	      }, {}),
	          custom = _Object$keys$reduce.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_Object$keys$reduce, ["custom"]);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return _react["default"].createElement(component, (0, _extends2["default"])({}, props, {}, custom));
	    };
	
	    return ConnectedFields;
	  }(_react["default"].Component);
	
	  ConnectedFields.propTypes = {
	    component: _validateComponentProp["default"],
	    _fields: _propTypes["default"].object.isRequired,
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, "initial." + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, "values." + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, "asyncErrors." + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          initial: initial,
	          pristine: pristine,
	          state: getIn(formState, "fields." + name),
	          submitError: getIn(formState, "submitErrors." + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for radios)
	
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFields);
	}

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createField = _interopRequireDefault(__webpack_require__(610));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createField["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFieldArray = _interopRequireDefault(__webpack_require__(611));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createFieldArray["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFields = _interopRequireDefault(__webpack_require__(613));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createFields["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	var Form = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.onSubmit !== prevProps.onSubmit) {
	      this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm"]);
	    return /*#__PURE__*/_react["default"].createElement("form", rest);
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes["default"].func.isRequired,
	  _reduxForm: _propTypes["default"].object
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(Form);
	
	exports["default"] = _default;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	var FormName = function FormName(_ref) {
	  var children = _ref.children,
	      _reduxForm = _ref._reduxForm;
	  return children({
	    form: _reduxForm && _reduxForm.form,
	    sectionPrefix: _reduxForm && _reduxForm.sectionPrefix
	  });
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormName);
	
	exports["default"] = _default;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(93));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(62));
	
	var FormSection = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(FormSection, _Component);
	
	  function FormSection(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = FormSection.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        children = _this$props.children,
	        name = _this$props.name,
	        component = _this$props.component,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm", "children", "name", "component"]);
	
	    if (_react["default"].isValidElement(children)) {
	      return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	        value: (0, _extends2["default"])({}, this.props._reduxForm, {
	          sectionPrefix: (0, _prefixName["default"])(this.props, name)
	        }),
	        children: children
	      });
	    }
	
	    return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	      value: (0, _extends2["default"])({}, this.props._reduxForm, {
	        sectionPrefix: (0, _prefixName["default"])(this.props, name)
	      }),
	      children: (0, _react.createElement)(component, (0, _extends2["default"])({}, rest, {
	        children: children
	      }))
	    });
	  };
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes["default"].string.isRequired,
	  component: _validateComponentProp["default"]
	};
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormSection);
	
	exports["default"] = _default;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPromise = _interopRequireDefault(__webpack_require__(153));
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	
	  if (!(0, _isPromise["default"])(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (rejected) {
	        if (errors && Object.keys(errors).length) {
	          stop(errors);
	          return errors;
	        } else {
	          stop();
	          throw new Error('Asynchronous validation promise was rejected without errors.');
	        }
	      }
	
	      stop();
	      return Promise.resolve();
	    };
	  };
	
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	var _default = asyncValidation;
	exports["default"] = _default;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(80));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _invariant = _interopRequireDefault(__webpack_require__(76));
	
	var _ConnectedField = _interopRequireDefault(__webpack_require__(600));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(274));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(93));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(62));
	
	function createField(structure) {
	  var ConnectedField = (0, _ConnectedField["default"])(structure);
	  var setIn = structure.setIn;
	
	  var Field = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Field, _Component);
	
	    function Field(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.normalize = function (name, value) {
	        var normalize = _this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	
	        var previousValues = _this.props._reduxForm.getValues();
	
	        var previousValue = _this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues, name);
	      };
	
	      if (!props._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = Field.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'Field', function () {
	        return _this2.props.validate;
	      }, function () {
	        return _this2.props.warn;
	      });
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shallowCompare["default"])(this, nextProps, nextState);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName || // use deepEqual here because they could be a function or an array of functions
	      !_plain["default"].deepEqual(this.props.validate, nextProps.validate) || !_plain["default"].deepEqual(this.props.warn, nextProps.warn)) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'Field', function () {
	          return nextProps.validate;
	        }, function () {
	          return nextProps.warn;
	        });
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Field');
	      return this.ref.current ? this.ref.current.getRenderedComponent() : undefined;
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedField, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        normalize: this.normalize,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(Field, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref.current && this.ref.current.isPristine());
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref.current && this.ref.current.getValue();
	      }
	    }]);
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    format: _propTypes["default"].func,
	    normalize: _propTypes["default"].func,
	    onBlur: _propTypes["default"].func,
	    onChange: _propTypes["default"].func,
	    onFocus: _propTypes["default"].func,
	    onDragStart: _propTypes["default"].func,
	    onDrop: _propTypes["default"].func,
	    parse: _propTypes["default"].func,
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(Field);
	}
	
	var _default = createField;
	exports["default"] = _default;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createFieldArray;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(80));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _invariant = _interopRequireDefault(__webpack_require__(76));
	
	var _ConnectedFieldArray = _interopRequireDefault(__webpack_require__(601));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(93));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(62));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	
	      if (result) {
	        var _ref;
	
	        return _ref = {}, _ref[key] = result, _ref;
	      }
	    }
	  };
	};
	
	function createFieldArray(structure) {
	  var ConnectedFieldArray = (0, _ConnectedFieldArray["default"])(structure);
	
	  var FieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(FieldArray, _Component);
	
	    function FieldArray(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      if (!props._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = FieldArray.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'FieldArray', function () {
	        return wrapError(_this2.props.validate, '_error');
	      }, function () {
	        return wrapError(_this2.props.warn, '_warning');
	      });
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'FieldArray');
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to FieldArray');
	      return this.ref && this.ref.current.getRenderedComponent();
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedFieldArray, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(FieldArray, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.ref || this.ref.current.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref && this.ref.current.pristine);
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref ? this.ref.current.value : undefined;
	      }
	    }]);
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(FieldArray);
	}

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createFieldArrayProps;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	function createFieldArrayProps(_ref, name, form, sectionPrefix, getValue, _ref2) {
	  var getIn = _ref.getIn;
	  var arrayInsert = _ref2.arrayInsert,
	      arrayMove = _ref2.arrayMove,
	      arrayPop = _ref2.arrayPop,
	      arrayPush = _ref2.arrayPush,
	      arrayRemove = _ref2.arrayRemove,
	      arrayRemoveAll = _ref2.arrayRemoveAll,
	      arrayShift = _ref2.arrayShift,
	      arraySplice = _ref2.arraySplice,
	      arraySwap = _ref2.arraySwap,
	      arrayUnshift = _ref2.arrayUnshift,
	      asyncError = _ref2.asyncError,
	      dirty = _ref2.dirty,
	      length = _ref2.length,
	      pristine = _ref2.pristine,
	      submitError = _ref2.submitError,
	      state = _ref2.state,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      value = _ref2.value,
	      props = _ref2.props,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncError", "dirty", "length", "pristine", "submitError", "state", "submitFailed", "submitting", "syncError", "syncWarning", "value", "props"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	  var finalProps = (0, _extends2["default"])({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, String(length - 1));
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + "[" + index + "]", index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, '0');
	      },
	      splice: arraySplice,
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, {}, rest);
	  return finalProps;
	}

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(80));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _invariant = _interopRequireDefault(__webpack_require__(76));
	
	var _get = _interopRequireDefault(__webpack_require__(249));
	
	var _ConnectedFields = _interopRequireDefault(__webpack_require__(602));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(274));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(93));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(62));
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var warnAndValidatePropType = _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func), _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]))]);
	
	var fieldsPropTypes = {
	  component: _validateComponentProp["default"],
	  format: _propTypes["default"].func,
	  parse: _propTypes["default"].func,
	  props: _propTypes["default"].object,
	  forwardRef: _propTypes["default"].bool,
	  validate: warnAndValidatePropType,
	  warn: warnAndValidatePropType
	};
	
	var getFieldWarnAndValidate = function getFieldWarnAndValidate(prop, name) {
	  return Array.isArray(prop) || typeof prop === 'function' ? prop : (0, _get["default"])(prop, name, undefined);
	};
	
	function createFields(structure) {
	  var ConnectedFields = (0, _ConnectedFields["default"])(structure);
	
	  var Fields = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Fields, _Component);
	
	    function Fields(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.connected = (0, _react.createRef)();
	
	      if (!props._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	
	      var error = validateNameProp(props.names);
	
	      if (error) {
	        throw error;
	      }
	
	      return _this;
	    }
	
	    var _proto = Fields.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      return (0, _shallowCompare["default"])(this, nextProps);
	    };
	
	    _proto.componentDidMount = function componentDidMount() {
	      this.registerFields(this.props.names);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (!_plain["default"].deepEqual(this.props.names, nextProps.names)) {
	        var props = this.props;
	        var unregister = props._reduxForm.unregister; // unregister old name
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName["default"])(props, name));
	        }); // register new name
	
	        this.registerFields(nextProps.names);
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      var props = this.props;
	      var unregister = props._reduxForm.unregister;
	      this.props.names.forEach(function (name) {
	        return unregister((0, _prefixName["default"])(props, name));
	      });
	    };
	
	    _proto.registerFields = function registerFields(names) {
	      var _this2 = this;
	
	      var props = this.props;
	      var register = props._reduxForm.register;
	      names.forEach(function (name) {
	        return register((0, _prefixName["default"])(props, name), 'Field', function () {
	          return getFieldWarnAndValidate(_this2.props.validate, name);
	        }, function () {
	          return getFieldWarnAndValidate(_this2.props.warn, name);
	        });
	      });
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Fields');
	      return this.connected.current ? this.connected.current.getRenderedComponent() : null;
	    };
	
	    _proto.render = function render() {
	      var props = this.props;
	      return (0, _react.createElement)(ConnectedFields, (0, _extends2["default"])({}, this.props, {
	        names: this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        }),
	        ref: this.connected
	      }));
	    };
	
	    (0, _createClass2["default"])(Fields, [{
	      key: "names",
	      get: function get() {
	        var props = this.props;
	        return this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        });
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return this.connected.current ? this.connected.current.isDirty() : false;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: "values",
	      get: function get() {
	        return this.connected.current ? this.connected.current.getValues() : {};
	      }
	    }]);
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = (0, _extends2["default"])({
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    }
	  }, fieldsPropTypes);
	  return (0, _ReduxFormContext.withReduxForm)(Fields);
	}

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createFormValueSelector;
	
	var _invariant = _interopRequireDefault(__webpack_require__(76));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    (0, _invariant["default"])(form, 'Form value must be specified');
	
	    var nonNullGetFormState = getFormState || function (state) {
	      return getIn(state, 'form');
	    };
	
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant["default"])(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(nonNullGetFormState(state), form + ".values." + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(nonNullGetFormState(state), form + ".values." + field);
	        return value === undefined ? accumulator : _plain["default"].setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	}

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(163));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(546));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(545));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(8);
	
	var _prefixName = _interopRequireDefault(__webpack_require__(93));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (firstArg) {
	    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(FormValues, _React$Component);
	
	        function FormValues(props) {
	          var _this;
	
	          _this = _React$Component.call(this, props) || this;
	
	          if (!props._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	
	          _this.updateComponent(props);
	
	          return _this;
	        }
	
	        var _proto = FormValues.prototype;
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
	          if (typeof firstArg === 'function') {
	            this.updateComponent(props);
	          }
	        };
	
	        _proto.render = function render() {
	          var Component = this.Component;
	          return /*#__PURE__*/_react["default"].createElement(Component // so that the connected component updates props when sectionPrefix has changed
	          , (0, _extends2["default"])({
	            sectionPrefix: this.props._reduxForm.sectionPrefix
	          }, this.props));
	        };
	
	        _proto.updateComponent = function updateComponent(props) {
	          var valuesMap;
	          var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
	
	          if (typeof resolvedFirstArg === 'string') {
	            var _rest$reduce;
	
	            valuesMap = rest.reduce(function (result, k) {
	              result[k] = k;
	              return result;
	            }, (_rest$reduce = {}, _rest$reduce[resolvedFirstArg] = resolvedFirstArg, _rest$reduce));
	          } else {
	            valuesMap = resolvedFirstArg;
	          }
	
	          if ((0, _isEmpty2["default"])(valuesMap)) {
	            // maybe that empty valuesMap is ok if firstArg is a function?
	            // if this is the case, we probably should set this.Component = Component
	            throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
	          }
	
	          if ((0, _isEqual2["default"])(valuesMap, this._valuesMap)) {
	            // no change in valuesMap
	            return;
	          }
	
	          this._valuesMap = valuesMap;
	          this.setComponent();
	        };
	
	        _proto.setComponent = function setComponent() {
	          var _this2 = this;
	
	          var formValuesSelector = function formValuesSelector(_, _ref2) {
	            var sectionPrefix = _ref2.sectionPrefix;
	            // Yes, we're only using connect() for listening to updates.
	            // The second argument needs to be there so that connect calls
	            // the selector when props change
	            var getValues = _this2.props._reduxForm.getValues;
	            var values = getValues();
	            return (0, _mapValues2["default"])(_this2._valuesMap, function (path) {
	              return getIn(values, (0, _prefixName["default"])(_this2.props, path));
	            });
	          };
	
	          this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	            return {};
	          } // ignore dispatch
	          )(function (_ref3) {
	            var sectionPrefix = _ref3.sectionPrefix,
	                otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["sectionPrefix"]);
	            return /*#__PURE__*/_react["default"].createElement(Component, otherProps);
	          });
	        };
	
	        return FormValues;
	      }(_react["default"].Component);
	
	      return (0, _ReduxFormContext.withReduxForm)(FormValues);
	    };
	  };
	}

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(119));
	
	var _actionTypes = __webpack_require__(168);
	
	var _deleteInWithCleanUp = _interopRequireDefault(__webpack_require__(619));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var shouldDelete = function shouldDelete(_ref) {
	  var getIn = _ref.getIn;
	  return function (state, path) {
	    var initialValuesPath = null;
	
	    if (/^values/.test(path)) {
	      initialValuesPath = path.replace('values', 'initial');
	    }
	
	    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;
	    return getIn(state, path) !== undefined && initialValueComparison;
	  };
	};
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      forEach = structure.forEach,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(structure)(shouldDelete);
	  var plainDeleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(_plain["default"])(shouldDelete);
	
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + "." + field);
	    return existing || force ? setIn(state, key + "." + field, splice(existing, index, removeNum, value)) : state;
	  };
	
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	
	    var existing = _plain["default"].getIn(slice, field);
	
	    return existing || force ? setIn(state, key, _plain["default"].setIn(slice, field, _plain["default"].splice(existing, index, removeNum, value))) : state;
	  };
	
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ARRAY_INSERT] = function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        index = _ref2$meta.index,
	        payload = _ref2.payload;
	    return arraySplice(state, field, index, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_MOVE] = function (state, _ref3) {
	    var _ref3$meta = _ref3.meta,
	        field = _ref3$meta.field,
	        from = _ref3$meta.from,
	        to = _ref3$meta.to;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + "." + field;
	
	        if (getIn(result, path)) {
	          var value = getIn(result, path + "[" + from + "]");
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_POP] = function (state, _ref4) {
	    var field = _ref4.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }, _behaviors[_actionTypes.ARRAY_PUSH] = function (state, _ref5) {
	    var field = _ref5.meta.field,
	        payload = _ref5.payload;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE] = function (state, _ref6) {
	    var _ref6$meta = _ref6.meta,
	        field = _ref6$meta.field,
	        index = _ref6$meta.index;
	    return arraySplice(state, field, index, 1);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE_ALL] = function (state, _ref7) {
	    var field = _ref7.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }, _behaviors[_actionTypes.ARRAY_SHIFT] = function (state, _ref8) {
	    var field = _ref8.meta.field;
	    return arraySplice(state, field, 0, 1);
	  }, _behaviors[_actionTypes.ARRAY_SPLICE] = function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        index = _ref9$meta.index,
	        removeNum = _ref9$meta.removeNum,
	        payload = _ref9.payload;
	    return arraySplice(state, field, index, removeNum, payload);
	  }, _behaviors[_actionTypes.ARRAY_SWAP] = function (state, _ref10) {
	    var _ref10$meta = _ref10.meta,
	        field = _ref10$meta.field,
	        indexA = _ref10$meta.indexA,
	        indexB = _ref10$meta.indexB;
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + "." + field + "[" + indexA + "]");
	      var valueB = getIn(result, key + "." + field + "[" + indexB + "]");
	
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + "." + field + "[" + indexA + "]", valueB);
	        result = setIn(result, key + "." + field + "[" + indexB + "]", valueA);
	      }
	    });
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_UNSHIFT] = function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	    return arraySplice(state, field, 0, 0, payload);
	  }, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref12) {
	    var field = _ref12.meta.field,
	        payload = _ref12.payload;
	    var result = state;
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	    result = deleteInWithCleanUp(result, "submitErrors." + field);
	    result = setIn(result, "fields." + field + ".autofilled", true);
	    result = setIn(result, "values." + field, payload);
	    return result;
	  }, _behaviors[_actionTypes.BLUR] = function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        payload = _ref13.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	
	    result = deleteIn(result, "fields." + field + ".active");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CHANGE] = function (state, _ref14) {
	    var _ref14$meta = _ref14.meta,
	        field = _ref14$meta.field,
	        touch = _ref14$meta.touch,
	        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
	        payload = _ref14.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '' || payload === undefined) {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if ((0, _isFunction2["default"])(payload)) {
	      var fieldCurrentValue = getIn(state, "values." + field);
	      result = setIn(result, "values." + field, payload(fieldCurrentValue, state.values));
	    } else {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, "submitErrors." + field);
	    }
	
	    result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT] = function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT_ERRORS] = function (state) {
	    var result = state;
	    result = deleteInWithCleanUp(result, 'submitErrors');
	    result = deleteIn(result, 'error');
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_ASYNC_ERROR] = function (state, _ref15) {
	    var field = _ref15.meta.field;
	    return deleteIn(state, "asyncErrors." + field);
	  }, _behaviors[_actionTypes.CLEAR_FIELDS] = function (state, _ref16) {
	    var _ref16$meta = _ref16.meta,
	        keepTouched = _ref16$meta.keepTouched,
	        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
	        fields = _ref16$meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	      if (!persistentSubmitErrors) {
	        result = deleteInWithCleanUp(result, "submitErrors." + field);
	      }
	
	      result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	      if (!keepTouched) {
	        result = deleteIn(result, "fields." + field + ".touched");
	      }
	
	      var values = getIn(state, "initial." + field);
	      result = values ? setIn(result, "values." + field, values) : deleteInWithCleanUp(result, "values." + field);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.FOCUS] = function (state, _ref17) {
	    var field = _ref17.meta.field;
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, "fields." + previouslyActive + ".active");
	    result = setIn(result, "fields." + field + ".visited", true);
	    result = setIn(result, "fields." + field + ".active", true);
	    result = setIn(result, 'active', field);
	    return result;
	  }, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref18) {
	    var payload = _ref18.payload,
	        _ref18$meta = _ref18.meta,
	        keepDirty = _ref18$meta.keepDirty,
	        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
	        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
	        keepValues = _ref18$meta.keepValues;
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	
	    var warning = getIn(state, 'warning');
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	
	    var syncWarnings = getIn(state, 'syncWarnings');
	
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } // persist old errors, they will get recalculated if the new form values are different from the old values
	
	
	    var error = getIn(state, 'error');
	
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	
	    var syncErrors = getIn(state, 'syncErrors');
	
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	    var newInitialValues = mapData;
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        var overwritePristineValue = function overwritePristineValue(name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name); // This check prevents any 'setIn' call that would create useless
	            // nested objects, since the path to the new field value would
	            // evaluate to the same (especially for undefined values)
	
	            if (getIn(newValues, name) !== newInitialValue) {
	              newValues = setIn(newValues, name, newInitialValue);
	            }
	          }
	        };
	
	        if (!updateUnregisteredFields) {
	          forEach(keys(registeredFields), function (name) {
	            return overwritePristineValue(name);
	          });
	        }
	
	        forEach(keys(newInitialValues), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	
	          if (updateUnregisteredFields) {
	            overwritePristineValue(name);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepValues) {
	      forEach(keys(previousValues), function (name) {
	        var previousValue = getIn(previousValues, name);
	        newValues = setIn(newValues, name, previousValue);
	      });
	      forEach(keys(previousInitialValues), function (name) {
	        var previousInitialValue = getIn(previousInitialValues, name);
	        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
	      });
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }, _behaviors[_actionTypes.REGISTER_FIELD] = function (state, _ref19) {
	    var _ref19$payload = _ref19.payload,
	        name = _ref19$payload.name,
	        type = _ref19$payload.type;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(state, key);
	
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({
	        name: name,
	        type: type,
	        count: 1
	      });
	    }
	
	    return setIn(state, key, field);
	  }, _behaviors[_actionTypes.RESET] = function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var values = getIn(state, 'initial');
	
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.RESET_SECTION] = function (state, _ref20) {
	    var sections = _ref20.meta.sections;
	    var result = state;
	    sections.forEach(function (section) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + section);
	      result = deleteInWithCleanUp(result, "submitErrors." + section);
	      result = deleteInWithCleanUp(result, "fields." + section);
	      var values = getIn(state, "initial." + section);
	      result = values ? setIn(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.SUBMIT] = function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref21) {
	    var field = _ref21.meta.field;
	    return setIn(state, 'asyncValidating', field || true);
	  }, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	    return setIn(state, 'submitting', true);
	  }, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref22) {
	    var payload = _ref22.payload;
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref23) {
	    var payload = _ref23.payload;
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_FAILED] = function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_SUCCEEDED] = function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }, _behaviors[_actionTypes.TOUCH] = function (state, _ref25) {
	    var fields = _ref25.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }, _behaviors[_actionTypes.UNREGISTER_FIELD] = function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        name = _ref26$payload.name,
	        destroyOnUnmount = _ref26$payload.destroyOnUnmount;
	    var result = state;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(result, key);
	
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	
	      var syncErrors = getIn(result, 'syncErrors');
	
	      if (syncErrors) {
	        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
	
	        if (_plain["default"].deepEqual(syncErrors, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncErrors');
	        } else {
	          result = setIn(result, 'syncErrors', syncErrors);
	        }
	      }
	
	      var syncWarnings = getIn(result, 'syncWarnings');
	
	      if (syncWarnings) {
	        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
	
	        if (_plain["default"].deepEqual(syncWarnings, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncWarnings');
	        } else {
	          result = setIn(result, 'syncWarnings', syncWarnings);
	        }
	      }
	
	      result = deleteInWithCleanUp(result, "submitErrors." + name);
	      result = deleteInWithCleanUp(result, "asyncErrors." + name);
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref27) {
	    var fields = _ref27.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, "fields." + field + ".touched");
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_ERRORS] = function (state, _ref28) {
	    var _ref28$payload = _ref28.payload,
	        syncErrors = _ref28$payload.syncErrors,
	        error = _ref28$payload.error;
	    var result = state;
	
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_WARNINGS] = function (state, _ref29) {
	    var _ref29$payload = _ref29.payload,
	        syncWarnings = _ref29$payload.syncWarnings,
	        warning = _ref29$payload.warning;
	    var result = state;
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	
	    return result;
	  }, _behaviors);
	
	  var reducer = function reducer(state, action) {
	    if (state === void 0) {
	      state = empty;
	    }
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function (state, action) {
	      if (state === void 0) {
	        state = empty;
	      }
	
	      if (action === void 0) {
	        action = {
	          type: 'NONE'
	        };
	      }
	
	      var form = action && action.meta && action.meta.form;
	
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	
	      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	  /**
	   * Adds additional functionality to the reducer
	   */
	
	
	  function decorate(target) {
	    target.plugin = function (reducers, config) {
	      var _this = this;
	
	      if (config === void 0) {
	        config = {};
	      }
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function (state, action) {
	        if (state === void 0) {
	          state = empty;
	        }
	
	        if (action === void 0) {
	          action = {
	            type: 'NONE'
	          };
	        }
	
	        var callPlugin = function callPlugin(processed, key) {
	          var previousState = getIn(processed, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
	        };
	
	        var processed = _this(state, action); // run through redux-form reducer
	
	
	        var form = action && action.meta && action.meta.form;
	
	        if (form && !config.receiveAllFormActions) {
	          // this is an action aimed at forms, so only give it to the specified form's plugin
	          return reducers[form] ? callPlugin(processed, form) : processed;
	        } else {
	          // this is not a form-specific action, so send it to all the plugins
	          return Object.keys(reducers).reduce(callPlugin, processed);
	        }
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	}
	
	var _default = createReducer;
	exports["default"] = _default;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createReduxForm;
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(80));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(23));
	
	var _merge4 = _interopRequireDefault(__webpack_require__(550));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(163));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(227));
	
	var _invariant = _interopRequireDefault(__webpack_require__(76));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(153));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(8);
	
	var _redux = __webpack_require__(95);
	
	var _actions = _interopRequireDefault(__webpack_require__(264));
	
	var _asyncValidation = _interopRequireDefault(__webpack_require__(609));
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(266));
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(268));
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(267));
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(269));
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(271));
	
	var _silenceEvents = _interopRequireDefault(__webpack_require__(621));
	
	var _generateValidator = _interopRequireDefault(__webpack_require__(624));
	
	var _handleSubmit = _interopRequireDefault(__webpack_require__(634));
	
	var _isValid = _interopRequireDefault(__webpack_require__(170));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(669));
	
	var _isHotReloading = _interopRequireDefault(__webpack_require__(670));
	
	var _ReduxFormContext = __webpack_require__(46);
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	}; // extract field-specific actions
	
	
	var arrayInsert = _actions["default"].arrayInsert,
	    arrayMove = _actions["default"].arrayMove,
	    arrayPop = _actions["default"].arrayPop,
	    arrayPush = _actions["default"].arrayPush,
	    arrayRemove = _actions["default"].arrayRemove,
	    arrayRemoveAll = _actions["default"].arrayRemoveAll,
	    arrayShift = _actions["default"].arrayShift,
	    arraySplice = _actions["default"].arraySplice,
	    arraySwap = _actions["default"].arraySwap,
	    arrayUnshift = _actions["default"].arrayUnshift,
	    blur = _actions["default"].blur,
	    change = _actions["default"].change,
	    focus = _actions["default"].focus,
	    formActions = (0, _objectWithoutPropertiesLoose2["default"])(_actions["default"], ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "blur", "change", "focus"]);
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	var propsToNotUpdateFor = [].concat(Object.keys(_actions["default"]), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS,
	      toJS = structure.toJS;
	  var isValid = (0, _isValid["default"])(structure);
	  return function (initialConfig) {
	    var config = (0, _extends2["default"])({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate["default"],
	      shouldValidate: _defaultShouldValidate["default"],
	      shouldError: _defaultShouldError["default"],
	      shouldWarn: _defaultShouldWarn["default"],
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      updateUnregisteredFields: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false,
	      submitAsSideEffect: false
	    }, initialConfig);
	    return function (WrappedComponent) {
	      var Form = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(Form, _React$Component);
	
	        function Form() {
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	          _this.wrapped = _react["default"].createRef();
	          _this.destroyed = false;
	          _this.fieldCounts = {};
	          _this.fieldValidators = {};
	          _this.lastFieldValidatorKeys = [];
	          _this.fieldWarners = {};
	          _this.lastFieldWarnerKeys = [];
	          _this.innerOnSubmit = undefined;
	          _this.submitPromise = undefined;
	
	          _this.initIfNeeded = function (nextProps) {
	            var enableReinitialize = _this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(_this.props.initialValues, nextProps.initialValues)) {
	                var _keepDirty = nextProps.initialized && _this.props.keepDirtyOnReinitialize;
	
	                _this.props.initialize(nextProps.initialValues, _keepDirty, {
	                  keepValues: nextProps.keepValues,
	                  lastInitialValues: _this.props.initialValues,
	                  updateUnregisteredFields: nextProps.updateUnregisteredFields
	                });
	              }
	            } else if (_this.props.initialValues && (!_this.props.initialized || enableReinitialize)) {
	              _this.props.initialize(_this.props.initialValues, _this.props.keepDirtyOnReinitialize, {
	                keepValues: _this.props.keepValues,
	                updateUnregisteredFields: _this.props.updateUnregisteredFields
	              });
	            }
	          };
	
	          _this.updateSyncErrorsIfNeeded = function (nextSyncErrors, nextError, lastSyncErrors) {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                updateSyncErrors = _this$props.updateSyncErrors;
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	
	            if (!(noErrors && nextNoErrors) && (!_plain["default"].deepEqual(lastSyncErrors, nextSyncErrors) || !_plain["default"].deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          };
	
	          _this.clearSubmitPromiseIfNeeded = function (nextProps) {
	            var submitting = _this.props.submitting;
	
	            if (_this.submitPromise && submitting && !nextProps.submitting) {
	              delete _this.submitPromise;
	            }
	          };
	
	          _this.submitIfNeeded = function (nextProps) {
	            var _this$props2 = _this.props,
	                clearSubmit = _this$props2.clearSubmit,
	                triggerSubmit = _this$props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	
	              _this.submit();
	            }
	          };
	
	          _this.shouldErrorFunction = function () {
	            var _this$props3 = _this.props,
	                shouldValidate = _this$props3.shouldValidate,
	                shouldError = _this$props3.shouldError;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldErrorOverridden = shouldError !== _defaultShouldError["default"];
	            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
	          };
	
	          _this.validateIfNeeded = function (nextProps) {
	            var _this$props4 = _this.props,
	                validate = _this$props4.validate,
	                values = _this$props4.values;
	
	            var shouldError = _this.shouldErrorFunction();
	
	            var fieldLevelValidate = _this.generateValidator();
	
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(_this.getValidators());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              };
	
	              if (shouldError(validateParams)) {
	                var propsToValidate = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge2 = (0, _merge4["default"])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = (0, _objectWithoutPropertiesLoose2["default"])(_merge2, ["_error"]);
	
	                _this.lastFieldValidatorKeys = fieldValidatorKeys;
	
	                _this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            } else {
	              _this.lastFieldValidatorKeys = [];
	            }
	          };
	
	          _this.updateSyncWarningsIfNeeded = function (nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _this$props5 = _this.props,
	                warning = _this$props5.warning,
	                updateSyncWarnings = _this$props5.updateSyncWarnings;
	            var noWarnings = (!lastSyncWarnings || !Object.keys(lastSyncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	
	            if (!(noWarnings && nextNoWarnings) && (!_plain["default"].deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain["default"].deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          };
	
	          _this.shouldWarnFunction = function () {
	            var _this$props6 = _this.props,
	                shouldValidate = _this$props6.shouldValidate,
	                shouldWarn = _this$props6.shouldWarn;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldWarnOverridden = shouldWarn !== _defaultShouldWarn["default"];
	            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
	          };
	
	          _this.warnIfNeeded = function (nextProps) {
	            var _this$props7 = _this.props,
	                warn = _this$props7.warn,
	                values = _this$props7.values;
	
	            var shouldWarn = _this.shouldWarnFunction();
	
	            var fieldLevelWarn = _this.generateWarner();
	
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(_this.getWarners());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              };
	
	              if (shouldWarn(validateParams)) {
	                var propsToWarn = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge3 = (0, _merge4["default"])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = (0, _objectWithoutPropertiesLoose2["default"])(_merge3, ["_warning"]);
	
	                _this.lastFieldWarnerKeys = fieldWarnerKeys;
	
	                _this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          };
	
	          _this.getValues = function () {
	            return _this.props.values;
	          };
	
	          _this.isValid = function () {
	            return _this.props.valid;
	          };
	
	          _this.isPristine = function () {
	            return _this.props.pristine;
	          };
	
	          _this.register = function (name, type, getValidator, getWarner) {
	            var lastCount = _this.fieldCounts[name];
	            var nextCount = (lastCount || 0) + 1;
	            _this.fieldCounts[name] = nextCount;
	
	            _this.props.registerField(name, type);
	
	            if (getValidator) {
	              _this.fieldValidators[name] = getValidator;
	            }
	
	            if (getWarner) {
	              _this.fieldWarners[name] = getWarner;
	            }
	          };
	
	          _this.unregister = function (name) {
	            var lastCount = _this.fieldCounts[name];
	            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;
	
	            if (!_this.destroyed) {
	              var _this$props8 = _this.props,
	                  _destroyOnUnmount = _this$props8.destroyOnUnmount,
	                  forceUnregisterOnUnmount = _this$props8.forceUnregisterOnUnmount,
	                  unregisterField = _this$props8.unregisterField;
	
	              if (_destroyOnUnmount || forceUnregisterOnUnmount) {
	                unregisterField(name, _destroyOnUnmount);
	
	                if (!_this.fieldCounts[name]) {
	                  delete _this.fieldValidators[name];
	                  delete _this.fieldWarners[name];
	                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
	                    return key !== name;
	                  });
	                }
	              } else {
	                unregisterField(name, false);
	              }
	            }
	          };
	
	          _this.getFieldList = function (options) {
	            var registeredFields = _this.props.registeredFields;
	
	            if (!registeredFields) {
	              return [];
	            }
	
	            var keySeq = keys(registeredFields);
	
	            if (options) {
	              if (options.excludeFieldArray) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].type") !== 'FieldArray';
	                });
	              }
	
	              if (options.excludeUnregistered) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].count") !== 0;
	                });
	              }
	            }
	
	            return toJS(keySeq);
	          };
	
	          _this.getValidators = function () {
	            var validators = {};
	            Object.keys(_this.fieldValidators).forEach(function (name) {
	              var validator = _this.fieldValidators[name]();
	
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          };
	
	          _this.generateValidator = function () {
	            var validators = _this.getValidators();
	
	            return Object.keys(validators).length ? (0, _generateValidator["default"])(validators, structure) : undefined;
	          };
	
	          _this.getWarners = function () {
	            var warners = {};
	            Object.keys(_this.fieldWarners).forEach(function (name) {
	              var warner = _this.fieldWarners[name]();
	
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          };
	
	          _this.generateWarner = function () {
	            var warners = _this.getWarners();
	
	            return Object.keys(warners).length ? (0, _generateValidator["default"])(warners, structure) : undefined;
	          };
	
	          _this.asyncValidate = function (name, value, trigger) {
	            var _this$props9 = _this.props,
	                asyncBlurFields = _this$props9.asyncBlurFields,
	                asyncChangeFields = _this$props9.asyncChangeFields,
	                asyncErrors = _this$props9.asyncErrors,
	                asyncValidate = _this$props9.asyncValidate,
	                dispatch = _this$props9.dispatch,
	                initialized = _this$props9.initialized,
	                pristine = _this$props9.pristine,
	                shouldAsyncValidate = _this$props9.shouldAsyncValidate,
	                startAsyncValidation = _this$props9.startAsyncValidation,
	                stopAsyncValidation = _this$props9.stopAsyncValidation,
	                syncErrors = _this$props9.syncErrors,
	                values = _this$props9.values;
	            var submitting = !name;
	
	            var fieldNeedsValidation = function fieldNeedsValidation() {
	              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
	              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
	            };
	
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	
	              if (fieldNeedsValidation() && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : trigger,
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation["default"])(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          };
	
	          _this.submitCompleted = function (result) {
	            delete _this.submitPromise;
	            return result;
	          };
	
	          _this.submitFailed = function (error) {
	            delete _this.submitPromise;
	            throw error;
	          };
	
	          _this.listenToSubmit = function (promise) {
	            if (!(0, _isPromise["default"])(promise)) {
	              return promise;
	            }
	
	            _this.submitPromise = promise;
	            return promise.then(_this.submitCompleted, _this.submitFailed);
	          };
	
	          _this.submit = function (submitOrEvent) {
	            var _this$props10 = _this.props,
	                onSubmit = _this$props10.onSubmit,
	                blur = _this$props10.blur,
	                change = _this$props10.change,
	                dispatch = _this$props10.dispatch;
	
	            if (!submitOrEvent || (0, _silenceEvent["default"])(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!_this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return _this.innerOnSubmit();
	                } else {
	                  return _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(onSubmit), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                    blur: blur,
	                    change: change
	                  }, dispatch)), // TODO: fix type, should be `Props`
	                  _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                    excludeFieldArray: true,
	                    excludeUnregistered: true
	                  })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents["default"])(function () {
	                return !_this.submitPromise && _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(submitOrEvent), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                  blur: blur,
	                  change: change
	                }, dispatch)), // TODO: fix type, should be `Props`
	                _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                  excludeFieldArray: true,
	                  excludeUnregistered: true
	                })));
	              });
	            }
	          };
	
	          _this.reset = function () {
	            return _this.props.reset();
	          };
	
	          return _this;
	        }
	
	        var _proto = Form.prototype;
	
	        _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	          this.initIfNeeded(nextProps);
	          this.validateIfNeeded(nextProps);
	          this.warnIfNeeded(nextProps);
	          this.clearSubmitPromiseIfNeeded(nextProps);
	          this.submitIfNeeded(nextProps);
	          var onChange = nextProps.onChange,
	              values = nextProps.values,
	              dispatch = nextProps.dispatch;
	
	          if (onChange && !deepEqual(values, this.props.values)) {
	            onChange(values, dispatch, nextProps, this.props.values);
	          }
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	          var _this2 = this;
	
	          if (!this.props.pure) return true;
	          var _config$immutableProp = config.immutableProps,
	              immutableProps = _config$immutableProp === void 0 ? [] : _config$immutableProp; // if we have children, we MUST update in React 16
	          // https://twitter.com/erikras/status/915866544558788608
	
	          return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
	            // useful to debug rerenders
	            // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	            //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	            // }
	            if (~immutableProps.indexOf(prop)) {
	              return _this2.props[prop] !== nextProps[prop];
	            }
	
	            return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	          }));
	        };
	
	        _proto.componentDidMount = function componentDidMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded(this.props);
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          var _this$props11 = this.props,
	              destroyOnUnmount = _this$props11.destroyOnUnmount,
	              destroy = _this$props11.destroy;
	
	          if (destroyOnUnmount && !(0, _isHotReloading["default"])()) {
	            this.destroyed = true;
	            destroy();
	          }
	        };
	
	        _proto.render = function render() {
	          var _ref,
	              _this3 = this;
	
	          // remove some redux-form config-only props
	
	          /* eslint-disable no-unused-vars */
	          var _this$props12 = this.props,
	              anyTouched = _this$props12.anyTouched,
	              array = _this$props12.array,
	              arrayInsert = _this$props12.arrayInsert,
	              arrayMove = _this$props12.arrayMove,
	              arrayPop = _this$props12.arrayPop,
	              arrayPush = _this$props12.arrayPush,
	              arrayRemove = _this$props12.arrayRemove,
	              arrayRemoveAll = _this$props12.arrayRemoveAll,
	              arrayShift = _this$props12.arrayShift,
	              arraySplice = _this$props12.arraySplice,
	              arraySwap = _this$props12.arraySwap,
	              arrayUnshift = _this$props12.arrayUnshift,
	              asyncErrors = _this$props12.asyncErrors,
	              asyncValidate = _this$props12.asyncValidate,
	              asyncValidating = _this$props12.asyncValidating,
	              blur = _this$props12.blur,
	              change = _this$props12.change,
	              clearSubmit = _this$props12.clearSubmit,
	              destroy = _this$props12.destroy,
	              destroyOnUnmount = _this$props12.destroyOnUnmount,
	              forceUnregisterOnUnmount = _this$props12.forceUnregisterOnUnmount,
	              dirty = _this$props12.dirty,
	              dispatch = _this$props12.dispatch,
	              enableReinitialize = _this$props12.enableReinitialize,
	              error = _this$props12.error,
	              focus = _this$props12.focus,
	              form = _this$props12.form,
	              getFormState = _this$props12.getFormState,
	              immutableProps = _this$props12.immutableProps,
	              initialize = _this$props12.initialize,
	              initialized = _this$props12.initialized,
	              initialValues = _this$props12.initialValues,
	              invalid = _this$props12.invalid,
	              keepDirtyOnReinitialize = _this$props12.keepDirtyOnReinitialize,
	              keepValues = _this$props12.keepValues,
	              updateUnregisteredFields = _this$props12.updateUnregisteredFields,
	              pristine = _this$props12.pristine,
	              propNamespace = _this$props12.propNamespace,
	              registeredFields = _this$props12.registeredFields,
	              registerField = _this$props12.registerField,
	              reset = _this$props12.reset,
	              resetSection = _this$props12.resetSection,
	              setSubmitFailed = _this$props12.setSubmitFailed,
	              setSubmitSucceeded = _this$props12.setSubmitSucceeded,
	              shouldAsyncValidate = _this$props12.shouldAsyncValidate,
	              shouldValidate = _this$props12.shouldValidate,
	              shouldError = _this$props12.shouldError,
	              shouldWarn = _this$props12.shouldWarn,
	              startAsyncValidation = _this$props12.startAsyncValidation,
	              startSubmit = _this$props12.startSubmit,
	              stopAsyncValidation = _this$props12.stopAsyncValidation,
	              stopSubmit = _this$props12.stopSubmit,
	              submitAsSideEffect = _this$props12.submitAsSideEffect,
	              submitting = _this$props12.submitting,
	              submitFailed = _this$props12.submitFailed,
	              submitSucceeded = _this$props12.submitSucceeded,
	              touch = _this$props12.touch,
	              touchOnBlur = _this$props12.touchOnBlur,
	              touchOnChange = _this$props12.touchOnChange,
	              persistentSubmitErrors = _this$props12.persistentSubmitErrors,
	              syncErrors = _this$props12.syncErrors,
	              syncWarnings = _this$props12.syncWarnings,
	              unregisterField = _this$props12.unregisterField,
	              untouch = _this$props12.untouch,
	              updateSyncErrors = _this$props12.updateSyncErrors,
	              updateSyncWarnings = _this$props12.updateSyncWarnings,
	              valid = _this$props12.valid,
	              validExceptSubmit = _this$props12.validExceptSubmit,
	              values = _this$props12.values,
	              warning = _this$props12.warning,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props12, ["anyTouched", "array", "arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncErrors", "asyncValidate", "asyncValidating", "blur", "change", "clearSubmit", "destroy", "destroyOnUnmount", "forceUnregisterOnUnmount", "dirty", "dispatch", "enableReinitialize", "error", "focus", "form", "getFormState", "immutableProps", "initialize", "initialized", "initialValues", "invalid", "keepDirtyOnReinitialize", "keepValues", "updateUnregisteredFields", "pristine", "propNamespace", "registeredFields", "registerField", "reset", "resetSection", "setSubmitFailed", "setSubmitSucceeded", "shouldAsyncValidate", "shouldValidate", "shouldError", "shouldWarn", "startAsyncValidation", "startSubmit", "stopAsyncValidation", "stopSubmit", "submitAsSideEffect", "submitting", "submitFailed", "submitSucceeded", "touch", "touchOnBlur", "touchOnChange", "persistentSubmitErrors", "syncErrors", "syncWarnings", "unregisterField", "untouch", "updateSyncErrors", "updateSyncWarnings", "valid", "validExceptSubmit", "values", "warning"]);
	          /* eslint-enable no-unused-vars */
	
	          var reduxFormProps = (0, _extends2["default"])({
	            array: array,
	            anyTouched: anyTouched,
	            asyncValidate: this.asyncValidate,
	            asyncValidating: asyncValidating
	          }, (0, _redux.bindActionCreators)({
	            blur: blur,
	            change: change
	          }, dispatch), {
	            clearSubmit: clearSubmit,
	            destroy: destroy,
	            dirty: dirty,
	            dispatch: dispatch,
	            error: error,
	            form: form,
	            handleSubmit: this.submit,
	            initialize: initialize,
	            initialized: initialized,
	            initialValues: initialValues,
	            invalid: invalid,
	            pristine: pristine,
	            reset: reset,
	            resetSection: resetSection,
	            submitting: submitting,
	            submitAsSideEffect: submitAsSideEffect,
	            submitFailed: submitFailed,
	            submitSucceeded: submitSucceeded,
	            touch: touch,
	            untouch: untouch,
	            valid: valid,
	            warning: warning
	          });
	          var propsToPass = (0, _extends2["default"])({}, propNamespace ? (_ref = {}, _ref[propNamespace] = reduxFormProps, _ref) : reduxFormProps, {}, rest);
	
	          if (isClassComponent(WrappedComponent)) {
	            ;
	            propsToPass.ref = this.wrapped;
	          }
	
	          var _reduxForm = (0, _extends2["default"])({}, this.props, {
	            getFormState: function getFormState(state) {
	              return getIn(_this3.props.getFormState(state), _this3.props.form);
	            },
	            asyncValidate: this.asyncValidate,
	            getValues: this.getValues,
	            sectionPrefix: undefined,
	            register: this.register,
	            unregister: this.unregister,
	            registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	              return _this3.innerOnSubmit = innerOnSubmit;
	            }
	          });
	
	          return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	            value: _reduxForm,
	            children: (0, _react.createElement)(WrappedComponent, propsToPass)
	          });
	        };
	
	        return Form;
	      }(_react["default"].Component);
	
	      Form.displayName = "Form(" + (0, _getDisplayName["default"])(WrappedComponent) + ")";
	      Form.WrappedComponent = WrappedComponent;
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes["default"].bool,
	        forceUnregisterOnUnmount: _propTypes["default"].bool,
	        form: _propTypes["default"].string.isRequired,
	        immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	        initialValues: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
	        getFormState: _propTypes["default"].func,
	        onSubmitFail: _propTypes["default"].func,
	        onSubmitSuccess: _propTypes["default"].func,
	        propNamespace: _propTypes["default"].string,
	        validate: _propTypes["default"].func,
	        warn: _propTypes["default"].func,
	        touchOnBlur: _propTypes["default"].bool,
	        touchOnChange: _propTypes["default"].bool,
	        triggerSubmit: _propTypes["default"].bool,
	        persistentSubmitErrors: _propTypes["default"].bool,
	        registeredFields: _propTypes["default"].any
	      };
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	        var initial = initialValues || stateInitial || empty;
	
	        if (!shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	
	        var syncErrors = getIn(formState, 'syncErrors') || _plain["default"].empty;
	
	        var syncWarnings = getIn(formState, 'syncWarnings') || _plain["default"].empty;
	
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        }; // Bind the first parameter on `props.form`
	
	
	        var boundFormACs = (0, _mapValues2["default"])(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues2["default"])(arrayActions, bindForm);
	
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	
	        var boundFocus = bindForm(focus); // Wrap action creators with `dispatch`
	
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	        return (0, _extends2["default"])({}, connectedFormACs, {}, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	      }, undefined, {
	        forwardRef: true
	      });
	      var ConnectedForm = (0, _hoistNonReactStatics["default"])(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config; // build outer component to expose instance api
	
	      var ReduxForm = /*#__PURE__*/function (_React$Component2) {
	        (0, _inheritsLoose2["default"])(ReduxForm, _React$Component2);
	
	        function ReduxForm() {
	          var _this4;
	
	          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          _this4 = _React$Component2.call.apply(_React$Component2, [this].concat(args)) || this;
	          _this4.ref = _react["default"].createRef();
	          return _this4;
	        }
	
	        var _proto2 = ReduxForm.prototype;
	
	        _proto2.submit = function submit() {
	          return this.ref.current && this.ref.current.submit();
	        };
	
	        _proto2.reset = function reset() {
	          if (this.ref) {
	            this.ref.current.reset();
	          }
	        };
	
	        _proto2.render = function render() {
	          var _this$props13 = this.props,
	              initialValues = _this$props13.initialValues,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props13, ["initialValues"]);
	          return (0, _react.createElement)(ConnectedForm, (0, _extends2["default"])({}, rest, {
	            ref: this.ref,
	            // convert initialValues if need to
	            initialValues: fromJS(initialValues)
	          }));
	        };
	
	        (0, _createClass2["default"])(ReduxForm, [{
	          key: "valid",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isValid());
	          }
	        }, {
	          key: "invalid",
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: "pristine",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isPristine());
	          }
	        }, {
	          key: "dirty",
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: "values",
	          get: function get() {
	            return this.ref.current ? this.ref.current.getValues() : empty;
	          }
	        }, {
	          key: "fieldList",
	          get: function get() {
	            // mainly provided for testing
	            return this.ref.current ? this.ref.current.getFieldList() : [];
	          }
	        }, {
	          key: "wrappedInstance",
	          get: function get() {
	            // for testing
	            return this.ref.current && this.ref.current.wrapped.current;
	          }
	        }]);
	        return ReduxForm;
	      }(_react["default"].Component);
	
	      var WithContext = (0, _hoistNonReactStatics["default"])((0, _ReduxFormContext.withReduxForm)(ReduxForm), WrappedComponent);
	      WithContext.defaultProps = config;
	      return WithContext;
	    };
	  };
	}

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _reactRedux = __webpack_require__(8);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = (0, _extends2["default"])({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      var _ref2;
	
	      return _ref2 = {}, _ref2[prop] = getIn(getFormState(state), form + ".values"), _ref2;
	    } // ignore dispatch
	    );
	  };
	}

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(122));
	
	function createDeleteInWithCleanUp(structure) {
	  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
	    return function (state, path) {
	      return structure.getIn(state, path) !== undefined;
	    };
	  };
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      deleteIn = structure.deleteIn,
	      setIn = structure.setIn;
	  return function (shouldDelete) {
	    if (shouldDelete === void 0) {
	      shouldDelete = shouldDeleteDefault;
	    }
	
	    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	      if (path[path.length - 1] === ']') {
	        // array path
	        var pathTokens = (0, _toPath2["default"])(path);
	        pathTokens.pop();
	        var parent = getIn(state, pathTokens.join('.'));
	        return parent ? setIn(state, path) : state;
	      }
	
	      var result = state;
	
	      if (shouldDelete(structure)(state, path)) {
	        result = deleteIn(state, path);
	      }
	
	      var dotIndex = path.lastIndexOf('.');
	
	      if (dotIndex > 0) {
	        var parentPath = path.substring(0, dotIndex);
	
	        if (parentPath[parentPath.length - 1] !== ']') {
	          var _parent = getIn(result, parentPath);
	
	          if (deepEqual(_parent, empty)) {
	            return deleteInWithCleanUp(result, parentPath);
	          }
	        }
	      }
	
	      return result;
	    };
	
	    return deleteInWithCleanUp;
	  };
	}
	
	var _default = createDeleteInWithCleanUp;
	exports["default"] = _default;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(169));
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent["default"])(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    var detypedEvent = event;
	    var _detypedEvent$target = detypedEvent.target,
	        type = _detypedEvent$target.type,
	        value = _detypedEvent$target.value,
	        checked = _detypedEvent$target.checked,
	        files = _detypedEvent$target.files,
	        dataTransfer = detypedEvent.dataTransfer;
	
	    if (type === 'checkbox') {
	      return !!checked;
	    }
	
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	
	    return value;
	  }
	
	  return event;
	};
	
	var _default = getValue;
	exports["default"] = _default;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(271));
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent["default"])(event) ? fn.apply(void 0, args) : fn.apply(void 0, [event].concat(args));
	  };
	};
	
	var _default = silenceEvents;
	exports["default"] = _default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValueSelector = _interopRequireDefault(__webpack_require__(614));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createFormValueSelector["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValues = _interopRequireDefault(__webpack_require__(615));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = generateValidator;
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var getError = function getError(value, values, props, validators, name) {
	  var array = toArray(validators);
	
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props, name);
	
	    if (error) {
	      return error;
	    }
	  }
	};
	
	function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name], name);
	
	      if (error) {
	        errors = _plain["default"].setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	}

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(647));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormAsyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormError = _interopRequireDefault(__webpack_require__(648));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormError["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(649));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormInitialValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(650));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormMeta["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(651));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormNames["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(652));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormSubmitErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(653));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormSyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(654));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormSyncWarnings["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(655));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _getFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(153));
	
	var _SubmissionError = __webpack_require__(263);
	
	var mergeErrors = function mergeErrors(_ref) {
	  var asyncErrors = _ref.asyncErrors,
	      syncErrors = _ref.syncErrors;
	  return asyncErrors && typeof asyncErrors.merge === 'function' ? asyncErrors.merge(syncErrors).toJS() : (0, _extends2["default"])({}, asyncErrors, {}, syncErrors);
	};
	
	var executeSubmit = function executeSubmit(submit, fields, props) {
	  var dispatch = props.dispatch,
	      submitAsSideEffect = props.submitAsSideEffect,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      values = props.values;
	  var result;
	
	  try {
	    result = submit(values, dispatch, props);
	  } catch (submitError) {
	    var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	    stopSubmit(error);
	    setSubmitFailed.apply(void 0, fields);
	
	    if (onSubmitFail) {
	      onSubmitFail(error, dispatch, submitError, props);
	    }
	
	    if (error || onSubmitFail) {
	      // if you've provided an onSubmitFail callback, don't re-throw the error
	      return error;
	    } else {
	      throw submitError;
	    }
	  }
	
	  if (submitAsSideEffect) {
	    if (result) {
	      dispatch(result);
	    }
	  } else {
	    if ((0, _isPromise["default"])(result)) {
	      startSubmit();
	      return result.then(function (submitResult) {
	        stopSubmit();
	        setSubmitSucceeded();
	
	        if (onSubmitSuccess) {
	          onSubmitSuccess(submitResult, dispatch, props);
	        }
	
	        return submitResult;
	      }, function (submitError) {
	        var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      });
	    } else {
	      setSubmitSucceeded();
	
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result, dispatch, props);
	      }
	    }
	  }
	
	  return result;
	};
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      setSubmitFailed = props.setSubmitFailed,
	      syncErrors = props.syncErrors,
	      asyncErrors = props.asyncErrors,
	      touch = props.touch,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	  touch.apply(void 0, fields);
	
	  if (valid || persistentSubmitErrors) {
	    var asyncValidateResult = asyncValidate && asyncValidate();
	
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	
	        return executeSubmit(submit, fields, props);
	      })["catch"](function (asyncErrors) {
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return executeSubmit(submit, fields, props);
	    }
	  } else {
	    setSubmitFailed.apply(void 0, fields);
	    var errors = mergeErrors({
	      asyncErrors: asyncErrors,
	      syncErrors: syncErrors
	    });
	
	    if (onSubmitFail) {
	      onSubmitFail(errors, dispatch, null, props);
	    }
	
	    return errors;
	  }
	};
	
	var _default = handleSubmit;
	exports["default"] = _default;

/***/ },
/* 635 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasError;
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + "._error"];
	
	    case 'FieldArray':
	      return [name + "._error"];
	
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	function createHasError(_ref) {
	  var getIn = _ref.getIn;
	  return function (field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	}

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(656));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _hasSubmitFailed["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(657));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _hasSubmitSucceeded["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(658));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _isAsyncValidating["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isDirty = _interopRequireDefault(__webpack_require__(659));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _isDirty["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(660));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _isInvalid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(273));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _isPristine["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(661));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _isSubmitting["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isValid = _interopRequireDefault(__webpack_require__(170));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _isValid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = exports.fieldArrayPropTypes = exports.fieldPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var any = _propTypes["default"].any,
	    bool = _propTypes["default"].bool,
	    func = _propTypes["default"].func,
	    shape = _propTypes["default"].shape,
	    string = _propTypes["default"].string,
	    oneOfType = _propTypes["default"].oneOfType,
	    object = _propTypes["default"].object,
	    number = _propTypes["default"].number;
	var formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired,
	  // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired,
	  // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired,
	  // true if any values are different from initialValues
	  error: any,
	  // form-wide error from '_error' key in validation result
	  form: string.isRequired,
	  // the name of the form
	  invalid: bool.isRequired,
	  // true if there are any validation errors
	  initialized: bool.isRequired,
	  // true if the form has been initialized
	  initialValues: object,
	  // the initialValues object passed to reduxForm
	  pristine: bool.isRequired,
	  // true if the values are the same as initialValues
	  pure: bool.isRequired,
	  // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired,
	  // true if the form is in the process of being submitted
	  submitAsSideEffect: bool.isRequired,
	  // true if onSubmit result will be dispatched
	  submitFailed: bool.isRequired,
	  // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired,
	  // true if the form was successfully submitted
	  valid: bool.isRequired,
	  // true if there are no validation errors
	  warning: any,
	  // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired,
	    // function to insert a value into an array field
	    move: func.isRequired,
	    // function to move a value within an array field
	    pop: func.isRequired,
	    // function to pop a value off of an array field
	    push: func.isRequired,
	    // function to push a value onto an array field
	    remove: func.isRequired,
	    // function to remove a value from an array field
	    removeAll: func.isRequired,
	    // function to remove all the values from an array field
	    shift: func.isRequired,
	    // function to shift a value out of an array field
	    splice: func.isRequired,
	    // function to splice a value into an array field
	    swap: func.isRequired,
	    // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	
	  }),
	  asyncValidate: func.isRequired,
	  // function to trigger async validation
	  autofill: func.isRequired,
	  // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired,
	  // action to mark a field as blurred
	  change: func.isRequired,
	  // action to change the value of a field
	  clearAsyncError: func.isRequired,
	  // action to clear the async error of a field
	  clearFields: func.isRequired,
	  // action to clean fields values for all fields
	  clearSubmitErrors: func.isRequired,
	  // action to remove submitErrors and error
	  destroy: func.isRequired,
	  // action to destroy the form's data in Redux
	  dispatch: func.isRequired,
	  // the Redux dispatch action
	  handleSubmit: func.isRequired,
	  // function to submit the form
	  initialize: func.isRequired,
	  // action to initialize form data
	  reset: func.isRequired,
	  // action to reset the form data to previously initialized values
	  resetSection: func.isRequired,
	  // action to reset the form sections data to previously initialized values
	  touch: func.isRequired,
	  // action to mark fields as touched
	  submit: func.isRequired,
	  // action to trigger a submission of the specified form
	  untouch: func.isRequired,
	  // action to mark fields as untouched
	  // triggerSubmit
	  triggerSubmit: bool,
	  // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	
	};
	exports.formPropTypes = formPropTypes;
	var fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	exports.fieldInputPropTypes = fieldInputPropTypes;
	var fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	exports.fieldMetaPropTypes = fieldMetaPropTypes;
	var fieldArrayMetaPropTypes = {
	  dirty: bool.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitFailed: bool,
	  submitting: bool,
	  valid: bool.isRequired,
	  warning: string
	};
	exports.fieldArrayMetaPropTypes = fieldArrayMetaPropTypes;
	var fieldArrayFieldsPropTypes = {
	  name: string.isRequired,
	  forEach: func.isRequired,
	  get: func.isRequired,
	  getAll: func.isRequired,
	  insert: func.isRequired,
	  length: number.isRequired,
	  map: func.isRequired,
	  move: func.isRequired,
	  pop: func.isRequired,
	  push: func.isRequired,
	  reduce: func.isRequired,
	  remove: func.isRequired,
	  removeAll: func.isRequired,
	  shift: func.isRequired,
	  swap: func.isRequired,
	  unshift: func.isRequired
	};
	exports.fieldArrayFieldsPropTypes = fieldArrayFieldsPropTypes;
	var fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired
	};
	exports.fieldPropTypes = fieldPropTypes;
	var fieldArrayPropTypes = {
	  fields: shape(fieldArrayFieldsPropTypes).isRequired,
	  meta: shape(fieldArrayMetaPropTypes).isRequired
	};
	exports.fieldArrayPropTypes = fieldArrayPropTypes;
	var _default = formPropTypes;
	exports["default"] = _default;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReducer = _interopRequireDefault(__webpack_require__(616));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createReducer["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReduxForm = _interopRequireDefault(__webpack_require__(617));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createReduxForm["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 647 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormAsyncErrors;
	
	function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".asyncErrors");
	    };
	  };
	}

/***/ },
/* 648 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormError;
	
	function createGetFormError(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".error");
	    };
	  };
	}

/***/ },
/* 649 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormInitialValues;
	
	function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".initial");
	    };
	  };
	}

/***/ },
/* 650 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormMeta;
	
	function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".fields") || empty;
	    };
	  };
	}

/***/ },
/* 651 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormNames;
	
	function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	  return function (getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return keys(nonNullGetFormState(state));
	    };
	  };
	}

/***/ },
/* 652 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSubmitErrors;
	
	function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".submitErrors") || empty;
	    };
	  };
	}

/***/ },
/* 653 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncErrors;
	
	function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncErrors") || empty;
	    };
	  };
	}

/***/ },
/* 654 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncWarnings;
	
	function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncWarnings") || empty;
	    };
	  };
	}

/***/ },
/* 655 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormValues;
	
	function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".values");
	    };
	  };
	}

/***/ },
/* 656 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitFailed;
	
	function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitFailed");
	    };
	  };
	}

/***/ },
/* 657 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitSucceeded;
	
	function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitSucceeded");
	    };
	  };
	}

/***/ },
/* 658 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsAsyncValidating;
	
	function createIsAsyncValidating(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".asyncValidating");
	    };
	  };
	}

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createIsDirty;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(273));
	
	function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine["default"])(structure)(form, getFormState);
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      return !isPristine.apply(void 0, [state].concat(fields));
	    };
	  };
	}

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = createIsInvalid;
	
	var _isValid = _interopRequireDefault(__webpack_require__(170));
	
	function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid["default"])(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	}

/***/ },
/* 661 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsSubmitting;
	
	function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitting");
	    };
	  };
	}

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(547));
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(250));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var isEmpty = function isEmpty(obj) {
	  return (0, _isNil2["default"])(obj) || obj === '' || isNaN(obj);
	};
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	
	  if (!obj && !other) {
	    return isEmpty(obj) === isEmpty(other);
	  }
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	  if (_react["default"].isValidElement(obj) || _react["default"].isValidElement(other)) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith2["default"])(a, b, customizer);
	};
	
	var _default = deepEqual;
	exports["default"] = _default;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(14));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(122));
	
	function deleteInWithPath(state, first) {
	  if (state === undefined || state === null || first === undefined || first === null) {
	    return state;
	  }
	
	  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (isNaN(first)) {
	        throw new Error("Must access array elements with a number, not \"" + String(first) + "\".");
	      }
	
	      var firstIndex = Number(first);
	
	      if (firstIndex < state.length) {
	        var result = deleteInWithPath.apply(void 0, [state && state[firstIndex]].concat(rest));
	
	        if (result !== state[firstIndex]) {
	          var copy = [].concat(state);
	          copy[firstIndex] = result;
	          return copy;
	        }
	      }
	
	      return state;
	    }
	
	    if (first in state) {
	      var _extends2;
	
	      var _result = deleteInWithPath.apply(void 0, [state && state[first]].concat(rest));
	
	      return state[first] === _result ? state : (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = _result, _extends2));
	    }
	
	    return state;
	  }
	
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error("Cannot delete non-numerical index from an array. Given: \"" + String(first));
	    }
	
	    var _firstIndex = Number(first);
	
	    if (_firstIndex < state.length) {
	      var _copy = [].concat(state);
	
	      _copy.splice(_firstIndex, 1);
	
	      return _copy;
	    }
	
	    return state;
	  }
	
	  if (first in state) {
	    var _copy2 = (0, _extends3["default"])({}, state);
	
	    delete _copy2[first];
	    return _copy2;
	  }
	
	  return state;
	}
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(void 0, [state].concat((0, _toPath2["default"])(field)));
	};
	
	var _default = deleteIn;
	exports["default"] = _default;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(122));
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath2["default"])(field);
	  var length = path.length;
	
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	
	  for (var i = 0; i < length && result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	var _default = getIn;
	exports["default"] = _default;

/***/ },
/* 665 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	}
	
	var _default = keys;
	exports["default"] = _default;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(14));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(122));
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  var _extends2;
	
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
	  var next = setInWithPath(firstState, value, path, pathIndex + 1);
	
	  if (!state) {
	    if (isNaN(first)) {
	      var _ref;
	
	      return _ref = {}, _ref[first] = next, _ref;
	    }
	
	    var initialized = [];
	    initialized[parseInt(first, 10)] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[parseInt(first, 10)] = next;
	    return copy;
	  }
	
	  return (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = next, _extends2));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath2["default"])(field), 0);
	};
	
	var _default = setIn;
	exports["default"] = _default;

/***/ },
/* 667 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(array);
	
	      _copy2.splice(index, 0, true); // temporary placeholder
	
	
	      _copy2[index] = undefined; // set to undefined
	
	      return _copy2;
	    }
	
	    if (value != null) {
	      var _copy3 = [].concat(array);
	
	      _copy3.splice(index, removeNum, value); // removing and adding
	
	
	      return _copy3;
	    }
	
	    var _copy = [].concat(array);
	
	    _copy.splice(index, removeNum); // removing
	
	
	    return _copy;
	  }
	
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  } // trying to add outside of range: just set value
	
	
	  var copy = [].concat(array);
	  copy[index] = value;
	  return copy;
	};
	
	var _default = splice;
	exports["default"] = _default;

/***/ },
/* 668 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.dataKey = void 0;
	var dataKey = 'text';
	exports.dataKey = dataKey;

/***/ },
/* 669 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	var _default = getDisplayName;
	exports["default"] = _default;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isHotReloading = function isHotReloading() {
	  var castModule = module;
	  return !!(typeof castModule !== 'undefined' && castModule.hot && typeof castModule.hot.status === 'function' && castModule.hot.status() === 'apply');
	};
	
	var _default = isHotReloading;
	exports["default"] = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createValues = _interopRequireDefault(__webpack_require__(618));
	
	var _plain = _interopRequireDefault(__webpack_require__(6));
	
	var _default = (0, _createValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 672 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = function (engine, ms) {
	    var maxWait = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    if (maxWait !== null && ms > maxWait) {
	        throw new Error('maxWait must be > ms');
	    }
	
	    var lastTimeout = void 0;
	    var maxTimeout = void 0;
	    var lastReject = void 0;
	    var lastState = void 0;
	
	    var hasWindow = false;
	    try {
	        hasWindow = !!window;
	    } catch (err) {
	        // ignore error
	    }
	    if (hasWindow && window.addEventListener) {
	        window.addEventListener('beforeunload', function () {
	            if (!lastTimeout) {
	                return;
	            }
	
	            lastTimeout = clearTimeout(lastTimeout);
	            maxTimeout = clearTimeout(maxTimeout);
	            lastReject = null;
	            engine.save(lastState);
	        });
	    }
	
	    return _extends({}, engine, {
	        save: function save(state) {
	            lastState = state;
	            lastTimeout = clearTimeout(lastTimeout);
	
	            if (lastReject) {
	                lastReject(Error('Debounced, newer action pending'));
	                lastReject = null;
	            }
	
	            return new Promise(function (resolve, reject) {
	                var doSave = function doSave() {
	                    lastTimeout = clearTimeout(lastTimeout);
	                    maxTimeout = clearTimeout(maxTimeout);
	                    lastReject = null;
	                    lastState = null;
	                    engine.save(state).then(resolve)['catch'](reject);
	                };
	
	                lastReject = reject;
	                lastTimeout = setTimeout(doSave, ms);
	
	                if (maxWait !== null && !maxTimeout) {
	                    maxTimeout = setTimeout(doSave, maxWait);
	                }
	            });
	        }
	    });
	};

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(452);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(454);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _lodash5 = __webpack_require__(228);
	
	var _lodash6 = _interopRequireDefault(_lodash5);
	
	var _lodash7 = __webpack_require__(154);
	
	var _lodash8 = _interopRequireDefault(_lodash7);
	
	var _lodash9 = __webpack_require__(455);
	
	var _lodash10 = _interopRequireDefault(_lodash9);
	
	var _lodash11 = __webpack_require__(456);
	
	var _lodash12 = _interopRequireDefault(_lodash11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (engine) {
	    var whitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var blacklist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    whitelist = whitelist || []; // eslint-disable-line no-param-reassign
	
	    return _extends({}, engine, {
	        save: function save(state) {
	            var saveState = {};
	
	            // Copy the whole state if we're about to blacklist only
	            if (whitelist.length === 0 && blacklist !== null) {
	                saveState = _extends({}, state);
	            }
	
	            blacklist = blacklist || []; // eslint-disable-line no-param-reassign
	
	            whitelist.forEach(function (key) {
	                // Support strings for one-level paths
	                if (typeof key === 'string') {
	                    key = [key]; // eslint-disable-line no-param-reassign
	                }
	
	                var value = (0, _lodash4['default'])(key, function (result, keyPart) {
	                    if (result) {
	                        // Support immutable structures
	                        if ((0, _lodash6['default'])(result.has) && (0, _lodash6['default'])(result.get)) {
	                            return result.get(keyPart);
	                        }
	
	                        if (result.hasOwnProperty(keyPart)) {
	                            return result[keyPart];
	                        }
	                    }
	                }, state);
	
	                if (value !== undefined) {
	                    // done to support null values
	                    (0, _lodash10['default'])(saveState, key, value);
	                }
	            });
	
	            blacklist.forEach(function (key) {
	                // Support strings for one-level paths
	                if (typeof key === 'string') {
	                    key = [key]; // eslint-disable-line no-param-reassign
	                }
	
	                // Support immutable structures
	                var value = state[key[0]];
	                var blacklistedState = saveState[key[0]] || value;
	
	                if (blacklistedState && (0, _lodash6['default'])(blacklistedState.deleteIn)) {
	                    // Handle multiple blacklist path with same key
	                    saveState[key[0]] = blacklistedState.deleteIn(key.slice(1));
	                    return;
	                }
	
	                // If we're a nested path ...
	                if (key.length > 1) {
	                    // ... and inside a object ...
	                    var myKey = key.slice(0, -1);
	                    var subValue = (0, _lodash2['default'])(saveState, myKey);
	                    if ((0, _lodash8['default'])(subValue)) {
	                        // ... clone it, as we don't want to change the state!
	                        (0, _lodash10['default'])(saveState, myKey, _extends({}, subValue));
	                    }
	                }
	                (0, _lodash12['default'])(saveState, key);
	            });
	
	            return engine.save(saveState);
	        }
	    });
	};

/***/ },
/* 674 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rejectWithMessage(error) {
	    return Promise.reject(error.message);
	}
	
	exports["default"] = function (key, replacer, reviver) {
	    return {
	        load: function load() {
	            return new Promise(function (resolve) {
	                var jsonState = localStorage.getItem(key);
	                resolve(JSON.parse(jsonState, reviver) || {});
	            })["catch"](rejectWithMessage);
	        },
	        save: function save(state) {
	            return new Promise(function (resolve) {
	                var jsonState = JSON.stringify(state, replacer);
	                localStorage.setItem(key, jsonState);
	                resolve();
	            })["catch"](rejectWithMessage);
	        }
	    };
	};

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(154);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(453);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (oldState, newState) {
	    var result = _extends({}, oldState);
	
	    for (var key in newState) {
	        if (!newState.hasOwnProperty(key)) {
	            continue;
	        }
	        var value = newState[key];
	
	        // Assign if we don't need to merge at all
	        if (!result.hasOwnProperty(key)) {
	            result[key] = (0, _lodash2['default'])(value) && !Array.isArray(value) ? (0, _lodash4['default'])({}, value) : value;
	            continue;
	        }
	
	        var oldValue = result[key];
	
	        if ((0, _lodash2['default'])(value) && !Array.isArray(value)) {
	            result[key] = (0, _lodash4['default'])({}, oldValue, value);
	        } else {
	            result[key] = value;
	        }
	    }
	
	    return result;
	};

/***/ },
/* 676 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 677 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(677);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(680);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(63)(module)))

/***/ },
/* 680 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 682 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 683 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initializeConfigurator = undefined;
	
	var _UserAuthentication = __webpack_require__(24);
	
	var _ActionTypes = __webpack_require__(5);
	
	var ActionTypes = _interopRequireWildcard(_ActionTypes);
	
	var _ArticleData = __webpack_require__(64);
	
	var _AppInit = __webpack_require__(81);
	
	var _GetParam = __webpack_require__(17);
	
	var _Config = __webpack_require__(11);
	
	var _General = __webpack_require__(10);
	
	var _reduxForm = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initializeConfigurator = exports.initializeConfigurator = function initializeConfigurator() {
	    return function (dispatch, getState) {
	
	        var configurationMode = [_General.ARTICLE_CONFIGURATOR_MODE_SHOP, _General.ARTICLE_CONFIGURATOR_MODE_CMS, _General.ARTICLE_CONFIGURATOR_MODE_SHARED].indexOf(_GetParam._configuratorMode) >= 0 ? _GetParam._configuratorMode : 'shared';
	
	        Promise.all([dispatch((0, _UserAuthentication.queryBearerToken)())]).then(function (args) {
	            if (args[0].type !== ActionTypes.BEARER_TOKEN_FAILURE) {
	
	                var initialCalls = configurationMode === 'shared' ? [(0, _ArticleData.queryBaseArticle)(_Config.agencyServerArticleNumber)] : [];
	
	                Promise.all(initialCalls.map(function (func) {
	                    return dispatch(func);
	                })).then(function (args) {
	                    if (args.length === 0 || args[0].type === ActionTypes.BASE_ARTICLE_SUCCESS) {
	
	                        var configuration = (0, _Config.getArticleConfiguratorData)(getState())[configurationMode];
	
	                        var neededArticleData = [];
	
	                        Object.keys(configuration.projectStates).forEach(function (projectStateKey) {
	                            var projectState = configuration.projectStates[projectStateKey];
	                            Object.keys(projectState.projectTypes).forEach(function (projectTypeKey) {
	                                var projectType = projectState.projectTypes[projectTypeKey];
	                                neededArticleData = [].concat(_toConsumableArray(projectType.articles), _toConsumableArray(neededArticleData));
	                            });
	                        });
	
	                        Promise.all([
	                        // iterate through articleOptions and load data if price not available
	                        dispatch((0, _ArticleData.queryArticleOptionData)([].concat(_toConsumableArray(neededArticleData), _toConsumableArray(Object.keys(getState().articleData.articleOptions).filter(function (key) {
	                            return key.includes("default") || getState().articleData.articleOptions[key].price ? null : key;
	                        })))))]).then(function (args) {
	
	                            switch (_GetParam._configuratorMode) {
	
	                                case _General.ARTICLE_CONFIGURATOR_MODE_SHARED:
	                                    dispatch((0, _reduxForm.initialize)('projectSelection', {
	                                        type: _General.ARTICLE_TYPE_CMS,
	                                        state: _General.PROJECT_STATE_LIVE,
	                                        article: "" + _Config.agencyServerCMSArticles[2],
	                                        storage: "",
	                                        backup: 7
	                                    }));
	                                    break;
	
	                                case _General.ARTICLE_CONFIGURATOR_MODE_CMS:
	                                    dispatch((0, _reduxForm.initialize)('projectSelection', {
	                                        type: _General.ARTICLE_TYPE_CMS,
	                                        state: _General.PROJECT_STATE_LIVE,
	                                        article: "" + _Config.cmsArticles[1],
	                                        storage: "",
	                                        backup: 7
	                                    }));
	                                    break;
	
	                                case _General.ARTICLE_CONFIGURATOR_MODE_SHOP:
	                                    dispatch((0, _reduxForm.initialize)('projectSelection', {
	                                        type: _General.ARTICLE_TYPE_SHOP,
	                                        state: _General.PROJECT_STATE_LIVE,
	                                        article: "" + _Config.shopArticles[1],
	                                        storage: "",
	                                        backup: 7
	                                    }));
	                                    break;
	
	                            }
	                            dispatch((0, _AppInit.appInitialized)());
	                        });
	                    }
	                });
	            }
	        });
	    };
	};

/***/ },
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _AppInit = __webpack_require__(721);
	
	var _reactTooltip = __webpack_require__(61);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _ArticleConfigurator = __webpack_require__(178);
	
	var _ArticleConfigurator2 = _interopRequireDefault(_ArticleConfigurator);
	
	var _GetParam = __webpack_require__(17);
	
	var _AppPreloader = __webpack_require__(132);
	
	var _AppPreloader2 = _interopRequireDefault(_AppPreloader);
	
	var _General = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state) {
	    return {
	        appInitialized: state.appState.isInitialized
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        initializeConfigurator: function initializeConfigurator() {
	            dispatch((0, _AppInit.initializeConfigurator)());
	        }
	    };
	}
	
	var ArticleConfiguratorApp = function (_Component) {
	    _inherits(ArticleConfiguratorApp, _Component);
	
	    function ArticleConfiguratorApp() {
	        _classCallCheck(this, ArticleConfiguratorApp);
	
	        return _possibleConstructorReturn(this, (ArticleConfiguratorApp.__proto__ || Object.getPrototypeOf(ArticleConfiguratorApp)).apply(this, arguments));
	    }
	
	    _createClass(ArticleConfiguratorApp, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            setTimeout(function () {
	                _reactTooltip2.default.rebuild();
	            }, 1000);
	
	            this.props.initializeConfigurator();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactTooltip2.default, { className: 'global-tooltip', effect: 'float', type: 'light', border: true, multiline: true, id: 'global', getContent: function getContent(dataTip) {
	                        return dataTip;
	                    } }),
	                this.props.appInitialized ? _react2.default.createElement(_ArticleConfigurator2.default, {
	                    hidePersonalization: true,
	                    hideBackup: _GetParam._configuratorMode === _General.ARTICLE_CONFIGURATOR_MODE_SHARED,
	                    hideAddons: true,
	                    connectToCart: false,
	                    forceDefaultOnTypeSwitch: true,
	                    mode: _GetParam._configuratorMode,
	                    layout: _GetParam._configuratorMode === 'shared' ? _General.ARTICLE_CONFIGURATOR_LAYOUT_AGENCY : _General.ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE
	                }) : _react2.default.createElement(_AppPreloader2.default, { label: '' })
	            );
	        }
	    }]);
	
	    return ArticleConfiguratorApp;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArticleConfiguratorApp);

/***/ },
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(47);
	
	var _redux = __webpack_require__(95);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reduxThunk = __webpack_require__(676);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _MittwaldApi = __webpack_require__(42);
	
	var _MittwaldApi2 = _interopRequireDefault(_MittwaldApi);
	
	var _index = __webpack_require__(798);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(337);
	
	__webpack_require__(338);
	
	__webpack_require__(339);
	
	__webpack_require__(340);
	
	__webpack_require__(342);
	
	__webpack_require__(341);
	
	var _reduxStorageEngineLocalstorage = __webpack_require__(674);
	
	var _reduxStorageEngineLocalstorage2 = _interopRequireDefault(_reduxStorageEngineLocalstorage);
	
	var _reduxStorage = __webpack_require__(278);
	
	var storage = _interopRequireWildcard(_reduxStorage);
	
	var _reduxStorageDecoratorFilter = __webpack_require__(673);
	
	var _reduxStorageDecoratorFilter2 = _interopRequireDefault(_reduxStorageDecoratorFilter);
	
	var _reduxStorageDecoratorDebounce = __webpack_require__(672);
	
	var _reduxStorageDecoratorDebounce2 = _interopRequireDefault(_reduxStorageDecoratorDebounce);
	
	var _ArticleConfiguratorApp = __webpack_require__(731);
	
	var _ArticleConfiguratorApp2 = _interopRequireDefault(_ArticleConfiguratorApp);
	
	var _Config = __webpack_require__(11);
	
	var _GetParam = __webpack_require__(17);
	
	__webpack_require__(802);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// **************************************************************************************************************
	try {
	    // set Domain for cross-origin policy
	    if (document.domain.includes('ddev.site')) {
	        document.domain = "mittwald.ddev.site";
	    } else {
	        document.domain = "mittwald.de";
	    }
	} catch (e) {}
	
	var store = void 0;
	
	var renderApp = function renderApp() {
	    (0, _reactDom.render)(_react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(_ArticleConfiguratorApp2.default, null)
	    ), document.getElementById('root'));
	};
	
	var engine = (0, _reduxStorageDecoratorDebounce2.default)((0, _reduxStorageDecoratorFilter2.default)((0, _reduxStorageEngineLocalstorage2.default)(_Config.lsConfigurator + "_" + (_GetParam._configuratorMode || 'shared')), [['form', 'projectSelection']], null), 1500);
	
	var storageMiddleware = storage.createMiddleware(engine);
	var middleware = [_reduxThunk2.default, _MittwaldApi2.default, storageMiddleware];
	var load = storage.createLoader(engine);
	
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	var enhancer = composeEnhancers(_redux.applyMiddleware.apply(undefined, middleware));
	
	store = (0, _redux.createStore)(_index2.default, {}, enhancer);
	
	load(store).then(function (newState) {
	    renderApp();
	});

/***/ },
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(95);
	
	var _reduxForm = __webpack_require__(12);
	
	var _Token = __webpack_require__(332);
	
	var _ArticleData = __webpack_require__(330);
	
	var _UserInterface = __webpack_require__(333);
	
	var _AppState = __webpack_require__(329);
	
	var _ToggleSelections = __webpack_require__(331);
	
	var _reduxStorage = __webpack_require__(278);
	
	var storage = _interopRequireWildcard(_reduxStorage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// **************************************************************************************************************
	var rootReducer = (0, _redux.combineReducers)({
	    token: _Token.tokenReducer,
	    articleData: _ArticleData.articleDataReducer,
	    ui: _UserInterface.uiReducer,
	    appState: _AppState.appStateReducer,
	    form: _reduxForm.reducer,
	    toggleSelections: _ToggleSelections.toggleSelectionReducer
	});
	
	exports.default = storage.reducer(rootReducer);

/***/ },
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/configurator.73172259.js
 **/